/* tslint:disable */
/* eslint-disable */
/**
 * Physio Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const APPOINTMENTSUGGESTIONJobName = {
    AppointmentSuggestion: 'APPOINTMENT_SUGGESTION'
} as const;

export type APPOINTMENTSUGGESTIONJobName = typeof APPOINTMENTSUGGESTIONJobName[keyof typeof APPOINTMENTSUGGESTIONJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const AVAILABILITYREQUESTFORPATIENTJobName = {
    AvailabilityRequestForPatient: 'AVAILABILITY_REQUEST_FOR_PATIENT'
} as const;

export type AVAILABILITYREQUESTFORPATIENTJobName = typeof AVAILABILITYREQUESTFORPATIENTJobName[keyof typeof AVAILABILITYREQUESTFORPATIENTJobName];


/**
 * 
 * @export
 * @interface AccountDetailDto
 */
export interface AccountDetailDto {
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'ik'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'creditorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof AccountDetailDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDetailDto
     */
    'isCompanyGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'logoDocumentId'?: string | null;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof AccountDetailDto
     */
    'contactInfo'?: KontakInfoDto;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface AccountDto
 */
export interface AccountDto {
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    'name': string;
    /**
     * 
     * @type {TherapyType}
     * @memberof AccountDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface AccountDtoForInsurance
 */
export interface AccountDtoForInsurance {
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'name': string;
    /**
     * 
     * @type {TherapyType}
     * @memberof AccountDtoForInsurance
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'fullName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'ik': string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'bundesland': string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'district': string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AccountDtoForInsurance
     */
    'updatedAt': string;
    /**
     * 
     * @type {ContactInfo}
     * @memberof AccountDtoForInsurance
     */
    'contactInfo': ContactInfo;
}


/**
 * 
 * @export
 * @interface AccountLogoDto
 */
export interface AccountLogoDto {
    /**
     * 
     * @type {string}
     * @memberof AccountLogoDto
     */
    'documentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountLogoDto
     */
    'accessUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AccountSEPADataDto
 */
export interface AccountSEPADataDto {
    /**
     * Account ID
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'accountId': string;
    /**
     * Account name
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'accountName': string;
    /**
     * Full account name
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'accountFullName': string;
    /**
     * Business name from contact info
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'creditorName': string;
    /**
     * IBAN from contact info
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'creditorIBAN': string;
    /**
     * Bank name from contact info
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'creditorBIC': string;
    /**
     * SEPA creditor ID
     * @type {string}
     * @memberof AccountSEPADataDto
     */
    'creditorId': string;
    /**
     * Number of unexported transactions for this account
     * @type {number}
     * @memberof AccountSEPADataDto
     */
    'transactionCount': number;
}
/**
 * 
 * @export
 * @interface ActionGroupDto
 */
export interface ActionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof ActionGroupDto
     */
    'actionGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof ActionGroupDto
     */
    'dayStr': string;
    /**
     * 
     * @type {boolean}
     * @memberof ActionGroupDto
     */
    'success': boolean;
    /**
     * 
     * @type {Array<ProposedActionDto>}
     * @memberof ActionGroupDto
     */
    'proposedActions': Array<ProposedActionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ActionGroupDto
     */
    'usedAgent': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionGroupDto
     */
    'errors': Array<string>;
}
/**
 * 
 * @export
 * @interface ActionValidationResultDto
 */
export interface ActionValidationResultDto {
    /**
     * 
     * @type {number}
     * @memberof ActionValidationResultDto
     */
    'actionIndex': number;
    /**
     * 
     * @type {boolean}
     * @memberof ActionValidationResultDto
     */
    'valid': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionValidationResultDto
     */
    'errors': Array<string>;
    /**
     * Non-blocking soft constraint warnings (e.g. long driving time, poor visit grouping)
     * @type {Array<string>}
     * @memberof ActionValidationResultDto
     */
    'warnings': Array<string>;
    /**
     * Non-DT appointments that must be rescheduled because this DT action takes precedence at their time slot.
     * @type {Array<DisplacedAppointmentDto>}
     * @memberof ActionValidationResultDto
     */
    'displacedAppointments'?: Array<DisplacedAppointmentDto>;
}
/**
 * 
 * @export
 * @interface ActivityDto
 */
export interface ActivityDto {
    /**
     * 
     * @type {string}
     * @memberof ActivityDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityDto
     */
    'type': string;
    /**
     * 
     * @type {GetTicketChangeLogDTO}
     * @memberof ActivityDto
     */
    'text': GetTicketChangeLogDTO;
    /**
     * 
     * @type {string}
     * @memberof ActivityDto
     */
    'ticketId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityDto
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface ActivityQueryFiltersDto
 */
export interface ActivityQueryFiltersDto {
    /**
     * Number of items per page (Max = 50)
     * @type {number}
     * @memberof ActivityQueryFiltersDto
     */
    'limit'?: number;
    /**
     * Page number (Min = 1)
     * @type {number}
     * @memberof ActivityQueryFiltersDto
     */
    'page'?: number;
    /**
     * Sorting order: asc or desc
     * @type {string}
     * @memberof ActivityQueryFiltersDto
     */
    'sortOrder'?: ActivityQueryFiltersDtoSortOrderEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActivityQueryFiltersDto
     */
    'type'?: Array<ActivityQueryFiltersDtoTypeEnum>;
    /**
     * 
     * @type {number}
     * @memberof ActivityQueryFiltersDto
     */
    'ticketId'?: number;
}

export const ActivityQueryFiltersDtoSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type ActivityQueryFiltersDtoSortOrderEnum = typeof ActivityQueryFiltersDtoSortOrderEnum[keyof typeof ActivityQueryFiltersDtoSortOrderEnum];
export const ActivityQueryFiltersDtoTypeEnum = {
    Comments: 'COMMENTS',
    History: 'HISTORY'
} as const;

export type ActivityQueryFiltersDtoTypeEnum = typeof ActivityQueryFiltersDtoTypeEnum[keyof typeof ActivityQueryFiltersDtoTypeEnum];

/**
 * 
 * @export
 * @interface AddressCoordinateDto
 */
export interface AddressCoordinateDto {
    /**
     * 
     * @type {string}
     * @memberof AddressCoordinateDto
     */
    'addressId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressCoordinateDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddressCoordinateDto
     */
    'latitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressCoordinateDto
     */
    'addressString'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCoordinateDto
     */
    'sublocality'?: string;
}
/**
 * 
 * @export
 * @interface AddressDisplayDto
 */
export interface AddressDisplayDto {
    /**
     * Address ID
     * @type {string}
     * @memberof AddressDisplayDto
     */
    'addressId'?: string;
    /**
     * Whether address is primary
     * @type {boolean}
     * @memberof AddressDisplayDto
     */
    'isPrimary'?: boolean;
    /**
     * Whether address is for visits
     * @type {boolean}
     * @memberof AddressDisplayDto
     */
    'isVisit'?: boolean;
    /**
     * Whether address is alternative billing
     * @type {boolean}
     * @memberof AddressDisplayDto
     */
    'isAlternativeBilling'?: boolean;
    /**
     * Address type
     * @type {string}
     * @memberof AddressDisplayDto
     */
    'addressType'?: string;
}
/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressDto
     */
    'isDefaultVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressDto
     */
    'isAlternativeBilling'?: boolean;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof AddressDto
     */
    'contactInfo'?: ContactInfoDTO;
    /**
     * 
     * @type {boolean}
     * @memberof AddressDto
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressDto
     */
    'isVisit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'type'?: AddressDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'note'?: string;
    /**
     * 
     * @type {AddressCoordinateDto}
     * @memberof AddressDto
     */
    'coordinates'?: AddressCoordinateDto;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'sublocalityId'?: string;
    /**
     * 
     * @type {SublocalityDto}
     * @memberof AddressDto
     */
    'sublocality'?: SublocalityDto;
}

export const AddressDtoTypeEnum = {
    Praxis: 'Praxis',
    Haus: 'Haus',
    Heim: 'Heim'
} as const;

export type AddressDtoTypeEnum = typeof AddressDtoTypeEnum[keyof typeof AddressDtoTypeEnum];

/**
 * 
 * @export
 * @interface AdjustOutsideAppointmentsDto
 */
export interface AdjustOutsideAppointmentsDto {
    /**
     * 
     * @type {string}
     * @memberof AdjustOutsideAppointmentsDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjustOutsideAppointmentsDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjustOutsideAppointmentsDto
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface AgentActionGroupDto
 */
export interface AgentActionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof AgentActionGroupDto
     */
    'actionGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof AgentActionGroupDto
     */
    'dayStr': string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentActionGroupDto
     */
    'success': boolean;
    /**
     * 
     * @type {AgentActionGroupDtoActions}
     * @memberof AgentActionGroupDto
     */
    'actions': AgentActionGroupDtoActions;
    /**
     * 
     * @type {boolean}
     * @memberof AgentActionGroupDto
     */
    'usedAgent': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentActionGroupDto
     */
    'errors': Array<string>;
}
/**
 * Map of actionName → array of action DTOs
 * @export
 * @interface AgentActionGroupDtoActions
 */
export interface AgentActionGroupDtoActions {
    /**
     * 
     * @type {Array<TimeSlotMoveActionDto>}
     * @memberof AgentActionGroupDtoActions
     */
    'TIME_SLOT_MOVE'?: Array<TimeSlotMoveActionDto>;
    /**
     * 
     * @type {Array<TimeSlotCreateActionDto>}
     * @memberof AgentActionGroupDtoActions
     */
    'TIME_SLOT_CREATE'?: Array<TimeSlotCreateActionDto>;
    /**
     * 
     * @type {Array<TimeSlotSkipActionDto>}
     * @memberof AgentActionGroupDtoActions
     */
    'TIME_SLOT_SKIP'?: Array<TimeSlotSkipActionDto>;
    /**
     * 
     * @type {Array<TravelTimeSlotChangeActionDto>}
     * @memberof AgentActionGroupDtoActions
     */
    'TRAVEL_TIME_SLOT_CHANGE'?: Array<TravelTimeSlotChangeActionDto>;
}
/**
 * 
 * @export
 * @interface AgentActionGroupsDto
 */
export interface AgentActionGroupsDto {
    /**
     * 
     * @type {Array<AgentActionGroupDto>}
     * @memberof AgentActionGroupsDto
     */
    'actionGroups': Array<AgentActionGroupDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgentActionName = {
    TimeSlotMove: 'TIME_SLOT_MOVE',
    TimeSlotCreate: 'TIME_SLOT_CREATE',
    TimeSlotSkip: 'TIME_SLOT_SKIP',
    TravelTimeSlotChange: 'TRAVEL_TIME_SLOT_CHANGE'
} as const;

export type AgentActionName = typeof AgentActionName[keyof typeof AgentActionName];


/**
 * 
 * @export
 * @interface AgentActionNameSchema
 */
export interface AgentActionNameSchema {
    /**
     * 
     * @type {AgentActionName}
     * @memberof AgentActionNameSchema
     */
    'actionName': AgentActionName;
}


/**
 * 
 * @export
 * @interface AgentMetadataDto
 */
export interface AgentMetadataDto {
    /**
     * 
     * @type {WorkflowJobMeta}
     * @memberof AgentMetadataDto
     */
    'workflowJobMeta'?: WorkflowJobMeta;
    /**
     * All callbacks available for this agent
     * @type {Array<CallbackRegistrationDto>}
     * @memberof AgentMetadataDto
     */
    'callbacks'?: Array<CallbackRegistrationDto>;
    /**
     * API access token (JWT) for calling regular API endpoints during a workflow
     * @type {string}
     * @memberof AgentMetadataDto
     */
    'apiAccessToken'?: string;
    /**
     * Base URL of this API server to be used by external services
     * @type {string}
     * @memberof AgentMetadataDto
     */
    'baseApiUrl'?: string;
}
/**
 * 
 * @export
 * @interface AiAgentChatJobResultDto
 */
export interface AiAgentChatJobResultDto {
    /**
     * Thread ID of the completed conversation
     * @type {string}
     * @memberof AiAgentChatJobResultDto
     */
    'threadId': string;
    /**
     * Whether the agent completed successfully
     * @type {boolean}
     * @memberof AiAgentChatJobResultDto
     */
    'completed': boolean;
}
/**
 * 
 * @export
 * @interface AiPriceProcessingRequestDto
 */
export interface AiPriceProcessingRequestDto {
    /**
     * Raw text pasted from a price PDF
     * @type {string}
     * @memberof AiPriceProcessingRequestDto
     */
    'rawText': string;
    /**
     * Additional instructions for AI processing
     * @type {string}
     * @memberof AiPriceProcessingRequestDto
     */
    'instructions'?: string;
}
/**
 * 
 * @export
 * @interface AiPriceProcessingResponseDto
 */
export interface AiPriceProcessingResponseDto {
    /**
     * 
     * @type {Array<ProposedPriceChangeDto>}
     * @memberof AiPriceProcessingResponseDto
     */
    'proposedChanges': Array<ProposedPriceChangeDto>;
    /**
     * 
     * @type {string}
     * @memberof AiPriceProcessingResponseDto
     */
    'summary'?: string;
}
/**
 * 
 * @export
 * @interface AllocationsDto
 */
export interface AllocationsDto {
    /**
     * 
     * @type {string}
     * @memberof AllocationsDto
     */
    'rechnungId': string;
    /**
     * 
     * @type {number}
     * @memberof AllocationsDto
     */
    'paidAmount': number;
    /**
     * 
     * @type {string}
     * @memberof AllocationsDto
     */
    'rechnungNumber': string;
}
/**
 * 
 * @export
 * @interface AmountPerPaymentTypeDto
 */
export interface AmountPerPaymentTypeDto {
    /**
     * Type of payment
     * @type {string}
     * @memberof AmountPerPaymentTypeDto
     */
    'payment_type': AmountPerPaymentTypeDtoPaymentTypeEnum;
    /**
     * Amount in cents
     * @type {number}
     * @memberof AmountPerPaymentTypeDto
     */
    'amount': number;
}

export const AmountPerPaymentTypeDtoPaymentTypeEnum = {
    Cash: 'CASH',
    NonCash: 'NON_CASH'
} as const;

export type AmountPerPaymentTypeDtoPaymentTypeEnum = typeof AmountPerPaymentTypeDtoPaymentTypeEnum[keyof typeof AmountPerPaymentTypeDtoPaymentTypeEnum];

/**
 * 
 * @export
 * @interface AppStatsDto
 */
export interface AppStatsDto {
    /**
     * 
     * @type {string}
     * @memberof AppStatsDto
     */
    'rxId': string;
    /**
     * 
     * @type {string}
     * @memberof AppStatsDto
     */
    'therapyRxId': string;
    /**
     * 
     * @type {number}
     * @memberof AppStatsDto
     */
    'amountPrescribed': number;
    /**
     * 
     * @type {number}
     * @memberof AppStatsDto
     */
    'amountDefined': number;
    /**
     * 
     * @type {number}
     * @memberof AppStatsDto
     */
    'amountScheduled': number;
}
/**
 * 
 * @export
 * @interface AppointmentCoordinatesDto
 */
export interface AppointmentCoordinatesDto {
    /**
     * Appointment ID
     * @type {string}
     * @memberof AppointmentCoordinatesDto
     */
    'appointmentId': string;
    /**
     * Address ID
     * @type {string}
     * @memberof AppointmentCoordinatesDto
     */
    'addressId': string;
    /**
     * Latitude
     * @type {number}
     * @memberof AppointmentCoordinatesDto
     */
    'latitude': number;
    /**
     * Longitude
     * @type {number}
     * @memberof AppointmentCoordinatesDto
     */
    'longitude': number;
    /**
     * Formatted address string
     * @type {string}
     * @memberof AppointmentCoordinatesDto
     */
    'addressString'?: string;
}
/**
 * 
 * @export
 * @interface AppointmentDto
 */
export interface AppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof AppointmentDto
     */
    'timeSlots'?: Array<TimeSlotDto>;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof AppointmentDto
     */
    'frequency': TherapyFrequencyDto;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof AppointmentDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof AppointmentDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'end'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentDto
     */
    'attended'?: boolean;
    /**
     * 
     * @type {AppointmentInformedToPatientStatus}
     * @memberof AppointmentDto
     */
    'wasPatientInformed'?: AppointmentInformedToPatientStatus;
    /**
     * 
     * @type {PatientInformingProjectionDto}
     * @memberof AppointmentDto
     */
    'informing'?: PatientInformingProjectionDto | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'originalDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'reason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentDto
     */
    'byTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentDto
     */
    'resolved'?: boolean;
    /**
     * 
     * @type {Array<GapJustificationDto>}
     * @memberof AppointmentDto
     */
    'gapJustifications'?: Array<GapJustificationDto>;
    /**
     * 
     * @type {Array<ParticipantDto>}
     * @memberof AppointmentDto
     */
    'participants'?: Array<ParticipantDto>;
}


/**
 * 
 * @export
 * @interface AppointmentInformedStatusDto
 */
export interface AppointmentInformedStatusDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentInformedStatusDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentInformedStatusDto
     */
    'patientId': number;
    /**
     * 
     * @type {AppointmentInformedToPatientStatus}
     * @memberof AppointmentInformedStatusDto
     */
    'status': AppointmentInformedToPatientStatus;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AppointmentInformedToPatientStatus = {
    Informiert: 'INFORMIERT',
    WirdSpterInformieren: 'WIRD SPÄTER INFORMIEREN',
    Unbekannt: 'UNBEKANNT'
} as const;

export type AppointmentInformedToPatientStatus = typeof AppointmentInformedToPatientStatus[keyof typeof AppointmentInformedToPatientStatus];


/**
 * 
 * @export
 * @interface AppointmentQueryFilters
 */
export interface AppointmentQueryFilters {
    /**
     * Maximum number of results per page
     * @type {number}
     * @memberof AppointmentQueryFilters
     */
    'limit'?: number;
    /**
     * Page number for pagination
     * @type {number}
     * @memberof AppointmentQueryFilters
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentQueryFilters
     */
    'appointmentId'?: string;
    /**
     * Filter to show only future appointments
     * @type {boolean}
     * @memberof AppointmentQueryFilters
     */
    'showOnlyFutureAppointments'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentQueryFilters
     */
    'start'?: string;
    /**
     * Filter to show only active Rxs
     * @type {boolean}
     * @memberof AppointmentQueryFilters
     */
    'showOnlyActiveRxs'?: boolean;
    /**
     * Filter to show appointments from the last 3 months
     * @type {boolean}
     * @memberof AppointmentQueryFilters
     */
    'showLastThreeMonths'?: boolean;
    /**
     * Filter appointments by RX IDs (comma-separated list)
     * @type {Array<string>}
     * @memberof AppointmentQueryFilters
     */
    'rxIds'?: Array<string>;
    /**
     * Filter to show only personal appointments
     * @type {boolean}
     * @memberof AppointmentQueryFilters
     */
    'personalAppointmentsOnly'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AppointmentRelationsEnum = {
    TimeSlots: 'TIME_SLOTS',
    TherapyRx: 'THERAPY_RX',
    Rx: 'RX',
    Patient: 'PATIENT',
    User: 'USER',
    Notes: 'NOTES',
    Address: 'ADDRESS'
} as const;

export type AppointmentRelationsEnum = typeof AppointmentRelationsEnum[keyof typeof AppointmentRelationsEnum];


/**
 * 
 * @export
 * @interface AppointmentSchedulingAgentApiRequestDto
 */
export interface AppointmentSchedulingAgentApiRequestDto {
    /**
     * 
     * @type {AppointmentSchedulingParametersDto}
     * @memberof AppointmentSchedulingAgentApiRequestDto
     */
    'schedulingParams': AppointmentSchedulingParametersDto;
    /**
     * 
     * @type {AgentMetadataDto}
     * @memberof AppointmentSchedulingAgentApiRequestDto
     */
    'metadata'?: AgentMetadataDto;
    /**
     * 
     * @type {StateForPatientDto}
     * @memberof AppointmentSchedulingAgentApiRequestDto
     */
    'state': StateForPatientDto;
    /**
     * The current day in ISO 8601 format.
     * @type {string}
     * @memberof AppointmentSchedulingAgentApiRequestDto
     */
    'currentDay': string;
}
/**
 * 
 * @export
 * @interface AppointmentSchedulingParametersDto
 */
export interface AppointmentSchedulingParametersDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentSchedulingParametersDto
     */
    'searchFunction'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSchedulingParametersDto
     */
    'pruningTarget'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSchedulingParametersDto
     */
    'betaGap'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSchedulingParametersDto
     */
    'betaTherapists'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSchedulingParametersDto
     */
    'betaTreatmentMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSchedulingParametersDto
     */
    'betaDrivingTime'?: number;
}
/**
 * 
 * @export
 * @interface AppointmentTemplateDto
 */
export interface AppointmentTemplateDto {
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof AppointmentTemplateDto
     */
    'therapyRx': Array<TherapyRxDto>;
    /**
     * therapyRx.id -> visit fee therapy.id
     * @type {{ [key: string]: string; }}
     * @memberof AppointmentTemplateDto
     */
    'visitFees'?: { [key: string]: string; };
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof AppointmentTemplateDto
     */
    'frequency': TherapyFrequencyDto;
    /**
     * 
     * @type {number}
     * @memberof AppointmentTemplateDto
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTemplateDto
     */
    'addressId'?: string;
}
/**
 * 
 * @export
 * @interface AppointmentWithGapDto
 */
export interface AppointmentWithGapDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentWithGapDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof AppointmentWithGapDto
     */
    'timeSlots'?: Array<TimeSlotDto>;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof AppointmentWithGapDto
     */
    'frequency': TherapyFrequencyDto;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof AppointmentWithGapDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof AppointmentWithGapDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof AppointmentWithGapDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentWithGapDto
     */
    'end'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentWithGapDto
     */
    'attended'?: boolean;
    /**
     * 
     * @type {AppointmentInformedToPatientStatus}
     * @memberof AppointmentWithGapDto
     */
    'wasPatientInformed'?: AppointmentInformedToPatientStatus;
    /**
     * 
     * @type {PatientInformingProjectionDto}
     * @memberof AppointmentWithGapDto
     */
    'informing'?: PatientInformingProjectionDto | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentWithGapDto
     */
    'originalDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentWithGapDto
     */
    'reason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentWithGapDto
     */
    'byTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentWithGapDto
     */
    'resolved'?: boolean;
    /**
     * 
     * @type {Array<GapJustificationDto>}
     * @memberof AppointmentWithGapDto
     */
    'gapJustifications'?: Array<GapJustificationDto>;
    /**
     * 
     * @type {Array<ParticipantDto>}
     * @memberof AppointmentWithGapDto
     */
    'participants'?: Array<ParticipantDto>;
    /**
     * Gap in days between closest scheduled appointments around this unscheduled/cancelled slot (ranking metric).
     * @type {object}
     * @memberof AppointmentWithGapDto
     */
    'gapInDays'?: object | null;
}


/**
 * 
 * @export
 * @interface AppointmentsOfAllTypesDto
 */
export interface AppointmentsOfAllTypesDto {
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof AppointmentsOfAllTypesDto
     */
    'appointments': Array<AppointmentDto>;
    /**
     * 
     * @type {Array<LeaveOfAbsenceDto>}
     * @memberof AppointmentsOfAllTypesDto
     */
    'leaveOfAbsences': Array<LeaveOfAbsenceDto>;
    /**
     * 
     * @type {Array<EventTimeSlotDto>}
     * @memberof AppointmentsOfAllTypesDto
     */
    'eventTimeSlots': Array<EventTimeSlotDto>;
    /**
     * 
     * @type {Array<TravelTimeDto>}
     * @memberof AppointmentsOfAllTypesDto
     */
    'travelTimes': Array<TravelTimeDto>;
}
/**
 * 
 * @export
 * @interface AssignDoctorReportDto
 */
export interface AssignDoctorReportDto {
    /**
     * The ID of the user to assign the doctor report to
     * @type {string}
     * @memberof AssignDoctorReportDto
     */
    'assignedToUserId': string;
}
/**
 * 
 * @export
 * @interface AssignPatientDto
 */
export interface AssignPatientDto {
    /**
     * Patient ID to assign the document to
     * @type {number}
     * @memberof AssignPatientDto
     */
    'patientId': number;
}
/**
 * 
 * @export
 * @interface AvailabilityDto
 */
export interface AvailabilityDto {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    'end'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof AvailabilityDto
     */
    'user'?: UserDto;
    /**
     * Type of the availability slot
     * @type {string}
     * @memberof AvailabilityDto
     */
    'type': AvailabilityDtoTypeEnum;
    /**
     * 
     * @type {LunchBreakDto}
     * @memberof AvailabilityDto
     */
    'lunchBreak'?: LunchBreakDto;
    /**
     * 
     * @type {AddressCoordinateDto}
     * @memberof AvailabilityDto
     */
    'startAddress'?: AddressCoordinateDto;
}

export const AvailabilityDtoTypeEnum = {
    Availability: 'AVAILABILITY'
} as const;

export type AvailabilityDtoTypeEnum = typeof AvailabilityDtoTypeEnum[keyof typeof AvailabilityDtoTypeEnum];

/**
 * 
 * @export
 * @interface AvailabilityRequestDto
 */
export interface AvailabilityRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRequestDto
     */
    'requestString'?: string;
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof AvailabilityRequestDto
     */
    'availabilities'?: Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof AvailabilityRequestDto
     */
    'blockedSlots'?: Array<BlockingSlotDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BILLPDFBATCHAGGREGATORJobName = {
    BillPdfBatchAggregator: 'BILL_PDF_BATCH_AGGREGATOR'
} as const;

export type BILLPDFBATCHAGGREGATORJobName = typeof BILLPDFBATCHAGGREGATORJobName[keyof typeof BILLPDFBATCHAGGREGATORJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const BILLPDFMULTISTEPAGGREGATORJobName = {
    BillPdfMultiStepAggregator: 'BILL_PDF_MULTI_STEP_AGGREGATOR'
} as const;

export type BILLPDFMULTISTEPAGGREGATORJobName = typeof BILLPDFMULTISTEPAGGREGATORJobName[keyof typeof BILLPDFMULTISTEPAGGREGATORJobName];


/**
 * 
 * @export
 * @interface BackPlanResult
 */
export interface BackPlanResult {
    /**
     * 
     * @type {string}
     * @memberof BackPlanResult
     */
    'date': string;
    /**
     * 
     * @type {AppointmentDto}
     * @memberof BackPlanResult
     */
    'app': AppointmentDto;
    /**
     * 
     * @type {string}
     * @memberof BackPlanResult
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface BackplanActionDto
 */
export interface BackplanActionDto {
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'actionType': BackplanActionDtoActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'appointmentId'?: string;
    /**
     * Existing timeslot ID within the appointment (for move)
     * @type {string}
     * @memberof BackplanActionDto
     */
    'timeSlotId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'end'?: string;
    /**
     * Target start time (for move/shift)
     * @type {string}
     * @memberof BackplanActionDto
     */
    'newStart'?: string;
    /**
     * Target end time (for move/shift)
     * @type {string}
     * @memberof BackplanActionDto
     */
    'newEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'therapistId'?: string;
    /**
     * Target therapist (for shift to different therapist)
     * @type {string}
     * @memberof BackplanActionDto
     */
    'newTherapistId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'therapyId'?: string;
    /**
     * TherapyRx UUID — used for frequency validation
     * @type {string}
     * @memberof BackplanActionDto
     */
    'therapyRxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackplanActionDto
     */
    'reason': string;
}

export const BackplanActionDtoActionTypeEnum = {
    Create: 'create',
    Move: 'move',
    Skip: 'skip',
    Delete: 'delete'
} as const;

export type BackplanActionDtoActionTypeEnum = typeof BackplanActionDtoActionTypeEnum[keyof typeof BackplanActionDtoActionTypeEnum];

/**
 * 
 * @export
 * @interface BackplanningLLMStepDto
 */
export interface BackplanningLLMStepDto {
    /**
     * Logical name of the step, e.g. \'parse_request\', \'summarize_for_user\'.
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'stepName': string;
    /**
     * LLM call duration in milliseconds, if applicable.
     * @type {number}
     * @memberof BackplanningLLMStepDto
     */
    'durationMs'?: number | null;
    /**
     * Model identifier used for this step, e.g. \"openai:gpt-5-nano-2025-08-07\".
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'llmModel'?: string | null;
    /**
     * Short human-readable description of what input was given to the LLM.
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'input': string;
    /**
     * Short human-readable description of what the LLM produced.
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'output'?: string | null;
    /**
     * More detailed explanation or reasoning notes for this step.
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'explanation'?: string | null;
    /**
     * Small machine-readable payload: key data points, flags, etc.
     * @type {{ [key: string]: any; }}
     * @memberof BackplanningLLMStepDto
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * Error message if the step failed.
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'errorMessage'?: string | null;
    /**
     * The calendar date being processed, e.g. \'2026-05-04\'.
     * @type {string}
     * @memberof BackplanningLLMStepDto
     */
    'day'?: string | null;
    /**
     * 1-based index of the day being processed within the run.
     * @type {number}
     * @memberof BackplanningLLMStepDto
     */
    'dayIndex'?: number | null;
    /**
     * Total number of days to process in this run.
     * @type {number}
     * @memberof BackplanningLLMStepDto
     */
    'totalDays'?: number | null;
}
/**
 * 
 * @export
 * @interface BankAccountWithMandatesDto
 */
export interface BankAccountWithMandatesDto {
    /**
     * 
     * @type {string}
     * @memberof BankAccountWithMandatesDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountWithMandatesDto
     */
    'holderFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountWithMandatesDto
     */
    'holderLastName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountWithMandatesDto
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountWithMandatesDto
     */
    'bic': string | null;
    /**
     * 
     * @type {string}
     * @memberof BankAccountWithMandatesDto
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<MandateSummaryDto>}
     * @memberof BankAccountWithMandatesDto
     */
    'mandates': Array<MandateSummaryDto>;
    /**
     * Number of ACTIVE mandates on this account.
     * @type {number}
     * @memberof BankAccountWithMandatesDto
     */
    'activeMandateCount': number;
}
/**
 * 
 * @export
 * @interface BankTransferAllocationDto
 */
export interface BankTransferAllocationDto {
    /**
     * 
     * @type {string}
     * @memberof BankTransferAllocationDto
     */
    'bankTransferId': string;
    /**
     * 
     * @type {string}
     * @memberof BankTransferAllocationDto
     */
    'transactionNumber': string;
    /**
     * 
     * @type {number}
     * @memberof BankTransferAllocationDto
     */
    'paidAmount': number;
    /**
     * 
     * @type {string}
     * @memberof BankTransferAllocationDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof BankTransferAllocationDto
     */
    'userFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof BankTransferAllocationDto
     */
    'userLastName': string;
    /**
     * 
     * @type {string}
     * @memberof BankTransferAllocationDto
     */
    'createdAt': string;
    /**
     * 
     * @type {DocumentDto}
     * @memberof BankTransferAllocationDto
     */
    'docDto'?: DocumentDto;
}
/**
 * 
 * @export
 * @interface BaseResultDto
 */
export interface BaseResultDto {
    /**
     * 
     * @type {string}
     * @memberof BaseResultDto
     */
    'kind': BaseResultDtoKindEnum;
    /**
     * Primary identifier of the result (patientId or prescriptionId).
     * @type {object}
     * @memberof BaseResultDto
     */
    'id': object;
    /**
     * 
     * @type {string}
     * @memberof BaseResultDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseResultDto
     */
    'lastName'?: string;
    /**
     * Date of birth in ISO format (YYYY-MM-DD).
     * @type {string}
     * @memberof BaseResultDto
     */
    'dob'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseResultDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseResultDto
     */
    'prescriptionId'?: string;
    /**
     * 
     * @type {object}
     * @memberof BaseResultDto
     */
    'locationId'?: object;
    /**
     * 
     * @type {string}
     * @memberof BaseResultDto
     */
    'locationName'?: string;
    /**
     * Patient\'s insurance number (Versichertennummer).
     * @type {string}
     * @memberof BaseResultDto
     */
    'insuranceNo'?: string;
    /**
     * True if the result belongs to the provided locationId.
     * @type {boolean}
     * @memberof BaseResultDto
     */
    'locationMatch': boolean;
}

export const BaseResultDtoKindEnum = {
    Patient: 'patient',
    Prescription: 'prescription'
} as const;

export type BaseResultDtoKindEnum = typeof BaseResultDtoKindEnum[keyof typeof BaseResultDtoKindEnum];

/**
 * 
 * @export
 * @interface BaseTransactionDetailsDto
 */
export interface BaseTransactionDetailsDto {
    /**
     * Unique identifier for the transaction
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'id': string;
    /**
     * Transaction number
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'transactionNumber': string;
    /**
     * Type of the transaction
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'type': BaseTransactionDetailsDtoTypeEnum;
    /**
     * Description of the transaction
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'text': string;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof BaseTransactionDetailsDto
     */
    'amount': number;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof BaseTransactionDetailsDto
     */
    'wasExported': boolean;
    /**
     * 
     * @type {GetUserDto}
     * @memberof BaseTransactionDetailsDto
     */
    'user': GetUserDto;
    /**
     * 
     * @type {GetAccountDto}
     * @memberof BaseTransactionDetailsDto
     */
    'account': GetAccountDto;
    /**
     * 
     * @type {GetPatientDto}
     * @memberof BaseTransactionDetailsDto
     */
    'patient': GetPatientDto;
    /**
     * 
     * @type {GetRxDto}
     * @memberof BaseTransactionDetailsDto
     */
    'rx'?: GetRxDto;
    /**
     * Date when the transaction was created
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'createdAt': string;
    /**
     * Date when the transaction was last updated
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetTAccountDto}
     * @memberof BaseTransactionDetailsDto
     */
    'tAccounts': GetTAccountDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof BaseTransactionDetailsDto
     */
    'docDto'?: DocumentDto;
    /**
     * Transaction Number of the original transaction if this is a cancellation
     * @type {string}
     * @memberof BaseTransactionDetailsDto
     */
    'originalTransactionNumber'?: string;
    /**
     * Indicates if this transaction is a cancellation of a previous transaction
     * @type {boolean}
     * @memberof BaseTransactionDetailsDto
     */
    'isCancelled'?: boolean;
}

export const BaseTransactionDetailsDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type BaseTransactionDetailsDtoTypeEnum = typeof BaseTransactionDetailsDtoTypeEnum[keyof typeof BaseTransactionDetailsDtoTypeEnum];

/**
 * 
 * @export
 * @interface BasicPatientDto
 */
export interface BasicPatientDto {
    /**
     * 
     * @type {string}
     * @memberof BasicPatientDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BasicPatientDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof BasicPatientDto
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface BatchCancelDeleteAppointmentDto
 */
export interface BatchCancelDeleteAppointmentDto {
    /**
     * IDs of appointments to cancel
     * @type {Array<string>}
     * @memberof BatchCancelDeleteAppointmentDto
     */
    'cancelIds'?: Array<string>;
    /**
     * IDs of appointments to delete
     * @type {Array<string>}
     * @memberof BatchCancelDeleteAppointmentDto
     */
    'deleteIds'?: Array<string>;
    /**
     * Who cancelled the appointments
     * @type {string}
     * @memberof BatchCancelDeleteAppointmentDto
     */
    'whoCancelled': string;
    /**
     * 
     * @type {UpdateCancelledAppointmentDto}
     * @memberof BatchCancelDeleteAppointmentDto
     */
    'cancelAppDto'?: UpdateCancelledAppointmentDto;
    /**
     * IDs of time slots to cancel
     * @type {Array<string>}
     * @memberof BatchCancelDeleteAppointmentDto
     */
    'cancelTimeSlotIds'?: Array<string>;
    /**
     * IDs of time slots to delete
     * @type {Array<string>}
     * @memberof BatchCancelDeleteAppointmentDto
     */
    'deleteTimeSlotIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BatchCancelDeleteResponseDto
 */
export interface BatchCancelDeleteResponseDto {
    /**
     * Array of cancelled appointments and their amounts
     * @type {Array<CancelledDataDto>}
     * @memberof BatchCancelDeleteResponseDto
     */
    'cancelled': Array<CancelledDataDto>;
    /**
     * Deleted appointment IDs and action
     * @type {object}
     * @memberof BatchCancelDeleteResponseDto
     */
    'deleted': object;
}
/**
 * 
 * @export
 * @interface BillPdfBatchAggregatorJobResultDto
 */
export interface BillPdfBatchAggregatorJobResultDto {
    /**
     * Type of PDFs in this batch
     * @type {string}
     * @memberof BillPdfBatchAggregatorJobResultDto
     */
    'pdfType': BillPdfBatchAggregatorJobResultDtoPdfTypeEnum;
    /**
     * Total number of PDFs attempted
     * @type {number}
     * @memberof BillPdfBatchAggregatorJobResultDto
     */
    'totalCount': number;
    /**
     * Number of successful PDF generations
     * @type {number}
     * @memberof BillPdfBatchAggregatorJobResultDto
     */
    'successCount': number;
    /**
     * Number of failed PDF generations
     * @type {number}
     * @memberof BillPdfBatchAggregatorJobResultDto
     */
    'failureCount': number;
    /**
     * Total duration of batch in milliseconds
     * @type {number}
     * @memberof BillPdfBatchAggregatorJobResultDto
     */
    'totalDurationMs': number;
    /**
     * Results for each individual PDF
     * @type {Array<GenerateBillPdfJobResultDto>}
     * @memberof BillPdfBatchAggregatorJobResultDto
     */
    'results': Array<GenerateBillPdfJobResultDto>;
}

export const BillPdfBatchAggregatorJobResultDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type BillPdfBatchAggregatorJobResultDtoPdfTypeEnum = typeof BillPdfBatchAggregatorJobResultDtoPdfTypeEnum[keyof typeof BillPdfBatchAggregatorJobResultDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface BillPdfBatchItemDto
 */
export interface BillPdfBatchItemDto {
    /**
     * Type of PDF to generate
     * @type {string}
     * @memberof BillPdfBatchItemDto
     */
    'pdfType': BillPdfBatchItemDtoPdfTypeEnum;
    /**
     * ID of the entity to generate PDF for (bill ID, rechnung ID, etc.)
     * @type {string}
     * @memberof BillPdfBatchItemDto
     */
    'entityId': string;
    /**
     * Transaction number for identification in batch results
     * @type {string}
     * @memberof BillPdfBatchItemDto
     */
    'transactionNumber'?: string;
    /**
     * Optional PDF date override (ISO date string). Used for GKV bills.
     * @type {string}
     * @memberof BillPdfBatchItemDto
     */
    'pdfDate'?: string;
}

export const BillPdfBatchItemDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type BillPdfBatchItemDtoPdfTypeEnum = typeof BillPdfBatchItemDtoPdfTypeEnum[keyof typeof BillPdfBatchItemDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface BillPdfWorkflowAggregatorJobResultDto
 */
export interface BillPdfWorkflowAggregatorJobResultDto {
    /**
     * Type of PDFs in this batch
     * @type {string}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'pdfType': BillPdfWorkflowAggregatorJobResultDtoPdfTypeEnum;
    /**
     * Total number of PDFs attempted
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'totalCount': number;
    /**
     * Number of successful PDF generations
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'successCount': number;
    /**
     * Number of failed PDF generations
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'failureCount': number;
    /**
     * Number of prep failures (subset of failureCount)
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'prepFailureCount': number;
    /**
     * Number of render failures (subset of failureCount)
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'renderFailureCount': number;
    /**
     * Number of document persistence failures (subset of failureCount)
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'persistFailureCount': number;
    /**
     * Total duration of workflow in milliseconds
     * @type {number}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'totalDurationMs': number;
    /**
     * Results for each individual PDF
     * @type {Array<PersistBillPdfDocumentJobResultDto>}
     * @memberof BillPdfWorkflowAggregatorJobResultDto
     */
    'results': Array<PersistBillPdfDocumentJobResultDto>;
}

export const BillPdfWorkflowAggregatorJobResultDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type BillPdfWorkflowAggregatorJobResultDtoPdfTypeEnum = typeof BillPdfWorkflowAggregatorJobResultDtoPdfTypeEnum[keyof typeof BillPdfWorkflowAggregatorJobResultDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface BillReminderDto
 */
export interface BillReminderDto {
    /**
     * 
     * @type {string}
     * @memberof BillReminderDto
     */
    'id': string;
    /**
     * The reminder level
     * @type {number}
     * @memberof BillReminderDto
     */
    'level': BillReminderDtoLevelEnum;
    /**
     * The fee for this reminder
     * @type {number}
     * @memberof BillReminderDto
     */
    'fee': number;
    /**
     * 
     * @type {string}
     * @memberof BillReminderDto
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillReminderDto
     */
    'sentByEmail': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillReminderDto
     */
    'emailSentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillReminderDto
     */
    'emailSentTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillReminderDto
     */
    'printed': boolean;
    /**
     * 
     * @type {DocumentDto}
     * @memberof BillReminderDto
     */
    'document'?: DocumentDto;
}

export const BillReminderDtoLevelEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type BillReminderDtoLevelEnum = typeof BillReminderDtoLevelEnum[keyof typeof BillReminderDtoLevelEnum];

/**
 * 
 * @export
 * @interface BillingAnalyticsQueryDto
 */
export interface BillingAnalyticsQueryDto {
    /**
     * Start date for the analytics period
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'startDate'?: string;
    /**
     * End date for the analytics period
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'endDate'?: string;
    /**
     * Filter by specific account ID
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'accountId'?: string;
    /**
     * Filter by specific payer ID
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'payerId'?: string;
    /**
     * Filter by bill status
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'billStatus'?: BillingAnalyticsQueryDtoBillStatusEnum;
    /**
     * Filter by bill type
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'billType'?: BillingAnalyticsQueryDtoBillTypeEnum;
    /**
     * Filter by user ID
     * @type {string}
     * @memberof BillingAnalyticsQueryDto
     */
    'userId'?: string;
}

export const BillingAnalyticsQueryDtoBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;

export type BillingAnalyticsQueryDtoBillStatusEnum = typeof BillingAnalyticsQueryDtoBillStatusEnum[keyof typeof BillingAnalyticsQueryDtoBillStatusEnum];
export const BillingAnalyticsQueryDtoBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;

export type BillingAnalyticsQueryDtoBillTypeEnum = typeof BillingAnalyticsQueryDtoBillTypeEnum[keyof typeof BillingAnalyticsQueryDtoBillTypeEnum];

/**
 * 
 * @export
 * @interface BillingCenterDto
 */
export interface BillingCenterDto {
    /**
     * 
     * @type {string}
     * @memberof BillingCenterDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillingCenterDto
     */
    'ik': string;
    /**
     * 
     * @type {string}
     * @memberof BillingCenterDto
     */
    'validFrom': string;
    /**
     * 
     * @type {object}
     * @memberof BillingCenterDto
     */
    'address': object;
    /**
     * 
     * @type {object}
     * @memberof BillingCenterDto
     */
    'contact': object;
    /**
     * 
     * @type {Array<string>}
     * @memberof BillingCenterDto
     */
    'transferTypes': Array<string>;
}
/**
 * 
 * @export
 * @interface BlockingSlotDto
 */
export interface BlockingSlotDto {
    /**
     * 
     * @type {string}
     * @memberof BlockingSlotDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockingSlotDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof BlockingSlotDto
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface BulkChangeItemDto
 */
export interface BulkChangeItemDto {
    /**
     * 
     * @type {string}
     * @memberof BulkChangeItemDto
     */
    'action': BulkChangeItemDtoActionEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkChangeItemDto
     */
    'entityType': BulkChangeItemDtoEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkChangeItemDto
     */
    'id'?: string;
    /**
     * The DTO data for create/update operations
     * @type {object}
     * @memberof BulkChangeItemDto
     */
    'data'?: object;
}

export const BulkChangeItemDtoActionEnum = {
    Create: 'create',
    Update: 'update',
    Delete: 'delete'
} as const;

export type BulkChangeItemDtoActionEnum = typeof BulkChangeItemDtoActionEnum[keyof typeof BulkChangeItemDtoActionEnum];
export const BulkChangeItemDtoEntityTypeEnum = {
    Therapy: 'therapy',
    Price: 'price',
    DiagnosisGroup: 'diagnosisGroup'
} as const;

export type BulkChangeItemDtoEntityTypeEnum = typeof BulkChangeItemDtoEntityTypeEnum[keyof typeof BulkChangeItemDtoEntityTypeEnum];

/**
 * 
 * @export
 * @interface BulkPatientIdsDto
 */
export interface BulkPatientIdsDto {
    /**
     * Array of patient IDs
     * @type {Array<number>}
     * @memberof BulkPatientIdsDto
     */
    'patientIds': Array<number>;
}
/**
 * 
 * @export
 * @interface BulkRxIdsDto
 */
export interface BulkRxIdsDto {
    /**
     * Array of Rx IDs
     * @type {Array<string>}
     * @memberof BulkRxIdsDto
     */
    'rxIds': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSaveRequestDto
 */
export interface BulkSaveRequestDto {
    /**
     * 
     * @type {Array<BulkChangeItemDto>}
     * @memberof BulkSaveRequestDto
     */
    'changes': Array<BulkChangeItemDto>;
}
/**
 * 
 * @export
 * @interface BulkSaveResponseDto
 */
export interface BulkSaveResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof BulkSaveResponseDto
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkSaveResponseDto
     */
    'appliedCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSaveResponseDto
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSoftDeleteLastSchrifts200Response
 */
export interface BulkSoftDeleteLastSchrifts200Response {
    /**
     * 
     * @type {number}
     * @memberof BulkSoftDeleteLastSchrifts200Response
     */
    'deletedCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSoftDeleteLastSchrifts200Response
     */
    'deletedRechnungIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSoftDeleteLastSchrifts200Response
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSoftDeleteLastSchriftsRequest
 */
export interface BulkSoftDeleteLastSchriftsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSoftDeleteLastSchriftsRequest
     */
    'lastSchriftIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSoftDeleteLastSchriftsRequest
     */
    'deleteAssociatedRechnungen'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkTimeSlotDisplayRequestDto
 */
export interface BulkTimeSlotDisplayRequestDto {
    /**
     * Array of time slot IDs to fetch display data for
     * @type {Array<string>}
     * @memberof BulkTimeSlotDisplayRequestDto
     */
    'timeSlotIds': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkTimeSlotDisplayResponseDto
 */
export interface BulkTimeSlotDisplayResponseDto {
    /**
     * Found time slot display data
     * @type {Array<TimeSlotDisplayDto>}
     * @memberof BulkTimeSlotDisplayResponseDto
     */
    'results': Array<TimeSlotDisplayDto>;
    /**
     * IDs that were not found
     * @type {Array<string>}
     * @memberof BulkTimeSlotDisplayResponseDto
     */
    'missingIds': Array<string>;
}
/**
 * 
 * @export
 * @interface BusinessDetailDto
 */
export interface BusinessDetailDto {
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'creditorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof BusinessDetailDto
     */
    'contactInfo'?: KontakInfoDto;
    /**
     * 
     * @type {Array<AccountDto>}
     * @memberof BusinessDetailDto
     */
    'accounts'?: Array<AccountDto>;
    /**
     * 
     * @type {number}
     * @memberof BusinessDetailDto
     */
    'locationCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDetailDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface BusinessDto
 */
export interface BusinessDto {
    /**
     * 
     * @type {string}
     * @memberof BusinessDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDto
     */
    'bundesland': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BusinessDto
     */
    'accounts': Array<string> | null;
}
/**
 * 
 * @export
 * @interface BusinessLocationTssDto
 */
export interface BusinessLocationTssDto {
    /**
     * Business ID to which the TSS belongs
     * @type {string}
     * @memberof BusinessLocationTssDto
     */
    'businessId': string;
    /**
     * Location ID to which the TSS belongs
     * @type {string}
     * @memberof BusinessLocationTssDto
     */
    'locationId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CALLPYAPPBACKPLANNINGAPIJobName = {
    CallPyAppBackplanningApi: 'CALL_PY_APP_BACKPLANNING_API'
} as const;

export type CALLPYAPPBACKPLANNINGAPIJobName = typeof CALLPYAPPBACKPLANNINGAPIJobName[keyof typeof CALLPYAPPBACKPLANNINGAPIJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const CALLPYAPPPATIENTAVAILABILITYAPIJobName = {
    CallPyAppPatientAvailabilityApi: 'CALL_PY_APP_PATIENT_AVAILABILITY_API'
} as const;

export type CALLPYAPPPATIENTAVAILABILITYAPIJobName = typeof CALLPYAPPPATIENTAVAILABILITYAPIJobName[keyof typeof CALLPYAPPPATIENTAVAILABILITYAPIJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const CALLPYAPPRESCHEDULINGAPIJobName = {
    CallPyAppReschedulingApi: 'CALL_PY_APP_RESCHEDULING_API'
} as const;

export type CALLPYAPPRESCHEDULINGAPIJobName = typeof CALLPYAPPRESCHEDULINGAPIJobName[keyof typeof CALLPYAPPRESCHEDULINGAPIJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const CALLPYAPPSCHEDULINGAPIJobName = {
    CallPyAppSchedulingApi: 'CALL_PY_APP_SCHEDULING_API'
} as const;

export type CALLPYAPPSCHEDULINGAPIJobName = typeof CALLPYAPPSCHEDULINGAPIJobName[keyof typeof CALLPYAPPSCHEDULINGAPIJobName];


/**
 * 
 * @export
 * @interface CAResponse
 */
export interface CAResponse {
    /**
     * 
     * @type {ContinuousAppointmentDto}
     * @memberof CAResponse
     */
    'savedCA': ContinuousAppointmentDto;
    /**
     * 
     * @type {Array<BackPlanResult>}
     * @memberof CAResponse
     */
    'backPlanResults': Array<BackPlanResult>;
}
/**
 * 
 * @export
 * @interface CalculateRxDTO
 */
export interface CalculateRxDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CalculateRxDTO
     */
    'matchNumberofAppointments': boolean;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'estimatedPrice': number;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'realPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateRxDTO
     */
    'isTimeSlotZero': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateRxDTO
     */
    'isProvisionalPrice': boolean;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof CalculateRxDTO
     */
    'therapyReportDetails'?: TherapyDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'grossValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'netValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'copayment'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'copaymentPercentualComponent'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateRxDTO
     */
    'copaymentFixedComponent'?: number;
}
/**
 * 
 * @export
 * @interface CalendarAppointmentDto
 */
export interface CalendarAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'patientName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarAppointmentDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'wasPatientInformed'?: string;
    /**
     * 
     * @type {Array<CalendarTimeSlotDto>}
     * @memberof CalendarAppointmentDto
     */
    'timeSlots': Array<CalendarTimeSlotDto>;
    /**
     * 
     * @type {string}
     * @memberof CalendarAppointmentDto
     */
    'addressString'?: string;
    /**
     * 
     * @type {number}
     * @memberof CalendarAppointmentDto
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarAppointmentDto
     */
    'longitude'?: number;
}
/**
 * 
 * @export
 * @interface CalendarColumnOrderDto
 */
export interface CalendarColumnOrderDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarColumnOrderDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarColumnOrderDto
     */
    'userId': string;
    /**
     * Lower ranks are shown further left
     * @type {number}
     * @memberof CalendarColumnOrderDto
     */
    'sortRank': number;
}
/**
 * 
 * @export
 * @interface CalendarEventDto
 */
export interface CalendarEventDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface CalendarLeaveDto
 */
export interface CalendarLeaveDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarLeaveDto
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarLeaveDto
     */
    'end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarLeaveDto
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface CalendarTimeSlotDto
 */
export interface CalendarTimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarTimeSlotDto
     */
    'therapyAbbreviation': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarTimeSlotDto
     */
    'therapyId': string;
    /**
     * 
     * @type {number}
     * @memberof CalendarTimeSlotDto
     */
    'duration': number;
    /**
     * Treatment | TravelTime | ...
     * @type {string}
     * @memberof CalendarTimeSlotDto
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface CalendarTravelTimeDto
 */
export interface CalendarTravelTimeDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarTravelTimeDto
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarTravelTimeDto
     */
    'end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarTravelTimeDto
     */
    'fromAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarTravelTimeDto
     */
    'toAddress'?: string;
}
/**
 * 
 * @export
 * @interface CalendarWorkingPeriodDto
 */
export interface CalendarWorkingPeriodDto {
    /**
     * 
     * @type {string}
     * @memberof CalendarWorkingPeriodDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarWorkingPeriodDto
     */
    'end': string;
    /**
     * true = lunch break
     * @type {boolean}
     * @memberof CalendarWorkingPeriodDto
     */
    'isBreak': boolean;
}
/**
 * 
 * @export
 * @interface CallbackEndpointDto
 */
export interface CallbackEndpointDto {
    /**
     * host
     * @type {string}
     * @memberof CallbackEndpointDto
     */
    'host': string;
    /**
     * Callback URL
     * @type {string}
     * @memberof CallbackEndpointDto
     */
    'url': string;
    /**
     * Optional description or type of callback
     * @type {string}
     * @memberof CallbackEndpointDto
     */
    'description'?: string;
    /**
     * Optional HTTP method
     * @type {string}
     * @memberof CallbackEndpointDto
     */
    'method'?: string;
    /**
     * Bearer token for the callback
     * @type {string}
     * @memberof CallbackEndpointDto
     */
    'bearerToken': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CallbackEndpointName = {
    WorkflowEvents: 'WORKFLOW_EVENTS'
} as const;

export type CallbackEndpointName = typeof CallbackEndpointName[keyof typeof CallbackEndpointName];


/**
 * 
 * @export
 * @interface CallbackRegistrationDto
 */
export interface CallbackRegistrationDto {
    /**
     * 
     * @type {CallbackEndpointName}
     * @memberof CallbackRegistrationDto
     */
    'name': CallbackEndpointName;
    /**
     * 
     * @type {CallbackEndpointDto}
     * @memberof CallbackRegistrationDto
     */
    'endpoint': CallbackEndpointDto;
}


/**
 * 
 * @export
 * @interface CancelDayRequest
 */
export interface CancelDayRequest {
    /**
     * User ID
     * @type {string}
     * @memberof CancelDayRequest
     */
    'userId': string;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof CancelDayRequest
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface CancellationHistoryItemDto
 */
export interface CancellationHistoryItemDto {
    /**
     * 
     * @type {string}
     * @memberof CancellationHistoryItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CancellationHistoryItemDto
     */
    'originalDate': string;
    /**
     * 
     * @type {string}
     * @memberof CancellationHistoryItemDto
     */
    'reason'?: string;
    /**
     * True when the cancellation was initiated by the therapist/practice, false when initiated by (or on behalf of) the patient.
     * @type {boolean}
     * @memberof CancellationHistoryItemDto
     */
    'byTherapist': boolean;
    /**
     * Whether the cancellation has already been rescheduled/resolved.
     * @type {boolean}
     * @memberof CancellationHistoryItemDto
     */
    'resolved': boolean;
    /**
     * 
     * @type {string}
     * @memberof CancellationHistoryItemDto
     */
    'timeliness'?: CancellationHistoryItemDtoTimelinessEnum;
    /**
     * 
     * @type {string}
     * @memberof CancellationHistoryItemDto
     */
    'callStatus'?: CancellationHistoryItemDtoCallStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CancellationHistoryItemDto
     */
    'noShowInvoice'?: boolean;
    /**
     * Prescriptions (and their therapies) affected by this cancellation.
     * @type {Array<CancellationRxDto>}
     * @memberof CancellationHistoryItemDto
     */
    'rxs'?: Array<CancellationRxDto>;
    /**
     * 
     * @type {string}
     * @memberof CancellationHistoryItemDto
     */
    'createdAt': string;
}

export const CancellationHistoryItemDtoTimelinessEnum = {
    Fristgerecht24StVorher: 'fristgerecht ( > 24 st. vorher)',
    Nichtfristgerecht: 'nichtfristgerecht',
    NichtErschienen: 'nicht erschienen'
} as const;

export type CancellationHistoryItemDtoTimelinessEnum = typeof CancellationHistoryItemDtoTimelinessEnum[keyof typeof CancellationHistoryItemDtoTimelinessEnum];
export const CancellationHistoryItemDtoCallStatusEnum = {
    NichtBentigt: 'nicht benötigt',
    Bentigt: 'benötigt',
    Versucht: 'versucht',
    Erledigt: 'erledigt'
} as const;

export type CancellationHistoryItemDtoCallStatusEnum = typeof CancellationHistoryItemDtoCallStatusEnum[keyof typeof CancellationHistoryItemDtoCallStatusEnum];

/**
 * 
 * @export
 * @interface CancellationRxDto
 */
export interface CancellationRxDto {
    /**
     * Prescription (Rx) number.
     * @type {string}
     * @memberof CancellationRxDto
     */
    'rxNumber'?: string;
    /**
     * Date on the prescription (Rx).
     * @type {string}
     * @memberof CancellationRxDto
     */
    'date'?: string | null;
    /**
     * Therapy abbreviations from this prescription affected by the cancellation.
     * @type {Array<string>}
     * @memberof CancellationRxDto
     */
    'therapies'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CancelledAndUnscheduledAppointmentsResponseDto
 */
export interface CancelledAndUnscheduledAppointmentsResponseDto {
    /**
     * 
     * @type {Array<PatientUnscheduledAppointmentsDto>}
     * @memberof CancelledAndUnscheduledAppointmentsResponseDto
     */
    'unScheduledAppointments': Array<PatientUnscheduledAppointmentsDto>;
    /**
     * Total count of unscheduled appointments (before limiting).
     * @type {number}
     * @memberof CancelledAndUnscheduledAppointmentsResponseDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface CancelledAppointmentDto
 */
export interface CancelledAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof CancelledAppointmentDto
     */
    'id': string;
    /**
     * 
     * @type {AppointmentDto}
     * @memberof CancelledAppointmentDto
     */
    'appointment': AppointmentDto;
    /**
     * 
     * @type {string}
     * @memberof CancelledAppointmentDto
     */
    'originalDate': string;
    /**
     * 
     * @type {string}
     * @memberof CancelledAppointmentDto
     */
    'reason'?: string;
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof CancelledAppointmentDto
     */
    'users'?: Array<UserDto>;
    /**
     * 
     * @type {string}
     * @memberof CancelledAppointmentDto
     */
    'timeliness'?: CancelledAppointmentDtoTimelinessEnum;
    /**
     * 
     * @type {string}
     * @memberof CancelledAppointmentDto
     */
    'callStatus'?: CancelledAppointmentDtoCallStatusEnum;
    /**
     * True when the cancellation was initiated by the therapist/practice, false when initiated by (or on behalf of) the patient.
     * @type {boolean}
     * @memberof CancelledAppointmentDto
     */
    'byTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledAppointmentDto
     */
    'noShowInvoice'?: boolean;
    /**
     * 
     * @type {Array<CancelledSlotDto>}
     * @memberof CancelledAppointmentDto
     */
    'cancelledSlots'?: Array<CancelledSlotDto>;
    /**
     * 
     * @type {PatientDto}
     * @memberof CancelledAppointmentDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {string}
     * @memberof CancelledAppointmentDto
     */
    'createdAt'?: string;
}

export const CancelledAppointmentDtoTimelinessEnum = {
    Fristgerecht24StVorher: 'fristgerecht ( > 24 st. vorher)',
    Nichtfristgerecht: 'nichtfristgerecht',
    NichtErschienen: 'nicht erschienen'
} as const;

export type CancelledAppointmentDtoTimelinessEnum = typeof CancelledAppointmentDtoTimelinessEnum[keyof typeof CancelledAppointmentDtoTimelinessEnum];
export const CancelledAppointmentDtoCallStatusEnum = {
    NichtBentigt: 'nicht benötigt',
    Bentigt: 'benötigt',
    Versucht: 'versucht',
    Erledigt: 'erledigt'
} as const;

export type CancelledAppointmentDtoCallStatusEnum = typeof CancelledAppointmentDtoCallStatusEnum[keyof typeof CancelledAppointmentDtoCallStatusEnum];

/**
 * 
 * @export
 * @interface CancelledDataDto
 */
export interface CancelledDataDto {
    /**
     * 
     * @type {object}
     * @memberof CancelledDataDto
     */
    'cancelledAppt': object;
    /**
     * 
     * @type {number}
     * @memberof CancelledDataDto
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface CancelledSlotDto
 */
export interface CancelledSlotDto {
    /**
     * 
     * @type {string}
     * @memberof CancelledSlotDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CancelledSlotDto
     */
    'rxId'?: string | null;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof CancelledSlotDto
     */
    'therapy'?: TherapyDetailsDto;
    /**
     * 
     * @type {TherapyRxDto}
     * @memberof CancelledSlotDto
     */
    'therapyRx'?: TherapyRxDto;
    /**
     * 
     * @type {string}
     * @memberof CancelledSlotDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelledSlotDto
     */
    'originalStart'?: string | null;
}
/**
 * 
 * @export
 * @interface CatalogGraphDto
 */
export interface CatalogGraphDto {
    /**
     * 
     * @type {Array<CatalogTermNodeDto>}
     * @memberof CatalogGraphDto
     */
    'terms': Array<CatalogTermNodeDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogGraphDto
     */
    'tarifGroups': Array<string>;
    /**
     * 
     * @type {CatalogIssuesDto}
     * @memberof CatalogGraphDto
     */
    'issues': CatalogIssuesDto;
}
/**
 * 
 * @export
 * @interface CatalogIssuesDto
 */
export interface CatalogIssuesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogIssuesDto
     */
    'termsWithoutResolution': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogIssuesDto
     */
    'methodsWithoutTerm': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogIssuesDto
     */
    'methodsWithoutLineItem': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogIssuesDto
     */
    'lineItemsWithoutMethod': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogIssuesDto
     */
    'termsWithoutAlias': Array<string>;
}
/**
 * 
 * @export
 * @interface CatalogTermNodeDto
 */
export interface CatalogTermNodeDto {
    /**
     * 
     * @type {string}
     * @memberof CatalogTermNodeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogTermNodeDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogTermNodeDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogTermNodeDto
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogTermNodeDto
     */
    'therapyType'?: string | null;
    /**
     * 
     * @type {Array<TermResolutionDto>}
     * @memberof CatalogTermNodeDto
     */
    'resolutions': Array<TermResolutionDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogTermNodeDto
     */
    'aliases': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CatalogTermNodeDto
     */
    'usedByLines': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogTermNodeDto
     */
    'unreachableInTarifGroups': Array<string>;
}
/**
 * 
 * @export
 * @interface CatalogUsageDto
 */
export interface CatalogUsageDto {
    /**
     * 
     * @type {string}
     * @memberof CatalogUsageDto
     */
    'entity': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogUsageDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogUsageDto
     */
    'deletable': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogUsageDto
     */
    'blockers': Array<string>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CatalogUsageDto
     */
    'counts': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface ChangeAdminPinDto
 */
export interface ChangeAdminPinDto {
    /**
     * 
     * @type {string}
     * @memberof ChangeAdminPinDto
     */
    'newPin': string;
}
/**
 * 
 * @export
 * @interface ChatRequestDto
 */
export interface ChatRequestDto {
    /**
     * Name of the agent to use (e.g., \"validation-agent\")
     * @type {string}
     * @memberof ChatRequestDto
     */
    'agentName': string;
    /**
     * The user message to send to the agent
     * @type {string}
     * @memberof ChatRequestDto
     */
    'message': string;
    /**
     * Thread ID for continuing a conversation. Omit to start a new thread.
     * @type {string}
     * @memberof ChatRequestDto
     */
    'threadId'?: string;
}
/**
 * 
 * @export
 * @interface ChatResponseDto
 */
export interface ChatResponseDto {
    /**
     * Thread ID for this conversation. Use this to subscribe via WebSocket and to continue the conversation.
     * @type {string}
     * @memberof ChatResponseDto
     */
    'threadId': string;
    /**
     * Name of the agent handling this request
     * @type {string}
     * @memberof ChatResponseDto
     */
    'agentName': string;
}
/**
 * 
 * @export
 * @interface ClientInfoDto
 */
export interface ClientInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDto
     */
    'serialNumber'?: string;
    /**
     * 
     * @type {object}
     * @memberof ClientInfoDto
     */
    'metadata'?: object;
}
/**
 * 
 * @export
 * @interface ClientMetadataDto
 */
export interface ClientMetadataDto {
    /**
     * Client description
     * @type {string}
     * @memberof ClientMetadataDto
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface ClinicLightDto
 */
export interface ClinicLightDto {
    /**
     * Clinic id (practice number)
     * @type {string}
     * @memberof ClinicLightDto
     */
    'id'?: string;
    /**
     * Official BSNR of the clinic
     * @type {string}
     * @memberof ClinicLightDto
     */
    'BSNR'?: string;
}
/**
 * 
 * @export
 * @interface ClosestAppointmentDto
 */
export interface ClosestAppointmentDto {
    /**
     * Appointment ID
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'appointmentId': string;
    /**
     * Date string (YYYY-MM-DD)
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'date': string;
    /**
     * Start time (ISO)
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'start': string;
    /**
     * End time (ISO)
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'end': string;
    /**
     * Patient full name
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'patientName': string;
    /**
     * Patient ID
     * @type {number}
     * @memberof ClosestAppointmentDto
     */
    'patientId': number;
    /**
     * Therapist full name
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'therapistName': string;
    /**
     * Formatted address string
     * @type {string}
     * @memberof ClosestAppointmentDto
     */
    'addressString'?: string;
    /**
     * Address latitude
     * @type {number}
     * @memberof ClosestAppointmentDto
     */
    'latitude': number;
    /**
     * Address longitude
     * @type {number}
     * @memberof ClosestAppointmentDto
     */
    'longitude': number;
    /**
     * Euclidean distance to target coordinates
     * @type {number}
     * @memberof ClosestAppointmentDto
     */
    'distance': number;
    /**
     * Actual driving travel time in minutes from the target address (via Google Maps Distance Matrix). Only populated for the closest unique addresses; undefined when not available.
     * @type {number}
     * @memberof ClosestAppointmentDto
     */
    'travelTimeMinutes'?: number;
}
/**
 * 
 * @export
 * @interface ClosestAppointmentsRequestDto
 */
export interface ClosestAppointmentsRequestDto {
    /**
     * Target latitude
     * @type {number}
     * @memberof ClosestAppointmentsRequestDto
     */
    'latitude'?: number;
    /**
     * Target longitude
     * @type {number}
     * @memberof ClosestAppointmentsRequestDto
     */
    'longitude'?: number;
    /**
     * Selected appointment ID used to derive target coordinates server-side
     * @type {string}
     * @memberof ClosestAppointmentsRequestDto
     */
    'appointmentId'?: string;
    /**
     * Selected address ID used to derive target coordinates server-side
     * @type {string}
     * @memberof ClosestAppointmentsRequestDto
     */
    'addressId'?: string;
    /**
     * Start date of the week (YYYY-MM-DD)
     * @type {string}
     * @memberof ClosestAppointmentsRequestDto
     */
    'weekStartDate': string;
    /**
     * Currently selected day (YYYY-MM-DD). When provided, the closest unique addresses on this day are also evaluated for travel times.
     * @type {string}
     * @memberof ClosestAppointmentsRequestDto
     */
    'selectedDate'?: string;
    /**
     * Maximum number of results to return
     * @type {number}
     * @memberof ClosestAppointmentsRequestDto
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface ClosestContinuousAppointmentDto
 */
export interface ClosestContinuousAppointmentDto {
    /**
     * Continuous appointment ID
     * @type {string}
     * @memberof ClosestContinuousAppointmentDto
     */
    'continuousAppointmentId': string;
    /**
     * Weekday it recurs on (0 = Sunday … 6 = Saturday)
     * @type {number}
     * @memberof ClosestContinuousAppointmentDto
     */
    'dayOfWeek': number;
    /**
     * Start time (ISO). Only the time-of-day is meaningful.
     * @type {string}
     * @memberof ClosestContinuousAppointmentDto
     */
    'start': string;
    /**
     * End time (ISO). Only the time-of-day is meaningful.
     * @type {string}
     * @memberof ClosestContinuousAppointmentDto
     */
    'end': string;
    /**
     * Patient full name
     * @type {string}
     * @memberof ClosestContinuousAppointmentDto
     */
    'patientName': string;
    /**
     * Patient ID
     * @type {number}
     * @memberof ClosestContinuousAppointmentDto
     */
    'patientId': number;
    /**
     * Therapist full name
     * @type {string}
     * @memberof ClosestContinuousAppointmentDto
     */
    'therapistName': string;
    /**
     * Formatted address string
     * @type {string}
     * @memberof ClosestContinuousAppointmentDto
     */
    'addressString'?: string;
    /**
     * Address latitude
     * @type {number}
     * @memberof ClosestContinuousAppointmentDto
     */
    'latitude': number;
    /**
     * Address longitude
     * @type {number}
     * @memberof ClosestContinuousAppointmentDto
     */
    'longitude': number;
    /**
     * Euclidean distance to target coordinates
     * @type {number}
     * @memberof ClosestContinuousAppointmentDto
     */
    'distance': number;
    /**
     * Actual driving travel time in minutes from the target address (via Google Maps Distance Matrix). Only populated for the closest unique addresses; undefined when not available.
     * @type {number}
     * @memberof ClosestContinuousAppointmentDto
     */
    'travelTimeMinutes'?: number;
}
/**
 * 
 * @export
 * @interface ClosestContinuousAppointmentsRequestDto
 */
export interface ClosestContinuousAppointmentsRequestDto {
    /**
     * Target latitude
     * @type {number}
     * @memberof ClosestContinuousAppointmentsRequestDto
     */
    'latitude'?: number;
    /**
     * Target longitude
     * @type {number}
     * @memberof ClosestContinuousAppointmentsRequestDto
     */
    'longitude'?: number;
    /**
     * Selected continuous appointment ID used to derive target coordinates server-side
     * @type {string}
     * @memberof ClosestContinuousAppointmentsRequestDto
     */
    'continuousAppointmentId'?: string;
    /**
     * Selected address ID used to derive target coordinates server-side
     * @type {string}
     * @memberof ClosestContinuousAppointmentsRequestDto
     */
    'addressId'?: string;
    /**
     * Currently viewed weekday (0 = Sunday … 6 = Saturday). When provided, the closest unique addresses on this weekday are also evaluated for travel times.
     * @type {number}
     * @memberof ClosestContinuousAppointmentsRequestDto
     */
    'dayOfWeek'?: number;
    /**
     * Maximum number of results to return
     * @type {number}
     * @memberof ClosestContinuousAppointmentsRequestDto
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface CommentRequestDto
 */
export interface CommentRequestDto {
    /**
     * The comment text
     * @type {string}
     * @memberof CommentRequestDto
     */
    'comment': string;
    /**
     * Activity ID for updating existing comment
     * @type {string}
     * @memberof CommentRequestDto
     */
    'activityId'?: string;
}
/**
 * 
 * @export
 * @interface CompletableRxDto
 */
export interface CompletableRxDto {
    /**
     * ID of the Rx that is now completable
     * @type {string}
     * @memberof CompletableRxDto
     */
    'rxId': string;
    /**
     * Human-readable Rx number
     * @type {string}
     * @memberof CompletableRxDto
     */
    'rxNumber': string;
    /**
     * Whether all scheduled appointments have been attended
     * @type {boolean}
     * @memberof CompletableRxDto
     */
    'allAttended': boolean;
    /**
     * Whether there are still unscheduled timeslots on this Rx
     * @type {boolean}
     * @memberof CompletableRxDto
     */
    'hasUnscheduled': boolean;
    /**
     * Number of unscheduled timeslots remaining
     * @type {number}
     * @memberof CompletableRxDto
     */
    'unscheduledCount'?: number;
}
/**
 * 
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'salutation': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'firstNames': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'businessName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'phone1': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'phone2': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'fax': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'bic': string;
}
/**
 * 
 * @export
 * @interface ContactInfoDTO
 */
export interface ContactInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'salutation'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'firstNames'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'phone1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDTO
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface ContextDto
 */
export interface ContextDto {
    /**
     * 
     * @type {object}
     * @memberof ContextDto
     */
    'pre': object;
    /**
     * 
     * @type {object}
     * @memberof ContextDto
     */
    'post': object;
}
/**
 * 
 * @export
 * @interface ContinousAppLists
 */
export interface ContinousAppLists {
    /**
     * 
     * @type {Array<ContinuousAppointmentDto>}
     * @memberof ContinousAppLists
     */
    'appointments': Array<ContinuousAppointmentDto>;
    /**
     * 
     * @type {Array<ContinuousEventTimeSlotDto>}
     * @memberof ContinousAppLists
     */
    'eventTimeSlots': Array<ContinuousEventTimeSlotDto>;
}
/**
 * 
 * @export
 * @interface ContinuousAppointmentDto
 */
export interface ContinuousAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof ContinuousAppointmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof ContinuousAppointmentDto
     */
    'timeSlots'?: Array<TimeSlotDto>;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof ContinuousAppointmentDto
     */
    'frequency': TherapyFrequencyDto;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof ContinuousAppointmentDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContinuousAppointmentDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof ContinuousAppointmentDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinuousAppointmentDto
     */
    'end'?: string;
    /**
     * 
     * @type {Array<ContinuousParticipantDto>}
     * @memberof ContinuousAppointmentDto
     */
    'participants'?: Array<ContinuousParticipantDto>;
}
/**
 * 
 * @export
 * @interface ContinuousEventTimeSlotDto
 */
export interface ContinuousEventTimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof ContinuousEventTimeSlotDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinuousEventTimeSlotDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinuousEventTimeSlotDto
     */
    'title'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof ContinuousEventTimeSlotDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof ContinuousEventTimeSlotDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinuousEventTimeSlotDto
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface ContinuousParticipantDto
 */
export interface ContinuousParticipantDto {
    /**
     * 
     * @type {string}
     * @memberof ContinuousParticipantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinuousParticipantDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinuousParticipantDto
     */
    'end'?: string;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof ContinuousParticipantDto
     */
    'timeSlots'?: Array<TimeSlotDto>;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof ContinuousParticipantDto
     */
    'frequency'?: TherapyFrequencyDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContinuousParticipantDto
     */
    'address'?: AddressDto;
}
/**
 * 
 * @export
 * @interface CopaymentExemptionDto
 */
export interface CopaymentExemptionDto {
    /**
     * 
     * @type {string}
     * @memberof CopaymentExemptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopaymentExemptionDto
     */
    'documentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopaymentExemptionDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopaymentExemptionDto
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface CopaymentSummaryDto
 */
export interface CopaymentSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CopaymentSummaryDto
     */
    'copayment': number;
    /**
     * 
     * @type {number}
     * @memberof CopaymentSummaryDto
     */
    'copaymentPercentualComponent': number;
    /**
     * 
     * @type {number}
     * @memberof CopaymentSummaryDto
     */
    'copaymentFixedComponent': number;
}
/**
 * 
 * @export
 * @interface CopyToNewDto
 */
export interface CopyToNewDto {
    /**
     * Whitelist of timeslot ids to include in the copy. When omitted, all timeslots of the appointment are copied.
     * @type {Array<string>}
     * @memberof CopyToNewDto
     */
    'timeSlotIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateAccountDto
 */
export interface CreateAccountDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'ik'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'creditorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof CreateAccountDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountDto
     */
    'isCompanyGroup'?: boolean;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof CreateAccountDto
     */
    'contactInfo'?: KontakInfoDto;
}


/**
 * 
 * @export
 * @interface CreateAndScheduleAppointmentDto
 */
export interface CreateAndScheduleAppointmentDto {
    /**
     * Ordered TherapyRx ids to include in the appointment (e.g. KG then PA). Server loads them and builds one time slot per therapy.
     * @type {Array<string>}
     * @memberof CreateAndScheduleAppointmentDto
     */
    'therapyRxIds': Array<string>;
    /**
     * ISO start time of the drop point (aligned to the first non-heat therapy).
     * @type {string}
     * @memberof CreateAndScheduleAppointmentDto
     */
    'start': string;
    /**
     * Therapist (user) id to assign to the time slots.
     * @type {string}
     * @memberof CreateAndScheduleAppointmentDto
     */
    'userId': string;
    /**
     * Address id for the appointment. Required – every appointment needs an address.
     * @type {string}
     * @memberof CreateAndScheduleAppointmentDto
     */
    'addressId': string;
    /**
     * Optional frequency id to set on the appointment.
     * @type {string}
     * @memberof CreateAndScheduleAppointmentDto
     */
    'frequencyId'?: string;
    /**
     * Required map of therapyRxId -> visit fee (Hausbesuchsgebühr) id, or null for an explicit \'no fee\' choice. Every therapyRxId in therapyRxIds must be present as a key so the fee is always a deliberate decision (null allowed, undefined is not).
     * @type {object}
     * @memberof CreateAndScheduleAppointmentDto
     */
    'visitFees': object;
}
/**
 * 
 * @export
 * @interface CreateBankAccountDto
 */
export interface CreateBankAccountDto {
    /**
     * Owning patient id.
     * @type {number}
     * @memberof CreateBankAccountDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBankAccountDto
     */
    'holderFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankAccountDto
     */
    'holderLastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankAccountDto
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankAccountDto
     */
    'bic'?: string;
}
/**
 * 
 * @export
 * @interface CreateBankTransferDto
 */
export interface CreateBankTransferDto {
    /**
     * Method of the transaction (must be BANKTRANSFER here)
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'method': CreateBankTransferDtoMethodEnum;
    /**
     * ID of the associated account
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'accountId': string;
    /**
     * UUID of the associated user
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'userId': string;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof CreateBankTransferDto
     */
    'wasExported'?: boolean;
    /**
     * ID of the associated TAccount
     * @type {number}
     * @memberof CreateBankTransferDto
     */
    'tAccountId'?: number;
    /**
     * Associated Business ID
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'businessId'?: string;
    /**
     * Associated Location ID
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'locationId'?: string;
    /**
     * Description of the bank transfer
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'text': string;
    /**
     * Type of the transaction
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'type': CreateBankTransferDtoTypeEnum;
    /**
     * Total amount of this bank transfer. Sum of all allocations ideally matches this.
     * @type {number}
     * @memberof CreateBankTransferDto
     */
    'amount': number;
    /**
     * An array of rechnung allocations for partial payments
     * @type {Array<RechnungAllocationDto>}
     * @memberof CreateBankTransferDto
     */
    'rechnungAllocations': Array<RechnungAllocationDto>;
    /**
     * 
     * @type {number}
     * @memberof CreateBankTransferDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransferDto
     */
    'rxId'?: string;
}

export const CreateBankTransferDtoMethodEnum = {
    Cash: 'CASH',
    Ec: 'EC',
    Lastschrift: 'LASTSCHRIFT',
    Versicherung: 'VERSICHERUNG',
    Banktransfer: 'BANKTRANSFER',
    Sepa: 'SEPA',
    Internal: 'INTERNAL'
} as const;

export type CreateBankTransferDtoMethodEnum = typeof CreateBankTransferDtoMethodEnum[keyof typeof CreateBankTransferDtoMethodEnum];
export const CreateBankTransferDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type CreateBankTransferDtoTypeEnum = typeof CreateBankTransferDtoTypeEnum[keyof typeof CreateBankTransferDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateBaseNoticeDefinitionDataDto
 */
export interface CreateBaseNoticeDefinitionDataDto {
    /**
     * ID of the notice definition this data is based on
     * @type {string}
     * @memberof CreateBaseNoticeDefinitionDataDto
     */
    'noticeDefinitionId': string;
    /**
     * Date from which this particualar template data becomes effective
     * @type {string}
     * @memberof CreateBaseNoticeDefinitionDataDto
     */
    'effectiveFrom': string;
}
/**
 * 
 * @export
 * @interface CreateBusinessDto
 */
export interface CreateBusinessDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessDto
     */
    'creditorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof CreateBusinessDto
     */
    'contactInfo'?: KontakInfoDto;
}
/**
 * 
 * @export
 * @interface CreateClinicDto
 */
export interface CreateClinicDto {
    /**
     * 
     * @type {string}
     * @memberof CreateClinicDto
     */
    'id'?: string;
    /**
     * Official BSNR (9 numeric digits)
     * @type {string}
     * @memberof CreateClinicDto
     */
    'BSNR'?: string;
    /**
     * List of IDs associated with the clinic
     * @type {Array<string>}
     * @memberof CreateClinicDto
     */
    'doctorNumbers'?: Array<string>;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof CreateClinicDto
     */
    'contactInfo': ContactInfoDTO;
    /**
     * 
     * @type {string}
     * @memberof CreateClinicDto
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClinicDto
     */
    'methodForDrReport'?: CreateClinicDtoMethodForDrReportEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateClinicDto
     */
    'methodForRxOrder'?: CreateClinicDtoMethodForRxOrderEnum;
}

export const CreateClinicDtoMethodForDrReportEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type CreateClinicDtoMethodForDrReportEnum = typeof CreateClinicDtoMethodForDrReportEnum[keyof typeof CreateClinicDtoMethodForDrReportEnum];
export const CreateClinicDtoMethodForRxOrderEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type CreateClinicDtoMethodForRxOrderEnum = typeof CreateClinicDtoMethodForRxOrderEnum[keyof typeof CreateClinicDtoMethodForRxOrderEnum];

/**
 * 
 * @export
 * @interface CreateDiagnosisGroupDto
 */
export interface CreateDiagnosisGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'a'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'b'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'c'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'd'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiagnosisGroupDto
     */
    'isRelevant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'PrimaryTreatments'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'SecondaryTreatments'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'MaxAmountPerRx'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'MaxAmountStandard'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'MaxAmountException'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'Frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiagnosisGroupDto
     */
    'rxTypeId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof CreateDiagnosisGroupDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface CreateDirectDebitDto
 */
export interface CreateDirectDebitDto {
    /**
     * 
     * @type {number}
     * @memberof CreateDirectDebitDto
     */
    'patientId': number;
    /**
     * Creditor account (Mandant) id.
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'accountId': string;
    /**
     * ACTIVE mandate authorizing the collection.
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'mandateId': string;
    /**
     * Positive amount in EUR.
     * @type {number}
     * @memberof CreateDirectDebitDto
     */
    'amount': number;
    /**
     * Remittance information.
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'text': string;
    /**
     * Optional associated Rx id.
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'rxId'?: string;
    /**
     * Optional bookkeeping account (TAccount) id.
     * @type {number}
     * @memberof CreateDirectDebitDto
     */
    'tAccountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'locationId'?: string;
    /**
     * Idempotency key to make creation retry-safe.
     * @type {string}
     * @memberof CreateDirectDebitDto
     */
    'idempotencyKey'?: string;
}
/**
 * 
 * @export
 * @interface CreateDoctorClinicDto
 */
export interface CreateDoctorClinicDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorClinicDto
     */
    'id'?: string;
    /**
     * Official LANR (9 numeric digits)
     * @type {string}
     * @memberof CreateDoctorClinicDto
     */
    'LANR'?: string;
    /**
     * List of clinics the doctor is associated with
     * @type {Array<CreateClinicDto>}
     * @memberof CreateDoctorClinicDto
     */
    'clinics'?: Array<CreateClinicDto>;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof CreateDoctorClinicDto
     */
    'contactInfo': ContactInfoDTO;
    /**
     * List of doctors associated with the clinic
     * @type {Array<CreateDoctorDto>}
     * @memberof CreateDoctorClinicDto
     */
    'doctors'?: Array<CreateDoctorDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorClinicDto
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorClinicDto
     */
    'methodForDrReport'?: CreateDoctorClinicDtoMethodForDrReportEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorClinicDto
     */
    'methodForRxOrder'?: CreateDoctorClinicDtoMethodForRxOrderEnum;
}

export const CreateDoctorClinicDtoMethodForDrReportEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type CreateDoctorClinicDtoMethodForDrReportEnum = typeof CreateDoctorClinicDtoMethodForDrReportEnum[keyof typeof CreateDoctorClinicDtoMethodForDrReportEnum];
export const CreateDoctorClinicDtoMethodForRxOrderEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type CreateDoctorClinicDtoMethodForRxOrderEnum = typeof CreateDoctorClinicDtoMethodForRxOrderEnum[keyof typeof CreateDoctorClinicDtoMethodForRxOrderEnum];

/**
 * 
 * @export
 * @interface CreateDoctorDto
 */
export interface CreateDoctorDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorDto
     */
    'id'?: string;
    /**
     * Official LANR (9 numeric digits)
     * @type {string}
     * @memberof CreateDoctorDto
     */
    'LANR'?: string;
    /**
     * List of clinics the doctor is associated with
     * @type {Array<string>}
     * @memberof CreateDoctorDto
     */
    'clinics'?: Array<string>;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof CreateDoctorDto
     */
    'contactInfo': ContactInfoDTO;
}
/**
 * 
 * @export
 * @interface CreateDoctorReportDto
 */
export interface CreateDoctorReportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'rxId': string;
    /**
     * 
     * @type {RxDto}
     * @memberof CreateDoctorReportDto
     */
    'rx'?: RxDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'isDifferentTreatmentPeriod'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'latestTimeSlotStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'earliestTimeSlotStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'treatmentStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'treatmentEnd'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'therapyStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'specialFeatures'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'isRegulatedTreatment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'therapyFrequency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'singleTherapy'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'groupTherapy'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'treatmentModification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'isTreatmentDiscontinued'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'treatmentTerminationDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'treatmentTerminationReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDoctorReportDto
     */
    'treatmentTerminationAfter'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDoctorReportDto
     */
    'continueTreatment'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'therapyAssessment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'therapyChangeSuggestions'?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'processingDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'printedAt'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'sentByEmailAt'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'sentByFaxAt'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'createdByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof CreateDoctorReportDto
     */
    'createdByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'assignedToUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof CreateDoctorReportDto
     */
    'assignedToUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'updatedByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof CreateDoctorReportDto
     */
    'updatedByUser'?: UserDto;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'createdAt'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateDoctorReportDto
     */
    'updatedAt'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'latestTransactionNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDoctorReportDto
     */
    'latestTransactionBillStatus'?: CreateDoctorReportDtoLatestTransactionBillStatusEnum;
}

export const CreateDoctorReportDtoLatestTransactionBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;

export type CreateDoctorReportDtoLatestTransactionBillStatusEnum = typeof CreateDoctorReportDtoLatestTransactionBillStatusEnum[keyof typeof CreateDoctorReportDtoLatestTransactionBillStatusEnum];

/**
 * 
 * @export
 * @interface CreateExportBatchDto
 */
export interface CreateExportBatchDto {
    /**
     * Creditor account (Mandant) id whose transactions are exported.
     * @type {string}
     * @memberof CreateExportBatchDto
     */
    'accountId': string;
    /**
     * Which movement to export. One batch = one direction, because each maps to a different ISO 20022 schema (pain.008 vs pain.001).
     * @type {string}
     * @memberof CreateExportBatchDto
     */
    'direction': CreateExportBatchDtoDirectionEnum;
    /**
     * Optional explicit selection. When omitted, all PENDING transactions for the account + direction are exported.
     * @type {Array<string>}
     * @memberof CreateExportBatchDto
     */
    'transactionIds'?: Array<string>;
    /**
     * Idempotency key to make the export retry-safe.
     * @type {string}
     * @memberof CreateExportBatchDto
     */
    'idempotencyKey'?: string;
}

export const CreateExportBatchDtoDirectionEnum = {
    DirectDebit: 'DIRECT_DEBIT',
    CreditTransfer: 'CREDIT_TRANSFER'
} as const;

export type CreateExportBatchDtoDirectionEnum = typeof CreateExportBatchDtoDirectionEnum[keyof typeof CreateExportBatchDtoDirectionEnum];

/**
 * 
 * @export
 * @interface CreateInitialEvaluationDto
 */
export interface CreateInitialEvaluationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateInitialEvaluationDto
     */
    'evaluation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitialEvaluationDto
     */
    'goals'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateInitialEvaluationDto
     */
    'patientId': number;
}
/**
 * 
 * @export
 * @interface CreateInsuranceTransactionDto
 */
export interface CreateInsuranceTransactionDto {
    /**
     * Method of the transaction
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'method': CreateInsuranceTransactionDtoMethodEnum;
    /**
     * ID of the associated account
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'accountId': string;
    /**
     * UUID of the associated user
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'userId': string;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof CreateInsuranceTransactionDto
     */
    'wasExported'?: boolean;
    /**
     * ID of the associated TAccount
     * @type {number}
     * @memberof CreateInsuranceTransactionDto
     */
    'tAccountId'?: number;
    /**
     * Associated Business ID
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'businessId'?: string;
    /**
     * Associated Location ID
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'locationId'?: string;
    /**
     * Total amount of all the relevant Rxs/Transaction
     * @type {number}
     * @memberof CreateInsuranceTransactionDto
     */
    'amount': number;
    /**
     * Array of UUIDs of the associated Rxs
     * @type {Array<string>}
     * @memberof CreateInsuranceTransactionDto
     */
    'rxIds': Array<string>;
    /**
     * ID of the associated payer
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'payerId': string;
    /**
     * ID of the associated paper billing center
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'paperCenterId': string;
    /**
     * ID of the associated digital billing center
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'dataCenterId': string;
    /**
     * Notes for the transaction
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'notes': string;
    /**
     * Type of the bill (BG, GKV)
     * @type {string}
     * @memberof CreateInsuranceTransactionDto
     */
    'billType': string;
    /**
     * Selected line items per Rx for LINE_ITEM_CORRECTION bills
     * @type {Array<RxLineItemSelectionDto>}
     * @memberof CreateInsuranceTransactionDto
     */
    'rxLineItemSelections'?: Array<RxLineItemSelectionDto>;
}

export const CreateInsuranceTransactionDtoMethodEnum = {
    Cash: 'CASH',
    Ec: 'EC',
    Lastschrift: 'LASTSCHRIFT',
    Versicherung: 'VERSICHERUNG',
    Banktransfer: 'BANKTRANSFER',
    Sepa: 'SEPA',
    Internal: 'INTERNAL'
} as const;

export type CreateInsuranceTransactionDtoMethodEnum = typeof CreateInsuranceTransactionDtoMethodEnum[keyof typeof CreateInsuranceTransactionDtoMethodEnum];

/**
 * 
 * @export
 * @interface CreateKostentraegerDto
 */
export interface CreateKostentraegerDto {
    /**
     * Institutionskennzeichen (also used as the id).
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'ik': string;
    /**
     * Name of the Kostenträger.
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'name': string;
    /**
     * GKV | Privat | BG | BW. Non-GKV also creates a Payer.
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'type'?: string;
    /**
     * TarifGroup id.
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKostentraegerDto
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface CreateLocationDto
 */
export interface CreateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'primaryAccountId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationDto
     */
    'accountIds'?: Array<string>;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof CreateLocationDto
     */
    'addressContactInfo'?: KontakInfoDto;
}
/**
 * 
 * @export
 * @interface CreateMandateDto
 */
export interface CreateMandateDto {
    /**
     * Owning patient id.
     * @type {number}
     * @memberof CreateMandateDto
     */
    'patientId': number;
    /**
     * Creditor account (Mandant) id that may collect.
     * @type {string}
     * @memberof CreateMandateDto
     */
    'accountId': string;
    /**
     * Reuse an existing bank account. If omitted, inline holder + IBAN are used.
     * @type {string}
     * @memberof CreateMandateDto
     */
    'bankAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMandateDto
     */
    'holderFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMandateDto
     */
    'holderLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMandateDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMandateDto
     */
    'bic'?: string;
    /**
     * For one-off mandates: the Rx this single authorization pays.
     * @type {string}
     * @memberof CreateMandateDto
     */
    'rxId'?: string;
    /**
     * OOFF = one-off (single use), RCUR = recurring (multi use).
     * @type {string}
     * @memberof CreateMandateDto
     */
    'sequenceType': CreateMandateDtoSequenceTypeEnum;
    /**
     * Optional cap for one-off (OOFF) mandates.
     * @type {number}
     * @memberof CreateMandateDto
     */
    'maxAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMandateDto
     */
    'validUntil'?: string;
}

export const CreateMandateDtoSequenceTypeEnum = {
    Ooff: 'OOFF',
    Rcur: 'RCUR'
} as const;

export type CreateMandateDtoSequenceTypeEnum = typeof CreateMandateDtoSequenceTypeEnum[keyof typeof CreateMandateDtoSequenceTypeEnum];

/**
 * 
 * @export
 * @interface CreateNoteDto
 */
export interface CreateNoteDto {
    /**
     * Optional client-generated UUID for offline idempotency. Must be a UUID when present.
     * @type {string}
     * @memberof CreateNoteDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoteDto
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof CreateNoteDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateNoteDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoteDto
     */
    'rxId'?: string;
}
/**
 * 
 * @export
 * @interface CreateNoticeDefinitionDto
 */
export interface CreateNoticeDefinitionDto {
    /**
     * Title of the notice template
     * @type {string}
     * @memberof CreateNoticeDefinitionDto
     */
    'title': string;
    /**
     * Description of the notice
     * @type {string}
     * @memberof CreateNoticeDefinitionDto
     */
    'description': string;
    /**
     * Type of the notice
     * @type {string}
     * @memberof CreateNoticeDefinitionDto
     */
    'type': CreateNoticeDefinitionDtoTypeEnum;
    /**
     * Template id
     * @type {string}
     * @memberof CreateNoticeDefinitionDto
     */
    'templateId': string;
}

export const CreateNoticeDefinitionDtoTypeEnum = {
    PrivatePricing: 'PRIVATE_PRICING',
    PolicyUpdate: 'POLICY_UPDATE',
    GeneralInfo: 'GENERAL_INFO'
} as const;

export type CreateNoticeDefinitionDtoTypeEnum = typeof CreateNoticeDefinitionDtoTypeEnum[keyof typeof CreateNoticeDefinitionDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreatePatientDto
 */
export interface CreatePatientDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'salutation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'dob': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'status'?: string;
    /**
     * 
     * @type {InsurerDto}
     * @memberof CreatePatientDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'insuranceNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePatientDto
     */
    'coPayment'?: boolean;
    /**
     * 
     * @type {Array<CopaymentExemptionDto>}
     * @memberof CreatePatientDto
     */
    'copaymentExemptions'?: Array<CopaymentExemptionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePatientDto
     */
    'waitList'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'letterOfAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'phone1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'email'?: string;
    /**
     * 
     * @type {object}
     * @memberof CreatePatientDto
     */
    'location'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingFirstnames'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingLastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingTel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingFax'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingAddressline1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingAddressline2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingZip'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentBusinessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentTel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentFax'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentAddressline1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentAddressline2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentZip'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePatientDto
     */
    'smsDesired': boolean;
    /**
     * 
     * @type {Array<RxDto>}
     * @memberof CreatePatientDto
     */
    'rxs'?: Array<RxDto>;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof CreatePatientDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'primaryAddressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'alternativeBillingAddressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'treatmentAddressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'dataPrivacyPolicyStatus'?: string;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof CreatePatientDto
     */
    'addresses': Array<AddressDto>;
}
/**
 * 
 * @export
 * @interface CreatePatientTransactionDto
 */
export interface CreatePatientTransactionDto {
    /**
     * Method of the transaction
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'method': CreatePatientTransactionDtoMethodEnum;
    /**
     * ID of the associated account
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'accountId': string;
    /**
     * UUID of the associated user
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'userId': string;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof CreatePatientTransactionDto
     */
    'wasExported'?: boolean;
    /**
     * ID of the associated TAccount
     * @type {number}
     * @memberof CreatePatientTransactionDto
     */
    'tAccountId'?: number;
    /**
     * Associated Business ID
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'businessId'?: string;
    /**
     * Associated Location ID
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'locationId'?: string;
    /**
     * Description of the transaction
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'text': string;
    /**
     * Type of the transaction
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'type': CreatePatientTransactionDtoTypeEnum;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof CreatePatientTransactionDto
     */
    'amount': number;
    /**
     * UUID of the associated Rx
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'rxId'?: string;
    /**
     * ID of the associated patient. Absent for counter sales (services / gift certificates) that are not tied to a patient record.
     * @type {number}
     * @memberof CreatePatientTransactionDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {DebitPermissionDto}
     * @memberof CreatePatientTransactionDto
     */
    'debitPermission'?: DebitPermissionDto;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientTransactionDto
     */
    'originalTransactionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePatientTransactionDto
     */
    'isCancelled'?: boolean;
}

export const CreatePatientTransactionDtoMethodEnum = {
    Cash: 'CASH',
    Ec: 'EC',
    Lastschrift: 'LASTSCHRIFT',
    Versicherung: 'VERSICHERUNG',
    Banktransfer: 'BANKTRANSFER',
    Sepa: 'SEPA',
    Internal: 'INTERNAL'
} as const;

export type CreatePatientTransactionDtoMethodEnum = typeof CreatePatientTransactionDtoMethodEnum[keyof typeof CreatePatientTransactionDtoMethodEnum];
export const CreatePatientTransactionDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type CreatePatientTransactionDtoTypeEnum = typeof CreatePatientTransactionDtoTypeEnum[keyof typeof CreatePatientTransactionDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreatePriceDateRangeDto
 */
export interface CreatePriceDateRangeDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePriceDateRangeDto
     */
    'therapyId': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceDateRangeDto
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceDateRangeDto
     */
    'invalidFrom': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceDateRangeDto
     */
    'price': number;
    /**
     * Date-specific Positionsnummer override
     * @type {string}
     * @memberof CreatePriceDateRangeDto
     */
    'lineItem'?: string;
}
/**
 * 
 * @export
 * @interface CreatePublicHolidayDto
 */
export interface CreatePublicHolidayDto {
    /**
     * Title of the public holiday
     * @type {string}
     * @memberof CreatePublicHolidayDto
     */
    'title': string;
    /**
     * Start date of the public holiday
     * @type {string}
     * @memberof CreatePublicHolidayDto
     */
    'start': string;
    /**
     * End date of the public holiday
     * @type {string}
     * @memberof CreatePublicHolidayDto
     */
    'end': string;
    /**
     * Bundesland code (null for national holidays)
     * @type {string}
     * @memberof CreatePublicHolidayDto
     */
    'bundesland'?: string;
    /**
     * Year of the public holiday
     * @type {number}
     * @memberof CreatePublicHolidayDto
     */
    'year': number;
}
/**
 * 
 * @export
 * @interface CreateRechnungDto
 */
export interface CreateRechnungDto {
    /**
     * Total invoice amount
     * @type {number}
     * @memberof CreateRechnungDto
     */
    'amount': number;
    /**
     * ID of the associated patient
     * @type {number}
     * @memberof CreateRechnungDto
     */
    'patientId': number;
    /**
     * Optional: Description or text for invoice
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'text'?: string;
    /**
     * Transaction type or classification (if needed)
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'type'?: CreateRechnungDtoTypeEnum;
    /**
     * Payment status of the invoice
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'paymentStatus'?: CreateRechnungDtoPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'userId'?: string;
    /**
     * UUID of the associated Rx
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRechnungDto
     */
    'tAccountId'?: number;
    /**
     * Optional header/footer decoration for the generated PDF
     * @type {string}
     * @memberof CreateRechnungDto
     */
    'pdfDecoration'?: CreateRechnungDtoPdfDecorationEnum;
}

export const CreateRechnungDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type CreateRechnungDtoTypeEnum = typeof CreateRechnungDtoTypeEnum[keyof typeof CreateRechnungDtoTypeEnum];
export const CreateRechnungDtoPaymentStatusEnum = {
    Bezahlt: 'Bezahlt',
    TeilweiseBezahlt: 'Teilweise bezahlt',
    NichtBezahlt: 'Nicht bezahlt',
    GkvZuzahlungAngefordert: 'GKV Zuzahlung angefordert'
} as const;

export type CreateRechnungDtoPaymentStatusEnum = typeof CreateRechnungDtoPaymentStatusEnum[keyof typeof CreateRechnungDtoPaymentStatusEnum];
export const CreateRechnungDtoPdfDecorationEnum = {
    None: 'NONE',
    Header: 'HEADER',
    Footer: 'FOOTER',
    Both: 'BOTH'
} as const;

export type CreateRechnungDtoPdfDecorationEnum = typeof CreateRechnungDtoPdfDecorationEnum[keyof typeof CreateRechnungDtoPdfDecorationEnum];

/**
 * 
 * @export
 * @interface CreateRefundDto
 */
export interface CreateRefundDto {
    /**
     * Method of the transaction
     * @type {string}
     * @memberof CreateRefundDto
     */
    'method': CreateRefundDtoMethodEnum;
    /**
     * ID of the associated account
     * @type {string}
     * @memberof CreateRefundDto
     */
    'accountId': string;
    /**
     * UUID of the associated user
     * @type {string}
     * @memberof CreateRefundDto
     */
    'userId': string;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof CreateRefundDto
     */
    'wasExported'?: boolean;
    /**
     * ID of the associated TAccount
     * @type {number}
     * @memberof CreateRefundDto
     */
    'tAccountId'?: number;
    /**
     * Associated Business ID
     * @type {string}
     * @memberof CreateRefundDto
     */
    'businessId'?: string;
    /**
     * Associated Location ID
     * @type {string}
     * @memberof CreateRefundDto
     */
    'locationId'?: string;
    /**
     * Reason for the refund
     * @type {string}
     * @memberof CreateRefundDto
     */
    'text': string;
    /**
     * Amount to refund (must be positive). Will be stored as negative in database for proper accounting, but converted to positive when exporting to SEPA XML.
     * @type {number}
     * @memberof CreateRefundDto
     */
    'amount': number;
    /**
     * ID of the associated patient
     * @type {number}
     * @memberof CreateRefundDto
     */
    'patientId': number;
    /**
     * UUID of the credit permission (bank account for refund)
     * @type {string}
     * @memberof CreateRefundDto
     */
    'creditPermissionId': string;
    /**
     * Optional UUID of the associated Rx
     * @type {string}
     * @memberof CreateRefundDto
     */
    'rxId'?: string;
    /**
     * Transaction type (always REFUND for refunds)
     * @type {string}
     * @memberof CreateRefundDto
     */
    'type': CreateRefundDtoTypeEnum;
}

export const CreateRefundDtoMethodEnum = {
    Cash: 'CASH',
    Ec: 'EC',
    Lastschrift: 'LASTSCHRIFT',
    Versicherung: 'VERSICHERUNG',
    Banktransfer: 'BANKTRANSFER',
    Sepa: 'SEPA',
    Internal: 'INTERNAL'
} as const;

export type CreateRefundDtoMethodEnum = typeof CreateRefundDtoMethodEnum[keyof typeof CreateRefundDtoMethodEnum];
export const CreateRefundDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type CreateRefundDtoTypeEnum = typeof CreateRefundDtoTypeEnum[keyof typeof CreateRefundDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateSepaRefundDto
 */
export interface CreateSepaRefundDto {
    /**
     * 
     * @type {number}
     * @memberof CreateSepaRefundDto
     */
    'patientId': number;
    /**
     * Paying account (Mandant) id.
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'accountId': string;
    /**
     * Positive amount in EUR.
     * @type {number}
     * @memberof CreateSepaRefundDto
     */
    'amount': number;
    /**
     * Remittance information.
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'text': string;
    /**
     * Reuse an existing payee bank account.
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'bankAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'holderFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'holderLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'bic'?: string;
    /**
     * Optional associated Rx id.
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'rxId'?: string;
    /**
     * Optional bookkeeping account (TAccount) id.
     * @type {number}
     * @memberof CreateSepaRefundDto
     */
    'tAccountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'locationId'?: string;
    /**
     * Idempotency key to make creation retry-safe.
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'idempotencyKey'?: string;
    /**
     * Chief-only override to refund an Rx that is still \'in Behandlung\'. Requires overrideReason.
     * @type {boolean}
     * @memberof CreateSepaRefundDto
     */
    'override'?: boolean;
    /**
     * Reason for the early-refund override (mandatory when override = true). Audited.
     * @type {string}
     * @memberof CreateSepaRefundDto
     */
    'overrideReason'?: string;
}
/**
 * 
 * @export
 * @interface CreateServiceRechnungDto
 */
export interface CreateServiceRechnungDto {
    /**
     * Total invoice amount without Giftcard
     * @type {number}
     * @memberof CreateServiceRechnungDto
     */
    'amount': number;
    /**
     * Total invoice amount
     * @type {number}
     * @memberof CreateServiceRechnungDto
     */
    'originalAmount': number;
    /**
     * Optional: ID of the associated patient for gift certificate billing
     * @type {number}
     * @memberof CreateServiceRechnungDto
     */
    'patientId'?: number;
    /**
     * Optional: Description or text for invoice
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'text'?: string;
    /**
     * Transaction type or classification (if needed)
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'type'?: CreateServiceRechnungDtoTypeEnum;
    /**
     * Payment status of the invoice
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'paymentStatus'?: CreateServiceRechnungDtoPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<SalesTimeSlotDto>}
     * @memberof CreateServiceRechnungDto
     */
    'serviceTimeSlots'?: Array<SalesTimeSlotDto>;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceRechnungDto
     */
    'tAccountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'gcId'?: string;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof CreateServiceRechnungDto
     */
    'amountApplied'?: number;
    /**
     * Optional header/footer decoration for the generated PDF
     * @type {string}
     * @memberof CreateServiceRechnungDto
     */
    'pdfDecoration'?: CreateServiceRechnungDtoPdfDecorationEnum;
}

export const CreateServiceRechnungDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type CreateServiceRechnungDtoTypeEnum = typeof CreateServiceRechnungDtoTypeEnum[keyof typeof CreateServiceRechnungDtoTypeEnum];
export const CreateServiceRechnungDtoPaymentStatusEnum = {
    Bezahlt: 'Bezahlt',
    TeilweiseBezahlt: 'Teilweise bezahlt',
    NichtBezahlt: 'Nicht bezahlt',
    GkvZuzahlungAngefordert: 'GKV Zuzahlung angefordert'
} as const;

export type CreateServiceRechnungDtoPaymentStatusEnum = typeof CreateServiceRechnungDtoPaymentStatusEnum[keyof typeof CreateServiceRechnungDtoPaymentStatusEnum];
export const CreateServiceRechnungDtoPdfDecorationEnum = {
    None: 'NONE',
    Header: 'HEADER',
    Footer: 'FOOTER',
    Both: 'BOTH'
} as const;

export type CreateServiceRechnungDtoPdfDecorationEnum = typeof CreateServiceRechnungDtoPdfDecorationEnum[keyof typeof CreateServiceRechnungDtoPdfDecorationEnum];

/**
 * 
 * @export
 * @interface CreateServicesTransactionDto
 */
export interface CreateServicesTransactionDto {
    /**
     * Method of the transaction
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'method': CreateServicesTransactionDtoMethodEnum;
    /**
     * ID of the associated account
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'accountId': string;
    /**
     * UUID of the associated user
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'userId': string;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof CreateServicesTransactionDto
     */
    'wasExported'?: boolean;
    /**
     * ID of the associated TAccount
     * @type {number}
     * @memberof CreateServicesTransactionDto
     */
    'tAccountId'?: number;
    /**
     * Associated Business ID
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'businessId'?: string;
    /**
     * Associated Location ID
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'locationId'?: string;
    /**
     * Description of the transaction
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'gcId'?: string;
    /**
     * Type of the transaction
     * @type {string}
     * @memberof CreateServicesTransactionDto
     */
    'type': CreateServicesTransactionDtoTypeEnum;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof CreateServicesTransactionDto
     */
    'amount'?: number;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof CreateServicesTransactionDto
     */
    'amountApplied'?: number;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof CreateServicesTransactionDto
     */
    'originalAmount'?: number;
    /**
     * 
     * @type {Array<SalesTimeSlotDto>}
     * @memberof CreateServicesTransactionDto
     */
    'serviceTimeSlots'?: Array<SalesTimeSlotDto>;
    /**
     * ID of the associated patient
     * @type {number}
     * @memberof CreateServicesTransactionDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {Array<GiftCertificateDto>}
     * @memberof CreateServicesTransactionDto
     */
    'giftCertificates'?: Array<GiftCertificateDto>;
}

export const CreateServicesTransactionDtoMethodEnum = {
    Cash: 'CASH',
    Ec: 'EC',
    Lastschrift: 'LASTSCHRIFT',
    Versicherung: 'VERSICHERUNG',
    Banktransfer: 'BANKTRANSFER',
    Sepa: 'SEPA',
    Internal: 'INTERNAL'
} as const;

export type CreateServicesTransactionDtoMethodEnum = typeof CreateServicesTransactionDtoMethodEnum[keyof typeof CreateServicesTransactionDtoMethodEnum];
export const CreateServicesTransactionDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type CreateServicesTransactionDtoTypeEnum = typeof CreateServicesTransactionDtoTypeEnum[keyof typeof CreateServicesTransactionDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateTherapyDto
 */
export interface CreateTherapyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTherapyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTherapyDto
     */
    'lineItem'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTherapyDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTherapyDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTherapyDto
     */
    'inUse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTherapyDto
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {object}
     * @memberof CreateTherapyDto
     */
    'duration'?: object;
    /**
     * 
     * @type {number}
     * @memberof CreateTherapyDto
     */
    'maxParticipants'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTherapyDto
     */
    'tarifGroupId': string;
    /**
     * 
     * @type {object}
     * @memberof CreateTherapyDto
     */
    'therapyCertificationId'?: object;
    /**
     * 
     * @type {TherapyType}
     * @memberof CreateTherapyDto
     */
    'therapyType'?: TherapyType;
}


/**
 * @type CreateTransactionRequest
 * @export
 */
export type CreateTransactionRequest = CreateInsuranceTransactionDto | CreatePatientTransactionDto;

/**
 * 
 * @export
 * @interface CreateTreatmentNoteDto
 */
export interface CreateTreatmentNoteDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTreatmentNoteDto
     */
    'note': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTreatmentNoteDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTreatmentNoteDto
     */
    'treatmentId': string;
}
/**
 * 
 * @export
 * @interface CreateWorkingHoursForDayDto
 */
export interface CreateWorkingHoursForDayDto {
    /**
     * Start time in HH:mm format
     * @type {string}
     * @memberof CreateWorkingHoursForDayDto
     */
    'startTime': string;
    /**
     * End time in HH:mm format
     * @type {string}
     * @memberof CreateWorkingHoursForDayDto
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface DailyScheduleRevenueDto
 */
export interface DailyScheduleRevenueDto {
    /**
     * 
     * @type {number}
     * @memberof DailyScheduleRevenueDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DailyScheduleRevenueDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof DailyScheduleRevenueDto
     */
    'locationId': string;
    /**
     * 
     * @type {number}
     * @memberof DailyScheduleRevenueDto
     */
    'monthlyRevenue': number;
}
/**
 * 
 * @export
 * @interface DebitPermissionDto
 */
export interface DebitPermissionDto {
    /**
     * 
     * @type {string}
     * @memberof DebitPermissionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DebitPermissionDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DebitPermissionDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DebitPermissionDto
     */
    'iban'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DebitPermissionDto
     */
    'bic'?: string | null;
    /**
     * 
     * @type {AccountDto}
     * @memberof DebitPermissionDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof DebitPermissionDto
     */
    'printOut'?: DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof DebitPermissionDto
     */
    'signedDocument'?: DocumentDto;
    /**
     * 
     * @type {PatientDto}
     * @memberof DebitPermissionDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {boolean}
     * @memberof DebitPermissionDto
     */
    'isSingleUse'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DebitPermissionDto
     */
    'amount'?: number | null;
}
/**
 * 
 * @export
 * @interface DeleteExceptionResponseDto
 */
export interface DeleteExceptionResponseDto {
    /**
     * Success message confirming exception deletion
     * @type {string}
     * @memberof DeleteExceptionResponseDto
     */
    'message': string;
    /**
     * The date that was affected by the exception deletion (YYYY-MM-DD format)
     * @type {string}
     * @memberof DeleteExceptionResponseDto
     */
    'affectedDate': string;
}
/**
 * 
 * @export
 * @interface DeleteLeaveOfAbsenceResultDto
 */
export interface DeleteLeaveOfAbsenceResultDto {
    /**
     * 
     * @type {Array<RestoredAppointmentDto>}
     * @memberof DeleteLeaveOfAbsenceResultDto
     */
    'restored': Array<RestoredAppointmentDto>;
    /**
     * Candidates that stayed cancelled; the user has to be informed about these.
     * @type {Array<SkippedRestoreDto>}
     * @memberof DeleteLeaveOfAbsenceResultDto
     */
    'skipped': Array<SkippedRestoreDto>;
    /**
     * 
     * @type {TimeSlotDto}
     * @memberof DeleteLeaveOfAbsenceResultDto
     */
    'timeSlot': TimeSlotDto;
}
/**
 * 
 * @export
 * @interface DeltaSummaryDto
 */
export interface DeltaSummaryDto {
    /**
     * User ID
     * @type {string}
     * @memberof DeltaSummaryDto
     */
    'userId': string;
    /**
     * Total delta minutes (positive = over planned hours, negative = under planned hours)
     * @type {number}
     * @memberof DeltaSummaryDto
     */
    'totalDeltaMinutes': number;
}
/**
 * 
 * @export
 * @interface DiagnosisGroupAdminDto
 */
export interface DiagnosisGroupAdminDto {
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'a'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'b'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'c'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'd'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiagnosisGroupAdminDto
     */
    'isRelevant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'PrimaryTreatments'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'SecondaryTreatments'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'MaxAmountPerRx'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'MaxAmountStandard'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'MaxAmountException'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'Frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupAdminDto
     */
    'rxTypeId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof DiagnosisGroupAdminDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface DiagnosisGroupDto
 */
export interface DiagnosisGroupDto {
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'a'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'b'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'c'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosisGroupDto
     */
    'd'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof DiagnosisGroupDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface DirectBillingCenterDto
 */
export interface DirectBillingCenterDto {
    /**
     * Billing center name
     * @type {string}
     * @memberof DirectBillingCenterDto
     */
    'name': string;
    /**
     * Billing center IK number
     * @type {string}
     * @memberof DirectBillingCenterDto
     */
    'ik': string;
    /**
     * Billing center address
     * @type {object}
     * @memberof DirectBillingCenterDto
     */
    'address': object;
}
/**
 * 
 * @export
 * @interface DirectBillingPatientDto
 */
export interface DirectBillingPatientDto {
    /**
     * Patient ID
     * @type {number}
     * @memberof DirectBillingPatientDto
     */
    'id': number;
    /**
     * Patient first name
     * @type {string}
     * @memberof DirectBillingPatientDto
     */
    'firstName': string;
    /**
     * Patient last name
     * @type {string}
     * @memberof DirectBillingPatientDto
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface DirectBillingPayerGroupDto
 */
export interface DirectBillingPayerGroupDto {
    /**
     * Payer IK number
     * @type {string}
     * @memberof DirectBillingPayerGroupDto
     */
    'payerIK': string;
    /**
     * Payer name
     * @type {string}
     * @memberof DirectBillingPayerGroupDto
     */
    'payerName': string;
    /**
     * 
     * @type {DirectBillingPayerGroupDtoDigitalReceivingCenter}
     * @memberof DirectBillingPayerGroupDto
     */
    'digitalReceivingCenter': DirectBillingPayerGroupDtoDigitalReceivingCenter | null;
    /**
     * 
     * @type {DirectBillingPayerGroupDtoPaperReceivingCenter}
     * @memberof DirectBillingPayerGroupDto
     */
    'paperReceivingCenter': DirectBillingPayerGroupDtoPaperReceivingCenter | null;
    /**
     * List of Rxs for this payer
     * @type {Array<DirectBillingRxDto>}
     * @memberof DirectBillingPayerGroupDto
     */
    'rxs': Array<DirectBillingRxDto>;
    /**
     * Total net price for all Rxs (sum of netValues)
     * @type {number}
     * @memberof DirectBillingPayerGroupDto
     */
    'totalPrice': number;
}
/**
 * Digital receiving center (linkType 03)
 * @export
 * @interface DirectBillingPayerGroupDtoDigitalReceivingCenter
 */
export interface DirectBillingPayerGroupDtoDigitalReceivingCenter {
    /**
     * Billing center name
     * @type {string}
     * @memberof DirectBillingPayerGroupDtoDigitalReceivingCenter
     */
    'name': string;
    /**
     * Billing center IK number
     * @type {string}
     * @memberof DirectBillingPayerGroupDtoDigitalReceivingCenter
     */
    'ik': string;
    /**
     * Billing center address
     * @type {object}
     * @memberof DirectBillingPayerGroupDtoDigitalReceivingCenter
     */
    'address': object;
}
/**
 * Paper receiving center (linkType 09)
 * @export
 * @interface DirectBillingPayerGroupDtoPaperReceivingCenter
 */
export interface DirectBillingPayerGroupDtoPaperReceivingCenter {
    /**
     * Billing center name
     * @type {string}
     * @memberof DirectBillingPayerGroupDtoPaperReceivingCenter
     */
    'name': string;
    /**
     * Billing center IK number
     * @type {string}
     * @memberof DirectBillingPayerGroupDtoPaperReceivingCenter
     */
    'ik': string;
    /**
     * Billing center address
     * @type {object}
     * @memberof DirectBillingPayerGroupDtoPaperReceivingCenter
     */
    'address': object;
}
/**
 * 
 * @export
 * @interface DirectBillingPriceDto
 */
export interface DirectBillingPriceDto {
    /**
     * Gross value (total before copayment deduction)
     * @type {number}
     * @memberof DirectBillingPriceDto
     */
    'grossValue': number;
    /**
     * Patient copayment amount
     * @type {number}
     * @memberof DirectBillingPriceDto
     */
    'copayment': number;
    /**
     * Net value (gross - copayment) billed to insurance
     * @type {number}
     * @memberof DirectBillingPriceDto
     */
    'netValue': number;
}
/**
 * 
 * @export
 * @interface DirectBillingRxDto
 */
export interface DirectBillingRxDto {
    /**
     * Rx ID
     * @type {string}
     * @memberof DirectBillingRxDto
     */
    'id': string;
    /**
     * Rx number
     * @type {string}
     * @memberof DirectBillingRxDto
     */
    'rxNumber': string;
    /**
     * Rx date
     * @type {string}
     * @memberof DirectBillingRxDto
     */
    'date': string | null;
    /**
     * Whether Rx is marked for Taxieren
     * @type {boolean}
     * @memberof DirectBillingRxDto
     */
    'isTaxieren': boolean;
    /**
     * Processing status (e.g., FINISHED, INTERRUPTED)
     * @type {string}
     * @memberof DirectBillingRxDto
     */
    'processingStatus': string;
    /**
     * Tarif group ID for this Rx
     * @type {string}
     * @memberof DirectBillingRxDto
     */
    'tarifGroupId': string;
    /**
     * RxType ID for this Rx (e.g. Kasse, Zahnarzt)
     * @type {string}
     * @memberof DirectBillingRxDto
     */
    'rxTypeId': string;
    /**
     * 
     * @type {DirectBillingPatientDto}
     * @memberof DirectBillingRxDto
     */
    'patient': DirectBillingPatientDto;
    /**
     * List of therapies
     * @type {Array<DirectBillingTherapyDto>}
     * @memberof DirectBillingRxDto
     */
    'therapies': Array<DirectBillingTherapyDto>;
    /**
     * 
     * @type {DirectBillingPriceDto}
     * @memberof DirectBillingRxDto
     */
    'price': DirectBillingPriceDto;
}
/**
 * 
 * @export
 * @interface DirectBillingSingleRxResponseDto
 */
export interface DirectBillingSingleRxResponseDto {
    /**
     * 
     * @type {DirectBillingRxDto}
     * @memberof DirectBillingSingleRxResponseDto
     */
    'rx': DirectBillingRxDto;
    /**
     * Payer IK number
     * @type {string}
     * @memberof DirectBillingSingleRxResponseDto
     */
    'payerIK': string;
    /**
     * Payer name
     * @type {string}
     * @memberof DirectBillingSingleRxResponseDto
     */
    'payerName': string;
    /**
     * 
     * @type {DirectBillingPayerGroupDtoDigitalReceivingCenter}
     * @memberof DirectBillingSingleRxResponseDto
     */
    'digitalReceivingCenter': DirectBillingPayerGroupDtoDigitalReceivingCenter | null;
    /**
     * 
     * @type {DirectBillingPayerGroupDtoPaperReceivingCenter}
     * @memberof DirectBillingSingleRxResponseDto
     */
    'paperReceivingCenter': DirectBillingPayerGroupDtoPaperReceivingCenter | null;
    /**
     * Validation results for this Rx
     * @type {object}
     * @memberof DirectBillingSingleRxResponseDto
     */
    'validation': object;
}
/**
 * 
 * @export
 * @interface DirectBillingTherapyDto
 */
export interface DirectBillingTherapyDto {
    /**
     * Therapy abbreviation (e.g., KG, MT)
     * @type {string}
     * @memberof DirectBillingTherapyDto
     */
    'abbreviation': string;
    /**
     * Number of units prescribed
     * @type {number}
     * @memberof DirectBillingTherapyDto
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface DisplacedAppointmentDto
 */
export interface DisplacedAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'appointmentId': string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'timeSlotId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'therapistId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'therapyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'therapyRxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplacedAppointmentDto
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface DoctorReportDto
 */
export interface DoctorReportDto {
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'rxId': string;
    /**
     * 
     * @type {RxDto}
     * @memberof DoctorReportDto
     */
    'rx'?: RxDto;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'isDifferentTreatmentPeriod'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'latestTimeSlotStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'earliestTimeSlotStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'treatmentStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'treatmentEnd'?: object;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'therapyStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'specialFeatures'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'isRegulatedTreatment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'therapyFrequency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'singleTherapy'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'groupTherapy'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'treatmentModification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'isTreatmentDiscontinued'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'treatmentTerminationDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'treatmentTerminationReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof DoctorReportDto
     */
    'treatmentTerminationAfter'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'continueTreatment'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'therapyAssessment'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'therapyChangeSuggestions'?: string;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'processingDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'printedAt'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'sentByEmailAt'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'sentByFaxAt'?: object;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'createdByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof DoctorReportDto
     */
    'createdByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'assignedToUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof DoctorReportDto
     */
    'assignedToUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'updatedByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof DoctorReportDto
     */
    'updatedByUser'?: UserDto;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'createdAt'?: object;
    /**
     * 
     * @type {object}
     * @memberof DoctorReportDto
     */
    'updatedAt'?: object;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'latestTransactionNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'latestTransactionBillStatus'?: DoctorReportDtoLatestTransactionBillStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'documentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportDto
     */
    'pdfGeneratedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportDto
     */
    'isPdfStale'?: boolean;
}

export const DoctorReportDtoLatestTransactionBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;

export type DoctorReportDtoLatestTransactionBillStatusEnum = typeof DoctorReportDtoLatestTransactionBillStatusEnum[keyof typeof DoctorReportDtoLatestTransactionBillStatusEnum];

/**
 * 
 * @export
 * @interface DoctorReportStatusByRxDto
 */
export interface DoctorReportStatusByRxDto {
    /**
     * Doctor report status
     * @type {string}
     * @memberof DoctorReportStatusByRxDto
     */
    'status': DoctorReportStatusByRxDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportStatusByRxDto
     */
    'doctorReportExists'?: boolean;
    /**
     * Whether a new ticket was created during this status update
     * @type {boolean}
     * @memberof DoctorReportStatusByRxDto
     */
    'ticketCreated'?: boolean;
    /**
     * ID of existing ticket if one already existed
     * @type {number}
     * @memberof DoctorReportStatusByRxDto
     */
    'existingTicketId'?: number;
    /**
     * Status of existing ticket if one already existed
     * @type {string}
     * @memberof DoctorReportStatusByRxDto
     */
    'existingTicketStatus'?: string;
    /**
     * Rx ID this status entry belongs to
     * @type {string}
     * @memberof DoctorReportStatusByRxDto
     */
    'rxId': string;
}

export const DoctorReportStatusByRxDtoStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type DoctorReportStatusByRxDtoStatusEnum = typeof DoctorReportStatusByRxDtoStatusEnum[keyof typeof DoctorReportStatusByRxDtoStatusEnum];

/**
 * 
 * @export
 * @interface DoctorReportStatusDto
 */
export interface DoctorReportStatusDto {
    /**
     * Doctor report status
     * @type {string}
     * @memberof DoctorReportStatusDto
     */
    'status': DoctorReportStatusDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorReportStatusDto
     */
    'doctorReportExists'?: boolean;
    /**
     * Whether a new ticket was created during this status update
     * @type {boolean}
     * @memberof DoctorReportStatusDto
     */
    'ticketCreated'?: boolean;
    /**
     * ID of existing ticket if one already existed
     * @type {number}
     * @memberof DoctorReportStatusDto
     */
    'existingTicketId'?: number;
    /**
     * Status of existing ticket if one already existed
     * @type {string}
     * @memberof DoctorReportStatusDto
     */
    'existingTicketStatus'?: string;
}

export const DoctorReportStatusDtoStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type DoctorReportStatusDtoStatusEnum = typeof DoctorReportStatusDtoStatusEnum[keyof typeof DoctorReportStatusDtoStatusEnum];

/**
 * 
 * @export
 * @interface DoctorReportTherapistCountDto
 */
export interface DoctorReportTherapistCountDto {
    /**
     * 
     * @type {string}
     * @memberof DoctorReportTherapistCountDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportTherapistCountDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportTherapistCountDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorReportTherapistCountDto
     */
    'nickName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DoctorReportTherapistCountDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DoctorReportTimeSlotDto
 */
export interface DoctorReportTimeSlotDto {
    /**
     * 
     * @type {TimeSlotDto}
     * @memberof DoctorReportTimeSlotDto
     */
    'earliestTimeSlot': TimeSlotDto;
    /**
     * 
     * @type {TimeSlotDto}
     * @memberof DoctorReportTimeSlotDto
     */
    'latestTimeSlot': TimeSlotDto;
}
/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'accessUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'container': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'docuType': DocumentDtoDocuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'createdAt': string;
    /**
     * 
     * @type {object}
     * @memberof DocumentDto
     */
    'extraction'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'extractionAnalyzerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'extractedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'userId': string;
    /**
     * 
     * @type {MinifiedDocumentDtoUser}
     * @memberof DocumentDto
     */
    'user': MinifiedDocumentDtoUser;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'payerId': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'inboxLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'noticeDefinitionDataId': string;
}

export const DocumentDtoDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;

export type DocumentDtoDocuTypeEnum = typeof DocumentDtoDocuTypeEnum[keyof typeof DocumentDtoDocuTypeEnum];

/**
 * 
 * @export
 * @interface DocumentationFilterDto
 */
export interface DocumentationFilterDto {
    /**
     * Number of items per page (Max: 10)
     * @type {number}
     * @memberof DocumentationFilterDto
     */
    'limit': number;
    /**
     * Page number (Min: 1)
     * @type {number}
     * @memberof DocumentationFilterDto
     */
    'page': number;
    /**
     * Sorting order: asc or desc
     * @type {string}
     * @memberof DocumentationFilterDto
     */
    'sortOrder'?: DocumentationFilterDtoSortOrderEnum;
    /**
     * appointmentId
     * @type {string}
     * @memberof DocumentationFilterDto
     */
    'appointmentId'?: string;
}

export const DocumentationFilterDtoSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type DocumentationFilterDtoSortOrderEnum = typeof DocumentationFilterDtoSortOrderEnum[keyof typeof DocumentationFilterDtoSortOrderEnum];

/**
 * 
 * @export
 * @interface DuePaymentDto
 */
export interface DuePaymentDto {
    /**
     * The amount that needs to be paid
     * @type {number}
     * @memberof DuePaymentDto
     */
    'dueAmount': number;
    /**
     * The amount that already been paid
     * @type {number}
     * @memberof DuePaymentDto
     */
    'totalAmountPaid': number;
    /**
     * If the number of appointments matches
     * @type {boolean}
     * @memberof DuePaymentDto
     */
    'matchAppointments': boolean;
    /**
     * If no appointments are scheduled yet
     * @type {boolean}
     * @memberof DuePaymentDto
     */
    'isTimeSlotZero': boolean;
}
/**
 * 
 * @export
 * @interface EntityTicketTypesDto
 */
export interface EntityTicketTypesDto {
    /**
     * 
     * @type {TicketingRelationEntities}
     * @memberof EntityTicketTypesDto
     */
    'entity': TicketingRelationEntities;
    /**
     * 
     * @type {Array<TicketFilterEntryDto>}
     * @memberof EntityTicketTypesDto
     */
    'ticketTypes': Array<TicketFilterEntryDto>;
}


/**
 * 
 * @export
 * @interface EntityTicketTypesQueryFilters
 */
export interface EntityTicketTypesQueryFilters {
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityTicketTypesQueryFilters
     */
    'entities': Array<string>;
}
/**
 * 
 * @export
 * @interface EventTimeSlotDto
 */
export interface EventTimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof EventTimeSlotDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTimeSlotDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTimeSlotDto
     */
    'title'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof EventTimeSlotDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof EventTimeSlotDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTimeSlotDto
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTimeSlotDto
     */
    'locationId'?: string | null;
}
/**
 * 
 * @export
 * @interface ExceptionSlotDto
 */
export interface ExceptionSlotDto {
    /**
     * 
     * @type {string}
     * @memberof ExceptionSlotDto
     */
    'slotId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionSlotDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionSlotDto
     */
    'end': string;
    /**
     * 
     * @type {boolean}
     * @memberof ExceptionSlotDto
     */
    'isBreak': boolean;
}
/**
 * 
 * @export
 * @interface ExecutiveDashboardDto
 */
export interface ExecutiveDashboardDto {
    /**
     * 
     * @type {KpiAnalyticsDto}
     * @memberof ExecutiveDashboardDto
     */
    'kpi': KpiAnalyticsDto;
    /**
     * Top performing payers by amount
     * @type {Array<PayerPerformanceDto>}
     * @memberof ExecutiveDashboardDto
     */
    'topPayers': Array<PayerPerformanceDto>;
    /**
     * Summary of Rx type distribution
     * @type {Array<RxTypeDistributionDto>}
     * @memberof ExecutiveDashboardDto
     */
    'rxSummary': Array<RxTypeDistributionDto>;
    /**
     * 
     * @type {TrendAnalyticsResponseDto}
     * @memberof ExecutiveDashboardDto
     */
    'trends': TrendAnalyticsResponseDto;
}
/**
 * 
 * @export
 * @interface ExpiredTicketDigestDto
 */
export interface ExpiredTicketDigestDto {
    /**
     * 
     * @type {number}
     * @memberof ExpiredTicketDigestDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketDigestDto
     */
    'ticketType': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketDigestDto
     */
    'ticketStatus': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketDigestDto
     */
    'createdAt': string;
    /**
     * 
     * @type {object}
     * @memberof ExpiredTicketDigestDto
     */
    'patient'?: object;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketDigestDto
     */
    'displayDate': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketDigestDto
     */
    'displayMessage': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketDigestDto
     */
    'lastComment'?: string;
}
/**
 * 
 * @export
 * @interface ExpiredTicketWithReminderDigestDto
 */
export interface ExpiredTicketWithReminderDigestDto {
    /**
     * 
     * @type {number}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'ticketType': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'ticketStatus': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'createdAt': string;
    /**
     * 
     * @type {object}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'patient'?: object;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'displayDate': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'displayMessage': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'lastComment'?: string;
    /**
     * 
     * @type {object}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'expiredReminder': object;
    /**
     * 
     * @type {string}
     * @memberof ExpiredTicketWithReminderDigestDto
     */
    'deadline'?: string;
}
/**
 * 
 * @export
 * @interface ExportBillingData
 */
export interface ExportBillingData {
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'payerIK': string;
    /**
     * 
     * @type {GroupedRxWithPayerDto}
     * @memberof ExportBillingData
     */
    'data': GroupedRxWithPayerDto;
    /**
     * 
     * @type {boolean}
     * @memberof ExportBillingData
     */
    'wasExported': boolean;
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'billNumber': string;
    /**
     * 
     * @type {AccountDtoForInsurance}
     * @memberof ExportBillingData
     */
    'accountInfo': AccountDtoForInsurance;
    /**
     * 
     * @type {UserDto}
     * @memberof ExportBillingData
     */
    'userInfo': UserDto;
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'billingDate': string;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'docDto': DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'billPdf': DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'paperCenterReceipt': DocumentDto;
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'previousBillNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ExportBillingData
     */
    'previousBillDate': string;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'patientRechnung': DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'patientMahnung': DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'previousPaperCenterReceipt': DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof ExportBillingData
     */
    'previousBillPdf': DocumentDto;
}
/**
 * 
 * @export
 * @interface ExportBillingRequestDto
 */
export interface ExportBillingRequestDto {
    /**
     * The array of ExportBillingData objects to be exported
     * @type {Array<ExportBillingData>}
     * @memberof ExportBillingRequestDto
     */
    'exportBillingData': Array<ExportBillingData>;
    /**
     * 
     * @type {object}
     * @memberof ExportBillingRequestDto
     */
    'testTypeData': object;
    /**
     * The processing code for the operation
     * @type {string}
     * @memberof ExportBillingRequestDto
     */
    'processingCode': ExportBillingRequestDtoProcessingCodeEnum;
}

export const ExportBillingRequestDtoProcessingCodeEnum = {
    _01: '01',
    _02: '02',
    _03: '03',
    _04: '04',
    _10: '10'
} as const;

export type ExportBillingRequestDtoProcessingCodeEnum = typeof ExportBillingRequestDtoProcessingCodeEnum[keyof typeof ExportBillingRequestDtoProcessingCodeEnum];

/**
 * 
 * @export
 * @interface ExportCreditTransferToSEPA200Response
 */
export interface ExportCreditTransferToSEPA200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ExportCreditTransferToSEPA200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExportCreditTransferToSEPA200Response
     */
    'documentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportCreditTransferToSEPA200Response
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportCreditTransferToSEPA200Response
     */
    'downloadUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExportCreditTransferToSEPA200Response
     */
    'exportedCount'?: number;
}
/**
 * 
 * @export
 * @interface ExportCreditTransferToSEPARequest
 */
export interface ExportCreditTransferToSEPARequest {
    /**
     * 
     * @type {Array<ExportCreditTransferToSEPARequestTransactionsInner>}
     * @memberof ExportCreditTransferToSEPARequest
     */
    'transactions': Array<ExportCreditTransferToSEPARequestTransactionsInner>;
    /**
     * 
     * @type {ExportCreditTransferToSEPARequestExportOptions}
     * @memberof ExportCreditTransferToSEPARequest
     */
    'exportOptions': ExportCreditTransferToSEPARequestExportOptions;
}
/**
 * 
 * @export
 * @interface ExportCreditTransferToSEPARequestExportOptions
 */
export interface ExportCreditTransferToSEPARequestExportOptions {
    /**
     * Unique message ID for SEPA file
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestExportOptions
     */
    'messageId': string;
    /**
     * Name of the debtor (payer)
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestExportOptions
     */
    'debtorName': string;
    /**
     * IBAN of the debtor (payer)
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestExportOptions
     */
    'debtorIBAN': string;
    /**
     * BIC of the debtor (payer)
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestExportOptions
     */
    'debtorBIC': string;
    /**
     * Debtor creditor ID (optional)
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestExportOptions
     */
    'debtorCreditorId'?: string;
}
/**
 * 
 * @export
 * @interface ExportCreditTransferToSEPARequestTransactionsInner
 */
export interface ExportCreditTransferToSEPARequestTransactionsInner {
    /**
     * Unique transaction ID
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'transactionId': string;
    /**
     * Name of the payment recipient
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'creditorName': string;
    /**
     * IBAN of the payment recipient
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'creditorIBAN': string;
    /**
     * BIC of the payment recipient (optional)
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'creditorBIC'?: string;
    /**
     * Amount in EUR decimals (e.g., 12.34 = €12.34)
     * @type {number}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'amount': number;
    /**
     * Payment reference/purpose
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'remittanceInformation': string;
    /**
     * End-to-end reference
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'endToEndId': string;
    /**
     * Instruction ID (optional)
     * @type {string}
     * @memberof ExportCreditTransferToSEPARequestTransactionsInner
     */
    'instructionId'?: string;
}
/**
 * 
 * @export
 * @interface ExportCreditTransfersBatchRequest
 */
export interface ExportCreditTransfersBatchRequest {
    /**
     * Array of credit transfer IDs to export
     * @type {Array<string>}
     * @memberof ExportCreditTransfersBatchRequest
     */
    'creditTransferIds': Array<string>;
    /**
     * 
     * @type {ExportCreditTransfersBatchRequestExportOptions}
     * @memberof ExportCreditTransfersBatchRequest
     */
    'exportOptions': ExportCreditTransfersBatchRequestExportOptions;
}
/**
 * 
 * @export
 * @interface ExportCreditTransfersBatchRequestExportOptions
 */
export interface ExportCreditTransfersBatchRequestExportOptions {
    /**
     * Unique message ID for SEPA file
     * @type {string}
     * @memberof ExportCreditTransfersBatchRequestExportOptions
     */
    'messageId': string;
    /**
     * Name of the debtor (sender/clinic)
     * @type {string}
     * @memberof ExportCreditTransfersBatchRequestExportOptions
     */
    'debtorName': string;
    /**
     * IBAN of the debtor (sender/clinic)
     * @type {string}
     * @memberof ExportCreditTransfersBatchRequestExportOptions
     */
    'debtorIBAN': string;
    /**
     * BIC of the debtor (sender/clinic)
     * @type {string}
     * @memberof ExportCreditTransfersBatchRequestExportOptions
     */
    'debtorBIC': string;
    /**
     * Creditor ID of debtor (optional)
     * @type {string}
     * @memberof ExportCreditTransfersBatchRequestExportOptions
     */
    'debtorCreditorId'?: string;
}
/**
 * 
 * @export
 * @interface ExportDataDto
 */
export interface ExportDataDto {
    /**
     * The current state of the export operation
     * @type {string}
     * @memberof ExportDataDto
     */
    'state': ExportDataDtoStateEnum;
    /**
     * Time of the initial request (Unix timestamp)
     * @type {number}
     * @memberof ExportDataDto
     */
    'time_request': number;
    /**
     * Time of the start of the export operation (Unix timestamp)
     * @type {number}
     * @memberof ExportDataDto
     */
    'time_start'?: number;
    /**
     * Time of the end of the export operation (Unix timestamp)
     * @type {number}
     * @memberof ExportDataDto
     */
    'time_end'?: number;
    /**
     * Metadata associated with the export
     * @type {object}
     * @memberof ExportDataDto
     */
    'metadata'?: object;
    /**
     * TSS ID associated with this export
     * @type {string}
     * @memberof ExportDataDto
     */
    'tss_id': string;
    /**
     * Export ID from Fiskaly
     * @type {string}
     * @memberof ExportDataDto
     */
    '_id': string;
    /**
     * Formatted request time in German locale
     * @type {string}
     * @memberof ExportDataDto
     */
    'time_request_formatted'?: string;
    /**
     * Formatted start time in German locale
     * @type {string}
     * @memberof ExportDataDto
     */
    'time_start_formatted'?: string;
    /**
     * Formatted end time in German locale
     * @type {string}
     * @memberof ExportDataDto
     */
    'time_end_formatted'?: string;
}

export const ExportDataDtoStateEnum = {
    Pending: 'PENDING',
    Working: 'WORKING',
    Completed: 'COMPLETED',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type ExportDataDtoStateEnum = typeof ExportDataDtoStateEnum[keyof typeof ExportDataDtoStateEnum];

/**
 * 
 * @export
 * @interface ExportDataItemDto
 */
export interface ExportDataItemDto {
    /**
     * Unique ID for this export data item
     * @type {string}
     * @memberof ExportDataItemDto
     */
    'id': string;
    /**
     * 
     * @type {ExportInfoPayloadDto}
     * @memberof ExportDataItemDto
     */
    'formattedPayload': ExportInfoPayloadDto;
    /**
     * 
     * @type {ExportDataItemDtoMetadata}
     * @memberof ExportDataItemDto
     */
    'metadata': ExportDataItemDtoMetadata | null;
}
/**
 * Metadata extracted from the export file (Auftragsdatei)
 * @export
 * @interface ExportDataItemDtoMetadata
 */
export interface ExportDataItemDtoMetadata {
    /**
     * Sender IK (ABSENDER_EIGNER)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'senderIk': string;
    /**
     * Physical sender IK (ABSENDER_PHYSIKALISCH)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'physicalSenderIk': string;
    /**
     * Receiver IK (EMPFÄNGER_NUTZER)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'receiverIk': string;
    /**
     * Physical receiver IK (EMPFÄNGER_PHYSIKALISCH)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'physicalReceiverIk': string;
    /**
     * Logical file name (DATEINAME)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'logicalFileName': string;
    /**
     * Creation date (DATUM_ERSTELLUNG)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'creationDate': string;
    /**
     * Transmission date (DATUM_ÜBERTRAGUNG_GESENDET)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'transmissionDate': string;
    /**
     * Payload size in bytes (DATEIGRÖßE_NUTZDATEN)
     * @type {number}
     * @memberof ExportDataItemDtoMetadata
     */
    'payloadSize': number;
    /**
     * Encrypted size in bytes (DATEIGRÖßE_ÜBERTRAGUNG)
     * @type {number}
     * @memberof ExportDataItemDtoMetadata
     */
    'encryptedSize': number;
    /**
     * Encryption type (VERSCHLÜSSELUNGSART)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'encryptionType': string;
    /**
     * Transfer number (TRANSFER_NUMMER)
     * @type {number}
     * @memberof ExportDataItemDtoMetadata
     */
    'transferNumber': number;
    /**
     * Physical file name (VERFAHREN_KENNUNG + TRANSFER_NUMMER)
     * @type {string}
     * @memberof ExportDataItemDtoMetadata
     */
    'physicalFileName': string;
}
/**
 * 
 * @export
 * @interface ExportInfoPayloadDto
 */
export interface ExportInfoPayloadDto {
    /**
     * Transaction number extracted from REC segment
     * @type {string}
     * @memberof ExportInfoPayloadDto
     */
    'transactionNumber': string;
    /**
     * Array of Rx numbers extracted from INV segments
     * @type {Array<string>}
     * @memberof ExportInfoPayloadDto
     */
    'rxNumbers': Array<string>;
    /**
     * 
     * @type {ExportInfoPayloadDtoTotalAmounts}
     * @memberof ExportInfoPayloadDto
     */
    'totalAmounts': ExportInfoPayloadDtoTotalAmounts | null;
    /**
     * 
     * @type {StatusAmountsDto}
     * @memberof ExportInfoPayloadDto
     */
    'statusAmounts': StatusAmountsDto;
}
/**
 * Total amounts from GES+00 segment
 * @export
 * @interface ExportInfoPayloadDtoTotalAmounts
 */
export interface ExportInfoPayloadDtoTotalAmounts {
    /**
     * Status code (00=total, 11=status 10000, 31=status 30000, 51=status 50000)
     * @type {string}
     * @memberof ExportInfoPayloadDtoTotalAmounts
     */
    'status': string;
    /**
     * Amount the insurer will pay
     * @type {number}
     * @memberof ExportInfoPayloadDtoTotalAmounts
     */
    'billValue': number;
    /**
     * Total gross amount
     * @type {number}
     * @memberof ExportInfoPayloadDtoTotalAmounts
     */
    'grossValue': number;
    /**
     * Copayment amount
     * @type {number}
     * @memberof ExportInfoPayloadDtoTotalAmounts
     */
    'copayment': number;
}
/**
 * 
 * @export
 * @interface ExportLastSchriftsByAccountRequest
 */
export interface ExportLastSchriftsByAccountRequest {
    /**
     * ID of the account (mandant) to export transactions for
     * @type {string}
     * @memberof ExportLastSchriftsByAccountRequest
     */
    'accountId': string;
}
/**
 * 
 * @export
 * @interface ExportLastSchriftsToSEPARequest
 */
export interface ExportLastSchriftsToSEPARequest {
    /**
     * Array of LastSchrift IDs to export
     * @type {Array<string>}
     * @memberof ExportLastSchriftsToSEPARequest
     */
    'lastSchriftIds': Array<string>;
    /**
     * 
     * @type {ExportLastSchriftsToSEPARequestExportOptions}
     * @memberof ExportLastSchriftsToSEPARequest
     */
    'exportOptions': ExportLastSchriftsToSEPARequestExportOptions;
}
/**
 * 
 * @export
 * @interface ExportLastSchriftsToSEPARequestExportOptions
 */
export interface ExportLastSchriftsToSEPARequestExportOptions {
    /**
     * Unique message ID for SEPA file
     * @type {string}
     * @memberof ExportLastSchriftsToSEPARequestExportOptions
     */
    'messageId': string;
    /**
     * Name of the creditor
     * @type {string}
     * @memberof ExportLastSchriftsToSEPARequestExportOptions
     */
    'creditorName': string;
    /**
     * IBAN of the creditor
     * @type {string}
     * @memberof ExportLastSchriftsToSEPARequestExportOptions
     */
    'creditorIBAN': string;
    /**
     * BIC of the creditor (optional)
     * @type {string}
     * @memberof ExportLastSchriftsToSEPARequestExportOptions
     */
    'creditorBIC'?: string;
    /**
     * SEPA creditor ID
     * @type {string}
     * @memberof ExportLastSchriftsToSEPARequestExportOptions
     */
    'creditorId': string;
}
/**
 * 
 * @export
 * @interface ExportMetadataDto
 */
export interface ExportMetadataDto {
    /**
     * Sender IK (ABSENDER_EIGNER)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'senderIk': string;
    /**
     * Physical sender IK (ABSENDER_PHYSIKALISCH)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'physicalSenderIk': string;
    /**
     * Receiver IK (EMPFÄNGER_NUTZER)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'receiverIk': string;
    /**
     * Physical receiver IK (EMPFÄNGER_PHYSIKALISCH)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'physicalReceiverIk': string;
    /**
     * Logical file name (DATEINAME)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'logicalFileName': string;
    /**
     * Creation date (DATUM_ERSTELLUNG)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'creationDate': string;
    /**
     * Transmission date (DATUM_ÜBERTRAGUNG_GESENDET)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'transmissionDate': string;
    /**
     * Payload size in bytes (DATEIGRÖßE_NUTZDATEN)
     * @type {number}
     * @memberof ExportMetadataDto
     */
    'payloadSize': number;
    /**
     * Encrypted size in bytes (DATEIGRÖßE_ÜBERTRAGUNG)
     * @type {number}
     * @memberof ExportMetadataDto
     */
    'encryptedSize': number;
    /**
     * Encryption type (VERSCHLÜSSELUNGSART)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'encryptionType': string;
    /**
     * Transfer number (TRANSFER_NUMMER)
     * @type {number}
     * @memberof ExportMetadataDto
     */
    'transferNumber': number;
    /**
     * Physical file name (VERFAHREN_KENNUNG + TRANSFER_NUMMER)
     * @type {string}
     * @memberof ExportMetadataDto
     */
    'physicalFileName': string;
}
/**
 * 
 * @export
 * @interface ExportPaginationMetadataDto
 */
export interface ExportPaginationMetadataDto {
    /**
     * Number of items per page
     * @type {number}
     * @memberof ExportPaginationMetadataDto
     */
    'limit': number;
    /**
     * Current offset
     * @type {number}
     * @memberof ExportPaginationMetadataDto
     */
    'offset': number;
    /**
     * Total number of exports (if available)
     * @type {number}
     * @memberof ExportPaginationMetadataDto
     */
    'count': number;
    /**
     * Whether more data is available
     * @type {boolean}
     * @memberof ExportPaginationMetadataDto
     */
    'hasMore': boolean;
}
/**
 * 
 * @export
 * @interface ExportQueryDto
 */
export interface ExportQueryDto {
    /**
     * Existing TSS ID
     * @type {string}
     * @memberof ExportQueryDto
     */
    'tssId': string;
    /**
     * Start date for the export (ISO 8601 format: YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss)
     * @type {string}
     * @memberof ExportQueryDto
     */
    'startDate': string;
    /**
     * End date for the export (ISO 8601 format: YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss)
     * @type {string}
     * @memberof ExportQueryDto
     */
    'endDate': string;
    /**
     * Start transaction number for the export
     * @type {string}
     * @memberof ExportQueryDto
     */
    'startTransactionNumber'?: string;
    /**
     * End transaction number for the export
     * @type {string}
     * @memberof ExportQueryDto
     */
    'endTransactionNumber'?: string;
    /**
     * Start signature counter for the export
     * @type {number}
     * @memberof ExportQueryDto
     */
    'startSignatureCounter'?: number;
    /**
     * End signature counter for the export
     * @type {number}
     * @memberof ExportQueryDto
     */
    'endSignatureCounter'?: number;
}
/**
 * 
 * @export
 * @interface ExportTransactionsResponseDto
 */
export interface ExportTransactionsResponseDto {
    /**
     * Array of exports
     * @type {Array<ExportDataDto>}
     * @memberof ExportTransactionsResponseDto
     */
    'data': Array<ExportDataDto>;
    /**
     * 
     * @type {ExportPaginationMetadataDto}
     * @memberof ExportTransactionsResponseDto
     */
    'pagination': ExportPaginationMetadataDto;
}
/**
 * 
 * @export
 * @interface ExtendWorkingHoursForAppointmentDto
 */
export interface ExtendWorkingHoursForAppointmentDto {
    /**
     * User ID whose working hours should be extended
     * @type {string}
     * @memberof ExtendWorkingHoursForAppointmentDto
     */
    'userId': string;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ExtendWorkingHoursForAppointmentDto
     */
    'date': string;
    /**
     * Appointment start time
     * @type {string}
     * @memberof ExtendWorkingHoursForAppointmentDto
     */
    'appointmentStart': string;
    /**
     * Appointment end time
     * @type {string}
     * @memberof ExtendWorkingHoursForAppointmentDto
     */
    'appointmentEnd': string;
}
/**
 * 
 * @export
 * @interface FindAllHistoryQueryFiltersDto
 */
export interface FindAllHistoryQueryFiltersDto {
    /**
     * 
     * @type {number}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'page'?: number;
    /**
     * 
     * @type {HistoryType}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'type'?: HistoryType;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'searchKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'fromDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'toDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'initialEvaluationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'treatmentNoteId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'addressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'therapyRxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllHistoryQueryFiltersDto
     */
    'affectedUserId'?: string;
}


/**
 * 
 * @export
 * @interface FindAllTicketsQueryFilters
 */
export interface FindAllTicketsQueryFilters {
    /**
     * Number of items per page (Max = 50)
     * @type {number}
     * @memberof FindAllTicketsQueryFilters
     */
    'limit'?: number;
    /**
     * Page number (Min = 1)
     * @type {number}
     * @memberof FindAllTicketsQueryFilters
     */
    'page'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAllTicketsQueryFilters
     */
    'ticketStatus'?: Array<FindAllTicketsQueryFiltersTicketStatusEnum>;
    /**
     * Filter by ticket type
     * @type {Array<string>}
     * @memberof FindAllTicketsQueryFilters
     */
    'ticketType'?: Array<FindAllTicketsQueryFiltersTicketTypeEnum>;
    /**
     * Filter tickets created from this date (YYYY-MM-DD)
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'dateFrom'?: string;
    /**
     * Filter tickets created until this date (YYYY-MM-DD)
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'dateTo'?: string;
    /**
     * Sort tickets by field
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'sortBy'?: FindAllTicketsQueryFiltersSortByEnum;
    /**
     * Sort order
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'sortOrder'?: FindAllTicketsQueryFiltersSortOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'createdByUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'assignedToUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'locationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FindAllTicketsQueryFilters
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'appointmentId'?: string;
    /**
     * Filter tickets by the clinic BSNR on the linked Rx (partial match)
     * @type {string}
     * @memberof FindAllTicketsQueryFilters
     */
    'BSNR'?: string;
}

export const FindAllTicketsQueryFiltersTicketStatusEnum = {
    New: 'NEW',
    Paused: 'PAUSED',
    InProgress: 'IN_PROGRESS',
    Ordered: 'ORDERED',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Pending: 'PENDING',
    Closed: 'CLOSED',
    NotReached: 'NOT_REACHED',
    ConversationDone: 'CONVERSATION_DONE'
} as const;

export type FindAllTicketsQueryFiltersTicketStatusEnum = typeof FindAllTicketsQueryFiltersTicketStatusEnum[keyof typeof FindAllTicketsQueryFiltersTicketStatusEnum];
export const FindAllTicketsQueryFiltersTicketTypeEnum = {
    OrderRx: 'ORDER_RX',
    ChangeRx: 'CHANGE_RX',
    Other: 'OTHER',
    Telephone: 'TELEPHONE',
    DrReport: 'DR_REPORT',
    Planning: 'PLANNING',
    Wiedervorlage: 'WIEDERVORLAGE',
    Billing: 'BILLING'
} as const;

export type FindAllTicketsQueryFiltersTicketTypeEnum = typeof FindAllTicketsQueryFiltersTicketTypeEnum[keyof typeof FindAllTicketsQueryFiltersTicketTypeEnum];
export const FindAllTicketsQueryFiltersSortByEnum = {
    Priority: 'priority',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Bsnr: 'BSNR'
} as const;

export type FindAllTicketsQueryFiltersSortByEnum = typeof FindAllTicketsQueryFiltersSortByEnum[keyof typeof FindAllTicketsQueryFiltersSortByEnum];
export const FindAllTicketsQueryFiltersSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type FindAllTicketsQueryFiltersSortOrderEnum = typeof FindAllTicketsQueryFiltersSortOrderEnum[keyof typeof FindAllTicketsQueryFiltersSortOrderEnum];

/**
 * 
 * @export
 * @interface FiskalyClientResponseDto
 */
export interface FiskalyClientResponseDto {
    /**
     * TSS ID from Fiskaly
     * @type {string}
     * @memberof FiskalyClientResponseDto
     */
    '_id': string;
    /**
     * Environment (e.g., \'Test\', \'Live\')
     * @type {string}
     * @memberof FiskalyClientResponseDto
     */
    '_env': string;
    /**
     * Serial Number
     * @type {string}
     * @memberof FiskalyClientResponseDto
     */
    'serial_number': string;
    /**
     * Current state of the Client
     * @type {string}
     * @memberof FiskalyClientResponseDto
     */
    'state': FiskalyClientResponseDtoStateEnum;
    /**
     * 
     * @type {ClientMetadataDto}
     * @memberof FiskalyClientResponseDto
     */
    'metadata'?: ClientMetadataDto;
    /**
     * TSS ID associated with the client
     * @type {string}
     * @memberof FiskalyClientResponseDto
     */
    'tss_id': string;
    /**
     * Initialization timestamp formatted in German locale (DD.MM.YYYY HH:mm:ss)
     * @type {string}
     * @memberof FiskalyClientResponseDto
     */
    'time_creation_formatted'?: string;
}

export const FiskalyClientResponseDtoStateEnum = {
    Registered: 'REGISTERED',
    Deregistered: 'DEREGISTERED'
} as const;

export type FiskalyClientResponseDtoStateEnum = typeof FiskalyClientResponseDtoStateEnum[keyof typeof FiskalyClientResponseDtoStateEnum];

/**
 * 
 * @export
 * @interface FiskalyTransactionResponseDto
 */
export interface FiskalyTransactionResponseDto {
    /**
     * Transaction ID from Fiskaly
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    '_id': string;
    /**
     * Client ID associated with this transaction
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    'client_id': string;
    /**
     * TSS ID associated with this transaction
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    'tss_id': string;
    /**
     * Sequential transaction number
     * @type {number}
     * @memberof FiskalyTransactionResponseDto
     */
    'transaction_number': number;
    /**
     * Creation timestamp formatted in German locale (DD.MM.YYYY HH:mm:ss)
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    'time_creation_formatted': string;
    /**
     * Type of receipt
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    'receipt_type': FiskalyTransactionResponseDtoReceiptTypeEnum;
    /**
     * Amounts grouped by payment type
     * @type {Array<AmountPerPaymentTypeDto>}
     * @memberof FiskalyTransactionResponseDto
     */
    'amounts_per_payment_type': Array<AmountPerPaymentTypeDto>;
    /**
     * Transaction state
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    'state': FiskalyTransactionResponseDtoStateEnum;
    /**
     * Environment (e.g., \'Test\', \'Live\')
     * @type {string}
     * @memberof FiskalyTransactionResponseDto
     */
    '_env': string;
    /**
     * 
     * @type {FiskalyTransactionResponseDtoMetadata}
     * @memberof FiskalyTransactionResponseDto
     */
    'metadata'?: FiskalyTransactionResponseDtoMetadata;
}

export const FiskalyTransactionResponseDtoReceiptTypeEnum = {
    Receipt: 'RECEIPT',
    Training: 'TRAINING',
    Cancellation: 'CANCELLATION',
    Transfer: 'TRANSFER',
    Order: 'ORDER',
    Abort: 'ABORT',
    BenefitInKind: 'BENEFIT_IN_KIND',
    Invoice: 'INVOICE',
    Other: 'OTHER',
    Annulation: 'ANNULATION'
} as const;

export type FiskalyTransactionResponseDtoReceiptTypeEnum = typeof FiskalyTransactionResponseDtoReceiptTypeEnum[keyof typeof FiskalyTransactionResponseDtoReceiptTypeEnum];
export const FiskalyTransactionResponseDtoStateEnum = {
    Active: 'ACTIVE',
    Cancelled: 'CANCELLED',
    Finished: 'FINISHED'
} as const;

export type FiskalyTransactionResponseDtoStateEnum = typeof FiskalyTransactionResponseDtoStateEnum[keyof typeof FiskalyTransactionResponseDtoStateEnum];

/**
 * Metadata associated with the transaction
 * @export
 * @interface FiskalyTransactionResponseDtoMetadata
 */
export interface FiskalyTransactionResponseDtoMetadata {
    /**
     * 
     * @type {string}
     * @memberof FiskalyTransactionResponseDtoMetadata
     */
    'transactionNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiskalyTransactionResponseDtoMetadata
     */
    'rxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiskalyTransactionResponseDtoMetadata
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface FiskalyTssResponseDto
 */
export interface FiskalyTssResponseDto {
    /**
     * TSS ID from Fiskaly
     * @type {string}
     * @memberof FiskalyTssResponseDto
     */
    '_id': string;
    /**
     * Environment (e.g., \'Test\', \'Live\')
     * @type {string}
     * @memberof FiskalyTssResponseDto
     */
    '_env': string;
    /**
     * Description of the TSS
     * @type {string}
     * @memberof FiskalyTssResponseDto
     */
    'description'?: string;
    /**
     * 
     * @type {TssMetadataDto}
     * @memberof FiskalyTssResponseDto
     */
    'metadata': TssMetadataDto;
    /**
     * Current state of the TSS
     * @type {string}
     * @memberof FiskalyTssResponseDto
     */
    'state': FiskalyTssResponseDtoStateEnum;
    /**
     * Transaction counter (bigint as string)
     * @type {string}
     * @memberof FiskalyTssResponseDto
     */
    'transaction_counter': string;
    /**
     * Initialization timestamp formatted in German locale (DD.MM.YYYY HH:mm:ss)
     * @type {string}
     * @memberof FiskalyTssResponseDto
     */
    'time_init_formatted'?: string;
}

export const FiskalyTssResponseDtoStateEnum = {
    Created: 'CREATED',
    Uninitialized: 'UNINITIALIZED',
    Initialized: 'INITIALIZED',
    Disabled: 'DISABLED',
    Deleted: 'DELETED',
    Defective: 'DEFECTIVE',
    Evicted: 'EVICTED'
} as const;

export type FiskalyTssResponseDtoStateEnum = typeof FiskalyTssResponseDtoStateEnum[keyof typeof FiskalyTssResponseDtoStateEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const GENERATEBILLPDFJobName = {
    GenerateBillPdf: 'GENERATE_BILL_PDF'
} as const;

export type GENERATEBILLPDFJobName = typeof GENERATEBILLPDFJobName[keyof typeof GENERATEBILLPDFJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const GENERATEPDFREPORTJobName = {
    GeneratePdfReport: 'GENERATE_PDF_REPORT'
} as const;

export type GENERATEPDFREPORTJobName = typeof GENERATEPDFREPORTJobName[keyof typeof GENERATEPDFREPORTJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const GETAPPOINTMENTSTATEFORPATIENTJobName = {
    GetAppointmentStateForPatient: 'GET_APPOINTMENT_STATE_FOR_PATIENT'
} as const;

export type GETAPPOINTMENTSTATEFORPATIENTJobName = typeof GETAPPOINTMENTSTATEFORPATIENTJobName[keyof typeof GETAPPOINTMENTSTATEFORPATIENTJobName];


/**
 * 
 * @export
 * @interface GapJustificationDto
 */
export interface GapJustificationDto {
    /**
     * 
     * @type {string}
     * @memberof GapJustificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GapJustificationDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof GapJustificationDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GapJustificationDto
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GapJustificationDto
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GapJustificationDto
     */
    'endDate': string | null;
}
/**
 * 
 * @export
 * @interface GenerateBillPdfJobResultDto
 */
export interface GenerateBillPdfJobResultDto {
    /**
     * Type of PDF that was generated
     * @type {string}
     * @memberof GenerateBillPdfJobResultDto
     */
    'pdfType': GenerateBillPdfJobResultDtoPdfTypeEnum;
    /**
     * ID of the entity the PDF was generated for
     * @type {string}
     * @memberof GenerateBillPdfJobResultDto
     */
    'entityId': string;
    /**
     * Transaction number for identification
     * @type {string}
     * @memberof GenerateBillPdfJobResultDto
     */
    'transactionNumber'?: string;
    /**
     * Whether PDF generation succeeded
     * @type {boolean}
     * @memberof GenerateBillPdfJobResultDto
     */
    'success': boolean;
    /**
     * Document ID of the generated PDF (if successful)
     * @type {string}
     * @memberof GenerateBillPdfJobResultDto
     */
    'documentId'?: string;
    /**
     * Blob URL of the generated PDF (if successful)
     * @type {string}
     * @memberof GenerateBillPdfJobResultDto
     */
    'blobUrl'?: string;
    /**
     * Error message if generation failed
     * @type {string}
     * @memberof GenerateBillPdfJobResultDto
     */
    'error'?: string;
    /**
     * Duration of PDF generation in milliseconds
     * @type {number}
     * @memberof GenerateBillPdfJobResultDto
     */
    'durationMs': number;
}

export const GenerateBillPdfJobResultDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type GenerateBillPdfJobResultDtoPdfTypeEnum = typeof GenerateBillPdfJobResultDtoPdfTypeEnum[keyof typeof GenerateBillPdfJobResultDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface GenerateDoctorReportRequestDto
 */
export interface GenerateDoctorReportRequestDto {
    /**
     * Whether the patient\'s initial evaluation (Erstbefund) should be considered. Evaluations are linked to the patient, not the Rx, so they may or may not be relevant — the therapist decides.
     * @type {boolean}
     * @memberof GenerateDoctorReportRequestDto
     */
    'considerEvaluation'?: boolean;
    /**
     * IDs of the initial evaluations to consider. Only relevant when considerEvaluation is true; when omitted, all of the patient\'s evaluations are considered (backward compatible).
     * @type {Array<number>}
     * @memberof GenerateDoctorReportRequestDto
     */
    'evaluationIds'?: Array<number>;
    /**
     * Free-text supplemental instructions from the therapist for the LLM to consider when drafting the report.
     * @type {string}
     * @memberof GenerateDoctorReportRequestDto
     */
    'userPrompt'?: string;
    /**
     * Ready-made text building blocks the therapist selected (e.g. \'Weiterbehandlung empfohlen\') to include as context.
     * @type {Array<string>}
     * @memberof GenerateDoctorReportRequestDto
     */
    'quickSelections'?: Array<string>;
    /**
     * The therapist\'s own decision/text on suggested changes to the therapy plan (\'Änderungen vorschlagen\'). This is a human clinical decision — the LLM only uses it as context so the rest of the report is consistent with it; it never originates plan changes itself. Omit when the therapist decided \'no changes\'.
     * @type {string}
     * @memberof GenerateDoctorReportRequestDto
     */
    'therapyChangeSuggestion'?: string;
    /**
     * The therapist\'s own free text describing a change of the treatment. Improve-only field: when omitted, the LLM must not generate a treatment modification at all.
     * @type {string}
     * @memberof GenerateDoctorReportRequestDto
     */
    'treatmentModificationText'?: string;
    /**
     * The therapist\'s own free text stating the reason for a treatment termination. Improve-only field: when omitted, the LLM must not derive a termination reason from the documentation.
     * @type {string}
     * @memberof GenerateDoctorReportRequestDto
     */
    'treatmentTerminationReasonText'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDoctorReportResponseDto
 */
export interface GenerateDoctorReportResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GenerateDoctorReportResponseDto
     */
    'therapyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateDoctorReportResponseDto
     */
    'specialFeatures'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateDoctorReportResponseDto
     */
    'treatmentModification'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateDoctorReportResponseDto
     */
    'treatmentTerminationReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateDoctorReportResponseDto
     */
    'therapyAssessment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateDoctorReportResponseDto
     */
    'therapyChangeSuggestions'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneratePdfJobResultDto
 */
export interface GeneratePdfJobResultDto {
    /**
     * 
     * @type {string}
     * @memberof GeneratePdfJobResultDto
     */
    'message': string;
    /**
     * Size of generated PDF in bytes
     * @type {number}
     * @memberof GeneratePdfJobResultDto
     */
    'pdfSizeBytes'?: number;
}
/**
 * 
 * @export
 * @interface GeneratedWorkflowDto
 */
export interface GeneratedWorkflowDto {
    /**
     * 
     * @type {string}
     * @memberof GeneratedWorkflowDto
     */
    'workflowId': string;
    /**
     * 
     * @type {string}
     * @memberof GeneratedWorkflowDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface GesAmountsDto
 */
export interface GesAmountsDto {
    /**
     * Status code (00=total, 11=status 10000, 31=status 30000, 51=status 50000)
     * @type {string}
     * @memberof GesAmountsDto
     */
    'status': string;
    /**
     * Amount the insurer will pay
     * @type {number}
     * @memberof GesAmountsDto
     */
    'billValue': number;
    /**
     * Total gross amount
     * @type {number}
     * @memberof GesAmountsDto
     */
    'grossValue': number;
    /**
     * Copayment amount
     * @type {number}
     * @memberof GesAmountsDto
     */
    'copayment': number;
}
/**
 * 
 * @export
 * @interface GetAccountDto
 */
export interface GetAccountDto {
    /**
     * The name of the account
     * @type {string}
     * @memberof GetAccountDto
     */
    'name': string;
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof GetAccountDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface GetAppointmentsByIdsDto
 */
export interface GetAppointmentsByIdsDto {
    /**
     * Array of appointment IDs to fetch
     * @type {Array<string>}
     * @memberof GetAppointmentsByIdsDto
     */
    'ids': Array<string>;
    /**
     * Array of relations to fetch
     * @type {Array<AppointmentRelationsEnum>}
     * @memberof GetAppointmentsByIdsDto
     */
    'relations'?: Array<AppointmentRelationsEnum>;
}
/**
 * 
 * @export
 * @interface GetAppointmentsDto
 */
export interface GetAppointmentsDto {
    /**
     * Filter selected userIds
     * @type {Array<string>}
     * @memberof GetAppointmentsDto
     */
    'userIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetAppointmentsFilterDto
 */
export interface GetAppointmentsFilterDto {
    /**
     * Array of relations to fetch
     * @type {Array<AppointmentRelationsEnum>}
     * @memberof GetAppointmentsFilterDto
     */
    'relations': Array<AppointmentRelationsEnum>;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsFilterDto
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsFilterDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsFilterDto
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface GetBankTransferDto
 */
export interface GetBankTransferDto {
    /**
     * Bank transfer ID
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'id': string;
    /**
     * Transaction number
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'transactionNumber': string;
    /**
     * Type of the transaction
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'type': string;
    /**
     * Description of the bank transfer
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'text': string;
    /**
     * Total amount of the bank transfer
     * @type {number}
     * @memberof GetBankTransferDto
     */
    'amount': number;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof GetBankTransferDto
     */
    'wasExported': boolean;
    /**
     * User associated with the transaction
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'userName': string;
    /**
     * Account associated with the transaction
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'accountName': string;
    /**
     * Rx ID associated with the transaction
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'rxId'?: string;
    /**
     * Rx number associated with the transaction
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'rxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'rxDate'?: string;
    /**
     * Patient ID associated with the transaction
     * @type {number}
     * @memberof GetBankTransferDto
     */
    'patientId': number;
    /**
     * Patient name associated with the transaction
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'patientName': string;
    /**
     * Created at timestamp
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'createdAt': string;
    /**
     * Updated at timestamp
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'updatedAt': string;
    /**
     * List of allocated invoices (bill transactions) for this bank transfer
     * @type {Array<AllocationsDto>}
     * @memberof GetBankTransferDto
     */
    'allocations'?: Array<AllocationsDto>;
    /**
     * Transaction Number of the original transaction if this is a cancellation
     * @type {string}
     * @memberof GetBankTransferDto
     */
    'originalTransactionNumber'?: string;
    /**
     * Indicates if this transaction has been cancelled
     * @type {boolean}
     * @memberof GetBankTransferDto
     */
    'isCancelled'?: boolean;
}
/**
 * 
 * @export
 * @interface GetClinicalDoctorReportsWithFilters200Response
 */
export interface GetClinicalDoctorReportsWithFilters200Response {
    /**
     * 
     * @type {Array<DoctorReportDto>}
     * @memberof GetClinicalDoctorReportsWithFilters200Response
     */
    'data'?: Array<DoctorReportDto>;
    /**
     * Total number of records
     * @type {number}
     * @memberof GetClinicalDoctorReportsWithFilters200Response
     */
    'total'?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof GetClinicalDoctorReportsWithFilters200Response
     */
    'page'?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GetClinicalDoctorReportsWithFilters200Response
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface GetDashboardStats200Response
 */
export interface GetDashboardStats200Response {
    /**
     * Total number of TSS
     * @type {number}
     * @memberof GetDashboardStats200Response
     */
    'totalTss'?: number;
    /**
     * Total number of Clients
     * @type {number}
     * @memberof GetDashboardStats200Response
     */
    'totalClients'?: number;
    /**
     * Total number of Exports
     * @type {number}
     * @memberof GetDashboardStats200Response
     */
    'totalExports'?: number;
    /**
     * 
     * @type {GetDashboardStats200ResponseTssStats}
     * @memberof GetDashboardStats200Response
     */
    'tssStats'?: GetDashboardStats200ResponseTssStats;
    /**
     * 
     * @type {GetDashboardStats200ResponseClientStats}
     * @memberof GetDashboardStats200Response
     */
    'clientStats'?: GetDashboardStats200ResponseClientStats;
    /**
     * 
     * @type {GetDashboardStats200ResponseExportStats}
     * @memberof GetDashboardStats200Response
     */
    'exportStats'?: GetDashboardStats200ResponseExportStats;
}
/**
 * 
 * @export
 * @interface GetDashboardStats200ResponseClientStats
 */
export interface GetDashboardStats200ResponseClientStats {
    /**
     * Client count grouped by state
     * @type {{ [key: string]: number; }}
     * @memberof GetDashboardStats200ResponseClientStats
     */
    'byState'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface GetDashboardStats200ResponseExportStats
 */
export interface GetDashboardStats200ResponseExportStats {
    /**
     * Total number of exports
     * @type {number}
     * @memberof GetDashboardStats200ResponseExportStats
     */
    'total'?: number;
    /**
     * Export count grouped by status
     * @type {{ [key: string]: number; }}
     * @memberof GetDashboardStats200ResponseExportStats
     */
    'byStatus'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface GetDashboardStats200ResponseTssStats
 */
export interface GetDashboardStats200ResponseTssStats {
    /**
     * TSS count grouped by state
     * @type {{ [key: string]: number; }}
     * @memberof GetDashboardStats200ResponseTssStats
     */
    'byState'?: { [key: string]: number; };
    /**
     * Total transaction count across all TSS
     * @type {number}
     * @memberof GetDashboardStats200ResponseTssStats
     */
    'totalTransactions'?: number;
}
/**
 * 
 * @export
 * @interface GetHistoryDto
 */
export interface GetHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof GetHistoryDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetHistoryDto
     */
    'type': GetHistoryDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetHistoryDto
     */
    'action': GetHistoryDtoActionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetHistoryDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GetHistoryDto
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof GetHistoryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetHistoryDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {object}
     * @memberof GetHistoryDto
     */
    'user': object;
    /**
     * 
     * @type {SingleHistoryTranslationFieldsDto}
     * @memberof GetHistoryDto
     */
    'translations': SingleHistoryTranslationFieldsDto;
}

export const GetHistoryDtoTypeEnum = {
    Patient: 'PATIENT',
    Appointment: 'APPOINTMENT',
    Rx: 'RX',
    Doctor: 'DOCTOR',
    UserProfile: 'USER_PROFILE',
    Documentation: 'DOCUMENTATION',
    RxSeries: 'RX_SERIES',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE'
} as const;

export type GetHistoryDtoTypeEnum = typeof GetHistoryDtoTypeEnum[keyof typeof GetHistoryDtoTypeEnum];
export const GetHistoryDtoActionEnum = {
    CreateNewPatient: 'CREATE_NEW_PATIENT',
    UpdatePatient: 'UPDATE_PATIENT',
    CreateInitialEvaluation: 'CREATE_INITIAL_EVALUATION',
    CreateTreatmentNote: 'CREATE_TREATMENT_NOTE',
    UpdateInitialEvaluation: 'UPDATE_INITIAL_EVALUATION',
    UpdateTreatmentNote: 'UPDATE_TREATMENT_NOTE',
    SaveRx: 'SAVE_RX',
    UpdateRxstatus: 'UPDATE_RXSTATUS',
    SaveAppointment: 'SAVE_APPOINTMENT',
    DeletePatientAddress: 'DELETE_PATIENT_ADDRESS',
    CopyRx: 'COPY_RX',
    UpdateRxSeries: 'UPDATE_RX_SERIES',
    AddRxSeries: 'ADD_RX_SERIES',
    UpdateRxSeriesidForTherapyrx: 'UPDATE_RX_SERIESID_FOR_THERAPYRX',
    SaveSolutionAppointment: 'SAVE_SOLUTION_APPOINTMENT',
    SaveSolutionLunchBreak: 'SAVE_SOLUTION_LUNCH_BREAK',
    UpdateCancelledAppointment: 'UPDATE_CANCELLED_APPOINTMENT',
    CancelAppointment: 'CANCEL_APPOINTMENT',
    UpdateAppointment: 'UPDATE_APPOINTMENT',
    PrintRx: 'PRINT_RX',
    SetAppointmentInformedToPatient: 'SET_APPOINTMENT_INFORMED_TO_PATIENT',
    ArchivePatient: 'ARCHIVE_PATIENT',
    DeletePatient: 'DELETE_PATIENT',
    RestorePatient: 'RESTORE_PATIENT',
    CreateLeaveOfAbsence: 'CREATE_LEAVE_OF_ABSENCE',
    UpdateLeaveOfAbsence: 'UPDATE_LEAVE_OF_ABSENCE',
    DeleteLeaveOfAbsence: 'DELETE_LEAVE_OF_ABSENCE'
} as const;

export type GetHistoryDtoActionEnum = typeof GetHistoryDtoActionEnum[keyof typeof GetHistoryDtoActionEnum];

/**
 * 
 * @export
 * @interface GetInitialEvaluationDto
 */
export interface GetInitialEvaluationDto {
    /**
     * 
     * @type {string}
     * @memberof GetInitialEvaluationDto
     */
    'evaluation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInitialEvaluationDto
     */
    'goals'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetInitialEvaluationDto
     */
    'patientId': number;
    /**
     * 
     * @type {number}
     * @memberof GetInitialEvaluationDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetInitialEvaluationDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetInitialEvaluationDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetInitialEvaluationDto
     */
    'createdByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof GetInitialEvaluationDto
     */
    'createdByUser'?: UserDto;
}
/**
 * 
 * @export
 * @interface GetInsuranceTransactionDto
 */
export interface GetInsuranceTransactionDto {
    /**
     * UUID of the transaction
     * @type {string}
     * @memberof GetInsuranceTransactionDto
     */
    'id': string;
    /**
     * Transaction number
     * @type {string}
     * @memberof GetInsuranceTransactionDto
     */
    'transactionNumber': string;
    /**
     * Creation Date of the transaction
     * @type {string}
     * @memberof GetInsuranceTransactionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {GetAccountDto}
     * @memberof GetInsuranceTransactionDto
     */
    'account': GetAccountDto;
    /**
     * Status of the billing
     * @type {string}
     * @memberof GetInsuranceTransactionDto
     */
    'billStatus': GetInsuranceTransactionDtoBillStatusEnum;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetInsuranceTransactionDto
     */
    'user': GetUserDto;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof GetInsuranceTransactionDto
     */
    'amount': number;
    /**
     * 
     * @type {GetTAccountDto}
     * @memberof GetInsuranceTransactionDto
     */
    'tAccounts'?: GetTAccountDto;
    /**
     * 
     * @type {PickTypeClass}
     * @memberof GetInsuranceTransactionDto
     */
    'payer': PickTypeClass;
    /**
     * 
     * @type {string}
     * @memberof GetInsuranceTransactionDto
     */
    'notes': string;
    /**
     * 
     * @type {DocumentDto}
     * @memberof GetInsuranceTransactionDto
     */
    'docDto'?: DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof GetInsuranceTransactionDto
     */
    'paperCenterReceipt'?: DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof GetInsuranceTransactionDto
     */
    'billPdf'?: DocumentDto;
    /**
     * Whether this transaction has a billing delay
     * @type {boolean}
     * @memberof GetInsuranceTransactionDto
     */
    'isDelayed': boolean;
    /**
     * Amount that is delayed
     * @type {number}
     * @memberof GetInsuranceTransactionDto
     */
    'amountDelayed'?: number | null;
    /**
     * Date when the delay was flagged
     * @type {object}
     * @memberof GetInsuranceTransactionDto
     */
    'delayedOn'?: object | null;
}

export const GetInsuranceTransactionDtoBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;

export type GetInsuranceTransactionDtoBillStatusEnum = typeof GetInsuranceTransactionDtoBillStatusEnum[keyof typeof GetInsuranceTransactionDtoBillStatusEnum];

/**
 * 
 * @export
 * @interface GetNextAppointmentsBulkDto
 */
export interface GetNextAppointmentsBulkDto {
    /**
     * 
     * @type {Array<NextAppointmentQueryItemDto>}
     * @memberof GetNextAppointmentsBulkDto
     */
    'items': Array<NextAppointmentQueryItemDto>;
}
/**
 * 
 * @export
 * @interface GetNoticeDefinitionDataDto
 */
export interface GetNoticeDefinitionDataDto {
    /**
     * ID of the notice definition this data is based on
     * @type {string}
     * @memberof GetNoticeDefinitionDataDto
     */
    'noticeDefinitionId': string;
    /**
     * Date from which this particualar template data becomes effective
     * @type {string}
     * @memberof GetNoticeDefinitionDataDto
     */
    'effectiveFrom': string;
    /**
     * 
     * @type {string}
     * @memberof GetNoticeDefinitionDataDto
     */
    'id': string;
    /**
     * 
     * @type {GetNotificationDefinitionDto}
     * @memberof GetNoticeDefinitionDataDto
     */
    'noticeDefinition': GetNotificationDefinitionDto;
}
/**
 * 
 * @export
 * @interface GetNotificationDefinitionDto
 */
export interface GetNotificationDefinitionDto {
    /**
     * Title of the notice template
     * @type {string}
     * @memberof GetNotificationDefinitionDto
     */
    'title': string;
    /**
     * Description of the notice
     * @type {string}
     * @memberof GetNotificationDefinitionDto
     */
    'description': string;
    /**
     * Type of the notice
     * @type {string}
     * @memberof GetNotificationDefinitionDto
     */
    'type': GetNotificationDefinitionDtoTypeEnum;
    /**
     * Template id
     * @type {string}
     * @memberof GetNotificationDefinitionDto
     */
    'templateId': string;
}

export const GetNotificationDefinitionDtoTypeEnum = {
    PrivatePricing: 'PRIVATE_PRICING',
    PolicyUpdate: 'POLICY_UPDATE',
    GeneralInfo: 'GENERAL_INFO'
} as const;

export type GetNotificationDefinitionDtoTypeEnum = typeof GetNotificationDefinitionDtoTypeEnum[keyof typeof GetNotificationDefinitionDtoTypeEnum];

/**
 * 
 * @export
 * @interface GetPatientDto
 */
export interface GetPatientDto {
    /**
     * Unique identifier for the patient
     * @type {number}
     * @memberof GetPatientDto
     */
    'id': number;
    /**
     * First name of the patient
     * @type {string}
     * @memberof GetPatientDto
     */
    'firstName': string;
    /**
     * Last name of the patient
     * @type {string}
     * @memberof GetPatientDto
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface GetPatientsByIdsDto
 */
export interface GetPatientsByIdsDto {
    /**
     * Array of patient IDs to fetch
     * @type {Array<number>}
     * @memberof GetPatientsByIdsDto
     */
    'patientIds': Array<number>;
}
/**
 * 
 * @export
 * @interface GetRechnungDetailsDto
 */
export interface GetRechnungDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'rechnungNumber': string;
    /**
     * 
     * @type {number}
     * @memberof GetRechnungDetailsDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetRechnungDetailsDto
     */
    'amountWithMahnung': number;
    /**
     * 
     * @type {number}
     * @memberof GetRechnungDetailsDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'patientFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'patientLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'rxId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'rxDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'accountName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'patientEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'text'?: string;
    /**
     * Total amount paid so far
     * @type {number}
     * @memberof GetRechnungDetailsDto
     */
    'totalPaid': number;
    /**
     * Remaining amount due
     * @type {number}
     * @memberof GetRechnungDetailsDto
     */
    'due': number;
    /**
     * Payment status of the invoice
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'paymentStatus': GetRechnungDetailsDtoPaymentStatusEnum;
    /**
     * 
     * @type {DocumentDto}
     * @memberof GetRechnungDetailsDto
     */
    'docDto'?: DocumentDto;
    /**
     * 
     * @type {Array<BankTransferAllocationDto>}
     * @memberof GetRechnungDetailsDto
     */
    'allocations': Array<BankTransferAllocationDto>;
    /**
     * 
     * @type {Array<BillReminderDto>}
     * @memberof GetRechnungDetailsDto
     */
    'billReminders'?: Array<BillReminderDto>;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'emailSentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'emailSentTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'tarifGroup'?: string;
    /**
     * Soft-delete timestamp, null if active
     * @type {string}
     * @memberof GetRechnungDetailsDto
     */
    'deletedAt'?: string;
}

export const GetRechnungDetailsDtoPaymentStatusEnum = {
    Bezahlt: 'Bezahlt',
    TeilweiseBezahlt: 'Teilweise bezahlt',
    NichtBezahlt: 'Nicht bezahlt',
    GkvZuzahlungAngefordert: 'GKV Zuzahlung angefordert'
} as const;

export type GetRechnungDetailsDtoPaymentStatusEnum = typeof GetRechnungDetailsDtoPaymentStatusEnum[keyof typeof GetRechnungDetailsDtoPaymentStatusEnum];

/**
 * 
 * @export
 * @interface GetRxDto
 */
export interface GetRxDto {
    /**
     * Unique identifier for the Rx
     * @type {string}
     * @memberof GetRxDto
     */
    'id': string;
    /**
     * Rx number
     * @type {string}
     * @memberof GetRxDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetRxDto
     */
    'rxDate'?: string;
    /**
     * 
     * @type {GetPatientDto}
     * @memberof GetRxDto
     */
    'patient': GetPatientDto;
}
/**
 * 
 * @export
 * @interface GetRxsByIdsDto
 */
export interface GetRxsByIdsDto {
    /**
     * Array of Rx IDs (UUIDs) to fetch
     * @type {Array<string>}
     * @memberof GetRxsByIdsDto
     */
    'rxIds': Array<string>;
}
/**
 * 
 * @export
 * @interface GetTAccountDto
 */
export interface GetTAccountDto {
    /**
     * TAccount ID
     * @type {number}
     * @memberof GetTAccountDto
     */
    'id': number;
    /**
     * TAccount name
     * @type {string}
     * @memberof GetTAccountDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetTicketChangeLogDTO
 */
export interface GetTicketChangeLogDTO {
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'action': GetTicketChangeLogDTOActionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'previous': string;
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'current': string;
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {UserDto}
     * @memberof GetTicketChangeLogDTO
     */
    'updatedByUser': UserDto;
    /**
     * 
     * @type {string}
     * @memberof GetTicketChangeLogDTO
     */
    'changeMessage': string;
}

export const GetTicketChangeLogDTOActionEnum = {
    Added: 'ADDED',
    Created: 'CREATED',
    Updated: 'UPDATED'
} as const;

export type GetTicketChangeLogDTOActionEnum = typeof GetTicketChangeLogDTOActionEnum[keyof typeof GetTicketChangeLogDTOActionEnum];

/**
 * 
 * @export
 * @interface GetUserDto
 */
export interface GetUserDto {
    /**
     * First name of the user
     * @type {string}
     * @memberof GetUserDto
     */
    'firstName': string;
    /**
     * Last name of the user
     * @type {string}
     * @memberof GetUserDto
     */
    'lastName': string;
    /**
     * Email of the user
     * @type {string}
     * @memberof GetUserDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface GiftCertificateDto
 */
export interface GiftCertificateDto {
    /**
     * 
     * @type {string}
     * @memberof GiftCertificateDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof GiftCertificateDto
     */
    'items'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof GiftCertificateDto
     */
    'codeLowSecurity'?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftCertificateDto
     */
    'text'?: string;
    /**
     * Monetary value of the certificate
     * @type {number}
     * @memberof GiftCertificateDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof GiftCertificateDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GiftCertificateDto
     */
    'remainingAmount'?: number;
    /**
     * 
     * @type {AccountDto}
     * @memberof GiftCertificateDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {object}
     * @memberof GiftCertificateDto
     */
    'transaction'?: object;
    /**
     * 
     * @type {UserDto}
     * @memberof GiftCertificateDto
     */
    'createdByUser'?: UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof GiftCertificateDto
     */
    'updatedByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof GiftCertificateDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftCertificateDto
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GkvBillAccountDto
 */
export interface GkvBillAccountDto {
    /**
     * Account ID
     * @type {string}
     * @memberof GkvBillAccountDto
     */
    'id': string;
    /**
     * account name
     * @type {string}
     * @memberof GkvBillAccountDto
     */
    'name': string;
    /**
     * IK number
     * @type {string}
     * @memberof GkvBillAccountDto
     */
    'ik': string;
    /**
     * Bundesland for billing center resolution
     * @type {string}
     * @memberof GkvBillAccountDto
     */
    'bundesland': string;
    /**
     * District for billing center resolution
     * @type {string}
     * @memberof GkvBillAccountDto
     */
    'district': string;
    /**
     * Therapy type (Physiotherapie, Ergotherapie)
     * @type {string}
     * @memberof GkvBillAccountDto
     */
    'therapyType': string;
}
/**
 * 
 * @export
 * @interface GkvBillDocumentDto
 */
export interface GkvBillDocumentDto {
    /**
     * Document ID
     * @type {string}
     * @memberof GkvBillDocumentDto
     */
    'id': string;
    /**
     * Document URL (blob storage)
     * @type {string}
     * @memberof GkvBillDocumentDto
     */
    'url': string;
    /**
     * User-visible label
     * @type {string}
     * @memberof GkvBillDocumentDto
     */
    'label': string;
    /**
     * File name
     * @type {string}
     * @memberof GkvBillDocumentDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GkvBillEditDto
 */
export interface GkvBillEditDto {
    /**
     * Bill/transaction ID
     * @type {string}
     * @memberof GkvBillEditDto
     */
    'id': string;
    /**
     * Transaction number (e.g., V-24-1)
     * @type {string}
     * @memberof GkvBillEditDto
     */
    'transactionNumber': string;
    /**
     * Total bill amount (sum of Rx net values)
     * @type {number}
     * @memberof GkvBillEditDto
     */
    'amount': number;
    /**
     * Current bill status
     * @type {string}
     * @memberof GkvBillEditDto
     */
    'billStatus': GkvBillEditDtoBillStatusEnum;
    /**
     * Bill type (GKV)
     * @type {string}
     * @memberof GkvBillEditDto
     */
    'billType': GkvBillEditDtoBillTypeEnum;
    /**
     * User notes on the bill
     * @type {object}
     * @memberof GkvBillEditDto
     */
    'notes': object | null;
    /**
     * Whether the bill has been exported
     * @type {boolean}
     * @memberof GkvBillEditDto
     */
    'wasExported': boolean;
    /**
     * Billing date (bill creation date)
     * @type {string}
     * @memberof GkvBillEditDto
     */
    'billingDate': string;
    /**
     * 
     * @type {GkvBillAccountDto}
     * @memberof GkvBillEditDto
     */
    'account': GkvBillAccountDto;
    /**
     * 
     * @type {GkvBillUserDto}
     * @memberof GkvBillEditDto
     */
    'user': GkvBillUserDto;
    /**
     * 
     * @type {GkvBillPayerDto}
     * @memberof GkvBillEditDto
     */
    'payer': GkvBillPayerDto;
    /**
     * 
     * @type {GkvBillEditDtoPaperCenter}
     * @memberof GkvBillEditDto
     */
    'paperCenter': GkvBillEditDtoPaperCenter | null;
    /**
     * 
     * @type {GkvBillEditDtoDataCenter}
     * @memberof GkvBillEditDto
     */
    'dataCenter': GkvBillEditDtoDataCenter | null;
    /**
     * 
     * @type {GkvBillEditDtoPaperCenterReceipt}
     * @memberof GkvBillEditDto
     */
    'paperCenterReceipt': GkvBillEditDtoPaperCenterReceipt | null;
    /**
     * 
     * @type {GkvBillEditDtoBillPdf}
     * @memberof GkvBillEditDto
     */
    'billPdf': GkvBillEditDtoBillPdf | null;
    /**
     * 
     * @type {GkvBillEditDtoDocDto}
     * @memberof GkvBillEditDto
     */
    'docDto': GkvBillEditDtoDocDto | null;
    /**
     * List of Rxs in this bill
     * @type {Array<DirectBillingRxDto>}
     * @memberof GkvBillEditDto
     */
    'rxs': Array<DirectBillingRxDto>;
}

export const GkvBillEditDtoBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;

export type GkvBillEditDtoBillStatusEnum = typeof GkvBillEditDtoBillStatusEnum[keyof typeof GkvBillEditDtoBillStatusEnum];
export const GkvBillEditDtoBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;

export type GkvBillEditDtoBillTypeEnum = typeof GkvBillEditDtoBillTypeEnum[keyof typeof GkvBillEditDtoBillTypeEnum];

/**
 * Generated bill PDF
 * @export
 * @interface GkvBillEditDtoBillPdf
 */
export interface GkvBillEditDtoBillPdf {
    /**
     * Document ID
     * @type {string}
     * @memberof GkvBillEditDtoBillPdf
     */
    'id': string;
    /**
     * Document URL (blob storage)
     * @type {string}
     * @memberof GkvBillEditDtoBillPdf
     */
    'url': string;
    /**
     * User-visible label
     * @type {string}
     * @memberof GkvBillEditDtoBillPdf
     */
    'label': string;
    /**
     * File name
     * @type {string}
     * @memberof GkvBillEditDtoBillPdf
     */
    'name': string;
}
/**
 * Digital receiving center
 * @export
 * @interface GkvBillEditDtoDataCenter
 */
export interface GkvBillEditDtoDataCenter {
    /**
     * Billing center name
     * @type {string}
     * @memberof GkvBillEditDtoDataCenter
     */
    'name': string;
    /**
     * Billing center IK number
     * @type {string}
     * @memberof GkvBillEditDtoDataCenter
     */
    'ik': string;
    /**
     * Billing center address
     * @type {object}
     * @memberof GkvBillEditDtoDataCenter
     */
    'address': object;
}
/**
 * RX scan document
 * @export
 * @interface GkvBillEditDtoDocDto
 */
export interface GkvBillEditDtoDocDto {
    /**
     * Document ID
     * @type {string}
     * @memberof GkvBillEditDtoDocDto
     */
    'id': string;
    /**
     * Document URL (blob storage)
     * @type {string}
     * @memberof GkvBillEditDtoDocDto
     */
    'url': string;
    /**
     * User-visible label
     * @type {string}
     * @memberof GkvBillEditDtoDocDto
     */
    'label': string;
    /**
     * File name
     * @type {string}
     * @memberof GkvBillEditDtoDocDto
     */
    'name': string;
}
/**
 * Paper receiving center
 * @export
 * @interface GkvBillEditDtoPaperCenter
 */
export interface GkvBillEditDtoPaperCenter {
    /**
     * Billing center name
     * @type {string}
     * @memberof GkvBillEditDtoPaperCenter
     */
    'name': string;
    /**
     * Billing center IK number
     * @type {string}
     * @memberof GkvBillEditDtoPaperCenter
     */
    'ik': string;
    /**
     * Billing center address
     * @type {object}
     * @memberof GkvBillEditDtoPaperCenter
     */
    'address': object;
}
/**
 * Paper center receipt document
 * @export
 * @interface GkvBillEditDtoPaperCenterReceipt
 */
export interface GkvBillEditDtoPaperCenterReceipt {
    /**
     * Document ID
     * @type {string}
     * @memberof GkvBillEditDtoPaperCenterReceipt
     */
    'id': string;
    /**
     * Document URL (blob storage)
     * @type {string}
     * @memberof GkvBillEditDtoPaperCenterReceipt
     */
    'url': string;
    /**
     * User-visible label
     * @type {string}
     * @memberof GkvBillEditDtoPaperCenterReceipt
     */
    'label': string;
    /**
     * File name
     * @type {string}
     * @memberof GkvBillEditDtoPaperCenterReceipt
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GkvBillExportRequestDto
 */
export interface GkvBillExportRequestDto {
    /**
     * IDs of bills to export
     * @type {Array<string>}
     * @memberof GkvBillExportRequestDto
     */
    'billIds': Array<string>;
    /**
     * 
     * @type {GkvExportTestTypeDto}
     * @memberof GkvBillExportRequestDto
     */
    'testTypeData': GkvExportTestTypeDto;
}
/**
 * 
 * @export
 * @interface GkvBillExportResponseDto
 */
export interface GkvBillExportResponseDto {
    /**
     * Per-bill export results
     * @type {Array<GkvBillExportResultDto>}
     * @memberof GkvBillExportResponseDto
     */
    'results': Array<GkvBillExportResultDto>;
}
/**
 * 
 * @export
 * @interface GkvBillExportResultDto
 */
export interface GkvBillExportResultDto {
    /**
     * Bill ID
     * @type {string}
     * @memberof GkvBillExportResultDto
     */
    'billId': string;
    /**
     * Bill number (e.g. V-24-001)
     * @type {string}
     * @memberof GkvBillExportResultDto
     */
    'billNumber': string;
    /**
     * Whether export succeeded
     * @type {boolean}
     * @memberof GkvBillExportResultDto
     */
    'success': boolean;
    /**
     * Human-readable result message
     * @type {string}
     * @memberof GkvBillExportResultDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface GkvBillPayerDto
 */
export interface GkvBillPayerDto {
    /**
     * Payer IK number
     * @type {string}
     * @memberof GkvBillPayerDto
     */
    'ik': string;
    /**
     * Payer name
     * @type {string}
     * @memberof GkvBillPayerDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GkvBillPrintResponseDto
 */
export interface GkvBillPrintResponseDto {
    /**
     * 
     * @type {GkvBillPrintResponseDtoPaperCenterReceipt}
     * @memberof GkvBillPrintResponseDto
     */
    'paperCenterReceipt': GkvBillPrintResponseDtoPaperCenterReceipt | null;
    /**
     * 
     * @type {GkvBillEditDtoBillPdf}
     * @memberof GkvBillPrintResponseDto
     */
    'billPdf': GkvBillEditDtoBillPdf | null;
}
/**
 * Paper center receipt PDF
 * @export
 * @interface GkvBillPrintResponseDtoPaperCenterReceipt
 */
export interface GkvBillPrintResponseDtoPaperCenterReceipt {
    /**
     * Document ID
     * @type {string}
     * @memberof GkvBillPrintResponseDtoPaperCenterReceipt
     */
    'id': string;
    /**
     * Document URL (blob storage)
     * @type {string}
     * @memberof GkvBillPrintResponseDtoPaperCenterReceipt
     */
    'url': string;
    /**
     * User-visible label
     * @type {string}
     * @memberof GkvBillPrintResponseDtoPaperCenterReceipt
     */
    'label': string;
    /**
     * File name
     * @type {string}
     * @memberof GkvBillPrintResponseDtoPaperCenterReceipt
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GkvBillUpdateResponseDto
 */
export interface GkvBillUpdateResponseDto {
    /**
     * Bill ID
     * @type {string}
     * @memberof GkvBillUpdateResponseDto
     */
    'id': string;
    /**
     * Updated total amount
     * @type {number}
     * @memberof GkvBillUpdateResponseDto
     */
    'amount': number;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof GkvBillUpdateResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface GkvBillUserDto
 */
export interface GkvBillUserDto {
    /**
     * User ID
     * @type {string}
     * @memberof GkvBillUserDto
     */
    'id': string;
    /**
     * First name
     * @type {string}
     * @memberof GkvBillUserDto
     */
    'firstName': string;
    /**
     * Last name
     * @type {string}
     * @memberof GkvBillUserDto
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface GkvExportTestTypeDto
 */
export interface GkvExportTestTypeDto {
    /**
     * Test mode: Global (production), Internal (dry-run), External (to specific email)
     * @type {string}
     * @memberof GkvExportTestTypeDto
     */
    'type': GkvExportTestTypeDtoTypeEnum;
    /**
     * Override email for EXTERNAL test mode
     * @type {string}
     * @memberof GkvExportTestTypeDto
     */
    'email'?: string;
}

export const GkvExportTestTypeDtoTypeEnum = {
    Global: 'Global',
    Internal: 'Internal',
    External: 'External'
} as const;

export type GkvExportTestTypeDtoTypeEnum = typeof GkvExportTestTypeDtoTypeEnum[keyof typeof GkvExportTestTypeDtoTypeEnum];

/**
 * 
 * @export
 * @interface GroupedDataDto
 */
export interface GroupedDataDto {
    /**
     * 
     * @type {string}
     * @memberof GroupedDataDto
     */
    'payerIK': string;
    /**
     * 
     * @type {GroupedRxWithPayerDto}
     * @memberof GroupedDataDto
     */
    'data': GroupedRxWithPayerDto;
}
/**
 * 
 * @export
 * @interface GroupedRxWithPayerDto
 */
export interface GroupedRxWithPayerDto {
    /**
     * 
     * @type {Array<RxWithPriceAndAppointmentsDto>}
     * @memberof GroupedRxWithPayerDto
     */
    'rxs': Array<RxWithPriceAndAppointmentsDto>;
    /**
     * 
     * @type {PayerDto}
     * @memberof GroupedRxWithPayerDto
     */
    'payerDto': PayerDto;
    /**
     * 
     * @type {number}
     * @memberof GroupedRxWithPayerDto
     */
    'totalPrice': number;
}
/**
 * 
 * @export
 * @interface HardDeletePatientRequest
 */
export interface HardDeletePatientRequest {
    /**
     * Confirmation text required for hard deletion
     * @type {string}
     * @memberof HardDeletePatientRequest
     */
    'confirmationText': string;
}
/**
 * 
 * @export
 * @interface HistoryFilterEntryDto
 */
export interface HistoryFilterEntryDto {
    /**
     * 
     * @type {string}
     * @memberof HistoryFilterEntryDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFilterEntryDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface HistoryFiltersDto
 */
export interface HistoryFiltersDto {
    /**
     * 
     * @type {Array<HistoryFilterEntryDto>}
     * @memberof HistoryFiltersDto
     */
    'actionFilters': Array<HistoryFilterEntryDto>;
    /**
     * 
     * @type {Array<HistoryFilterEntryDto>}
     * @memberof HistoryFiltersDto
     */
    'typeFilters': Array<HistoryFilterEntryDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HistoryType = {
    Patient: 'PATIENT',
    Appointment: 'APPOINTMENT',
    Rx: 'RX',
    Doctor: 'DOCTOR',
    UserProfile: 'USER_PROFILE',
    Documentation: 'DOCUMENTATION',
    RxSeries: 'RX_SERIES',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE'
} as const;

export type HistoryType = typeof HistoryType[keyof typeof HistoryType];


/**
 * 
 * @export
 * @interface ICDCodeDto
 */
export interface ICDCodeDto {
    /**
     * 
     * @type {string}
     * @memberof ICDCodeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ICDCodeDto
     */
    'normCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ICDCodeDto
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface ICDCodeEntryDto
 */
export interface ICDCodeEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ICDCodeEntryDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ICDCodeEntryDto
     */
    'userText'?: string;
    /**
     * 
     * @type {object}
     * @memberof ICDCodeEntryDto
     */
    'laterality'?: object | null;
    /**
     * 
     * @type {ICDCodeDto}
     * @memberof ICDCodeEntryDto
     */
    'icdCode'?: ICDCodeDto;
}
/**
 * 
 * @export
 * @interface ImportGeojsonResultDto
 */
export interface ImportGeojsonResultDto {
    /**
     * Number of sublocalities imported from GeoJSON
     * @type {number}
     * @memberof ImportGeojsonResultDto
     */
    'sublocalitiesImported': number;
    /**
     * Total number of addresses processed
     * @type {number}
     * @memberof ImportGeojsonResultDto
     */
    'totalAddresses': number;
    /**
     * Number of addresses matched to a sublocality geometry
     * @type {number}
     * @memberof ImportGeojsonResultDto
     */
    'addressesMatched': number;
    /**
     * Number of addresses with coordinates but no matching geometry
     * @type {number}
     * @memberof ImportGeojsonResultDto
     */
    'addressesUnmatched': number;
    /**
     * Number of addresses skipped (no coordinates)
     * @type {number}
     * @memberof ImportGeojsonResultDto
     */
    'addressesSkipped': number;
}
/**
 * 
 * @export
 * @interface InitialEvaluationsByPatientDto
 */
export interface InitialEvaluationsByPatientDto {
    /**
     * 
     * @type {number}
     * @memberof InitialEvaluationsByPatientDto
     */
    'patientId': number;
    /**
     * 
     * @type {Array<GetInitialEvaluationDto>}
     * @memberof InitialEvaluationsByPatientDto
     */
    'evaluations': Array<GetInitialEvaluationDto>;
}
/**
 * 
 * @export
 * @interface InstituteDto
 */
export interface InstituteDto {
    /**
     * 
     * @type {string}
     * @memberof InstituteDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InstituteDto
     */
    'ik': string;
    /**
     * 
     * @type {string}
     * @memberof InstituteDto
     */
    'validFrom': string;
    /**
     * 
     * @type {object}
     * @memberof InstituteDto
     */
    'address': object;
    /**
     * 
     * @type {object}
     * @memberof InstituteDto
     */
    'contact': object;
}
/**
 * 
 * @export
 * @interface InsurerDto
 */
export interface InsurerDto {
    /**
     * 
     * @type {string}
     * @memberof InsurerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InsurerDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsurerDto
     */
    'ik'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsurerDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {TarifGroupDto}
     * @memberof InsurerDto
     */
    'tarifGroup'?: TarifGroupDto;
    /**
     * 
     * @type {PayerDto}
     * @memberof InsurerDto
     */
    'payer'?: PayerDto;
    /**
     * 
     * @type {string}
     * @memberof InsurerDto
     */
    'payerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsurerDto
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface JobChildDtoAPPOINTMENTSUGGESTION
 */
export interface JobChildDtoAPPOINTMENTSUGGESTION {
    /**
     * Results from child job CALL_PY_APP_SCHEDULING_API
     * @type {Array<JobResultCallPyAppSchedulingApiDto>}
     * @memberof JobChildDtoAPPOINTMENTSUGGESTION
     */
    'CALL_PY_APP_SCHEDULING_API'?: Array<JobResultCallPyAppSchedulingApiDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoAVAILABILITYREQUESTFORPATIENT
 */
export interface JobChildDtoAVAILABILITYREQUESTFORPATIENT {
    /**
     * Results from child job CALL_PY_APP_PATIENT_AVAILABILITY_API
     * @type {Array<JobResultCallPyAppPatientAvailabilityApiDto>}
     * @memberof JobChildDtoAVAILABILITYREQUESTFORPATIENT
     */
    'CALL_PY_APP_PATIENT_AVAILABILITY_API'?: Array<JobResultCallPyAppPatientAvailabilityApiDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoBILLPDFBATCHAGGREGATOR
 */
export interface JobChildDtoBILLPDFBATCHAGGREGATOR {
    /**
     * Results from child job GENERATE_BILL_PDF
     * @type {Array<JobResultGenerateBillPdfDto>}
     * @memberof JobChildDtoBILLPDFBATCHAGGREGATOR
     */
    'GENERATE_BILL_PDF'?: Array<JobResultGenerateBillPdfDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoBILLPDFMULTISTEPAGGREGATOR
 */
export interface JobChildDtoBILLPDFMULTISTEPAGGREGATOR {
    /**
     * Results from child job PERSIST_BILL_PDF_DOCUMENT
     * @type {Array<JobResultPersistBillPdfDocumentDto>}
     * @memberof JobChildDtoBILLPDFMULTISTEPAGGREGATOR
     */
    'PERSIST_BILL_PDF_DOCUMENT'?: Array<JobResultPersistBillPdfDocumentDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoCALLPYAPPSCHEDULINGAPI
 */
export interface JobChildDtoCALLPYAPPSCHEDULINGAPI {
    /**
     * Results from child job GET_APPOINTMENT_STATE_FOR_PATIENT
     * @type {Array<JobResultGetAppointmentStateForPatientDto>}
     * @memberof JobChildDtoCALLPYAPPSCHEDULINGAPI
     */
    'GET_APPOINTMENT_STATE_FOR_PATIENT'?: Array<JobResultGetAppointmentStateForPatientDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoGENERATEPDFREPORT
 */
export interface JobChildDtoGENERATEPDFREPORT {
    /**
     * Results from child job GET_APPOINTMENT_STATE_FOR_PATIENT
     * @type {Array<JobResultGetAppointmentStateForPatientDto>}
     * @memberof JobChildDtoGENERATEPDFREPORT
     */
    'GET_APPOINTMENT_STATE_FOR_PATIENT'?: Array<JobResultGetAppointmentStateForPatientDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoPDFLOADTESTAGGREGATOR
 */
export interface JobChildDtoPDFLOADTESTAGGREGATOR {
    /**
     * Results from child job GENERATE_PDF_REPORT
     * @type {Array<JobResultGeneratePdfReportDto>}
     * @memberof JobChildDtoPDFLOADTESTAGGREGATOR
     */
    'GENERATE_PDF_REPORT'?: Array<JobResultGeneratePdfReportDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoPERSISTBILLPDFDOCUMENT
 */
export interface JobChildDtoPERSISTBILLPDFDOCUMENT {
    /**
     * Results from child job RENDER_BILL_PDF
     * @type {Array<JobResultRenderBillPdfDto>}
     * @memberof JobChildDtoPERSISTBILLPDFDOCUMENT
     */
    'RENDER_BILL_PDF'?: Array<JobResultRenderBillPdfDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoRENDERBILLPDF
 */
export interface JobChildDtoRENDERBILLPDF {
    /**
     * Results from child job PREP_BILL_PDF_DATA
     * @type {Array<JobResultPrepBillPdfDataDto>}
     * @memberof JobChildDtoRENDERBILLPDF
     */
    'PREP_BILL_PDF_DATA'?: Array<JobResultPrepBillPdfDataDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoRESCHEDULINGAGENT
 */
export interface JobChildDtoRESCHEDULINGAGENT {
    /**
     * Results from child job CALL_PY_APP_RESCHEDULING_API
     * @type {Array<JobResultCallPyAppReschedulingApiDto>}
     * @memberof JobChildDtoRESCHEDULINGAGENT
     */
    'CALL_PY_APP_RESCHEDULING_API'?: Array<JobResultCallPyAppReschedulingApiDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoRUNBACKPLANNING
 */
export interface JobChildDtoRUNBACKPLANNING {
    /**
     * Results from child job CALL_PY_APP_BACKPLANNING_API
     * @type {Array<JobResultCallPyAppBackplanningApiDto>}
     * @memberof JobChildDtoRUNBACKPLANNING
     */
    'CALL_PY_APP_BACKPLANNING_API'?: Array<JobResultCallPyAppBackplanningApiDto>;
}
/**
 * 
 * @export
 * @interface JobChildDtoVALIDATERXBULK
 */
export interface JobChildDtoVALIDATERXBULK {
    /**
     * Results from child job RUN_RX_VALIDATION_BULK
     * @type {Array<JobResultRunRxValidationBulkDto>}
     * @memberof JobChildDtoVALIDATERXBULK
     */
    'RUN_RX_VALIDATION_BULK'?: Array<JobResultRunRxValidationBulkDto>;
}
/**
 * 
 * @export
 * @interface JobChildrenSchemaMap
 */
export interface JobChildrenSchemaMap {
    /**
     * 
     * @type {JobChildDtoCALLPYAPPSCHEDULINGAPI}
     * @memberof JobChildrenSchemaMap
     */
    'CALL_PY_APP_SCHEDULING_API'?: JobChildDtoCALLPYAPPSCHEDULINGAPI;
    /**
     * 
     * @type {JobChildDtoGENERATEPDFREPORT}
     * @memberof JobChildrenSchemaMap
     */
    'GENERATE_PDF_REPORT'?: JobChildDtoGENERATEPDFREPORT;
    /**
     * 
     * @type {JobChildDtoAPPOINTMENTSUGGESTION}
     * @memberof JobChildrenSchemaMap
     */
    'APPOINTMENT_SUGGESTION'?: JobChildDtoAPPOINTMENTSUGGESTION;
    /**
     * 
     * @type {JobChildDtoAVAILABILITYREQUESTFORPATIENT}
     * @memberof JobChildrenSchemaMap
     */
    'AVAILABILITY_REQUEST_FOR_PATIENT'?: JobChildDtoAVAILABILITYREQUESTFORPATIENT;
    /**
     * 
     * @type {JobChildDtoRESCHEDULINGAGENT}
     * @memberof JobChildrenSchemaMap
     */
    'RESCHEDULING_AGENT'?: JobChildDtoRESCHEDULINGAGENT;
    /**
     * 
     * @type {JobChildDtoRUNBACKPLANNING}
     * @memberof JobChildrenSchemaMap
     */
    'RUN_BACKPLANNING'?: JobChildDtoRUNBACKPLANNING;
    /**
     * 
     * @type {JobChildDtoVALIDATERXBULK}
     * @memberof JobChildrenSchemaMap
     */
    'VALIDATE_RX_BULK'?: JobChildDtoVALIDATERXBULK;
    /**
     * 
     * @type {JobChildDtoPDFLOADTESTAGGREGATOR}
     * @memberof JobChildrenSchemaMap
     */
    'PDF_LOAD_TEST_AGGREGATOR'?: JobChildDtoPDFLOADTESTAGGREGATOR;
    /**
     * 
     * @type {JobChildDtoBILLPDFBATCHAGGREGATOR}
     * @memberof JobChildrenSchemaMap
     */
    'BILL_PDF_BATCH_AGGREGATOR'?: JobChildDtoBILLPDFBATCHAGGREGATOR;
    /**
     * 
     * @type {JobChildDtoRENDERBILLPDF}
     * @memberof JobChildrenSchemaMap
     */
    'RENDER_BILL_PDF'?: JobChildDtoRENDERBILLPDF;
    /**
     * 
     * @type {JobChildDtoPERSISTBILLPDFDOCUMENT}
     * @memberof JobChildrenSchemaMap
     */
    'PERSIST_BILL_PDF_DOCUMENT'?: JobChildDtoPERSISTBILLPDFDOCUMENT;
    /**
     * 
     * @type {JobChildDtoBILLPDFMULTISTEPAGGREGATOR}
     * @memberof JobChildrenSchemaMap
     */
    'BILL_PDF_MULTI_STEP_AGGREGATOR'?: JobChildDtoBILLPDFMULTISTEPAGGREGATOR;
}
/**
 * 
 * @export
 * @interface JobDataAppointmentSuggestionDto
 */
export interface JobDataAppointmentSuggestionDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataAppointmentSuggestionDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataAppointmentSuggestionDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataAppointmentSuggestionDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataAppointmentSuggestionDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
}


/**
 * 
 * @export
 * @interface JobDataAvailabilityRequestForPatientDto
 */
export interface JobDataAvailabilityRequestForPatientDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataAvailabilityRequestForPatientDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataAvailabilityRequestForPatientDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataAvailabilityRequestForPatientDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataAvailabilityRequestForPatientDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * 
     * @type {number}
     * @memberof JobDataAvailabilityRequestForPatientDto
     */
    'patientId': number;
}


/**
 * 
 * @export
 * @interface JobDataBillPdfBatchAggregatorDto
 */
export interface JobDataBillPdfBatchAggregatorDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataBillPdfBatchAggregatorDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataBillPdfBatchAggregatorDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataBillPdfBatchAggregatorDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataBillPdfBatchAggregatorDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Type of PDFs being generated in this batch
     * @type {string}
     * @memberof JobDataBillPdfBatchAggregatorDto
     */
    'pdfType': JobDataBillPdfBatchAggregatorDtoPdfTypeEnum;
}

export const JobDataBillPdfBatchAggregatorDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type JobDataBillPdfBatchAggregatorDtoPdfTypeEnum = typeof JobDataBillPdfBatchAggregatorDtoPdfTypeEnum[keyof typeof JobDataBillPdfBatchAggregatorDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface JobDataBillPdfMultiStepAggregatorDto
 */
export interface JobDataBillPdfMultiStepAggregatorDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataBillPdfMultiStepAggregatorDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataBillPdfMultiStepAggregatorDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataBillPdfMultiStepAggregatorDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataBillPdfMultiStepAggregatorDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Primary PDF type for this workflow batch
     * @type {string}
     * @memberof JobDataBillPdfMultiStepAggregatorDto
     */
    'pdfType': JobDataBillPdfMultiStepAggregatorDtoPdfTypeEnum;
}

export const JobDataBillPdfMultiStepAggregatorDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type JobDataBillPdfMultiStepAggregatorDtoPdfTypeEnum = typeof JobDataBillPdfMultiStepAggregatorDtoPdfTypeEnum[keyof typeof JobDataBillPdfMultiStepAggregatorDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface JobDataCallPyAppBackplanningApiDto
 */
export interface JobDataCallPyAppBackplanningApiDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Farthest future date to backplan from. Defaults to today + TIME_HORIZON_WEEKS if omitted.
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'startingHorizonDate'?: string;
    /**
     * Earliest date (inclusive) to stop walking backward. If omitted, auto-computed from selectedRxId or falls back to today.
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'locationId': string;
    /**
     * Rx ID from the selected appointment. Used to compute the end date: last appointment on this Rx series + 2 days. If omitted, endDate falls back to today.
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'selectedRxId'?: string;
    /**
     * Only process these ContinuousAppointment IDs. If omitted, all DTs for the location are processed.
     * @type {Array<string>}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'changedCaIds'?: Array<string>;
    /**
     * ISO weekdays (1=Mon..5=Fri) affected by changed CAs. Used to limit DT fetch to only these days.
     * @type {Array<number>}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'changedWeekdays'?: Array<number>;
    /**
     * Optional user-provided instructions for the LLM (e.g. \'Patient A bevorzugt morgens\'). Passed to the agent context on escalation.
     * @type {string}
     * @memberof JobDataCallPyAppBackplanningApiDto
     */
    'userText'?: string;
}


/**
 * 
 * @export
 * @interface JobDataCallPyAppPatientAvailabilityApiDto
 */
export interface JobDataCallPyAppPatientAvailabilityApiDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * 
     * @type {string}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'requestString'?: string;
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'availabilities'?: Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'blockedSlots'?: Array<BlockingSlotDto>;
    /**
     * 
     * @type {number}
     * @memberof JobDataCallPyAppPatientAvailabilityApiDto
     */
    'patientId': number;
}


/**
 * 
 * @export
 * @interface JobDataCallPyAppReschedulingApiDto
 */
export interface JobDataCallPyAppReschedulingApiDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Patient ID to reschedule
     * @type {string}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'patientId': string;
    /**
     * Location ID
     * @type {string}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'locationId': string;
    /**
     * \'direct\' or \'post_automatic_scheduler\'
     * @type {string}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'mode'?: string;
    /**
     * Specific appointment IDs to target
     * @type {Array<string>}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'targetAppointmentIds'?: Array<string>;
    /**
     * Rejected action groups with rejection reason
     * @type {Array<RejectedActionGroupDto>}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'rejectedProposals'?: Array<RejectedActionGroupDto>;
    /**
     * Unreviewed action groups — may re-propose with modifications
     * @type {Array<ActionGroupDto>}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'unreviewedProposals'?: Array<ActionGroupDto>;
    /**
     * Free-text user instructions for the agent
     * @type {string}
     * @memberof JobDataCallPyAppReschedulingApiDto
     */
    'userInstructions'?: string;
}


/**
 * 
 * @export
 * @interface JobDataCallPyAppSchedulingApiDto
 */
export interface JobDataCallPyAppSchedulingApiDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * 
     * @type {string}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'searchFunction'?: string;
    /**
     * 
     * @type {number}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'pruningTarget'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'betaGap'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'betaTherapists'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'betaTreatmentMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'betaDrivingTime'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'wishTherapists'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'date'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDataCallPyAppSchedulingApiDto
     */
    'appointmentIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface JobDataGenerateBillPdfDto
 */
export interface JobDataGenerateBillPdfDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataGenerateBillPdfDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataGenerateBillPdfDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Type of PDF to generate - determines which factory method to call
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'pdfType': JobDataGenerateBillPdfDtoPdfTypeEnum;
    /**
     * ID of the entity to generate PDF for (billId, rechnungId, reportId, etc.)
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'entityId': string;
    /**
     * Transaction number for identification in batch results
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'transactionNumber'?: string;
    /**
     * User ID of the user who initiated the PDF generation
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'createdByUserId': string;
    /**
     * Optional PDF date override (ISO string). Used by GKV bills.
     * @type {string}
     * @memberof JobDataGenerateBillPdfDto
     */
    'pdfDate'?: string;
}

export const JobDataGenerateBillPdfDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type JobDataGenerateBillPdfDtoPdfTypeEnum = typeof JobDataGenerateBillPdfDtoPdfTypeEnum[keyof typeof JobDataGenerateBillPdfDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface JobDataGeneratePdfReportDto
 */
export interface JobDataGeneratePdfReportDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataGeneratePdfReportDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataGeneratePdfReportDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * 
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'searchFunction'?: string;
    /**
     * 
     * @type {number}
     * @memberof JobDataGeneratePdfReportDto
     */
    'pruningTarget'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGeneratePdfReportDto
     */
    'betaGap'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGeneratePdfReportDto
     */
    'betaTherapists'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGeneratePdfReportDto
     */
    'betaTreatmentMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGeneratePdfReportDto
     */
    'betaDrivingTime'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDataGeneratePdfReportDto
     */
    'wishTherapists'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'date'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDataGeneratePdfReportDto
     */
    'appointmentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobDataGeneratePdfReportDto
     */
    'pdfID': string;
}


/**
 * 
 * @export
 * @interface JobDataGetAppointmentStateForPatientDto
 */
export interface JobDataGetAppointmentStateForPatientDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * 
     * @type {string}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'searchFunction'?: string;
    /**
     * 
     * @type {number}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'pruningTarget'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'betaGap'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'betaTherapists'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'betaTreatmentMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'betaDrivingTime'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'wishTherapists'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'date'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDataGetAppointmentStateForPatientDto
     */
    'appointmentIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface JobDataPdfLoadTestAggregatorDto
 */
export interface JobDataPdfLoadTestAggregatorDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataPdfLoadTestAggregatorDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataPdfLoadTestAggregatorDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataPdfLoadTestAggregatorDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataPdfLoadTestAggregatorDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
}


/**
 * 
 * @export
 * @interface JobDataPersistBillPdfDocumentDto
 */
export interface JobDataPersistBillPdfDocumentDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Type of PDF to persist as Document entities
     * @type {string}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'pdfType': JobDataPersistBillPdfDocumentDtoPdfTypeEnum;
    /**
     * Entity ID for the bill/report being persisted
     * @type {string}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'entityId': string;
    /**
     * Transaction number for identification in batch results
     * @type {string}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'transactionNumber'?: string;
    /**
     * User ID who initiated the PDF generation
     * @type {string}
     * @memberof JobDataPersistBillPdfDocumentDto
     */
    'createdByUserId': string;
}

export const JobDataPersistBillPdfDocumentDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type JobDataPersistBillPdfDocumentDtoPdfTypeEnum = typeof JobDataPersistBillPdfDocumentDtoPdfTypeEnum[keyof typeof JobDataPersistBillPdfDocumentDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface JobDataPrepBillPdfDataDto
 */
export interface JobDataPrepBillPdfDataDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Type of PDF to prepare data for
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'pdfType': JobDataPrepBillPdfDataDtoPdfTypeEnum;
    /**
     * ID of the entity to generate PDF for
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'entityId': string;
    /**
     * Transaction number for identification in batch results
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'transactionNumber'?: string;
    /**
     * User ID who initiated the PDF generation
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'createdByUserId': string;
    /**
     * Optional PDF date override (ISO string). Used by GKV bills.
     * @type {string}
     * @memberof JobDataPrepBillPdfDataDto
     */
    'pdfDate'?: string;
}

export const JobDataPrepBillPdfDataDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type JobDataPrepBillPdfDataDtoPdfTypeEnum = typeof JobDataPrepBillPdfDataDtoPdfTypeEnum[keyof typeof JobDataPrepBillPdfDataDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface JobDataRenderBillPdfDto
 */
export interface JobDataRenderBillPdfDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataRenderBillPdfDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataRenderBillPdfDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataRenderBillPdfDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataRenderBillPdfDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Type of PDF to render
     * @type {string}
     * @memberof JobDataRenderBillPdfDto
     */
    'pdfType': JobDataRenderBillPdfDtoPdfTypeEnum;
    /**
     * Entity ID for the bill being rendered
     * @type {string}
     * @memberof JobDataRenderBillPdfDto
     */
    'entityId': string;
    /**
     * Transaction number for identification in batch results
     * @type {string}
     * @memberof JobDataRenderBillPdfDto
     */
    'transactionNumber'?: string;
    /**
     * User ID who initiated the PDF generation
     * @type {string}
     * @memberof JobDataRenderBillPdfDto
     */
    'createdByUserId': string;
}

export const JobDataRenderBillPdfDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type JobDataRenderBillPdfDtoPdfTypeEnum = typeof JobDataRenderBillPdfDtoPdfTypeEnum[keyof typeof JobDataRenderBillPdfDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface JobDataReschedulingAgentDto
 */
export interface JobDataReschedulingAgentDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataReschedulingAgentDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataReschedulingAgentDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataReschedulingAgentDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataReschedulingAgentDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
}


/**
 * 
 * @export
 * @interface JobDataRunAiAgentDto
 */
export interface JobDataRunAiAgentDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataRunAiAgentDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataRunAiAgentDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataRunAiAgentDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataRunAiAgentDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Name of the AI agent to use
     * @type {string}
     * @memberof JobDataRunAiAgentDto
     */
    'agentName': string;
    /**
     * Conversation thread ID
     * @type {string}
     * @memberof JobDataRunAiAgentDto
     */
    'threadId': string;
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof JobDataRunAiAgentDto
     */
    'message': string;
}


/**
 * 
 * @export
 * @interface JobDataRunBackplanningDto
 */
export interface JobDataRunBackplanningDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataRunBackplanningDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataRunBackplanningDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataRunBackplanningDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataRunBackplanningDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
}


/**
 * 
 * @export
 * @interface JobDataRunRxValidationBulkDto
 */
export interface JobDataRunRxValidationBulkDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
    /**
     * Optional location (Standort) to restrict the validation run to. When omitted, all locations are validated.
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'locationId'?: string;
    /**
     * Opaque nonce identifying one user-initiated run. The workflow id is derived from this whole payload and a completed workflow\'s result is replayed for its TTL, so without a fresh nonce \'Erneut prüfen\' returns the previous run\'s numbers instead of re-checking (MD-184). Callers that mean \'run it again\' must send a new value; omit it to deliberately reuse a recent run.
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'runId'?: string;
    /**
     * Restrict the run to one Bearbeitungsstatus. Omitted = the default candidate statuses.
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'processingStatus'?: JobDataRunRxValidationBulkDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'doctorReportStatus'?: JobDataRunRxValidationBulkDtoDoctorReportStatusEnum;
    /**
     * Restrict the run to one tarif group
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'tarifGroupId'?: string;
    /**
     * Restrict the run to one Rx type
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'rxTypeId'?: string;
    /**
     * Restrict the run to one Mandant (account)
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'accountId'?: string;
    /**
     * Restrict the run to Rxs prescribing this term
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'prescribedTherapyId'?: string;
    /**
     * Restrict the run to a patient last name prefix
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'lastName'?: string;
    /**
     * Restrict the run to one Rx number
     * @type {string}
     * @memberof JobDataRunRxValidationBulkDto
     */
    'rxNumber'?: string;
}

export const JobDataRunRxValidationBulkDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type JobDataRunRxValidationBulkDtoProcessingStatusEnum = typeof JobDataRunRxValidationBulkDtoProcessingStatusEnum[keyof typeof JobDataRunRxValidationBulkDtoProcessingStatusEnum];
export const JobDataRunRxValidationBulkDtoDoctorReportStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type JobDataRunRxValidationBulkDtoDoctorReportStatusEnum = typeof JobDataRunRxValidationBulkDtoDoctorReportStatusEnum[keyof typeof JobDataRunRxValidationBulkDtoDoctorReportStatusEnum];

/**
 * 
 * @export
 * @interface JobDataSchemaMap
 */
export interface JobDataSchemaMap {
    /**
     * 
     * @type {JobDataGetAppointmentStateForPatientDto}
     * @memberof JobDataSchemaMap
     */
    'GET_APPOINTMENT_STATE_FOR_PATIENT'?: JobDataGetAppointmentStateForPatientDto;
    /**
     * 
     * @type {JobDataCallPyAppSchedulingApiDto}
     * @memberof JobDataSchemaMap
     */
    'CALL_PY_APP_SCHEDULING_API'?: JobDataCallPyAppSchedulingApiDto;
    /**
     * 
     * @type {JobDataGeneratePdfReportDto}
     * @memberof JobDataSchemaMap
     */
    'GENERATE_PDF_REPORT'?: JobDataGeneratePdfReportDto;
    /**
     * 
     * @type {JobDataAppointmentSuggestionDto}
     * @memberof JobDataSchemaMap
     */
    'APPOINTMENT_SUGGESTION'?: JobDataAppointmentSuggestionDto;
    /**
     * 
     * @type {JobDataRunAiAgentDto}
     * @memberof JobDataSchemaMap
     */
    'RUN_AI_AGENT'?: JobDataRunAiAgentDto;
    /**
     * 
     * @type {JobDataAvailabilityRequestForPatientDto}
     * @memberof JobDataSchemaMap
     */
    'AVAILABILITY_REQUEST_FOR_PATIENT'?: JobDataAvailabilityRequestForPatientDto;
    /**
     * 
     * @type {JobDataCallPyAppPatientAvailabilityApiDto}
     * @memberof JobDataSchemaMap
     */
    'CALL_PY_APP_PATIENT_AVAILABILITY_API'?: JobDataCallPyAppPatientAvailabilityApiDto;
    /**
     * 
     * @type {JobDataReschedulingAgentDto}
     * @memberof JobDataSchemaMap
     */
    'RESCHEDULING_AGENT'?: JobDataReschedulingAgentDto;
    /**
     * 
     * @type {JobDataCallPyAppReschedulingApiDto}
     * @memberof JobDataSchemaMap
     */
    'CALL_PY_APP_RESCHEDULING_API'?: JobDataCallPyAppReschedulingApiDto;
    /**
     * 
     * @type {JobDataRunBackplanningDto}
     * @memberof JobDataSchemaMap
     */
    'RUN_BACKPLANNING'?: JobDataRunBackplanningDto;
    /**
     * 
     * @type {JobDataCallPyAppBackplanningApiDto}
     * @memberof JobDataSchemaMap
     */
    'CALL_PY_APP_BACKPLANNING_API'?: JobDataCallPyAppBackplanningApiDto;
    /**
     * 
     * @type {JobDataValidateRxBulkDto}
     * @memberof JobDataSchemaMap
     */
    'VALIDATE_RX_BULK'?: JobDataValidateRxBulkDto;
    /**
     * 
     * @type {JobDataRunRxValidationBulkDto}
     * @memberof JobDataSchemaMap
     */
    'RUN_RX_VALIDATION_BULK'?: JobDataRunRxValidationBulkDto;
    /**
     * 
     * @type {JobDataPdfLoadTestAggregatorDto}
     * @memberof JobDataSchemaMap
     */
    'PDF_LOAD_TEST_AGGREGATOR'?: JobDataPdfLoadTestAggregatorDto;
    /**
     * 
     * @type {JobDataGenerateBillPdfDto}
     * @memberof JobDataSchemaMap
     */
    'GENERATE_BILL_PDF'?: JobDataGenerateBillPdfDto;
    /**
     * 
     * @type {JobDataBillPdfBatchAggregatorDto}
     * @memberof JobDataSchemaMap
     */
    'BILL_PDF_BATCH_AGGREGATOR'?: JobDataBillPdfBatchAggregatorDto;
    /**
     * 
     * @type {JobDataPrepBillPdfDataDto}
     * @memberof JobDataSchemaMap
     */
    'PREP_BILL_PDF_DATA'?: JobDataPrepBillPdfDataDto;
    /**
     * 
     * @type {JobDataRenderBillPdfDto}
     * @memberof JobDataSchemaMap
     */
    'RENDER_BILL_PDF'?: JobDataRenderBillPdfDto;
    /**
     * 
     * @type {JobDataPersistBillPdfDocumentDto}
     * @memberof JobDataSchemaMap
     */
    'PERSIST_BILL_PDF_DOCUMENT'?: JobDataPersistBillPdfDocumentDto;
    /**
     * 
     * @type {JobDataBillPdfMultiStepAggregatorDto}
     * @memberof JobDataSchemaMap
     */
    'BILL_PDF_MULTI_STEP_AGGREGATOR'?: JobDataBillPdfMultiStepAggregatorDto;
}
/**
 * 
 * @export
 * @interface JobDataValidateRxBulkDto
 */
export interface JobDataValidateRxBulkDto {
    /**
     * Unique workflow instance ID
     * @type {string}
     * @memberof JobDataValidateRxBulkDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowName}
     * @memberof JobDataValidateRxBulkDto
     */
    'workflowName': WorkflowName;
    /**
     * Current workflow phase ID for this job
     * @type {string}
     * @memberof JobDataValidateRxBulkDto
     */
    'phase': string;
    /**
     * 
     * @type {WorkflowRedisKeys}
     * @memberof JobDataValidateRxBulkDto
     */
    'workflowRedisKeys': WorkflowRedisKeys;
}


/**
 * 
 * @export
 * @interface JobErrorDto
 */
export interface JobErrorDto {
    /**
     * 
     * @type {string}
     * @memberof JobErrorDto
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof JobErrorDto
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface JobProgressDto
 */
export interface JobProgressDto {
    /**
     * 
     * @type {string}
     * @memberof JobProgressDto
     */
    'workflowId': string;
    /**
     * 
     * @type {string}
     * @memberof JobProgressDto
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof JobProgressDto
     */
    'phase': string;
    /**
     * 
     * @type {number}
     * @memberof JobProgressDto
     */
    'percent': number;
    /**
     * 
     * @type {string}
     * @memberof JobProgressDto
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const JobQueueName = {
    Workflow: 'workflow',
    Internal: 'internal',
    External: 'external',
    Pdf: 'pdf'
} as const;

export type JobQueueName = typeof JobQueueName[keyof typeof JobQueueName];


/**
 * 
 * @export
 * @interface JobResultAppointmentSuggestionDto
 */
export interface JobResultAppointmentSuggestionDto {
    /**
     * 
     * @type {APPOINTMENTSUGGESTIONJobName}
     * @memberof JobResultAppointmentSuggestionDto
     */
    'jobName': APPOINTMENTSUGGESTIONJobName;
    /**
     * 
     * @type {SolutionDto}
     * @memberof JobResultAppointmentSuggestionDto
     */
    'data': SolutionDto;
}


/**
 * 
 * @export
 * @interface JobResultAvailabilityRequestForPatientDto
 */
export interface JobResultAvailabilityRequestForPatientDto {
    /**
     * 
     * @type {AVAILABILITYREQUESTFORPATIENTJobName}
     * @memberof JobResultAvailabilityRequestForPatientDto
     */
    'jobName': AVAILABILITYREQUESTFORPATIENTJobName;
    /**
     * 
     * @type {ParsedPatientAvailabilityDto}
     * @memberof JobResultAvailabilityRequestForPatientDto
     */
    'data': ParsedPatientAvailabilityDto;
}


/**
 * 
 * @export
 * @interface JobResultBillPdfBatchAggregatorDto
 */
export interface JobResultBillPdfBatchAggregatorDto {
    /**
     * 
     * @type {BILLPDFBATCHAGGREGATORJobName}
     * @memberof JobResultBillPdfBatchAggregatorDto
     */
    'jobName': BILLPDFBATCHAGGREGATORJobName;
    /**
     * 
     * @type {BillPdfBatchAggregatorJobResultDto}
     * @memberof JobResultBillPdfBatchAggregatorDto
     */
    'data': BillPdfBatchAggregatorJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultBillPdfMultiStepAggregatorDto
 */
export interface JobResultBillPdfMultiStepAggregatorDto {
    /**
     * 
     * @type {BILLPDFMULTISTEPAGGREGATORJobName}
     * @memberof JobResultBillPdfMultiStepAggregatorDto
     */
    'jobName': BILLPDFMULTISTEPAGGREGATORJobName;
    /**
     * 
     * @type {BillPdfWorkflowAggregatorJobResultDto}
     * @memberof JobResultBillPdfMultiStepAggregatorDto
     */
    'data': BillPdfWorkflowAggregatorJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultCallPyAppBackplanningApiDto
 */
export interface JobResultCallPyAppBackplanningApiDto {
    /**
     * 
     * @type {CALLPYAPPBACKPLANNINGAPIJobName}
     * @memberof JobResultCallPyAppBackplanningApiDto
     */
    'jobName': CALLPYAPPBACKPLANNINGAPIJobName;
    /**
     * 
     * @type {ScheduleAgentResultDto}
     * @memberof JobResultCallPyAppBackplanningApiDto
     */
    'data': ScheduleAgentResultDto;
}


/**
 * 
 * @export
 * @interface JobResultCallPyAppPatientAvailabilityApiDto
 */
export interface JobResultCallPyAppPatientAvailabilityApiDto {
    /**
     * 
     * @type {CALLPYAPPPATIENTAVAILABILITYAPIJobName}
     * @memberof JobResultCallPyAppPatientAvailabilityApiDto
     */
    'jobName': CALLPYAPPPATIENTAVAILABILITYAPIJobName;
    /**
     * 
     * @type {PatientAvailabilityAgentResponseDto}
     * @memberof JobResultCallPyAppPatientAvailabilityApiDto
     */
    'data': PatientAvailabilityAgentResponseDto;
}


/**
 * 
 * @export
 * @interface JobResultCallPyAppReschedulingApiDto
 */
export interface JobResultCallPyAppReschedulingApiDto {
    /**
     * 
     * @type {CALLPYAPPRESCHEDULINGAPIJobName}
     * @memberof JobResultCallPyAppReschedulingApiDto
     */
    'jobName': CALLPYAPPRESCHEDULINGAPIJobName;
    /**
     * 
     * @type {ScheduleAgentResultDto}
     * @memberof JobResultCallPyAppReschedulingApiDto
     */
    'data': ScheduleAgentResultDto;
}


/**
 * 
 * @export
 * @interface JobResultCallPyAppSchedulingApiDto
 */
export interface JobResultCallPyAppSchedulingApiDto {
    /**
     * 
     * @type {CALLPYAPPSCHEDULINGAPIJobName}
     * @memberof JobResultCallPyAppSchedulingApiDto
     */
    'jobName': CALLPYAPPSCHEDULINGAPIJobName;
    /**
     * 
     * @type {SolutionDto}
     * @memberof JobResultCallPyAppSchedulingApiDto
     */
    'data': SolutionDto;
}


/**
 * 
 * @export
 * @interface JobResultGenerateBillPdfDto
 */
export interface JobResultGenerateBillPdfDto {
    /**
     * 
     * @type {GENERATEBILLPDFJobName}
     * @memberof JobResultGenerateBillPdfDto
     */
    'jobName': GENERATEBILLPDFJobName;
    /**
     * 
     * @type {GenerateBillPdfJobResultDto}
     * @memberof JobResultGenerateBillPdfDto
     */
    'data': GenerateBillPdfJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultGeneratePdfReportDto
 */
export interface JobResultGeneratePdfReportDto {
    /**
     * 
     * @type {GENERATEPDFREPORTJobName}
     * @memberof JobResultGeneratePdfReportDto
     */
    'jobName': GENERATEPDFREPORTJobName;
    /**
     * 
     * @type {GeneratePdfJobResultDto}
     * @memberof JobResultGeneratePdfReportDto
     */
    'data': GeneratePdfJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultGetAppointmentStateForPatientDto
 */
export interface JobResultGetAppointmentStateForPatientDto {
    /**
     * 
     * @type {GETAPPOINTMENTSTATEFORPATIENTJobName}
     * @memberof JobResultGetAppointmentStateForPatientDto
     */
    'jobName': GETAPPOINTMENTSTATEFORPATIENTJobName;
    /**
     * 
     * @type {StateForPatientDto}
     * @memberof JobResultGetAppointmentStateForPatientDto
     */
    'data': StateForPatientDto;
}


/**
 * 
 * @export
 * @interface JobResultPdfLoadTestAggregatorDto
 */
export interface JobResultPdfLoadTestAggregatorDto {
    /**
     * 
     * @type {PDFLOADTESTAGGREGATORJobName}
     * @memberof JobResultPdfLoadTestAggregatorDto
     */
    'jobName': PDFLOADTESTAGGREGATORJobName;
    /**
     * 
     * @type {GeneratePdfJobResultDto}
     * @memberof JobResultPdfLoadTestAggregatorDto
     */
    'data': GeneratePdfJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultPersistBillPdfDocumentDto
 */
export interface JobResultPersistBillPdfDocumentDto {
    /**
     * 
     * @type {PERSISTBILLPDFDOCUMENTJobName}
     * @memberof JobResultPersistBillPdfDocumentDto
     */
    'jobName': PERSISTBILLPDFDOCUMENTJobName;
    /**
     * 
     * @type {PersistBillPdfDocumentJobResultDto}
     * @memberof JobResultPersistBillPdfDocumentDto
     */
    'data': PersistBillPdfDocumentJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultPrepBillPdfDataDto
 */
export interface JobResultPrepBillPdfDataDto {
    /**
     * 
     * @type {PREPBILLPDFDATAJobName}
     * @memberof JobResultPrepBillPdfDataDto
     */
    'jobName': PREPBILLPDFDATAJobName;
    /**
     * 
     * @type {PrepBillPdfDataJobResultDto}
     * @memberof JobResultPrepBillPdfDataDto
     */
    'data': PrepBillPdfDataJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultRenderBillPdfDto
 */
export interface JobResultRenderBillPdfDto {
    /**
     * 
     * @type {RENDERBILLPDFJobName}
     * @memberof JobResultRenderBillPdfDto
     */
    'jobName': RENDERBILLPDFJobName;
    /**
     * 
     * @type {RenderBillPdfJobResultDto}
     * @memberof JobResultRenderBillPdfDto
     */
    'data': RenderBillPdfJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultReschedulingAgentDto
 */
export interface JobResultReschedulingAgentDto {
    /**
     * 
     * @type {RESCHEDULINGAGENTJobName}
     * @memberof JobResultReschedulingAgentDto
     */
    'jobName': RESCHEDULINGAGENTJobName;
    /**
     * 
     * @type {ScheduleAgentResultDto}
     * @memberof JobResultReschedulingAgentDto
     */
    'data': ScheduleAgentResultDto;
}


/**
 * 
 * @export
 * @interface JobResultRunAiAgentDto
 */
export interface JobResultRunAiAgentDto {
    /**
     * 
     * @type {RUNAIAGENTJobName}
     * @memberof JobResultRunAiAgentDto
     */
    'jobName': RUNAIAGENTJobName;
    /**
     * 
     * @type {AiAgentChatJobResultDto}
     * @memberof JobResultRunAiAgentDto
     */
    'data': AiAgentChatJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultRunBackplanningDto
 */
export interface JobResultRunBackplanningDto {
    /**
     * 
     * @type {RUNBACKPLANNINGJobName}
     * @memberof JobResultRunBackplanningDto
     */
    'jobName': RUNBACKPLANNINGJobName;
    /**
     * 
     * @type {ScheduleAgentResultDto}
     * @memberof JobResultRunBackplanningDto
     */
    'data': ScheduleAgentResultDto;
}


/**
 * 
 * @export
 * @interface JobResultRunRxValidationBulkDto
 */
export interface JobResultRunRxValidationBulkDto {
    /**
     * 
     * @type {RUNRXVALIDATIONBULKJobName}
     * @memberof JobResultRunRxValidationBulkDto
     */
    'jobName': RUNRXVALIDATIONBULKJobName;
    /**
     * 
     * @type {RxValidationBulkJobResultDto}
     * @memberof JobResultRunRxValidationBulkDto
     */
    'data': RxValidationBulkJobResultDto;
}


/**
 * 
 * @export
 * @interface JobResultSchemaMap
 */
export interface JobResultSchemaMap {
    /**
     * 
     * @type {JobResultGetAppointmentStateForPatientDto}
     * @memberof JobResultSchemaMap
     */
    'GET_APPOINTMENT_STATE_FOR_PATIENT'?: JobResultGetAppointmentStateForPatientDto;
    /**
     * 
     * @type {JobResultCallPyAppSchedulingApiDto}
     * @memberof JobResultSchemaMap
     */
    'CALL_PY_APP_SCHEDULING_API'?: JobResultCallPyAppSchedulingApiDto;
    /**
     * 
     * @type {JobResultGeneratePdfReportDto}
     * @memberof JobResultSchemaMap
     */
    'GENERATE_PDF_REPORT'?: JobResultGeneratePdfReportDto;
    /**
     * 
     * @type {JobResultAppointmentSuggestionDto}
     * @memberof JobResultSchemaMap
     */
    'APPOINTMENT_SUGGESTION'?: JobResultAppointmentSuggestionDto;
    /**
     * 
     * @type {JobResultRunAiAgentDto}
     * @memberof JobResultSchemaMap
     */
    'RUN_AI_AGENT'?: JobResultRunAiAgentDto;
    /**
     * 
     * @type {JobResultAvailabilityRequestForPatientDto}
     * @memberof JobResultSchemaMap
     */
    'AVAILABILITY_REQUEST_FOR_PATIENT'?: JobResultAvailabilityRequestForPatientDto;
    /**
     * 
     * @type {JobResultCallPyAppPatientAvailabilityApiDto}
     * @memberof JobResultSchemaMap
     */
    'CALL_PY_APP_PATIENT_AVAILABILITY_API'?: JobResultCallPyAppPatientAvailabilityApiDto;
    /**
     * 
     * @type {JobResultReschedulingAgentDto}
     * @memberof JobResultSchemaMap
     */
    'RESCHEDULING_AGENT'?: JobResultReschedulingAgentDto;
    /**
     * 
     * @type {JobResultCallPyAppReschedulingApiDto}
     * @memberof JobResultSchemaMap
     */
    'CALL_PY_APP_RESCHEDULING_API'?: JobResultCallPyAppReschedulingApiDto;
    /**
     * 
     * @type {JobResultRunBackplanningDto}
     * @memberof JobResultSchemaMap
     */
    'RUN_BACKPLANNING'?: JobResultRunBackplanningDto;
    /**
     * 
     * @type {JobResultCallPyAppBackplanningApiDto}
     * @memberof JobResultSchemaMap
     */
    'CALL_PY_APP_BACKPLANNING_API'?: JobResultCallPyAppBackplanningApiDto;
    /**
     * 
     * @type {JobResultValidateRxBulkDto}
     * @memberof JobResultSchemaMap
     */
    'VALIDATE_RX_BULK'?: JobResultValidateRxBulkDto;
    /**
     * 
     * @type {JobResultRunRxValidationBulkDto}
     * @memberof JobResultSchemaMap
     */
    'RUN_RX_VALIDATION_BULK'?: JobResultRunRxValidationBulkDto;
    /**
     * 
     * @type {JobResultPdfLoadTestAggregatorDto}
     * @memberof JobResultSchemaMap
     */
    'PDF_LOAD_TEST_AGGREGATOR'?: JobResultPdfLoadTestAggregatorDto;
    /**
     * 
     * @type {JobResultGenerateBillPdfDto}
     * @memberof JobResultSchemaMap
     */
    'GENERATE_BILL_PDF'?: JobResultGenerateBillPdfDto;
    /**
     * 
     * @type {JobResultBillPdfBatchAggregatorDto}
     * @memberof JobResultSchemaMap
     */
    'BILL_PDF_BATCH_AGGREGATOR'?: JobResultBillPdfBatchAggregatorDto;
    /**
     * 
     * @type {JobResultPrepBillPdfDataDto}
     * @memberof JobResultSchemaMap
     */
    'PREP_BILL_PDF_DATA'?: JobResultPrepBillPdfDataDto;
    /**
     * 
     * @type {JobResultRenderBillPdfDto}
     * @memberof JobResultSchemaMap
     */
    'RENDER_BILL_PDF'?: JobResultRenderBillPdfDto;
    /**
     * 
     * @type {JobResultPersistBillPdfDocumentDto}
     * @memberof JobResultSchemaMap
     */
    'PERSIST_BILL_PDF_DOCUMENT'?: JobResultPersistBillPdfDocumentDto;
    /**
     * 
     * @type {JobResultBillPdfMultiStepAggregatorDto}
     * @memberof JobResultSchemaMap
     */
    'BILL_PDF_MULTI_STEP_AGGREGATOR'?: JobResultBillPdfMultiStepAggregatorDto;
}
/**
 * 
 * @export
 * @interface JobResultValidateRxBulkDto
 */
export interface JobResultValidateRxBulkDto {
    /**
     * 
     * @type {VALIDATERXBULKJobName}
     * @memberof JobResultValidateRxBulkDto
     */
    'jobName': VALIDATERXBULKJobName;
    /**
     * 
     * @type {RxValidationBulkJobResultDto}
     * @memberof JobResultValidateRxBulkDto
     */
    'data': RxValidationBulkJobResultDto;
}


/**
 * 
 * @export
 * @interface KontakInfoDto
 */
export interface KontakInfoDto {
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'salutation'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'firstNames'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'phone1'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof KontakInfoDto
     */
    'bic'?: string;
}
/**
 * 
 * @export
 * @interface KostentraegerCreatedDto
 */
export interface KostentraegerCreatedDto {
    /**
     * 
     * @type {string}
     * @memberof KostentraegerCreatedDto
     */
    'id': string;
    /**
     * Whether a Payer entity was also created (non-GKV).
     * @type {boolean}
     * @memberof KostentraegerCreatedDto
     */
    'payerCreated': boolean;
}
/**
 * 
 * @export
 * @interface KostentraegerImportResultDto
 */
export interface KostentraegerImportResultDto {
    /**
     * Timestamp/id of this upload batch (YYYY-MM-DDTHH-mm-ss).
     * @type {string}
     * @memberof KostentraegerImportResultDto
     */
    'uploadDate': string;
    /**
     * Number of EDIFACT files that were imported.
     * @type {number}
     * @memberof KostentraegerImportResultDto
     */
    'files': number;
    /**
     * Number of Payer (Kostenträger) records written.
     * @type {number}
     * @memberof KostentraegerImportResultDto
     */
    'payers': number;
    /**
     * Number of billing-center records written.
     * @type {number}
     * @memberof KostentraegerImportResultDto
     */
    'billingCenters': number;
    /**
     * Number of insurer (insurance-card) records written.
     * @type {number}
     * @memberof KostentraegerImportResultDto
     */
    'insuranceCards': number;
}
/**
 * 
 * @export
 * @interface KostentraegerUploadDto
 */
export interface KostentraegerUploadDto {
    /**
     * Upload batch id (YYYY-MM-DDTHH-mm-ss).
     * @type {string}
     * @memberof KostentraegerUploadDto
     */
    'uploadDate': string;
    /**
     * How many files were stored in this batch.
     * @type {number}
     * @memberof KostentraegerUploadDto
     */
    'fileCount': number;
    /**
     * The stored file names.
     * @type {Array<string>}
     * @memberof KostentraegerUploadDto
     */
    'files': Array<string>;
}
/**
 * 
 * @export
 * @interface KpiAnalyticsDto
 */
export interface KpiAnalyticsDto {
    /**
     * Total number of bills in current period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'totalBills': number;
    /**
     * Total number of bills in previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'totalBillsLastPeriod': number;
    /**
     * Percentage growth in bills compared to previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'billsGrowthPercentage': number;
    /**
     * Total amount in current period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'totalAmount': number;
    /**
     * Total amount in previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'totalAmountLastPeriod': number;
    /**
     * Percentage growth in amount compared to previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'amountGrowthPercentage': number;
    /**
     * Total number of prescriptions (Rxs) in current period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'totalRxs': number;
    /**
     * Total number of prescriptions (Rxs) in previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'totalRxsLastPeriod': number;
    /**
     * Percentage growth in Rxs compared to previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'rxsGrowthPercentage': number;
    /**
     * Number of unique payers in current period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'uniquePayersCount': number;
    /**
     * Number of unique payers in previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'uniquePayersLastPeriod': number;
    /**
     * Percentage growth in unique payers compared to previous period
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'payersGrowthPercentage': number;
    /**
     * Number of bills started (START status)
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'billsStarted': number;
    /**
     * Number of bills currently in progress (OPEN status)
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'billsInProgress': number;
    /**
     * Number of bills completed (PREVIOUS status)
     * @type {number}
     * @memberof KpiAnalyticsDto
     */
    'billsCompleted': number;
}
/**
 * 
 * @export
 * @interface LeaveOfAbsenceDto
 */
export interface LeaveOfAbsenceDto {
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'loAType'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof LeaveOfAbsenceDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveOfAbsenceDto
     */
    'locationId'?: string | null;
}
/**
 * 
 * @export
 * @interface LifespanDeltas
 */
export interface LifespanDeltas {
    /**
     * 
     * @type {number}
     * @memberof LifespanDeltas
     */
    'rxDateToBooking': number;
    /**
     * 
     * @type {number}
     * @memberof LifespanDeltas
     */
    'firstTreatmentToBooking': number;
    /**
     * 
     * @type {number}
     * @memberof LifespanDeltas
     */
    'lastTreatmentToBooking': number;
}
/**
 * 
 * @export
 * @interface LineItemDto
 */
export interface LineItemDto {
    /**
     * 
     * @type {string}
     * @memberof LineItemDto
     */
    'priceId': string;
    /**
     * 
     * @type {string}
     * @memberof LineItemDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof LineItemDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof LineItemDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof LineItemDto
     */
    'copayment': number;
    /**
     * 
     * @type {boolean}
     * @memberof LineItemDto
     */
    'isCopaymentExempted': boolean;
    /**
     * 
     * @type {string}
     * @memberof LineItemDto
     */
    'abbreviation': string;
    /**
     * 
     * @type {string}
     * @memberof LineItemDto
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof LineItemDto
     */
    'fromAppointment': boolean;
}
/**
 * 
 * @export
 * @interface ListAgentsResponseDto
 */
export interface ListAgentsResponseDto {
    /**
     * List of available agent names
     * @type {Array<string>}
     * @memberof ListAgentsResponseDto
     */
    'agents': Array<string>;
}
/**
 * 
 * @export
 * @interface LocationDetailDto
 */
export interface LocationDetailDto {
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {AccountDto}
     * @memberof LocationDetailDto
     */
    'primaryAccount'?: AccountDto;
    /**
     * 
     * @type {Array<AccountDto>}
     * @memberof LocationDetailDto
     */
    'accounts'?: Array<AccountDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof LocationDetailDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface LocationDto
 */
export interface LocationDto {
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'name': string;
    /**
     * 
     * @type {AccountDto}
     * @memberof LocationDto
     */
    'primaryAccount': AccountDto;
    /**
     * 
     * @type {Array<AccountDto>}
     * @memberof LocationDto
     */
    'accounts': Array<AccountDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof LocationDto
     */
    'address': AddressDto;
}
/**
 * 
 * @export
 * @interface LocationLeaveOfAbsenceDto
 */
export interface LocationLeaveOfAbsenceDto {
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'userId': string;
    /**
     * First and last name of the absent user.
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'loAType': string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeaveOfAbsenceDto
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface LogoutResponseDto
 */
export interface LogoutResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LogoutResponseDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface LunchBreakDto
 */
export interface LunchBreakDto {
    /**
     * 
     * @type {string}
     * @memberof LunchBreakDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LunchBreakDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LunchBreakDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof LunchBreakDto
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface MandateDocumentVersionDto
 */
export interface MandateDocumentVersionDto {
    /**
     * Sequential version number (1-based).
     * @type {number}
     * @memberof MandateDocumentVersionDto
     */
    'version': number;
    /**
     * The date the debtor signed this version.
     * @type {string}
     * @memberof MandateDocumentVersionDto
     */
    'signatureDate': string;
    /**
     * When this version was confirmed as signed.
     * @type {string}
     * @memberof MandateDocumentVersionDto
     */
    'confirmedAt': string;
    /**
     * Name of the user who confirmed this version.
     * @type {string}
     * @memberof MandateDocumentVersionDto
     */
    'confirmedByName'?: string | null;
    /**
     * Id of the stored signed document for this version (for download).
     * @type {string}
     * @memberof MandateDocumentVersionDto
     */
    'documentId'?: string | null;
}
/**
 * 
 * @export
 * @interface MandateSummaryDto
 */
export interface MandateSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'status': MandateSummaryDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'sequenceType': MandateSummaryDtoSequenceTypeEnum;
    /**
     * SEPA mandate reference (MndtId) printed on the form and exported unchanged.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'mandateReference'?: string | null;
    /**
     * For one-off mandates: the Rx this single authorization pays.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'rxId'?: string | null;
    /**
     * Human-readable Rx number for display (never the UUID).
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'rxNumber'?: string | null;
    /**
     * Version number of the currently attached signed document (0 = none).
     * @type {number}
     * @memberof MandateSummaryDto
     */
    'documentVersion'?: number;
    /**
     * Creditor account (Mandant) id.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'accountId': string;
    /**
     * Creditor account (Mandant) name.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'accountName'?: string;
    /**
     * Date the mandate was signed.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'signedDate'?: string | null;
    /**
     * Mandate validity end date.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'validUntil'?: string | null;
    /**
     * When the mandate was revoked (null while active).
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'revokedAt'?: string | null;
    /**
     * Reason / source recorded when the mandate was revoked.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'revocationReason'?: string | null;
    /**
     * When the mandate was created.
     * @type {string}
     * @memberof MandateSummaryDto
     */
    'createdAt'?: string;
    /**
     * Immutable signed-document version history, newest first.
     * @type {Array<MandateDocumentVersionDto>}
     * @memberof MandateSummaryDto
     */
    'documentVersions'?: Array<MandateDocumentVersionDto>;
}

export const MandateSummaryDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Used: 'USED',
    Revoked: 'REVOKED',
    Expired: 'EXPIRED'
} as const;

export type MandateSummaryDtoStatusEnum = typeof MandateSummaryDtoStatusEnum[keyof typeof MandateSummaryDtoStatusEnum];
export const MandateSummaryDtoSequenceTypeEnum = {
    Ooff: 'OOFF',
    Rcur: 'RCUR'
} as const;

export type MandateSummaryDtoSequenceTypeEnum = typeof MandateSummaryDtoSequenceTypeEnum[keyof typeof MandateSummaryDtoSequenceTypeEnum];

/**
 * 
 * @export
 * @interface MergeClinicTargetUpdateDto
 */
export interface MergeClinicTargetUpdateDto {
    /**
     * Official BSNR to set on the retained clinic (9 digits)
     * @type {string}
     * @memberof MergeClinicTargetUpdateDto
     */
    'BSNR'?: string;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof MergeClinicTargetUpdateDto
     */
    'contactInfo'?: ContactInfoDTO;
    /**
     * 
     * @type {string}
     * @memberof MergeClinicTargetUpdateDto
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof MergeClinicTargetUpdateDto
     */
    'methodForDrReport'?: MergeClinicTargetUpdateDtoMethodForDrReportEnum;
    /**
     * 
     * @type {string}
     * @memberof MergeClinicTargetUpdateDto
     */
    'methodForRxOrder'?: MergeClinicTargetUpdateDtoMethodForRxOrderEnum;
}

export const MergeClinicTargetUpdateDtoMethodForDrReportEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type MergeClinicTargetUpdateDtoMethodForDrReportEnum = typeof MergeClinicTargetUpdateDtoMethodForDrReportEnum[keyof typeof MergeClinicTargetUpdateDtoMethodForDrReportEnum];
export const MergeClinicTargetUpdateDtoMethodForRxOrderEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type MergeClinicTargetUpdateDtoMethodForRxOrderEnum = typeof MergeClinicTargetUpdateDtoMethodForRxOrderEnum[keyof typeof MergeClinicTargetUpdateDtoMethodForRxOrderEnum];

/**
 * 
 * @export
 * @interface MergeClinicsDto
 */
export interface MergeClinicsDto {
    /**
     * ID of the clinic to keep (retained / target)
     * @type {string}
     * @memberof MergeClinicsDto
     */
    'targetId': string;
    /**
     * ID of the duplicate clinic to merge in and delete (source)
     * @type {string}
     * @memberof MergeClinicsDto
     */
    'sourceId': string;
    /**
     * 
     * @type {MergeClinicTargetUpdateDto}
     * @memberof MergeClinicsDto
     */
    'updatedTarget'?: MergeClinicTargetUpdateDto;
}
/**
 * 
 * @export
 * @interface MergeDoctorTargetUpdateDto
 */
export interface MergeDoctorTargetUpdateDto {
    /**
     * Official LANR to set on the retained doctor (9 digits)
     * @type {string}
     * @memberof MergeDoctorTargetUpdateDto
     */
    'LANR'?: string;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof MergeDoctorTargetUpdateDto
     */
    'contactInfo'?: ContactInfoDTO;
}
/**
 * 
 * @export
 * @interface MergeDoctorsDto
 */
export interface MergeDoctorsDto {
    /**
     * ID of the doctor to keep (retained / target)
     * @type {string}
     * @memberof MergeDoctorsDto
     */
    'targetId': string;
    /**
     * ID of the duplicate doctor to merge in and delete (source)
     * @type {string}
     * @memberof MergeDoctorsDto
     */
    'sourceId': string;
    /**
     * 
     * @type {MergeDoctorTargetUpdateDto}
     * @memberof MergeDoctorsDto
     */
    'updatedTarget'?: MergeDoctorTargetUpdateDto;
}
/**
 * 
 * @export
 * @interface MergeDocumentsRequestDto
 */
export interface MergeDocumentsRequestDto {
    /**
     * Document IDs of paper receipts
     * @type {Array<string>}
     * @memberof MergeDocumentsRequestDto
     */
    'paperDocumentIds'?: Array<string>;
    /**
     * Document IDs of bill PDFs
     * @type {Array<string>}
     * @memberof MergeDocumentsRequestDto
     */
    'billDocumentIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MergeDocumentsResponseDto
 */
export interface MergeDocumentsResponseDto {
    /**
     * 
     * @type {MergedDocumentPayloadDto}
     * @memberof MergeDocumentsResponseDto
     */
    'paperMerged'?: MergedDocumentPayloadDto;
    /**
     * 
     * @type {MergedDocumentPayloadDto}
     * @memberof MergeDocumentsResponseDto
     */
    'billMerged'?: MergedDocumentPayloadDto;
}
/**
 * 
 * @export
 * @interface MergedDocumentPayloadDto
 */
export interface MergedDocumentPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof MergedDocumentPayloadDto
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedDocumentPayloadDto
     */
    'contentType': string;
    /**
     * Base64 encoded PDF
     * @type {string}
     * @memberof MergedDocumentPayloadDto
     */
    'base64Data': string;
}
/**
 * 
 * @export
 * @interface MethodLineItemDto
 */
export interface MethodLineItemDto {
    /**
     * 
     * @type {string}
     * @memberof MethodLineItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MethodLineItemDto
     */
    'abbreviation': string;
    /**
     * 
     * @type {string}
     * @memberof MethodLineItemDto
     */
    'lineItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodLineItemDto
     */
    'tarifGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodLineItemDto
     */
    'therapyType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MethodLineItemDto
     */
    'inUse': boolean;
}
/**
 * 
 * @export
 * @interface MethodTermRefDto
 */
export interface MethodTermRefDto {
    /**
     * 
     * @type {string}
     * @memberof MethodTermRefDto
     */
    'prescribedTherapyId': string;
    /**
     * 
     * @type {string}
     * @memberof MethodTermRefDto
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof MethodTermRefDto
     */
    'priority': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MethodTermRefDto
     */
    'aliases': Array<string>;
}
/**
 * 
 * @export
 * @interface MinifiedDocumentDtoUser
 */
export interface MinifiedDocumentDtoUser {
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'nickName'?: string;
    /**
     * 
     * @type {BusinessDto}
     * @memberof MinifiedDocumentDtoUser
     */
    'business'?: BusinessDto;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'locationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'therapistLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'therapist'?: string;
    /**
     * 
     * @type {Array<TherapyDtoForUser>}
     * @memberof MinifiedDocumentDtoUser
     */
    'therapies'?: Array<TherapyDtoForUser>;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof MinifiedDocumentDtoUser
     */
    'roles'?: Array<RoleDto>;
    /**
     * 
     * @type {Array<PermissionDto>}
     * @memberof MinifiedDocumentDtoUser
     */
    'permissions'?: Array<PermissionDto>;
    /**
     * Discipline of a NEW therapist. Decides the default therapy grants at creation: Ergotherapie grants every ergo line item (ergo therapists are not certificate-gated), Physiotherapie (and omitted, for backward compatibility) grants the \'Alle Physiotherapeuten\' set. Ignored on updates — grants are managed on the Fortbildungen screen after creation.
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'therapistDiscipline'?: MinifiedDocumentDtoUserTherapistDisciplineEnum;
    /**
     * Last working day of the user
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'lastWorkDay'?: string;
    /**
     * Annual vacation entitlement in days
     * @type {number}
     * @memberof MinifiedDocumentDtoUser
     */
    'vacationDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'punchInTime'?: string | null;
    /**
     * Calendar column position for the requested location; lower ranks are shown further left
     * @type {number}
     * @memberof MinifiedDocumentDtoUser
     */
    'columnSortRank'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MinifiedDocumentDtoUser
     */
    'deletedAt'?: string;
}

export const MinifiedDocumentDtoUserTherapistDisciplineEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type MinifiedDocumentDtoUserTherapistDisciplineEnum = typeof MinifiedDocumentDtoUserTherapistDisciplineEnum[keyof typeof MinifiedDocumentDtoUserTherapistDisciplineEnum];

/**
 * 
 * @export
 * @interface MonthlyRxTrendDto
 */
export interface MonthlyRxTrendDto {
    /**
     * Month in YYYY-MM format
     * @type {string}
     * @memberof MonthlyRxTrendDto
     */
    'month': string;
    /**
     * Total number of prescriptions (Rxs)
     * @type {number}
     * @memberof MonthlyRxTrendDto
     */
    'totalRxs': number;
    /**
     * Breakdown by Rx type
     * @type {object}
     * @memberof MonthlyRxTrendDto
     */
    'rxTypes': object;
}
/**
 * 
 * @export
 * @interface MonthlyTransactionTrendDto
 */
export interface MonthlyTransactionTrendDto {
    /**
     * Month in YYYY-MM format
     * @type {string}
     * @memberof MonthlyTransactionTrendDto
     */
    'month': string;
    /**
     * Total number of transactions in this month
     * @type {number}
     * @memberof MonthlyTransactionTrendDto
     */
    'totalTransactions': number;
    /**
     * Total amount for this month
     * @type {number}
     * @memberof MonthlyTransactionTrendDto
     */
    'totalAmount': number;
    /**
     * Total number of prescriptions (Rxs)
     * @type {number}
     * @memberof MonthlyTransactionTrendDto
     */
    'totalRxs': number;
    /**
     * Number of unique payers
     * @type {number}
     * @memberof MonthlyTransactionTrendDto
     */
    'uniquePayersCount': number;
    /**
     * Completion rate as percentage
     * @type {number}
     * @memberof MonthlyTransactionTrendDto
     */
    'completionRate': number;
}
/**
 * 
 * @export
 * @interface NextAppointmentQueryItemDto
 */
export interface NextAppointmentQueryItemDto {
    /**
     * 
     * @type {number}
     * @memberof NextAppointmentQueryItemDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof NextAppointmentQueryItemDto
     */
    'appointmentId': string;
    /**
     * ISO start of the current appointment
     * @type {string}
     * @memberof NextAppointmentQueryItemDto
     */
    'currentStart': string;
}
/**
 * 
 * @export
 * @interface NextAppointmentResultDto
 */
export interface NextAppointmentResultDto {
    /**
     * 
     * @type {string}
     * @memberof NextAppointmentResultDto
     */
    'appointmentId': string;
    /**
     * 
     * @type {AppointmentDto}
     * @memberof NextAppointmentResultDto
     */
    'next'?: AppointmentDto | null;
}
/**
 * 
 * @export
 * @interface NoteDto
 */
export interface NoteDto {
    /**
     * UUID of a persisted user note. Absent (undefined) for system advisories, which are not persisted.
     * @type {string}
     * @memberof NoteDto
     */
    'id'?: string;
    /**
     * Discriminant: \'user\' for editable notes, \'system\' for read-only advisories.
     * @type {string}
     * @memberof NoteDto
     */
    'kind'?: NoteDtoKindEnum;
    /**
     * For system advisories only: the kind of domain object that produced it (e.g. \'copayment-exemption\').
     * @type {string}
     * @memberof NoteDto
     */
    'source'?: string;
    /**
     * For system advisories only: id of the source domain object. This is NOT a Note id and is not writable.
     * @type {string}
     * @memberof NoteDto
     */
    'sourceId'?: string;
    /**
     * 
     * @type {number}
     * @memberof NoteDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'text': string;
    /**
     * 
     * @type {UserDto}
     * @memberof NoteDto
     */
    'createdByUser'?: UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof NoteDto
     */
    'updatedByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'updatedAt'?: string;
    /**
     * Deprecated: prefer `kind === \'system\'`. True for read-only system advisories.
     * @type {boolean}
     * @memberof NoteDto
     * @deprecated
     */
    'isSystemNote'?: boolean;
}

export const NoteDtoKindEnum = {
    User: 'user',
    System: 'system'
} as const;

export type NoteDtoKindEnum = typeof NoteDtoKindEnum[keyof typeof NoteDtoKindEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const PDFLOADTESTAGGREGATORJobName = {
    PdfLoadTestAggregator: 'PDF_LOAD_TEST_AGGREGATOR'
} as const;

export type PDFLOADTESTAGGREGATORJobName = typeof PDFLOADTESTAGGREGATORJobName[keyof typeof PDFLOADTESTAGGREGATORJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const PERSISTBILLPDFDOCUMENTJobName = {
    PersistBillPdfDocument: 'PERSIST_BILL_PDF_DOCUMENT'
} as const;

export type PERSISTBILLPDFDOCUMENTJobName = typeof PERSISTBILLPDFDOCUMENTJobName[keyof typeof PERSISTBILLPDFDOCUMENTJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const PREPBILLPDFDATAJobName = {
    PrepBillPdfData: 'PREP_BILL_PDF_DATA'
} as const;

export type PREPBILLPDFDATAJobName = typeof PREPBILLPDFDATAJobName[keyof typeof PREPBILLPDFDATAJobName];


/**
 * 
 * @export
 * @interface PaginatedBaseTransactionDetailsDto
 */
export interface PaginatedBaseTransactionDetailsDto {
    /**
     * 
     * @type {Array<BaseTransactionDetailsDto>}
     * @memberof PaginatedBaseTransactionDetailsDto
     */
    'data': Array<BaseTransactionDetailsDto>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof PaginatedBaseTransactionDetailsDto
     */
    'meta': PaginationMeta;
    /**
     * 
     * @type {PaginationLinks}
     * @memberof PaginatedBaseTransactionDetailsDto
     */
    'links': PaginationLinks;
}
/**
 * 
 * @export
 * @interface PaginatedGetBankTransferDto
 */
export interface PaginatedGetBankTransferDto {
    /**
     * 
     * @type {Array<GetBankTransferDto>}
     * @memberof PaginatedGetBankTransferDto
     */
    'data': Array<GetBankTransferDto>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof PaginatedGetBankTransferDto
     */
    'meta': PaginationMeta;
    /**
     * 
     * @type {PaginationLinks}
     * @memberof PaginatedGetBankTransferDto
     */
    'links': PaginationLinks;
}
/**
 * 
 * @export
 * @interface PaginatedGetInsuranceTransactionDto
 */
export interface PaginatedGetInsuranceTransactionDto {
    /**
     * 
     * @type {Array<GetInsuranceTransactionDto>}
     * @memberof PaginatedGetInsuranceTransactionDto
     */
    'data': Array<GetInsuranceTransactionDto>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof PaginatedGetInsuranceTransactionDto
     */
    'meta': PaginationMeta;
    /**
     * 
     * @type {PaginationLinks}
     * @memberof PaginatedGetInsuranceTransactionDto
     */
    'links': PaginationLinks;
}
/**
 * 
 * @export
 * @interface PaginatedGetRechnungDto
 */
export interface PaginatedGetRechnungDto {
    /**
     * 
     * @type {Array<GetRechnungDetailsDto>}
     * @memberof PaginatedGetRechnungDto
     */
    'data': Array<GetRechnungDetailsDto>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof PaginatedGetRechnungDto
     */
    'meta': PaginationMeta;
    /**
     * 
     * @type {PaginationLinks}
     * @memberof PaginatedGetRechnungDto
     */
    'links': PaginationLinks;
}
/**
 * 
 * @export
 * @interface PaginationLinks
 */
export interface PaginationLinks {
    /**
     * 
     * @type {string}
     * @memberof PaginationLinks
     */
    'first': string;
    /**
     * 
     * @type {string}
     * @memberof PaginationLinks
     */
    'last': string;
    /**
     * 
     * @type {string}
     * @memberof PaginationLinks
     */
    'current': string;
    /**
     * 
     * @type {string}
     * @memberof PaginationLinks
     */
    'next': string;
    /**
     * 
     * @type {string}
     * @memberof PaginationLinks
     */
    'previous': string;
}
/**
 * 
 * @export
 * @interface PaginationMeta
 */
export interface PaginationMeta {
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'totalItems': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface PaginationMetadataDto
 */
export interface PaginationMetadataDto {
    /**
     * Number of items per page
     * @type {number}
     * @memberof PaginationMetadataDto
     */
    'limit': number;
    /**
     * Total number of transactions (if available)
     * @type {number}
     * @memberof PaginationMetadataDto
     */
    'total': number;
    /**
     * Whether more data is available
     * @type {boolean}
     * @memberof PaginationMetadataDto
     */
    'hasMore': boolean;
}
/**
 * 
 * @export
 * @interface ParsedPatientAvailabilityDto
 */
export interface ParsedPatientAvailabilityDto {
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof ParsedPatientAvailabilityDto
     */
    'patientAvailabilities': Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof ParsedPatientAvailabilityDto
     */
    'patientBlockedSlots': Array<BlockingSlotDto>;
}
/**
 * 
 * @export
 * @interface ParsedPatientAvailabilityLLMStepDto
 */
export interface ParsedPatientAvailabilityLLMStepDto {
    /**
     * Logical name of the step, e.g. \'parse_request\', \'summarize_for_user\'.
     * @type {string}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'stepName': string;
    /**
     * LLM call duration in milliseconds, if applicable.
     * @type {number}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'durationMs'?: number | null;
    /**
     * Model identifier used for this step, e.g. \"openai:gpt-5-nano-2025-08-07\".
     * @type {string}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'llmModel'?: string | null;
    /**
     * Short human-readable description of what input was given to the LLM.
     * @type {string}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'input': string;
    /**
     * 
     * @type {ParsedPatientAvailabilityLLMStepDtoOutput}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'output'?: ParsedPatientAvailabilityLLMStepDtoOutput | null;
    /**
     * More detailed explanation or reasoning notes for this step.
     * @type {string}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'explanation'?: string | null;
    /**
     * Small machine-readable payload: key data points, flags, etc.
     * @type {{ [key: string]: any; }}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * Error message if the step failed.
     * @type {string}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'errorMessage'?: string | null;
    /**
     * The unique identifier of the patient for whom the availability request is being processed.
     * @type {number}
     * @memberof ParsedPatientAvailabilityLLMStepDto
     */
    'patientId': number;
}
/**
 * Parsed patient availability with mapped availabilities and blocked slots.
 * @export
 * @interface ParsedPatientAvailabilityLLMStepDtoOutput
 */
export interface ParsedPatientAvailabilityLLMStepDtoOutput {
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof ParsedPatientAvailabilityLLMStepDtoOutput
     */
    'patientAvailabilities': Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof ParsedPatientAvailabilityLLMStepDtoOutput
     */
    'patientBlockedSlots': Array<BlockingSlotDto>;
}
/**
 * 
 * @export
 * @interface ParticipantDto
 */
export interface ParticipantDto {
    /**
     * 
     * @type {string}
     * @memberof ParticipantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantDto
     */
    'end'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParticipantDto
     */
    'attended'?: boolean;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof ParticipantDto
     */
    'timeSlots'?: Array<TimeSlotDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof ParticipantDto
     */
    'address'?: AddressDto;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityAgentRequestDto
 */
export interface PatientAvailabilityAgentRequestDto {
    /**
     * 
     * @type {AgentMetadataDto}
     * @memberof PatientAvailabilityAgentRequestDto
     */
    'metadata'?: AgentMetadataDto;
    /**
     * 
     * @type {PatientAvailabilityRequestDto}
     * @memberof PatientAvailabilityAgentRequestDto
     */
    'availabilityRequest': PatientAvailabilityRequestDto;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityAgentResponseDto
 */
export interface PatientAvailabilityAgentResponseDto {
    /**
     * The unique identifier of the patient for whom the availability request is being processed.
     * @type {number}
     * @memberof PatientAvailabilityAgentResponseDto
     */
    'patientId': number;
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof PatientAvailabilityAgentResponseDto
     */
    'availabilities'?: Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof PatientAvailabilityAgentResponseDto
     */
    'blockedSlots'?: Array<BlockingSlotDto>;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityAgentResponseDto
     */
    'responseMessage'?: string;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityDto
 */
export interface PatientAvailabilityDto {
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityDto
     */
    'groupId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientAvailabilityDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientAvailabilityDto
     */
    'dayOfWeek'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityDto
     */
    'validityStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityDto
     */
    'validityEnd'?: string | null;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityInfoDto
 */
export interface PatientAvailabilityInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityInfoDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityInfoDto
     */
    'patientName'?: string;
    /**
     * 
     * @type {Array<PatientAvailabilityWindowDto>}
     * @memberof PatientAvailabilityInfoDto
     */
    'availableWindows': Array<PatientAvailabilityWindowDto>;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityLLMStepDto
 */
export interface PatientAvailabilityLLMStepDto {
    /**
     * Logical name of the step, e.g. \'parse_request\', \'summarize_for_user\'.
     * @type {string}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'stepName': string;
    /**
     * LLM call duration in milliseconds, if applicable.
     * @type {number}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'durationMs'?: number | null;
    /**
     * Model identifier used for this step, e.g. \"openai:gpt-5-nano-2025-08-07\".
     * @type {string}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'llmModel'?: string | null;
    /**
     * Short human-readable description of what input was given to the LLM.
     * @type {string}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'input': string;
    /**
     * 
     * @type {PatientAvailabilityLLMStepDtoOutput}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'output'?: PatientAvailabilityLLMStepDtoOutput | null;
    /**
     * More detailed explanation or reasoning notes for this step.
     * @type {string}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'explanation'?: string | null;
    /**
     * Small machine-readable payload: key data points, flags, etc.
     * @type {{ [key: string]: any; }}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * Error message if the step failed.
     * @type {string}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'errorMessage'?: string | null;
    /**
     * The unique identifier of the patient for whom the availability request is being processed.
     * @type {number}
     * @memberof PatientAvailabilityLLMStepDto
     */
    'patientId': number;
}
/**
 * Parsed patient availability response.
 * @export
 * @interface PatientAvailabilityLLMStepDtoOutput
 */
export interface PatientAvailabilityLLMStepDtoOutput {
    /**
     * The unique identifier of the patient for whom the availability request is being processed.
     * @type {number}
     * @memberof PatientAvailabilityLLMStepDtoOutput
     */
    'patientId': number;
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof PatientAvailabilityLLMStepDtoOutput
     */
    'availabilities'?: Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof PatientAvailabilityLLMStepDtoOutput
     */
    'blockedSlots'?: Array<BlockingSlotDto>;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityLLMStepDtoOutput
     */
    'responseMessage'?: string;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityRequestDto
 */
export interface PatientAvailabilityRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityRequestDto
     */
    'requestString'?: string;
    /**
     * 
     * @type {Array<PatientAvailabilityDto>}
     * @memberof PatientAvailabilityRequestDto
     */
    'availabilities'?: Array<PatientAvailabilityDto>;
    /**
     * 
     * @type {Array<BlockingSlotDto>}
     * @memberof PatientAvailabilityRequestDto
     */
    'blockedSlots'?: Array<BlockingSlotDto>;
    /**
     * The unique identifier of the patient for whom the availability request is being made.
     * @type {number}
     * @memberof PatientAvailabilityRequestDto
     */
    'patientId': number;
}
/**
 * 
 * @export
 * @interface PatientAvailabilityWindowDto
 */
export interface PatientAvailabilityWindowDto {
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityWindowDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof PatientAvailabilityWindowDto
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface PatientBillInfoDto
 */
export interface PatientBillInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'rxId': string;
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'date': string | null;
    /**
     * 
     * @type {Array<TherapyInfoDto>}
     * @memberof PatientBillInfoDto
     */
    'therapies': Array<TherapyInfoDto>;
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'businessId': string;
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'tarifGroupId': string;
    /**
     * 
     * @type {number}
     * @memberof PatientBillInfoDto
     */
    'realPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PatientBillInfoDto
     */
    'estimatedPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof PatientBillInfoDto
     */
    'isEstimated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientBillInfoDto
     */
    'isTimeSlotZero': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientBillInfoDto
     */
    'isProvisionalPrice': boolean;
    /**
     * 
     * @type {number}
     * @memberof PatientBillInfoDto
     */
    'amountPaid': number;
    /**
     * 
     * @type {number}
     * @memberof PatientBillInfoDto
     */
    'dueAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PatientBillInfoDto
     */
    'insuranceTransactionNumber': string;
    /**
     * Whether the patient has a billing email (alternative-billing address email, falling back to the primary address email).
     * @type {boolean}
     * @memberof PatientBillInfoDto
     */
    'patientHasBillingEmail': boolean;
    /**
     * Whether the Rx is eligible for a refund (its processingStatus is not \'in Behandlung\'). An in-treatment refund needs a chief override.
     * @type {boolean}
     * @memberof PatientBillInfoDto
     */
    'isRxCompleted': boolean;
}
/**
 * 
 * @export
 * @interface PatientBlockedTimeDto
 */
export interface PatientBlockedTimeDto {
    /**
     * 
     * @type {number}
     * @memberof PatientBlockedTimeDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof PatientBlockedTimeDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PatientBlockedTimeDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof PatientBlockedTimeDto
     */
    'end': string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientBlockedTimeDto
     */
    'allDay': boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientBlockedTimeDto
     */
    'source': PatientBlockedTimeDtoSourceEnum;
}

export const PatientBlockedTimeDtoSourceEnum = {
    Recurring: 'recurring',
    Specific: 'specific'
} as const;

export type PatientBlockedTimeDtoSourceEnum = typeof PatientBlockedTimeDtoSourceEnum[keyof typeof PatientBlockedTimeDtoSourceEnum];

/**
 * 
 * @export
 * @interface PatientCoordinatesDto
 */
export interface PatientCoordinatesDto {
    /**
     * Address longitude
     * @type {number}
     * @memberof PatientCoordinatesDto
     */
    'addressLongitude': number;
    /**
     * Address latitude
     * @type {number}
     * @memberof PatientCoordinatesDto
     */
    'addressLatitude': number;
    /**
     * Sublocality identifier
     * @type {string}
     * @memberof PatientCoordinatesDto
     */
    'sublocalityId'?: string;
    /**
     * Sublocality color in hex format
     * @type {string}
     * @memberof PatientCoordinatesDto
     */
    'sublocalityColor'?: string;
}
/**
 * 
 * @export
 * @interface PatientDto
 */
export interface PatientDto {
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'salutation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'dob': string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'status'?: string;
    /**
     * 
     * @type {InsurerDto}
     * @memberof PatientDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'insuranceNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDto
     */
    'coPayment'?: boolean;
    /**
     * 
     * @type {Array<CopaymentExemptionDto>}
     * @memberof PatientDto
     */
    'copaymentExemptions'?: Array<CopaymentExemptionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDto
     */
    'waitList'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'letterOfAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'phone1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'email'?: string;
    /**
     * 
     * @type {object}
     * @memberof PatientDto
     */
    'location'?: object;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingFirstnames'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingLastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingTel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingFax'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingAddressline1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingAddressline2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingZip'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentBusinessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentTel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentFax'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentAddressline1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentAddressline2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentZip'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDto
     */
    'smsDesired': boolean;
    /**
     * 
     * @type {Array<RxDto>}
     * @memberof PatientDto
     */
    'rxs'?: Array<RxDto>;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof PatientDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'primaryAddressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'alternativeBillingAddressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'treatmentAddressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    'dataPrivacyPolicyStatus'?: string;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof PatientDto
     */
    'addresses': Array<AddressDto>;
    /**
     * 
     * @type {number}
     * @memberof PatientDto
     */
    'id': number;
    /**
     * 
     * @type {TarifGroupDto}
     * @memberof PatientDto
     */
    'tarifGroup'?: TarifGroupDto;
}
/**
 * 
 * @export
 * @interface PatientInfo
 */
export interface PatientInfo {
    /**
     * 
     * @type {number}
     * @memberof PatientInfo
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PatientInfo
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfo
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface PatientInfoDto
 */
export interface PatientInfoDto {
    /**
     * Patient ID
     * @type {number}
     * @memberof PatientInfoDto
     */
    'id': number;
    /**
     * Patient first name
     * @type {string}
     * @memberof PatientInfoDto
     */
    'firstName': string;
    /**
     * Patient last name
     * @type {string}
     * @memberof PatientInfoDto
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PatientInformingChannel = {
    Printout: 'PRINTOUT',
    Therapist: 'THERAPIST',
    Manual: 'MANUAL'
} as const;

export type PatientInformingChannel = typeof PatientInformingChannel[keyof typeof PatientInformingChannel];


/**
 * 
 * @export
 * @interface PatientInformingProjectionDto
 */
export interface PatientInformingProjectionDto {
    /**
     * 
     * @type {string}
     * @memberof PatientInformingProjectionDto
     */
    'timeSlotId': string;
    /**
     * 
     * @type {number}
     * @memberof PatientInformingProjectionDto
     */
    'patientId'?: number | null;
    /**
     * 
     * @type {PatientInformingStatus}
     * @memberof PatientInformingProjectionDto
     */
    'status': PatientInformingStatus;
    /**
     * 
     * @type {string}
     * @memberof PatientInformingProjectionDto
     */
    'lastInformedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatientInformingProjectionDto
     */
    'informedForStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatientInformingProjectionDto
     */
    'informedForEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatientInformingProjectionDto
     */
    'informedForLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatientInformingProjectionDto
     */
    'informedForTherapistId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatientInformingProjectionDto
     */
    'isUninformedNextVisit'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PatientInformingStatus = {
    NotInformed: 'NOT_INFORMED',
    Informed: 'INFORMED',
    InformedButChanged: 'INFORMED_BUT_CHANGED'
} as const;

export type PatientInformingStatus = typeof PatientInformingStatus[keyof typeof PatientInformingStatus];


/**
 * 
 * @export
 * @interface PatientMinimalDto
 */
export interface PatientMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof PatientMinimalDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PatientMinimalDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientMinimalDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientMinimalDto
     */
    'dob': string;
}
/**
 * 
 * @export
 * @interface PatientStartDateDto
 */
export interface PatientStartDateDto {
    /**
     * 
     * @type {string}
     * @memberof PatientStartDateDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof PatientStartDateDto
     */
    'locationName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientStartDateDto
     */
    'patientStartDates': Array<string>;
}
/**
 * 
 * @export
 * @interface PatientStartDateResponseDto
 */
export interface PatientStartDateResponseDto {
    /**
     * 
     * @type {Array<PatientStartDateDto>}
     * @memberof PatientStartDateResponseDto
     */
    'patientStats': Array<PatientStartDateDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PatientStartDateResponseDto
     */
    'fallbackUsed': boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientStartDateResponseDto
     */
    'usedStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof PatientStartDateResponseDto
     */
    'usedEndDate': string;
}
/**
 * 
 * @export
 * @interface PatientTableDto
 */
export interface PatientTableDto {
    /**
     * 
     * @type {number}
     * @memberof PatientTableDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PatientTableDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTableDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTableDto
     */
    'dob': string;
    /**
     * 
     * @type {InsurerDto}
     * @memberof PatientTableDto
     */
    'payer': InsurerDto;
    /**
     * 
     * @type {string}
     * @memberof PatientTableDto
     */
    'insuranceNo': string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientTableDto
     */
    'coPayment': boolean;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof PatientTableDto
     */
    'addresses': Array<AddressDto>;
    /**
     * 
     * @type {LocationDto}
     * @memberof PatientTableDto
     */
    'location': LocationDto;
    /**
     * 
     * @type {TarifGroupDto}
     * @memberof PatientTableDto
     */
    'tarifGroup'?: TarifGroupDto;
    /**
     * All known copayment exemptions of the patient (used by the Registry patients view to differentiate between exempt / exempt-but-missing-document / required).
     * @type {Array<CopaymentExemptionDto>}
     * @memberof PatientTableDto
     */
    'copaymentExemptions'?: Array<CopaymentExemptionDto>;
}
/**
 * 
 * @export
 * @interface PatientTableFilters
 */
export interface PatientTableFilters {
    /**
     * Number of items per page (Max = 50)
     * @type {number}
     * @memberof PatientTableFilters
     */
    'limit'?: number;
    /**
     * Page number (Min = 1)
     * @type {number}
     * @memberof PatientTableFilters
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientTableFilters
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientTableFilters
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientTableFilters
     */
    'location'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientTableFilters
     */
    'includeDeleted'?: boolean;
    /**
     * Filter by tarif group ID
     * @type {string}
     * @memberof PatientTableFilters
     */
    'tarifGroupId'?: string;
    /**
     * Filter by patient copayment status
     * @type {string}
     * @memberof PatientTableFilters
     */
    'copayment'?: PatientTableFiltersCopaymentEnum;
    /**
     * Key-value pairs of sort fields and directions
     * @type {object}
     * @memberof PatientTableFilters
     */
    'sortBy'?: object;
}

export const PatientTableFiltersCopaymentEnum = {
    Required: 'required',
    Exempted: 'exempted',
    MissingDoc: 'missingDoc'
} as const;

export type PatientTableFiltersCopaymentEnum = typeof PatientTableFiltersCopaymentEnum[keyof typeof PatientTableFiltersCopaymentEnum];

/**
 * 
 * @export
 * @interface PatientTherapistPreferenceDto
 */
export interface PatientTherapistPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistPreferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientTherapistPreferenceDto
     */
    'patientId': number;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistPreferenceDto
     */
    'therapistId': string;
    /**
     * 
     * @type {TherapistListType}
     * @memberof PatientTherapistPreferenceDto
     */
    'listType': TherapistListType;
    /**
     * true = Muss (hard), false = Kann (soft)
     * @type {boolean}
     * @memberof PatientTherapistPreferenceDto
     */
    'isMandatory': boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistPreferenceDto
     */
    'updatedById'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistPreferenceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistPreferenceDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @interface PatientUnscheduledAppointmentsDto
 */
export interface PatientUnscheduledAppointmentsDto {
    /**
     * 
     * @type {string}
     * @memberof PatientUnscheduledAppointmentsDto
     */
    'patientId': string;
    /**
     * 
     * @type {BasicPatientDto}
     * @memberof PatientUnscheduledAppointmentsDto
     */
    'patient': BasicPatientDto;
    /**
     * 
     * @type {Array<AppointmentWithGapDto>}
     * @memberof PatientUnscheduledAppointmentsDto
     */
    'appointments': Array<AppointmentWithGapDto>;
}
/**
 * 
 * @export
 * @interface PayerDto
 */
export interface PayerDto {
    /**
     * 
     * @type {string}
     * @memberof PayerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PayerDto
     */
    'ik': string;
    /**
     * 
     * @type {string}
     * @memberof PayerDto
     */
    'validFrom': string;
    /**
     * 
     * @type {object}
     * @memberof PayerDto
     */
    'address': object;
    /**
     * 
     * @type {object}
     * @memberof PayerDto
     */
    'contact': object;
    /**
     * 
     * @type {BillingCenterDto}
     * @memberof PayerDto
     */
    'paperReceivingCenter': BillingCenterDto;
    /**
     * 
     * @type {BillingCenterDto}
     * @memberof PayerDto
     */
    'digitalReceivingCenter': BillingCenterDto;
}
/**
 * 
 * @export
 * @interface PayerPerformanceDto
 */
export interface PayerPerformanceDto {
    /**
     * Payer ID
     * @type {string}
     * @memberof PayerPerformanceDto
     */
    'payerId': string;
    /**
     * Payer name
     * @type {string}
     * @memberof PayerPerformanceDto
     */
    'payerName': string;
    /**
     * Total amount for this payer
     * @type {number}
     * @memberof PayerPerformanceDto
     */
    'totalAmount': number;
    /**
     * Number of bills
     * @type {number}
     * @memberof PayerPerformanceDto
     */
    'billCount': number;
    /**
     * Percentage of total revenue
     * @type {number}
     * @memberof PayerPerformanceDto
     */
    'percentageOfTotalRevenue': number;
}
/**
 * 
 * @export
 * @interface PermissionDto
 */
export interface PermissionDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    'id': PermissionDtoIdEnum;
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionDto
     */
    'isUserPermission'?: boolean;
}

export const PermissionDtoIdEnum = {
    AdminPage: 'adminPage',
    ChangeLocation: 'changeLocation',
    Dashboard: 'dashboard',
    Ledger: 'ledger',
    ViewHistoryUser: 'view-history-user',
    SwitchMobilUser: 'switchMobilUser',
    FeaturePreview: 'featurePreview',
    IssueGiftCertificateInternal: 'issueGiftCertificateInternal',
    PunchIn: 'punchIn'
} as const;

export type PermissionDtoIdEnum = typeof PermissionDtoIdEnum[keyof typeof PermissionDtoIdEnum];

/**
 * 
 * @export
 * @interface PersistBillPdfDocumentJobResultDto
 */
export interface PersistBillPdfDocumentJobResultDto {
    /**
     * Type of PDF that was persisted
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'pdfType': PersistBillPdfDocumentJobResultDtoPdfTypeEnum;
    /**
     * Entity ID the PDF belongs to
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'entityId': string;
    /**
     * Whether document persistence succeeded
     * @type {boolean}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'success': boolean;
    /**
     * Primary document ID (for single-PDF types)
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'documentId'?: string;
    /**
     * Paper document ID (for GKV / Zuzahlung dual-PDF flows)
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'paperDocumentId'?: string;
    /**
     * Bill document ID (for GKV / Zuzahlung dual-PDF flows)
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'billDocumentId'?: string;
    /**
     * Primary blob URL for the generated PDF
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'blobUrl'?: string;
    /**
     * Workflow stage that failed for this item, if any
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'failedStage'?: PersistBillPdfDocumentJobResultDtoFailedStageEnum;
    /**
     * Error message if persistence failed
     * @type {string}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'error'?: string;
    /**
     * Duration of document persistence in milliseconds
     * @type {number}
     * @memberof PersistBillPdfDocumentJobResultDto
     */
    'durationMs': number;
}

export const PersistBillPdfDocumentJobResultDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type PersistBillPdfDocumentJobResultDtoPdfTypeEnum = typeof PersistBillPdfDocumentJobResultDtoPdfTypeEnum[keyof typeof PersistBillPdfDocumentJobResultDtoPdfTypeEnum];
export const PersistBillPdfDocumentJobResultDtoFailedStageEnum = {
    Prep: 'PREP',
    Render: 'RENDER',
    Persist: 'PERSIST'
} as const;

export type PersistBillPdfDocumentJobResultDtoFailedStageEnum = typeof PersistBillPdfDocumentJobResultDtoFailedStageEnum[keyof typeof PersistBillPdfDocumentJobResultDtoFailedStageEnum];

/**
 * 
 * @export
 * @interface PickTypeClass
 */
export interface PickTypeClass {
    /**
     * 
     * @type {string}
     * @memberof PickTypeClass
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PickTypeClass
     */
    'ik': string;
}
/**
 * 
 * @export
 * @interface PostPatientResponse
 */
export interface PostPatientResponse {
    /**
     * 
     * @type {PatientDto}
     * @memberof PostPatientResponse
     */
    'patient': PatientDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostPatientResponse
     */
    'messages': Array<string>;
}
/**
 * 
 * @export
 * @interface PrepBillPdfDataJobResultDto
 */
export interface PrepBillPdfDataJobResultDto {
    /**
     * Type of PDF that was prepared
     * @type {string}
     * @memberof PrepBillPdfDataJobResultDto
     */
    'pdfType': PrepBillPdfDataJobResultDtoPdfTypeEnum;
    /**
     * Entity ID the prep was done for
     * @type {string}
     * @memberof PrepBillPdfDataJobResultDto
     */
    'entityId': string;
    /**
     * Whether data preparation succeeded
     * @type {boolean}
     * @memberof PrepBillPdfDataJobResultDto
     */
    'success': boolean;
    /**
     * Redis key where prepared render data is stored (if successful)
     * @type {string}
     * @memberof PrepBillPdfDataJobResultDto
     */
    'preparedDataKey'?: string;
    /**
     * Error message if preparation failed
     * @type {string}
     * @memberof PrepBillPdfDataJobResultDto
     */
    'error'?: string;
    /**
     * Duration of data preparation in milliseconds
     * @type {number}
     * @memberof PrepBillPdfDataJobResultDto
     */
    'durationMs': number;
}

export const PrepBillPdfDataJobResultDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type PrepBillPdfDataJobResultDtoPdfTypeEnum = typeof PrepBillPdfDataJobResultDtoPdfTypeEnum[keyof typeof PrepBillPdfDataJobResultDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface PrepareCorrectionBillsFromRxsRequest
 */
export interface PrepareCorrectionBillsFromRxsRequest {
    /**
     * 
     * @type {string}
     * @memberof PrepareCorrectionBillsFromRxsRequest
     */
    'accountId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrepareCorrectionBillsFromRxsRequest
     */
    'rxIds': Array<string>;
}
/**
 * 
 * @export
 * @interface PrescribedTherapyAdminDto
 */
export interface PrescribedTherapyAdminDto {
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyAdminDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyAdminDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyAdminDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrescribedTherapyAdminDto
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyAdminDto
     */
    'therapyType'?: PrescribedTherapyAdminDtoTherapyTypeEnum;
    /**
     * 
     * @type {Array<TermAliasDto>}
     * @memberof PrescribedTherapyAdminDto
     */
    'aliases': Array<TermAliasDto>;
    /**
     * 
     * @type {Array<TermResolutionDto>}
     * @memberof PrescribedTherapyAdminDto
     */
    'resolutions': Array<TermResolutionDto>;
    /**
     * 
     * @type {number}
     * @memberof PrescribedTherapyAdminDto
     */
    'usedByLines': number;
    /**
     * 
     * @type {number}
     * @memberof PrescribedTherapyAdminDto
     */
    'usedByDiagnosisGroups': number;
}

export const PrescribedTherapyAdminDtoTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type PrescribedTherapyAdminDtoTherapyTypeEnum = typeof PrescribedTherapyAdminDtoTherapyTypeEnum[keyof typeof PrescribedTherapyAdminDtoTherapyTypeEnum];

/**
 * 
 * @export
 * @interface PrescribedTherapyDto
 */
export interface PrescribedTherapyDto {
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyDto
     */
    'shortLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrescribedTherapyDto
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyDto
     */
    'therapyType'?: PrescribedTherapyDtoTherapyTypeEnum;
}

export const PrescribedTherapyDtoTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type PrescribedTherapyDtoTherapyTypeEnum = typeof PrescribedTherapyDtoTherapyTypeEnum[keyof typeof PrescribedTherapyDtoTherapyTypeEnum];

/**
 * 
 * @export
 * @interface PrescribedTherapyOptionDto
 */
export interface PrescribedTherapyOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyOptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyOptionDto
     */
    'shortLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyOptionDto
     */
    'label': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrescribedTherapyOptionDto
     */
    'aliases': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PrescribedTherapyOptionDto
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {string}
     * @memberof PrescribedTherapyOptionDto
     */
    'therapyType'?: PrescribedTherapyOptionDtoTherapyTypeEnum;
    /**
     * tarifGroupId → default duration in minutes
     * @type {{ [key: string]: number; }}
     * @memberof PrescribedTherapyOptionDto
     */
    'defaultDurations': { [key: string]: number; };
    /**
     * tarifGroupId → whether the default line item is a passive application
     * @type {{ [key: string]: boolean; }}
     * @memberof PrescribedTherapyOptionDto
     */
    'defaultPassivity': { [key: string]: boolean; };
}

export const PrescribedTherapyOptionDtoTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type PrescribedTherapyOptionDtoTherapyTypeEnum = typeof PrescribedTherapyOptionDtoTherapyTypeEnum[keyof typeof PrescribedTherapyOptionDtoTherapyTypeEnum];

/**
 * 
 * @export
 * @interface PreviewSwapDto
 */
export interface PreviewSwapDto {
    /**
     * 
     * @type {Array<SeriesSwapAppointmentsDto>}
     * @memberof PreviewSwapDto
     */
    'beforeSwap': Array<SeriesSwapAppointmentsDto>;
    /**
     * 
     * @type {Array<SeriesSwapAppointmentsDto>}
     * @memberof PreviewSwapDto
     */
    'afterSwap': Array<SeriesSwapAppointmentsDto>;
}
/**
 * 
 * @export
 * @interface PriceDateRangeDto
 */
export interface PriceDateRangeDto {
    /**
     * 
     * @type {string}
     * @memberof PriceDateRangeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PriceDateRangeDto
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof PriceDateRangeDto
     */
    'invalidFrom': string;
    /**
     * 
     * @type {number}
     * @memberof PriceDateRangeDto
     */
    'price': number;
    /**
     * Date-specific Positionsnummer; null when not yet backfilled
     * @type {string}
     * @memberof PriceDateRangeDto
     */
    'lineItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PriceDateRangeDto
     */
    'therapyId': string;
}
/**
 * 
 * @export
 * @interface ProcessedCopaymentBillingDto
 */
export interface ProcessedCopaymentBillingDto {
    /**
     * 
     * @type {Array<RxWithPriceAndAppointmentsDto>}
     * @memberof ProcessedCopaymentBillingDto
     */
    'rxs': Array<RxWithPriceAndAppointmentsDto>;
    /**
     * 
     * @type {PayerDto}
     * @memberof ProcessedCopaymentBillingDto
     */
    'payer': PayerDto;
    /**
     * 
     * @type {number}
     * @memberof ProcessedCopaymentBillingDto
     */
    'totalPrice': number;
    /**
     * 
     * @type {string}
     * @memberof ProcessedCopaymentBillingDto
     */
    'previousBillNumber': string;
}
/**
 * 
 * @export
 * @interface ProcessedCorrectionBillingDto
 */
export interface ProcessedCorrectionBillingDto {
    /**
     * 
     * @type {Array<RxWithPriceAndAppointmentsDto>}
     * @memberof ProcessedCorrectionBillingDto
     */
    'rxs': Array<RxWithPriceAndAppointmentsDto>;
    /**
     * 
     * @type {PayerDto}
     * @memberof ProcessedCorrectionBillingDto
     */
    'payer': PayerDto;
    /**
     * The total correction amount for all Rxs
     * @type {number}
     * @memberof ProcessedCorrectionBillingDto
     */
    'correctionAmount': number;
    /**
     * 
     * @type {string}
     * @memberof ProcessedCorrectionBillingDto
     */
    'previousBillNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ProcessedCorrectionBillingDto
     */
    'previousBillDate': string;
}
/**
 * 
 * @export
 * @interface ProcessedPaperBillingDto
 */
export interface ProcessedPaperBillingDto {
    /**
     * 
     * @type {Array<RxWithPriceAndAppointmentsDto>}
     * @memberof ProcessedPaperBillingDto
     */
    'rxs': Array<RxWithPriceAndAppointmentsDto>;
    /**
     * 
     * @type {InstituteDto}
     * @memberof ProcessedPaperBillingDto
     */
    'payer': InstituteDto;
    /**
     * 
     * @type {number}
     * @memberof ProcessedPaperBillingDto
     */
    'totalPrice': number;
}
/**
 * 
 * @export
 * @interface ProposedActionDto
 */
export interface ProposedActionDto {
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'actionType': ProposedActionDtoActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'timeSlotId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'originalStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'originalEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'originalTherapistId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'newTherapistId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedActionDto
     */
    'reason': string;
}

export const ProposedActionDtoActionTypeEnum = {
    Create: 'create',
    Move: 'move',
    Skip: 'skip',
    Delete: 'delete'
} as const;

export type ProposedActionDtoActionTypeEnum = typeof ProposedActionDtoActionTypeEnum[keyof typeof ProposedActionDtoActionTypeEnum];

/**
 * 
 * @export
 * @interface ProposedPriceChangeDto
 */
export interface ProposedPriceChangeDto {
    /**
     * 
     * @type {string}
     * @memberof ProposedPriceChangeDto
     */
    'action': ProposedPriceChangeDtoActionEnum;
    /**
     * 
     * @type {string}
     * @memberof ProposedPriceChangeDto
     */
    'therapyId': string;
    /**
     * 
     * @type {string}
     * @memberof ProposedPriceChangeDto
     */
    'therapyAbbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedPriceChangeDto
     */
    'existingPriceId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProposedPriceChangeDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ProposedPriceChangeDto
     */
    'oldPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposedPriceChangeDto
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ProposedPriceChangeDto
     */
    'invalidFrom': string;
}

export const ProposedPriceChangeDtoActionEnum = {
    Create: 'create',
    Update: 'update'
} as const;

export type ProposedPriceChangeDtoActionEnum = typeof ProposedPriceChangeDtoActionEnum[keyof typeof ProposedPriceChangeDtoActionEnum];

/**
 * 
 * @export
 * @interface PublicHolidayDto
 */
export interface PublicHolidayDto {
    /**
     * 
     * @type {number}
     * @memberof PublicHolidayDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayDto
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayDto
     */
    'bundesland': string;
    /**
     * 
     * @type {number}
     * @memberof PublicHolidayDto
     */
    'year': number;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface PunchRequestDto
 */
export interface PunchRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PunchRequestDto
     */
    'action': PunchRequestDtoActionEnum;
    /**
     * Punch time; must fall on today. Omit for now.
     * @type {string}
     * @memberof PunchRequestDto
     */
    'at'?: string;
    /**
     * Punch-in only: length of the new work block when the day has nothing to shift (see needsDuration). Omit for the 1-hour default.
     * @type {number}
     * @memberof PunchRequestDto
     */
    'durationMinutes'?: number;
    /**
     * Compute the resulting day without saving anything (dialog preview).
     * @type {boolean}
     * @memberof PunchRequestDto
     */
    'dryRun'?: boolean;
}

export const PunchRequestDtoActionEnum = {
    In: 'in',
    Out: 'out'
} as const;

export type PunchRequestDtoActionEnum = typeof PunchRequestDtoActionEnum[keyof typeof PunchRequestDtoActionEnum];

/**
 * 
 * @export
 * @interface PunchResultDto
 */
export interface PunchResultDto {
    /**
     * 
     * @type {string}
     * @memberof PunchResultDto
     */
    'action': PunchResultDtoActionEnum;
    /**
     * 
     * @type {string}
     * @memberof PunchResultDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PunchResultDto
     */
    'at': string;
    /**
     * False for a dry run.
     * @type {boolean}
     * @memberof PunchResultDto
     */
    'saved': boolean;
    /**
     * Punch-in only: the day had no remaining work to shift, so the block\'s length comes from durationMinutes.
     * @type {boolean}
     * @memberof PunchResultDto
     */
    'needsDuration': boolean;
    /**
     * The user\'s punch-in time after this punch (null after punching out).
     * @type {string}
     * @memberof PunchResultDto
     */
    'punchInTime': string | null;
    /**
     * Start of the counted span: the punch-in time (out) or the punch time (in).
     * @type {string}
     * @memberof PunchResultDto
     */
    'workFrom': string;
    /**
     * End of the counted span: the punch time (out) or the end of the day\'s work (in).
     * @type {string}
     * @memberof PunchResultDto
     */
    'workTo': string;
    /**
     * Net working minutes from workFrom to workTo, breaks subtracted.
     * @type {number}
     * @memberof PunchResultDto
     */
    'netWorkMinutes': number;
    /**
     * The day\'s complete schedule after the punch.
     * @type {Array<ExceptionSlotDto>}
     * @memberof PunchResultDto
     */
    'slots': Array<ExceptionSlotDto>;
}

export const PunchResultDtoActionEnum = {
    In: 'in',
    Out: 'out'
} as const;

export type PunchResultDtoActionEnum = typeof PunchResultDtoActionEnum[keyof typeof PunchResultDtoActionEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const RENDERBILLPDFJobName = {
    RenderBillPdf: 'RENDER_BILL_PDF'
} as const;

export type RENDERBILLPDFJobName = typeof RENDERBILLPDFJobName[keyof typeof RENDERBILLPDFJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const RESCHEDULINGAGENTJobName = {
    ReschedulingAgent: 'RESCHEDULING_AGENT'
} as const;

export type RESCHEDULINGAGENTJobName = typeof RESCHEDULINGAGENTJobName[keyof typeof RESCHEDULINGAGENTJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const RUNAIAGENTJobName = {
    RunAiAgent: 'RUN_AI_AGENT'
} as const;

export type RUNAIAGENTJobName = typeof RUNAIAGENTJobName[keyof typeof RUNAIAGENTJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const RUNBACKPLANNINGJobName = {
    RunBackplanning: 'RUN_BACKPLANNING'
} as const;

export type RUNBACKPLANNINGJobName = typeof RUNBACKPLANNINGJobName[keyof typeof RUNBACKPLANNINGJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const RUNRXVALIDATIONBULKJobName = {
    RunRxValidationBulk: 'RUN_RX_VALIDATION_BULK'
} as const;

export type RUNRXVALIDATIONBULKJobName = typeof RUNRXVALIDATIONBULKJobName[keyof typeof RUNRXVALIDATIONBULKJobName];


/**
 * 
 * @export
 * @interface RechnungAllocationDto
 */
export interface RechnungAllocationDto {
    /**
     * The UUID of the Rechnung to allocate payment to
     * @type {string}
     * @memberof RechnungAllocationDto
     */
    'rechnungId': string;
    /**
     * Amount allocated to this particular invoice
     * @type {number}
     * @memberof RechnungAllocationDto
     */
    'paidAmount': number;
}
/**
 * 
 * @export
 * @interface RecordInformingDto
 */
export interface RecordInformingDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecordInformingDto
     */
    'timeSlotIds': Array<string>;
    /**
     * 
     * @type {PatientInformingChannel}
     * @memberof RecordInformingDto
     */
    'channel'?: PatientInformingChannel;
}


/**
 * 
 * @export
 * @interface RefineDoctorReportRequestDto
 */
export interface RefineDoctorReportRequestDto {
    /**
     * Free-text instruction from the therapist describing how the texts should be changed (e.g. \'kürzer formulieren\'). Grammar and spelling are always corrected regardless of this instruction.
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'userPrompt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'therapyStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'specialFeatures'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'treatmentModification'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'treatmentTerminationReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'therapyAssessment'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefineDoctorReportRequestDto
     */
    'therapyChangeSuggestions'?: string;
}
/**
 * 
 * @export
 * @interface RefineTreatmentNoteRequestDto
 */
export interface RefineTreatmentNoteRequestDto {
    /**
     * Current text of the treatment note to refine. May be empty when generating a new note from an instruction alone.
     * @type {string}
     * @memberof RefineTreatmentNoteRequestDto
     */
    'note'?: string;
    /**
     * Free-text instruction from the therapist describing how the text should be changed (e.g. \'kürzer formulieren\'). Grammar, spelling and dictation errors are always corrected regardless of this instruction.
     * @type {string}
     * @memberof RefineTreatmentNoteRequestDto
     */
    'userPrompt'?: string;
    /**
     * Patient id — used server-side to strip the patient\'s known name/DOB from the text before it is sent to the LLM.
     * @type {number}
     * @memberof RefineTreatmentNoteRequestDto
     */
    'patientId'?: number;
}
/**
 * 
 * @export
 * @interface RefineTreatmentNoteResponseDto
 */
export interface RefineTreatmentNoteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RefineTreatmentNoteResponseDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface RefreshTokenDto
 */
export interface RefreshTokenDto {
    /**
     * Refresh token, for clients that can\'t rely on the httpOnly cookie
     * @type {string}
     * @memberof RefreshTokenDto
     */
    'refresh_token'?: string;
}
/**
 * 
 * @export
 * @interface RefundDetailsDto
 */
export interface RefundDetailsDto {
    /**
     * Unique identifier for the transaction
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'id': string;
    /**
     * Transaction number
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'transactionNumber': string;
    /**
     * Type of the transaction
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'type': RefundDetailsDtoTypeEnum;
    /**
     * Description of the transaction
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'text': string;
    /**
     * Amount of the transaction
     * @type {number}
     * @memberof RefundDetailsDto
     */
    'amount': number;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof RefundDetailsDto
     */
    'wasExported': boolean;
    /**
     * 
     * @type {GetUserDto}
     * @memberof RefundDetailsDto
     */
    'user': GetUserDto;
    /**
     * 
     * @type {GetAccountDto}
     * @memberof RefundDetailsDto
     */
    'account': GetAccountDto;
    /**
     * 
     * @type {GetPatientDto}
     * @memberof RefundDetailsDto
     */
    'patient': GetPatientDto;
    /**
     * 
     * @type {GetRxDto}
     * @memberof RefundDetailsDto
     */
    'rx'?: GetRxDto;
    /**
     * Date when the transaction was created
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'createdAt': string;
    /**
     * Date when the transaction was last updated
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetTAccountDto}
     * @memberof RefundDetailsDto
     */
    'tAccounts': GetTAccountDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof RefundDetailsDto
     */
    'docDto'?: DocumentDto;
    /**
     * Transaction Number of the original transaction if this is a cancellation
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'originalTransactionNumber'?: string;
    /**
     * Indicates if this transaction is a cancellation of a previous transaction
     * @type {boolean}
     * @memberof RefundDetailsDto
     */
    'isCancelled'?: boolean;
    /**
     * Credit permission details (bank account used for refund)
     * @type {object}
     * @memberof RefundDetailsDto
     */
    'creditPermission'?: object;
    /**
     * SEPA export timestamp
     * @type {string}
     * @memberof RefundDetailsDto
     */
    'exportedOn'?: string;
    /**
     * User who exported the SEPA file
     * @type {object}
     * @memberof RefundDetailsDto
     */
    'exportedBy'?: object;
    /**
     * 
     * @type {DocumentDto}
     * @memberof RefundDetailsDto
     */
    'sepaDocument'?: DocumentDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof RefundDetailsDto
     */
    'sepaExportPdf'?: DocumentDto;
}

export const RefundDetailsDtoTypeEnum = {
    Einnahme: 'Einnahme',
    Ausgabe: 'Ausgabe',
    Stornierung: 'Stornierung',
    Rckerstattung: 'Rückerstattung'
} as const;

export type RefundDetailsDtoTypeEnum = typeof RefundDetailsDtoTypeEnum[keyof typeof RefundDetailsDtoTypeEnum];

/**
 * 
 * @export
 * @interface RegistryDocumentationStatsDto
 */
export interface RegistryDocumentationStatsDto {
    /**
     * 
     * @type {string}
     * @memberof RegistryDocumentationStatsDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof RegistryDocumentationStatsDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryDocumentationStatsDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RegistryDocumentationStatsDto
     */
    'totalTreatments': number;
    /**
     * 
     * @type {number}
     * @memberof RegistryDocumentationStatsDto
     */
    'treatmentsWithNotes': number;
    /**
     * Percentage of treatments that have documentation, 0-100
     * @type {number}
     * @memberof RegistryDocumentationStatsDto
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface RegistryTreatmentNoteRowDto
 */
export interface RegistryTreatmentNoteRowDto {
    /**
     * 
     * @type {number}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'note'?: string | null;
    /**
     * Date of the treatment note (timeslot.start)
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'patientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'patientLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'patientFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'rxId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'rxNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'rxDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'therapistId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'therapistFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'therapistLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistryTreatmentNoteRowDto
     */
    'therapistNickName'?: string | null;
}
/**
 * 
 * @export
 * @interface RejectExportBatchDto
 */
export interface RejectExportBatchDto {
    /**
     * Bank rejection reason / return code.
     * @type {string}
     * @memberof RejectExportBatchDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface RejectedActionGroupDto
 */
export interface RejectedActionGroupDto {
    /**
     * 
     * @type {ActionGroupDto}
     * @memberof RejectedActionGroupDto
     */
    'actionGroup': ActionGroupDto;
    /**
     * Rejection reason from the user (free text or chip selection, e.g. \'Nicht verfügbar\', \'Fahrtweg\', \'Therapeut\', \'Tag/Uhrzeit\')
     * @type {string}
     * @memberof RejectedActionGroupDto
     */
    'rejectionReason'?: string;
}
/**
 * 
 * @export
 * @interface RejectedDayOutcomeDto
 */
export interface RejectedDayOutcomeDto {
    /**
     * The date of the rejected day
     * @type {string}
     * @memberof RejectedDayOutcomeDto
     */
    'day': string;
    /**
     * The proposed actions that were rejected
     * @type {Array<BackplanActionDto>}
     * @memberof RejectedDayOutcomeDto
     */
    'proposedActions': Array<BackplanActionDto>;
    /**
     * Optional reason why the user rejected this day
     * @type {string}
     * @memberof RejectedDayOutcomeDto
     */
    'rejectionReason'?: string;
}
/**
 * 
 * @export
 * @interface ReminderDto
 */
export interface ReminderDto {
    /**
     * 
     * @type {number}
     * @memberof ReminderDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReminderDto
     */
    'date': string;
    /**
     * 
     * @type {boolean}
     * @memberof ReminderDto
     */
    'isResolved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReminderDto
     */
    'alternativeMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReminderDto
     */
    'ticketId'?: number;
    /**
     * 
     * @type {object}
     * @memberof ReminderDto
     */
    'createdByUser'?: object;
}
/**
 * 
 * @export
 * @interface RemoveRxFromExportedTransactionDto
 */
export interface RemoveRxFromExportedTransactionDto {
    /**
     * Reason for removing the Rx from transaction
     * @type {string}
     * @memberof RemoveRxFromExportedTransactionDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface RenderBillPdfJobResultDto
 */
export interface RenderBillPdfJobResultDto {
    /**
     * Type of PDF that was generated
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'pdfType': RenderBillPdfJobResultDtoPdfTypeEnum;
    /**
     * Entity ID the PDF was generated for
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'entityId': string;
    /**
     * Whether PDF rendering succeeded
     * @type {boolean}
     * @memberof RenderBillPdfJobResultDto
     */
    'success': boolean;
    /**
     * Primary document ID (for single-PDF types)
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'documentId'?: string;
    /**
     * Paper document ID (for GKV bills)
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'paperDocumentId'?: string;
    /**
     * Bill document ID (for GKV bills)
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'billDocumentId'?: string;
    /**
     * Blob URL of the generated PDF
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'blobUrl'?: string;
    /**
     * Error message if generation failed
     * @type {string}
     * @memberof RenderBillPdfJobResultDto
     */
    'error'?: string;
    /**
     * Duration of PDF rendering in milliseconds
     * @type {number}
     * @memberof RenderBillPdfJobResultDto
     */
    'durationMs': number;
}

export const RenderBillPdfJobResultDtoPdfTypeEnum = {
    GkvBill: 'GKV_BILL',
    InsuranceCopaymentBill: 'INSURANCE_COPAYMENT_BILL',
    PatientBill: 'PATIENT_BILL',
    Mahnung: 'MAHNUNG',
    CopaymentBill: 'COPAYMENT_BILL',
    DoctorReport: 'DOCTOR_REPORT',
    PaperBill: 'PAPER_BILL',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION',
    Transaction: 'TRANSACTION'
} as const;

export type RenderBillPdfJobResultDtoPdfTypeEnum = typeof RenderBillPdfJobResultDtoPdfTypeEnum[keyof typeof RenderBillPdfJobResultDtoPdfTypeEnum];

/**
 * 
 * @export
 * @interface RenderNoticeTemplateDto
 */
export interface RenderNoticeTemplateDto {
    /**
     * notice definition data id
     * @type {string}
     * @memberof RenderNoticeTemplateDto
     */
    'noticeDefinitionDataId': string;
    /**
     * Format of the rendered output (default is \"file\")
     * @type {string}
     * @memberof RenderNoticeTemplateDto
     */
    'format'?: RenderNoticeTemplateDtoFormatEnum;
    /**
     * Type of the notice
     * @type {string}
     * @memberof RenderNoticeTemplateDto
     */
    'noticeType': RenderNoticeTemplateDtoNoticeTypeEnum;
    /**
     * flag to render template maybe for testing even if it is inactive
     * @type {boolean}
     * @memberof RenderNoticeTemplateDto
     */
    'forceRenderInactiveTemplate'?: boolean;
}

export const RenderNoticeTemplateDtoFormatEnum = {
    File: 'file',
    Html: 'html'
} as const;

export type RenderNoticeTemplateDtoFormatEnum = typeof RenderNoticeTemplateDtoFormatEnum[keyof typeof RenderNoticeTemplateDtoFormatEnum];
export const RenderNoticeTemplateDtoNoticeTypeEnum = {
    PrivatePricing: 'PRIVATE_PRICING',
    PolicyUpdate: 'POLICY_UPDATE',
    GeneralInfo: 'GENERAL_INFO'
} as const;

export type RenderNoticeTemplateDtoNoticeTypeEnum = typeof RenderNoticeTemplateDtoNoticeTypeEnum[keyof typeof RenderNoticeTemplateDtoNoticeTypeEnum];

/**
 * 
 * @export
 * @interface RenderPatientNoticeTemplateDto
 */
export interface RenderPatientNoticeTemplateDto {
    /**
     * notice definition data id
     * @type {string}
     * @memberof RenderPatientNoticeTemplateDto
     */
    'noticeDefinitionDataId': string;
    /**
     * Format of the rendered output (default is \"file\")
     * @type {string}
     * @memberof RenderPatientNoticeTemplateDto
     */
    'format'?: RenderPatientNoticeTemplateDtoFormatEnum;
    /**
     * Type of the notice
     * @type {string}
     * @memberof RenderPatientNoticeTemplateDto
     */
    'noticeType': RenderPatientNoticeTemplateDtoNoticeTypeEnum;
    /**
     * flag to render template maybe for testing even if it is inactive
     * @type {boolean}
     * @memberof RenderPatientNoticeTemplateDto
     */
    'forceRenderInactiveTemplate'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RenderPatientNoticeTemplateDto
     */
    'patientId': number;
}

export const RenderPatientNoticeTemplateDtoFormatEnum = {
    File: 'file',
    Html: 'html'
} as const;

export type RenderPatientNoticeTemplateDtoFormatEnum = typeof RenderPatientNoticeTemplateDtoFormatEnum[keyof typeof RenderPatientNoticeTemplateDtoFormatEnum];
export const RenderPatientNoticeTemplateDtoNoticeTypeEnum = {
    PrivatePricing: 'PRIVATE_PRICING',
    PolicyUpdate: 'POLICY_UPDATE',
    GeneralInfo: 'GENERAL_INFO'
} as const;

export type RenderPatientNoticeTemplateDtoNoticeTypeEnum = typeof RenderPatientNoticeTemplateDtoNoticeTypeEnum[keyof typeof RenderPatientNoticeTemplateDtoNoticeTypeEnum];

/**
 * 
 * @export
 * @interface RescheduleTimeSlotDto
 */
export interface RescheduleTimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof RescheduleTimeSlotDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleTimeSlotDto
     */
    'end': string;
    /**
     * New therapist user id
     * @type {string}
     * @memberof RescheduleTimeSlotDto
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface ReschedulingLLMStepDto
 */
export interface ReschedulingLLMStepDto {
    /**
     * Logical name of the step, e.g. \'parse_request\', \'summarize_for_user\'.
     * @type {string}
     * @memberof ReschedulingLLMStepDto
     */
    'stepName': string;
    /**
     * LLM call duration in milliseconds, if applicable.
     * @type {number}
     * @memberof ReschedulingLLMStepDto
     */
    'durationMs'?: number | null;
    /**
     * Model identifier used for this step, e.g. \"openai:gpt-5-nano-2025-08-07\".
     * @type {string}
     * @memberof ReschedulingLLMStepDto
     */
    'llmModel'?: string | null;
    /**
     * Short human-readable description of what input was given to the LLM.
     * @type {string}
     * @memberof ReschedulingLLMStepDto
     */
    'input': string;
    /**
     * Short human-readable description of what the LLM produced.
     * @type {string}
     * @memberof ReschedulingLLMStepDto
     */
    'output'?: string | null;
    /**
     * More detailed explanation or reasoning notes for this step.
     * @type {string}
     * @memberof ReschedulingLLMStepDto
     */
    'explanation'?: string | null;
    /**
     * Small machine-readable payload: key data points, flags, etc.
     * @type {{ [key: string]: any; }}
     * @memberof ReschedulingLLMStepDto
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * Error message if the step failed.
     * @type {string}
     * @memberof ReschedulingLLMStepDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<ActionGroupDto>}
     * @memberof ReschedulingLLMStepDto
     */
    'ActionGroup'?: Array<ActionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface ReschedulingRequestDto
 */
export interface ReschedulingRequestDto {
    /**
     * Patient ID to reschedule
     * @type {string}
     * @memberof ReschedulingRequestDto
     */
    'patientId': string;
    /**
     * Location ID (e.g. \'Brunswick\')
     * @type {string}
     * @memberof ReschedulingRequestDto
     */
    'locationId': string;
    /**
     * \'direct\' or \'post_automatic_scheduler\'
     * @type {string}
     * @memberof ReschedulingRequestDto
     */
    'mode'?: string;
    /**
     * Specific appointment IDs to target
     * @type {Array<string>}
     * @memberof ReschedulingRequestDto
     */
    'targetAppointmentIds'?: Array<string>;
    /**
     * Rejected action groups with rejection reason
     * @type {Array<RejectedActionGroupDto>}
     * @memberof ReschedulingRequestDto
     */
    'rejectedProposals'?: Array<RejectedActionGroupDto>;
    /**
     * Unreviewed action groups — may re-propose with modifications
     * @type {Array<ActionGroupDto>}
     * @memberof ReschedulingRequestDto
     */
    'unreviewedProposals'?: Array<ActionGroupDto>;
    /**
     * Free-text user instructions for the agent
     * @type {string}
     * @memberof ReschedulingRequestDto
     */
    'userInstructions'?: string;
}
/**
 * 
 * @export
 * @interface ResolveCorrectionBillNumber200Response
 */
export interface ResolveCorrectionBillNumber200Response {
    /**
     * 
     * @type {string}
     * @memberof ResolveCorrectionBillNumber200Response
     */
    'transactionId'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponseExportInfoDto
 */
export interface ResponseExportInfoDto {
    /**
     * List of prescriptions (Rx) included in this export
     * @type {Array<RxBasicInfoDto>}
     * @memberof ResponseExportInfoDto
     */
    'rxs': Array<RxBasicInfoDto>;
    /**
     * Array of export data containing payload and metadata for each export record
     * @type {Array<ExportDataItemDto>}
     * @memberof ResponseExportInfoDto
     */
    'exportData': Array<ExportDataItemDto>;
    /**
     * 
     * @type {ResponseExportInfoDtoBillingCenter}
     * @memberof ResponseExportInfoDto
     */
    'billingCenter': ResponseExportInfoDtoBillingCenter | null;
}
/**
 * Billing center information associated with the export records
 * @export
 * @interface ResponseExportInfoDtoBillingCenter
 */
export interface ResponseExportInfoDtoBillingCenter {
    /**
     * 
     * @type {string}
     * @memberof ResponseExportInfoDtoBillingCenter
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseExportInfoDtoBillingCenter
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseExportInfoDtoBillingCenter
     */
    'ik'?: string;
    /**
     * 
     * @type {ResponseExportInfoDtoBillingCenterAddress}
     * @memberof ResponseExportInfoDtoBillingCenter
     */
    'address'?: ResponseExportInfoDtoBillingCenterAddress;
}
/**
 * 
 * @export
 * @interface ResponseExportInfoDtoBillingCenterAddress
 */
export interface ResponseExportInfoDtoBillingCenterAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponseExportInfoDtoBillingCenterAddress
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseExportInfoDtoBillingCenterAddress
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseExportInfoDtoBillingCenterAddress
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface RestoredAppointmentDto
 */
export interface RestoredAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof RestoredAppointmentDto
     */
    'cancellationId': string;
    /**
     * 
     * @type {string}
     * @memberof RestoredAppointmentDto
     */
    'appointmentId': string;
    /**
     * 
     * @type {string}
     * @memberof RestoredAppointmentDto
     */
    'originalDate': string;
    /**
     * 
     * @type {object}
     * @memberof RestoredAppointmentDto
     */
    'patientId'?: object | null;
}
/**
 * 
 * @export
 * @interface RetryBackplanningDto
 */
export interface RetryBackplanningDto {
    /**
     * Day outcomes that the user rejected
     * @type {Array<RejectedDayOutcomeDto>}
     * @memberof RetryBackplanningDto
     */
    'rejectedDays': Array<RejectedDayOutcomeDto>;
    /**
     * 
     * @type {string}
     * @memberof RetryBackplanningDto
     */
    'locationId': string;
}
/**
 * 
 * @export
 * @interface ReverseSepaTransactionDto
 */
export interface ReverseSepaTransactionDto {
    /**
     * Reason for the reversal (kept for audit).
     * @type {string}
     * @memberof ReverseSepaTransactionDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface RevokeMandateDto
 */
export interface RevokeMandateDto {
    /**
     * Why the mandate is being revoked (reason / source).
     * @type {string}
     * @memberof RevokeMandateDto
     */
    'reason': string;
    /**
     * Effective date of the revocation (defaults to now).
     * @type {string}
     * @memberof RevokeMandateDto
     */
    'effectiveDate'?: string;
}
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'description': string;
    /**
     * 
     * @type {Array<PermissionDto>}
     * @memberof RoleDto
     */
    'permissions'?: Array<PermissionDto>;
}
/**
 * 
 * @export
 * @interface RunBackplanningDto
 */
export interface RunBackplanningDto {
    /**
     * Farthest future date to backplan from. Defaults to today + TIME_HORIZON_WEEKS if omitted.
     * @type {string}
     * @memberof RunBackplanningDto
     */
    'startingHorizonDate'?: string;
    /**
     * Earliest date (inclusive) to stop walking backward. If omitted, auto-computed from selectedRxId or falls back to today.
     * @type {string}
     * @memberof RunBackplanningDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RunBackplanningDto
     */
    'locationId': string;
    /**
     * Rx ID from the selected appointment. Used to compute the end date: last appointment on this Rx series + 2 days. If omitted, endDate falls back to today.
     * @type {string}
     * @memberof RunBackplanningDto
     */
    'selectedRxId'?: string;
    /**
     * Only process these ContinuousAppointment IDs. If omitted, all DTs for the location are processed.
     * @type {Array<string>}
     * @memberof RunBackplanningDto
     */
    'changedCaIds'?: Array<string>;
    /**
     * ISO weekdays (1=Mon..5=Fri) affected by changed CAs. Used to limit DT fetch to only these days.
     * @type {Array<number>}
     * @memberof RunBackplanningDto
     */
    'changedWeekdays'?: Array<number>;
    /**
     * Optional user-provided instructions for the LLM (e.g. \'Patient A bevorzugt morgens\'). Passed to the agent context on escalation.
     * @type {string}
     * @memberof RunBackplanningDto
     */
    'userText'?: string;
}
/**
 * 
 * @export
 * @interface RunRxValidationBulkDto
 */
export interface RunRxValidationBulkDto {
    /**
     * Optional location (Standort) to restrict the validation run to. When omitted, all locations are validated.
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'locationId'?: string;
    /**
     * Opaque nonce identifying one user-initiated run. The workflow id is derived from this whole payload and a completed workflow\'s result is replayed for its TTL, so without a fresh nonce \'Erneut prüfen\' returns the previous run\'s numbers instead of re-checking (MD-184). Callers that mean \'run it again\' must send a new value; omit it to deliberately reuse a recent run.
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'runId'?: string;
    /**
     * Restrict the run to one Bearbeitungsstatus. Omitted = the default candidate statuses.
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'processingStatus'?: RunRxValidationBulkDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'doctorReportStatus'?: RunRxValidationBulkDtoDoctorReportStatusEnum;
    /**
     * Restrict the run to one tarif group
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'tarifGroupId'?: string;
    /**
     * Restrict the run to one Rx type
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'rxTypeId'?: string;
    /**
     * Restrict the run to one Mandant (account)
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'accountId'?: string;
    /**
     * Restrict the run to Rxs prescribing this term
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'prescribedTherapyId'?: string;
    /**
     * Restrict the run to a patient last name prefix
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'lastName'?: string;
    /**
     * Restrict the run to one Rx number
     * @type {string}
     * @memberof RunRxValidationBulkDto
     */
    'rxNumber'?: string;
}

export const RunRxValidationBulkDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RunRxValidationBulkDtoProcessingStatusEnum = typeof RunRxValidationBulkDtoProcessingStatusEnum[keyof typeof RunRxValidationBulkDtoProcessingStatusEnum];
export const RunRxValidationBulkDtoDoctorReportStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type RunRxValidationBulkDtoDoctorReportStatusEnum = typeof RunRxValidationBulkDtoDoctorReportStatusEnum[keyof typeof RunRxValidationBulkDtoDoctorReportStatusEnum];

/**
 * 
 * @export
 * @interface RxBasicInfoDto
 */
export interface RxBasicInfoDto {
    /**
     * Rx ID
     * @type {string}
     * @memberof RxBasicInfoDto
     */
    'id': string;
    /**
     * Rx number
     * @type {string}
     * @memberof RxBasicInfoDto
     */
    'rxNumber': string;
    /**
     * Rx date
     * @type {string}
     * @memberof RxBasicInfoDto
     */
    'date': string | null;
    /**
     * Whether the Rx is a perpetual prescription (Dauerrezept)
     * @type {boolean}
     * @memberof RxBasicInfoDto
     */
    'isPerpetual': boolean;
    /**
     * Insurance status
     * @type {object}
     * @memberof RxBasicInfoDto
     */
    'insuranceStatus'?: object;
    /**
     * 
     * @type {TarifGroupMinimalDto}
     * @memberof RxBasicInfoDto
     */
    'tarifGroup': TarifGroupMinimalDto;
    /**
     * 
     * @type {RxTypeMinimalDto}
     * @memberof RxBasicInfoDto
     */
    'type': RxTypeMinimalDto;
    /**
     * 
     * @type {PatientInfoDto}
     * @memberof RxBasicInfoDto
     */
    'patient': PatientInfoDto;
}
/**
 * 
 * @export
 * @interface RxBillingTimelineDto
 */
export interface RxBillingTimelineDto {
    /**
     * All payment transactions for this Rx (Cash, EC, LastSchrift, BankTransfer)
     * @type {Array<TimelineTransactionDto>}
     * @memberof RxBillingTimelineDto
     */
    'transactions': Array<TimelineTransactionDto>;
    /**
     * All Rechnungen (invoices) for this Rx with their bill reminders
     * @type {Array<TimelineRechnungDto>}
     * @memberof RxBillingTimelineDto
     */
    'rechnungen': Array<TimelineRechnungDto>;
}
/**
 * 
 * @export
 * @interface RxDeletionBlockerDto
 */
export interface RxDeletionBlockerDto {
    /**
     * 
     * @type {string}
     * @memberof RxDeletionBlockerDto
     */
    'code': RxDeletionBlockerDtoCodeEnum;
    /**
     * Human readable explanation of the blocker
     * @type {string}
     * @memberof RxDeletionBlockerDto
     */
    'message': string;
    /**
     * Counts / identifiers backing the blocker, for UI display
     * @type {object}
     * @memberof RxDeletionBlockerDto
     */
    'details'?: object;
}

export const RxDeletionBlockerDtoCodeEnum = {
    PatientBill: 'PATIENT_BILL',
    AttendedAppointments: 'ATTENDED_APPOINTMENTS',
    InsuranceBill: 'INSURANCE_BILL'
} as const;

export type RxDeletionBlockerDtoCodeEnum = typeof RxDeletionBlockerDtoCodeEnum[keyof typeof RxDeletionBlockerDtoCodeEnum];

/**
 * 
 * @export
 * @interface RxDeletionCheckDto
 */
export interface RxDeletionCheckDto {
    /**
     * True when the Rx has no blockers and may be deleted
     * @type {boolean}
     * @memberof RxDeletionCheckDto
     */
    'canDelete': boolean;
    /**
     * 
     * @type {Array<RxDeletionBlockerDto>}
     * @memberof RxDeletionCheckDto
     */
    'blockers': Array<RxDeletionBlockerDto>;
}
/**
 * 
 * @export
 * @interface RxDeletionResultDto
 */
export interface RxDeletionResultDto {
    /**
     * True when the Rx was soft-deleted
     * @type {boolean}
     * @memberof RxDeletionResultDto
     */
    'deleted': boolean;
    /**
     * Populated (and deleted=false) when deletion was blocked
     * @type {Array<RxDeletionBlockerDto>}
     * @memberof RxDeletionResultDto
     */
    'blockers': Array<RxDeletionBlockerDto>;
}
/**
 * 
 * @export
 * @interface RxDisplayDto
 */
export interface RxDisplayDto {
    /**
     * Prescription number
     * @type {string}
     * @memberof RxDisplayDto
     */
    'rxNumber': string;
    /**
     * Rx ID
     * @type {string}
     * @memberof RxDisplayDto
     */
    'rxId': string;
}
/**
 * 
 * @export
 * @interface RxDto
 */
export interface RxDto {
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {PatientDto}
     * @memberof RxDto
     */
    'patient'?: PatientDto;
    /**
     * Patient first name, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxDto
     */
    'firstName'?: string;
    /**
     * Patient last name, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxDto
     */
    'lastName'?: string;
    /**
     * Patient date of birth, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxDto
     */
    'dob'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'rxNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isPerpetualApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isCopaymentExempted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isAccident'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isBVG'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'approvalStatus'?: RxDtoApprovalStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof RxDto
     */
    'validStartWindow'?: number;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'rxExpireDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'insuranceStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'insureeNumber'?: string;
    /**
     * 
     * @type {RxTypeDto}
     * @memberof RxDto
     */
    'rxtype'?: RxTypeDto;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'symptoms'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'additionalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'additionalNotes2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'expectedTherapyLength'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'signatureStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isLongTermRx'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'a'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'c'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'hasIndividualSymptoms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'therapyStart'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'therapyReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'hygiene'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'doctorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'clinicId'?: string;
    /**
     * Official LANR (9 numeric digits)
     * @type {string}
     * @memberof RxDto
     */
    'LANR'?: string;
    /**
     * Official BSNR (9 numeric digits)
     * @type {string}
     * @memberof RxDto
     */
    'BSNR'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'diagnosisText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'diagnosisText2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'accountId'?: string;
    /**
     * 
     * @type {AccountDto}
     * @memberof RxDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'Receiptpayer'?: string;
    /**
     * Payer IK read from the patient\'s chip card. Equals the Insurer id (Institutionskennzeichen).
     * @type {string}
     * @memberof RxDto
     */
    'chipcard'?: string;
    /**
     * 
     * @type {InsurerDto}
     * @memberof RxDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof RxDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'medicalPracticeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'accidentDay'?: string;
    /**
     * 
     * @type {DiagnosisGroupDto}
     * @memberof RxDto
     */
    'diagnosegroup'?: DiagnosisGroupDto;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'therapy'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxDto
     */
    'number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'problematic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'changeRequested'?: boolean;
    /**
     * 
     * @type {Array<ICDCodeEntryDto>}
     * @memberof RxDto
     */
    'icdCodeEntries'?: Array<ICDCodeEntryDto>;
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof RxDto
     */
    'therapyRxs'?: Array<TherapyRxDto>;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'rxSeriesId'?: string | null;
    /**
     * 
     * @type {RxSeriesDto}
     * @memberof RxDto
     */
    'rxSeries'?: RxSeriesDto | null;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof RxDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RxDto
     */
    'unvirtualize'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'processingStatus'?: RxDtoProcessingStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RxDto
     */
    'messages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {CreateDoctorDto}
     * @memberof RxDto
     */
    'doctor'?: CreateDoctorDto;
    /**
     * 
     * @type {CreateClinicDto}
     * @memberof RxDto
     */
    'clinic'?: CreateClinicDto;
    /**
     * 
     * @type {Array<SublocalityDto>}
     * @memberof RxDto
     */
    'sublocalities'?: Array<SublocalityDto>;
}

export const RxDtoApprovalStatusEnum = {
    Fehlt: 'fehlt',
    IstBestellt: 'ist Bestellt',
    LiegtVor: 'liegt vor'
} as const;

export type RxDtoApprovalStatusEnum = typeof RxDtoApprovalStatusEnum[keyof typeof RxDtoApprovalStatusEnum];
export const RxDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxDtoProcessingStatusEnum = typeof RxDtoProcessingStatusEnum[keyof typeof RxDtoProcessingStatusEnum];

/**
 * 
 * @export
 * @interface RxExtractionDto
 */
export interface RxExtractionDto {
    /**
     * Name of the health insurance provider
     * @type {object}
     * @memberof RxExtractionDto
     */
    'payerName': object | null;
    /**
     * IK-Nummer of the cost bearer (Kostenträgerkennung)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'payerIk': object | null;
    /**
     * Insurance number of the insured person (Versichertennummer)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'insureeNumber': object | null;
    /**
     * Insurance status code (e.g. 10000, 30000, 50000)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'insuranceStatus': object | null;
    /**
     * Full name of the insured person
     * @type {object}
     * @memberof RxExtractionDto
     */
    'patientName': object | null;
    /**
     * Address of the insured person
     * @type {object}
     * @memberof RxExtractionDto
     */
    'patientAddress': object | null;
    /**
     * Date of birth (DD.MM.YYYY)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'patientDateOfBirth': object | null;
    /**
     * LANR (Lebenslange Arztnummer) of the physician
     * @type {object}
     * @memberof RxExtractionDto
     */
    'doctorNumber': object | null;
    /**
     * Resolved Doctor entity UUID (from frontend matching)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'doctorId'?: object | null;
    /**
     * Name of the physician
     * @type {object}
     * @memberof RxExtractionDto
     */
    'doctorName': object | null;
    /**
     * Specialization of the physician
     * @type {object}
     * @memberof RxExtractionDto
     */
    'doctorSpecialization': object | null;
    /**
     * BSNR (Betriebsstättennummer) of the medical facility
     * @type {object}
     * @memberof RxExtractionDto
     */
    'practiceNumber': object | null;
    /**
     * Resolved Clinic entity UUID (from frontend matching)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'clinicId'?: object | null;
    /**
     * Address of the medical practice
     * @type {object}
     * @memberof RxExtractionDto
     */
    'practiceAddress': object | null;
    /**
     * Contact info of the medical practice (phone, fax)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'practiceContact': object | null;
    /**
     * Issue date of the prescription (DD.MM.YYYY)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'date': object | null;
    /**
     * Raw ICD-10 diagnosis codes as extracted
     * @type {object}
     * @memberof RxExtractionDto
     */
    'diagnosisCodes': object | null;
    /**
     * Textual diagnosis description
     * @type {object}
     * @memberof RxExtractionDto
     */
    'diagnosisText': object | null;
    /**
     * Diagnosis group code (e.g. WS2a)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'diagnosisGroupCode': object | null;
    /**
     * Therapy type (e.g. Physiotherapie)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'therapyType': object | null;
    /**
     * Main symptom code (Leitsymptomatik a/b/c/d)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'mainSymptom': object | null;
    /**
     * Individual patient-specific symptom description
     * @type {object}
     * @memberof RxExtractionDto
     */
    'symptoms': object | null;
    /**
     * Prescribed remedy / Heilmittel abbreviation
     * @type {object}
     * @memberof RxExtractionDto
     */
    'prescribedRemedy': object | null;
    /**
     * Number of prescribed treatment units
     * @type {object}
     * @memberof RxExtractionDto
     */
    'treatmentUnitCount': object | null;
    /**
     * Prescribed therapy frequency
     * @type {object}
     * @memberof RxExtractionDto
     */
    'therapyFrequency': object | null;
    /**
     * Whether a therapy report is required
     * @type {object}
     * @memberof RxExtractionDto
     */
    'therapyReport': object | null;
    /**
     * Whether home visit is required
     * @type {object}
     * @memberof RxExtractionDto
     */
    'isHomeVisit': object | null;
    /**
     * Whether urgent treatment is required (dringlicher Behandlungsbedarf)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'urgent': object | null;
    /**
     * Whether the prescription is signed by the doctor
     * @type {object}
     * @memberof RxExtractionDto
     */
    'isSignedByDoctor': object | null;
    /**
     * Additional medical notes, therapy goals, or findings
     * @type {object}
     * @memberof RxExtractionDto
     */
    'additionalNotes': object | null;
    /**
     * IK of the service provider (Leistungserbringer)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'serviceProviderId': object | null;
    /**
     * Inferred RxType id (e.g. Kasse, Zahnarzt)
     * @type {object}
     * @memberof RxExtractionDto
     */
    'rxType'?: object | null;
}
/**
 * 
 * @export
 * @interface RxFeeWaiversDto
 */
export interface RxFeeWaiversDto {
    /**
     * 
     * @type {string}
     * @memberof RxFeeWaiversDto
     */
    'rxId': string;
    /**
     * The fees that may be waived on this Rx. Empty for non-private Rxs.
     * @type {Array<RxWaivableFeeDto>}
     * @memberof RxFeeWaiversDto
     */
    'fees': Array<RxWaivableFeeDto>;
    /**
     * Number of the live Rechnung for this Rx, if one exists. While it does, waivers cannot be changed: the Rechnung must be cancelled first.
     * @type {string}
     * @memberof RxFeeWaiversDto
     */
    'lockedByRechnung'?: string | null;
}
/**
 * 
 * @export
 * @interface RxIdDto
 */
export interface RxIdDto {
    /**
     * The unique identifier of the prescription
     * @type {string}
     * @memberof RxIdDto
     */
    'id': string;
    /**
     * The Rx number of the prescription
     * @type {string}
     * @memberof RxIdDto
     */
    'rxNumber': string;
}
/**
 * 
 * @export
 * @interface RxLifespanDto
 */
export interface RxLifespanDto {
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'rxId': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'rxType': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'rxCreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'insuranceCreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'firstTreatmentDate': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'lastTreatmentDate': string;
    /**
     * 
     * @type {string}
     * @memberof RxLifespanDto
     */
    'locationId': string;
    /**
     * 
     * @type {PatientInfo}
     * @memberof RxLifespanDto
     */
    'patient': PatientInfo;
    /**
     * 
     * @type {LifespanDeltas}
     * @memberof RxLifespanDto
     */
    'lifespanDeltas': LifespanDeltas;
}
/**
 * 
 * @export
 * @interface RxLightDto
 */
export interface RxLightDto {
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxLightDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxLightDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'processingStatus'?: RxLightDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {Array<TherapyRxSimpleDto>}
     * @memberof RxLightDto
     */
    'therapyRxs'?: Array<TherapyRxSimpleDto>;
    /**
     * 
     * @type {string}
     * @memberof RxLightDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof RxLightDto
     */
    'therapyType'?: TherapyType;
    /**
     * Official BSNR of the clinic on the Rx
     * @type {string}
     * @memberof RxLightDto
     */
    'BSNR'?: string;
    /**
     * Clinic id (practice number) on the Rx
     * @type {string}
     * @memberof RxLightDto
     */
    'clinicId'?: string;
    /**
     * 
     * @type {ClinicLightDto}
     * @memberof RxLightDto
     */
    'clinic'?: ClinicLightDto;
}

export const RxLightDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxLightDtoProcessingStatusEnum = typeof RxLightDtoProcessingStatusEnum[keyof typeof RxLightDtoProcessingStatusEnum];

/**
 * 
 * @export
 * @interface RxLineItemSelectionDto
 */
export interface RxLineItemSelectionDto {
    /**
     * The Rx ID
     * @type {string}
     * @memberof RxLineItemSelectionDto
     */
    'rxId': string;
    /**
     * The selected line items for this Rx
     * @type {Array<string>}
     * @memberof RxLineItemSelectionDto
     */
    'selectedLineItems': Array<string>;
}
/**
 * 
 * @export
 * @interface RxPreviewDto
 */
export interface RxPreviewDto {
    /**
     * Rx ID
     * @type {string}
     * @memberof RxPreviewDto
     */
    'id': string;
    /**
     * Rx Number
     * @type {string}
     * @memberof RxPreviewDto
     */
    'rxNumber': string;
    /**
     * Rx Date
     * @type {object}
     * @memberof RxPreviewDto
     */
    'rxDate'?: object | null;
    /**
     * List of therapies
     * @type {Array<string>}
     * @memberof RxPreviewDto
     */
    'therapies': Array<string>;
    /**
     * Patient\'s first name
     * @type {string}
     * @memberof RxPreviewDto
     */
    'patientFirstName': string;
    /**
     * Patient\'s last name
     * @type {string}
     * @memberof RxPreviewDto
     */
    'patientLastName': string;
}
/**
 * 
 * @export
 * @interface RxPriceDataDto
 */
export interface RxPriceDataDto {
    /**
     * 
     * @type {Array<LineItemDto>}
     * @memberof RxPriceDataDto
     */
    'lineItems': Array<LineItemDto>;
    /**
     * 
     * @type {CopaymentSummaryDto}
     * @memberof RxPriceDataDto
     */
    'copaymentInfo': CopaymentSummaryDto;
}
/**
 * 
 * @export
 * @interface RxSelectionFiltersDto
 */
export interface RxSelectionFiltersDto {
    /**
     * Number of items per page (Max = 50)
     * @type {number}
     * @memberof RxSelectionFiltersDto
     */
    'limit'?: number;
    /**
     * Page number (Min = 1)
     * @type {number}
     * @memberof RxSelectionFiltersDto
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'processingStatus'?: RxSelectionFiltersDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'signatureStatus'?: RxSelectionFiltersDtoSignatureStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'approvalStatus'?: RxSelectionFiltersDtoApprovalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'rxStatus'?: RxSelectionFiltersDtoRxStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'insuranceStatus'?: RxSelectionFiltersDtoInsuranceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'doctorReportStatus'?: RxSelectionFiltersDtoDoctorReportStatusEnum;
    /**
     * RxType ID
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'rxTypeId'?: string;
    /**
     * TarifGroup ID
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'tarifGroupId'?: string;
    /**
     * Location name
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'location'?: string;
    /**
     * Insurer / Payer ID
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'payerId'?: string;
    /**
     * Doctor ID (FK to doctor table)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'doctorId'?: string;
    /**
     * Clinic ID (FK to clinic table)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'clinicId'?: string;
    /**
     * Account ID (Abrechnungsstelle)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'accountId'?: string;
    /**
     * DiagnosisGroup ID
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'diagnosisGroupId'?: string;
    /**
     * Therapy ID (filters via TherapyRx)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'therapyId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isCopaymentExempted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isAccident'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isBVG'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isLongTermRx'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'therapyReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isTaxieren'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'problematic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'changeRequested'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'hygiene'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'isPerpetualApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'hasIndividualSymptoms'?: boolean;
    /**
     * Rx date from (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'dateFrom'?: string;
    /**
     * Rx date to (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'dateTo'?: string;
    /**
     * Rx expire date from (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'rxExpireDateFrom'?: string;
    /**
     * Rx expire date to (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'rxExpireDateTo'?: string;
    /**
     * Created at from (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'createdFrom'?: string;
    /**
     * Created at to (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'createdTo'?: string;
    /**
     * Therapy start from (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'therapyStartFrom'?: string;
    /**
     * Therapy start to (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'therapyStartTo'?: string;
    /**
     * Rx number (partial match)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'rxNumber'?: string;
    /**
     * Insuree number on Rx (partial match)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'insureeNumber'?: string;
    /**
     * Diagnosis text free-text search
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'diagnosisText'?: string;
    /**
     * Symptoms / Leitsymptomatik free-text search
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'symptoms'?: string;
    /**
     * Additional notes / therapy goals free-text search
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'additionalNotes'?: string;
    /**
     * Verordnungsmenge a
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'a'?: boolean;
    /**
     * Verordnungsmenge b
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'b'?: boolean;
    /**
     * Verordnungsmenge c
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'c'?: boolean;
    /**
     * Verordnungsmenge d
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'd'?: boolean;
    /**
     * Rx has treatments attended but without documentation (Doku offen)
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'hasOpenDocumentation'?: boolean;
    /**
     * Rx has open (not closed) tickets — Validierungsprobleme
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'hasOpenTickets'?: boolean;
    /**
     * Include soft-deleted Rx records
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'includeDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'patientType'?: RxSelectionFiltersDtoPatientTypeEnum;
    /**
     * Patient date of birth from (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'patientDobFrom'?: string;
    /**
     * Patient date of birth to (ISO)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'patientDobTo'?: string;
    /**
     * Patient insurance number (partial match)
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'insuranceNo'?: string;
    /**
     * Patient co-payment / Zuzahlung
     * @type {boolean}
     * @memberof RxSelectionFiltersDto
     */
    'coPayment'?: boolean;
    /**
     * Patient status
     * @type {string}
     * @memberof RxSelectionFiltersDto
     */
    'patientStatus'?: string;
    /**
     * Key-value pairs of sort fields and directions
     * @type {object}
     * @memberof RxSelectionFiltersDto
     */
    'sortBy'?: object;
}

export const RxSelectionFiltersDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxSelectionFiltersDtoProcessingStatusEnum = typeof RxSelectionFiltersDtoProcessingStatusEnum[keyof typeof RxSelectionFiltersDtoProcessingStatusEnum];
export const RxSelectionFiltersDtoSignatureStatusEnum = {
    NichtKontrolliert: 'nicht kontrolliert',
    Vorhanden: 'vorhanden',
    Fehlend: 'fehlend'
} as const;

export type RxSelectionFiltersDtoSignatureStatusEnum = typeof RxSelectionFiltersDtoSignatureStatusEnum[keyof typeof RxSelectionFiltersDtoSignatureStatusEnum];
export const RxSelectionFiltersDtoApprovalStatusEnum = {
    Fehlt: 'fehlt',
    IstBestellt: 'ist Bestellt',
    LiegtVor: 'liegt vor'
} as const;

export type RxSelectionFiltersDtoApprovalStatusEnum = typeof RxSelectionFiltersDtoApprovalStatusEnum[keyof typeof RxSelectionFiltersDtoApprovalStatusEnum];
export const RxSelectionFiltersDtoRxStatusEnum = {
    NochNichtErstellt: 'noch nicht erstellt',
    BeimPatient: 'beim Patient',
    BeimTherapeut: 'beim Therapeut',
    Vorhanden: 'vorhanden'
} as const;

export type RxSelectionFiltersDtoRxStatusEnum = typeof RxSelectionFiltersDtoRxStatusEnum[keyof typeof RxSelectionFiltersDtoRxStatusEnum];
export const RxSelectionFiltersDtoInsuranceStatusEnum = {
    _10000: '10000',
    _30000: '30000',
    _50000: '50000'
} as const;

export type RxSelectionFiltersDtoInsuranceStatusEnum = typeof RxSelectionFiltersDtoInsuranceStatusEnum[keyof typeof RxSelectionFiltersDtoInsuranceStatusEnum];
export const RxSelectionFiltersDtoDoctorReportStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type RxSelectionFiltersDtoDoctorReportStatusEnum = typeof RxSelectionFiltersDtoDoctorReportStatusEnum[keyof typeof RxSelectionFiltersDtoDoctorReportStatusEnum];
export const RxSelectionFiltersDtoPatientTypeEnum = {
    GesetzlichVersicherterPatient: 'gesetzlich versicherter Patient',
    PrivatVersicherterPatient: 'privat versicherter Patient',
    BgPatient: 'BG Patient'
} as const;

export type RxSelectionFiltersDtoPatientTypeEnum = typeof RxSelectionFiltersDtoPatientTypeEnum[keyof typeof RxSelectionFiltersDtoPatientTypeEnum];

/**
 * 
 * @export
 * @interface RxSelectionResponseDto
 */
export interface RxSelectionResponseDto {
    /**
     * 
     * @type {Array<RxSelectionResultDto>}
     * @memberof RxSelectionResponseDto
     */
    'data': Array<RxSelectionResultDto>;
    /**
     * 
     * @type {number}
     * @memberof RxSelectionResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof RxSelectionResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof RxSelectionResponseDto
     */
    'limit': number;
}
/**
 * 
 * @export
 * @interface RxSelectionResultDto
 */
export interface RxSelectionResultDto {
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'processingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'signatureStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'approvalStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'rxStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'insuranceStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'rxTypeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxSelectionResultDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'patientFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'patientLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'patientType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'payerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'doctorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'locationName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RxSelectionResultDto
     */
    'therapies'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'isCopaymentExempted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'isLongTermRx'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'isTaxieren'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'problematic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'changeRequested'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'diagnosisText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'symptoms'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'insureeNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'therapyStart'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'a'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'c'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxSelectionResultDto
     */
    'd'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSelectionResultDto
     */
    'patientInsuranceNo'?: string;
    /**
     * Number of open (non-closed) tickets
     * @type {number}
     * @memberof RxSelectionResultDto
     */
    'openTicketCount'?: number;
}
/**
 * 
 * @export
 * @interface RxSeriesDto
 */
export interface RxSeriesDto {
    /**
     * 
     * @type {string}
     * @memberof RxSeriesDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxSeriesDto
     */
    'label'?: string;
    /**
     * 
     * @type {Array<RxDto>}
     * @memberof RxSeriesDto
     */
    'rxs'?: Array<RxDto> | null;
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof RxSeriesDto
     */
    'therapyRxs'?: Array<TherapyRxDto> | null;
}
/**
 * 
 * @export
 * @interface RxStatsDto
 */
export interface RxStatsDto {
    /**
     * 
     * @type {string}
     * @memberof RxStatsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RxStatsDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RxStatsDto
     */
    'rxCreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RxStatsDto
     */
    'rxType': string;
    /**
     * 
     * @type {boolean}
     * @memberof RxStatsDto
     */
    'isPerpetual': boolean;
    /**
     * 
     * @type {string}
     * @memberof RxStatsDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof RxStatsDto
     */
    'locationName': string;
    /**
     * 
     * @type {number}
     * @memberof RxStatsDto
     */
    'estimatedPrice': number;
    /**
     * 
     * @type {number}
     * @memberof RxStatsDto
     */
    'realPrice': number;
}
/**
 * 
 * @export
 * @interface RxStatsResponseDto
 */
export interface RxStatsResponseDto {
    /**
     * 
     * @type {Array<RxStatsDto>}
     * @memberof RxStatsResponseDto
     */
    'rxStats': Array<RxStatsDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RxStatsResponseDto
     */
    'fallbackUsed': boolean;
    /**
     * 
     * @type {string}
     * @memberof RxStatsResponseDto
     */
    'usedStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof RxStatsResponseDto
     */
    'usedEndDate': string;
}
/**
 * 
 * @export
 * @interface RxTableDto
 */
export interface RxTableDto {
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxTableDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'firstAppointmentDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxTableDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'processingStatus'?: RxTableDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'doctorReportStatus'?: RxTableDtoDoctorReportStatusEnum;
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof RxTableDto
     */
    'therapyRxs': Array<TherapyRxDto>;
    /**
     * 
     * @type {PatientDto}
     * @memberof RxTableDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {Array<DoctorReportDto>}
     * @memberof RxTableDto
     */
    'doctorReports'?: Array<DoctorReportDto>;
    /**
     * 
     * @type {InsurerDto}
     * @memberof RxTableDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {CreateDoctorDto}
     * @memberof RxTableDto
     */
    'doctor'?: CreateDoctorDto;
    /**
     * 
     * @type {CreateClinicDto}
     * @memberof RxTableDto
     */
    'clinic'?: CreateClinicDto;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'insuranceStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'insureeNumber'?: string;
    /**
     * 
     * @type {RxTypeDto}
     * @memberof RxTableDto
     */
    'rxtype'?: RxTypeDto;
    /**
     * 
     * @type {TarifGroupDto}
     * @memberof RxTableDto
     */
    'tarifGroup'?: TarifGroupDto;
    /**
     * 
     * @type {AccountDto}
     * @memberof RxTableDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {string}
     * @memberof RxTableDto
     */
    'createdAt'?: string;
}

export const RxTableDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxTableDtoProcessingStatusEnum = typeof RxTableDtoProcessingStatusEnum[keyof typeof RxTableDtoProcessingStatusEnum];
export const RxTableDtoDoctorReportStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type RxTableDtoDoctorReportStatusEnum = typeof RxTableDtoDoctorReportStatusEnum[keyof typeof RxTableDtoDoctorReportStatusEnum];

/**
 * 
 * @export
 * @interface RxTableFilters
 */
export interface RxTableFilters {
    /**
     * Number of items per page (Max = 50)
     * @type {number}
     * @memberof RxTableFilters
     */
    'limit'?: number;
    /**
     * Page number (Min = 1)
     * @type {number}
     * @memberof RxTableFilters
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof RxTableFilters
     */
    'rxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxTableFilters
     */
    'rxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxTableFilters
     */
    'location'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxTableFilters
     */
    'includeDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxTableFilters
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxTableFilters
     */
    'processingStatus'?: RxTableFiltersProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxTableFilters
     */
    'doctorReportStatus'?: RxTableFiltersDoctorReportStatusEnum;
    /**
     * Filter by tarif group ID
     * @type {string}
     * @memberof RxTableFilters
     */
    'tarifGroupId'?: string;
    /**
     * Filter by rx type ID
     * @type {string}
     * @memberof RxTableFilters
     */
    'rxTypeId'?: string;
    /**
     * Filter by account ID
     * @type {string}
     * @memberof RxTableFilters
     */
    'accountId'?: string;
    /**
     * Filter by prescribed therapy (term) ID — matches Rxs having at least one line with this term
     * @type {string}
     * @memberof RxTableFilters
     */
    'prescribedTherapyId'?: string;
    /**
     * Key-value pairs of sort fields and directions
     * @type {object}
     * @memberof RxTableFilters
     */
    'sortBy'?: object;
}

export const RxTableFiltersProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxTableFiltersProcessingStatusEnum = typeof RxTableFiltersProcessingStatusEnum[keyof typeof RxTableFiltersProcessingStatusEnum];
export const RxTableFiltersDoctorReportStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type RxTableFiltersDoctorReportStatusEnum = typeof RxTableFiltersDoctorReportStatusEnum[keyof typeof RxTableFiltersDoctorReportStatusEnum];

/**
 * 
 * @export
 * @interface RxTherapistInfoDto
 */
export interface RxTherapistInfoDto {
    /**
     * 
     * @type {string}
     * @memberof RxTherapistInfoDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RxTherapistInfoDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RxTherapistInfoDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RxTherapistInfoDto
     */
    'nickName'?: string | null;
}
/**
 * 
 * @export
 * @interface RxTypeDistributionDto
 */
export interface RxTypeDistributionDto {
    /**
     * Rx type identifier
     * @type {string}
     * @memberof RxTypeDistributionDto
     */
    'rxType': string;
    /**
     * Number of Rxs of this type
     * @type {number}
     * @memberof RxTypeDistributionDto
     */
    'count': number;
    /**
     * Percentage of total Rxs
     * @type {number}
     * @memberof RxTypeDistributionDto
     */
    'percentage': number;
    /**
     * Total amount for this Rx type
     * @type {number}
     * @memberof RxTypeDistributionDto
     */
    'totalAmount': number;
    /**
     * Average amount per Rx
     * @type {number}
     * @memberof RxTypeDistributionDto
     */
    'averageAmount': number;
}
/**
 * 
 * @export
 * @interface RxTypeDto
 */
export interface RxTypeDto {
    /**
     * 
     * @type {string}
     * @memberof RxTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxTypeDto
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface RxTypeMinimalDto
 */
export interface RxTypeMinimalDto {
    /**
     * Rx type ID
     * @type {string}
     * @memberof RxTypeMinimalDto
     */
    'id': string;
    /**
     * Rx type text
     * @type {string}
     * @memberof RxTypeMinimalDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface RxValidationBulkBatchDto
 */
export interface RxValidationBulkBatchDto {
    /**
     * Invalid Rx rows discovered in this batch
     * @type {Array<RxValidationBulkRowDto>}
     * @memberof RxValidationBulkBatchDto
     */
    'rows': Array<RxValidationBulkRowDto>;
    /**
     * Number of Rxs validated so far
     * @type {number}
     * @memberof RxValidationBulkBatchDto
     */
    'processed': number;
    /**
     * Total number of Rxs to validate in this run
     * @type {number}
     * @memberof RxValidationBulkBatchDto
     */
    'total': number;
    /**
     * Cumulative number of invalid Rxs found so far
     * @type {number}
     * @memberof RxValidationBulkBatchDto
     */
    'invalidCount': number;
}
/**
 * 
 * @export
 * @interface RxValidationBulkIssueDto
 */
export interface RxValidationBulkIssueDto {
    /**
     * Validator label of the failing check
     * @type {string}
     * @memberof RxValidationBulkIssueDto
     */
    'label': string;
    /**
     * Human readable failure message
     * @type {string}
     * @memberof RxValidationBulkIssueDto
     */
    'message': string;
    /**
     * True when the check could not be completed (it threw). Not a finding about the Rx — the Rx was not fully checked.
     * @type {boolean}
     * @memberof RxValidationBulkIssueDto
     */
    'checkFailed'?: boolean;
}
/**
 * 
 * @export
 * @interface RxValidationBulkJobResultDto
 */
export interface RxValidationBulkJobResultDto {
    /**
     * All Rxs with at least one failing validation check
     * @type {Array<RxValidationBulkRowDto>}
     * @memberof RxValidationBulkJobResultDto
     */
    'rows': Array<RxValidationBulkRowDto>;
    /**
     * Total number of Rxs that were validated
     * @type {number}
     * @memberof RxValidationBulkJobResultDto
     */
    'totalChecked': number;
    /**
     * Total number of Rxs found with at least one failing check
     * @type {number}
     * @memberof RxValidationBulkJobResultDto
     */
    'totalInvalid': number;
    /**
     * Number of Rxs that could not be fully checked — validation threw, or one of their checks did. These used to be dropped or counted as findings, which made repeated runs disagree (MD-184). Overlaps with totalInvalid when an Rx has both a real finding and a failed check.
     * @type {number}
     * @memberof RxValidationBulkJobResultDto
     */
    'totalFailed': number;
}
/**
 * 
 * @export
 * @interface RxValidationBulkRowDto
 */
export interface RxValidationBulkRowDto {
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxValidationBulkRowDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'firstAppointmentDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxValidationBulkRowDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'processingStatus'?: RxValidationBulkRowDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'doctorReportStatus'?: RxValidationBulkRowDtoDoctorReportStatusEnum;
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof RxValidationBulkRowDto
     */
    'therapyRxs': Array<TherapyRxDto>;
    /**
     * 
     * @type {PatientDto}
     * @memberof RxValidationBulkRowDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {Array<DoctorReportDto>}
     * @memberof RxValidationBulkRowDto
     */
    'doctorReports'?: Array<DoctorReportDto>;
    /**
     * 
     * @type {InsurerDto}
     * @memberof RxValidationBulkRowDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {CreateDoctorDto}
     * @memberof RxValidationBulkRowDto
     */
    'doctor'?: CreateDoctorDto;
    /**
     * 
     * @type {CreateClinicDto}
     * @memberof RxValidationBulkRowDto
     */
    'clinic'?: CreateClinicDto;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'insuranceStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'insureeNumber'?: string;
    /**
     * 
     * @type {RxTypeDto}
     * @memberof RxValidationBulkRowDto
     */
    'rxtype'?: RxTypeDto;
    /**
     * 
     * @type {TarifGroupDto}
     * @memberof RxValidationBulkRowDto
     */
    'tarifGroup'?: TarifGroupDto;
    /**
     * 
     * @type {AccountDto}
     * @memberof RxValidationBulkRowDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {string}
     * @memberof RxValidationBulkRowDto
     */
    'createdAt'?: string;
    /**
     * List of failing (Not Valid) validation checks for this Rx
     * @type {Array<RxValidationBulkIssueDto>}
     * @memberof RxValidationBulkRowDto
     */
    'issues': Array<RxValidationBulkIssueDto>;
}

export const RxValidationBulkRowDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxValidationBulkRowDtoProcessingStatusEnum = typeof RxValidationBulkRowDtoProcessingStatusEnum[keyof typeof RxValidationBulkRowDtoProcessingStatusEnum];
export const RxValidationBulkRowDtoDoctorReportStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;

export type RxValidationBulkRowDtoDoctorReportStatusEnum = typeof RxValidationBulkRowDtoDoctorReportStatusEnum[keyof typeof RxValidationBulkRowDtoDoctorReportStatusEnum];

/**
 * 
 * @export
 * @interface RxWaivableFeeDto
 */
export interface RxWaivableFeeDto {
    /**
     * 
     * @type {WaivableFee}
     * @memberof RxWaivableFeeDto
     */
    'fee': WaivableFee;
    /**
     * Catalog abbreviation of the fee, e.g. PBE
     * @type {string}
     * @memberof RxWaivableFeeDto
     */
    'abbreviation': string;
    /**
     * Catalog description of the fee
     * @type {string}
     * @memberof RxWaivableFeeDto
     */
    'description': string;
    /**
     * Price of the fee at the Rx date
     * @type {number}
     * @memberof RxWaivableFeeDto
     */
    'price': number;
    /**
     * true when the fee is waived, i.e. not charged
     * @type {boolean}
     * @memberof RxWaivableFeeDto
     */
    'waived': boolean;
}


/**
 * 
 * @export
 * @interface RxWithPriceAndAppointmentsDto
 */
export interface RxWithPriceAndAppointmentsDto {
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {PatientDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'patient'?: PatientDto;
    /**
     * Patient first name, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'firstName'?: string;
    /**
     * Patient last name, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'lastName'?: string;
    /**
     * Patient date of birth, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'dob'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'rxNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isPerpetualApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isCopaymentExempted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isAccident'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isBVG'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'approvalStatus'?: RxWithPriceAndAppointmentsDtoApprovalStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'validStartWindow'?: number;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'rxExpireDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'insuranceStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'insureeNumber'?: string;
    /**
     * 
     * @type {RxTypeDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'rxtype'?: RxTypeDto;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'symptoms'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'additionalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'additionalNotes2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'expectedTherapyLength'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'signatureStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isLongTermRx'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'a'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'c'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'hasIndividualSymptoms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'therapyStart'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'therapyReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'hygiene'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'doctorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'clinicId'?: string;
    /**
     * Official LANR (9 numeric digits)
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'LANR'?: string;
    /**
     * Official BSNR (9 numeric digits)
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'BSNR'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'diagnosisText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'diagnosisText2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'accountId'?: string;
    /**
     * 
     * @type {AccountDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'Receiptpayer'?: string;
    /**
     * Payer IK read from the patient\'s chip card. Equals the Insurer id (Institutionskennzeichen).
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'chipcard'?: string;
    /**
     * 
     * @type {InsurerDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'medicalPracticeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'accidentDay'?: string;
    /**
     * 
     * @type {DiagnosisGroupDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'diagnosegroup'?: DiagnosisGroupDto;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'therapy'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'problematic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'changeRequested'?: boolean;
    /**
     * 
     * @type {Array<ICDCodeEntryDto>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'icdCodeEntries'?: Array<ICDCodeEntryDto>;
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'therapyRxs'?: Array<TherapyRxDto>;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'rxSeriesId'?: string | null;
    /**
     * 
     * @type {RxSeriesDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'rxSeries'?: RxSeriesDto | null;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'unvirtualize'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'processingStatus'?: RxWithPriceAndAppointmentsDtoProcessingStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'messages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {CreateDoctorDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'doctor'?: CreateDoctorDto;
    /**
     * 
     * @type {CreateClinicDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'clinic'?: CreateClinicDto;
    /**
     * 
     * @type {Array<SublocalityDto>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'sublocalities'?: Array<SublocalityDto>;
    /**
     * 
     * @type {number}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'amountPaidByPatient': number;
    /**
     * 
     * @type {number}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'coPaymentValue': number;
    /**
     * 
     * @type {object}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'formvalidation': object;
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'appointmentShow'?: Array<AppointmentDto>;
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'appointments'?: Array<AppointmentDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'isTaxieren': boolean;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'therapyReportDetails'?: TherapyDetailsDto;
    /**
     * 
     * @type {CalculateRxDTO}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'rxPrice': CalculateRxDTO;
    /**
     * Selected line items for LINE_ITEM_CORRECTION bills
     * @type {Array<string>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'selectedLineItems'?: Array<string>;
    /**
     * All possible line items for the Rx (computed on the fly)
     * @type {Array<string>}
     * @memberof RxWithPriceAndAppointmentsDto
     */
    'allLineItems'?: Array<string>;
}

export const RxWithPriceAndAppointmentsDtoApprovalStatusEnum = {
    Fehlt: 'fehlt',
    IstBestellt: 'ist Bestellt',
    LiegtVor: 'liegt vor'
} as const;

export type RxWithPriceAndAppointmentsDtoApprovalStatusEnum = typeof RxWithPriceAndAppointmentsDtoApprovalStatusEnum[keyof typeof RxWithPriceAndAppointmentsDtoApprovalStatusEnum];
export const RxWithPriceAndAppointmentsDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxWithPriceAndAppointmentsDtoProcessingStatusEnum = typeof RxWithPriceAndAppointmentsDtoProcessingStatusEnum[keyof typeof RxWithPriceAndAppointmentsDtoProcessingStatusEnum];

/**
 * 
 * @export
 * @interface RxWithTherapistsDto
 */
export interface RxWithTherapistsDto {
    /**
     * 
     * @type {string}
     * @memberof RxWithTherapistsDto
     */
    'rxId': string;
    /**
     * 
     * @type {string}
     * @memberof RxWithTherapistsDto
     */
    'rxNumber': string;
    /**
     * 
     * @type {PatientInfo}
     * @memberof RxWithTherapistsDto
     */
    'patient': PatientInfo;
    /**
     * 
     * @type {string}
     * @memberof RxWithTherapistsDto
     */
    'rxType': string;
    /**
     * 
     * @type {string}
     * @memberof RxWithTherapistsDto
     */
    'locationId': string;
    /**
     * 
     * @type {number}
     * @memberof RxWithTherapistsDto
     */
    'therapistCount': number;
    /**
     * 
     * @type {Array<TherapistInfo>}
     * @memberof RxWithTherapistsDto
     */
    'therapists': Array<TherapistInfo>;
    /**
     * 
     * @type {Array<TherapyRxAmountInfo>}
     * @memberof RxWithTherapistsDto
     */
    'therapyRxAmounts': Array<TherapyRxAmountInfo>;
}
/**
 * 
 * @export
 * @interface RxWriteDto
 */
export interface RxWriteDto {
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxWriteDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {PatientDto}
     * @memberof RxWriteDto
     */
    'patient'?: PatientDto;
    /**
     * Patient first name, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxWriteDto
     */
    'firstName'?: string;
    /**
     * Patient last name, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxWriteDto
     */
    'lastName'?: string;
    /**
     * Patient date of birth, sent flat by the Rx form for live validation.
     * @type {string}
     * @memberof RxWriteDto
     */
    'dob'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'rxNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isPerpetual'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isPerpetualApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isCopaymentExempted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isAccident'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isBVG'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'approvalStatus'?: RxWriteDtoApprovalStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof RxWriteDto
     */
    'validStartWindow'?: number;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'rxExpireDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'insuranceStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'insureeNumber'?: string;
    /**
     * 
     * @type {RxTypeDto}
     * @memberof RxWriteDto
     */
    'rxtype'?: RxTypeDto;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'symptoms'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'additionalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'additionalNotes2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'expectedTherapyLength'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'signatureStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isLongTermRx'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'a'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'c'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'hasIndividualSymptoms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'therapyStart'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'therapyReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'isHomeVisit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'urgent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'hygiene'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'doctorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'clinicId'?: string;
    /**
     * Official LANR (9 numeric digits)
     * @type {string}
     * @memberof RxWriteDto
     */
    'LANR'?: string;
    /**
     * Official BSNR (9 numeric digits)
     * @type {string}
     * @memberof RxWriteDto
     */
    'BSNR'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'diagnosisText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'diagnosisText2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'accountId'?: string;
    /**
     * 
     * @type {AccountDto}
     * @memberof RxWriteDto
     */
    'account'?: AccountDto;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'Receiptpayer'?: string;
    /**
     * Payer IK read from the patient\'s chip card. Equals the Insurer id (Institutionskennzeichen).
     * @type {string}
     * @memberof RxWriteDto
     */
    'chipcard'?: string;
    /**
     * 
     * @type {InsurerDto}
     * @memberof RxWriteDto
     */
    'payer'?: InsurerDto;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof RxWriteDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'medicalPracticeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'accidentDay'?: string;
    /**
     * 
     * @type {DiagnosisGroupDto}
     * @memberof RxWriteDto
     */
    'diagnosegroup'?: DiagnosisGroupDto;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'therapy'?: string;
    /**
     * 
     * @type {number}
     * @memberof RxWriteDto
     */
    'number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'problematic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'changeRequested'?: boolean;
    /**
     * 
     * @type {Array<ICDCodeEntryDto>}
     * @memberof RxWriteDto
     */
    'icdCodeEntries'?: Array<ICDCodeEntryDto>;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'rxSeriesId'?: string | null;
    /**
     * 
     * @type {RxSeriesDto}
     * @memberof RxWriteDto
     */
    'rxSeries'?: RxSeriesDto | null;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof RxWriteDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RxWriteDto
     */
    'unvirtualize'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'processingStatus'?: RxWriteDtoProcessingStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RxWriteDto
     */
    'messages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RxWriteDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {CreateDoctorDto}
     * @memberof RxWriteDto
     */
    'doctor'?: CreateDoctorDto;
    /**
     * 
     * @type {CreateClinicDto}
     * @memberof RxWriteDto
     */
    'clinic'?: CreateClinicDto;
    /**
     * 
     * @type {Array<SublocalityDto>}
     * @memberof RxWriteDto
     */
    'sublocalities'?: Array<SublocalityDto>;
    /**
     * 
     * @type {Array<TherapyRxWriteDto>}
     * @memberof RxWriteDto
     */
    'therapyRxs'?: Array<TherapyRxWriteDto>;
}

export const RxWriteDtoApprovalStatusEnum = {
    Fehlt: 'fehlt',
    IstBestellt: 'ist Bestellt',
    LiegtVor: 'liegt vor'
} as const;

export type RxWriteDtoApprovalStatusEnum = typeof RxWriteDtoApprovalStatusEnum[keyof typeof RxWriteDtoApprovalStatusEnum];
export const RxWriteDtoProcessingStatusEnum = {
    InBehandlung: 'in Behandlung',
    Abgeschlossen: 'abgeschlossen',
    Abgerechnet: 'abgerechnet',
    Abgebrochen: 'abgebrochen',
    ZurKontrolle: 'zur Kontrolle'
} as const;

export type RxWriteDtoProcessingStatusEnum = typeof RxWriteDtoProcessingStatusEnum[keyof typeof RxWriteDtoProcessingStatusEnum];

/**
 * 
 * @export
 * @interface SEPAExportResultDto
 */
export interface SEPAExportResultDto {
    /**
     * Whether the export was successful
     * @type {boolean}
     * @memberof SEPAExportResultDto
     */
    'success': boolean;
    /**
     * Document ID of the exported SEPA file
     * @type {string}
     * @memberof SEPAExportResultDto
     */
    'documentId': string;
    /**
     * File name of the exported SEPA file
     * @type {string}
     * @memberof SEPAExportResultDto
     */
    'fileName': string;
    /**
     * Download URL for the exported SEPA file
     * @type {string}
     * @memberof SEPAExportResultDto
     */
    'downloadUrl': string;
    /**
     * Number of LastSchrift transactions successfully exported
     * @type {number}
     * @memberof SEPAExportResultDto
     */
    'exportedCount': number;
    /**
     * Number of LastSchrift transactions that could not be exported due to missing debit permissions
     * @type {number}
     * @memberof SEPAExportResultDto
     */
    'skippedCount': number;
    /**
     * Total amount of exported transactions in EUR
     * @type {number}
     * @memberof SEPAExportResultDto
     */
    'totalAmount': number;
    /**
     * List of LastSchrift IDs that were successfully exported
     * @type {Array<string>}
     * @memberof SEPAExportResultDto
     */
    'exportedIds': Array<string>;
    /**
     * List of LastSchrift IDs that were skipped due to missing debit permissions
     * @type {Array<string>}
     * @memberof SEPAExportResultDto
     */
    'skippedIds': Array<string>;
    /**
     * Detailed message about the export result
     * @type {string}
     * @memberof SEPAExportResultDto
     */
    'message': string;
    /**
     * Document info for the SEPA export PDF
     * @type {object}
     * @memberof SEPAExportResultDto
     */
    'sepaExportDocument'?: object;
}
/**
 * 
 * @export
 * @interface SalesTemplateDto
 */
export interface SalesTemplateDto {
    /**
     * 
     * @type {Array<TherapyDto>}
     * @memberof SalesTemplateDto
     */
    'therapies': Array<TherapyDto>;
    /**
     * 
     * @type {PatientDto}
     * @memberof SalesTemplateDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {number}
     * @memberof SalesTemplateDto
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesTemplateDto
     */
    'addressId'?: string;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof SalesTemplateDto
     */
    'visitFee'?: TherapyDetailsDto;
}
/**
 * 
 * @export
 * @interface SalesTimeSlotDto
 */
export interface SalesTimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'id'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof SalesTimeSlotDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {TherapyDto}
     * @memberof SalesTimeSlotDto
     */
    'visitFee'?: TherapyDto;
    /**
     * 
     * @type {PatientDto}
     * @memberof SalesTimeSlotDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof SalesTimeSlotDto
     */
    'therapy'?: TherapyDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof SalesTimeSlotDto
     */
    'performedIntervals'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {TherapyRxDto}
     * @memberof SalesTimeSlotDto
     */
    'therapyRx'?: TherapyRxDto;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'end': string;
    /**
     * 
     * @type {boolean}
     * @memberof SalesTimeSlotDto
     */
    'attended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesTimeSlotDto
     */
    'therapyIsManuallyChosen'?: boolean;
    /**
     * 
     * @type {TreatmentNoteDTO}
     * @memberof SalesTimeSlotDto
     */
    'treatmentNote'?: TreatmentNoteDTO | null;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'treatmentIndex'?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesTimeSlotDto
     */
    'wasDocumentedCount'?: number;
    /**
     * 
     * @type {AddressCoordinateDto}
     * @memberof SalesTimeSlotDto
     */
    'startAddress'?: AddressCoordinateDto;
    /**
     * 
     * @type {string}
     * @memberof SalesTimeSlotDto
     */
    'groupAppointmentId'?: string;
    /**
     * 
     * @type {PatientInformingProjectionDto}
     * @memberof SalesTimeSlotDto
     */
    'informing'?: PatientInformingProjectionDto | null;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof SalesTimeSlotDto
     */
    'service': TherapyDetailsDto;
    /**
     * 
     * @type {object}
     * @memberof SalesTimeSlotDto
     */
    'transaction'?: object;
}
/**
 * 
 * @export
 * @interface SaveCalendarColumnOrderDto
 */
export interface SaveCalendarColumnOrderDto {
    /**
     * 
     * @type {string}
     * @memberof SaveCalendarColumnOrderDto
     */
    'locationId': string;
    /**
     * User ids in the desired left-to-right column order
     * @type {Array<string>}
     * @memberof SaveCalendarColumnOrderDto
     */
    'userIds': Array<string>;
}
/**
 * 
 * @export
 * @interface SaveRxFromExtractionDto
 */
export interface SaveRxFromExtractionDto {
    /**
     * ID of an existing Rx to update. If null, a new Rx is created.
     * @type {object}
     * @memberof SaveRxFromExtractionDto
     */
    'rxId'?: object | null;
    /**
     * Account (Mandant) ID to assign to the Rx
     * @type {object}
     * @memberof SaveRxFromExtractionDto
     */
    'accountId'?: object | null;
    /**
     * Signature status override (Arztunterschrift)
     * @type {string}
     * @memberof SaveRxFromExtractionDto
     */
    'signatureStatus'?: SaveRxFromExtractionDtoSignatureStatusEnum;
    /**
     * Whether the existing Rx is a Dauerrezept that should be unvirtualized
     * @type {boolean}
     * @memberof SaveRxFromExtractionDto
     */
    'unvirtualize'?: boolean;
    /**
     * 
     * @type {RxExtractionDto}
     * @memberof SaveRxFromExtractionDto
     */
    'extraction': RxExtractionDto;
}

export const SaveRxFromExtractionDtoSignatureStatusEnum = {
    NichtKontrolliert: 'nicht kontrolliert',
    Vorhanden: 'vorhanden',
    Fehlend: 'fehlend'
} as const;

export type SaveRxFromExtractionDtoSignatureStatusEnum = typeof SaveRxFromExtractionDtoSignatureStatusEnum[keyof typeof SaveRxFromExtractionDtoSignatureStatusEnum];

/**
 * 
 * @export
 * @interface SaveRxResponse
 */
export interface SaveRxResponse {
    /**
     * 
     * @type {RxDto}
     * @memberof SaveRxResponse
     */
    'rx': RxDto;
    /**
     * 
     * @type {Array<TherapyRxDto>}
     * @memberof SaveRxResponse
     */
    'therapies': Array<TherapyRxDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveRxResponse
     */
    'validRxSeriesIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ScheduleAgentResultDto
 */
export interface ScheduleAgentResultDto {
    /**
     * 
     * @type {Array<AgentActionGroupDto>}
     * @memberof ScheduleAgentResultDto
     */
    'agentActionGroups': Array<AgentActionGroupDto>;
}
/**
 * 
 * @export
 * @interface ScheduleBasedStatsDto
 */
export interface ScheduleBasedStatsDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduleBasedStatsDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBasedStatsDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBasedStatsDto
     */
    'locationName': string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleBasedStatsDto
     */
    'rxCount': number;
    /**
     * 
     * @type {number}
     * @memberof ScheduleBasedStatsDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof ScheduleBasedStatsDto
     */
    'gaps': number;
}
/**
 * 
 * @export
 * @interface ScheduleBasedTherapyRxFrequencyDto
 */
export interface ScheduleBasedTherapyRxFrequencyDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduleBasedTherapyRxFrequencyDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBasedTherapyRxFrequencyDto
     */
    'therapyRxWeekKey': string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleBasedTherapyRxFrequencyDto
     */
    'therapyRxFrequency': number;
}
/**
 * 
 * @export
 * @interface ScheduleBootstrapDto
 */
export interface ScheduleBootstrapDto {
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof ScheduleBootstrapDto
     */
    'appointments': Array<AppointmentDto>;
    /**
     * 
     * @type {Array<PatientDto>}
     * @memberof ScheduleBootstrapDto
     */
    'patients': Array<PatientDto>;
    /**
     * 
     * @type {Array<NextAppointmentResultDto>}
     * @memberof ScheduleBootstrapDto
     */
    'nextAppointments': Array<NextAppointmentResultDto>;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof ScheduleBootstrapDto
     */
    'appointmentNotes': Array<NoteDto>;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof ScheduleBootstrapDto
     */
    'patientNotes': Array<NoteDto>;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof ScheduleBootstrapDto
     */
    'rxNotes': Array<NoteDto>;
    /**
     * 
     * @type {Array<TreatmentNotesByPatientDto>}
     * @memberof ScheduleBootstrapDto
     */
    'treatmentNotes': Array<TreatmentNotesByPatientDto>;
    /**
     * 
     * @type {Array<DoctorReportStatusByRxDto>}
     * @memberof ScheduleBootstrapDto
     */
    'doctorReportStatuses': Array<DoctorReportStatusByRxDto>;
    /**
     * 
     * @type {Array<InitialEvaluationsByPatientDto>}
     * @memberof ScheduleBootstrapDto
     */
    'initialEvaluations': Array<InitialEvaluationsByPatientDto>;
}
/**
 * 
 * @export
 * @interface ScheduledAppointmentMinimalDto
 */
export interface ScheduledAppointmentMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduledAppointmentMinimalDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledAppointmentMinimalDto
     */
    'end'?: string;
    /**
     * 
     * @type {Array<ScheduledTimeSlotMinimalDto>}
     * @memberof ScheduledAppointmentMinimalDto
     */
    'timeSlots': Array<ScheduledTimeSlotMinimalDto>;
}
/**
 * 
 * @export
 * @interface ScheduledRxMinimalDto
 */
export interface ScheduledRxMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduledRxMinimalDto
     */
    'id'?: string;
    /**
     * 
     * @type {DiagnosisGroupDto}
     * @memberof ScheduledRxMinimalDto
     */
    'diagnosegroup'?: DiagnosisGroupDto;
    /**
     * 
     * @type {Array<ICDCodeEntryDto>}
     * @memberof ScheduledRxMinimalDto
     */
    'icdCodeEntries'?: Array<ICDCodeEntryDto>;
    /**
     * 
     * @type {ScheduledRxSeriesMinimalDto}
     * @memberof ScheduledRxMinimalDto
     */
    'rxSeries'?: ScheduledRxSeriesMinimalDto;
}
/**
 * 
 * @export
 * @interface ScheduledRxSeriesMinimalDto
 */
export interface ScheduledRxSeriesMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduledRxSeriesMinimalDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ScheduledTherapyRxMinimalDto
 */
export interface ScheduledTherapyRxMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduledTherapyRxMinimalDto
     */
    'id'?: string;
    /**
     * 
     * @type {ScheduledRxMinimalDto}
     * @memberof ScheduledTherapyRxMinimalDto
     */
    'rx'?: ScheduledRxMinimalDto;
}
/**
 * 
 * @export
 * @interface ScheduledTimeSlotMinimalDto
 */
export interface ScheduledTimeSlotMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduledTimeSlotMinimalDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTimeSlotMinimalDto
     */
    'end'?: string;
    /**
     * 
     * @type {ScheduledUserMinimalDto}
     * @memberof ScheduledTimeSlotMinimalDto
     */
    'user'?: ScheduledUserMinimalDto;
    /**
     * 
     * @type {ScheduledTherapyRxMinimalDto}
     * @memberof ScheduledTimeSlotMinimalDto
     */
    'therapyRx'?: ScheduledTherapyRxMinimalDto;
}
/**
 * 
 * @export
 * @interface ScheduledUserMinimalDto
 */
export interface ScheduledUserMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduledUserMinimalDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface SearchDoctorDto
 */
export interface SearchDoctorDto {
    /**
     * 
     * @type {string}
     * @memberof SearchDoctorDto
     */
    'searchTerm'?: string;
}
/**
 * 
 * @export
 * @interface SearchResponseDto
 */
export interface SearchResponseDto {
    /**
     * Unified list. Clients can group by `locationMatch`.
     * @type {Array<BaseResultDto>}
     * @memberof SearchResponseDto
     */
    'results': Array<BaseResultDto>;
}
/**
 * 
 * @export
 * @interface SendBIReportCSVEmailRequest
 */
export interface SendBIReportCSVEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendBIReportCSVEmailRequest
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof SendBIReportCSVEmailRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof SendBIReportCSVEmailRequest
     */
    'csvData': string;
    /**
     * 
     * @type {string}
     * @memberof SendBIReportCSVEmailRequest
     */
    'filename'?: string;
}
/**
 * 
 * @export
 * @interface SendBillEmailDto
 */
export interface SendBillEmailDto {
    /**
     * Whether to attach the Rechnung (invoice) PDF. Defaults to true when omitted.
     * @type {boolean}
     * @memberof SendBillEmailDto
     */
    'includeRechnung'?: boolean;
    /**
     * IDs of the BillReminder (Mahnung) PDFs belonging to this Rechnung that should be attached.
     * @type {Array<string>}
     * @memberof SendBillEmailDto
     */
    'billReminderIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SepaAccountRefDto
 */
export interface SepaAccountRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaAccountRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaAccountRefDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface SepaBankAccountRefDto
 */
export interface SepaBankAccountRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaBankAccountRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaBankAccountRefDto
     */
    'holderFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof SepaBankAccountRefDto
     */
    'holderLastName': string;
    /**
     * 
     * @type {string}
     * @memberof SepaBankAccountRefDto
     */
    'iban': string;
    /**
     * 
     * @type {object}
     * @memberof SepaBankAccountRefDto
     */
    'bic'?: object | null;
}
/**
 * 
 * @export
 * @interface SepaDocumentRefDto
 */
export interface SepaDocumentRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaDocumentRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaDocumentRefDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SepaDocumentRefDto
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof SepaDocumentRefDto
     */
    'container'?: string;
    /**
     * Temporary, ready-to-download access URL. Populated on the export-create response so the UI can auto-download the XML/PDF immediately.
     * @type {string}
     * @memberof SepaDocumentRefDto
     */
    'accessUrl'?: string;
}
/**
 * 
 * @export
 * @interface SepaExportBatchPageDto
 */
export interface SepaExportBatchPageDto {
    /**
     * 
     * @type {Array<SepaExportBatchResponseDto>}
     * @memberof SepaExportBatchPageDto
     */
    'data': Array<SepaExportBatchResponseDto>;
    /**
     * Opaque cursor for the next page, or null on the last page.
     * @type {object}
     * @memberof SepaExportBatchPageDto
     */
    'nextCursor': object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SepaExportBatchPageDto
     */
    'hasMore': boolean;
}
/**
 * 
 * @export
 * @interface SepaExportBatchRefDto
 */
export interface SepaExportBatchRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchRefDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SepaExportBatchRefDto
     */
    'batchNumber': number;
}
/**
 * 
 * @export
 * @interface SepaExportBatchResponseDto
 */
export interface SepaExportBatchResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SepaExportBatchResponseDto
     */
    'batchNumber': number;
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'direction': SepaExportBatchResponseDtoDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'status': SepaExportBatchResponseDtoStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof SepaExportBatchResponseDto
     */
    'messageId': object | null;
    /**
     * 
     * @type {number}
     * @memberof SepaExportBatchResponseDto
     */
    'transactionCount': number;
    /**
     * 
     * @type {number}
     * @memberof SepaExportBatchResponseDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'undoneAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'undoReason'?: string | null;
    /**
     * When the file was marked as submitted to the bank.
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'sentAt'?: string | null;
    /**
     * When the bank acknowledged (accepted/rejected) the file.
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'acknowledgedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SepaExportBatchResponseDto
     */
    'rejectionReason'?: string | null;
    /**
     * 
     * @type {SepaAccountRefDto}
     * @memberof SepaExportBatchResponseDto
     */
    'account'?: SepaAccountRefDto;
    /**
     * 
     * @type {SepaUserRefDto}
     * @memberof SepaExportBatchResponseDto
     */
    'createdBy'?: SepaUserRefDto | null;
    /**
     * 
     * @type {SepaUserRefDto}
     * @memberof SepaExportBatchResponseDto
     */
    'undoneBy'?: SepaUserRefDto | null;
    /**
     * 
     * @type {SepaUserRefDto}
     * @memberof SepaExportBatchResponseDto
     */
    'sentBy'?: SepaUserRefDto | null;
    /**
     * 
     * @type {SepaDocumentRefDto}
     * @memberof SepaExportBatchResponseDto
     */
    'xmlDocument'?: SepaDocumentRefDto | null;
    /**
     * 
     * @type {SepaDocumentRefDto}
     * @memberof SepaExportBatchResponseDto
     */
    'pdfDocument'?: SepaDocumentRefDto | null;
    /**
     * 
     * @type {Array<SepaTransactionResponseDto>}
     * @memberof SepaExportBatchResponseDto
     */
    'transactions'?: Array<SepaTransactionResponseDto>;
}

export const SepaExportBatchResponseDtoDirectionEnum = {
    DirectDebit: 'DIRECT_DEBIT',
    CreditTransfer: 'CREDIT_TRANSFER'
} as const;

export type SepaExportBatchResponseDtoDirectionEnum = typeof SepaExportBatchResponseDtoDirectionEnum[keyof typeof SepaExportBatchResponseDtoDirectionEnum];
export const SepaExportBatchResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    SentToBank: 'SENT_TO_BANK',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Undone: 'UNDONE',
    Reversed: 'REVERSED'
} as const;

export type SepaExportBatchResponseDtoStatusEnum = typeof SepaExportBatchResponseDtoStatusEnum[keyof typeof SepaExportBatchResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface SepaMandateRefDto
 */
export interface SepaMandateRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaMandateRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaMandateRefDto
     */
    'status': SepaMandateRefDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SepaMandateRefDto
     */
    'sequenceType': SepaMandateRefDtoSequenceTypeEnum;
}

export const SepaMandateRefDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Used: 'USED',
    Revoked: 'REVOKED',
    Expired: 'EXPIRED'
} as const;

export type SepaMandateRefDtoStatusEnum = typeof SepaMandateRefDtoStatusEnum[keyof typeof SepaMandateRefDtoStatusEnum];
export const SepaMandateRefDtoSequenceTypeEnum = {
    Ooff: 'OOFF',
    Rcur: 'RCUR'
} as const;

export type SepaMandateRefDtoSequenceTypeEnum = typeof SepaMandateRefDtoSequenceTypeEnum[keyof typeof SepaMandateRefDtoSequenceTypeEnum];

/**
 * 
 * @export
 * @interface SepaPatientRefDto
 */
export interface SepaPatientRefDto {
    /**
     * 
     * @type {number}
     * @memberof SepaPatientRefDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SepaPatientRefDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SepaPatientRefDto
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface SepaReversalRefDto
 */
export interface SepaReversalRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaReversalRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaReversalRefDto
     */
    'transactionNumber'?: string;
}
/**
 * 
 * @export
 * @interface SepaRxRefDto
 */
export interface SepaRxRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaRxRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaRxRefDto
     */
    'rxNumber'?: string;
    /**
     * Prescription (Rx) date.
     * @type {object}
     * @memberof SepaRxRefDto
     */
    'date'?: object | null;
}
/**
 * 
 * @export
 * @interface SepaTimelineEventDto
 */
export interface SepaTimelineEventDto {
    /**
     * 
     * @type {string}
     * @memberof SepaTimelineEventDto
     */
    'type': SepaTimelineEventDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SepaTimelineEventDto
     */
    'date': string;
    /**
     * Full name of the acting user, when known.
     * @type {string}
     * @memberof SepaTimelineEventDto
     */
    'actorName'?: string | null;
    /**
     * Human-friendly export number, for export-related events.
     * @type {number}
     * @memberof SepaTimelineEventDto
     */
    'batchNumber'?: number | null;
    /**
     * Reason recorded for a rejection or a rollback.
     * @type {string}
     * @memberof SepaTimelineEventDto
     */
    'reason'?: string | null;
    /**
     * Transaction amount, present on the creation event.
     * @type {number}
     * @memberof SepaTimelineEventDto
     */
    'amount'?: number | null;
}

export const SepaTimelineEventDtoTypeEnum = {
    Created: 'CREATED',
    Exported: 'EXPORTED',
    SentToBank: 'SENT_TO_BANK',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    RolledBack: 'ROLLED_BACK',
    Cancelled: 'CANCELLED',
    Deleted: 'DELETED'
} as const;

export type SepaTimelineEventDtoTypeEnum = typeof SepaTimelineEventDtoTypeEnum[keyof typeof SepaTimelineEventDtoTypeEnum];

/**
 * 
 * @export
 * @interface SepaTransactionPageDto
 */
export interface SepaTransactionPageDto {
    /**
     * 
     * @type {Array<SepaTransactionResponseDto>}
     * @memberof SepaTransactionPageDto
     */
    'data': Array<SepaTransactionResponseDto>;
    /**
     * Opaque cursor for the next page, or null on the last page.
     * @type {object}
     * @memberof SepaTransactionPageDto
     */
    'nextCursor': object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SepaTransactionPageDto
     */
    'hasMore': boolean;
}
/**
 * 
 * @export
 * @interface SepaTransactionResponseDto
 */
export interface SepaTransactionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDto
     */
    'transactionNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDto
     */
    'direction': SepaTransactionResponseDtoDirectionEnum;
    /**
     * Positive for a normal movement; negative for a reversal (storno) entry.
     * @type {number}
     * @memberof SepaTransactionResponseDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDto
     */
    'status': SepaTransactionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {SepaPatientRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'patient'?: SepaPatientRefDto;
    /**
     * 
     * @type {SepaBankAccountRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'bankAccount'?: SepaBankAccountRefDto;
    /**
     * 
     * @type {SepaMandateRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'mandate'?: SepaMandateRefDto | null;
    /**
     * 
     * @type {SepaRxRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'rx'?: SepaRxRefDto | null;
    /**
     * 
     * @type {SepaAccountRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'account'?: SepaAccountRefDto;
    /**
     * 
     * @type {SepaExportBatchRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'exportBatch'?: SepaExportBatchRefDto | null;
    /**
     * 
     * @type {SepaUserRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'user'?: SepaUserRefDto | null;
    /**
     * 
     * @type {SepaTxnDocumentRefDto}
     * @memberof SepaTransactionResponseDto
     */
    'document'?: SepaTxnDocumentRefDto | null;
    /**
     * 
     * @type {SepaTransactionResponseDtoReversalOf}
     * @memberof SepaTransactionResponseDto
     */
    'reversalOf'?: SepaTransactionResponseDtoReversalOf | null;
}

export const SepaTransactionResponseDtoDirectionEnum = {
    DirectDebit: 'DIRECT_DEBIT',
    CreditTransfer: 'CREDIT_TRANSFER'
} as const;

export type SepaTransactionResponseDtoDirectionEnum = typeof SepaTransactionResponseDtoDirectionEnum[keyof typeof SepaTransactionResponseDtoDirectionEnum];
export const SepaTransactionResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Exported: 'EXPORTED',
    Settled: 'SETTLED',
    Returned: 'RETURNED',
    Cancelled: 'CANCELLED',
    Reversed: 'REVERSED'
} as const;

export type SepaTransactionResponseDtoStatusEnum = typeof SepaTransactionResponseDtoStatusEnum[keyof typeof SepaTransactionResponseDtoStatusEnum];

/**
 * Set when this row is a reversal (storno) — points to the original transaction.
 * @export
 * @interface SepaTransactionResponseDtoReversalOf
 */
export interface SepaTransactionResponseDtoReversalOf {
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDtoReversalOf
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionResponseDtoReversalOf
     */
    'transactionNumber'?: string;
}
/**
 * 
 * @export
 * @interface SepaTransactionTimelineDto
 */
export interface SepaTransactionTimelineDto {
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionTimelineDto
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionTimelineDto
     */
    'transactionNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionTimelineDto
     */
    'direction': SepaTransactionTimelineDtoDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof SepaTransactionTimelineDto
     */
    'status': SepaTransactionTimelineDtoStatusEnum;
    /**
     * 
     * @type {Array<SepaTimelineEventDto>}
     * @memberof SepaTransactionTimelineDto
     */
    'events': Array<SepaTimelineEventDto>;
}

export const SepaTransactionTimelineDtoDirectionEnum = {
    DirectDebit: 'DIRECT_DEBIT',
    CreditTransfer: 'CREDIT_TRANSFER'
} as const;

export type SepaTransactionTimelineDtoDirectionEnum = typeof SepaTransactionTimelineDtoDirectionEnum[keyof typeof SepaTransactionTimelineDtoDirectionEnum];
export const SepaTransactionTimelineDtoStatusEnum = {
    Pending: 'PENDING',
    Exported: 'EXPORTED',
    Settled: 'SETTLED',
    Returned: 'RETURNED',
    Cancelled: 'CANCELLED',
    Reversed: 'REVERSED'
} as const;

export type SepaTransactionTimelineDtoStatusEnum = typeof SepaTransactionTimelineDtoStatusEnum[keyof typeof SepaTransactionTimelineDtoStatusEnum];

/**
 * 
 * @export
 * @interface SepaTxnDocumentRefDto
 */
export interface SepaTxnDocumentRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaTxnDocumentRefDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface SepaUserRefDto
 */
export interface SepaUserRefDto {
    /**
     * 
     * @type {string}
     * @memberof SepaUserRefDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SepaUserRefDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SepaUserRefDto
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface SeriesSwapAppointmentsDto
 */
export interface SeriesSwapAppointmentsDto {
    /**
     * 
     * @type {string}
     * @memberof SeriesSwapAppointmentsDto
     */
    'seriesId': string;
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof SeriesSwapAppointmentsDto
     */
    'appointments': Array<AppointmentDto>;
}
/**
 * 
 * @export
 * @interface SetAppointmentInformedDto
 */
export interface SetAppointmentInformedDto {
    /**
     * 
     * @type {string}
     * @memberof SetAppointmentInformedDto
     */
    'appointmentId': string;
    /**
     * 
     * @type {boolean}
     * @memberof SetAppointmentInformedDto
     */
    'informed': boolean;
}
/**
 * 
 * @export
 * @interface SetResolutionDto
 */
export interface SetResolutionDto {
    /**
     * 
     * @type {string}
     * @memberof SetResolutionDto
     */
    'therapyMethodId': string;
    /**
     * Higher wins. 100 is the canonical first choice.
     * @type {number}
     * @memberof SetResolutionDto
     */
    'priority': number;
}
/**
 * 
 * @export
 * @interface SetRxFeeWaiversDto
 */
export interface SetRxFeeWaiversDto {
    /**
     * The complete set of fees to waive on this Rx; every other fee is charged.
     * @type {Array<WaivableFee>}
     * @memberof SetRxFeeWaiversDto
     */
    'waivedFees': Array<WaivableFee>;
}
/**
 * 
 * @export
 * @interface SetTherapyRxTherapyDto
 */
export interface SetTherapyRxTherapyDto {
    /**
     * The chosen line-item id. Null returns the line to automatic resolution (default rule).
     * @type {string}
     * @memberof SetTherapyRxTherapyDto
     */
    'therapyId': string | null;
}
/**
 * 
 * @export
 * @interface SetTimeSlotTherapyDto
 */
export interface SetTimeSlotTherapyDto {
    /**
     * The chosen line-item id. Null resets the slot to automatic resolution (default rule).
     * @type {string}
     * @memberof SetTimeSlotTherapyDto
     */
    'therapyId': string | null;
}
/**
 * 
 * @export
 * @interface SimpleSwapAssignmentDto
 */
export interface SimpleSwapAssignmentDto {
    /**
     * Treatment ID
     * @type {string}
     * @memberof SimpleSwapAssignmentDto
     */
    'treatmentId': string;
    /**
     * Previous TherapyRx ID (null if none)
     * @type {object}
     * @memberof SimpleSwapAssignmentDto
     */
    'fromTherapyRxId'?: object;
    /**
     * Target TherapyRx ID
     * @type {string}
     * @memberof SimpleSwapAssignmentDto
     */
    'toTherapyRxId': string;
    /**
     * Target Rx number
     * @type {string}
     * @memberof SimpleSwapAssignmentDto
     */
    'toRxNumber': string;
    /**
     * Whether this assignment represents a change
     * @type {boolean}
     * @memberof SimpleSwapAssignmentDto
     */
    'changed': boolean;
}
/**
 * 
 * @export
 * @interface SimpleSwapErrorDto
 */
export interface SimpleSwapErrorDto {
    /**
     * 
     * @type {SwapErrorType}
     * @memberof SimpleSwapErrorDto
     */
    'type': SwapErrorType;
    /**
     * Treatment ID (if applicable)
     * @type {string}
     * @memberof SimpleSwapErrorDto
     */
    'treatmentId'?: string;
    /**
     * TherapyRx ID (if applicable)
     * @type {string}
     * @memberof SimpleSwapErrorDto
     */
    'therapyRxId'?: string;
    /**
     * Rx number (if applicable)
     * @type {string}
     * @memberof SimpleSwapErrorDto
     */
    'rxNumber'?: string;
    /**
     * Lane / therapy term (if applicable)
     * @type {string}
     * @memberof SimpleSwapErrorDto
     */
    'lane'?: string;
    /**
     * Human-readable error message
     * @type {string}
     * @memberof SimpleSwapErrorDto
     */
    'message': string;
}


/**
 * 
 * @export
 * @interface SimpleSwapRequestDto
 */
export interface SimpleSwapRequestDto {
    /**
     * Series IDs to swap
     * @type {Array<string>}
     * @memberof SimpleSwapRequestDto
     */
    'seriesIds': Array<string>;
    /**
     * If true (default), returns preview only. If false, executes the swap.
     * @type {boolean}
     * @memberof SimpleSwapRequestDto
     */
    'previewMode'?: boolean;
    /**
     * Enforce Rx capacity (amount). If false, treatments keep their current Rx, just reordered.
     * @type {boolean}
     * @memberof SimpleSwapRequestDto
     */
    'enforceAmounts'?: boolean;
}
/**
 * 
 * @export
 * @interface SimpleSwapResponseDto
 */
export interface SimpleSwapResponseDto {
    /**
     * True if this is a preview (no commit yet)
     * @type {boolean}
     * @memberof SimpleSwapResponseDto
     */
    'preview': boolean;
    /**
     * Assignments computed by the algorithm
     * @type {Array<SimpleSwapAssignmentDto>}
     * @memberof SimpleSwapResponseDto
     */
    'assignments': Array<SimpleSwapAssignmentDto>;
    /**
     * Errors from computation phase
     * @type {Array<SimpleSwapErrorDto>}
     * @memberof SimpleSwapResponseDto
     */
    'computeErrors': Array<SimpleSwapErrorDto>;
    /**
     * Errors from validation phase
     * @type {Array<SimpleSwapErrorDto>}
     * @memberof SimpleSwapResponseDto
     */
    'validationErrors': Array<SimpleSwapErrorDto>;
    /**
     * Warnings
     * @type {Array<SimpleSwapWarningDto>}
     * @memberof SimpleSwapResponseDto
     */
    'warnings': Array<SimpleSwapWarningDto>;
    /**
     * Whether assignments were committed to DB
     * @type {boolean}
     * @memberof SimpleSwapResponseDto
     */
    'committed': boolean;
    /**
     * Number of treatments updated
     * @type {number}
     * @memberof SimpleSwapResponseDto
     */
    'commitCount': number;
    /**
     * Errors during commit
     * @type {Array<SimpleSwapErrorDto>}
     * @memberof SimpleSwapResponseDto
     */
    'commitErrors': Array<SimpleSwapErrorDto>;
    /**
     * Whether any changes would occur
     * @type {boolean}
     * @memberof SimpleSwapResponseDto
     */
    'hasChanges': boolean;
    /**
     * Appointments before swap (for visual preview)
     * @type {Array<SeriesSwapAppointmentsDto>}
     * @memberof SimpleSwapResponseDto
     */
    'beforeSwap'?: Array<SeriesSwapAppointmentsDto>;
    /**
     * Appointments after swap (for visual preview)
     * @type {Array<SeriesSwapAppointmentsDto>}
     * @memberof SimpleSwapResponseDto
     */
    'afterSwap'?: Array<SeriesSwapAppointmentsDto>;
    /**
     * IDs of deleted perpetual appointments
     * @type {Array<string>}
     * @memberof SimpleSwapResponseDto
     */
    'deletedAppointmentIds'?: Array<string>;
    /**
     * Status messages for perpetual appointments
     * @type {Array<string>}
     * @memberof SimpleSwapResponseDto
     */
    'perpetualAppointmentStatus'?: Array<string>;
    /**
     * Validation errors newly introduced by this swap (not pre-existing)
     * @type {Array<SwapValidationErrorDto>}
     * @memberof SimpleSwapResponseDto
     */
    'swapValidationErrors'?: Array<SwapValidationErrorDto>;
}
/**
 * 
 * @export
 * @interface SimpleSwapWarningDto
 */
export interface SimpleSwapWarningDto {
    /**
     * 
     * @type {SwapWarningType}
     * @memberof SimpleSwapWarningDto
     */
    'type': SwapWarningType;
    /**
     * Treatment ID
     * @type {string}
     * @memberof SimpleSwapWarningDto
     */
    'treatmentId': string;
    /**
     * Human-readable warning message
     * @type {string}
     * @memberof SimpleSwapWarningDto
     */
    'message': string;
}


/**
 * 
 * @export
 * @interface SimpleWorkingHoursDto
 */
export interface SimpleWorkingHoursDto {
    /**
     * 
     * @type {string}
     * @memberof SimpleWorkingHoursDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleWorkingHoursDto
     */
    'type'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof SimpleWorkingHoursDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof SimpleWorkingHoursDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleWorkingHoursDto
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface SingleHistoryTranslationFieldsDto
 */
export interface SingleHistoryTranslationFieldsDto {
    /**
     * 
     * @type {string}
     * @memberof SingleHistoryTranslationFieldsDto
     */
    'type': SingleHistoryTranslationFieldsDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SingleHistoryTranslationFieldsDto
     */
    'action': SingleHistoryTranslationFieldsDtoActionEnum;
}

export const SingleHistoryTranslationFieldsDtoTypeEnum = {
    Patient: 'Patient',
    Appointment: 'Appointment',
    Prescription: 'Prescription',
    Doctor: 'Doctor',
    User: 'User',
    Documentation: 'Documentation',
    RxSeries: 'Rx Series',
    LeaveOfAbsence: 'Leave of Absence'
} as const;

export type SingleHistoryTranslationFieldsDtoTypeEnum = typeof SingleHistoryTranslationFieldsDtoTypeEnum[keyof typeof SingleHistoryTranslationFieldsDtoTypeEnum];
export const SingleHistoryTranslationFieldsDtoActionEnum = {
    CreateNewPatient: 'create new patient',
    UpdatePatient: 'update patient',
    CreateInitialEvaluation: 'create initial evaluation',
    UpdateInitialEvaluation: 'update initial evaluation',
    CreateTreatmentNote: 'create treatment note',
    UpdateTreatmentNote: 'update treatment note',
    SavePrescription: 'save prescription',
    UpdatePrescriptionProcessingStatus: 'update prescription processingStatus',
    ScheduleAppointment: 'schedule appointment',
    DeletePatientAddress: 'delete patient address',
    RxDuplication: 'rx duplication',
    RxSeriesUpdate: 'rx series update',
    CreateRxSeries: 'create rx series',
    ChangeRxseriesToTherapyRx: 'change rxseries to therapyRx',
    AutomatedSavedAppointments: 'automated saved appointments',
    AutomatedSavedLunchBreaks: 'automated saved lunch breaks',
    UpdateCancelledAppointment: 'update cancelled appointment',
    CancelAppointment: 'cancel appointment',
    UpdateAppointment: 'update appointment',
    PrintRx: 'print rx',
    InformPatientAboutAppointment: 'inform patient about appointment',
    ArchivePatient: 'archive patient',
    DeletePatient: 'delete patient',
    RestorePatient: 'restore patient',
    CreateLeaveOfAbsence: 'create leave of absence',
    UpdateLeaveOfAbsence: 'update leave of absence',
    DeleteLeaveOfAbsence: 'delete leave of absence'
} as const;

export type SingleHistoryTranslationFieldsDtoActionEnum = typeof SingleHistoryTranslationFieldsDtoActionEnum[keyof typeof SingleHistoryTranslationFieldsDtoActionEnum];

/**
 * 
 * @export
 * @interface SkippedRestoreDto
 */
export interface SkippedRestoreDto {
    /**
     * 
     * @type {string}
     * @memberof SkippedRestoreDto
     */
    'cancellationId': string;
    /**
     * 
     * @type {object}
     * @memberof SkippedRestoreDto
     */
    'appointmentId'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof SkippedRestoreDto
     */
    'originalDate': string;
    /**
     * 
     * @type {object}
     * @memberof SkippedRestoreDto
     */
    'patientId'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof SkippedRestoreDto
     */
    'reason': SkippedRestoreDtoReasonEnum;
    /**
     * User-facing explanation why the appointment stayed cancelled.
     * @type {string}
     * @memberof SkippedRestoreDto
     */
    'message': string;
}

export const SkippedRestoreDtoReasonEnum = {
    TimeUnavailable: 'TIME_UNAVAILABLE',
    RestoreFailed: 'RESTORE_FAILED'
} as const;

export type SkippedRestoreDtoReasonEnum = typeof SkippedRestoreDtoReasonEnum[keyof typeof SkippedRestoreDtoReasonEnum];

/**
 * 
 * @export
 * @interface SoftDeleteLastSchrift200Response
 */
export interface SoftDeleteLastSchrift200Response {
    /**
     * 
     * @type {string}
     * @memberof SoftDeleteLastSchrift200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoftDeleteLastSchrift200Response
     */
    'deletedRechnungId'?: string;
}
/**
 * 
 * @export
 * @interface SolutionDto
 */
export interface SolutionDto {
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof SolutionDto
     */
    'appointments': Array<AppointmentDto>;
    /**
     * 
     * @type {Array<ContextDto>}
     * @memberof SolutionDto
     */
    'contexts'?: Array<ContextDto>;
    /**
     * 
     * @type {Array<SummaryMetricsDto>}
     * @memberof SolutionDto
     */
    'summary'?: Array<SummaryMetricsDto>;
    /**
     * 
     * @type {Array<LunchBreakDto>}
     * @memberof SolutionDto
     */
    'lunchBreaks'?: Array<LunchBreakDto>;
    /**
     * 
     * @type {boolean}
     * @memberof SolutionDto
     */
    'isPartial'?: boolean;
    /**
     * 
     * @type {Array<UnscheduledAppointmentDto>}
     * @memberof SolutionDto
     */
    'unscheduledAppointments'?: Array<UnscheduledAppointmentDto>;
}
/**
 * 
 * @export
 * @interface StartBillPdfBatchRequestDto
 */
export interface StartBillPdfBatchRequestDto {
    /**
     * Items to generate PDFs for (max 100)
     * @type {Array<BillPdfBatchItemDto>}
     * @memberof StartBillPdfBatchRequestDto
     */
    'items': Array<BillPdfBatchItemDto>;
    /**
     * Workflow expiry in seconds (default: 300 = 5 minutes)
     * @type {number}
     * @memberof StartBillPdfBatchRequestDto
     */
    'workflowExpiry'?: number;
}
/**
 * 
 * @export
 * @interface StartBillPdfBatchResponseDto
 */
export interface StartBillPdfBatchResponseDto {
    /**
     * Workflow ID for tracking progress
     * @type {string}
     * @memberof StartBillPdfBatchResponseDto
     */
    'workflowId': string;
    /**
     * Human-readable message
     * @type {string}
     * @memberof StartBillPdfBatchResponseDto
     */
    'message': string;
    /**
     * Number of items in the batch
     * @type {number}
     * @memberof StartBillPdfBatchResponseDto
     */
    'itemCount': number;
}
/**
 * 
 * @export
 * @interface StateForPatientDto
 */
export interface StateForPatientDto {
    /**
     * Mapping of therapist IDs to arrays of therapy IDs
     * @type {{ [key: string]: Array<string>; }}
     * @memberof StateForPatientDto
     */
    'therapistCredentials': { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<UnscheduledAppointmentDto>}
     * @memberof StateForPatientDto
     */
    'unscheduledAppointments': Array<UnscheduledAppointmentDto>;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof StateForPatientDto
     */
    'therapistsAvailabilities': Array<TimeSlotDto>;
    /**
     * 
     * @type {Array<AvailabilityDto>}
     * @memberof StateForPatientDto
     */
    'filteredAvailabilities': Array<AvailabilityDto>;
    /**
     * 
     * @type {Array<ScheduledAppointmentMinimalDto>}
     * @memberof StateForPatientDto
     */
    'scheduledAppointments': Array<ScheduledAppointmentMinimalDto>;
}
/**
 * 
 * @export
 * @interface StatusAmountsDto
 */
export interface StatusAmountsDto {
    /**
     * 
     * @type {GesAmountsDto}
     * @memberof StatusAmountsDto
     */
    'status10000'?: GesAmountsDto;
    /**
     * 
     * @type {GesAmountsDto}
     * @memberof StatusAmountsDto
     */
    'status30000'?: GesAmountsDto;
    /**
     * 
     * @type {GesAmountsDto}
     * @memberof StatusAmountsDto
     */
    'status50000'?: GesAmountsDto;
}
/**
 * 
 * @export
 * @interface SublocalityDto
 */
export interface SublocalityDto {
    /**
     * 
     * @type {string}
     * @memberof SublocalityDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SublocalityDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SublocalityDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SublocalityDto
     */
    'color'?: string;
    /**
     * GeoJSON geometry data for the sublocality boundaries
     * @type {object}
     * @memberof SublocalityDto
     */
    'geometry'?: object;
    /**
     * 
     * @type {string}
     * @memberof SublocalityDto
     */
    'addressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SublocalityDto
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface SummaryMetricsDto
 */
export interface SummaryMetricsDto {
    /**
     * 
     * @type {string}
     * @memberof SummaryMetricsDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryMetricsDto
     */
    'value': string;
    /**
     * 
     * @type {object}
     * @memberof SummaryMetricsDto
     */
    'units': object;
}
/**
 * 
 * @export
 * @interface SwapAppointmentsResponseDto
 */
export interface SwapAppointmentsResponseDto {
    /**
     * Swap results per series
     * @type {Array<object>}
     * @memberof SwapAppointmentsResponseDto
     */
    'results': Array<object>;
    /**
     * Rx prescriptions that are now completable after the swap
     * @type {Array<CompletableRxDto>}
     * @memberof SwapAppointmentsResponseDto
     */
    'completableRxs'?: Array<CompletableRxDto>;
    /**
     * Validation errors newly introduced by this swap
     * @type {Array<SwapValidationErrorDto>}
     * @memberof SwapAppointmentsResponseDto
     */
    'swapValidationErrors'?: Array<SwapValidationErrorDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SwapErrorType = {
    KapazittBerschritten: 'Kapazität überschritten',
    TarifAbweichung: 'Tarif-Abweichung',
    TherapeutKannNichtLiefern: 'Therapeut kann nicht liefern',
    HausbesuchAbweichung: 'Hausbesuch-Abweichung',
    HeilmittelNichtGefunden: 'Heilmittel nicht gefunden',
    ErgnzungstherapieAufAndererVerordnung: 'Ergänzungstherapie auf anderer Verordnung'
} as const;

export type SwapErrorType = typeof SwapErrorType[keyof typeof SwapErrorType];


/**
 * 
 * @export
 * @interface SwapValidationErrorDto
 */
export interface SwapValidationErrorDto {
    /**
     * ID of the Rx that gained a validation error after the swap
     * @type {string}
     * @memberof SwapValidationErrorDto
     */
    'rxId': string;
    /**
     * Human-readable Rx number
     * @type {string}
     * @memberof SwapValidationErrorDto
     */
    'rxNumber': string;
    /**
     * Validator label (e.g. \"Serienreihenfolge\")
     * @type {string}
     * @memberof SwapValidationErrorDto
     */
    'label': string;
    /**
     * Human-readable validation error message
     * @type {string}
     * @memberof SwapValidationErrorDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SwapWarningType = {
    TherapieNdertSich: 'Therapie ändert sich',
    WegegeldNdertSich: 'Wegegeld ändert sich'
} as const;

export type SwapWarningType = typeof SwapWarningType[keyof typeof SwapWarningType];


/**
 * 
 * @export
 * @interface TarifGroupDetailsDto
 */
export interface TarifGroupDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof TarifGroupDetailsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TarifGroupDetailsDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof TarifGroupDetailsDto
     */
    'priceDateRule': string;
}
/**
 * 
 * @export
 * @interface TarifGroupDto
 */
export interface TarifGroupDto {
    /**
     * 
     * @type {string}
     * @memberof TarifGroupDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TarifGroupDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TarifGroupMinimalDto
 */
export interface TarifGroupMinimalDto {
    /**
     * Tarif group ID
     * @type {string}
     * @memberof TarifGroupMinimalDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface TemplateWidgetDataDto
 */
export interface TemplateWidgetDataDto {
    /**
     * 
     * @type {Array<RxDto>}
     * @memberof TemplateWidgetDataDto
     */
    'selectableRxs': Array<RxDto>;
    /**
     * 
     * @type {TemplateWidgetDefaultSelectionDto}
     * @memberof TemplateWidgetDataDto
     */
    'defaultSelection'?: TemplateWidgetDefaultSelectionDto | null;
}
/**
 * 
 * @export
 * @interface TemplateWidgetDefaultSelectionDto
 */
export interface TemplateWidgetDefaultSelectionDto {
    /**
     * 
     * @type {string}
     * @memberof TemplateWidgetDefaultSelectionDto
     */
    'rxId': string;
    /**
     * 
     * @type {string}
     * @memberof TemplateWidgetDefaultSelectionDto
     */
    'therapyRxId': string;
}
/**
 * 
 * @export
 * @interface TermAliasDto
 */
export interface TermAliasDto {
    /**
     * 
     * @type {string}
     * @memberof TermAliasDto
     */
    'alias': string;
    /**
     * 
     * @type {string}
     * @memberof TermAliasDto
     */
    'normalizedAlias': string;
}
/**
 * 
 * @export
 * @interface TermResolutionDto
 */
export interface TermResolutionDto {
    /**
     * 
     * @type {string}
     * @memberof TermResolutionDto
     */
    'therapyMethodId': string;
    /**
     * 
     * @type {string}
     * @memberof TermResolutionDto
     */
    'methodLabel': string;
    /**
     * 
     * @type {number}
     * @memberof TermResolutionDto
     */
    'priority': number;
    /**
     * 
     * @type {Array<MethodLineItemDto>}
     * @memberof TermResolutionDto
     */
    'lineItems': Array<MethodLineItemDto>;
}
/**
 * 
 * @export
 * @interface TherapistAppointmentsDto
 */
export interface TherapistAppointmentsDto {
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof TherapistAppointmentsDto
     */
    'appointments': Array<AppointmentDto>;
    /**
     * 
     * @type {Array<LeaveOfAbsenceDto>}
     * @memberof TherapistAppointmentsDto
     */
    'leaveOfAbsences': Array<LeaveOfAbsenceDto>;
    /**
     * 
     * @type {Array<EventTimeSlotDto>}
     * @memberof TherapistAppointmentsDto
     */
    'eventTimeSlots': Array<EventTimeSlotDto>;
}
/**
 * 
 * @export
 * @interface TherapistCalendarsRequestDto
 */
export interface TherapistCalendarsRequestDto {
    /**
     * Therapist UUIDs
     * @type {Array<string>}
     * @memberof TherapistCalendarsRequestDto
     */
    'therapistIds': Array<string>;
    /**
     * ISO date strings, e.g. [\'2026-05-08\']
     * @type {Array<string>}
     * @memberof TherapistCalendarsRequestDto
     */
    'dates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TherapistCalendarsRequestDto
     */
    'locationId': string;
}
/**
 * 
 * @export
 * @interface TherapistCalendarsResponseDto
 */
export interface TherapistCalendarsResponseDto {
    /**
     * 
     * @type {Array<TherapistDayCalendarDto>}
     * @memberof TherapistCalendarsResponseDto
     */
    'calendars': Array<TherapistDayCalendarDto>;
    /**
     * 
     * @type {Array<PatientAvailabilityInfoDto>}
     * @memberof TherapistCalendarsResponseDto
     */
    'patientAvailabilities': Array<PatientAvailabilityInfoDto>;
    /**
     * 
     * @type {Array<TherapistCredentialDto>}
     * @memberof TherapistCalendarsResponseDto
     */
    'therapistCredentials': Array<TherapistCredentialDto>;
}
/**
 * 
 * @export
 * @interface TherapistCredentialDto
 */
export interface TherapistCredentialDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistCredentialDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistCredentialDto
     */
    'therapistName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistCredentialDto
     */
    'therapyIds': Array<string>;
}
/**
 * 
 * @export
 * @interface TherapistDayCalendarDto
 */
export interface TherapistDayCalendarDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistDayCalendarDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistDayCalendarDto
     */
    'therapistName': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistDayCalendarDto
     */
    'date': string;
    /**
     * 
     * @type {Array<CalendarWorkingPeriodDto>}
     * @memberof TherapistDayCalendarDto
     */
    'workingHours': Array<CalendarWorkingPeriodDto>;
    /**
     * 
     * @type {Array<CalendarAppointmentDto>}
     * @memberof TherapistDayCalendarDto
     */
    'appointments': Array<CalendarAppointmentDto>;
    /**
     * 
     * @type {Array<CalendarTravelTimeDto>}
     * @memberof TherapistDayCalendarDto
     */
    'travelTimes': Array<CalendarTravelTimeDto>;
    /**
     * 
     * @type {Array<CalendarLeaveDto>}
     * @memberof TherapistDayCalendarDto
     */
    'leaveOfAbsences': Array<CalendarLeaveDto>;
    /**
     * 
     * @type {Array<CalendarEventDto>}
     * @memberof TherapistDayCalendarDto
     */
    'events': Array<CalendarEventDto>;
}
/**
 * 
 * @export
 * @interface TherapistInfo
 */
export interface TherapistInfo {
    /**
     * 
     * @type {string}
     * @memberof TherapistInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistInfo
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistInfo
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistInfo
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistInfo
     */
    'therapistLocation': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TherapistListType = {
    Whitelist: 'WHITELIST',
    Blacklist: 'BLACKLIST'
} as const;

export type TherapistListType = typeof TherapistListType[keyof typeof TherapistListType];


/**
 * 
 * @export
 * @interface TherapistStatsDto
 */
export interface TherapistStatsDto {
    /**
     * 
     * @type {UserDto}
     * @memberof TherapistStatsDto
     */
    'user': UserDto;
    /**
     * 
     * @type {string}
     * @memberof TherapistStatsDto
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistStatsDto
     */
    'locationName': string;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'gaps': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'rxCount': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'productivity': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'auslastung': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'revenueByProductivityHour': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistStatsDto
     */
    'revenueByScheduledHour': number;
}
/**
 * 
 * @export
 * @interface TherapistsByRxDto
 */
export interface TherapistsByRxDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistsByRxDto
     */
    'rxIds': Array<string>;
}
/**
 * 
 * @export
 * @interface TherapistsByRxResultDto
 */
export interface TherapistsByRxResultDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistsByRxResultDto
     */
    'rxId': string;
    /**
     * 
     * @type {Array<RxTherapistInfoDto>}
     * @memberof TherapistsByRxResultDto
     */
    'therapists': Array<RxTherapistInfoDto>;
}
/**
 * 
 * @export
 * @interface TherapyAdminDto
 */
export interface TherapyAdminDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyAdminDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyAdminDto
     */
    'lineItem'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyAdminDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyAdminDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyAdminDto
     */
    'inUse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyAdminDto
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {object}
     * @memberof TherapyAdminDto
     */
    'duration'?: object;
    /**
     * 
     * @type {number}
     * @memberof TherapyAdminDto
     */
    'maxParticipants'?: number;
    /**
     * 
     * @type {string}
     * @memberof TherapyAdminDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {object}
     * @memberof TherapyAdminDto
     */
    'therapyCertificationId'?: object;
    /**
     * 
     * @type {Array<PriceDateRangeDto>}
     * @memberof TherapyAdminDto
     */
    'prices'?: Array<PriceDateRangeDto>;
    /**
     * 
     * @type {TherapyType}
     * @memberof TherapyAdminDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface TherapyCandidateDto
 */
export interface TherapyCandidateDto {
    /**
     * Line-item id (Therapy.id) — what the slot bills
     * @type {string}
     * @memberof TherapyCandidateDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyCandidateDto
     */
    'abbreviation': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyCandidateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TherapyCandidateDto
     */
    'duration'?: number | null;
    /**
     * Highest-priority candidate — what auto-resolution would pick.
     * @type {boolean}
     * @memberof TherapyCandidateDto
     */
    'isDefault': boolean;
    /**
     * Whether the slot\'s assigned therapist holds this line item. Always true when the slot has no therapist yet.
     * @type {boolean}
     * @memberof TherapyCandidateDto
     */
    'isCredentialed': boolean;
}
/**
 * 
 * @export
 * @interface TherapyDetailsDto
 */
export interface TherapyDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyDetailsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyDetailsDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {TarifGroupDetailsDto}
     * @memberof TherapyDetailsDto
     */
    'tarifGroup'?: TarifGroupDetailsDto;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyDetailsDto
     */
    'isSupplementary'?: boolean;
    /**
     * 
     * @type {TherapyType}
     * @memberof TherapyDetailsDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {number}
     * @memberof TherapyDetailsDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof TherapyDetailsDto
     */
    'lineItem'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyDetailsDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof TherapyDetailsDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TherapyDetailsDto
     */
    'maxParticipants'?: number;
    /**
     * 
     * @type {string}
     * @memberof TherapyDetailsDto
     */
    'therapyMethodId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyDetailsDto
     */
    'pricingBasis'?: TherapyDetailsDtoPricingBasisEnum;
    /**
     * 
     * @type {number}
     * @memberof TherapyDetailsDto
     */
    'standardIntervals'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyDetailsDto
     */
    'isPassive'?: boolean;
}

export const TherapyDetailsDtoPricingBasisEnum = {
    FixedPerService: 'FIXED_PER_SERVICE',
    PerTimeInterval: 'PER_TIME_INTERVAL'
} as const;

export type TherapyDetailsDtoPricingBasisEnum = typeof TherapyDetailsDtoPricingBasisEnum[keyof typeof TherapyDetailsDtoPricingBasisEnum];

/**
 * 
 * @export
 * @interface TherapyDisplayDto
 */
export interface TherapyDisplayDto {
    /**
     * Therapy ID
     * @type {string}
     * @memberof TherapyDisplayDto
     */
    'id': string;
    /**
     * Therapy abbreviation
     * @type {string}
     * @memberof TherapyDisplayDto
     */
    'abbreviation'?: string;
    /**
     * TherapyMethod id this line item bills
     * @type {string}
     * @memberof TherapyDisplayDto
     */
    'therapyMethodId'?: string | null;
}
/**
 * 
 * @export
 * @interface TherapyDto
 */
export interface TherapyDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {TarifGroupDetailsDto}
     * @memberof TherapyDto
     */
    'tarifGroup'?: TarifGroupDetailsDto;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyDto
     */
    'isSupplementary'?: boolean;
    /**
     * 
     * @type {TherapyType}
     * @memberof TherapyDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface TherapyDtoForUser
 */
export interface TherapyDtoForUser {
    /**
     * 
     * @type {string}
     * @memberof TherapyDtoForUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyDtoForUser
     */
    'lineItem': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyDtoForUser
     */
    'abbreviation': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyDtoForUser
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof TherapyDtoForUser
     */
    'duration': number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyDtoForUser
     */
    'inUse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyDtoForUser
     */
    'isSupplementary': boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapyDtoForUser
     */
    'maxParticipants'?: number;
    /**
     * 
     * @type {string}
     * @memberof TherapyDtoForUser
     */
    'therapyCertificationId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof TherapyDtoForUser
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof TherapyDtoForUser
     */
    'therapyMethodId'?: string | null;
}


/**
 * 
 * @export
 * @interface TherapyFrequencyDto
 */
export interface TherapyFrequencyDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyFrequencyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyFrequencyDto
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof TherapyFrequencyDto
     */
    'prefferedValue': number;
    /**
     * 
     * @type {number}
     * @memberof TherapyFrequencyDto
     */
    'minValue': number;
    /**
     * 
     * @type {number}
     * @memberof TherapyFrequencyDto
     */
    'maxValue': number;
}
/**
 * 
 * @export
 * @interface TherapyInfoDto
 */
export interface TherapyInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyInfoDto
     */
    'therapy': string;
    /**
     * 
     * @type {number}
     * @memberof TherapyInfoDto
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface TherapyMethodAdminDto
 */
export interface TherapyMethodAdminDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodAdminDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodAdminDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodAdminDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodAdminDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyMethodAdminDto
     */
    'isPassive': boolean;
    /**
     * 
     * @type {Array<MethodLineItemDto>}
     * @memberof TherapyMethodAdminDto
     */
    'lineItems': Array<MethodLineItemDto>;
    /**
     * 
     * @type {Array<MethodTermRefDto>}
     * @memberof TherapyMethodAdminDto
     */
    'terms': Array<MethodTermRefDto>;
}
/**
 * 
 * @export
 * @interface TherapyRxAmountInfo
 */
export interface TherapyRxAmountInfo {
    /**
     * 
     * @type {string}
     * @memberof TherapyRxAmountInfo
     */
    'therapyRxId': string;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxAmountInfo
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface TherapyRxDto
 */
export interface TherapyRxDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyRxDto
     */
    'id'?: string;
    /**
     * 
     * @type {PrescribedTherapyDto}
     * @memberof TherapyRxDto
     */
    'prescribedTherapy'?: PrescribedTherapyDto;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxDto
     */
    'prescribedTherapyId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxDto
     */
    'authority'?: TherapyRxDtoAuthorityEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxDto
     */
    'rawText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxDto
     */
    'unitsPerDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxDto
     */
    'prescribedIntervals'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxDto
     */
    'intervalDeviationReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxDto
     */
    'chosenTherapyId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TherapyRxDto
     */
    'therapyIsManuallyChosen'?: boolean;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof TherapyRxDto
     */
    'frequency'?: TherapyFrequencyDto;
    /**
     * 
     * @type {RxDto}
     * @memberof TherapyRxDto
     */
    'rx'?: RxDto;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxDto
     */
    'scheduledCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxDto
     */
    'order'?: number;
}

export const TherapyRxDtoAuthorityEnum = {
    Doctor: 'DOCTOR',
    Therapist: 'THERAPIST'
} as const;

export type TherapyRxDtoAuthorityEnum = typeof TherapyRxDtoAuthorityEnum[keyof typeof TherapyRxDtoAuthorityEnum];

/**
 * 
 * @export
 * @interface TherapyRxSimpleDto
 */
export interface TherapyRxSimpleDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyRxSimpleDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxSimpleDto
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxSimpleDto
     */
    'frequencyStr'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxSimpleDto
     */
    'therapyAbbr'?: string;
}
/**
 * 
 * @export
 * @interface TherapyRxTherapyCandidatesDto
 */
export interface TherapyRxTherapyCandidatesDto {
    /**
     * The prescription line these candidates belong to
     * @type {string}
     * @memberof TherapyRxTherapyCandidatesDto
     */
    'therapyRxId': string;
    /**
     * The line\'s chosen line-item id, or null when the default rule applies
     * @type {string}
     * @memberof TherapyRxTherapyCandidatesDto
     */
    'chosenTherapyId': string | null;
    /**
     * True when a person chose it rather than it being inherited
     * @type {boolean}
     * @memberof TherapyRxTherapyCandidatesDto
     */
    'therapyIsManuallyChosen': boolean;
    /**
     * Human label of the prescribed term, e.g. \"Wärme\"
     * @type {string}
     * @memberof TherapyRxTherapyCandidatesDto
     */
    'termLabel'?: string | null;
    /**
     * 
     * @type {Array<TherapyCandidateDto>}
     * @memberof TherapyRxTherapyCandidatesDto
     */
    'candidates': Array<TherapyCandidateDto>;
}
/**
 * 
 * @export
 * @interface TherapyRxWriteDto
 */
export interface TherapyRxWriteDto {
    /**
     * Omit to create a new line.
     * @type {string}
     * @memberof TherapyRxWriteDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxWriteDto
     */
    'prescribedTherapyId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxWriteDto
     */
    'rawText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxWriteDto
     */
    'authority'?: TherapyRxWriteDtoAuthorityEnum;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxWriteDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxWriteDto
     */
    'unitsPerDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxWriteDto
     */
    'prescribedIntervals'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TherapyRxWriteDto
     */
    'intervalDeviationReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TherapyRxWriteDto
     */
    'order'?: number;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof TherapyRxWriteDto
     */
    'frequency': TherapyFrequencyDto;
}

export const TherapyRxWriteDtoAuthorityEnum = {
    Doctor: 'DOCTOR',
    Therapist: 'THERAPIST'
} as const;

export type TherapyRxWriteDtoAuthorityEnum = typeof TherapyRxWriteDtoAuthorityEnum[keyof typeof TherapyRxWriteDtoAuthorityEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TherapyType = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type TherapyType = typeof TherapyType[keyof typeof TherapyType];


/**
 * 
 * @export
 * @interface TicketClinicDto
 */
export interface TicketClinicDto {
    /**
     * 
     * @type {string}
     * @memberof TicketClinicDto
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof TicketClinicDto
     */
    'BSNR'?: object;
    /**
     * 
     * @type {string}
     * @memberof TicketClinicDto
     */
    'methodForDrReport'?: string;
    /**
     * 
     * @type {ContactInfo}
     * @memberof TicketClinicDto
     */
    'contactInfo'?: ContactInfo;
}
/**
 * 
 * @export
 * @interface TicketDoctorDto
 */
export interface TicketDoctorDto {
    /**
     * 
     * @type {string}
     * @memberof TicketDoctorDto
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof TicketDoctorDto
     */
    'LANR'?: object;
    /**
     * 
     * @type {ContactInfo}
     * @memberof TicketDoctorDto
     */
    'contactInfo'?: ContactInfo;
}
/**
 * 
 * @export
 * @interface TicketDto
 */
export interface TicketDto {
    /**
     * 
     * @type {number}
     * @memberof TicketDto
     */
    'id'?: number;
    /**
     * 
     * @type {UserDto}
     * @memberof TicketDto
     */
    'createdByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'createdByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof TicketDto
     */
    'assignedToUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'assignedToUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'ticketType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'ticketStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'deadline'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof TicketDto
     */
    'updatedByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'updatedByUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {AppointmentDto}
     * @memberof TicketDto
     */
    'appointment'?: AppointmentDto;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {RxLightDto}
     * @memberof TicketDto
     */
    'rx'?: RxLightDto;
    /**
     * MD-109: id of the intelligently-chosen target Rx (perpetual/DT Rezept or undated Rx) from the same series. Null when the requested Rx is already the best target.
     * @type {string}
     * @memberof TicketDto
     */
    'targetRxId'?: string | null;
    /**
     * 
     * @type {RxLightDto}
     * @memberof TicketDto
     */
    'targetRx'?: RxLightDto;
    /**
     * 
     * @type {number}
     * @memberof TicketDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {PatientDto}
     * @memberof TicketDto
     */
    'patient'?: PatientDto;
    /**
     * Linked doctor id
     * @type {string}
     * @memberof TicketDto
     */
    'doctorId'?: string;
    /**
     * 
     * @type {TicketDoctorDto}
     * @memberof TicketDto
     */
    'doctor'?: TicketDoctorDto;
    /**
     * Linked clinic id
     * @type {string}
     * @memberof TicketDto
     */
    'clinicId'?: string;
    /**
     * 
     * @type {TicketClinicDto}
     * @memberof TicketDto
     */
    'clinic'?: TicketClinicDto;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'transactionId'?: string;
    /**
     * 
     * @type {Array<ActivityDto>}
     * @memberof TicketDto
     */
    'activities'?: Array<ActivityDto>;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'locationId': string;
    /**
     * 
     * @type {LocationDto}
     * @memberof TicketDto
     */
    'location'?: LocationDto;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ReminderDto>}
     * @memberof TicketDto
     */
    'reminders'?: Array<ReminderDto>;
}
/**
 * 
 * @export
 * @interface TicketFilterDto
 */
export interface TicketFilterDto {
    /**
     * 
     * @type {TicketFilterEntryDto}
     * @memberof TicketFilterDto
     */
    'ticketType': TicketFilterEntryDto;
    /**
     * 
     * @type {Array<TicketFilterEntryDto>}
     * @memberof TicketFilterDto
     */
    'statuses': Array<TicketFilterEntryDto>;
    /**
     * 
     * @type {Array<TicketFilterEntryDto>}
     * @memberof TicketFilterDto
     */
    'priorities': Array<TicketFilterEntryDto>;
    /**
     * 
     * @type {boolean}
     * @memberof TicketFilterDto
     */
    'hasPriorities': boolean;
}
/**
 * 
 * @export
 * @interface TicketFilterEntryDto
 */
export interface TicketFilterEntryDto {
    /**
     * 
     * @type {string}
     * @memberof TicketFilterEntryDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof TicketFilterEntryDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface TicketFlatFilterDto
 */
export interface TicketFlatFilterDto {
    /**
     * 
     * @type {Array<TicketFilterEntryDto>}
     * @memberof TicketFlatFilterDto
     */
    'ticketType': Array<TicketFilterEntryDto>;
    /**
     * 
     * @type {Array<TicketFilterEntryDto>}
     * @memberof TicketFlatFilterDto
     */
    'statuses': Array<TicketFilterEntryDto>;
    /**
     * 
     * @type {Array<TicketFilterEntryDto>}
     * @memberof TicketFlatFilterDto
     */
    'priorities': Array<TicketFilterEntryDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TicketingRelationEntities = {
    Patient: 'PATIENT',
    Rx: 'RX',
    Appointment: 'APPOINTMENT',
    Other: 'OTHER',
    Billing: 'BILLING'
} as const;

export type TicketingRelationEntities = typeof TicketingRelationEntities[keyof typeof TicketingRelationEntities];


/**
 * 
 * @export
 * @interface TicketsByDateDto
 */
export interface TicketsByDateDto {
    /**
     * 
     * @type {number}
     * @memberof TicketsByDateDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'ticketType': string;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'ticketStatus': string;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'createdAt': string;
    /**
     * 
     * @type {object}
     * @memberof TicketsByDateDto
     */
    'patient'?: object;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'lastComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'deadline'?: string;
    /**
     * 
     * @type {object}
     * @memberof TicketsByDateDto
     */
    'reminder'?: object;
    /**
     * 
     * @type {string}
     * @memberof TicketsByDateDto
     */
    'matchType': string;
}
/**
 * 
 * @export
 * @interface TimeSlotCreateActionDto
 */
export interface TimeSlotCreateActionDto {
    /**
     * Patient UUID
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'patientId'?: string;
    /**
     * UUID of appointment being created/placed
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'appointmentId': string;
    /**
     * UUID of the timeslot being created/placed
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'timeSlotId': string;
    /**
     * Start datetime
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'start': string;
    /**
     * End datetime
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'end': string;
    /**
     * UUID of assigned therapist
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'therapistId': string;
    /**
     * TherapyRx UUID for validation
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'therapyRxId'?: string;
    /**
     * Therapy UUID
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'therapyId'?: string;
    /**
     * Therapist display nickname
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'therapistNickname'?: string;
    /**
     * Reason for creating/placing this appointment
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotCreateActionDto
     */
    'actionName': TimeSlotCreateActionDtoActionNameEnum;
}

export const TimeSlotCreateActionDtoActionNameEnum = {
    TimeSlotCreate: 'TIME_SLOT_CREATE'
} as const;

export type TimeSlotCreateActionDtoActionNameEnum = typeof TimeSlotCreateActionDtoActionNameEnum[keyof typeof TimeSlotCreateActionDtoActionNameEnum];

/**
 * 
 * @export
 * @interface TimeSlotDisplayDto
 */
export interface TimeSlotDisplayDto {
    /**
     * Treatment ID
     * @type {string}
     * @memberof TimeSlotDisplayDto
     */
    'id': string;
    /**
     * Treatment index for display ordering
     * @type {string}
     * @memberof TimeSlotDisplayDto
     */
    'treatmentIndex': string;
    /**
     * 
     * @type {TherapyDisplayDto}
     * @memberof TimeSlotDisplayDto
     */
    'therapy': TherapyDisplayDto;
    /**
     * 
     * @type {PatientMinimalDto}
     * @memberof TimeSlotDisplayDto
     */
    'patient': PatientMinimalDto;
    /**
     * 
     * @type {RxDisplayDto}
     * @memberof TimeSlotDisplayDto
     */
    'rx': RxDisplayDto;
    /**
     * 
     * @type {AddressDisplayDto}
     * @memberof TimeSlotDisplayDto
     */
    'address'?: AddressDisplayDto;
    /**
     * 
     * @type {SublocalityDto}
     * @memberof TimeSlotDisplayDto
     */
    'sublocality'?: SublocalityDto;
    /**
     * 
     * @type {VisitFeeDisplayDto}
     * @memberof TimeSlotDisplayDto
     */
    'visitFee'?: VisitFeeDisplayDto;
}
/**
 * 
 * @export
 * @interface TimeSlotDto
 */
export interface TimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'id'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof TimeSlotDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {TherapyDto}
     * @memberof TimeSlotDto
     */
    'visitFee'?: TherapyDto;
    /**
     * 
     * @type {PatientDto}
     * @memberof TimeSlotDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof TimeSlotDto
     */
    'therapy'?: TherapyDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof TimeSlotDto
     */
    'performedIntervals'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {TherapyRxDto}
     * @memberof TimeSlotDto
     */
    'therapyRx'?: TherapyRxDto;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'end': string;
    /**
     * 
     * @type {boolean}
     * @memberof TimeSlotDto
     */
    'attended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TimeSlotDto
     */
    'therapyIsManuallyChosen'?: boolean;
    /**
     * 
     * @type {TreatmentNoteDTO}
     * @memberof TimeSlotDto
     */
    'treatmentNote'?: TreatmentNoteDTO | null;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'treatmentIndex'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimeSlotDto
     */
    'wasDocumentedCount'?: number;
    /**
     * 
     * @type {AddressCoordinateDto}
     * @memberof TimeSlotDto
     */
    'startAddress'?: AddressCoordinateDto;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotDto
     */
    'groupAppointmentId'?: string;
    /**
     * 
     * @type {PatientInformingProjectionDto}
     * @memberof TimeSlotDto
     */
    'informing'?: PatientInformingProjectionDto | null;
}
/**
 * 
 * @export
 * @interface TimeSlotMoveActionDto
 */
export interface TimeSlotMoveActionDto {
    /**
     * Patient UUID
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'patientId'?: string;
    /**
     * UUID of the appointment being moved
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'appointmentId': string;
    /**
     * UUID of the timeslot being moved
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'timeSlotId': string;
    /**
     * Collection/group identifier
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'collectionId'?: string;
    /**
     * Original start datetime
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'originalStart': string;
    /**
     * Original end datetime
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'originalEnd'?: string;
    /**
     * UUID of the original therapist
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'originalTherapistId': string;
    /**
     * New start datetime
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'newStart': string;
    /**
     * New end datetime
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'newEnd': string;
    /**
     * UUID of target therapist
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'newTherapistId': string;
    /**
     * TherapyRx UUID for validation
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'therapyRxId'?: string;
    /**
     * Therapy UUID
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'therapyId'?: string;
    /**
     * Original therapist nickname
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'therapistNickname'?: string;
    /**
     * Target therapist nickname
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'newTherapistNickname'?: string;
    /**
     * Reason for this move
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotMoveActionDto
     */
    'actionName': TimeSlotMoveActionDtoActionNameEnum;
}

export const TimeSlotMoveActionDtoActionNameEnum = {
    TimeSlotMove: 'TIME_SLOT_MOVE'
} as const;

export type TimeSlotMoveActionDtoActionNameEnum = typeof TimeSlotMoveActionDtoActionNameEnum[keyof typeof TimeSlotMoveActionDtoActionNameEnum];

/**
 * 
 * @export
 * @interface TimeSlotSkipActionDto
 */
export interface TimeSlotSkipActionDto {
    /**
     * Patient UUID
     * @type {string}
     * @memberof TimeSlotSkipActionDto
     */
    'patientId'?: string;
    /**
     * UUID of the appointment being skipped/unplaced
     * @type {string}
     * @memberof TimeSlotSkipActionDto
     */
    'appointmentId': string;
    /**
     * UUID of the timeslot being skipped/unplaced
     * @type {string}
     * @memberof TimeSlotSkipActionDto
     */
    'timeSlotId': string;
    /**
     * Reason this action was skipped/unplaced
     * @type {string}
     * @memberof TimeSlotSkipActionDto
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotSkipActionDto
     */
    'actionName': TimeSlotSkipActionDtoActionNameEnum;
}

export const TimeSlotSkipActionDtoActionNameEnum = {
    TimeSlotSkip: 'TIME_SLOT_SKIP'
} as const;

export type TimeSlotSkipActionDtoActionNameEnum = typeof TimeSlotSkipActionDtoActionNameEnum[keyof typeof TimeSlotSkipActionDtoActionNameEnum];

/**
 * 
 * @export
 * @interface TimeSlotTherapyCandidatesDto
 */
export interface TimeSlotTherapyCandidatesDto {
    /**
     * The slot\'s current line item id
     * @type {string}
     * @memberof TimeSlotTherapyCandidatesDto
     */
    'currentTherapyId': string | null;
    /**
     * True when the current item was manually picked (MD-302)
     * @type {boolean}
     * @memberof TimeSlotTherapyCandidatesDto
     */
    'therapyIsManuallyChosen': boolean;
    /**
     * Human label of the prescribed term the candidates fulfil
     * @type {string}
     * @memberof TimeSlotTherapyCandidatesDto
     */
    'termLabel'?: string | null;
    /**
     * 
     * @type {Array<TherapyCandidateDto>}
     * @memberof TimeSlotTherapyCandidatesDto
     */
    'candidates': Array<TherapyCandidateDto>;
}
/**
 * 
 * @export
 * @interface TimelineBillReminderDto
 */
export interface TimelineBillReminderDto {
    /**
     * Unique ID of the reminder
     * @type {string}
     * @memberof TimelineBillReminderDto
     */
    'id': string;
    /**
     * Reminder level (1, 2, or 3)
     * @type {number}
     * @memberof TimelineBillReminderDto
     */
    'level': TimelineBillReminderDtoLevelEnum;
    /**
     * Fee charged for this reminder level (5, 10, or 15 EUR)
     * @type {number}
     * @memberof TimelineBillReminderDto
     */
    'fee': number;
    /**
     * When the reminder was created
     * @type {string}
     * @memberof TimelineBillReminderDto
     */
    'createdAt': string;
}

export const TimelineBillReminderDtoLevelEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type TimelineBillReminderDtoLevelEnum = typeof TimelineBillReminderDtoLevelEnum[keyof typeof TimelineBillReminderDtoLevelEnum];

/**
 * 
 * @export
 * @interface TimelineRechnungDto
 */
export interface TimelineRechnungDto {
    /**
     * Unique ID of the Rechnung
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'id': string;
    /**
     * Rechnung number (e.g. R-2025-0042)
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'rechnungNumber': string;
    /**
     * When the Rechnung was created
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'createdAt': string;
    /**
     * Original invoice amount
     * @type {number}
     * @memberof TimelineRechnungDto
     */
    'amount': number;
    /**
     * Amount including Mahnung fees
     * @type {object}
     * @memberof TimelineRechnungDto
     */
    'amountWithMahnung'?: object | null;
    /**
     * Transaction type (Einnahme, Ausgabe)
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'type': string;
    /**
     * Payment status
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'paymentStatus': TimelineRechnungDtoPaymentStatusEnum;
    /**
     * Deletion date (if Rechnung was cancelled)
     * @type {object}
     * @memberof TimelineRechnungDto
     */
    'deletedAt'?: object | null;
    /**
     * First name of the user who created this Rechnung
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'createdByFirstName'?: string;
    /**
     * Last name of the user who created this Rechnung
     * @type {string}
     * @memberof TimelineRechnungDto
     */
    'createdByLastName'?: string;
    /**
     * Bill reminders (Mahnungen) associated with this Rechnung
     * @type {Array<TimelineBillReminderDto>}
     * @memberof TimelineRechnungDto
     */
    'reminders': Array<TimelineBillReminderDto>;
}

export const TimelineRechnungDtoPaymentStatusEnum = {
    Bezahlt: 'Bezahlt',
    TeilweiseBezahlt: 'Teilweise bezahlt',
    NichtBezahlt: 'Nicht bezahlt',
    GkvZuzahlungAngefordert: 'GKV Zuzahlung angefordert'
} as const;

export type TimelineRechnungDtoPaymentStatusEnum = typeof TimelineRechnungDtoPaymentStatusEnum[keyof typeof TimelineRechnungDtoPaymentStatusEnum];

/**
 * 
 * @export
 * @interface TimelineTransactionDto
 */
export interface TimelineTransactionDto {
    /**
     * Unique ID of the transaction
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'id': string;
    /**
     * When the transaction was created
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'createdAt': string;
    /**
     * Transaction amount (negative = cancellation/refund). Omitted for insurance (VERSICHERUNG) entries which carry no patient-facing amount.
     * @type {number}
     * @memberof TimelineTransactionDto
     */
    'amount'?: number;
    /**
     * Transaction type (Einnahme, Ausgabe, Stornierung, Rückerstattung)
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'type': string;
    /**
     * Payment method used
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'method': TimelineTransactionDtoMethodEnum;
    /**
     * Transaction number (e.g. RE-001)
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'transactionNumber'?: string;
    /**
     * Description/note of the transaction
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'text'?: string;
    /**
     * Deletion date (only for soft-deleted LastSchrift records)
     * @type {object}
     * @memberof TimelineTransactionDto
     */
    'deletedAt'?: object | null;
    /**
     * First name of the user who created this transaction
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'createdByFirstName'?: string;
    /**
     * Last name of the user who created this transaction
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'createdByLastName'?: string;
    /**
     * Whether this is a cancellation entry
     * @type {boolean}
     * @memberof TimelineTransactionDto
     */
    'isCancelled'?: boolean;
    /**
     * ID of the original transaction this cancels
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'originalTransactionId'?: string;
    /**
     * Bill type for insurance (VERSICHERUNG) entries, e.g. GKV, PAPER, CORRECTION
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'billType'?: string;
    /**
     * Billing status for insurance (VERSICHERUNG) entries, e.g. START, OPEN, PREVIOUS
     * @type {string}
     * @memberof TimelineTransactionDto
     */
    'billStatus'?: string;
}

export const TimelineTransactionDtoMethodEnum = {
    Cash: 'CASH',
    Ec: 'EC',
    Lastschrift: 'LASTSCHRIFT',
    Versicherung: 'VERSICHERUNG',
    Banktransfer: 'BANKTRANSFER',
    Sepa: 'SEPA',
    Internal: 'INTERNAL'
} as const;

export type TimelineTransactionDtoMethodEnum = typeof TimelineTransactionDtoMethodEnum[keyof typeof TimelineTransactionDtoMethodEnum];

/**
 * 
 * @export
 * @interface ToggleNoticeDefinitionDataActiveStatusDto
 */
export interface ToggleNoticeDefinitionDataActiveStatusDto {
    /**
     * The template data Id of a notice
     * @type {string}
     * @memberof ToggleNoticeDefinitionDataActiveStatusDto
     */
    'noticeDefinitionDataId': string;
    /**
     * The template data Id of a notice
     * @type {boolean}
     * @memberof ToggleNoticeDefinitionDataActiveStatusDto
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface TokenPairDto
 */
export interface TokenPairDto {
    /**
     * Short-lived access token (15 minutes)
     * @type {string}
     * @memberof TokenPairDto
     */
    'access_token': string;
    /**
     * Refresh token, for clients that can\'t rely on the httpOnly cookie (e.g. the therapist-app PWA, added to the home screen).
     * @type {string}
     * @memberof TokenPairDto
     */
    'refresh_token'?: string;
}
/**
 * 
 * @export
 * @interface TransactionsResponseDto
 */
export interface TransactionsResponseDto {
    /**
     * Array of transactions
     * @type {Array<FiskalyTransactionResponseDto>}
     * @memberof TransactionsResponseDto
     */
    'data': Array<FiskalyTransactionResponseDto>;
    /**
     * 
     * @type {PaginationMetadataDto}
     * @memberof TransactionsResponseDto
     */
    'pagination': PaginationMetadataDto;
}
/**
 * 
 * @export
 * @interface TravelTimeDto
 */
export interface TravelTimeDto {
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'id'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof TravelTimeDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {TherapyDto}
     * @memberof TravelTimeDto
     */
    'visitFee'?: TherapyDto;
    /**
     * 
     * @type {PatientDto}
     * @memberof TravelTimeDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof TravelTimeDto
     */
    'therapy'?: TherapyDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof TravelTimeDto
     */
    'performedIntervals'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {TherapyRxDto}
     * @memberof TravelTimeDto
     */
    'therapyRx'?: TherapyRxDto;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'end': string;
    /**
     * 
     * @type {boolean}
     * @memberof TravelTimeDto
     */
    'attended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TravelTimeDto
     */
    'therapyIsManuallyChosen'?: boolean;
    /**
     * 
     * @type {TreatmentNoteDTO}
     * @memberof TravelTimeDto
     */
    'treatmentNote'?: TreatmentNoteDTO | null;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'treatmentIndex'?: string;
    /**
     * 
     * @type {number}
     * @memberof TravelTimeDto
     */
    'wasDocumentedCount'?: number;
    /**
     * 
     * @type {AddressCoordinateDto}
     * @memberof TravelTimeDto
     */
    'startAddress'?: AddressCoordinateDto;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeDto
     */
    'groupAppointmentId'?: string;
    /**
     * 
     * @type {PatientInformingProjectionDto}
     * @memberof TravelTimeDto
     */
    'informing'?: PatientInformingProjectionDto | null;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof TravelTimeDto
     */
    'from': ContactInfoDTO;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof TravelTimeDto
     */
    'to': ContactInfoDTO;
}
/**
 * 
 * @export
 * @interface TravelTimeSlotChangeActionDto
 */
export interface TravelTimeSlotChangeActionDto {
    /**
     * 
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'action': TravelTimeSlotChangeActionDtoActionEnum;
    /**
     * Collection/group identifier
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'collectionId'?: string;
    /**
     * UUID of existing driving slot (update/delete)
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'id'?: string;
    /**
     * Start datetime (create/update)
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'start'?: string;
    /**
     * End datetime (create/update)
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'end'?: string;
    /**
     * UUID of therapist
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'therapistId': string;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof TravelTimeSlotChangeActionDto
     */
    'actionName': TravelTimeSlotChangeActionDtoActionNameEnum;
}

export const TravelTimeSlotChangeActionDtoActionEnum = {
    Create: 'create',
    Update: 'update',
    Delete: 'delete'
} as const;

export type TravelTimeSlotChangeActionDtoActionEnum = typeof TravelTimeSlotChangeActionDtoActionEnum[keyof typeof TravelTimeSlotChangeActionDtoActionEnum];
export const TravelTimeSlotChangeActionDtoActionNameEnum = {
    TravelTimeSlotChange: 'TRAVEL_TIME_SLOT_CHANGE'
} as const;

export type TravelTimeSlotChangeActionDtoActionNameEnum = typeof TravelTimeSlotChangeActionDtoActionNameEnum[keyof typeof TravelTimeSlotChangeActionDtoActionNameEnum];

/**
 * 
 * @export
 * @interface TreatmentNoteDTO
 */
export interface TreatmentNoteDTO {
    /**
     * 
     * @type {number}
     * @memberof TreatmentNoteDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TreatmentNoteDTO
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentNoteDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentNoteDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof TreatmentNoteDTO
     */
    'user': UserDto;
}
/**
 * 
 * @export
 * @interface TreatmentNotesByPatientDto
 */
export interface TreatmentNotesByPatientDto {
    /**
     * 
     * @type {number}
     * @memberof TreatmentNotesByPatientDto
     */
    'patientId': number;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof TreatmentNotesByPatientDto
     */
    'timeSlots': Array<TimeSlotDto>;
}
/**
 * 
 * @export
 * @interface TrendAnalyticsResponseDto
 */
export interface TrendAnalyticsResponseDto {
    /**
     * Monthly transaction trends
     * @type {Array<MonthlyTransactionTrendDto>}
     * @memberof TrendAnalyticsResponseDto
     */
    'monthlyTransactionTrends': Array<MonthlyTransactionTrendDto>;
    /**
     * Weekly transaction trends
     * @type {Array<WeeklyTransactionTrendDto>}
     * @memberof TrendAnalyticsResponseDto
     */
    'weeklyTransactionTrends': Array<WeeklyTransactionTrendDto>;
    /**
     * Monthly Rx trends
     * @type {Array<MonthlyRxTrendDto>}
     * @memberof TrendAnalyticsResponseDto
     */
    'monthlyRxTrends': Array<MonthlyRxTrendDto>;
    /**
     * Weekly Rx trends
     * @type {Array<WeeklyRxTrendDto>}
     * @memberof TrendAnalyticsResponseDto
     */
    'weeklyRxTrends': Array<WeeklyRxTrendDto>;
}
/**
 * 
 * @export
 * @interface TssInfoDto
 */
export interface TssInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TssInfoDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TssInfoDto
     */
    'state': TssInfoDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TssInfoDto
     */
    'puk'?: string;
    /**
     * 
     * @type {string}
     * @memberof TssInfoDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TssInfoDto
     */
    'locationId'?: string;
}

export const TssInfoDtoStateEnum = {
    Created: 'CREATED',
    Uninitialized: 'UNINITIALIZED',
    Initialized: 'INITIALIZED',
    Disabled: 'DISABLED',
    Deleted: 'DELETED',
    Defective: 'DEFECTIVE',
    Evicted: 'EVICTED'
} as const;

export type TssInfoDtoStateEnum = typeof TssInfoDtoStateEnum[keyof typeof TssInfoDtoStateEnum];

/**
 * 
 * @export
 * @interface TssMetadataDto
 */
export interface TssMetadataDto {
    /**
     * Business name
     * @type {string}
     * @memberof TssMetadataDto
     */
    'business': string;
    /**
     * Location name
     * @type {string}
     * @memberof TssMetadataDto
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface UndoCreditTransferExport200Response
 */
export interface UndoCreditTransferExport200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UndoCreditTransferExport200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UndoCreditTransferExport200Response
     */
    'undoneCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UndoCreditTransferExport200Response
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UndoCreditTransferExportByDocumentRequest
 */
export interface UndoCreditTransferExportByDocumentRequest {
    /**
     * SEPA document ID
     * @type {string}
     * @memberof UndoCreditTransferExportByDocumentRequest
     */
    'documentId': string;
}
/**
 * 
 * @export
 * @interface UndoCreditTransferExportRequest
 */
export interface UndoCreditTransferExportRequest {
    /**
     * Array of credit transfer IDs to reset
     * @type {Array<string>}
     * @memberof UndoCreditTransferExportRequest
     */
    'creditTransferIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UndoExportBatchDto
 */
export interface UndoExportBatchDto {
    /**
     * Why the export is being rolled back.
     * @type {string}
     * @memberof UndoExportBatchDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface UndoSEPAExportByDocumentRequest
 */
export interface UndoSEPAExportByDocumentRequest {
    /**
     * ID of the SEPA document to undo export for
     * @type {string}
     * @memberof UndoSEPAExportByDocumentRequest
     */
    'documentId': string;
}
/**
 * 
 * @export
 * @interface UndoSEPAExportForLastSchrifts200Response
 */
export interface UndoSEPAExportForLastSchrifts200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UndoSEPAExportForLastSchrifts200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UndoSEPAExportForLastSchrifts200Response
     */
    'undoneCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UndoSEPAExportForLastSchrifts200Response
     */
    'totalRequested'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UndoSEPAExportForLastSchrifts200Response
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UndoSEPAExportForLastSchriftsRequest
 */
export interface UndoSEPAExportForLastSchriftsRequest {
    /**
     * Array of LastSchrift IDs to undo export for
     * @type {Array<string>}
     * @memberof UndoSEPAExportForLastSchriftsRequest
     */
    'lastSchriftIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UndocumentedTreatmentDto
 */
export interface UndocumentedTreatmentDto {
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'treatmentId': string;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'start'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UndocumentedTreatmentDto
     */
    'patientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'patientLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'patientFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'rxId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'rxNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'therapyId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'therapyAbbreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndocumentedTreatmentDto
     */
    'therapyDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface UnexportedLastSchriftsResponseDto
 */
export interface UnexportedLastSchriftsResponseDto {
    /**
     * List of unexported LastSchrift transactions
     * @type {Array<string>}
     * @memberof UnexportedLastSchriftsResponseDto
     */
    'transactions': Array<string>;
    /**
     * Account SEPA data grouped by account
     * @type {Array<AccountSEPADataDto>}
     * @memberof UnexportedLastSchriftsResponseDto
     */
    'accountSepaData': Array<AccountSEPADataDto>;
}
/**
 * 
 * @export
 * @interface UnpaidBillsBadgeDto
 */
export interface UnpaidBillsBadgeDto {
    /**
     * Number of due bills
     * @type {number}
     * @memberof UnpaidBillsBadgeDto
     */
    'dueBillsCount': number;
    /**
     * List of Rxs with due amounts
     * @type {Array<UnpaidBillsBadgeRxDto>}
     * @memberof UnpaidBillsBadgeDto
     */
    'rxs': Array<UnpaidBillsBadgeRxDto>;
}
/**
 * 
 * @export
 * @interface UnpaidBillsBadgeRxDto
 */
export interface UnpaidBillsBadgeRxDto {
    /**
     * Rx ID
     * @type {string}
     * @memberof UnpaidBillsBadgeRxDto
     */
    'rxId': string;
    /**
     * Tarif group
     * @type {string}
     * @memberof UnpaidBillsBadgeRxDto
     */
    'tarifGroup': string;
    /**
     * Due amount for this Rx
     * @type {number}
     * @memberof UnpaidBillsBadgeRxDto
     */
    'dueAmount': number;
}
/**
 * 
 * @export
 * @interface UnscheduledAppointmentDto
 */
export interface UnscheduledAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof UnscheduledAppointmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<UnscheduledTimeSlotDto>}
     * @memberof UnscheduledAppointmentDto
     */
    'timeSlots'?: Array<UnscheduledTimeSlotDto>;
    /**
     * 
     * @type {TherapyFrequencyDto}
     * @memberof UnscheduledAppointmentDto
     */
    'frequency': TherapyFrequencyDto;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof UnscheduledAppointmentDto
     */
    'notes'?: Array<NoteDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof UnscheduledAppointmentDto
     */
    'address'?: AddressDto;
}
/**
 * 
 * @export
 * @interface UnscheduledTimeSlotDto
 */
export interface UnscheduledTimeSlotDto {
    /**
     * 
     * @type {string}
     * @memberof UnscheduledTimeSlotDto
     */
    'id'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof UnscheduledTimeSlotDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {TherapyDto}
     * @memberof UnscheduledTimeSlotDto
     */
    'visitFee'?: TherapyDto;
    /**
     * 
     * @type {PatientDto}
     * @memberof UnscheduledTimeSlotDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof UnscheduledTimeSlotDto
     */
    'therapy'?: TherapyDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof UnscheduledTimeSlotDto
     */
    'performedIntervals'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnscheduledTimeSlotDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {TherapyRxDto}
     * @memberof UnscheduledTimeSlotDto
     */
    'therapyRx'?: TherapyRxDto;
    /**
     * 
     * @type {string}
     * @memberof UnscheduledTimeSlotDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof UnscheduledTimeSlotDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnscheduledTimeSlotDto
     */
    'locationId'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAccountDto
 */
export interface UpdateAccountDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'ik'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'creditorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof UpdateAccountDto
     */
    'therapyType'?: TherapyType;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAccountDto
     */
    'isCompanyGroup'?: boolean;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof UpdateAccountDto
     */
    'contactInfo'?: KontakInfoDto;
}


/**
 * 
 * @export
 * @interface UpdateAppointmentDto
 */
export interface UpdateAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentDto
     */
    'end'?: string;
    /**
     * 
     * @type {TherapyDetailsDto}
     * @memberof UpdateAppointmentDto
     */
    'visitFee'?: TherapyDetailsDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateAppointmentDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {Array<TimeSlotDto>}
     * @memberof UpdateAppointmentDto
     */
    'timeSlots'?: Array<TimeSlotDto>;
}
/**
 * 
 * @export
 * @interface UpdateAppointmentResult
 */
export interface UpdateAppointmentResult {
    /**
     * 
     * @type {AppointmentDto}
     * @memberof UpdateAppointmentResult
     */
    'updatedAppointment': AppointmentDto;
    /**
     * Total gap in time format (HH:MM.SS) that was merged from appointment gaps
     * @type {string}
     * @memberof UpdateAppointmentResult
     */
    'mergeAppointmentGaps'?: string;
    /**
     * ID of the patient affected by this appointment update
     * @type {number}
     * @memberof UpdateAppointmentResult
     */
    'affectedPatientId': number;
    /**
     * Array of RX IDs that were affected by changes to timeslots
     * @type {Array<string>}
     * @memberof UpdateAppointmentResult
     */
    'affectedRxIds': Array<string>;
    /**
     * Whether the appointment was previously cancelled
     * @type {boolean}
     * @memberof UpdateAppointmentResult
     */
    'wasCancelledAppointment': boolean;
}
/**
 * 
 * @export
 * @interface UpdateBusinessDto
 */
export interface UpdateBusinessDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessDto
     */
    'creditorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof UpdateBusinessDto
     */
    'contactInfo'?: KontakInfoDto;
}
/**
 * 
 * @export
 * @interface UpdateCancelledAppointmentDto
 */
export interface UpdateCancelledAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCancelledAppointmentDto
     */
    'callStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCancelledAppointmentDto
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCancelledAppointmentDto
     */
    'gapJustificationReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCancelledAppointmentDto
     */
    'timeliness'?: UpdateCancelledAppointmentDtoTimelinessEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCancelledAppointmentDto
     */
    'noShowInvoice'?: boolean;
}

export const UpdateCancelledAppointmentDtoTimelinessEnum = {
    Fristgerecht24StVorher: 'fristgerecht ( > 24 st. vorher)',
    Nichtfristgerecht: 'nichtfristgerecht',
    NichtErschienen: 'nicht erschienen'
} as const;

export type UpdateCancelledAppointmentDtoTimelinessEnum = typeof UpdateCancelledAppointmentDtoTimelinessEnum[keyof typeof UpdateCancelledAppointmentDtoTimelinessEnum];

/**
 * 
 * @export
 * @interface UpdateClientStateRequest
 */
export interface UpdateClientStateRequest {
    /**
     * New state for the client
     * @type {string}
     * @memberof UpdateClientStateRequest
     */
    'state': UpdateClientStateRequestStateEnum;
}

export const UpdateClientStateRequestStateEnum = {
    Registered: 'REGISTERED',
    Deregistered: 'DEREGISTERED'
} as const;

export type UpdateClientStateRequestStateEnum = typeof UpdateClientStateRequestStateEnum[keyof typeof UpdateClientStateRequestStateEnum];

/**
 * 
 * @export
 * @interface UpdateClinicDto
 */
export interface UpdateClinicDto {
    /**
     * The unique identifier of the clinic
     * @type {string}
     * @memberof UpdateClinicDto
     */
    'id'?: string;
    /**
     * Official BSNR (9 numeric digits)
     * @type {string}
     * @memberof UpdateClinicDto
     */
    'BSNR'?: string;
    /**
     * List of IDs associated with the clinic
     * @type {Array<string>}
     * @memberof UpdateClinicDto
     */
    'doctorNumbers'?: Array<string>;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof UpdateClinicDto
     */
    'contactInfo'?: ContactInfoDTO;
    /**
     * 
     * @type {string}
     * @memberof UpdateClinicDto
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClinicDto
     */
    'methodForDrReport'?: UpdateClinicDtoMethodForDrReportEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateClinicDto
     */
    'methodForRxOrder'?: UpdateClinicDtoMethodForRxOrderEnum;
    /**
     * Doctors associated with the clinic
     * @type {Array<UpdateDoctorDto>}
     * @memberof UpdateClinicDto
     */
    'doctors'?: Array<UpdateDoctorDto>;
}

export const UpdateClinicDtoMethodForDrReportEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type UpdateClinicDtoMethodForDrReportEnum = typeof UpdateClinicDtoMethodForDrReportEnum[keyof typeof UpdateClinicDtoMethodForDrReportEnum];
export const UpdateClinicDtoMethodForRxOrderEnum = {
    Email: 'Email',
    Fax: 'Fax',
    Post: 'Post'
} as const;

export type UpdateClinicDtoMethodForRxOrderEnum = typeof UpdateClinicDtoMethodForRxOrderEnum[keyof typeof UpdateClinicDtoMethodForRxOrderEnum];

/**
 * 
 * @export
 * @interface UpdateDelayStatusDto
 */
export interface UpdateDelayStatusDto {
    /**
     * Whether the transaction billing is delayed
     * @type {boolean}
     * @memberof UpdateDelayStatusDto
     */
    'isDelayed': boolean;
    /**
     * The amount that is delayed (required when isDelayed is true)
     * @type {number}
     * @memberof UpdateDelayStatusDto
     */
    'amountDelayed'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDiagnosisGroupDto
 */
export interface UpdateDiagnosisGroupDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'a'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'b'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'c'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'd'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDiagnosisGroupDto
     */
    'isRelevant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'PrimaryTreatments'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'SecondaryTreatments'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'MaxAmountPerRx'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'MaxAmountStandard'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'MaxAmountException'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'Frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiagnosisGroupDto
     */
    'rxTypeId'?: string;
    /**
     * 
     * @type {TherapyType}
     * @memberof UpdateDiagnosisGroupDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface UpdateDoctorDto
 */
export interface UpdateDoctorDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDoctorDto
     */
    'id'?: string;
    /**
     * Official LANR (9 numeric digits)
     * @type {string}
     * @memberof UpdateDoctorDto
     */
    'LANR'?: string;
    /**
     * List of clinics the doctor is associated with
     * @type {Array<string>}
     * @memberof UpdateDoctorDto
     */
    'clinics'?: Array<string>;
    /**
     * 
     * @type {ContactInfoDTO}
     * @memberof UpdateDoctorDto
     */
    'contactInfo'?: ContactInfoDTO;
}
/**
 * 
 * @export
 * @interface UpdateDocumentDto
 */
export interface UpdateDocumentDto {
    /**
     * The name of the document
     * @type {string}
     * @memberof UpdateDocumentDto
     */
    'label'?: string;
    /**
     * The document type
     * @type {string}
     * @memberof UpdateDocumentDto
     */
    'docuType'?: string;
}
/**
 * 
 * @export
 * @interface UpdateExportStatusDto
 */
export interface UpdateExportStatusDto {
    /**
     * Boolean value to indicate if the transaction was exported
     * @type {boolean}
     * @memberof UpdateExportStatusDto
     */
    'wasExported': boolean;
    /**
     * Status of the bill (START, OPEN, PREVIOUS)
     * @type {string}
     * @memberof UpdateExportStatusDto
     */
    'billStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateInsuranceTransactionDto
 */
export interface UpdateInsuranceTransactionDto {
    /**
     * ID of the associated account
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'accountId'?: string;
    /**
     * UUID of the associated user
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'userId'?: string;
    /**
     * Flag indicating whether the transaction was exported
     * @type {boolean}
     * @memberof UpdateInsuranceTransactionDto
     */
    'wasExported'?: boolean;
    /**
     * ID of the associated TAccount
     * @type {number}
     * @memberof UpdateInsuranceTransactionDto
     */
    'tAccountId'?: number;
    /**
     * Associated Business ID
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'businessId'?: string;
    /**
     * Associated Location ID
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'locationId'?: string;
    /**
     * Total amount of all the relevant Rxs/Transaction
     * @type {number}
     * @memberof UpdateInsuranceTransactionDto
     */
    'amount'?: number;
    /**
     * Array of UUIDs of the associated Rxs
     * @type {Array<string>}
     * @memberof UpdateInsuranceTransactionDto
     */
    'rxIds'?: Array<string>;
    /**
     * ID of the associated payer
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'payerId'?: string;
    /**
     * ID of the associated paper billing center
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'paperCenterId'?: string;
    /**
     * ID of the associated digital billing center
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'dataCenterId'?: string;
    /**
     * Notes for the transaction
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'notes'?: string;
    /**
     * Type of the bill (BG, GKV)
     * @type {string}
     * @memberof UpdateInsuranceTransactionDto
     */
    'billType'?: string;
    /**
     * Selected line items per Rx for LINE_ITEM_CORRECTION bills
     * @type {Array<RxLineItemSelectionDto>}
     * @memberof UpdateInsuranceTransactionDto
     */
    'rxLineItemSelections'?: Array<RxLineItemSelectionDto>;
}
/**
 * 
 * @export
 * @interface UpdateLocationDto
 */
export interface UpdateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'businessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'primaryAccountId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationDto
     */
    'accountIds'?: Array<string>;
    /**
     * 
     * @type {KontakInfoDto}
     * @memberof UpdateLocationDto
     */
    'addressContactInfo'?: KontakInfoDto;
}
/**
 * 
 * @export
 * @interface UpdateMandateDto
 */
export interface UpdateMandateDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMandateDto
     */
    'bankAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMandateDto
     */
    'holderFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMandateDto
     */
    'holderLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMandateDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMandateDto
     */
    'bic'?: string;
    /**
     * Optional cap for one-off (OOFF) mandates.
     * @type {number}
     * @memberof UpdateMandateDto
     */
    'maxAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMandateDto
     */
    'validUntil'?: string;
}
/**
 * 
 * @export
 * @interface UpdateNoteDto
 */
export interface UpdateNoteDto {
    /**
     * UUID of the persisted note to update.
     * @type {string}
     * @memberof UpdateNoteDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNoteDto
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateNoteDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNoteDto
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNoteDto
     */
    'rxId'?: string;
}
/**
 * 
 * @export
 * @interface UpdatePriceDateRangeDto
 */
export interface UpdatePriceDateRangeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePriceDateRangeDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePriceDateRangeDto
     */
    'invalidFrom'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePriceDateRangeDto
     */
    'price'?: number;
    /**
     * Date-specific Positionsnummer override
     * @type {string}
     * @memberof UpdatePriceDateRangeDto
     */
    'lineItem'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProcessingStatusResponse
 */
export interface UpdateProcessingStatusResponse {
    /**
     * Response message with status update details
     * @type {string}
     * @memberof UpdateProcessingStatusResponse
     */
    'message': string;
    /**
     * Indicates if a doctor report was automatically created
     * @type {boolean}
     * @memberof UpdateProcessingStatusResponse
     */
    'doctorReportCreated'?: boolean;
    /**
     * Details about the doctor report creation
     * @type {object}
     * @memberof UpdateProcessingStatusResponse
     */
    'doctorReportDetails'?: object;
}
/**
 * 
 * @export
 * @interface UpdatePublicHolidayDto
 */
export interface UpdatePublicHolidayDto {
    /**
     * Title of the public holiday
     * @type {string}
     * @memberof UpdatePublicHolidayDto
     */
    'title'?: string;
    /**
     * Start date of the public holiday
     * @type {string}
     * @memberof UpdatePublicHolidayDto
     */
    'start'?: string;
    /**
     * End date of the public holiday
     * @type {string}
     * @memberof UpdatePublicHolidayDto
     */
    'end'?: string;
    /**
     * Bundesland code (null for national holidays)
     * @type {string}
     * @memberof UpdatePublicHolidayDto
     */
    'bundesland'?: string;
    /**
     * Year of the public holiday
     * @type {number}
     * @memberof UpdatePublicHolidayDto
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface UpdateRechnungDto
 */
export interface UpdateRechnungDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateRechnungDto
     */
    'newAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRechnungDto
     */
    'paymentStatus'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSelectedLineItems200Response
 */
export interface UpdateSelectedLineItems200Response {
    /**
     * 
     * @type {number}
     * @memberof UpdateSelectedLineItems200Response
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface UpdateSelectedLineItemsRequest
 */
export interface UpdateSelectedLineItemsRequest {
    /**
     * 
     * @type {Array<object>}
     * @memberof UpdateSelectedLineItemsRequest
     */
    'selectedLineItems': Array<object>;
}
/**
 * 
 * @export
 * @interface UpdateTherapyDto
 */
export interface UpdateTherapyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTherapyDto
     */
    'lineItem'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTherapyDto
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTherapyDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTherapyDto
     */
    'inUse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTherapyDto
     */
    'isSupplementary'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof UpdateTherapyDto
     */
    'duration'?: object;
    /**
     * 
     * @type {number}
     * @memberof UpdateTherapyDto
     */
    'maxParticipants'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTherapyDto
     */
    'tarifGroupId'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateTherapyDto
     */
    'therapyCertificationId'?: object;
    /**
     * 
     * @type {TherapyType}
     * @memberof UpdateTherapyDto
     */
    'therapyType'?: TherapyType;
}


/**
 * 
 * @export
 * @interface UpdateTssDto
 */
export interface UpdateTssDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTssDto
     */
    'tssId': string;
    /**
     * Next lifecycle state
     * @type {string}
     * @memberof UpdateTssDto
     */
    'state': UpdateTssDtoStateEnum;
}

export const UpdateTssDtoStateEnum = {
    Uninitialized: 'UNINITIALIZED',
    Initialized: 'INITIALIZED',
    Disabled: 'DISABLED'
} as const;

export type UpdateTssDtoStateEnum = typeof UpdateTssDtoStateEnum[keyof typeof UpdateTssDtoStateEnum];

/**
 * 
 * @export
 * @interface UploadDocumentDto
 */
export interface UploadDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentDto
     */
    'docuType': UploadDocumentDtoDocuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentDto
     */
    'ownerType': UploadDocumentDtoOwnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentDto
     */
    'ownerId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadDocumentDto
     */
    'makeAccessible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentDto
     */
    'noticeDefinitionDataId'?: string;
    /**
     * Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @type {boolean}
     * @memberof UploadDocumentDto
     */
    'scanToSearchablePdf'?: boolean;
    /**
     * 
     * @type {File}
     * @memberof UploadDocumentDto
     */
    'file': File;
}

export const UploadDocumentDtoDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;

export type UploadDocumentDtoDocuTypeEnum = typeof UploadDocumentDtoDocuTypeEnum[keyof typeof UploadDocumentDtoDocuTypeEnum];
export const UploadDocumentDtoOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;

export type UploadDocumentDtoOwnerTypeEnum = typeof UploadDocumentDtoOwnerTypeEnum[keyof typeof UploadDocumentDtoOwnerTypeEnum];

/**
 * 
 * @export
 * @interface UploadDocumentMetadataDto
 */
export interface UploadDocumentMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentMetadataDto
     */
    'docuType': UploadDocumentMetadataDtoDocuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentMetadataDto
     */
    'ownerType': UploadDocumentMetadataDtoOwnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentMetadataDto
     */
    'ownerId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadDocumentMetadataDto
     */
    'makeAccessible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentMetadataDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentMetadataDto
     */
    'noticeDefinitionDataId'?: string;
    /**
     * Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @type {boolean}
     * @memberof UploadDocumentMetadataDto
     */
    'scanToSearchablePdf'?: boolean;
}

export const UploadDocumentMetadataDtoDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;

export type UploadDocumentMetadataDtoDocuTypeEnum = typeof UploadDocumentMetadataDtoDocuTypeEnum[keyof typeof UploadDocumentMetadataDtoDocuTypeEnum];
export const UploadDocumentMetadataDtoOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;

export type UploadDocumentMetadataDtoOwnerTypeEnum = typeof UploadDocumentMetadataDtoOwnerTypeEnum[keyof typeof UploadDocumentMetadataDtoOwnerTypeEnum];

/**
 * 
 * @export
 * @interface UploadNoticeDocumentDto
 */
export interface UploadNoticeDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof UploadNoticeDocumentDto
     */
    'docuType': UploadNoticeDocumentDtoDocuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadNoticeDocumentDto
     */
    'ownerType': UploadNoticeDocumentDtoOwnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadNoticeDocumentDto
     */
    'ownerId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadNoticeDocumentDto
     */
    'makeAccessible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadNoticeDocumentDto
     */
    'rxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadNoticeDocumentDto
     */
    'noticeDefinitionDataId': string;
    /**
     * Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @type {boolean}
     * @memberof UploadNoticeDocumentDto
     */
    'scanToSearchablePdf'?: boolean;
    /**
     * 
     * @type {File}
     * @memberof UploadNoticeDocumentDto
     */
    'file': File;
}

export const UploadNoticeDocumentDtoDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;

export type UploadNoticeDocumentDtoDocuTypeEnum = typeof UploadNoticeDocumentDtoDocuTypeEnum[keyof typeof UploadNoticeDocumentDtoDocuTypeEnum];
export const UploadNoticeDocumentDtoOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;

export type UploadNoticeDocumentDtoOwnerTypeEnum = typeof UploadNoticeDocumentDtoOwnerTypeEnum[keyof typeof UploadNoticeDocumentDtoOwnerTypeEnum];

/**
 * 
 * @export
 * @interface UpsertPrescribedTherapyDto
 */
export interface UpsertPrescribedTherapyDto {
    /**
     * Omit on create to derive from the label.
     * @type {string}
     * @memberof UpsertPrescribedTherapyDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPrescribedTherapyDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPrescribedTherapyDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPrescribedTherapyDto
     */
    'isSupplementary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertPrescribedTherapyDto
     */
    'therapyType'?: UpsertPrescribedTherapyDtoTherapyTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPrescribedTherapyDto
     */
    'aliases'?: Array<string>;
    /**
     * 
     * @type {Array<SetResolutionDto>}
     * @memberof UpsertPrescribedTherapyDto
     */
    'resolutions'?: Array<SetResolutionDto>;
}

export const UpsertPrescribedTherapyDtoTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type UpsertPrescribedTherapyDtoTherapyTypeEnum = typeof UpsertPrescribedTherapyDtoTherapyTypeEnum[keyof typeof UpsertPrescribedTherapyDtoTherapyTypeEnum];

/**
 * 
 * @export
 * @interface UpsertTherapyMethodDto
 */
export interface UpsertTherapyMethodDto {
    /**
     * Omit on create to derive from the label.
     * @type {string}
     * @memberof UpsertTherapyMethodDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTherapyMethodDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTherapyMethodDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertTherapyMethodDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertTherapyMethodDto
     */
    'isPassive'?: boolean;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'bundesland'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'nickName'?: string;
    /**
     * 
     * @type {BusinessDto}
     * @memberof UserDto
     */
    'business'?: BusinessDto;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'locationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'therapistLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'therapist'?: string;
    /**
     * 
     * @type {Array<TherapyDtoForUser>}
     * @memberof UserDto
     */
    'therapies'?: Array<TherapyDtoForUser>;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof UserDto
     */
    'roles'?: Array<RoleDto>;
    /**
     * 
     * @type {Array<PermissionDto>}
     * @memberof UserDto
     */
    'permissions'?: Array<PermissionDto>;
    /**
     * Discipline of a NEW therapist. Decides the default therapy grants at creation: Ergotherapie grants every ergo line item (ergo therapists are not certificate-gated), Physiotherapie (and omitted, for backward compatibility) grants the \'Alle Physiotherapeuten\' set. Ignored on updates — grants are managed on the Fortbildungen screen after creation.
     * @type {string}
     * @memberof UserDto
     */
    'therapistDiscipline'?: UserDtoTherapistDisciplineEnum;
    /**
     * Last working day of the user
     * @type {string}
     * @memberof UserDto
     */
    'lastWorkDay'?: string;
    /**
     * Annual vacation entitlement in days
     * @type {number}
     * @memberof UserDto
     */
    'vacationDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'punchInTime'?: string | null;
    /**
     * Calendar column position for the requested location; lower ranks are shown further left
     * @type {number}
     * @memberof UserDto
     */
    'columnSortRank'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'deletedAt'?: string;
}

export const UserDtoTherapistDisciplineEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;

export type UserDtoTherapistDisciplineEnum = typeof UserDtoTherapistDisciplineEnum[keyof typeof UserDtoTherapistDisciplineEnum];

/**
 * 
 * @export
 * @interface UserFilterBaseDto
 */
export interface UserFilterBaseDto {
    /**
     * Array of relations to fetch
     * @type {Array<UserRelationsEnum>}
     * @memberof UserFilterBaseDto
     */
    'relations'?: Array<UserRelationsEnum>;
    /**
     * You need soft deleted users
     * @type {boolean}
     * @memberof UserFilterBaseDto
     */
    'withDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface UserFilterDto
 */
export interface UserFilterDto {
    /**
     * Number of items per page (Max = 50)
     * @type {number}
     * @memberof UserFilterDto
     */
    'limit'?: number;
    /**
     * Page number (Min = 1)
     * @type {number}
     * @memberof UserFilterDto
     */
    'page'?: number;
    /**
     * Array of relations to fetch
     * @type {Array<UserRelationsEnum>}
     * @memberof UserFilterDto
     */
    'relations'?: Array<UserRelationsEnum>;
    /**
     * You need soft deleted users
     * @type {boolean}
     * @memberof UserFilterDto
     */
    'withDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserFilterDto
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface UserRegisterDto
 */
export interface UserRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserRelationsEnum = {
    Location: 'LOCATION',
    TherapistLocation: 'THERAPIST_LOCATION',
    Therapies: 'THERAPIES',
    WeeklyWorkDays: 'WEEKLY_WORK_DAYS',
    Roles: 'ROLES',
    Permissions: 'PERMISSIONS',
    RolesPermissions: 'ROLES_PERMISSIONS',
    LocationAddress: 'LOCATION_ADDRESS',
    Business: 'BUSINESS'
} as const;

export type UserRelationsEnum = typeof UserRelationsEnum[keyof typeof UserRelationsEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const VALIDATERXBULKJobName = {
    ValidateRxBulk: 'VALIDATE_RX_BULK'
} as const;

export type VALIDATERXBULKJobName = typeof VALIDATERXBULKJobName[keyof typeof VALIDATERXBULKJobName];


/**
 * 
 * @export
 * @interface ValidateGkvBillRxsRequest
 */
export interface ValidateGkvBillRxsRequest {
    /**
     * Array of Rx IDs to validate
     * @type {Array<string>}
     * @memberof ValidateGkvBillRxsRequest
     */
    'rxIds': Array<string>;
}
/**
 * 
 * @export
 * @interface ValidateProposalDto
 */
export interface ValidateProposalDto {
    /**
     * 
     * @type {Array<BackplanActionDto>}
     * @memberof ValidateProposalDto
     */
    'actions': Array<BackplanActionDto>;
    /**
     * 
     * @type {string}
     * @memberof ValidateProposalDto
     */
    'date': string;
    /**
     * Location UUID — needed for therapist credential checks
     * @type {string}
     * @memberof ValidateProposalDto
     */
    'locationId'?: string;
    /**
     * TherapyRx IDs that belong to the DT template for this day. Used to determine DT precedence: when a DT action is blocked by an existing appointment whose therapyRxId is NOT in this set (non-DT), the action is valid and the blocking appointment is reported as displaced.
     * @type {Array<string>}
     * @memberof ValidateProposalDto
     */
    'dtTherapyRxIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ValidationResultDto
 */
export interface ValidationResultDto {
    /**
     * 
     * @type {Array<ActionValidationResultDto>}
     * @memberof ValidationResultDto
     */
    'results': Array<ActionValidationResultDto>;
}
/**
 * 
 * @export
 * @interface ValidityDto
 */
export interface ValidityDto {
    /**
     * 
     * @type {string}
     * @memberof ValidityDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ValidityDto
     */
    'validity': ValidityDtoValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidityDto
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof ValidityDto
     */
    'additionalInfo'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof ValidityDto
     */
    'checkFailed'?: boolean;
}

export const ValidityDtoValidityEnum = {
    Valid: 'Valid',
    NotValid: 'Not Valid',
    PartiallyValid: 'Partially Valid'
} as const;

export type ValidityDtoValidityEnum = typeof ValidityDtoValidityEnum[keyof typeof ValidityDtoValidityEnum];

/**
 * 
 * @export
 * @interface VersionWorkPlanDto
 */
export interface VersionWorkPlanDto {
    /**
     * ID of the existing work plan to version
     * @type {number}
     * @memberof VersionWorkPlanDto
     */
    'workPlanId': number;
    /**
     * Date from which the change should apply (YYYY-MM-DD). Must be >= today.
     * @type {string}
     * @memberof VersionWorkPlanDto
     */
    'effectiveDate': string;
    /**
     * The weekly work days for the new versioned plan (with user changes applied)
     * @type {Array<WeeklyWorkDayDto>}
     * @memberof VersionWorkPlanDto
     */
    'weeklyWorkDays': Array<WeeklyWorkDayDto>;
}
/**
 * 
 * @export
 * @interface VisitFeeDisplayDto
 */
export interface VisitFeeDisplayDto {
    /**
     * Visit fee ID
     * @type {string}
     * @memberof VisitFeeDisplayDto
     */
    'id': string;
    /**
     * Visit fee abbreviation
     * @type {string}
     * @memberof VisitFeeDisplayDto
     */
    'abbreviation'?: string;
}
/**
 * 
 * @export
 * @interface WaitListEntryDto
 */
export interface WaitListEntryDto {
    /**
     * Unique identifier for the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'id'?: string;
    /**
     * Optional note for the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'note'?: string;
    /**
     * Start date and time for the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'start'?: string;
    /**
     * End date and time for the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'end'?: string;
    /**
     * Optional prescription series ID associated with the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'rxSeriesId'?: string;
    /**
     * Optional prescription ID associated with the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'rxId'?: string;
    /**
     * Optional therapist ID associated with the waitlist entry.
     * @type {string}
     * @memberof WaitListEntryDto
     */
    'therapistId'?: string;
    /**
     * Indicates if the patient is currently waiting.
     * @type {boolean}
     * @memberof WaitListEntryDto
     */
    'isWaiting'?: boolean | null;
}
/**
 * 
 * @export
 * @interface WaitListFilters
 */
export interface WaitListFilters {
    /**
     * If true, only appointments matching the exact location(s) will be included.
     * @type {boolean}
     * @memberof WaitListFilters
     */
    'exactLocation'?: boolean;
    /**
     * Array of location objects to match if exactLocation is true.
     * @type {Array<AddressDto>}
     * @memberof WaitListFilters
     */
    'locations'?: Array<AddressDto>;
    /**
     * If true, only appointments matching the specified therapists will be included.
     * @type {boolean}
     * @memberof WaitListFilters
     */
    'therapistMatch'?: boolean;
    /**
     * Array of therapist objects to match if therapistMatch is true.
     * @type {Array<UserDto>}
     * @memberof WaitListFilters
     */
    'therapists'?: Array<UserDto>;
    /**
     * If true, only fetch patient appointments with waitList flag true.
     * @type {boolean}
     * @memberof WaitListFilters
     */
    'waitList'?: boolean;
    /**
     * If true, only fetch appointments with the exact same duration.
     * @type {boolean}
     * @memberof WaitListFilters
     */
    'exactDuration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaitListFilters
     */
    'sensibleVisitTypeChange'?: boolean;
    /**
     * Duration in minutes for filtering appointments.
     * @type {number}
     * @memberof WaitListFilters
     */
    'duration'?: number;
    /**
     * Page number for pagination (starting from 1).
     * @type {number}
     * @memberof WaitListFilters
     */
    'page'?: number;
    /**
     * Number of items per page for pagination.
     * @type {number}
     * @memberof WaitListFilters
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface WaitListResponse
 */
export interface WaitListResponse {
    /**
     * Array of appointment objects matching the waitlist criteria.
     * @type {Array<object>}
     * @memberof WaitListResponse
     */
    'data': Array<object>;
    /**
     * Total number of appointments matching the criteria.
     * @type {number}
     * @memberof WaitListResponse
     */
    'total'?: number;
    /**
     * Total number of pages available based on the limit.
     * @type {number}
     * @memberof WaitListResponse
     */
    'totalPages'?: number;
    /**
     * Current page number.
     * @type {number}
     * @memberof WaitListResponse
     */
    'page'?: number;
    /**
     * Number of items per page.
     * @type {number}
     * @memberof WaitListResponse
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WaivableFee = {
    Assessment: 'ASSESSMENT'
} as const;

export type WaivableFee = typeof WaivableFee[keyof typeof WaivableFee];


/**
 * 
 * @export
 * @interface WebSocketAppointmentDto
 */
export interface WebSocketAppointmentDto {
    /**
     * The appointment or timeslot data being updated
     * @type {object}
     * @memberof WebSocketAppointmentDto
     */
    'data'?: object;
    /**
     * Type of appointment/timeslot being updated
     * @type {string}
     * @memberof WebSocketAppointmentDto
     */
    'type'?: WebSocketAppointmentDtoTypeEnum;
    /**
     * Source of the update (e.g., \'updateAppointmentById\', \'deleteTimeSlot\')
     * @type {string}
     * @memberof WebSocketAppointmentDto
     */
    'source'?: string;
    /**
     * Action being performed on the appointment
     * @type {string}
     * @memberof WebSocketAppointmentDto
     */
    'action'?: WebSocketAppointmentDtoActionEnum;
    /**
     * Per-tab id of the client that initiated the change (from the X-Client-Id request header). Clients use this to ignore the echo of their own mutations.
     * @type {string}
     * @memberof WebSocketAppointmentDto
     */
    'clientId'?: string;
}

export const WebSocketAppointmentDtoTypeEnum = {
    TimeSlot: 'TimeSlot',
    Appointment: 'Appointment',
    ContinuousTimeSlot: 'ContinuousTimeSlot',
    ContinuousAppointment: 'ContinuousAppointment',
    EventTimeSlot: 'EventTimeSlot',
    ContinuousEventTimeSlot: 'ContinuousEventTimeSlot',
    SimpleWorkingHours: 'SimpleWorkingHours',
    CancelledAppointment: 'CancelledAppointment',
    TreatmentNote: 'TreatmentNote'
} as const;

export type WebSocketAppointmentDtoTypeEnum = typeof WebSocketAppointmentDtoTypeEnum[keyof typeof WebSocketAppointmentDtoTypeEnum];
export const WebSocketAppointmentDtoActionEnum = {
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete'
} as const;

export type WebSocketAppointmentDtoActionEnum = typeof WebSocketAppointmentDtoActionEnum[keyof typeof WebSocketAppointmentDtoActionEnum];

/**
 * 
 * @export
 * @interface WeeklyRxTrendDto
 */
export interface WeeklyRxTrendDto {
    /**
     * Week identifier in start_end date format
     * @type {string}
     * @memberof WeeklyRxTrendDto
     */
    'week': string;
    /**
     * Week start date
     * @type {string}
     * @memberof WeeklyRxTrendDto
     */
    'weekStart': string;
    /**
     * Week end date
     * @type {string}
     * @memberof WeeklyRxTrendDto
     */
    'weekEnd': string;
    /**
     * Total number of prescriptions (Rxs)
     * @type {number}
     * @memberof WeeklyRxTrendDto
     */
    'totalRxs': number;
    /**
     * Breakdown by Rx type
     * @type {object}
     * @memberof WeeklyRxTrendDto
     */
    'rxTypes': object;
}
/**
 * 
 * @export
 * @interface WeeklyTransactionTrendDto
 */
export interface WeeklyTransactionTrendDto {
    /**
     * Week identifier in start_end date format
     * @type {string}
     * @memberof WeeklyTransactionTrendDto
     */
    'week': string;
    /**
     * Week start date
     * @type {string}
     * @memberof WeeklyTransactionTrendDto
     */
    'weekStart': string;
    /**
     * Week end date
     * @type {string}
     * @memberof WeeklyTransactionTrendDto
     */
    'weekEnd': string;
    /**
     * Total number of transactions in this week
     * @type {number}
     * @memberof WeeklyTransactionTrendDto
     */
    'totalTransactions': number;
    /**
     * Total amount for this week
     * @type {number}
     * @memberof WeeklyTransactionTrendDto
     */
    'totalAmount': number;
    /**
     * Total number of prescriptions (Rxs)
     * @type {number}
     * @memberof WeeklyTransactionTrendDto
     */
    'totalRxs': number;
    /**
     * Number of unique payers
     * @type {number}
     * @memberof WeeklyTransactionTrendDto
     */
    'uniquePayersCount': number;
    /**
     * Completion rate as percentage
     * @type {number}
     * @memberof WeeklyTransactionTrendDto
     */
    'completionRate': number;
}
/**
 * 
 * @export
 * @interface WeeklyWorkDayDto
 */
export interface WeeklyWorkDayDto {
    /**
     * 
     * @type {number}
     * @memberof WeeklyWorkDayDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyWorkDayDto
     */
    'dayOfWeek'?: number;
    /**
     * 
     * @type {string}
     * @memberof WeeklyWorkDayDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyWorkDayDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyWorkDayDto
     */
    'employeeId'?: string;
    /**
     * 
     * @type {WorkPlanDto}
     * @memberof WeeklyWorkDayDto
     */
    'workPlan'?: WorkPlanDto;
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyWorkDayDto
     */
    'isBreak'?: boolean;
}
/**
 * 
 * @export
 * @interface WorkHourExceptionDto
 */
export interface WorkHourExceptionDto {
    /**
     * 
     * @type {string}
     * @memberof WorkHourExceptionDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkHourExceptionDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkHourExceptionDto
     */
    'type'?: WorkHourExceptionDtoTypeEnum;
    /**
     * 
     * @type {Array<ExceptionSlotDto>}
     * @memberof WorkHourExceptionDto
     */
    'slots'?: Array<ExceptionSlotDto>;
    /**
     * 
     * @type {string}
     * @memberof WorkHourExceptionDto
     */
    'initiator'?: WorkHourExceptionDtoInitiatorEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkHourExceptionDto
     */
    'locationId'?: string | null;
}

export const WorkHourExceptionDtoTypeEnum = {
    Cancel: 'Cancel',
    Override: 'Override'
} as const;

export type WorkHourExceptionDtoTypeEnum = typeof WorkHourExceptionDtoTypeEnum[keyof typeof WorkHourExceptionDtoTypeEnum];
export const WorkHourExceptionDtoInitiatorEnum = {
    Employer: 'Employer',
    Employee: 'Employee'
} as const;

export type WorkHourExceptionDtoInitiatorEnum = typeof WorkHourExceptionDtoInitiatorEnum[keyof typeof WorkHourExceptionDtoInitiatorEnum];

/**
 * 
 * @export
 * @interface WorkPlanDto
 */
export interface WorkPlanDto {
    /**
     * 
     * @type {number}
     * @memberof WorkPlanDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPlanDto
     */
    'validityStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPlanDto
     */
    'validityEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkPlanDto
     */
    'employeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPlanDto
     */
    'locationId'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkflowEventAgentActionGroupsDto
 */
export interface WorkflowEventAgentActionGroupsDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventAgentActionGroupsDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventAgentActionGroupsDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {AgentActionGroupsDto}
     * @memberof WorkflowEventAgentActionGroupsDto
     */
    'data': AgentActionGroupsDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventBackplanningLlmStepDto
 */
export interface WorkflowEventBackplanningLlmStepDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventBackplanningLlmStepDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventBackplanningLlmStepDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {BackplanningLLMStepDto}
     * @memberof WorkflowEventBackplanningLlmStepDto
     */
    'data': BackplanningLLMStepDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventJobProgressDto
 */
export interface WorkflowEventJobProgressDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventJobProgressDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventJobProgressDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {JobProgressDto}
     * @memberof WorkflowEventJobProgressDto
     */
    'data': JobProgressDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WorkflowEventName = {
    JobProgress: 'JOB_PROGRESS',
    PatientStateCalculated: 'PATIENT_STATE_CALCULATED',
    SchedulingCalculated: 'SCHEDULING_CALCULATED',
    PatientAvailabilityLlmStep: 'PATIENT_AVAILABILITY_LLM_STEP',
    PatientAvailabilityLlmStepParsed: 'PATIENT_AVAILABILITY_LLM_STEP_PARSED',
    ReschedulingLlmStep: 'RESCHEDULING_LLM_STEP',
    BackplanningLlmStep: 'BACKPLANNING_LLM_STEP',
    AgentActionGroups: 'AGENT_ACTION_GROUPS',
    RxValidationBulkBatch: 'RX_VALIDATION_BULK_BATCH'
} as const;

export type WorkflowEventName = typeof WorkflowEventName[keyof typeof WorkflowEventName];


/**
 * 
 * @export
 * @interface WorkflowEventPatientAvailabilityLlmStepDto
 */
export interface WorkflowEventPatientAvailabilityLlmStepDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventPatientAvailabilityLlmStepDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventPatientAvailabilityLlmStepDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {PatientAvailabilityLLMStepDto}
     * @memberof WorkflowEventPatientAvailabilityLlmStepDto
     */
    'data': PatientAvailabilityLLMStepDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventPatientAvailabilityLlmStepParsedDto
 */
export interface WorkflowEventPatientAvailabilityLlmStepParsedDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventPatientAvailabilityLlmStepParsedDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventPatientAvailabilityLlmStepParsedDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {ParsedPatientAvailabilityLLMStepDto}
     * @memberof WorkflowEventPatientAvailabilityLlmStepParsedDto
     */
    'data': ParsedPatientAvailabilityLLMStepDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventPatientStateCalculatedDto
 */
export interface WorkflowEventPatientStateCalculatedDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventPatientStateCalculatedDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventPatientStateCalculatedDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {StateForPatientDto}
     * @memberof WorkflowEventPatientStateCalculatedDto
     */
    'data': StateForPatientDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventReschedulingLlmStepDto
 */
export interface WorkflowEventReschedulingLlmStepDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventReschedulingLlmStepDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventReschedulingLlmStepDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {ReschedulingLLMStepDto}
     * @memberof WorkflowEventReschedulingLlmStepDto
     */
    'data': ReschedulingLLMStepDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventResultSchemaMap
 */
export interface WorkflowEventResultSchemaMap {
    /**
     * 
     * @type {WorkflowEventJobProgressDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'JOB_PROGRESS'?: WorkflowEventJobProgressDto;
    /**
     * 
     * @type {WorkflowEventSchedulingCalculatedDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'SCHEDULING_CALCULATED'?: WorkflowEventSchedulingCalculatedDto;
    /**
     * 
     * @type {WorkflowEventPatientStateCalculatedDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'PATIENT_STATE_CALCULATED'?: WorkflowEventPatientStateCalculatedDto;
    /**
     * 
     * @type {WorkflowEventPatientAvailabilityLlmStepDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'PATIENT_AVAILABILITY_LLM_STEP'?: WorkflowEventPatientAvailabilityLlmStepDto;
    /**
     * 
     * @type {WorkflowEventPatientAvailabilityLlmStepParsedDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'PATIENT_AVAILABILITY_LLM_STEP_PARSED'?: WorkflowEventPatientAvailabilityLlmStepParsedDto;
    /**
     * 
     * @type {WorkflowEventReschedulingLlmStepDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'RESCHEDULING_LLM_STEP'?: WorkflowEventReschedulingLlmStepDto;
    /**
     * 
     * @type {WorkflowEventBackplanningLlmStepDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'BACKPLANNING_LLM_STEP'?: WorkflowEventBackplanningLlmStepDto;
    /**
     * 
     * @type {WorkflowEventAgentActionGroupsDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'AGENT_ACTION_GROUPS'?: WorkflowEventAgentActionGroupsDto;
    /**
     * 
     * @type {WorkflowEventRxValidationBulkBatchDto}
     * @memberof WorkflowEventResultSchemaMap
     */
    'RX_VALIDATION_BULK_BATCH'?: WorkflowEventRxValidationBulkBatchDto;
}
/**
 * 
 * @export
 * @interface WorkflowEventRxValidationBulkBatchDto
 */
export interface WorkflowEventRxValidationBulkBatchDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventRxValidationBulkBatchDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventRxValidationBulkBatchDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {RxValidationBulkBatchDto}
     * @memberof WorkflowEventRxValidationBulkBatchDto
     */
    'data': RxValidationBulkBatchDto;
}


/**
 * 
 * @export
 * @interface WorkflowEventSchedulingCalculatedDto
 */
export interface WorkflowEventSchedulingCalculatedDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowEventSchedulingCalculatedDto
     */
    'workflowId': string;
    /**
     * 
     * @type {WorkflowEventName}
     * @memberof WorkflowEventSchedulingCalculatedDto
     */
    'eventName': WorkflowEventName;
    /**
     * 
     * @type {SolutionDto}
     * @memberof WorkflowEventSchedulingCalculatedDto
     */
    'data': SolutionDto;
}


/**
 * 
 * @export
 * @interface WorkflowJobMeta
 */
export interface WorkflowJobMeta {
    /**
     * 
     * @type {string}
     * @memberof WorkflowJobMeta
     */
    'workflowId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJobMeta
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJobMeta
     */
    'phase': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WorkflowJobName = {
    AppointmentSuggestion: 'APPOINTMENT_SUGGESTION',
    GetAppointmentStateForPatient: 'GET_APPOINTMENT_STATE_FOR_PATIENT',
    CallPyAppSchedulingApi: 'CALL_PY_APP_SCHEDULING_API',
    GeneratePdfReport: 'GENERATE_PDF_REPORT',
    RunAiAgent: 'RUN_AI_AGENT',
    AvailabilityRequestForPatient: 'AVAILABILITY_REQUEST_FOR_PATIENT',
    CallPyAppPatientAvailabilityApi: 'CALL_PY_APP_PATIENT_AVAILABILITY_API',
    ReschedulingAgent: 'RESCHEDULING_AGENT',
    CallPyAppReschedulingApi: 'CALL_PY_APP_RESCHEDULING_API',
    RunBackplanning: 'RUN_BACKPLANNING',
    CallPyAppBackplanningApi: 'CALL_PY_APP_BACKPLANNING_API',
    ValidateRxBulk: 'VALIDATE_RX_BULK',
    RunRxValidationBulk: 'RUN_RX_VALIDATION_BULK',
    PdfLoadTestAggregator: 'PDF_LOAD_TEST_AGGREGATOR',
    GenerateBillPdf: 'GENERATE_BILL_PDF',
    BillPdfBatchAggregator: 'BILL_PDF_BATCH_AGGREGATOR',
    PrepBillPdfData: 'PREP_BILL_PDF_DATA',
    RenderBillPdf: 'RENDER_BILL_PDF',
    PersistBillPdfDocument: 'PERSIST_BILL_PDF_DOCUMENT',
    BillPdfMultiStepAggregator: 'BILL_PDF_MULTI_STEP_AGGREGATOR'
} as const;

export type WorkflowJobName = typeof WorkflowJobName[keyof typeof WorkflowJobName];


/**
 * 
 * @export
 * @enum {string}
 */

export const WorkflowName = {
    AppointmentSuggestionWorkflow: 'APPOINTMENT_SUGGESTION_WORKFLOW',
    BillingWorkflow: 'BILLING_WORKFLOW',
    PatientAvailabilityRequestWorkflow: 'PATIENT_AVAILABILITY_REQUEST_WORKFLOW',
    ReschedulingWorkflow: 'RESCHEDULING_WORKFLOW',
    BackplanningWorkflow: 'BACKPLANNING_WORKFLOW',
    RxValidationBulkWorkflow: 'RX_VALIDATION_BULK_WORKFLOW',
    PdfLoadTestWorkflow: 'PDF_LOAD_TEST_WORKFLOW',
    BillPdfBatchWorkflow: 'BILL_PDF_BATCH_WORKFLOW',
    BillPdfMultiStepWorkflow: 'BILL_PDF_MULTI_STEP_WORKFLOW'
} as const;

export type WorkflowName = typeof WorkflowName[keyof typeof WorkflowName];


/**
 * 
 * @export
 * @interface WorkflowProgressDto
 */
export interface WorkflowProgressDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowProgressDto
     */
    'workflowId': string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowProgressDto
     */
    'percent': number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowProgressDto
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface WorkflowRedisKeys
 */
export interface WorkflowRedisKeys {
    /**
     * Redis stream key to publish workflow events to
     * @type {string}
     * @memberof WorkflowRedisKeys
     */
    'workflowEventsStreamKey': string;
}
/**
 * 
 * @export
 * @interface WorkflowResultDto
 */
export interface WorkflowResultDto {
    /**
     * 
     * @type {string}
     * @memberof WorkflowResultDto
     */
    'workflowId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowResultDto
     */
    'workflowName': WorkflowResultDtoWorkflowNameEnum;
    /**
     * 
     * @type {WorkflowResultDtoData}
     * @memberof WorkflowResultDto
     */
    'data': WorkflowResultDtoData;
    /**
     * 
     * @type {Array<JobErrorDto>}
     * @memberof WorkflowResultDto
     */
    'errors': Array<JobErrorDto>;
}

export const WorkflowResultDtoWorkflowNameEnum = {
    AppointmentSuggestionWorkflow: 'APPOINTMENT_SUGGESTION_WORKFLOW',
    BillingWorkflow: 'BILLING_WORKFLOW',
    PatientAvailabilityRequestWorkflow: 'PATIENT_AVAILABILITY_REQUEST_WORKFLOW',
    ReschedulingWorkflow: 'RESCHEDULING_WORKFLOW',
    BackplanningWorkflow: 'BACKPLANNING_WORKFLOW',
    RxValidationBulkWorkflow: 'RX_VALIDATION_BULK_WORKFLOW',
    PdfLoadTestWorkflow: 'PDF_LOAD_TEST_WORKFLOW',
    BillPdfBatchWorkflow: 'BILL_PDF_BATCH_WORKFLOW',
    BillPdfMultiStepWorkflow: 'BILL_PDF_MULTI_STEP_WORKFLOW'
} as const;

export type WorkflowResultDtoWorkflowNameEnum = typeof WorkflowResultDtoWorkflowNameEnum[keyof typeof WorkflowResultDtoWorkflowNameEnum];

/**
 * @type WorkflowResultDtoData
 * @export
 */
export type WorkflowResultDtoData = { workflowName: 'APPOINTMENT_SUGGESTION_WORKFLOW' } & JobResultAppointmentSuggestionDto | { workflowName: 'BACKPLANNING_WORKFLOW' } & JobResultRunBackplanningDto | { workflowName: 'BILLING_WORKFLOW' } & JobResultGetAppointmentStateForPatientDto | { workflowName: 'BILL_PDF_BATCH_WORKFLOW' } & JobResultBillPdfBatchAggregatorDto | { workflowName: 'BILL_PDF_MULTI_STEP_WORKFLOW' } & JobResultBillPdfMultiStepAggregatorDto | { workflowName: 'PATIENT_AVAILABILITY_REQUEST_WORKFLOW' } & JobResultAvailabilityRequestForPatientDto | { workflowName: 'PDF_LOAD_TEST_WORKFLOW' } & JobResultPdfLoadTestAggregatorDto | { workflowName: 'RESCHEDULING_WORKFLOW' } & JobResultReschedulingAgentDto | { workflowName: 'RX_VALIDATION_BULK_WORKFLOW' } & JobResultValidateRxBulkDto;

/**
 * 
 * @export
 * @interface WorkingHoursDto
 */
export interface WorkingHoursDto {
    /**
     * 
     * @type {WeeklyWorkDayDto}
     * @memberof WorkingHoursDto
     */
    'weeklyWorkDay'?: WeeklyWorkDayDto;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'slotId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'source': WorkingHoursDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'exceptionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursDto
     */
    'isBreak': boolean;
    /**
     * Name of the public holiday when source is \'public-holiday\' (matched on the user\'s Bundesland).
     * @type {string}
     * @memberof WorkingHoursDto
     */
    'holidayTitle'?: string;
}

export const WorkingHoursDtoSourceEnum = {
    Plan: 'plan',
    Exception: 'exception',
    CancelledFullDay: 'cancelled-fullDay',
    PublicHoliday: 'public-holiday'
} as const;

export type WorkingHoursDtoSourceEnum = typeof WorkingHoursDtoSourceEnum[keyof typeof WorkingHoursDtoSourceEnum];

/**
 * 
 * @export
 * @interface YearEndRxUnfinishedValueDto
 */
export interface YearEndRxUnfinishedValueDto {
    /**
     * 
     * @type {string}
     * @memberof YearEndRxUnfinishedValueDto
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof YearEndRxUnfinishedValueDto
     */
    'accountName': string;
    /**
     * 
     * @type {string}
     * @memberof YearEndRxUnfinishedValueDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof YearEndRxUnfinishedValueDto
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof YearEndRxUnfinishedValueDto
     */
    'rxUnfinishedValue': number;
}

/**
 * AddressApi - axios parameter creator
 * @export
 */
export const AddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMissingAddressesCoordinates: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createMissingAddressesCoordinates', 'locationId', locationId)
            const localVarPath = `/address/createMissingAddressesCoordinates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SublocalityDto} sublocalityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSublocality: async (sublocalityDto: SublocalityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sublocalityDto' is not null or undefined
            assertParamExists('createSublocality', 'sublocalityDto', sublocalityDto)
            const localVarPath = `/address/createSublocality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sublocalityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSublocality: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSublocality', 'id', id)
            const localVarPath = `/address/deleteSublocality/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} addressId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodeAndSaveCoordinatesByAddressId: async (addressId: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('geocodeAndSaveCoordinatesByAddressId', 'addressId', addressId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('geocodeAndSaveCoordinatesByAddressId', 'locationId', locationId)
            const localVarPath = `/address/geocodeByAddressId/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodeAndUpdateCoordinatesForAddresses: async (locationId: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('geocodeAndUpdateCoordinatesForAddresses', 'locationId', locationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('geocodeAndUpdateCoordinatesForAddresses', 'requestBody', requestBody)
            const localVarPath = `/address/geocodeAndUpdateCoordinatesForAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSublocalities: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAllSublocalities', 'locationId', locationId)
            const localVarPath = `/address/getAllSublocalities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns address coordinates for the given appointment IDs. Only returns appointments that have geocoded address coordinates.
         * @summary Get coordinates for a batch of appointments
         * @param {Array<string>} requestBody Array of appointment IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentCoordinatesBatch: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getAppointmentCoordinatesBatch', 'requestBody', requestBody)
            const localVarPath = `/address/coordinates/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the closest scheduled appointments for a given week, sorted by Euclidean distance from the target coordinates. Limited to top N results.
         * @summary Get closest appointments for a week by distance
         * @param {string} locationId 
         * @param {ClosestAppointmentsRequestDto} closestAppointmentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosestAppointmentsByWeek: async (locationId: string, closestAppointmentsRequestDto: ClosestAppointmentsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getClosestAppointmentsByWeek', 'locationId', locationId)
            // verify required parameter 'closestAppointmentsRequestDto' is not null or undefined
            assertParamExists('getClosestAppointmentsByWeek', 'closestAppointmentsRequestDto', closestAppointmentsRequestDto)
            const localVarPath = `/address/closest-by-week`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closestAppointmentsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the continuous appointments closest to the target, sorted by driving time (falling back to Euclidean distance). The continuous plane has no dates, so results carry a weekday instead. Limited to top N results.
         * @summary Get the closest Dauertermine by distance
         * @param {string} locationId 
         * @param {ClosestContinuousAppointmentsRequestDto} closestContinuousAppointmentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosestContinuousAppointments: async (locationId: string, closestContinuousAppointmentsRequestDto: ClosestContinuousAppointmentsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getClosestContinuousAppointments', 'locationId', locationId)
            // verify required parameter 'closestContinuousAppointmentsRequestDto' is not null or undefined
            assertParamExists('getClosestContinuousAppointments', 'closestContinuousAppointmentsRequestDto', closestContinuousAppointmentsRequestDto)
            const localVarPath = `/address/closest-continuous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closestContinuousAppointmentsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all sublocalities that have geometry definitions as a GeoJSON FeatureCollection. Each feature contains id, name, abbreviation, and color in properties.
         * @summary Export sublocalities with geometries as GeoJSON
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeojsonSublocalities: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getGeojsonSublocalities', 'locationId', locationId)
            const localVarPath = `/address/getGeojson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsCoordinates: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getPatientsCoordinates', 'locationId', locationId)
            const localVarPath = `/address/getPatientsCoordinates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {Array<AddressDto>} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSublocalityForAddresses: async (locationId: string, addressDto: Array<AddressDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getSublocalityForAddresses', 'locationId', locationId)
            // verify required parameter 'addressDto' is not null or undefined
            assertParamExists('getSublocalityForAddresses', 'addressDto', addressDto)
            const localVarPath = `/address/getSublocalityForAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Imports sublocality definitions from a GeoJSON FeatureCollection and then reapplies geometry-based matching to all addresses with coordinates.
         * @summary Import sublocalities from GeoJSON and reapply geometries to addresses
         * @param {string} locationId 
         * @param {object} body GeoJSON FeatureCollection with sublocality features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGeojsonSublocalities: async (locationId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('importGeojsonSublocalities', 'locationId', locationId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('importGeojsonSublocalities', 'body', body)
            const localVarPath = `/address/importGeojson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {SublocalityDto} sublocalityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSublocality: async (id: string, sublocalityDto: SublocalityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSublocality', 'id', id)
            // verify required parameter 'sublocalityDto' is not null or undefined
            assertParamExists('updateSublocality', 'sublocalityDto', sublocalityDto)
            const localVarPath = `/address/updateSublocality/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sublocalityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressApi - functional programming interface
 * @export
 */
export const AddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMissingAddressesCoordinates(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMissingAddressesCoordinates(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SublocalityDto} sublocalityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSublocality(sublocalityDto: SublocalityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSublocality(sublocalityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSublocality(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSublocality(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} addressId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geocodeAndSaveCoordinatesByAddressId(addressId: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geocodeAndSaveCoordinatesByAddressId(addressId, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geocodeAndUpdateCoordinatesForAddresses(locationId: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geocodeAndUpdateCoordinatesForAddresses(locationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSublocalities(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SublocalityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSublocalities(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns address coordinates for the given appointment IDs. Only returns appointments that have geocoded address coordinates.
         * @summary Get coordinates for a batch of appointments
         * @param {Array<string>} requestBody Array of appointment IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentCoordinatesBatch(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentCoordinatesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentCoordinatesBatch(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the closest scheduled appointments for a given week, sorted by Euclidean distance from the target coordinates. Limited to top N results.
         * @summary Get closest appointments for a week by distance
         * @param {string} locationId 
         * @param {ClosestAppointmentsRequestDto} closestAppointmentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClosestAppointmentsByWeek(locationId: string, closestAppointmentsRequestDto: ClosestAppointmentsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClosestAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClosestAppointmentsByWeek(locationId, closestAppointmentsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the continuous appointments closest to the target, sorted by driving time (falling back to Euclidean distance). The continuous plane has no dates, so results carry a weekday instead. Limited to top N results.
         * @summary Get the closest Dauertermine by distance
         * @param {string} locationId 
         * @param {ClosestContinuousAppointmentsRequestDto} closestContinuousAppointmentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClosestContinuousAppointments(locationId: string, closestContinuousAppointmentsRequestDto: ClosestContinuousAppointmentsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClosestContinuousAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClosestContinuousAppointments(locationId, closestContinuousAppointmentsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all sublocalities that have geometry definitions as a GeoJSON FeatureCollection. Each feature contains id, name, abbreviation, and color in properties.
         * @summary Export sublocalities with geometries as GeoJSON
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeojsonSublocalities(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeojsonSublocalities(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientsCoordinates(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientCoordinatesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientsCoordinates(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {Array<AddressDto>} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSublocalityForAddresses(locationId: string, addressDto: Array<AddressDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SublocalityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSublocalityForAddresses(locationId, addressDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Imports sublocality definitions from a GeoJSON FeatureCollection and then reapplies geometry-based matching to all addresses with coordinates.
         * @summary Import sublocalities from GeoJSON and reapply geometries to addresses
         * @param {string} locationId 
         * @param {object} body GeoJSON FeatureCollection with sublocality features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importGeojsonSublocalities(locationId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportGeojsonResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importGeojsonSublocalities(locationId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {SublocalityDto} sublocalityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSublocality(id: string, sublocalityDto: SublocalityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSublocality(id, sublocalityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AddressApi - factory interface
 * @export
 */
export const AddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMissingAddressesCoordinates(locationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.createMissingAddressesCoordinates(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SublocalityDto} sublocalityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSublocality(sublocalityDto: SublocalityDto, options?: any): AxiosPromise<object> {
            return localVarFp.createSublocality(sublocalityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSublocality(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSublocality(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} addressId 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodeAndSaveCoordinatesByAddressId(addressId: string, locationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.geocodeAndSaveCoordinatesByAddressId(addressId, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodeAndUpdateCoordinatesForAddresses(locationId: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.geocodeAndUpdateCoordinatesForAddresses(locationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSublocalities(locationId: string, options?: any): AxiosPromise<Array<SublocalityDto>> {
            return localVarFp.getAllSublocalities(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns address coordinates for the given appointment IDs. Only returns appointments that have geocoded address coordinates.
         * @summary Get coordinates for a batch of appointments
         * @param {Array<string>} requestBody Array of appointment IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentCoordinatesBatch(requestBody: Array<string>, options?: any): AxiosPromise<Array<AppointmentCoordinatesDto>> {
            return localVarFp.getAppointmentCoordinatesBatch(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the closest scheduled appointments for a given week, sorted by Euclidean distance from the target coordinates. Limited to top N results.
         * @summary Get closest appointments for a week by distance
         * @param {string} locationId 
         * @param {ClosestAppointmentsRequestDto} closestAppointmentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosestAppointmentsByWeek(locationId: string, closestAppointmentsRequestDto: ClosestAppointmentsRequestDto, options?: any): AxiosPromise<Array<ClosestAppointmentDto>> {
            return localVarFp.getClosestAppointmentsByWeek(locationId, closestAppointmentsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the continuous appointments closest to the target, sorted by driving time (falling back to Euclidean distance). The continuous plane has no dates, so results carry a weekday instead. Limited to top N results.
         * @summary Get the closest Dauertermine by distance
         * @param {string} locationId 
         * @param {ClosestContinuousAppointmentsRequestDto} closestContinuousAppointmentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosestContinuousAppointments(locationId: string, closestContinuousAppointmentsRequestDto: ClosestContinuousAppointmentsRequestDto, options?: any): AxiosPromise<Array<ClosestContinuousAppointmentDto>> {
            return localVarFp.getClosestContinuousAppointments(locationId, closestContinuousAppointmentsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all sublocalities that have geometry definitions as a GeoJSON FeatureCollection. Each feature contains id, name, abbreviation, and color in properties.
         * @summary Export sublocalities with geometries as GeoJSON
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeojsonSublocalities(locationId: string, options?: any): AxiosPromise<object> {
            return localVarFp.getGeojsonSublocalities(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsCoordinates(locationId: string, options?: any): AxiosPromise<Array<PatientCoordinatesDto>> {
            return localVarFp.getPatientsCoordinates(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {Array<AddressDto>} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSublocalityForAddresses(locationId: string, addressDto: Array<AddressDto>, options?: any): AxiosPromise<Array<SublocalityDto>> {
            return localVarFp.getSublocalityForAddresses(locationId, addressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Imports sublocality definitions from a GeoJSON FeatureCollection and then reapplies geometry-based matching to all addresses with coordinates.
         * @summary Import sublocalities from GeoJSON and reapply geometries to addresses
         * @param {string} locationId 
         * @param {object} body GeoJSON FeatureCollection with sublocality features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGeojsonSublocalities(locationId: string, body: object, options?: any): AxiosPromise<ImportGeojsonResultDto> {
            return localVarFp.importGeojsonSublocalities(locationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {SublocalityDto} sublocalityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSublocality(id: string, sublocalityDto: SublocalityDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateSublocality(id, sublocalityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
export class AddressApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public createMissingAddressesCoordinates(locationId: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).createMissingAddressesCoordinates(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SublocalityDto} sublocalityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public createSublocality(sublocalityDto: SublocalityDto, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).createSublocality(sublocalityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public deleteSublocality(id: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).deleteSublocality(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} addressId 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public geocodeAndSaveCoordinatesByAddressId(addressId: string, locationId: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).geocodeAndSaveCoordinatesByAddressId(addressId, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public geocodeAndUpdateCoordinatesForAddresses(locationId: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).geocodeAndUpdateCoordinatesForAddresses(locationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getAllSublocalities(locationId: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getAllSublocalities(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns address coordinates for the given appointment IDs. Only returns appointments that have geocoded address coordinates.
     * @summary Get coordinates for a batch of appointments
     * @param {Array<string>} requestBody Array of appointment IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getAppointmentCoordinatesBatch(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getAppointmentCoordinatesBatch(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the closest scheduled appointments for a given week, sorted by Euclidean distance from the target coordinates. Limited to top N results.
     * @summary Get closest appointments for a week by distance
     * @param {string} locationId 
     * @param {ClosestAppointmentsRequestDto} closestAppointmentsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getClosestAppointmentsByWeek(locationId: string, closestAppointmentsRequestDto: ClosestAppointmentsRequestDto, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getClosestAppointmentsByWeek(locationId, closestAppointmentsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the continuous appointments closest to the target, sorted by driving time (falling back to Euclidean distance). The continuous plane has no dates, so results carry a weekday instead. Limited to top N results.
     * @summary Get the closest Dauertermine by distance
     * @param {string} locationId 
     * @param {ClosestContinuousAppointmentsRequestDto} closestContinuousAppointmentsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getClosestContinuousAppointments(locationId: string, closestContinuousAppointmentsRequestDto: ClosestContinuousAppointmentsRequestDto, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getClosestContinuousAppointments(locationId, closestContinuousAppointmentsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all sublocalities that have geometry definitions as a GeoJSON FeatureCollection. Each feature contains id, name, abbreviation, and color in properties.
     * @summary Export sublocalities with geometries as GeoJSON
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getGeojsonSublocalities(locationId: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getGeojsonSublocalities(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getPatientsCoordinates(locationId: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getPatientsCoordinates(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {Array<AddressDto>} addressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getSublocalityForAddresses(locationId: string, addressDto: Array<AddressDto>, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getSublocalityForAddresses(locationId, addressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Imports sublocality definitions from a GeoJSON FeatureCollection and then reapplies geometry-based matching to all addresses with coordinates.
     * @summary Import sublocalities from GeoJSON and reapply geometries to addresses
     * @param {string} locationId 
     * @param {object} body GeoJSON FeatureCollection with sublocality features
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public importGeojsonSublocalities(locationId: string, body: object, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).importGeojsonSublocalities(locationId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {SublocalityDto} sublocalityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public updateSublocality(id: string, sublocalityDto: SublocalityDto, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).updateSublocality(id, sublocalityDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEntitiesApi - axios parameter creator
 * @export
 */
export const AdminEntitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {CreateAccountDto} createAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAccount: async (createAccountDto: CreateAccountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAccountDto' is not null or undefined
            assertParamExists('adminCreateAccount', 'createAccountDto', createAccountDto)
            const localVarPath = `/admin-entities/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateBusinessDto} createBusinessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateBusiness: async (createBusinessDto: CreateBusinessDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBusinessDto' is not null or undefined
            assertParamExists('adminCreateBusiness', 'createBusinessDto', createBusinessDto)
            const localVarPath = `/admin-entities/businesses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBusinessDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateLocation: async (createLocationDto: CreateLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLocationDto' is not null or undefined
            assertParamExists('adminCreateLocation', 'createLocationDto', createLocationDto)
            const localVarPath = `/admin-entities/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAccount: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteAccount', 'id', id)
            const localVarPath = `/admin-entities/accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteBusiness: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteBusiness', 'id', id)
            const localVarPath = `/admin-entities/businesses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteLocation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteLocation', 'id', id)
            const localVarPath = `/admin-entities/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAccountById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetAccountById', 'id', id)
            const localVarPath = `/admin-entities/accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAccountLogo: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetAccountLogo', 'id', id)
            const localVarPath = `/admin-entities/accounts/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllAccounts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-entities/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllBusinesses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-entities/businesses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllLocations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-entities/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBusinessById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetBusinessById', 'id', id)
            const localVarPath = `/admin-entities/businesses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLocationById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetLocationById', 'id', id)
            const localVarPath = `/admin-entities/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateAccountDto} updateAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAccount: async (id: string, updateAccountDto: UpdateAccountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateAccount', 'id', id)
            // verify required parameter 'updateAccountDto' is not null or undefined
            assertParamExists('adminUpdateAccount', 'updateAccountDto', updateAccountDto)
            const localVarPath = `/admin-entities/accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateBusinessDto} updateBusinessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateBusiness: async (id: string, updateBusinessDto: UpdateBusinessDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateBusiness', 'id', id)
            // verify required parameter 'updateBusinessDto' is not null or undefined
            assertParamExists('adminUpdateBusiness', 'updateBusinessDto', updateBusinessDto)
            const localVarPath = `/admin-entities/businesses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBusinessDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateLocation: async (id: string, updateLocationDto: UpdateLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateLocation', 'id', id)
            // verify required parameter 'updateLocationDto' is not null or undefined
            assertParamExists('adminUpdateLocation', 'updateLocationDto', updateLocationDto)
            const localVarPath = `/admin-entities/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadAccountLogo: async (id: string, file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUploadAccountLogo', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('adminUploadAccountLogo', 'file', file)
            const localVarPath = `/admin-entities/accounts/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEntitiesApi - functional programming interface
 * @export
 */
export const AdminEntitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEntitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateAccountDto} createAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateAccount(createAccountDto: CreateAccountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateAccount(createAccountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateBusinessDto} createBusinessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateBusiness(createBusinessDto: CreateBusinessDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateBusiness(createBusinessDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateLocation(createLocationDto: CreateLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateLocation(createLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteAccount(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteBusiness(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteBusiness(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteLocation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteLocation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAccountById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAccountById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAccountLogo(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLogoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAccountLogo(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllAccounts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllAccounts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllBusinesses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllBusinesses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllLocations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllLocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetBusinessById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetBusinessById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetLocationById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetLocationById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateAccountDto} updateAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateAccount(id: string, updateAccountDto: UpdateAccountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateAccount(id, updateAccountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateBusinessDto} updateBusinessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateBusiness(id: string, updateBusinessDto: UpdateBusinessDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateBusiness(id, updateBusinessDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateLocation(id: string, updateLocationDto: UpdateLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateLocation(id, updateLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUploadAccountLogo(id: string, file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLogoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUploadAccountLogo(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminEntitiesApi - factory interface
 * @export
 */
export const AdminEntitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEntitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateAccountDto} createAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAccount(createAccountDto: CreateAccountDto, options?: any): AxiosPromise<AccountDetailDto> {
            return localVarFp.adminCreateAccount(createAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateBusinessDto} createBusinessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateBusiness(createBusinessDto: CreateBusinessDto, options?: any): AxiosPromise<BusinessDetailDto> {
            return localVarFp.adminCreateBusiness(createBusinessDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateLocation(createLocationDto: CreateLocationDto, options?: any): AxiosPromise<LocationDetailDto> {
            return localVarFp.adminCreateLocation(createLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAccount(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminDeleteAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteBusiness(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminDeleteBusiness(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteLocation(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminDeleteLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAccountById(id: string, options?: any): AxiosPromise<AccountDetailDto> {
            return localVarFp.adminGetAccountById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAccountLogo(id: string, options?: any): AxiosPromise<AccountLogoDto> {
            return localVarFp.adminGetAccountLogo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllAccounts(options?: any): AxiosPromise<Array<AccountDetailDto>> {
            return localVarFp.adminGetAllAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllBusinesses(options?: any): AxiosPromise<Array<BusinessDetailDto>> {
            return localVarFp.adminGetAllBusinesses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllLocations(options?: any): AxiosPromise<Array<LocationDetailDto>> {
            return localVarFp.adminGetAllLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBusinessById(id: string, options?: any): AxiosPromise<BusinessDetailDto> {
            return localVarFp.adminGetBusinessById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLocationById(id: string, options?: any): AxiosPromise<LocationDetailDto> {
            return localVarFp.adminGetLocationById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateAccountDto} updateAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAccount(id: string, updateAccountDto: UpdateAccountDto, options?: any): AxiosPromise<AccountDetailDto> {
            return localVarFp.adminUpdateAccount(id, updateAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateBusinessDto} updateBusinessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateBusiness(id: string, updateBusinessDto: UpdateBusinessDto, options?: any): AxiosPromise<BusinessDetailDto> {
            return localVarFp.adminUpdateBusiness(id, updateBusinessDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateLocation(id: string, updateLocationDto: UpdateLocationDto, options?: any): AxiosPromise<LocationDetailDto> {
            return localVarFp.adminUpdateLocation(id, updateLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadAccountLogo(id: string, file: File, options?: any): AxiosPromise<AccountLogoDto> {
            return localVarFp.adminUploadAccountLogo(id, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEntitiesApi - object-oriented interface
 * @export
 * @class AdminEntitiesApi
 * @extends {BaseAPI}
 */
export class AdminEntitiesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {CreateAccountDto} createAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminCreateAccount(createAccountDto: CreateAccountDto, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminCreateAccount(createAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateBusinessDto} createBusinessDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminCreateBusiness(createBusinessDto: CreateBusinessDto, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminCreateBusiness(createBusinessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateLocationDto} createLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminCreateLocation(createLocationDto: CreateLocationDto, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminCreateLocation(createLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminDeleteAccount(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminDeleteAccount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminDeleteBusiness(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminDeleteBusiness(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminDeleteLocation(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminDeleteLocation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetAccountById(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetAccountById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetAccountLogo(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetAccountLogo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetAllAccounts(options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetAllAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetAllBusinesses(options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetAllBusinesses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetAllLocations(options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetAllLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetBusinessById(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetBusinessById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminGetLocationById(id: string, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminGetLocationById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateAccountDto} updateAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminUpdateAccount(id: string, updateAccountDto: UpdateAccountDto, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminUpdateAccount(id, updateAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateBusinessDto} updateBusinessDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminUpdateBusiness(id: string, updateBusinessDto: UpdateBusinessDto, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminUpdateBusiness(id, updateBusinessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateLocationDto} updateLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminUpdateLocation(id: string, updateLocationDto: UpdateLocationDto, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminUpdateLocation(id, updateLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntitiesApi
     */
    public adminUploadAccountLogo(id: string, file: File, options?: AxiosRequestConfig) {
        return AdminEntitiesApiFp(this.configuration).adminUploadAccountLogo(id, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentToolsApi - axios parameter creator
 * @export
 */
export const AgentToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns appointments and availability slots for multiple therapists across multiple dates. Used by the rescheduling agent to inspect therapist schedules and plan mutations.
         * @summary Get therapist calendars for specific dates
         * @param {TherapistCalendarsRequestDto} therapistCalendarsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistCalendars: async (therapistCalendarsRequestDto: TherapistCalendarsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistCalendarsRequestDto' is not null or undefined
            assertParamExists('getTherapistCalendars', 'therapistCalendarsRequestDto', therapistCalendarsRequestDto)
            const localVarPath = `/agent-tools/therapist-calendars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistCalendarsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate backplanning preview (intent summary + action list) without running the agent
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewBackplanning: async (runBackplanningDto: RunBackplanningDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runBackplanningDto' is not null or undefined
            assertParamExists('previewBackplanning', 'runBackplanningDto', runBackplanningDto)
            const localVarPath = `/agent-tools/backplanning/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runBackplanningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry backplanning for user-rejected days
         * @param {RetryBackplanningDto} retryBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryBackplanning: async (retryBackplanningDto: RetryBackplanningDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retryBackplanningDto' is not null or undefined
            assertParamExists('retryBackplanning', 'retryBackplanningDto', retryBackplanningDto)
            const localVarPath = `/agent-tools/backplanning/retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryBackplanningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger the backplanning agent for a CA change
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runBackplanning: async (runBackplanningDto: RunBackplanningDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runBackplanningDto' is not null or undefined
            assertParamExists('runBackplanning', 'runBackplanningDto', runBackplanningDto)
            const localVarPath = `/agent-tools/backplanning/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runBackplanningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedule a backplanning workflow (async with progress events)
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleBackplanningWorkflow: async (runBackplanningDto: RunBackplanningDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runBackplanningDto' is not null or undefined
            assertParamExists('scheduleBackplanningWorkflow', 'runBackplanningDto', runBackplanningDto)
            const localVarPath = `/agent-tools/backplanning/scheduleJob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runBackplanningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate proposed backplanning actions (used by backplanning agent)
         * @param {ValidateProposalDto} validateProposalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBackplanningProposal: async (validateProposalDto: ValidateProposalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateProposalDto' is not null or undefined
            assertParamExists('validateBackplanningProposal', 'validateProposalDto', validateProposalDto)
            const localVarPath = `/agent-tools/backplanning/validate-proposal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateProposalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentToolsApi - functional programming interface
 * @export
 */
export const AgentToolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentToolsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns appointments and availability slots for multiple therapists across multiple dates. Used by the rescheduling agent to inspect therapist schedules and plan mutations.
         * @summary Get therapist calendars for specific dates
         * @param {TherapistCalendarsRequestDto} therapistCalendarsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapistCalendars(therapistCalendarsRequestDto: TherapistCalendarsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistCalendarsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapistCalendars(therapistCalendarsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate backplanning preview (intent summary + action list) without running the agent
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewBackplanning(runBackplanningDto: RunBackplanningDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewBackplanning(runBackplanningDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retry backplanning for user-rejected days
         * @param {RetryBackplanningDto} retryBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryBackplanning(retryBackplanningDto: RetryBackplanningDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleAgentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryBackplanning(retryBackplanningDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Trigger the backplanning agent for a CA change
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runBackplanning(runBackplanningDto: RunBackplanningDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleAgentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runBackplanning(runBackplanningDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Schedule a backplanning workflow (async with progress events)
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleBackplanningWorkflow(runBackplanningDto: RunBackplanningDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedWorkflowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleBackplanningWorkflow(runBackplanningDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate proposed backplanning actions (used by backplanning agent)
         * @param {ValidateProposalDto} validateProposalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBackplanningProposal(validateProposalDto: ValidateProposalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBackplanningProposal(validateProposalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentToolsApi - factory interface
 * @export
 */
export const AgentToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentToolsApiFp(configuration)
    return {
        /**
         * Returns appointments and availability slots for multiple therapists across multiple dates. Used by the rescheduling agent to inspect therapist schedules and plan mutations.
         * @summary Get therapist calendars for specific dates
         * @param {TherapistCalendarsRequestDto} therapistCalendarsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistCalendars(therapistCalendarsRequestDto: TherapistCalendarsRequestDto, options?: any): AxiosPromise<TherapistCalendarsResponseDto> {
            return localVarFp.getTherapistCalendars(therapistCalendarsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate backplanning preview (intent summary + action list) without running the agent
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewBackplanning(runBackplanningDto: RunBackplanningDto, options?: any): AxiosPromise<void> {
            return localVarFp.previewBackplanning(runBackplanningDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry backplanning for user-rejected days
         * @param {RetryBackplanningDto} retryBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryBackplanning(retryBackplanningDto: RetryBackplanningDto, options?: any): AxiosPromise<ScheduleAgentResultDto> {
            return localVarFp.retryBackplanning(retryBackplanningDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger the backplanning agent for a CA change
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runBackplanning(runBackplanningDto: RunBackplanningDto, options?: any): AxiosPromise<ScheduleAgentResultDto> {
            return localVarFp.runBackplanning(runBackplanningDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedule a backplanning workflow (async with progress events)
         * @param {RunBackplanningDto} runBackplanningDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleBackplanningWorkflow(runBackplanningDto: RunBackplanningDto, options?: any): AxiosPromise<GeneratedWorkflowDto> {
            return localVarFp.scheduleBackplanningWorkflow(runBackplanningDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate proposed backplanning actions (used by backplanning agent)
         * @param {ValidateProposalDto} validateProposalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBackplanningProposal(validateProposalDto: ValidateProposalDto, options?: any): AxiosPromise<ValidationResultDto> {
            return localVarFp.validateBackplanningProposal(validateProposalDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentToolsApi - object-oriented interface
 * @export
 * @class AgentToolsApi
 * @extends {BaseAPI}
 */
export class AgentToolsApi extends BaseAPI {
    /**
     * Returns appointments and availability slots for multiple therapists across multiple dates. Used by the rescheduling agent to inspect therapist schedules and plan mutations.
     * @summary Get therapist calendars for specific dates
     * @param {TherapistCalendarsRequestDto} therapistCalendarsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentToolsApi
     */
    public getTherapistCalendars(therapistCalendarsRequestDto: TherapistCalendarsRequestDto, options?: AxiosRequestConfig) {
        return AgentToolsApiFp(this.configuration).getTherapistCalendars(therapistCalendarsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate backplanning preview (intent summary + action list) without running the agent
     * @param {RunBackplanningDto} runBackplanningDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentToolsApi
     */
    public previewBackplanning(runBackplanningDto: RunBackplanningDto, options?: AxiosRequestConfig) {
        return AgentToolsApiFp(this.configuration).previewBackplanning(runBackplanningDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry backplanning for user-rejected days
     * @param {RetryBackplanningDto} retryBackplanningDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentToolsApi
     */
    public retryBackplanning(retryBackplanningDto: RetryBackplanningDto, options?: AxiosRequestConfig) {
        return AgentToolsApiFp(this.configuration).retryBackplanning(retryBackplanningDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger the backplanning agent for a CA change
     * @param {RunBackplanningDto} runBackplanningDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentToolsApi
     */
    public runBackplanning(runBackplanningDto: RunBackplanningDto, options?: AxiosRequestConfig) {
        return AgentToolsApiFp(this.configuration).runBackplanning(runBackplanningDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedule a backplanning workflow (async with progress events)
     * @param {RunBackplanningDto} runBackplanningDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentToolsApi
     */
    public scheduleBackplanningWorkflow(runBackplanningDto: RunBackplanningDto, options?: AxiosRequestConfig) {
        return AgentToolsApiFp(this.configuration).scheduleBackplanningWorkflow(runBackplanningDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate proposed backplanning actions (used by backplanning agent)
     * @param {ValidateProposalDto} validateProposalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentToolsApi
     */
    public validateBackplanningProposal(validateProposalDto: ValidateProposalDto, options?: AxiosRequestConfig) {
        return AgentToolsApiFp(this.configuration).validateBackplanningProposal(validateProposalDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AiAgentsApi - axios parameter creator
 * @export
 */
export const AiAgentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgents: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai-agents/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {ChatRequestDto} chatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAgentChat: async (chatRequestDto: ChatRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatRequestDto' is not null or undefined
            assertParamExists('startAgentChat', 'chatRequestDto', chatRequestDto)
            const localVarPath = `/ai-agents/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiAgentsApi - functional programming interface
 * @export
 */
export const AiAgentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiAgentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgents(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAgentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgents(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {ChatRequestDto} chatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAgentChat(chatRequestDto: ChatRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAgentChat(chatRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AiAgentsApi - factory interface
 * @export
 */
export const AiAgentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiAgentsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgents(options?: any): AxiosPromise<ListAgentsResponseDto> {
            return localVarFp.listAgents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {ChatRequestDto} chatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAgentChat(chatRequestDto: ChatRequestDto, options?: any): AxiosPromise<ChatResponseDto> {
            return localVarFp.startAgentChat(chatRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiAgentsApi - object-oriented interface
 * @export
 * @class AiAgentsApi
 * @extends {BaseAPI}
 */
export class AiAgentsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiAgentsApi
     */
    public listAgents(options?: AxiosRequestConfig) {
        return AiAgentsApiFp(this.configuration).listAgents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {ChatRequestDto} chatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiAgentsApi
     */
    public startAgentChat(chatRequestDto: ChatRequestDto, options?: AxiosRequestConfig) {
        return AiAgentsApiFp(this.configuration).startAgentChat(chatRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppointmentApi - axios parameter creator
 * @export
 */
export const AppointmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint removes an appointment from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
         * @summary Remove an appointment by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        _delete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/appointment/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<GapJustificationDto>} gapJustificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateGapJustificationForTreatments: async (gapJustificationDto: Array<GapJustificationDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gapJustificationDto' is not null or undefined
            assertParamExists('addOrUpdateGapJustificationForTreatments', 'gapJustificationDto', gapJustificationDto)
            const localVarPath = `/appointment/treatment/gap-justification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gapJustificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {AdjustOutsideAppointmentsDto} adjustOutsideAppointmentsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustOutsideAppointments: async (adjustOutsideAppointmentsDto: AdjustOutsideAppointmentsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adjustOutsideAppointmentsDto' is not null or undefined
            assertParamExists('adjustOutsideAppointments', 'adjustOutsideAppointmentsDto', adjustOutsideAppointmentsDto)
            const localVarPath = `/appointment/adjustOutsideAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adjustOutsideAppointmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appointmentControllerCreate: async (appointmentDto: AppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentDto' is not null or undefined
            assertParamExists('appointmentControllerCreate', 'appointmentDto', appointmentDto)
            const localVarPath = `/appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist availability with improved handling of all-day time periods
         * @param {number} minutesNeeded 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<any>} [therapistIds] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appointmentControllerGetTherapistAvailabilityNew: async (minutesNeeded: number, startDate?: string, endDate?: string, therapistIds?: Array<any>, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'minutesNeeded' is not null or undefined
            assertParamExists('appointmentControllerGetTherapistAvailabilityNew', 'minutesNeeded', minutesNeeded)
            const localVarPath = `/appointment/availability/therapist-new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minutesNeeded !== undefined) {
                localVarQueryParameter['minutesNeeded'] = minutesNeeded;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (therapistIds) {
                localVarQueryParameter['therapistIds'] = therapistIds;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backFillContinuous: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('backFillContinuous', 'id', id)
            const localVarPath = `/appointment/backFillContinuous/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/batchCancelAndDeleteAppointments.
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        batchCancelAndDeleteAppointments: async (batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchCancelDeleteAppointmentDto' is not null or undefined
            assertParamExists('batchCancelAndDeleteAppointments', 'batchCancelDeleteAppointmentDto', batchCancelDeleteAppointmentDto)
            const localVarPath = `/appointment/batchCancelAndDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCancelDeleteAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/batchCancelAndDeleteTimeSlots.
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        batchCancelAndDeleteTimeSlots: async (batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchCancelDeleteAppointmentDto' is not null or undefined
            assertParamExists('batchCancelAndDeleteTimeSlots', 'batchCancelDeleteAppointmentDto', batchCancelDeleteAppointmentDto)
            const localVarPath = `/appointment/batchCancelAndDeleteTimeSlots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCancelDeleteAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/cancelAppointment/:apptId.
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {string} [reason] Reason for cancellation
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel: async (apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('cancel', 'apptId', apptId)
            // verify required parameter 'byTherapist' is not null or undefined
            assertParamExists('cancel', 'byTherapist', byTherapist)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('cancel', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/appointment/cancel/{apptId}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byTherapist !== undefined) {
                localVarQueryParameter['byTherapist'] = byTherapist;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/unscheduleContinuousAppointment/:id.
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelContinuous: async (apptId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('cancelContinuous', 'apptId', apptId)
            const localVarPath = `/appointment/cancelContinuous/{apptId}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancels every participant time slot (each gets its own cancellation at its own patient appointment level); the now-empty group anchor and its GroupTimeSlotTherapist slot are deleted as a side effect via the group-anchor reconciler.
         * @summary Cancel an entire group appointment
         * @param {string} anchorId Group anchor appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelGroupAppointment: async (anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('cancelGroupAppointment', 'anchorId', anchorId)
            // verify required parameter 'byTherapist' is not null or undefined
            assertParamExists('cancelGroupAppointment', 'byTherapist', byTherapist)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('cancelGroupAppointment', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/appointment/cancelGroupAppointment/{anchorId}`
                .replace(`{${"anchorId"}}`, encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byTherapist !== undefined) {
                localVarQueryParameter['byTherapist'] = byTherapist;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/cancelTimeSlot/:slotId.
         * @summary 
         * @param {string} slotId TimeSlot ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelTimeSlot: async (slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('cancelTimeSlot', 'slotId', slotId)
            // verify required parameter 'byTherapist' is not null or undefined
            assertParamExists('cancelTimeSlot', 'byTherapist', byTherapist)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('cancelTimeSlot', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/appointment/cancelTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byTherapist !== undefined) {
                localVarQueryParameter['byTherapist'] = byTherapist;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} resolved 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancellationOfCancelledAppointment: async (id: string, resolved: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancellationOfCancelledAppointment', 'id', id)
            // verify required parameter 'resolved' is not null or undefined
            assertParamExists('cancellationOfCancelledAppointment', 'resolved', resolved)
            const localVarPath = `/appointment/cancellationOfCancelledAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (resolved !== undefined) {
                localVarQueryParameter['resolved'] = resolved;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {boolean} [isContinuous] 
         * @param {CopyToNewDto} [copyToNewDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyToNew: async (apptId: string, isContinuous?: boolean, copyToNewDto?: CopyToNewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('copyToNew', 'apptId', apptId)
            const localVarPath = `/appointment/copyToNew/{apptId}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyToNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateAndScheduleAppointmentDto} createAndScheduleAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndScheduleAppointment: async (createAndScheduleAppointmentDto: CreateAndScheduleAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAndScheduleAppointmentDto' is not null or undefined
            assertParamExists('createAndScheduleAppointment', 'createAndScheduleAppointmentDto', createAndScheduleAppointmentDto)
            const localVarPath = `/appointment/createAndSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndScheduleAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SalesTemplateDto} salesTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentsForServices: async (salesTemplateDto: SalesTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesTemplateDto' is not null or undefined
            assertParamExists('createAppointmentsForServices', 'salesTemplateDto', salesTemplateDto)
            const localVarPath = `/appointment/createAppointmentsForServices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {AppointmentTemplateDto} appointmentTemplateDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForTreatments: async (appointmentTemplateDto: AppointmentTemplateDto, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentTemplateDto' is not null or undefined
            assertParamExists('createForTreatments', 'appointmentTemplateDto', appointmentTemplateDto)
            const localVarPath = `/appointment/createForTreatments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTherapistListEntry: async (patientId: number, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createTherapistListEntry', 'patientId', patientId)
            // verify required parameter 'patientTherapistPreferenceDto' is not null or undefined
            assertParamExists('createTherapistListEntry', 'patientTherapistPreferenceDto', patientTherapistPreferenceDto)
            const localVarPath = `/appointment/availability/createTherapistListEntry/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientTherapistPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This deletes a blocked slot for a patient based on the slot id
         * @summary Remove a blocked slot by its ID
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedSlot: async (slotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('deleteBlockedSlot', 'slotId', slotId)
            const localVarPath = `/appointment/availability/delete/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint removes a continuous appointment from the database. It will also remove all the appointments that are part of the continuous appointment
         * @summary Remove a continuous appointment and its timeslots by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteContinuous: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContinuous', 'id', id)
            const localVarPath = `/appointment/deleteContinuous/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a gap justification by id if it exists
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGapJustification: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGapJustification', 'id', id)
            const localVarPath = `/appointment/gap-justification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This deletes a blocked slot for a patient based on the groupId id
         * @summary Remove Patient Unavailability by its GroupID
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientUnavailability: async (groupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deletePatientUnavailability', 'groupId', groupId)
            const localVarPath = `/appointment/availability/deletePatientUnavailability/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a single therapist list entry by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTherapistListEntry: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTherapistListEntry', 'id', id)
            const localVarPath = `/appointment/availability/deleteTherapistListEntry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint removes an appointments from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
         * @summary Removes all unscheduled appointments for a patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteUnscheduledAppointments: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deleteUnscheduledAppointments', 'patientId', patientId)
            const localVarPath = `/appointment/deleteUnscheduledAppointments/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint removes a timeslot from the database
         * @summary Remove a timeslot by its ID
         * @param {string} timeSlotId 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deletehardTimeslot: async (timeSlotId: string, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('deletehardTimeslot', 'timeSlotId', timeSlotId)
            const localVarPath = `/appointment/deletehardTimeslot/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary OLD: Fill lunch break slots for work plan - no longer needed
         * @param {number} workPlanId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fillSlotsForWorkPlan: async (workPlanId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workPlanId' is not null or undefined
            assertParamExists('fillSlotsForWorkPlan', 'workPlanId', workPlanId)
            const localVarPath = `/appointment/workPlans/initializeLunchBreaks/{workPlanId}`
                .replace(`{${"workPlanId"}}`, encodeURIComponent(String(workPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frequencyValidation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('frequencyValidation', 'id', id)
            const localVarPath = `/appointment/frequencyValidation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId Appointment ID
         * @param {string} date Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frequencyValidationForAppointment: async (appointmentId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('frequencyValidationForAppointment', 'appointmentId', appointmentId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('frequencyValidationForAppointment', 'date', date)
            const localVarPath = `/appointment/validation/frequency/{appointmentId}/{date}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointment', 'id', id)
            const localVarPath = `/appointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an appointment with selected filters
         * @param {string} id 
         * @param {Array<AppointmentRelationsEnum>} relations Array of relations to fetch
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentWithFilters: async (id: string, relations: Array<AppointmentRelationsEnum>, patientId?: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointmentWithFilters', 'id', id)
            // verify required parameter 'relations' is not null or undefined
            assertParamExists('getAppointmentWithFilters', 'relations', relations)
            const localVarPath = `/appointment/{id}/with-filters`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (relations) {
                localVarQueryParameter['relations'] = relations;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {boolean} weeklyworkday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByDate: async (date: string, weeklyworkday: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAppointmentsByDate', 'date', date)
            // verify required parameter 'weeklyworkday' is not null or undefined
            assertParamExists('getAppointmentsByDate', 'weeklyworkday', weeklyworkday)
            const localVarPath = `/appointment/date/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (weeklyworkday !== undefined) {
                localVarQueryParameter['weeklyworkday'] = weeklyworkday;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get multiple appointments by IDs with selected relations
         * @param {GetAppointmentsByIdsDto} getAppointmentsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByIdsWithFilters: async (getAppointmentsByIdsDto: GetAppointmentsByIdsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAppointmentsByIdsDto' is not null or undefined
            assertParamExists('getAppointmentsByIdsWithFilters', 'getAppointmentsByIdsDto', getAppointmentsByIdsDto)
            const localVarPath = `/appointment/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAppointmentsByIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} [addressId] 
         * @param {string} [startDate] 
         * @param {string} [rxId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [dateComparisonOperator] 
         * @param {string} [sortDirection] 
         * @param {boolean} [withRelations] 
         * @param {boolean} [omitUnscheduled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForPatient: async (patientId: string, addressId?: string, startDate?: string, rxId?: string, page?: number, pageSize?: number, dateComparisonOperator?: string, sortDirection?: string, withRelations?: boolean, omitUnscheduled?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAppointmentsForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/forPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (rxId !== undefined) {
                localVarQueryParameter['rxId'] = rxId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (dateComparisonOperator !== undefined) {
                localVarQueryParameter['dateComparisonOperator'] = dateComparisonOperator;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (withRelations !== undefined) {
                localVarQueryParameter['withRelations'] = withRelations;
            }

            if (omitUnscheduled !== undefined) {
                localVarQueryParameter['omitUnscheduled'] = omitUnscheduled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForPatientWithRxId: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getAppointmentsForPatientWithRxId', 'rxId', rxId)
            const localVarPath = `/appointment/printEachRx/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getAppointmentsForRx', 'rxId', rxId)
            const localVarPath = `/appointment/forRx/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForSeries: async (seriesId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('getAppointmentsForSeries', 'seriesId', seriesId)
            const localVarPath = `/appointment/forSeries/{seriesId}`
                .replace(`{${"seriesId"}}`, encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForTherapyRx: async (therapyRxId: string, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapyRxId' is not null or undefined
            assertParamExists('getAppointmentsForTherapyRx', 'therapyRxId', therapyRxId)
            const localVarPath = `/appointment/forTherapyRx/{therapyRxId}`
                .replace(`{${"therapyRxId"}}`, encodeURIComponent(String(therapyRxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForUser: async (userId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAppointmentsForUser', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAppointmentsForUser', 'date', date)
            const localVarPath = `/appointment/forUser/{userId}/{date}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} [singleRx] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsPrintOut: async (id: string, singleRx?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointmentsPrintOut', 'id', id)
            const localVarPath = `/appointment/appointmentsPrintOut/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (singleRx !== undefined) {
                localVarQueryParameter['singleRx'] = singleRx;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedSlotsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getBlockedSlotsForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/availability/getBlockedSlotsForPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancellationHistoryForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getCancellationHistoryForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/cancellationHistory/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {boolean} [rank] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAndUnscheduledAppointments: async (locationId: string, rank?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCancelledAndUnscheduledAppointments', 'locationId', locationId)
            const localVarPath = `/appointment/unscheduledAppointments/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (rank !== undefined) {
                localVarQueryParameter['rank'] = rank;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAppointmentForAppointmentId: async (appointmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getCancelledAppointmentForAppointmentId', 'appointmentId', appointmentId)
            const localVarPath = `/appointment/cancelledAppointment/appointment/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAppointments: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCancelledAppointments', 'locationId', locationId)
            const localVarPath = `/appointment/cancelled/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAppointmentsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getCancelledAppointmentsForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/cancelledAppointment/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} [addressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsForPatient: async (patientId: string, addressId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getContinuousAppointmentsForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/continuous/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {AppointmentQueryFilters} appointmentQueryFilters 
         * @param {string} [addressId] 
         * @param {boolean} [omitUnscheduled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAppointmentsForPatient: async (patientId: number, appointmentQueryFilters: AppointmentQueryFilters, addressId?: string, omitUnscheduled?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getFilteredAppointmentsForPatient', 'patientId', patientId)
            // verify required parameter 'appointmentQueryFilters' is not null or undefined
            assertParamExists('getFilteredAppointmentsForPatient', 'appointmentQueryFilters', appointmentQueryFilters)
            const localVarPath = `/appointment/filteredAppointmentsForPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }

            if (omitUnscheduled !== undefined) {
                localVarQueryParameter['omitUnscheduled'] = omitUnscheduled;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentQueryFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInActiveAppointmentsCount: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getInActiveAppointmentsCount', 'patientId', patientId)
            const localVarPath = `/appointment/inActiveAppointments/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary For each (patientId, appointmentId, currentStart) item, return the next scheduled appointment for that patient
         * @param {GetNextAppointmentsBulkDto} getNextAppointmentsBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextAppointmentsBulk: async (getNextAppointmentsBulkDto: GetNextAppointmentsBulkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getNextAppointmentsBulkDto' is not null or undefined
            assertParamExists('getNextAppointmentsBulk', 'getNextAppointmentsBulkDto', getNextAppointmentsBulkDto)
            const localVarPath = `/appointment/next/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNextAppointmentsBulkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInforming: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('getPatientInforming', 'timeSlotId', timeSlotId)
            const localVarPath = `/appointment/patientInforming/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnavailabilityForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientUnavailabilityForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/availability/getPatientUnavailability/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesAppointmentsForPatient: async (patId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patId' is not null or undefined
            assertParamExists('getSalesAppointmentsForPatient', 'patId', patId)
            const localVarPath = `/appointment/serviceForPatient/{patId}`
                .replace(`{${"patId"}}`, encodeURIComponent(String(patId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [searchFunction] 
         * @param {number} [pruningTarget] 
         * @param {number} [betaGap] 
         * @param {number} [betaTherapists] 
         * @param {number} [betaTreatmentMonths] 
         * @param {number} [betaDrivingTime] 
         * @param {Array<any>} [wishTherapists] 
         * @param {Array<string>} [appointmentIds] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolution: async (patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<any>, appointmentIds?: Array<string>, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getSolution', 'patientId', patientId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getSolution', 'locationId', locationId)
            const localVarPath = `/appointment/solution/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (searchFunction !== undefined) {
                localVarQueryParameter['searchFunction'] = searchFunction;
            }

            if (pruningTarget !== undefined) {
                localVarQueryParameter['pruningTarget'] = pruningTarget;
            }

            if (betaGap !== undefined) {
                localVarQueryParameter['betaGap'] = betaGap;
            }

            if (betaTherapists !== undefined) {
                localVarQueryParameter['betaTherapists'] = betaTherapists;
            }

            if (betaTreatmentMonths !== undefined) {
                localVarQueryParameter['betaTreatmentMonths'] = betaTreatmentMonths;
            }

            if (betaDrivingTime !== undefined) {
                localVarQueryParameter['betaDrivingTime'] = betaDrivingTime;
            }

            if (wishTherapists) {
                localVarQueryParameter['wishTherapists'] = wishTherapists;
            }

            if (appointmentIds) {
                localVarQueryParameter['appointmentIds'] = appointmentIds;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {number} max 
         * @param {string} locationId 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolutions: async (patientId: string, max: number, locationId: string, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getSolutions', 'patientId', patientId)
            // verify required parameter 'max' is not null or undefined
            assertParamExists('getSolutions', 'max', max)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getSolutions', 'locationId', locationId)
            const localVarPath = `/appointment/solutions/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} max 
         * @param {string} locationId 
         * @param {AppointmentTemplateDto} appointmentTemplateDto 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolutionsForContinuous: async (max: number, locationId: string, appointmentTemplateDto: AppointmentTemplateDto, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'max' is not null or undefined
            assertParamExists('getSolutionsForContinuous', 'max', max)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getSolutionsForContinuous', 'locationId', locationId)
            // verify required parameter 'appointmentTemplateDto' is not null or undefined
            assertParamExists('getSolutionsForContinuous', 'appointmentTemplateDto', appointmentTemplateDto)
            const localVarPath = `/appointment/solutionsForContinuous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateForPatient: async (patientId: string, locationId: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getStateForPatient', 'patientId', patientId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getStateForPatient', 'locationId', locationId)
            const localVarPath = `/appointment/ai/stateForPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistListForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getTherapistListForPatient', 'patientId', patientId)
            const localVarPath = `/appointment/availability/getTherapistListForPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return the set of therapists (users) who treated on each Rx
         * @param {TherapistsByRxDto} therapistsByRxDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistsByRxs: async (therapistsByRxDto: TherapistsByRxDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistsByRxDto' is not null or undefined
            assertParamExists('getTherapistsByRxs', 'therapistsByRxDto', therapistsByRxDto)
            const localVarPath = `/appointment/therapists-by-rxs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistsByRxDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyCandidatesForTherapyRx: async (therapyRxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapyRxId' is not null or undefined
            assertParamExists('getTherapyCandidatesForTherapyRx', 'therapyRxId', therapyRxId)
            const localVarPath = `/appointment/therapyRxTherapyCandidates/{therapyRxId}`
                .replace(`{${"therapyRxId"}}`, encodeURIComponent(String(therapyRxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyCandidatesForTimeSlot: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('getTherapyCandidatesForTimeSlot', 'timeSlotId', timeSlotId)
            const localVarPath = `/appointment/therapyCandidates/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches compact display data for UI: treatmentIndex, therapy, patient, rxNumber, and sublocality. Single query, optimized for appointment detail views.
         * @summary Get display data for a time slot
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDisplayData: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('getTreatmentDisplayData', 'timeSlotId', timeSlotId)
            const localVarPath = `/appointment/time-slot/{timeSlotId}/display`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches compact display data for multiple time slots in a single DB query. Returns found results and any missing IDs. Max 100 IDs per request.
         * @summary Get display data for multiple time slots in one request
         * @param {BulkTimeSlotDisplayRequestDto} bulkTimeSlotDisplayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDisplayDataBulk: async (bulkTimeSlotDisplayRequestDto: BulkTimeSlotDisplayRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkTimeSlotDisplayRequestDto' is not null or undefined
            assertParamExists('getTreatmentDisplayDataBulk', 'bulkTimeSlotDisplayRequestDto', bulkTimeSlotDisplayRequestDto)
            const localVarPath = `/appointment/time-slots/display/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkTimeSlotDisplayRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnattendedAppointmentsForRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getUnattendedAppointmentsForRx', 'rxId', rxId)
            const localVarPath = `/appointment/unAttendedAppointmentsForRx/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} apptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueofAppointment: async (apptId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('getValueofAppointment', 'apptId', apptId)
            const localVarPath = `/appointment/insurance/bill/{apptId}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aggregates patient and appointment info per RxSeries for the week.
         * @summary Get waiting list data for all RxSeries for a given week
         * @param {string} weekDate 
         * @param {string} locationId 
         * @param {WaitListFilters} waitListFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingListByRxSeries: async (weekDate: string, locationId: string, waitListFilters: WaitListFilters, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weekDate' is not null or undefined
            assertParamExists('getWaitingListByRxSeries', 'weekDate', weekDate)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getWaitingListByRxSeries', 'locationId', locationId)
            // verify required parameter 'waitListFilters' is not null or undefined
            assertParamExists('getWaitingListByRxSeries', 'waitListFilters', waitListFilters)
            const localVarPath = `/appointment/waiting-list-by-series/{weekDate}/{locationId}`
                .replace(`{${"weekDate"}}`, encodeURIComponent(String(weekDate)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waitListFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview swap of appointments
         * @param {Array<string>} requestBody Array of series IDs to preview swap
         * @param {boolean} [enforceAmounts] Whether to enforce amounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSwapAppointments: async (requestBody: Array<string>, enforceAmounts?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('previewSwapAppointments', 'requestBody', requestBody)
            const localVarPath = `/appointment/previewSwapAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (enforceAmounts !== undefined) {
                localVarQueryParameter['enforceAmounts'] = enforceAmounts;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {AvailabilityRequestDto} availabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAvailabilityRequest: async (patientId: number, availabilityRequestDto: AvailabilityRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('processAvailabilityRequest', 'patientId', patientId)
            // verify required parameter 'availabilityRequestDto' is not null or undefined
            assertParamExists('processAvailabilityRequest', 'availabilityRequestDto', availabilityRequestDto)
            const localVarPath = `/appointment/ai/processAvailabilityRequest/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {RecordInformingDto} recordInformingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPatientInforming: async (recordInformingDto: RecordInformingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordInformingDto' is not null or undefined
            assertParamExists('recordPatientInforming', 'recordInformingDto', recordInformingDto)
            const localVarPath = `/appointment/patientInforming/record`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordInformingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enqueues a rescheduling workflow via BullMQ. Returns a workflowId immediately; the result is delivered via WebSocket.
         * @summary Trigger the rescheduling agent
         * @param {ReschedulingRequestDto} reschedulingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runRescheduling: async (reschedulingRequestDto: ReschedulingRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reschedulingRequestDto' is not null or undefined
            assertParamExists('runRescheduling', 'reschedulingRequestDto', reschedulingRequestDto)
            const localVarPath = `/appointment/runRescheduling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reschedulingRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<AppointmentDto>} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppointments: async (appointmentDto: Array<AppointmentDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentDto' is not null or undefined
            assertParamExists('saveAppointments', 'appointmentDto', appointmentDto)
            const localVarPath = `/appointment/saveAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<TimeSlotDto>} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBlockedSlotsForPatient: async (patientId: number, timeSlotDto: Array<TimeSlotDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('saveBlockedSlotsForPatient', 'patientId', patientId)
            // verify required parameter 'timeSlotDto' is not null or undefined
            assertParamExists('saveBlockedSlotsForPatient', 'timeSlotDto', timeSlotDto)
            const localVarPath = `/appointment/availability/saveBlockedSlotsForPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<PatientAvailabilityDto>} patientAvailabilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePatientUnavailibilityForPatient: async (patientId: number, patientAvailabilityDto: Array<PatientAvailabilityDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('savePatientUnavailibilityForPatient', 'patientId', patientId)
            // verify required parameter 'patientAvailabilityDto' is not null or undefined
            assertParamExists('savePatientUnavailibilityForPatient', 'patientAvailabilityDto', patientAvailabilityDto)
            const localVarPath = `/appointment/availability/savePatientUnavailibility/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientAvailabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SolutionDto} solutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSolution: async (solutionDto: SolutionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'solutionDto' is not null or undefined
            assertParamExists('saveSolution', 'solutionDto', solutionDto)
            const localVarPath = `/appointment/saveSolution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solutionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [searchFunction] 
         * @param {number} [pruningTarget] 
         * @param {number} [betaGap] 
         * @param {number} [betaTherapists] 
         * @param {number} [betaTreatmentMonths] 
         * @param {number} [betaDrivingTime] 
         * @param {Array<string>} [wishTherapists] 
         * @param {string} [date] 
         * @param {Array<string>} [appointmentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleJobForAppointmentSuggestion: async (patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<string>, date?: string, appointmentIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('scheduleJobForAppointmentSuggestion', 'patientId', patientId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('scheduleJobForAppointmentSuggestion', 'locationId', locationId)
            const localVarPath = `/appointment/scheduleJobForAppointmentSuggestion/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (searchFunction !== undefined) {
                localVarQueryParameter['searchFunction'] = searchFunction;
            }

            if (pruningTarget !== undefined) {
                localVarQueryParameter['pruningTarget'] = pruningTarget;
            }

            if (betaGap !== undefined) {
                localVarQueryParameter['betaGap'] = betaGap;
            }

            if (betaTherapists !== undefined) {
                localVarQueryParameter['betaTherapists'] = betaTherapists;
            }

            if (betaTreatmentMonths !== undefined) {
                localVarQueryParameter['betaTreatmentMonths'] = betaTreatmentMonths;
            }

            if (betaDrivingTime !== undefined) {
                localVarQueryParameter['betaDrivingTime'] = betaDrivingTime;
            }

            if (wishTherapists) {
                localVarQueryParameter['wishTherapists'] = wishTherapists;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (appointmentIds) {
                localVarQueryParameter['appointmentIds'] = appointmentIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedule background job for patient availability processing
         * @param {number} patientId 
         * @param {AvailabilityRequestDto} availabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleJobForPatientAvailability: async (patientId: number, availabilityRequestDto: AvailabilityRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('scheduleJobForPatientAvailability', 'patientId', patientId)
            // verify required parameter 'availabilityRequestDto' is not null or undefined
            assertParamExists('scheduleJobForPatientAvailability', 'availabilityRequestDto', availabilityRequestDto)
            const localVarPath = `/appointment/ai/scheduleJobForPatientAvailability/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SetAppointmentInformedDto} setAppointmentInformedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppointmentInformed: async (setAppointmentInformedDto: SetAppointmentInformedDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setAppointmentInformedDto' is not null or undefined
            assertParamExists('setAppointmentInformed', 'setAppointmentInformedDto', setAppointmentInformedDto)
            const localVarPath = `/appointment/patientInforming/appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAppointmentInformedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {AppointmentInformedStatusDto} appointmentInformedStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppointmentInformedToPatient: async (appointmentInformedStatusDto: AppointmentInformedStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentInformedStatusDto' is not null or undefined
            assertParamExists('setAppointmentInformedToPatient', 'appointmentInformedStatusDto', appointmentInformedStatusDto)
            const localVarPath = `/appointment/setAppointmentInformedToPatient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentInformedStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} apptId 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAttended: async (apptId: string, value: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('setAttended', 'apptId', apptId)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('setAttended', 'value', value)
            const localVarPath = `/appointment/setAttended/{apptId}/{value}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)))
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {SetTherapyRxTherapyDto} setTherapyRxTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTherapyRxTherapy: async (therapyRxId: string, setTherapyRxTherapyDto: SetTherapyRxTherapyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapyRxId' is not null or undefined
            assertParamExists('setTherapyRxTherapy', 'therapyRxId', therapyRxId)
            // verify required parameter 'setTherapyRxTherapyDto' is not null or undefined
            assertParamExists('setTherapyRxTherapy', 'setTherapyRxTherapyDto', setTherapyRxTherapyDto)
            const localVarPath = `/appointment/therapyRxTherapy/{therapyRxId}`
                .replace(`{${"therapyRxId"}}`, encodeURIComponent(String(therapyRxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTherapyRxTherapyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} slotId 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeSlotAttended: async (slotId: string, value: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('setTimeSlotAttended', 'slotId', slotId)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('setTimeSlotAttended', 'value', value)
            const localVarPath = `/appointment/setTimeSlotAttended/{slotId}/{value}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)))
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {SetTimeSlotTherapyDto} setTimeSlotTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeSlotTherapy: async (timeSlotId: string, setTimeSlotTherapyDto: SetTimeSlotTherapyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('setTimeSlotTherapy', 'timeSlotId', timeSlotId)
            // verify required parameter 'setTimeSlotTherapyDto' is not null or undefined
            assertParamExists('setTimeSlotTherapy', 'setTimeSlotTherapyDto', setTimeSlotTherapyDto)
            const localVarPath = `/appointment/timeSlotTherapy/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTimeSlotTherapyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} treatmentId 
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTreatmentResources: async (treatmentId: string, therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('setTreatmentResources', 'treatmentId', treatmentId)
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('setTreatmentResources', 'therapistId', therapistId)
            const localVarPath = `/appointment/treatment/setResources`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)))
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/swapAppointments.
         * @summary 
         * @param {Array<string>} requestBody 
         * @param {boolean} [enforceAmounts] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        swapAppointments: async (requestBody: Array<string>, enforceAmounts?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('swapAppointments', 'requestBody', requestBody)
            const localVarPath = `/appointment/swapAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (enforceAmounts !== undefined) {
                localVarQueryParameter['enforceAmounts'] = enforceAmounts;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use POST /scheduler/splitTimeSlot/:timeSlotId.
         * @summary 
         * @param {string} timeSlotId 
         * @param {boolean} [isContinuous] 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        unfuseAppointment: async (timeSlotId: string, isContinuous?: boolean, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('unfuseAppointment', 'timeSlotId', timeSlotId)
            const localVarPath = `/appointment/unfuseAppointment/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears the appointment\'s time window and its slots\' window/user (the canonical unschedule), keeping the rows. Reconciles any group anchor whose participant just left. Does NOT create a cancellation event.
         * @summary Unschedule an appointment (move it off the calendar)
         * @param {string} apptId Appointment ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        unscheduleAppointment: async (apptId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('unscheduleAppointment', 'apptId', apptId)
            const localVarPath = `/appointment/unschedule/{apptId}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Splits the slot into its own appointment so sibling slots are untouched, then unschedules it. Reconciles the group anchor if the slot was a participant. Does NOT create a cancellation event.
         * @summary Unschedule a single time slot (split + move to shelf)
         * @param {string} slotId TimeSlot ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        unscheduleTimeSlot: async (slotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('unscheduleTimeSlot', 'slotId', slotId)
            const localVarPath = `/appointment/unscheduleTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use PATCH /scheduler/reschedule/:id.
         * @summary 
         * @param {string} id 
         * @param {UpdateAppointmentDto} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {boolean} [updateMultiple] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateAppointmentDatatById: async (id: string, updateAppointmentDto: UpdateAppointmentDto, isContinuous?: boolean, updateMultiple?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAppointmentDatatById', 'id', id)
            // verify required parameter 'updateAppointmentDto' is not null or undefined
            assertParamExists('updateAppointmentDatatById', 'updateAppointmentDto', updateAppointmentDto)
            const localVarPath = `/appointment/updateAppointmentData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }

            if (updateMultiple !== undefined) {
                localVarQueryParameter['updateMultiple'] = updateMultiple;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCancelledAppointment: async (id: string, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCancelledAppointment', 'id', id)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('updateCancelledAppointment', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/appointment/updateCancelledAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleContinuous/:id.
         * @summary 
         * @param {string} id 
         * @param {ContinuousAppointmentDto} continuousAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateContinuousAppointment: async (id: string, continuousAppointmentDto: ContinuousAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContinuousAppointment', 'id', id)
            // verify required parameter 'continuousAppointmentDto' is not null or undefined
            assertParamExists('updateContinuousAppointment', 'continuousAppointmentDto', continuousAppointmentDto)
            const localVarPath = `/appointment/updateContinuousAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continuousAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleMultiple.
         * @summary 
         * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateMultipleAppointments: async (updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAppointmentDto' is not null or undefined
            assertParamExists('updateMultipleAppointments', 'updateAppointmentDto', updateAppointmentDto)
            const localVarPath = `/appointment/updateMultipleAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTherapistListEntry: async (id: string, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTherapistListEntry', 'id', id)
            // verify required parameter 'patientTherapistPreferenceDto' is not null or undefined
            assertParamExists('updateTherapistListEntry', 'patientTherapistPreferenceDto', patientTherapistPreferenceDto)
            const localVarPath = `/appointment/availability/updateTherapistListEntry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientTherapistPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidPatientInforming: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('voidPatientInforming', 'timeSlotId', timeSlotId)
            const localVarPath = `/appointment/patientInforming/void/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppointmentApi - functional programming interface
 * @export
 */
export const AppointmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppointmentApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint removes an appointment from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
         * @summary Remove an appointment by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async _delete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<GapJustificationDto>} gapJustificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdateGapJustificationForTreatments(gapJustificationDto: Array<GapJustificationDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GapJustificationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdateGapJustificationForTreatments(gapJustificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {AdjustOutsideAppointmentsDto} adjustOutsideAppointmentsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustOutsideAppointments(adjustOutsideAppointmentsDto: AdjustOutsideAppointmentsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustOutsideAppointments(adjustOutsideAppointmentsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appointmentControllerCreate(appointmentDto: AppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appointmentControllerCreate(appointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist availability with improved handling of all-day time periods
         * @param {number} minutesNeeded 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<any>} [therapistIds] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appointmentControllerGetTherapistAvailabilityNew(minutesNeeded: number, startDate?: string, endDate?: string, therapistIds?: Array<any>, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appointmentControllerGetTherapistAvailabilityNew(minutesNeeded, startDate, endDate, therapistIds, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backFillContinuous(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backFillContinuous(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/batchCancelAndDeleteAppointments.
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async batchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCancelDeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/batchCancelAndDeleteTimeSlots.
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async batchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCancelDeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/cancelAppointment/:apptId.
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {string} [reason] Reason for cancellation
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancel(apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(apptId, byTherapist, updateCancelledAppointmentDto, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/unscheduleContinuousAppointment/:id.
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancelContinuous(apptId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelContinuous(apptId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancels every participant time slot (each gets its own cancellation at its own patient appointment level); the now-empty group anchor and its GroupTimeSlotTherapist slot are deleted as a side effect via the group-anchor reconciler.
         * @summary Cancel an entire group appointment
         * @param {string} anchorId Group anchor appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancelGroupAppointment(anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelGroupAppointment(anchorId, byTherapist, updateCancelledAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/cancelTimeSlot/:slotId.
         * @summary 
         * @param {string} slotId TimeSlot ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancelTimeSlot(slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTimeSlot(slotId, byTherapist, updateCancelledAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} resolved 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancellationOfCancelledAppointment(id: string, resolved: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancellationOfCancelledAppointment(id, resolved, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {boolean} [isContinuous] 
         * @param {CopyToNewDto} [copyToNewDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyToNew(apptId: string, isContinuous?: boolean, copyToNewDto?: CopyToNewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyToNew(apptId, isContinuous, copyToNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateAndScheduleAppointmentDto} createAndScheduleAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndScheduleAppointment(createAndScheduleAppointmentDto: CreateAndScheduleAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndScheduleAppointment(createAndScheduleAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SalesTemplateDto} salesTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointmentsForServices(salesTemplateDto: SalesTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointmentsForServices(salesTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {AppointmentTemplateDto} appointmentTemplateDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForTreatments(appointmentTemplateDto: AppointmentTemplateDto, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createForTreatments(appointmentTemplateDto, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTherapistListEntry(patientId: number, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientTherapistPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTherapistListEntry(patientId, patientTherapistPreferenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This deletes a blocked slot for a patient based on the slot id
         * @summary Remove a blocked slot by its ID
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBlockedSlot(slotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBlockedSlot(slotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint removes a continuous appointment from the database. It will also remove all the appointments that are part of the continuous appointment
         * @summary Remove a continuous appointment and its timeslots by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteContinuous(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContinuous(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a gap justification by id if it exists
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGapJustification(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGapJustification(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This deletes a blocked slot for a patient based on the groupId id
         * @summary Remove Patient Unavailability by its GroupID
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientUnavailability(groupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientUnavailability(groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a single therapist list entry by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTherapistListEntry(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTherapistListEntry(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint removes an appointments from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
         * @summary Removes all unscheduled appointments for a patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteUnscheduledAppointments(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnscheduledAppointments(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint removes a timeslot from the database
         * @summary Remove a timeslot by its ID
         * @param {string} timeSlotId 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deletehardTimeslot(timeSlotId: string, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletehardTimeslot(timeSlotId, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary OLD: Fill lunch break slots for work plan - no longer needed
         * @param {number} workPlanId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async fillSlotsForWorkPlan(workPlanId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fillSlotsForWorkPlan(workPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frequencyValidation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frequencyValidation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId Appointment ID
         * @param {string} date Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frequencyValidationForAppointment(appointmentId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frequencyValidationForAppointment(appointmentId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an appointment with selected filters
         * @param {string} id 
         * @param {Array<AppointmentRelationsEnum>} relations Array of relations to fetch
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentWithFilters(id: string, relations: Array<AppointmentRelationsEnum>, patientId?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentWithFilters(id, relations, patientId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {boolean} weeklyworkday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsByDate(date: string, weeklyworkday: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsByDate(date, weeklyworkday, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get multiple appointments by IDs with selected relations
         * @param {GetAppointmentsByIdsDto} getAppointmentsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsByIdsWithFilters(getAppointmentsByIdsDto: GetAppointmentsByIdsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsByIdsWithFilters(getAppointmentsByIdsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} [addressId] 
         * @param {string} [startDate] 
         * @param {string} [rxId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [dateComparisonOperator] 
         * @param {string} [sortDirection] 
         * @param {boolean} [withRelations] 
         * @param {boolean} [omitUnscheduled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsForPatient(patientId: string, addressId?: string, startDate?: string, rxId?: string, page?: number, pageSize?: number, dateComparisonOperator?: string, sortDirection?: string, withRelations?: boolean, omitUnscheduled?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsForPatient(patientId, addressId, startDate, rxId, page, pageSize, dateComparisonOperator, sortDirection, withRelations, omitUnscheduled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsForPatientWithRxId(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsForPatientWithRxId(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsForRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsForRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsForSeries(seriesId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsForSeries(seriesId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsForTherapyRx(therapyRxId: string, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsForTherapyRx(therapyRxId, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsForUser(userId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistAppointmentsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsForUser(userId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} [singleRx] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsPrintOut(id: string, singleRx?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsPrintOut(id, singleRx, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockedSlotsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeSlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockedSlotsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancellationHistoryForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CancellationHistoryItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancellationHistoryForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {boolean} [rank] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancelledAndUnscheduledAppointments(locationId: string, rank?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelledAndUnscheduledAppointmentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancelledAndUnscheduledAppointments(locationId, rank, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancelledAppointmentForAppointmentId(appointmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelledAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancelledAppointmentForAppointmentId(appointmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancelledAppointments(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CancelledAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancelledAppointments(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancelledAppointmentsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CancelledAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancelledAppointmentsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} [addressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContinuousAppointmentsForPatient(patientId: string, addressId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContinuousAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContinuousAppointmentsForPatient(patientId, addressId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {AppointmentQueryFilters} appointmentQueryFilters 
         * @param {string} [addressId] 
         * @param {boolean} [omitUnscheduled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredAppointmentsForPatient(patientId: number, appointmentQueryFilters: AppointmentQueryFilters, addressId?: string, omitUnscheduled?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredAppointmentsForPatient(patientId, appointmentQueryFilters, addressId, omitUnscheduled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInActiveAppointmentsCount(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInActiveAppointmentsCount(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary For each (patientId, appointmentId, currentStart) item, return the next scheduled appointment for that patient
         * @param {GetNextAppointmentsBulkDto} getNextAppointmentsBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextAppointmentsBulk(getNextAppointmentsBulkDto: GetNextAppointmentsBulkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NextAppointmentResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextAppointmentsBulk(getNextAppointmentsBulkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInforming(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientInformingProjectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInforming(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientUnavailabilityForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientAvailabilityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientUnavailabilityForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesAppointmentsForPatient(patId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesAppointmentsForPatient(patId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [searchFunction] 
         * @param {number} [pruningTarget] 
         * @param {number} [betaGap] 
         * @param {number} [betaTherapists] 
         * @param {number} [betaTreatmentMonths] 
         * @param {number} [betaDrivingTime] 
         * @param {Array<any>} [wishTherapists] 
         * @param {Array<string>} [appointmentIds] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolution(patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<any>, appointmentIds?: Array<string>, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSolution(patientId, locationId, searchFunction, pruningTarget, betaGap, betaTherapists, betaTreatmentMonths, betaDrivingTime, wishTherapists, appointmentIds, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {number} max 
         * @param {string} locationId 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolutions(patientId: string, max: number, locationId: string, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SolutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSolutions(patientId, max, locationId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} max 
         * @param {string} locationId 
         * @param {AppointmentTemplateDto} appointmentTemplateDto 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolutionsForContinuous(max: number, locationId: string, appointmentTemplateDto: AppointmentTemplateDto, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SolutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSolutionsForContinuous(max, locationId, appointmentTemplateDto, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateForPatient(patientId: string, locationId: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateForPatientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateForPatient(patientId, locationId, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapistListForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientTherapistPreferenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapistListForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return the set of therapists (users) who treated on each Rx
         * @param {TherapistsByRxDto} therapistsByRxDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapistsByRxs(therapistsByRxDto: TherapistsByRxDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapistsByRxResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapistsByRxs(therapistsByRxDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyCandidatesForTherapyRx(therapyRxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyRxTherapyCandidatesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyCandidatesForTherapyRx(therapyRxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyCandidatesForTimeSlot(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotTherapyCandidatesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyCandidatesForTimeSlot(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches compact display data for UI: treatmentIndex, therapy, patient, rxNumber, and sublocality. Single query, optimized for appointment detail views.
         * @summary Get display data for a time slot
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentDisplayData(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotDisplayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentDisplayData(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches compact display data for multiple time slots in a single DB query. Returns found results and any missing IDs. Max 100 IDs per request.
         * @summary Get display data for multiple time slots in one request
         * @param {BulkTimeSlotDisplayRequestDto} bulkTimeSlotDisplayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentDisplayDataBulk(bulkTimeSlotDisplayRequestDto: BulkTimeSlotDisplayRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkTimeSlotDisplayResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentDisplayDataBulk(bulkTimeSlotDisplayRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnattendedAppointmentsForRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnattendedAppointmentsForRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} apptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValueofAppointment(apptId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValueofAppointment(apptId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aggregates patient and appointment info per RxSeries for the week.
         * @summary Get waiting list data for all RxSeries for a given week
         * @param {string} weekDate 
         * @param {string} locationId 
         * @param {WaitListFilters} waitListFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitingListByRxSeries(weekDate: string, locationId: string, waitListFilters: WaitListFilters, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitingListByRxSeries(weekDate, locationId, waitListFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Preview swap of appointments
         * @param {Array<string>} requestBody Array of series IDs to preview swap
         * @param {boolean} [enforceAmounts] Whether to enforce amounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewSwapAppointments(requestBody: Array<string>, enforceAmounts?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewSwapDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewSwapAppointments(requestBody, enforceAmounts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {AvailabilityRequestDto} availabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processAvailabilityRequest(patientId: number, availabilityRequestDto: AvailabilityRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processAvailabilityRequest(patientId, availabilityRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {RecordInformingDto} recordInformingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordPatientInforming(recordInformingDto: RecordInformingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientInformingProjectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordPatientInforming(recordInformingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enqueues a rescheduling workflow via BullMQ. Returns a workflowId immediately; the result is delivered via WebSocket.
         * @summary Trigger the rescheduling agent
         * @param {ReschedulingRequestDto} reschedulingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runRescheduling(reschedulingRequestDto: ReschedulingRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedWorkflowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runRescheduling(reschedulingRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<AppointmentDto>} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAppointments(appointmentDto: Array<AppointmentDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAppointments(appointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<TimeSlotDto>} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBlockedSlotsForPatient(patientId: number, timeSlotDto: Array<TimeSlotDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBlockedSlotsForPatient(patientId, timeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<PatientAvailabilityDto>} patientAvailabilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePatientUnavailibilityForPatient(patientId: number, patientAvailabilityDto: Array<PatientAvailabilityDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePatientUnavailibilityForPatient(patientId, patientAvailabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SolutionDto} solutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSolution(solutionDto: SolutionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSolution(solutionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [searchFunction] 
         * @param {number} [pruningTarget] 
         * @param {number} [betaGap] 
         * @param {number} [betaTherapists] 
         * @param {number} [betaTreatmentMonths] 
         * @param {number} [betaDrivingTime] 
         * @param {Array<string>} [wishTherapists] 
         * @param {string} [date] 
         * @param {Array<string>} [appointmentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleJobForAppointmentSuggestion(patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<string>, date?: string, appointmentIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedWorkflowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleJobForAppointmentSuggestion(patientId, locationId, searchFunction, pruningTarget, betaGap, betaTherapists, betaTreatmentMonths, betaDrivingTime, wishTherapists, date, appointmentIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Schedule background job for patient availability processing
         * @param {number} patientId 
         * @param {AvailabilityRequestDto} availabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleJobForPatientAvailability(patientId: number, availabilityRequestDto: AvailabilityRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedWorkflowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleJobForPatientAvailability(patientId, availabilityRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SetAppointmentInformedDto} setAppointmentInformedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAppointmentInformed(setAppointmentInformedDto: SetAppointmentInformedDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientInformingProjectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAppointmentInformed(setAppointmentInformedDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {AppointmentInformedStatusDto} appointmentInformedStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAppointmentInformedToPatient(appointmentInformedStatusDto: AppointmentInformedStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAppointmentInformedToPatient(appointmentInformedStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} apptId 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAttended(apptId: string, value: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProcessingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAttended(apptId, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {SetTherapyRxTherapyDto} setTherapyRxTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTherapyRxTherapy(therapyRxId: string, setTherapyRxTherapyDto: SetTherapyRxTherapyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyRxTherapyCandidatesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTherapyRxTherapy(therapyRxId, setTherapyRxTherapyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} slotId 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTimeSlotAttended(slotId: string, value: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProcessingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTimeSlotAttended(slotId, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {SetTimeSlotTherapyDto} setTimeSlotTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTimeSlotTherapy(timeSlotId: string, setTimeSlotTherapyDto: SetTimeSlotTherapyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotTherapyCandidatesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTimeSlotTherapy(timeSlotId, setTimeSlotTherapyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} treatmentId 
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTreatmentResources(treatmentId: string, therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTreatmentResources(treatmentId, therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/swapAppointments.
         * @summary 
         * @param {Array<string>} requestBody 
         * @param {boolean} [enforceAmounts] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async swapAppointments(requestBody: Array<string>, enforceAmounts?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwapAppointmentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swapAppointments(requestBody, enforceAmounts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use POST /scheduler/splitTimeSlot/:timeSlotId.
         * @summary 
         * @param {string} timeSlotId 
         * @param {boolean} [isContinuous] 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async unfuseAppointment(timeSlotId: string, isContinuous?: boolean, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfuseAppointment(timeSlotId, isContinuous, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Clears the appointment\'s time window and its slots\' window/user (the canonical unschedule), keeping the rows. Reconciles any group anchor whose participant just left. Does NOT create a cancellation event.
         * @summary Unschedule an appointment (move it off the calendar)
         * @param {string} apptId Appointment ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async unscheduleAppointment(apptId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unscheduleAppointment(apptId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Splits the slot into its own appointment so sibling slots are untouched, then unschedules it. Reconciles the group anchor if the slot was a participant. Does NOT create a cancellation event.
         * @summary Unschedule a single time slot (split + move to shelf)
         * @param {string} slotId TimeSlot ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async unscheduleTimeSlot(slotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unscheduleTimeSlot(slotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use PATCH /scheduler/reschedule/:id.
         * @summary 
         * @param {string} id 
         * @param {UpdateAppointmentDto} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {boolean} [updateMultiple] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateAppointmentDatatById(id: string, updateAppointmentDto: UpdateAppointmentDto, isContinuous?: boolean, updateMultiple?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentDatatById(id, updateAppointmentDto, isContinuous, updateMultiple, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCancelledAppointment(id: string, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelledAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCancelledAppointment(id, updateCancelledAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleContinuous/:id.
         * @summary 
         * @param {string} id 
         * @param {ContinuousAppointmentDto} continuousAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateContinuousAppointment(id: string, continuousAppointmentDto: ContinuousAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContinuousAppointment(id, continuousAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleMultiple.
         * @summary 
         * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateMultipleAppointments(updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMultipleAppointments(updateAppointmentDto, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTherapistListEntry(id: string, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientTherapistPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTherapistListEntry(id, patientTherapistPreferenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voidPatientInforming(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientInformingProjectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voidPatientInforming(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppointmentApi - factory interface
 * @export
 */
export const AppointmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppointmentApiFp(configuration)
    return {
        /**
         * This endpoint removes an appointment from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
         * @summary Remove an appointment by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<GapJustificationDto>} gapJustificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateGapJustificationForTreatments(gapJustificationDto: Array<GapJustificationDto>, options?: any): AxiosPromise<Array<GapJustificationDto>> {
            return localVarFp.addOrUpdateGapJustificationForTreatments(gapJustificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {AdjustOutsideAppointmentsDto} adjustOutsideAppointmentsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustOutsideAppointments(adjustOutsideAppointmentsDto: AdjustOutsideAppointmentsDto, options?: any): AxiosPromise<void> {
            return localVarFp.adjustOutsideAppointments(adjustOutsideAppointmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appointmentControllerCreate(appointmentDto: AppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.appointmentControllerCreate(appointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist availability with improved handling of all-day time periods
         * @param {number} minutesNeeded 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<any>} [therapistIds] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appointmentControllerGetTherapistAvailabilityNew(minutesNeeded: number, startDate?: string, endDate?: string, therapistIds?: Array<any>, locationId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.appointmentControllerGetTherapistAvailabilityNew(minutesNeeded, startDate, endDate, therapistIds, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backFillContinuous(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.backFillContinuous(id, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/batchCancelAndDeleteAppointments.
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        batchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: any): AxiosPromise<BatchCancelDeleteResponseDto> {
            return localVarFp.batchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/batchCancelAndDeleteTimeSlots.
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        batchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: any): AxiosPromise<BatchCancelDeleteResponseDto> {
            return localVarFp.batchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/cancelAppointment/:apptId.
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {string} [reason] Reason for cancellation
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel(apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.cancel(apptId, byTherapist, updateCancelledAppointmentDto, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/unscheduleContinuousAppointment/:id.
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelContinuous(apptId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelContinuous(apptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels every participant time slot (each gets its own cancellation at its own patient appointment level); the now-empty group anchor and its GroupTimeSlotTherapist slot are deleted as a side effect via the group-anchor reconciler.
         * @summary Cancel an entire group appointment
         * @param {string} anchorId Group anchor appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelGroupAppointment(anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.cancelGroupAppointment(anchorId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/cancelTimeSlot/:slotId.
         * @summary 
         * @param {string} slotId TimeSlot ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelTimeSlot(slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: any): AxiosPromise<object> {
            return localVarFp.cancelTimeSlot(slotId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} resolved 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancellationOfCancelledAppointment(id: string, resolved: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.cancellationOfCancelledAppointment(id, resolved, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} apptId Appointment ID
         * @param {boolean} [isContinuous] 
         * @param {CopyToNewDto} [copyToNewDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyToNew(apptId: string, isContinuous?: boolean, copyToNewDto?: CopyToNewDto, options?: any): AxiosPromise<void> {
            return localVarFp.copyToNew(apptId, isContinuous, copyToNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateAndScheduleAppointmentDto} createAndScheduleAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndScheduleAppointment(createAndScheduleAppointmentDto: CreateAndScheduleAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.createAndScheduleAppointment(createAndScheduleAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SalesTemplateDto} salesTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentsForServices(salesTemplateDto: SalesTemplateDto, options?: any): AxiosPromise<void> {
            return localVarFp.createAppointmentsForServices(salesTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {AppointmentTemplateDto} appointmentTemplateDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForTreatments(appointmentTemplateDto: AppointmentTemplateDto, isContinuous?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.createForTreatments(appointmentTemplateDto, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTherapistListEntry(patientId: number, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options?: any): AxiosPromise<PatientTherapistPreferenceDto> {
            return localVarFp.createTherapistListEntry(patientId, patientTherapistPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This deletes a blocked slot for a patient based on the slot id
         * @summary Remove a blocked slot by its ID
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedSlot(slotId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBlockedSlot(slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint removes a continuous appointment from the database. It will also remove all the appointments that are part of the continuous appointment
         * @summary Remove a continuous appointment and its timeslots by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteContinuous(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteContinuous(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a gap justification by id if it exists
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGapJustification(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGapJustification(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This deletes a blocked slot for a patient based on the groupId id
         * @summary Remove Patient Unavailability by its GroupID
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientUnavailability(groupId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePatientUnavailability(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a single therapist list entry by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTherapistListEntry(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTherapistListEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint removes an appointments from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
         * @summary Removes all unscheduled appointments for a patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteUnscheduledAppointments(patientId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUnscheduledAppointments(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint removes a timeslot from the database
         * @summary Remove a timeslot by its ID
         * @param {string} timeSlotId 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deletehardTimeslot(timeSlotId: string, isContinuous?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.deletehardTimeslot(timeSlotId, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary OLD: Fill lunch break slots for work plan - no longer needed
         * @param {number} workPlanId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fillSlotsForWorkPlan(workPlanId: number, options?: any): AxiosPromise<string> {
            return localVarFp.fillSlotsForWorkPlan(workPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frequencyValidation(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.frequencyValidation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId Appointment ID
         * @param {string} date Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frequencyValidationForAppointment(appointmentId: string, date: string, options?: any): AxiosPromise<ValidityDto> {
            return localVarFp.frequencyValidationForAppointment(appointmentId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(id: string, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.getAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an appointment with selected filters
         * @param {string} id 
         * @param {Array<AppointmentRelationsEnum>} relations Array of relations to fetch
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentWithFilters(id: string, relations: Array<AppointmentRelationsEnum>, patientId?: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.getAppointmentWithFilters(id, relations, patientId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {boolean} weeklyworkday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByDate(date: string, weeklyworkday: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.getAppointmentsByDate(date, weeklyworkday, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get multiple appointments by IDs with selected relations
         * @param {GetAppointmentsByIdsDto} getAppointmentsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByIdsWithFilters(getAppointmentsByIdsDto: GetAppointmentsByIdsDto, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getAppointmentsByIdsWithFilters(getAppointmentsByIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} [addressId] 
         * @param {string} [startDate] 
         * @param {string} [rxId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [dateComparisonOperator] 
         * @param {string} [sortDirection] 
         * @param {boolean} [withRelations] 
         * @param {boolean} [omitUnscheduled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForPatient(patientId: string, addressId?: string, startDate?: string, rxId?: string, page?: number, pageSize?: number, dateComparisonOperator?: string, sortDirection?: string, withRelations?: boolean, omitUnscheduled?: boolean, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getAppointmentsForPatient(patientId, addressId, startDate, rxId, page, pageSize, dateComparisonOperator, sortDirection, withRelations, omitUnscheduled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForPatientWithRxId(rxId: string, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getAppointmentsForPatientWithRxId(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForRx(rxId: string, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getAppointmentsForRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForSeries(seriesId: string, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getAppointmentsForSeries(seriesId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForTherapyRx(therapyRxId: string, isContinuous?: boolean, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getAppointmentsForTherapyRx(therapyRxId, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsForUser(userId: string, date: string, options?: any): AxiosPromise<TherapistAppointmentsDto> {
            return localVarFp.getAppointmentsForUser(userId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} [singleRx] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsPrintOut(id: string, singleRx?: boolean, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.getAppointmentsPrintOut(id, singleRx, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedSlotsForPatient(patientId: number, options?: any): AxiosPromise<Array<TimeSlotDto>> {
            return localVarFp.getBlockedSlotsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancellationHistoryForPatient(patientId: number, options?: any): AxiosPromise<Array<CancellationHistoryItemDto>> {
            return localVarFp.getCancellationHistoryForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {boolean} [rank] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAndUnscheduledAppointments(locationId: string, rank?: boolean, options?: any): AxiosPromise<CancelledAndUnscheduledAppointmentsResponseDto> {
            return localVarFp.getCancelledAndUnscheduledAppointments(locationId, rank, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAppointmentForAppointmentId(appointmentId: string, options?: any): AxiosPromise<CancelledAppointmentDto> {
            return localVarFp.getCancelledAppointmentForAppointmentId(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAppointments(locationId: string, options?: any): AxiosPromise<Array<CancelledAppointmentDto>> {
            return localVarFp.getCancelledAppointments(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledAppointmentsForPatient(patientId: number, options?: any): AxiosPromise<Array<CancelledAppointmentDto>> {
            return localVarFp.getCancelledAppointmentsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} [addressId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsForPatient(patientId: string, addressId?: string, options?: any): AxiosPromise<Array<ContinuousAppointmentDto>> {
            return localVarFp.getContinuousAppointmentsForPatient(patientId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {AppointmentQueryFilters} appointmentQueryFilters 
         * @param {string} [addressId] 
         * @param {boolean} [omitUnscheduled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAppointmentsForPatient(patientId: number, appointmentQueryFilters: AppointmentQueryFilters, addressId?: string, omitUnscheduled?: boolean, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getFilteredAppointmentsForPatient(patientId, appointmentQueryFilters, addressId, omitUnscheduled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInActiveAppointmentsCount(patientId: number, options?: any): AxiosPromise<number> {
            return localVarFp.getInActiveAppointmentsCount(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary For each (patientId, appointmentId, currentStart) item, return the next scheduled appointment for that patient
         * @param {GetNextAppointmentsBulkDto} getNextAppointmentsBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextAppointmentsBulk(getNextAppointmentsBulkDto: GetNextAppointmentsBulkDto, options?: any): AxiosPromise<Array<NextAppointmentResultDto>> {
            return localVarFp.getNextAppointmentsBulk(getNextAppointmentsBulkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInforming(timeSlotId: string, options?: any): AxiosPromise<Array<PatientInformingProjectionDto>> {
            return localVarFp.getPatientInforming(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnavailabilityForPatient(patientId: number, options?: any): AxiosPromise<Array<PatientAvailabilityDto>> {
            return localVarFp.getPatientUnavailabilityForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesAppointmentsForPatient(patId: number, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getSalesAppointmentsForPatient(patId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [searchFunction] 
         * @param {number} [pruningTarget] 
         * @param {number} [betaGap] 
         * @param {number} [betaTherapists] 
         * @param {number} [betaTreatmentMonths] 
         * @param {number} [betaDrivingTime] 
         * @param {Array<any>} [wishTherapists] 
         * @param {Array<string>} [appointmentIds] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolution(patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<any>, appointmentIds?: Array<string>, date?: string, options?: any): AxiosPromise<SolutionDto> {
            return localVarFp.getSolution(patientId, locationId, searchFunction, pruningTarget, betaGap, betaTherapists, betaTreatmentMonths, betaDrivingTime, wishTherapists, appointmentIds, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {number} max 
         * @param {string} locationId 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolutions(patientId: string, max: number, locationId: string, date?: string, options?: any): AxiosPromise<Array<SolutionDto>> {
            return localVarFp.getSolutions(patientId, max, locationId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} max 
         * @param {string} locationId 
         * @param {AppointmentTemplateDto} appointmentTemplateDto 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolutionsForContinuous(max: number, locationId: string, appointmentTemplateDto: AppointmentTemplateDto, date?: string, options?: any): AxiosPromise<Array<SolutionDto>> {
            return localVarFp.getSolutionsForContinuous(max, locationId, appointmentTemplateDto, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateForPatient(patientId: string, locationId: string, startDate?: string, options?: any): AxiosPromise<StateForPatientDto> {
            return localVarFp.getStateForPatient(patientId, locationId, startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistListForPatient(patientId: number, options?: any): AxiosPromise<Array<PatientTherapistPreferenceDto>> {
            return localVarFp.getTherapistListForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return the set of therapists (users) who treated on each Rx
         * @param {TherapistsByRxDto} therapistsByRxDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistsByRxs(therapistsByRxDto: TherapistsByRxDto, options?: any): AxiosPromise<Array<TherapistsByRxResultDto>> {
            return localVarFp.getTherapistsByRxs(therapistsByRxDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyCandidatesForTherapyRx(therapyRxId: string, options?: any): AxiosPromise<TherapyRxTherapyCandidatesDto> {
            return localVarFp.getTherapyCandidatesForTherapyRx(therapyRxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyCandidatesForTimeSlot(timeSlotId: string, options?: any): AxiosPromise<TimeSlotTherapyCandidatesDto> {
            return localVarFp.getTherapyCandidatesForTimeSlot(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches compact display data for UI: treatmentIndex, therapy, patient, rxNumber, and sublocality. Single query, optimized for appointment detail views.
         * @summary Get display data for a time slot
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDisplayData(timeSlotId: string, options?: any): AxiosPromise<TimeSlotDisplayDto> {
            return localVarFp.getTreatmentDisplayData(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches compact display data for multiple time slots in a single DB query. Returns found results and any missing IDs. Max 100 IDs per request.
         * @summary Get display data for multiple time slots in one request
         * @param {BulkTimeSlotDisplayRequestDto} bulkTimeSlotDisplayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDisplayDataBulk(bulkTimeSlotDisplayRequestDto: BulkTimeSlotDisplayRequestDto, options?: any): AxiosPromise<BulkTimeSlotDisplayResponseDto> {
            return localVarFp.getTreatmentDisplayDataBulk(bulkTimeSlotDisplayRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnattendedAppointmentsForRx(rxId: string, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getUnattendedAppointmentsForRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} apptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueofAppointment(apptId: string, options?: any): AxiosPromise<object> {
            return localVarFp.getValueofAppointment(apptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aggregates patient and appointment info per RxSeries for the week.
         * @summary Get waiting list data for all RxSeries for a given week
         * @param {string} weekDate 
         * @param {string} locationId 
         * @param {WaitListFilters} waitListFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingListByRxSeries(weekDate: string, locationId: string, waitListFilters: WaitListFilters, options?: any): AxiosPromise<WaitListResponse> {
            return localVarFp.getWaitingListByRxSeries(weekDate, locationId, waitListFilters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview swap of appointments
         * @param {Array<string>} requestBody Array of series IDs to preview swap
         * @param {boolean} [enforceAmounts] Whether to enforce amounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSwapAppointments(requestBody: Array<string>, enforceAmounts?: boolean, options?: any): AxiosPromise<PreviewSwapDto> {
            return localVarFp.previewSwapAppointments(requestBody, enforceAmounts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {AvailabilityRequestDto} availabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAvailabilityRequest(patientId: number, availabilityRequestDto: AvailabilityRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.processAvailabilityRequest(patientId, availabilityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {RecordInformingDto} recordInformingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPatientInforming(recordInformingDto: RecordInformingDto, options?: any): AxiosPromise<Array<PatientInformingProjectionDto>> {
            return localVarFp.recordPatientInforming(recordInformingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Enqueues a rescheduling workflow via BullMQ. Returns a workflowId immediately; the result is delivered via WebSocket.
         * @summary Trigger the rescheduling agent
         * @param {ReschedulingRequestDto} reschedulingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runRescheduling(reschedulingRequestDto: ReschedulingRequestDto, options?: any): AxiosPromise<GeneratedWorkflowDto> {
            return localVarFp.runRescheduling(reschedulingRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<AppointmentDto>} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppointments(appointmentDto: Array<AppointmentDto>, options?: any): AxiosPromise<void> {
            return localVarFp.saveAppointments(appointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<TimeSlotDto>} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBlockedSlotsForPatient(patientId: number, timeSlotDto: Array<TimeSlotDto>, options?: any): AxiosPromise<void> {
            return localVarFp.saveBlockedSlotsForPatient(patientId, timeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<PatientAvailabilityDto>} patientAvailabilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePatientUnavailibilityForPatient(patientId: number, patientAvailabilityDto: Array<PatientAvailabilityDto>, options?: any): AxiosPromise<void> {
            return localVarFp.savePatientUnavailibilityForPatient(patientId, patientAvailabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SolutionDto} solutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSolution(solutionDto: SolutionDto, options?: any): AxiosPromise<void> {
            return localVarFp.saveSolution(solutionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {string} locationId 
         * @param {string} [searchFunction] 
         * @param {number} [pruningTarget] 
         * @param {number} [betaGap] 
         * @param {number} [betaTherapists] 
         * @param {number} [betaTreatmentMonths] 
         * @param {number} [betaDrivingTime] 
         * @param {Array<string>} [wishTherapists] 
         * @param {string} [date] 
         * @param {Array<string>} [appointmentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleJobForAppointmentSuggestion(patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<string>, date?: string, appointmentIds?: Array<string>, options?: any): AxiosPromise<GeneratedWorkflowDto> {
            return localVarFp.scheduleJobForAppointmentSuggestion(patientId, locationId, searchFunction, pruningTarget, betaGap, betaTherapists, betaTreatmentMonths, betaDrivingTime, wishTherapists, date, appointmentIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedule background job for patient availability processing
         * @param {number} patientId 
         * @param {AvailabilityRequestDto} availabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleJobForPatientAvailability(patientId: number, availabilityRequestDto: AvailabilityRequestDto, options?: any): AxiosPromise<GeneratedWorkflowDto> {
            return localVarFp.scheduleJobForPatientAvailability(patientId, availabilityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SetAppointmentInformedDto} setAppointmentInformedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppointmentInformed(setAppointmentInformedDto: SetAppointmentInformedDto, options?: any): AxiosPromise<Array<PatientInformingProjectionDto>> {
            return localVarFp.setAppointmentInformed(setAppointmentInformedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {AppointmentInformedStatusDto} appointmentInformedStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppointmentInformedToPatient(appointmentInformedStatusDto: AppointmentInformedStatusDto, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.setAppointmentInformedToPatient(appointmentInformedStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} apptId 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAttended(apptId: string, value: boolean, options?: any): AxiosPromise<UpdateProcessingStatusResponse> {
            return localVarFp.setAttended(apptId, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {SetTherapyRxTherapyDto} setTherapyRxTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTherapyRxTherapy(therapyRxId: string, setTherapyRxTherapyDto: SetTherapyRxTherapyDto, options?: any): AxiosPromise<TherapyRxTherapyCandidatesDto> {
            return localVarFp.setTherapyRxTherapy(therapyRxId, setTherapyRxTherapyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} slotId 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeSlotAttended(slotId: string, value: boolean, options?: any): AxiosPromise<UpdateProcessingStatusResponse> {
            return localVarFp.setTimeSlotAttended(slotId, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {SetTimeSlotTherapyDto} setTimeSlotTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeSlotTherapy(timeSlotId: string, setTimeSlotTherapyDto: SetTimeSlotTherapyDto, options?: any): AxiosPromise<TimeSlotTherapyCandidatesDto> {
            return localVarFp.setTimeSlotTherapy(timeSlotId, setTimeSlotTherapyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} treatmentId 
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTreatmentResources(treatmentId: string, therapistId: string, options?: any): AxiosPromise<string> {
            return localVarFp.setTreatmentResources(treatmentId, therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/swapAppointments.
         * @summary 
         * @param {Array<string>} requestBody 
         * @param {boolean} [enforceAmounts] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        swapAppointments(requestBody: Array<string>, enforceAmounts?: boolean, options?: any): AxiosPromise<SwapAppointmentsResponseDto> {
            return localVarFp.swapAppointments(requestBody, enforceAmounts, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use POST /scheduler/splitTimeSlot/:timeSlotId.
         * @summary 
         * @param {string} timeSlotId 
         * @param {boolean} [isContinuous] 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        unfuseAppointment(timeSlotId: string, isContinuous?: boolean, reason?: string, options?: any): AxiosPromise<void> {
            return localVarFp.unfuseAppointment(timeSlotId, isContinuous, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Clears the appointment\'s time window and its slots\' window/user (the canonical unschedule), keeping the rows. Reconciles any group anchor whose participant just left. Does NOT create a cancellation event.
         * @summary Unschedule an appointment (move it off the calendar)
         * @param {string} apptId Appointment ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        unscheduleAppointment(apptId: string, options?: any): AxiosPromise<void> {
            return localVarFp.unscheduleAppointment(apptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Splits the slot into its own appointment so sibling slots are untouched, then unschedules it. Reconciles the group anchor if the slot was a participant. Does NOT create a cancellation event.
         * @summary Unschedule a single time slot (split + move to shelf)
         * @param {string} slotId TimeSlot ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        unscheduleTimeSlot(slotId: string, options?: any): AxiosPromise<void> {
            return localVarFp.unscheduleTimeSlot(slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use PATCH /scheduler/reschedule/:id.
         * @summary 
         * @param {string} id 
         * @param {UpdateAppointmentDto} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {boolean} [updateMultiple] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateAppointmentDatatById(id: string, updateAppointmentDto: UpdateAppointmentDto, isContinuous?: boolean, updateMultiple?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.updateAppointmentDatatById(id, updateAppointmentDto, isContinuous, updateMultiple, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCancelledAppointment(id: string, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: any): AxiosPromise<CancelledAppointmentDto> {
            return localVarFp.updateCancelledAppointment(id, updateCancelledAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleContinuous/:id.
         * @summary 
         * @param {string} id 
         * @param {ContinuousAppointmentDto} continuousAppointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateContinuousAppointment(id: string, continuousAppointmentDto: ContinuousAppointmentDto, options?: any): AxiosPromise<CAResponse> {
            return localVarFp.updateContinuousAppointment(id, continuousAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleMultiple.
         * @summary 
         * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateMultipleAppointments(updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.updateMultipleAppointments(updateAppointmentDto, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTherapistListEntry(id: string, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options?: any): AxiosPromise<PatientTherapistPreferenceDto> {
            return localVarFp.updateTherapistListEntry(id, patientTherapistPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidPatientInforming(timeSlotId: string, options?: any): AxiosPromise<Array<PatientInformingProjectionDto>> {
            return localVarFp.voidPatientInforming(timeSlotId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppointmentApi - object-oriented interface
 * @export
 * @class AppointmentApi
 * @extends {BaseAPI}
 */
export class AppointmentApi extends BaseAPI {
    /**
     * This endpoint removes an appointment from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
     * @summary Remove an appointment by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public _delete(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<GapJustificationDto>} gapJustificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public addOrUpdateGapJustificationForTreatments(gapJustificationDto: Array<GapJustificationDto>, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).addOrUpdateGapJustificationForTreatments(gapJustificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {AdjustOutsideAppointmentsDto} adjustOutsideAppointmentsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public adjustOutsideAppointments(adjustOutsideAppointmentsDto: AdjustOutsideAppointmentsDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).adjustOutsideAppointments(adjustOutsideAppointmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AppointmentDto} appointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public appointmentControllerCreate(appointmentDto: AppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).appointmentControllerCreate(appointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist availability with improved handling of all-day time periods
     * @param {number} minutesNeeded 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<any>} [therapistIds] 
     * @param {string} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public appointmentControllerGetTherapistAvailabilityNew(minutesNeeded: number, startDate?: string, endDate?: string, therapistIds?: Array<any>, locationId?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).appointmentControllerGetTherapistAvailabilityNew(minutesNeeded, startDate, endDate, therapistIds, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public backFillContinuous(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).backFillContinuous(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/batchCancelAndDeleteAppointments.
     * @summary 
     * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public batchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).batchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/batchCancelAndDeleteTimeSlots.
     * @summary 
     * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public batchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).batchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/cancelAppointment/:apptId.
     * @summary 
     * @param {string} apptId Appointment ID
     * @param {boolean} byTherapist 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {string} [reason] Reason for cancellation
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public cancel(apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, reason?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancel(apptId, byTherapist, updateCancelledAppointmentDto, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/unscheduleContinuousAppointment/:id.
     * @summary 
     * @param {string} apptId Appointment ID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public cancelContinuous(apptId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancelContinuous(apptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancels every participant time slot (each gets its own cancellation at its own patient appointment level); the now-empty group anchor and its GroupTimeSlotTherapist slot are deleted as a side effect via the group-anchor reconciler.
     * @summary Cancel an entire group appointment
     * @param {string} anchorId Group anchor appointment ID
     * @param {boolean} byTherapist 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public cancelGroupAppointment(anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancelGroupAppointment(anchorId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/cancelTimeSlot/:slotId.
     * @summary 
     * @param {string} slotId TimeSlot ID
     * @param {boolean} byTherapist 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public cancelTimeSlot(slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancelTimeSlot(slotId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {boolean} resolved 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public cancellationOfCancelledAppointment(id: string, resolved: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancellationOfCancelledAppointment(id, resolved, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} apptId Appointment ID
     * @param {boolean} [isContinuous] 
     * @param {CopyToNewDto} [copyToNewDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public copyToNew(apptId: string, isContinuous?: boolean, copyToNewDto?: CopyToNewDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).copyToNew(apptId, isContinuous, copyToNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateAndScheduleAppointmentDto} createAndScheduleAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public createAndScheduleAppointment(createAndScheduleAppointmentDto: CreateAndScheduleAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).createAndScheduleAppointment(createAndScheduleAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SalesTemplateDto} salesTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public createAppointmentsForServices(salesTemplateDto: SalesTemplateDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).createAppointmentsForServices(salesTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {AppointmentTemplateDto} appointmentTemplateDto 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public createForTreatments(appointmentTemplateDto: AppointmentTemplateDto, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).createForTreatments(appointmentTemplateDto, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public createTherapistListEntry(patientId: number, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).createTherapistListEntry(patientId, patientTherapistPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This deletes a blocked slot for a patient based on the slot id
     * @summary Remove a blocked slot by its ID
     * @param {string} slotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deleteBlockedSlot(slotId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deleteBlockedSlot(slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint removes a continuous appointment from the database. It will also remove all the appointments that are part of the continuous appointment
     * @summary Remove a continuous appointment and its timeslots by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deleteContinuous(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deleteContinuous(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a gap justification by id if it exists
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deleteGapJustification(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deleteGapJustification(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This deletes a blocked slot for a patient based on the groupId id
     * @summary Remove Patient Unavailability by its GroupID
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deletePatientUnavailability(groupId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deletePatientUnavailability(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a single therapist list entry by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deleteTherapistListEntry(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deleteTherapistListEntry(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint removes an appointments from the database. It is not intended to be used for canceling a scheduled appointment. Use the cancel endpoint for that. It will only work on unscheduled appointments whose timeslots have not been scheduled. The children timeslots will also be deleted
     * @summary Removes all unscheduled appointments for a patient
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deleteUnscheduledAppointments(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deleteUnscheduledAppointments(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint removes a timeslot from the database
     * @summary Remove a timeslot by its ID
     * @param {string} timeSlotId 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public deletehardTimeslot(timeSlotId: string, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deletehardTimeslot(timeSlotId, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary OLD: Fill lunch break slots for work plan - no longer needed
     * @param {number} workPlanId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public fillSlotsForWorkPlan(workPlanId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).fillSlotsForWorkPlan(workPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public frequencyValidation(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).frequencyValidation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} appointmentId Appointment ID
     * @param {string} date Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public frequencyValidationForAppointment(appointmentId: string, date: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).frequencyValidationForAppointment(appointmentId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointment(id: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an appointment with selected filters
     * @param {string} id 
     * @param {Array<AppointmentRelationsEnum>} relations Array of relations to fetch
     * @param {string} [patientId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentWithFilters(id: string, relations: Array<AppointmentRelationsEnum>, patientId?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentWithFilters(id, relations, patientId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} date 
     * @param {boolean} weeklyworkday 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsByDate(date: string, weeklyworkday: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsByDate(date, weeklyworkday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get multiple appointments by IDs with selected relations
     * @param {GetAppointmentsByIdsDto} getAppointmentsByIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsByIdsWithFilters(getAppointmentsByIdsDto: GetAppointmentsByIdsDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsByIdsWithFilters(getAppointmentsByIdsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {string} [addressId] 
     * @param {string} [startDate] 
     * @param {string} [rxId] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [dateComparisonOperator] 
     * @param {string} [sortDirection] 
     * @param {boolean} [withRelations] 
     * @param {boolean} [omitUnscheduled] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsForPatient(patientId: string, addressId?: string, startDate?: string, rxId?: string, page?: number, pageSize?: number, dateComparisonOperator?: string, sortDirection?: string, withRelations?: boolean, omitUnscheduled?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsForPatient(patientId, addressId, startDate, rxId, page, pageSize, dateComparisonOperator, sortDirection, withRelations, omitUnscheduled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsForPatientWithRxId(rxId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsForPatientWithRxId(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsForRx(rxId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsForRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} seriesId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsForSeries(seriesId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsForSeries(seriesId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} therapyRxId 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsForTherapyRx(therapyRxId: string, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsForTherapyRx(therapyRxId, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsForUser(userId: string, date: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsForUser(userId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {boolean} [singleRx] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getAppointmentsPrintOut(id: string, singleRx?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsPrintOut(id, singleRx, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getBlockedSlotsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getBlockedSlotsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getCancellationHistoryForPatient(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCancellationHistoryForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {boolean} [rank] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getCancelledAndUnscheduledAppointments(locationId: string, rank?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCancelledAndUnscheduledAppointments(locationId, rank, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getCancelledAppointmentForAppointmentId(appointmentId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCancelledAppointmentForAppointmentId(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getCancelledAppointments(locationId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCancelledAppointments(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getCancelledAppointmentsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCancelledAppointmentsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {string} [addressId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getContinuousAppointmentsForPatient(patientId: string, addressId?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getContinuousAppointmentsForPatient(patientId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {AppointmentQueryFilters} appointmentQueryFilters 
     * @param {string} [addressId] 
     * @param {boolean} [omitUnscheduled] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getFilteredAppointmentsForPatient(patientId: number, appointmentQueryFilters: AppointmentQueryFilters, addressId?: string, omitUnscheduled?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getFilteredAppointmentsForPatient(patientId, appointmentQueryFilters, addressId, omitUnscheduled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getInActiveAppointmentsCount(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getInActiveAppointmentsCount(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary For each (patientId, appointmentId, currentStart) item, return the next scheduled appointment for that patient
     * @param {GetNextAppointmentsBulkDto} getNextAppointmentsBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getNextAppointmentsBulk(getNextAppointmentsBulkDto: GetNextAppointmentsBulkDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getNextAppointmentsBulk(getNextAppointmentsBulkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getPatientInforming(timeSlotId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getPatientInforming(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getPatientUnavailabilityForPatient(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getPatientUnavailabilityForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getSalesAppointmentsForPatient(patId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getSalesAppointmentsForPatient(patId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {string} locationId 
     * @param {string} [searchFunction] 
     * @param {number} [pruningTarget] 
     * @param {number} [betaGap] 
     * @param {number} [betaTherapists] 
     * @param {number} [betaTreatmentMonths] 
     * @param {number} [betaDrivingTime] 
     * @param {Array<any>} [wishTherapists] 
     * @param {Array<string>} [appointmentIds] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getSolution(patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<any>, appointmentIds?: Array<string>, date?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getSolution(patientId, locationId, searchFunction, pruningTarget, betaGap, betaTherapists, betaTreatmentMonths, betaDrivingTime, wishTherapists, appointmentIds, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {number} max 
     * @param {string} locationId 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getSolutions(patientId: string, max: number, locationId: string, date?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getSolutions(patientId, max, locationId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} max 
     * @param {string} locationId 
     * @param {AppointmentTemplateDto} appointmentTemplateDto 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getSolutionsForContinuous(max: number, locationId: string, appointmentTemplateDto: AppointmentTemplateDto, date?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getSolutionsForContinuous(max, locationId, appointmentTemplateDto, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {string} locationId 
     * @param {string} [startDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getStateForPatient(patientId: string, locationId: string, startDate?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getStateForPatient(patientId, locationId, startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getTherapistListForPatient(patientId: number, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getTherapistListForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return the set of therapists (users) who treated on each Rx
     * @param {TherapistsByRxDto} therapistsByRxDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getTherapistsByRxs(therapistsByRxDto: TherapistsByRxDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getTherapistsByRxs(therapistsByRxDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} therapyRxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getTherapyCandidatesForTherapyRx(therapyRxId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getTherapyCandidatesForTherapyRx(therapyRxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getTherapyCandidatesForTimeSlot(timeSlotId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getTherapyCandidatesForTimeSlot(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches compact display data for UI: treatmentIndex, therapy, patient, rxNumber, and sublocality. Single query, optimized for appointment detail views.
     * @summary Get display data for a time slot
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getTreatmentDisplayData(timeSlotId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getTreatmentDisplayData(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches compact display data for multiple time slots in a single DB query. Returns found results and any missing IDs. Max 100 IDs per request.
     * @summary Get display data for multiple time slots in one request
     * @param {BulkTimeSlotDisplayRequestDto} bulkTimeSlotDisplayRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getTreatmentDisplayDataBulk(bulkTimeSlotDisplayRequestDto: BulkTimeSlotDisplayRequestDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getTreatmentDisplayDataBulk(bulkTimeSlotDisplayRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getUnattendedAppointmentsForRx(rxId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getUnattendedAppointmentsForRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} apptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getValueofAppointment(apptId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getValueofAppointment(apptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aggregates patient and appointment info per RxSeries for the week.
     * @summary Get waiting list data for all RxSeries for a given week
     * @param {string} weekDate 
     * @param {string} locationId 
     * @param {WaitListFilters} waitListFilters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public getWaitingListByRxSeries(weekDate: string, locationId: string, waitListFilters: WaitListFilters, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getWaitingListByRxSeries(weekDate, locationId, waitListFilters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview swap of appointments
     * @param {Array<string>} requestBody Array of series IDs to preview swap
     * @param {boolean} [enforceAmounts] Whether to enforce amounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public previewSwapAppointments(requestBody: Array<string>, enforceAmounts?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).previewSwapAppointments(requestBody, enforceAmounts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {AvailabilityRequestDto} availabilityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public processAvailabilityRequest(patientId: number, availabilityRequestDto: AvailabilityRequestDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).processAvailabilityRequest(patientId, availabilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {RecordInformingDto} recordInformingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public recordPatientInforming(recordInformingDto: RecordInformingDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).recordPatientInforming(recordInformingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enqueues a rescheduling workflow via BullMQ. Returns a workflowId immediately; the result is delivered via WebSocket.
     * @summary Trigger the rescheduling agent
     * @param {ReschedulingRequestDto} reschedulingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public runRescheduling(reschedulingRequestDto: ReschedulingRequestDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).runRescheduling(reschedulingRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<AppointmentDto>} appointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public saveAppointments(appointmentDto: Array<AppointmentDto>, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).saveAppointments(appointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {Array<TimeSlotDto>} timeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public saveBlockedSlotsForPatient(patientId: number, timeSlotDto: Array<TimeSlotDto>, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).saveBlockedSlotsForPatient(patientId, timeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {Array<PatientAvailabilityDto>} patientAvailabilityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public savePatientUnavailibilityForPatient(patientId: number, patientAvailabilityDto: Array<PatientAvailabilityDto>, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).savePatientUnavailibilityForPatient(patientId, patientAvailabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SolutionDto} solutionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public saveSolution(solutionDto: SolutionDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).saveSolution(solutionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {string} locationId 
     * @param {string} [searchFunction] 
     * @param {number} [pruningTarget] 
     * @param {number} [betaGap] 
     * @param {number} [betaTherapists] 
     * @param {number} [betaTreatmentMonths] 
     * @param {number} [betaDrivingTime] 
     * @param {Array<string>} [wishTherapists] 
     * @param {string} [date] 
     * @param {Array<string>} [appointmentIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public scheduleJobForAppointmentSuggestion(patientId: string, locationId: string, searchFunction?: string, pruningTarget?: number, betaGap?: number, betaTherapists?: number, betaTreatmentMonths?: number, betaDrivingTime?: number, wishTherapists?: Array<string>, date?: string, appointmentIds?: Array<string>, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).scheduleJobForAppointmentSuggestion(patientId, locationId, searchFunction, pruningTarget, betaGap, betaTherapists, betaTreatmentMonths, betaDrivingTime, wishTherapists, date, appointmentIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedule background job for patient availability processing
     * @param {number} patientId 
     * @param {AvailabilityRequestDto} availabilityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public scheduleJobForPatientAvailability(patientId: number, availabilityRequestDto: AvailabilityRequestDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).scheduleJobForPatientAvailability(patientId, availabilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SetAppointmentInformedDto} setAppointmentInformedDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setAppointmentInformed(setAppointmentInformedDto: SetAppointmentInformedDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setAppointmentInformed(setAppointmentInformedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {AppointmentInformedStatusDto} appointmentInformedStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setAppointmentInformedToPatient(appointmentInformedStatusDto: AppointmentInformedStatusDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setAppointmentInformedToPatient(appointmentInformedStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} apptId 
     * @param {boolean} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setAttended(apptId: string, value: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setAttended(apptId, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} therapyRxId 
     * @param {SetTherapyRxTherapyDto} setTherapyRxTherapyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setTherapyRxTherapy(therapyRxId: string, setTherapyRxTherapyDto: SetTherapyRxTherapyDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setTherapyRxTherapy(therapyRxId, setTherapyRxTherapyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} slotId 
     * @param {boolean} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setTimeSlotAttended(slotId: string, value: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setTimeSlotAttended(slotId, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} timeSlotId 
     * @param {SetTimeSlotTherapyDto} setTimeSlotTherapyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setTimeSlotTherapy(timeSlotId: string, setTimeSlotTherapyDto: SetTimeSlotTherapyDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setTimeSlotTherapy(timeSlotId, setTimeSlotTherapyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} treatmentId 
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public setTreatmentResources(treatmentId: string, therapistId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setTreatmentResources(treatmentId, therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/swapAppointments.
     * @summary 
     * @param {Array<string>} requestBody 
     * @param {boolean} [enforceAmounts] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public swapAppointments(requestBody: Array<string>, enforceAmounts?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).swapAppointments(requestBody, enforceAmounts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use POST /scheduler/splitTimeSlot/:timeSlotId.
     * @summary 
     * @param {string} timeSlotId 
     * @param {boolean} [isContinuous] 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public unfuseAppointment(timeSlotId: string, isContinuous?: boolean, reason?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).unfuseAppointment(timeSlotId, isContinuous, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clears the appointment\'s time window and its slots\' window/user (the canonical unschedule), keeping the rows. Reconciles any group anchor whose participant just left. Does NOT create a cancellation event.
     * @summary Unschedule an appointment (move it off the calendar)
     * @param {string} apptId Appointment ID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public unscheduleAppointment(apptId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).unscheduleAppointment(apptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Splits the slot into its own appointment so sibling slots are untouched, then unschedules it. Reconciles the group anchor if the slot was a participant. Does NOT create a cancellation event.
     * @summary Unschedule a single time slot (split + move to shelf)
     * @param {string} slotId TimeSlot ID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public unscheduleTimeSlot(slotId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).unscheduleTimeSlot(slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use PATCH /scheduler/reschedule/:id.
     * @summary 
     * @param {string} id 
     * @param {UpdateAppointmentDto} updateAppointmentDto 
     * @param {boolean} [isContinuous] 
     * @param {boolean} [updateMultiple] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public updateAppointmentDatatById(id: string, updateAppointmentDto: UpdateAppointmentDto, isContinuous?: boolean, updateMultiple?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateAppointmentDatatById(id, updateAppointmentDto, isContinuous, updateMultiple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public updateCancelledAppointment(id: string, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateCancelledAppointment(id, updateCancelledAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use PATCH /scheduler/rescheduleContinuous/:id.
     * @summary 
     * @param {string} id 
     * @param {ContinuousAppointmentDto} continuousAppointmentDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public updateContinuousAppointment(id: string, continuousAppointmentDto: ContinuousAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateContinuousAppointment(id, continuousAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use PATCH /scheduler/rescheduleMultiple.
     * @summary 
     * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public updateMultipleAppointments(updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateMultipleAppointments(updateAppointmentDto, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {PatientTherapistPreferenceDto} patientTherapistPreferenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public updateTherapistListEntry(id: string, patientTherapistPreferenceDto: PatientTherapistPreferenceDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateTherapistListEntry(id, patientTherapistPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public voidPatientInforming(timeSlotId: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).voidPatientInforming(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login with username/email and password
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin: async (userDto: UserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('authControllerLogin', 'userDto', userDto)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout - revokes refresh token for current session only
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout: async (refreshTokenDto?: RefreshTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh access token using refresh token from cookie or body
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh: async (refreshTokenDto?: RefreshTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Login with username/email and password
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogin(userDto: UserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenPairDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(userDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout - revokes refresh token for current session only
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogout(refreshTokenDto?: RefreshTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogoutResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogout(refreshTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Refresh access token using refresh token from cookie or body
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRefresh(refreshTokenDto?: RefreshTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenPairDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRefresh(refreshTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Login with username/email and password
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(userDto: UserDto, options?: any): AxiosPromise<TokenPairDto> {
            return localVarFp.authControllerLogin(userDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout - revokes refresh token for current session only
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout(refreshTokenDto?: RefreshTokenDto, options?: any): AxiosPromise<LogoutResponseDto> {
            return localVarFp.authControllerLogout(refreshTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh access token using refresh token from cookie or body
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh(refreshTokenDto?: RefreshTokenDto, options?: any): AxiosPromise<TokenPairDto> {
            return localVarFp.authControllerRefresh(refreshTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUser(options?: any): AxiosPromise<UserDto> {
            return localVarFp.authControllerUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Login with username/email and password
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogin(userDto: UserDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogin(userDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout - revokes refresh token for current session only
     * @param {RefreshTokenDto} [refreshTokenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogout(refreshTokenDto?: RefreshTokenDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogout(refreshTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh access token using refresh token from cookie or body
     * @param {RefreshTokenDto} [refreshTokenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRefresh(refreshTokenDto?: RefreshTokenDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRefresh(refreshTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerUser(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerUser(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BiApi - axios parameter creator
 * @export
 */
export const BiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doDaily: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bi/daily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} [locationId] 
         * @param {number} [radius] 
         * @param {string} [centerDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGapReport: async (locationId?: string, radius?: number, centerDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bi/gapReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }

            if (centerDate !== undefined) {
                localVarQueryParameter['centerDate'] = (centerDate as any instanceof Date) ?
                    (centerDate as any).toISOString() :
                    centerDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} [locationIds] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyRevenue: async (locationIds?: Array<string>, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bi/monthlyRevenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientStats: async (startDate: string, endDate: string, locationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getPatientStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getPatientStats', 'endDate', endDate)
            const localVarPath = `/bi/patientStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBasicStats: async (startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRxBasicStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRxBasicStats', 'endDate', endDate)
            const localVarPath = `/bi/rxBasicStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }

            if (rxType !== undefined) {
                localVarQueryParameter['rxType'] = rxType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBlankoLifespanStats: async (startDate: string, endDate: string, locationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRxBlankoLifespanStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRxBlankoLifespanStats', 'endDate', endDate)
            const localVarPath = `/bi/rxBlankoLifespanStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBlankoStats: async (startDate: string, endDate: string, locationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRxBlankoStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRxBlankoStats', 'endDate', endDate)
            const localVarPath = `/bi/rxBlankoStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBlankoWithTherapistsStats: async (startDate: string, endDate: string, locationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRxBlankoWithTherapistsStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRxBlankoWithTherapistsStats', 'endDate', endDate)
            const localVarPath = `/bi/rxBlankoWithTherapistsStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxLifespanStats: async (startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRxLifespanStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRxLifespanStats', 'endDate', endDate)
            const localVarPath = `/bi/rxLifespanStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }

            if (rxType !== undefined) {
                localVarQueryParameter['rxType'] = rxType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxTherapistsStats: async (startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRxTherapistsStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRxTherapistsStats', 'endDate', endDate)
            const localVarPath = `/bi/rxTherapistsStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }

            if (rxType !== undefined) {
                localVarQueryParameter['rxType'] = rxType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleBasedStats: async (startDate: string, endDate: string, locationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getScheduleBasedStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getScheduleBasedStats', 'endDate', endDate)
            const localVarPath = `/bi/scheduleBasedStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistStats: async (startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTherapistStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTherapistStats', 'endDate', endDate)
            const localVarPath = `/bi/therapistStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyRxFrequencyStats: async (startDate: string, endDate: string, locationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTherapyRxFrequencyStats', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTherapyRxFrequencyStats', 'endDate', endDate)
            const localVarPath = `/bi/therapyRxFrequencyStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} [locationId] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalGaps: async (startDate: string, locationId?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTotalGaps', 'startDate', startDate)
            const localVarPath = `/bi/totalGaps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearEndRxUnfinishedValues: async (startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getYearEndRxUnfinishedValues', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getYearEndRxUnfinishedValues', 'endDate', endDate)
            const localVarPath = `/bi/yearEndRxUnfinishedValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SendBIReportCSVEmailRequest} sendBIReportCSVEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBIReportCSVEmail: async (sendBIReportCSVEmailRequest: SendBIReportCSVEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendBIReportCSVEmailRequest' is not null or undefined
            assertParamExists('sendBIReportCSVEmail', 'sendBIReportCSVEmailRequest', sendBIReportCSVEmailRequest)
            const localVarPath = `/bi/send-bi-report-csv-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendBIReportCSVEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BiApi - functional programming interface
 * @export
 */
export const BiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doDaily(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doDaily(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} [locationId] 
         * @param {number} [radius] 
         * @param {string} [centerDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGapReport(locationId?: string, radius?: number, centerDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGapReport(locationId, radius, centerDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} [locationIds] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyRevenue(locationIds?: Array<string>, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyScheduleRevenueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyRevenue(locationIds, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientStartDateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientStats(startDate, endDate, locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxBasicStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxStatsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxBasicStats(startDate, endDate, locationIds, rxType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxBlankoLifespanStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxLifespanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxBlankoLifespanStats(startDate, endDate, locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxBlankoStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxStatsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxBlankoStats(startDate, endDate, locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxBlankoWithTherapistsStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxWithTherapistsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxBlankoWithTherapistsStats(startDate, endDate, locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxLifespanStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxLifespanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxLifespanStats(startDate, endDate, locationIds, rxType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxTherapistsStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxWithTherapistsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxTherapistsStats(startDate, endDate, locationIds, rxType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleBasedStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleBasedStatsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleBasedStats(startDate, endDate, locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapistStats(startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapistStatsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapistStats(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyRxFrequencyStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleBasedTherapyRxFrequencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyRxFrequencyStats(startDate, endDate, locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} [locationId] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalGaps(startDate: string, locationId?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalGaps(startDate, locationId, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYearEndRxUnfinishedValues(startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YearEndRxUnfinishedValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYearEndRxUnfinishedValues(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SendBIReportCSVEmailRequest} sendBIReportCSVEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBIReportCSVEmail(sendBIReportCSVEmailRequest: SendBIReportCSVEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBIReportCSVEmail(sendBIReportCSVEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BiApi - factory interface
 * @export
 */
export const BiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BiApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doDaily(options?: any): AxiosPromise<void> {
            return localVarFp.doDaily(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} [locationId] 
         * @param {number} [radius] 
         * @param {string} [centerDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGapReport(locationId?: string, radius?: number, centerDate?: string, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getGapReport(locationId, radius, centerDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} [locationIds] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyRevenue(locationIds?: Array<string>, date?: string, options?: any): AxiosPromise<Array<DailyScheduleRevenueDto>> {
            return localVarFp.getMonthlyRevenue(locationIds, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: any): AxiosPromise<PatientStartDateResponseDto> {
            return localVarFp.getPatientStats(startDate, endDate, locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBasicStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: any): AxiosPromise<RxStatsResponseDto> {
            return localVarFp.getRxBasicStats(startDate, endDate, locationIds, rxType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBlankoLifespanStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: any): AxiosPromise<Array<RxLifespanDto>> {
            return localVarFp.getRxBlankoLifespanStats(startDate, endDate, locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBlankoStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: any): AxiosPromise<Array<RxStatsDto>> {
            return localVarFp.getRxBlankoStats(startDate, endDate, locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBlankoWithTherapistsStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: any): AxiosPromise<Array<RxWithTherapistsDto>> {
            return localVarFp.getRxBlankoWithTherapistsStats(startDate, endDate, locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxLifespanStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: any): AxiosPromise<Array<RxLifespanDto>> {
            return localVarFp.getRxLifespanStats(startDate, endDate, locationIds, rxType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxTherapistsStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: any): AxiosPromise<Array<RxWithTherapistsDto>> {
            return localVarFp.getRxTherapistsStats(startDate, endDate, locationIds, rxType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleBasedStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: any): AxiosPromise<Array<ScheduleBasedStatsDto>> {
            return localVarFp.getScheduleBasedStats(startDate, endDate, locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistStats(startDate: string, endDate: string, options?: any): AxiosPromise<Array<TherapistStatsDto>> {
            return localVarFp.getTherapistStats(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<string>} [locationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyRxFrequencyStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: any): AxiosPromise<Array<ScheduleBasedTherapyRxFrequencyDto>> {
            return localVarFp.getTherapyRxFrequencyStats(startDate, endDate, locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} [locationId] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalGaps(startDate: string, locationId?: string, endDate?: string, options?: any): AxiosPromise<number> {
            return localVarFp.getTotalGaps(startDate, locationId, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearEndRxUnfinishedValues(startDate: string, endDate: string, options?: any): AxiosPromise<Array<YearEndRxUnfinishedValueDto>> {
            return localVarFp.getYearEndRxUnfinishedValues(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SendBIReportCSVEmailRequest} sendBIReportCSVEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBIReportCSVEmail(sendBIReportCSVEmailRequest: SendBIReportCSVEmailRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendBIReportCSVEmail(sendBIReportCSVEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BiApi - object-oriented interface
 * @export
 * @class BiApi
 * @extends {BaseAPI}
 */
export class BiApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public doDaily(options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).doDaily(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} [locationId] 
     * @param {number} [radius] 
     * @param {string} [centerDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getGapReport(locationId?: string, radius?: number, centerDate?: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getGapReport(locationId, radius, centerDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<string>} [locationIds] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getMonthlyRevenue(locationIds?: Array<string>, date?: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getMonthlyRevenue(locationIds, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getPatientStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getPatientStats(startDate, endDate, locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getRxBasicStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getRxBasicStats(startDate, endDate, locationIds, rxType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getRxBlankoLifespanStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getRxBlankoLifespanStats(startDate, endDate, locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getRxBlankoStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getRxBlankoStats(startDate, endDate, locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getRxBlankoWithTherapistsStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getRxBlankoWithTherapistsStats(startDate, endDate, locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getRxLifespanStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getRxLifespanStats(startDate, endDate, locationIds, rxType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {string} [rxType] Filter by rxType, e.g. \&quot;Blankoverordnung\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getRxTherapistsStats(startDate: string, endDate: string, locationIds?: Array<string>, rxType?: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getRxTherapistsStats(startDate, endDate, locationIds, rxType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getScheduleBasedStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getScheduleBasedStats(startDate, endDate, locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getTherapistStats(startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getTherapistStats(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Array<string>} [locationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getTherapyRxFrequencyStats(startDate: string, endDate: string, locationIds?: Array<string>, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getTherapyRxFrequencyStats(startDate, endDate, locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} [locationId] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getTotalGaps(startDate: string, locationId?: string, endDate?: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getTotalGaps(startDate, locationId, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public getYearEndRxUnfinishedValues(startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).getYearEndRxUnfinishedValues(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SendBIReportCSVEmailRequest} sendBIReportCSVEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiApi
     */
    public sendBIReportCSVEmail(sendBIReportCSVEmailRequest: SendBIReportCSVEmailRequest, options?: AxiosRequestConfig) {
        return BiApiFp(this.configuration).sendBIReportCSVEmail(sendBIReportCSVEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalendarApi - axios parameter creator
 * @export
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint removes a continuous timeslot from the database
         * @summary Remove a continuous timeslot by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteContinuousTimeSlot: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContinuousTimeSlot', 'id', id)
            const localVarPath = `/calendar/deleteContinuousTimeSlot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use DELETE /scheduler/purgeEmptyGroupAnchor/:timeSlotId (same cleanup-only behaviour).
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteGroupTherapist: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('deleteGroupTherapist', 'timeSlotId', timeSlotId)
            const localVarPath = `/calendar/deleteGroupTherapist/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint removes a timeslot from the database
         * @summary Remove a timeslot by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteTimeslot: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTimeslot', 'id', id)
            const localVarPath = `/calendar/deleteTimeslot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByLocation: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAbsencesByLocation', 'locationId', locationId)
            const localVarPath = `/calendar/locationAbsences/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentForCalendar: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointmentForCalendar', 'id', id)
            const localVarPath = `/calendar/appointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {string} locationId 
         * @param {GetAppointmentsDto} getAppointmentsDto 
         * @param {boolean} [weeklyworkday] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByDateAndLocationForCalendar: async (date: string, locationId: string, getAppointmentsDto: GetAppointmentsDto, weeklyworkday?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAppointmentsByDateAndLocationForCalendar', 'date', date)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAppointmentsByDateAndLocationForCalendar', 'locationId', locationId)
            // verify required parameter 'getAppointmentsDto' is not null or undefined
            assertParamExists('getAppointmentsByDateAndLocationForCalendar', 'getAppointmentsDto', getAppointmentsDto)
            const localVarPath = `/calendar/date/{date}/{locationId}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (weeklyworkday !== undefined) {
                localVarQueryParameter['weeklyworkday'] = weeklyworkday;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAppointmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByDateRangeAndUser: async (userId: string, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAppointmentsByDateRangeAndUser', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAppointmentsByDateRangeAndUser', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAppointmentsByDateRangeAndUser', 'endDate', endDate)
            const localVarPath = `/calendar/user/{userId}/date-range`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContinuousAppointment', 'id', id)
            const localVarPath = `/calendar/continuous/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {number} dayOfWeek 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsByDayAndLocation: async (locationId: string, dayOfWeek: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getContinuousAppointmentsByDayAndLocation', 'locationId', locationId)
            // verify required parameter 'dayOfWeek' is not null or undefined
            assertParamExists('getContinuousAppointmentsByDayAndLocation', 'dayOfWeek', dayOfWeek)
            const localVarPath = `/calendar/continuous/location/{locationId}/{dayOfWeek}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"dayOfWeek"}}`, encodeURIComponent(String(dayOfWeek)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsForPatientCalendar: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getContinuousAppointmentsForPatientCalendar', 'patientId', patientId)
            const localVarPath = `/calendar/continuous/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsForUserCalendar: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getContinuousAppointmentsForUserCalendar', 'userId', userId)
            const localVarPath = `/calendar/continuous/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDerivedPatientBlockedTimesForCalendar: async (patientId: number, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getDerivedPatientBlockedTimesForCalendar', 'patientId', patientId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDerivedPatientBlockedTimesForCalendar', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDerivedPatientBlockedTimesForCalendar', 'endDate', endDate)
            const localVarPath = `/calendar/availability/getDerivedPatientBlockedTimes/{patientId}/{startDate}/{endDate}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} seconds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestUpdatedAppointments: async (seconds: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seconds' is not null or undefined
            assertParamExists('getLatestUpdatedAppointments', 'seconds', seconds)
            const localVarPath = `/calendar/getLatestUpdatedAppointments/{seconds}`
                .replace(`{${"seconds"}}`, encodeURIComponent(String(seconds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextAppointmentsByUserId: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getNextAppointmentsByUserId', 'userId', userId)
            const localVarPath = `/calendar/userNextAppointments/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} queryDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnavailabilityForCalendar: async (patientId: number, queryDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientUnavailabilityForCalendar', 'patientId', patientId)
            // verify required parameter 'queryDate' is not null or undefined
            assertParamExists('getPatientUnavailabilityForCalendar', 'queryDate', queryDate)
            const localVarPath = `/calendar/availability/getPatientUnavailability/{patientId}/{queryDate}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"queryDate"}}`, encodeURIComponent(String(queryDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnavailabilityTypeByDateForCalendar: async (patientId: number, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientUnavailabilityTypeByDateForCalendar', 'patientId', patientId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getPatientUnavailabilityTypeByDateForCalendar', 'date', date)
            const localVarPath = `/calendar/availability/getPatientUnavailabeTypeByDate/{patientId}/{date}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsByAppointmentDateForCalendar: async (date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getPatientsByAppointmentDateForCalendar', 'date', date)
            const localVarPath = `/calendar/patient/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<AppointmentDto>} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteDurationsForAppointments: async (appointmentDto: Array<AppointmentDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentDto' is not null or undefined
            assertParamExists('getRouteDurationsForAppointments', 'appointmentDto', appointmentDto)
            const localVarPath = `/calendar/getRouteDurationsForAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxForTimeSlot: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('getRxForTimeSlot', 'timeSlotId', timeSlotId)
            const localVarPath = `/calendar/timeslot/getRx/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnscheduledAppointmentsForPatient: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getUnscheduledAppointmentsForPatient', 'patientId', patientId)
            const localVarPath = `/calendar/patientAppointment/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnscheduledContinuousAppointmentsForPatient: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getUnscheduledContinuousAppointmentsForPatient', 'patientId', patientId)
            const localVarPath = `/calendar/patientContinuousAppointment/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnscheduledTimeslotsForPatient: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getUnscheduledTimeslotsForPatient', 'patientId', patientId)
            const localVarPath = `/calendar/patientTimeSlot/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAbsences: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserAbsences', 'userId', userId)
            const localVarPath = `/calendar/userAbsences/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {boolean} [includeOtherUsers] 
         * @param {GetAppointmentsDto} [getAppointmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByLocationForCalendar: async (locationId: string, includeOtherUsers?: boolean, getAppointmentsDto?: GetAppointmentsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getUsersByLocationForCalendar', 'locationId', locationId)
            const localVarPath = `/calendar/user/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeOtherUsers !== undefined) {
                localVarQueryParameter['includeOtherUsers'] = includeOtherUsers;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAppointmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {string} date 
         * @param {string} [role] Role to filter by (default: therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRoleAndDateForCalendar: async (locationId: string, date: string, role?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getUsersByRoleAndDateForCalendar', 'locationId', locationId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getUsersByRoleAndDateForCalendar', 'date', date)
            const localVarPath = `/calendar/usersByRole/{locationId}/{date}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleContinuousTimeSlot/:slotId.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchContinuousTimeSlotTimesAndUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchContinuousTimeSlotTimesAndUser', 'id', id)
            const localVarPath = `/calendar/patchContinuousTimeSlotTimesAndUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GONE — use PATCH /scheduler/rescheduleTimeSlot/:slotId (correctly SPLITs the slot off its appointment and MERGEs into the same-day appointment).
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchTimeSlotTimesAndUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTimeSlotTimesAndUser', 'id', id)
            const localVarPath = `/calendar/patchTimeSlotTimesAndUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {ContinuousEventTimeSlotDto} continuousEventTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContinuousEventTimeslot: async (continuousEventTimeSlotDto: ContinuousEventTimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'continuousEventTimeSlotDto' is not null or undefined
            assertParamExists('postContinuousEventTimeslot', 'continuousEventTimeSlotDto', continuousEventTimeSlotDto)
            const localVarPath = `/calendar/createContinuousEventTimeSlot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continuousEventTimeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {EventTimeSlotDto} eventTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEventTimeslot: async (eventTimeSlotDto: EventTimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTimeSlotDto' is not null or undefined
            assertParamExists('postEventTimeslot', 'eventTimeSlotDto', eventTimeSlotDto)
            const localVarPath = `/calendar/createEventTimeSlot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventTimeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeaveOfAbsence: async (leaveOfAbsenceDto: LeaveOfAbsenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leaveOfAbsenceDto' is not null or undefined
            assertParamExists('postLeaveOfAbsence', 'leaveOfAbsenceDto', leaveOfAbsenceDto)
            const localVarPath = `/calendar/createLeaveOfAbsence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leaveOfAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SimpleWorkingHoursDto} simpleWorkingHoursDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSimpleWorkingHours: async (simpleWorkingHoursDto: SimpleWorkingHoursDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simpleWorkingHoursDto' is not null or undefined
            assertParamExists('postSimpleWorkingHours', 'simpleWorkingHoursDto', simpleWorkingHoursDto)
            const localVarPath = `/calendar/createSimpleWorkingHours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simpleWorkingHoursDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTimeslot: async (timeSlotDto: TimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotDto' is not null or undefined
            assertParamExists('postTimeslot', 'timeSlotDto', timeSlotDto)
            const localVarPath = `/calendar/createTimeslot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GONE — use PATCH /scheduler/reschedule/:id.
         * @summary 
         * @param {string} id 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateAppointment: async (id: string, appointmentDto: AppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAppointment', 'id', id)
            // verify required parameter 'appointmentDto' is not null or undefined
            assertParamExists('updateAppointment', 'appointmentDto', appointmentDto)
            const localVarPath = `/calendar/updateAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContinuousTimeSlot: async (id: string, timeSlotDto: TimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContinuousTimeSlot', 'id', id)
            // verify required parameter 'timeSlotDto' is not null or undefined
            assertParamExists('updateContinuousTimeSlot', 'timeSlotDto', timeSlotDto)
            const localVarPath = `/calendar/updateContinuousTimeSlot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeSlot: async (id: string, timeSlotDto: TimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTimeSlot', 'id', id)
            // verify required parameter 'timeSlotDto' is not null or undefined
            assertParamExists('updateTimeSlot', 'timeSlotDto', timeSlotDto)
            const localVarPath = `/calendar/updateTimeSlot/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This will update the user\'s absence time slot
         * @summary 
         * @param {string} userId 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAbsence: async (userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserAbsence', 'userId', userId)
            // verify required parameter 'leaveOfAbsenceDto' is not null or undefined
            assertParamExists('updateUserAbsence', 'leaveOfAbsenceDto', leaveOfAbsenceDto)
            const localVarPath = `/calendar/userAbsence/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leaveOfAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This will create an absence time slot for the user, as well as cancel all the affected appointments
         * @summary 
         * @param {string} userId 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAbsence: async (userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userAbsence', 'userId', userId)
            // verify required parameter 'leaveOfAbsenceDto' is not null or undefined
            assertParamExists('userAbsence', 'leaveOfAbsenceDto', leaveOfAbsenceDto)
            const localVarPath = `/calendar/userAbsence/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leaveOfAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 * @export
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint removes a continuous timeslot from the database
         * @summary Remove a continuous timeslot by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteContinuousTimeSlot(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContinuousTimeSlot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use DELETE /scheduler/purgeEmptyGroupAnchor/:timeSlotId (same cleanup-only behaviour).
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteGroupTherapist(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupTherapist(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint removes a timeslot from the database
         * @summary Remove a timeslot by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteTimeslot(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTimeslot(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesByLocation(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationLeaveOfAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesByLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentForCalendar(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentForCalendar(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {string} locationId 
         * @param {GetAppointmentsDto} getAppointmentsDto 
         * @param {boolean} [weeklyworkday] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsByDateAndLocationForCalendar(date: string, locationId: string, getAppointmentsDto: GetAppointmentsDto, weeklyworkday?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentsOfAllTypesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsByDateAndLocationForCalendar(date, locationId, getAppointmentsDto, weeklyworkday, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsByDateRangeAndUser(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentsOfAllTypesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsByDateRangeAndUser(userId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContinuousAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinuousAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContinuousAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {number} dayOfWeek 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContinuousAppointmentsByDayAndLocation(locationId: string, dayOfWeek: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinousAppLists>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContinuousAppointmentsByDayAndLocation(locationId, dayOfWeek, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContinuousAppointmentsForPatientCalendar(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContinuousAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContinuousAppointmentsForPatientCalendar(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContinuousAppointmentsForUserCalendar(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinousAppLists>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContinuousAppointmentsForUserCalendar(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDerivedPatientBlockedTimesForCalendar(patientId: number, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientBlockedTimeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDerivedPatientBlockedTimesForCalendar(patientId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} seconds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestUpdatedAppointments(seconds: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestUpdatedAppointments(seconds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextAppointmentsByUserId(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextAppointmentsByUserId(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} queryDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientUnavailabilityForCalendar(patientId: number, queryDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientAvailabilityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientUnavailabilityForCalendar(patientId, queryDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientUnavailabilityTypeByDateForCalendar(patientId: number, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeSlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientUnavailabilityTypeByDateForCalendar(patientId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientsByAppointmentDateForCalendar(date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientsByAppointmentDateForCalendar(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<AppointmentDto>} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRouteDurationsForAppointments(appointmentDto: Array<AppointmentDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRouteDurationsForAppointments(appointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxForTimeSlot(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxForTimeSlot(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnscheduledAppointmentsForPatient(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnscheduledAppointmentsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnscheduledContinuousAppointmentsForPatient(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContinuousAppointmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnscheduledContinuousAppointmentsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnscheduledTimeslotsForPatient(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeSlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnscheduledTimeslotsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAbsences(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeaveOfAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAbsences(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {boolean} [includeOtherUsers] 
         * @param {GetAppointmentsDto} [getAppointmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByLocationForCalendar(locationId: string, includeOtherUsers?: boolean, getAppointmentsDto?: GetAppointmentsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByLocationForCalendar(locationId, includeOtherUsers, getAppointmentsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {string} date 
         * @param {string} [role] Role to filter by (default: therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByRoleAndDateForCalendar(locationId: string, date: string, role?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByRoleAndDateForCalendar(locationId, date, role, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleContinuousTimeSlot/:slotId.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async patchContinuousTimeSlotTimesAndUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchContinuousTimeSlotTimesAndUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * GONE — use PATCH /scheduler/rescheduleTimeSlot/:slotId (correctly SPLITs the slot off its appointment and MERGEs into the same-day appointment).
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async patchTimeSlotTimesAndUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTimeSlotTimesAndUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {ContinuousEventTimeSlotDto} continuousEventTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postContinuousEventTimeslot(continuousEventTimeSlotDto: ContinuousEventTimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinuousEventTimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postContinuousEventTimeslot(continuousEventTimeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {EventTimeSlotDto} eventTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEventTimeslot(eventTimeSlotDto: EventTimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEventTimeslot(eventTimeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLeaveOfAbsence(leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveOfAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLeaveOfAbsence(leaveOfAbsenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SimpleWorkingHoursDto} simpleWorkingHoursDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSimpleWorkingHours(simpleWorkingHoursDto: SimpleWorkingHoursDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleWorkingHoursDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSimpleWorkingHours(simpleWorkingHoursDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTimeslot(timeSlotDto: TimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTimeslot(timeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * GONE — use PATCH /scheduler/reschedule/:id.
         * @summary 
         * @param {string} id 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateAppointment(id: string, appointmentDto: AppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAppointmentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointment(id, appointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContinuousTimeSlot(id: string, timeSlotDto: TimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContinuousTimeSlot(id, timeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeSlot(id: string, timeSlotDto: TimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeSlot(id, timeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This will update the user\'s absence time slot
         * @summary 
         * @param {string} userId 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAbsence(userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveOfAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAbsence(userId, leaveOfAbsenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This will create an absence time slot for the user, as well as cancel all the affected appointments
         * @summary 
         * @param {string} userId 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAbsence(userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveOfAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAbsence(userId, leaveOfAbsenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CalendarApi - factory interface
 * @export
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarApiFp(configuration)
    return {
        /**
         * This endpoint removes a continuous timeslot from the database
         * @summary Remove a continuous timeslot by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteContinuousTimeSlot(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteContinuousTimeSlot(id, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use DELETE /scheduler/purgeEmptyGroupAnchor/:timeSlotId (same cleanup-only behaviour).
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteGroupTherapist(timeSlotId: string, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.deleteGroupTherapist(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint removes a timeslot from the database
         * @summary Remove a timeslot by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteTimeslot(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTimeslot(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByLocation(locationId: string, options?: any): AxiosPromise<Array<LocationLeaveOfAbsenceDto>> {
            return localVarFp.getAbsencesByLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentForCalendar(id: string, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.getAppointmentForCalendar(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {string} locationId 
         * @param {GetAppointmentsDto} getAppointmentsDto 
         * @param {boolean} [weeklyworkday] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByDateAndLocationForCalendar(date: string, locationId: string, getAppointmentsDto: GetAppointmentsDto, weeklyworkday?: boolean, options?: any): AxiosPromise<AppointmentsOfAllTypesDto> {
            return localVarFp.getAppointmentsByDateAndLocationForCalendar(date, locationId, getAppointmentsDto, weeklyworkday, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByDateRangeAndUser(userId: string, startDate: string, endDate: string, options?: any): AxiosPromise<AppointmentsOfAllTypesDto> {
            return localVarFp.getAppointmentsByDateRangeAndUser(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointment(id: string, options?: any): AxiosPromise<ContinuousAppointmentDto> {
            return localVarFp.getContinuousAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {number} dayOfWeek 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsByDayAndLocation(locationId: string, dayOfWeek: number, options?: any): AxiosPromise<ContinousAppLists> {
            return localVarFp.getContinuousAppointmentsByDayAndLocation(locationId, dayOfWeek, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsForPatientCalendar(patientId: string, options?: any): AxiosPromise<Array<ContinuousAppointmentDto>> {
            return localVarFp.getContinuousAppointmentsForPatientCalendar(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinuousAppointmentsForUserCalendar(userId: string, options?: any): AxiosPromise<ContinousAppLists> {
            return localVarFp.getContinuousAppointmentsForUserCalendar(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDerivedPatientBlockedTimesForCalendar(patientId: number, startDate: string, endDate: string, options?: any): AxiosPromise<Array<PatientBlockedTimeDto>> {
            return localVarFp.getDerivedPatientBlockedTimesForCalendar(patientId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} seconds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestUpdatedAppointments(seconds: number, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getLatestUpdatedAppointments(seconds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextAppointmentsByUserId(userId: string, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getNextAppointmentsByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} queryDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnavailabilityForCalendar(patientId: number, queryDate: string, options?: any): AxiosPromise<Array<PatientAvailabilityDto>> {
            return localVarFp.getPatientUnavailabilityForCalendar(patientId, queryDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnavailabilityTypeByDateForCalendar(patientId: number, date: string, options?: any): AxiosPromise<Array<TimeSlotDto>> {
            return localVarFp.getPatientUnavailabilityTypeByDateForCalendar(patientId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsByAppointmentDateForCalendar(date: string, options?: any): AxiosPromise<Array<PatientDto>> {
            return localVarFp.getPatientsByAppointmentDateForCalendar(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<AppointmentDto>} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteDurationsForAppointments(appointmentDto: Array<AppointmentDto>, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getRouteDurationsForAppointments(appointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxForTimeSlot(timeSlotId: string, options?: any): AxiosPromise<RxDto> {
            return localVarFp.getRxForTimeSlot(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnscheduledAppointmentsForPatient(patientId: string, options?: any): AxiosPromise<Array<AppointmentDto>> {
            return localVarFp.getUnscheduledAppointmentsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnscheduledContinuousAppointmentsForPatient(patientId: string, options?: any): AxiosPromise<Array<ContinuousAppointmentDto>> {
            return localVarFp.getUnscheduledContinuousAppointmentsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnscheduledTimeslotsForPatient(patientId: string, options?: any): AxiosPromise<Array<TimeSlotDto>> {
            return localVarFp.getUnscheduledTimeslotsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAbsences(userId: string, options?: any): AxiosPromise<Array<LeaveOfAbsenceDto>> {
            return localVarFp.getUserAbsences(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {boolean} [includeOtherUsers] 
         * @param {GetAppointmentsDto} [getAppointmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByLocationForCalendar(locationId: string, includeOtherUsers?: boolean, getAppointmentsDto?: GetAppointmentsDto, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getUsersByLocationForCalendar(locationId, includeOtherUsers, getAppointmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {string} date 
         * @param {string} [role] Role to filter by (default: therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRoleAndDateForCalendar(locationId: string, date: string, role?: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getUsersByRoleAndDateForCalendar(locationId, date, role, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED — use PATCH /scheduler/rescheduleContinuousTimeSlot/:slotId.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchContinuousTimeSlotTimesAndUser(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.patchContinuousTimeSlotTimesAndUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * GONE — use PATCH /scheduler/rescheduleTimeSlot/:slotId (correctly SPLITs the slot off its appointment and MERGEs into the same-day appointment).
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchTimeSlotTimesAndUser(id: string, options?: any): AxiosPromise<TimeSlotDto> {
            return localVarFp.patchTimeSlotTimesAndUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {ContinuousEventTimeSlotDto} continuousEventTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContinuousEventTimeslot(continuousEventTimeSlotDto: ContinuousEventTimeSlotDto, options?: any): AxiosPromise<ContinuousEventTimeSlotDto> {
            return localVarFp.postContinuousEventTimeslot(continuousEventTimeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {EventTimeSlotDto} eventTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEventTimeslot(eventTimeSlotDto: EventTimeSlotDto, options?: any): AxiosPromise<EventTimeSlotDto> {
            return localVarFp.postEventTimeslot(eventTimeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeaveOfAbsence(leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: any): AxiosPromise<LeaveOfAbsenceDto> {
            return localVarFp.postLeaveOfAbsence(leaveOfAbsenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SimpleWorkingHoursDto} simpleWorkingHoursDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSimpleWorkingHours(simpleWorkingHoursDto: SimpleWorkingHoursDto, options?: any): AxiosPromise<SimpleWorkingHoursDto> {
            return localVarFp.postSimpleWorkingHours(simpleWorkingHoursDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTimeslot(timeSlotDto: TimeSlotDto, options?: any): AxiosPromise<TimeSlotDto> {
            return localVarFp.postTimeslot(timeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * GONE — use PATCH /scheduler/reschedule/:id.
         * @summary 
         * @param {string} id 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateAppointment(id: string, appointmentDto: AppointmentDto, options?: any): AxiosPromise<UpdateAppointmentResult> {
            return localVarFp.updateAppointment(id, appointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContinuousTimeSlot(id: string, timeSlotDto: TimeSlotDto, options?: any): AxiosPromise<TimeSlotDto> {
            return localVarFp.updateContinuousTimeSlot(id, timeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {TimeSlotDto} timeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeSlot(id: string, timeSlotDto: TimeSlotDto, options?: any): AxiosPromise<TimeSlotDto> {
            return localVarFp.updateTimeSlot(id, timeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This will update the user\'s absence time slot
         * @summary 
         * @param {string} userId 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAbsence(userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: any): AxiosPromise<LeaveOfAbsenceDto> {
            return localVarFp.updateUserAbsence(userId, leaveOfAbsenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This will create an absence time slot for the user, as well as cancel all the affected appointments
         * @summary 
         * @param {string} userId 
         * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAbsence(userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: any): AxiosPromise<LeaveOfAbsenceDto> {
            return localVarFp.userAbsence(userId, leaveOfAbsenceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
export class CalendarApi extends BaseAPI {
    /**
     * This endpoint removes a continuous timeslot from the database
     * @summary Remove a continuous timeslot by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public deleteContinuousTimeSlot(id: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).deleteContinuousTimeSlot(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use DELETE /scheduler/purgeEmptyGroupAnchor/:timeSlotId (same cleanup-only behaviour).
     * @summary 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public deleteGroupTherapist(timeSlotId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).deleteGroupTherapist(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint removes a timeslot from the database
     * @summary Remove a timeslot by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public deleteTimeslot(id: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).deleteTimeslot(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getAbsencesByLocation(locationId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getAbsencesByLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getAppointmentForCalendar(id: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getAppointmentForCalendar(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} date 
     * @param {string} locationId 
     * @param {GetAppointmentsDto} getAppointmentsDto 
     * @param {boolean} [weeklyworkday] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getAppointmentsByDateAndLocationForCalendar(date: string, locationId: string, getAppointmentsDto: GetAppointmentsDto, weeklyworkday?: boolean, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getAppointmentsByDateAndLocationForCalendar(date, locationId, getAppointmentsDto, weeklyworkday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getAppointmentsByDateRangeAndUser(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getAppointmentsByDateRangeAndUser(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getContinuousAppointment(id: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getContinuousAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {number} dayOfWeek 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getContinuousAppointmentsByDayAndLocation(locationId: string, dayOfWeek: number, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getContinuousAppointmentsByDayAndLocation(locationId, dayOfWeek, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getContinuousAppointmentsForPatientCalendar(patientId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getContinuousAppointmentsForPatientCalendar(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getContinuousAppointmentsForUserCalendar(userId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getContinuousAppointmentsForUserCalendar(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getDerivedPatientBlockedTimesForCalendar(patientId: number, startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getDerivedPatientBlockedTimesForCalendar(patientId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} seconds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getLatestUpdatedAppointments(seconds: number, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getLatestUpdatedAppointments(seconds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getNextAppointmentsByUserId(userId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getNextAppointmentsByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {string} queryDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getPatientUnavailabilityForCalendar(patientId: number, queryDate: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getPatientUnavailabilityForCalendar(patientId, queryDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getPatientUnavailabilityTypeByDateForCalendar(patientId: number, date: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getPatientUnavailabilityTypeByDateForCalendar(patientId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getPatientsByAppointmentDateForCalendar(date: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getPatientsByAppointmentDateForCalendar(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<AppointmentDto>} appointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getRouteDurationsForAppointments(appointmentDto: Array<AppointmentDto>, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getRouteDurationsForAppointments(appointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getRxForTimeSlot(timeSlotId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getRxForTimeSlot(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getUnscheduledAppointmentsForPatient(patientId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getUnscheduledAppointmentsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getUnscheduledContinuousAppointmentsForPatient(patientId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getUnscheduledContinuousAppointmentsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getUnscheduledTimeslotsForPatient(patientId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getUnscheduledTimeslotsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getUserAbsences(userId: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getUserAbsences(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {boolean} [includeOtherUsers] 
     * @param {GetAppointmentsDto} [getAppointmentsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getUsersByLocationForCalendar(locationId: string, includeOtherUsers?: boolean, getAppointmentsDto?: GetAppointmentsDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getUsersByLocationForCalendar(locationId, includeOtherUsers, getAppointmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {string} date 
     * @param {string} [role] Role to filter by (default: therapist)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getUsersByRoleAndDateForCalendar(locationId: string, date: string, role?: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getUsersByRoleAndDateForCalendar(locationId, date, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED — use PATCH /scheduler/rescheduleContinuousTimeSlot/:slotId.
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public patchContinuousTimeSlotTimesAndUser(id: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).patchContinuousTimeSlotTimesAndUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GONE — use PATCH /scheduler/rescheduleTimeSlot/:slotId (correctly SPLITs the slot off its appointment and MERGEs into the same-day appointment).
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public patchTimeSlotTimesAndUser(id: string, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).patchTimeSlotTimesAndUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {ContinuousEventTimeSlotDto} continuousEventTimeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public postContinuousEventTimeslot(continuousEventTimeSlotDto: ContinuousEventTimeSlotDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).postContinuousEventTimeslot(continuousEventTimeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {EventTimeSlotDto} eventTimeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public postEventTimeslot(eventTimeSlotDto: EventTimeSlotDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).postEventTimeslot(eventTimeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public postLeaveOfAbsence(leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).postLeaveOfAbsence(leaveOfAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SimpleWorkingHoursDto} simpleWorkingHoursDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public postSimpleWorkingHours(simpleWorkingHoursDto: SimpleWorkingHoursDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).postSimpleWorkingHours(simpleWorkingHoursDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {TimeSlotDto} timeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public postTimeslot(timeSlotDto: TimeSlotDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).postTimeslot(timeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GONE — use PATCH /scheduler/reschedule/:id.
     * @summary 
     * @param {string} id 
     * @param {AppointmentDto} appointmentDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateAppointment(id: string, appointmentDto: AppointmentDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateAppointment(id, appointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {TimeSlotDto} timeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateContinuousTimeSlot(id: string, timeSlotDto: TimeSlotDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateContinuousTimeSlot(id, timeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {TimeSlotDto} timeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateTimeSlot(id: string, timeSlotDto: TimeSlotDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateTimeSlot(id, timeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This will update the user\'s absence time slot
     * @summary 
     * @param {string} userId 
     * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateUserAbsence(userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateUserAbsence(userId, leaveOfAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This will create an absence time slot for the user, as well as cancel all the affected appointments
     * @summary 
     * @param {string} userId 
     * @param {LeaveOfAbsenceDto} leaveOfAbsenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public userAbsence(userId: string, leaveOfAbsenceDto: LeaveOfAbsenceDto, options?: AxiosRequestConfig) {
        return CalendarApiFp(this.configuration).userAbsence(userId, leaveOfAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClinicalDocumentationApi - axios parameter creator
 * @export
 */
export const ClinicalDocumentationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows reassigning a doctor report to a different therapist.
         * @summary Assign or reassign a doctor report to a different therapist
         * @param {string} id 
         * @param {AssignDoctorReportDto} assignDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignClinicalDoctorReport: async (id: string, assignDoctorReportDto: AssignDoctorReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignClinicalDoctorReport', 'id', id)
            // verify required parameter 'assignDoctorReportDto' is not null or undefined
            assertParamExists('assignClinicalDoctorReport', 'assignDoctorReportDto', assignDoctorReportDto)
            const localVarPath = `/clinical-documentation/doctor-reports/{id}/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDoctorReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinicalInitialEvaluation: async (createInitialEvaluationDto: CreateInitialEvaluationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInitialEvaluationDto' is not null or undefined
            assertParamExists('createClinicalInitialEvaluation', 'createInitialEvaluationDto', createInitialEvaluationDto)
            const localVarPath = `/clinical-documentation/evaluations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInitialEvaluationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinicalTreatmentNote: async (createTreatmentNoteDto: CreateTreatmentNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTreatmentNoteDto' is not null or undefined
            assertParamExists('createClinicalTreatmentNote', 'createTreatmentNoteDto', createTreatmentNoteDto)
            const localVarPath = `/clinical-documentation/treatment-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTreatmentNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drafts the free-text fields of a Therapiebericht from the Rx\'s treatment notes and (optionally) the patient\'s initial evaluation. All source text is anonymized before it reaches the LLM. Nothing is persisted — the returned fields are a draft the therapist reviews and edits.
         * @summary Generate a doctor report draft from documentation using the LLM
         * @param {string} rxId 
         * @param {GenerateDoctorReportRequestDto} generateDoctorReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClinicalDoctorReport: async (rxId: string, generateDoctorReportRequestDto: GenerateDoctorReportRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('generateClinicalDoctorReport', 'rxId', rxId)
            // verify required parameter 'generateDoctorReportRequestDto' is not null or undefined
            assertParamExists('generateClinicalDoctorReport', 'generateDoctorReportRequestDto', generateDoctorReportRequestDto)
            const localVarPath = `/clinical-documentation/doctor-reports/rx/{rxId}/generate`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDoctorReportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClinicalDoctorReportPdf: async (reportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('generateClinicalDoctorReportPdf', 'reportId', reportId)
            const localVarPath = `/clinical-documentation/doctor-reports/{reportId}/generate-pdf`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClinicalDoctorReport', 'id', id)
            const localVarPath = `/clinical-documentation/doctor-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportByRxId: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getClinicalDoctorReportByRxId', 'rxId', rxId)
            const localVarPath = `/clinical-documentation/doctor-reports/rx/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportStatus: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getClinicalDoctorReportStatus', 'rxId', rxId)
            const localVarPath = `/clinical-documentation/doctor-reports/rx/{rxId}/status`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns one entry per requested Rx. Used by the therapist app to warm the offline cache without firing one HTTP request per Rx.
         * @summary Get doctor report status for many Rx IDs in a single request
         * @param {BulkRxIdsDto} bulkRxIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportStatusBulk: async (bulkRxIdsDto: BulkRxIdsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkRxIdsDto' is not null or undefined
            assertParamExists('getClinicalDoctorReportStatusBulk', 'bulkRxIdsDto', bulkRxIdsDto)
            const localVarPath = `/clinical-documentation/doctor-reports/rx/status/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkRxIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by the Registry / DoctorReports view to show how many reports each therapist still has in a given (typically \'unsubmitted\') state.
         * @summary Get count of doctor reports per assigned therapist for a given status
         * @param {string} status 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportTherapistCounts: async (status: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getClinicalDoctorReportTherapistCounts', 'status', status)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getClinicalDoctorReportTherapistCounts', 'locationId', locationId)
            const localVarPath = `/clinical-documentation/doctor-reports/therapist-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getClinicalDoctorReportsForPatient', 'patientId', patientId)
            const localVarPath = `/clinical-documentation/doctor-reports/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves doctor reports in batches with pagination support to reduce loading time.
         * @summary Get doctor reports with pagination and filters (batch loading)
         * @param {number} limit Number of items per page (Max: 50)
         * @param {number} page Page number (Min: 1)
         * @param {GetClinicalDoctorReportsWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {string} [userId] Filter by user ID (therapist/doctor)
         * @param {string} [assignedToUserId] Filter by assigned user ID - only returns reports assigned to this user (same as userId)
         * @param {number} [patientId] Filter by patient ID
         * @param {string} [locationId] Filter by location ID (Rx.patient.location)
         * @param {GetClinicalDoctorReportsWithFiltersStatusEnum} [status] Filter by doctor report status
         * @param {string} [doctorBsnr] Filter by doctor BSNR (clinic identifier number)
         * @param {string} [accountId] Filter by account ID (Rx.account)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportsWithFilters: async (limit: number, page: number, sortOrder?: GetClinicalDoctorReportsWithFiltersSortOrderEnum, userId?: string, assignedToUserId?: string, patientId?: number, locationId?: string, status?: GetClinicalDoctorReportsWithFiltersStatusEnum, doctorBsnr?: string, accountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getClinicalDoctorReportsWithFilters', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getClinicalDoctorReportsWithFilters', 'page', page)
            const localVarPath = `/clinical-documentation/doctor-reports/with-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (assignedToUserId !== undefined) {
                localVarQueryParameter['assignedToUserId'] = assignedToUserId;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (doctorBsnr !== undefined) {
                localVarQueryParameter['doctorBsnr'] = doctorBsnr;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalFirstAndLastTimeSlot: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getClinicalFirstAndLastTimeSlot', 'rxId', rxId)
            const localVarPath = `/clinical-documentation/doctor-reports/rx/{rxId}/time-slots`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalInitialEvaluation: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getClinicalInitialEvaluation', 'patientId', patientId)
            const localVarPath = `/clinical-documentation/evaluations/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns one bucket per requested patientId, newest-first, capped at 20 evaluations per patient. Used by the therapist app to warm the offline cache without per-patient fan-out.
         * @summary Get initial evaluations for many patients in a single request
         * @param {BulkPatientIdsDto} bulkPatientIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalInitialEvaluationsBulk: async (bulkPatientIdsDto: BulkPatientIdsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkPatientIdsDto' is not null or undefined
            assertParamExists('getClinicalInitialEvaluationsBulk', 'bulkPatientIdsDto', bulkPatientIdsDto)
            const localVarPath = `/clinical-documentation/evaluations/patient/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPatientIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotes: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getClinicalTreatmentNotes', 'patientId', patientId)
            const localVarPath = `/clinical-documentation/treatment-notes/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk-fetch the first page of treatment notes for multiple patients
         * @param {BulkPatientIdsDto} bulkPatientIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotesBulk: async (bulkPatientIdsDto: BulkPatientIdsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkPatientIdsDto' is not null or undefined
            assertParamExists('getClinicalTreatmentNotesBulk', 'bulkPatientIdsDto', bulkPatientIdsDto)
            const localVarPath = `/clinical-documentation/treatment-notes/patient/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPatientIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotesByTreatmentId: async (treatmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('getClinicalTreatmentNotesByTreatmentId', 'treatmentId', treatmentId)
            const localVarPath = `/clinical-documentation/treatment-notes/treatment/{treatmentId}`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {number} limit Number of items per page (Max: 10)
         * @param {number} page Page number (Min: 1)
         * @param {GetClinicalTreatmentNotesWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {string} [appointmentId] appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotesWithFilters: async (patientId: number, limit: number, page: number, sortOrder?: GetClinicalTreatmentNotesWithFiltersSortOrderEnum, appointmentId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getClinicalTreatmentNotesWithFilters', 'patientId', patientId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getClinicalTreatmentNotesWithFilters', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getClinicalTreatmentNotesWithFilters', 'page', page)
            const localVarPath = `/clinical-documentation/treatment-notes/patient/{patientId}/with-filters`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Per-therapist documentation completeness over a trailing window
         * @param {string} [locationId] Filter therapists by location ID
         * @param {GetDocumentationStatsWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentationStats: async (locationId?: string, window?: GetDocumentationStatsWindowEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/clinical-documentation/treatment-notes/registry/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cross-patient, paginated treatment-notes listing (registry view)
         * @param {number} limit Number of items per page (Max: 100)
         * @param {number} page Page number (Min: 1)
         * @param {GetRegistryTreatmentNotesSortOrderEnum} [sortOrder] Sort by the treatment-note date (timeslot.start)
         * @param {string} [locationId] Filter by location ID
         * @param {string} [therapistId] Filter by therapist (treatment note author) user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistryTreatmentNotes: async (limit: number, page: number, sortOrder?: GetRegistryTreatmentNotesSortOrderEnum, locationId?: string, therapistId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getRegistryTreatmentNotes', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getRegistryTreatmentNotes', 'page', page)
            const localVarPath = `/clinical-documentation/treatment-notes/registry/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (therapistId !== undefined) {
                localVarQueryParameter['therapistId'] = therapistId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attended treatments without notes for a therapist + window
         * @param {string} userId Therapist user id
         * @param {GetUndocumentedTreatmentsWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUndocumentedTreatments: async (userId: string, window?: GetUndocumentedTreatmentsWindowEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUndocumentedTreatments', 'userId', userId)
            const localVarPath = `/clinical-documentation/treatment-notes/registry/undocumented`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateDoctorReportDto} createDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClinicalDoctorReport: async (createDoctorReportDto: CreateDoctorReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDoctorReportDto' is not null or undefined
            assertParamExists('postClinicalDoctorReport', 'createDoctorReportDto', createDoctorReportDto)
            const localVarPath = `/clinical-documentation/doctor-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDoctorReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {DoctorReportDto} doctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putClinicalDoctorReport: async (doctorReportDto: DoctorReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorReportDto' is not null or undefined
            assertParamExists('putClinicalDoctorReport', 'doctorReportDto', doctorReportDto)
            const localVarPath = `/clinical-documentation/doctor-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(doctorReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes the current (unsaved) free-text fields of a Therapiebericht and returns refined versions: thorough German grammar/spelling correction plus optional rephrasing per the therapist\'s instruction. All text is anonymized before it reaches the LLM. Nothing is persisted.
         * @summary Refine the free-text fields of a doctor report using the LLM
         * @param {string} rxId 
         * @param {RefineDoctorReportRequestDto} refineDoctorReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refineClinicalDoctorReport: async (rxId: string, refineDoctorReportRequestDto: RefineDoctorReportRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('refineClinicalDoctorReport', 'rxId', rxId)
            // verify required parameter 'refineDoctorReportRequestDto' is not null or undefined
            assertParamExists('refineClinicalDoctorReport', 'refineDoctorReportRequestDto', refineDoctorReportRequestDto)
            const localVarPath = `/clinical-documentation/doctor-reports/rx/{rxId}/refine`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineDoctorReportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Corrects spelling, grammar and dictation errors in the given note text while preserving shorthand and length. The text is anonymized server-side before it is sent to the LLM. Nothing is persisted.
         * @summary Refine a treatment-note text (grammar/spelling/dictation fixes)
         * @param {RefineTreatmentNoteRequestDto} refineTreatmentNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refineClinicalTreatmentNote: async (refineTreatmentNoteRequestDto: RefineTreatmentNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refineTreatmentNoteRequestDto' is not null or undefined
            assertParamExists('refineClinicalTreatmentNote', 'refineTreatmentNoteRequestDto', refineTreatmentNoteRequestDto)
            const localVarPath = `/clinical-documentation/treatment-notes/refine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineTreatmentNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendClinicalDoctorReportByEmail: async (reportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('sendClinicalDoctorReportByEmail', 'reportId', reportId)
            const localVarPath = `/clinical-documentation/doctor-reports/{reportId}/send-email`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {CreateDoctorReportDto} createDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalDoctorReport: async (id: string, createDoctorReportDto: CreateDoctorReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateClinicalDoctorReport', 'id', id)
            // verify required parameter 'createDoctorReportDto' is not null or undefined
            assertParamExists('updateClinicalDoctorReport', 'createDoctorReportDto', createDoctorReportDto)
            const localVarPath = `/clinical-documentation/doctor-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDoctorReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {DoctorReportStatusDto} doctorReportStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalDoctorReportStatus: async (id: string, doctorReportStatusDto: DoctorReportStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateClinicalDoctorReportStatus', 'id', id)
            // verify required parameter 'doctorReportStatusDto' is not null or undefined
            assertParamExists('updateClinicalDoctorReportStatus', 'doctorReportStatusDto', doctorReportStatusDto)
            const localVarPath = `/clinical-documentation/doctor-reports/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(doctorReportStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalInitialEvaluation: async (id: number, createInitialEvaluationDto: CreateInitialEvaluationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateClinicalInitialEvaluation', 'id', id)
            // verify required parameter 'createInitialEvaluationDto' is not null or undefined
            assertParamExists('updateClinicalInitialEvaluation', 'createInitialEvaluationDto', createInitialEvaluationDto)
            const localVarPath = `/clinical-documentation/evaluations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInitialEvaluationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalTreatmentNote: async (id: number, createTreatmentNoteDto: CreateTreatmentNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateClinicalTreatmentNote', 'id', id)
            // verify required parameter 'createTreatmentNoteDto' is not null or undefined
            assertParamExists('updateClinicalTreatmentNote', 'createTreatmentNoteDto', createTreatmentNoteDto)
            const localVarPath = `/clinical-documentation/treatment-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTreatmentNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicalDocumentationApi - functional programming interface
 * @export
 */
export const ClinicalDocumentationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicalDocumentationApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows reassigning a doctor report to a different therapist.
         * @summary Assign or reassign a doctor report to a different therapist
         * @param {string} id 
         * @param {AssignDoctorReportDto} assignDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignClinicalDoctorReport(id: string, assignDoctorReportDto: AssignDoctorReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignClinicalDoctorReport(id, assignDoctorReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClinicalInitialEvaluation(createInitialEvaluationDto: CreateInitialEvaluationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInitialEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClinicalInitialEvaluation(createInitialEvaluationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClinicalTreatmentNote(createTreatmentNoteDto: CreateTreatmentNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TreatmentNoteDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClinicalTreatmentNote(createTreatmentNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Drafts the free-text fields of a Therapiebericht from the Rx\'s treatment notes and (optionally) the patient\'s initial evaluation. All source text is anonymized before it reaches the LLM. Nothing is persisted — the returned fields are a draft the therapist reviews and edits.
         * @summary Generate a doctor report draft from documentation using the LLM
         * @param {string} rxId 
         * @param {GenerateDoctorReportRequestDto} generateDoctorReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateClinicalDoctorReport(rxId: string, generateDoctorReportRequestDto: GenerateDoctorReportRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDoctorReportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateClinicalDoctorReport(rxId, generateDoctorReportRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateClinicalDoctorReportPdf(reportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateClinicalDoctorReportPdf(reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReport(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReportByRxId(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReportByRxId(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReportStatus(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReportStatus(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns one entry per requested Rx. Used by the therapist app to warm the offline cache without firing one HTTP request per Rx.
         * @summary Get doctor report status for many Rx IDs in a single request
         * @param {BulkRxIdsDto} bulkRxIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReportStatusBulk(bulkRxIdsDto: BulkRxIdsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DoctorReportStatusByRxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReportStatusBulk(bulkRxIdsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by the Registry / DoctorReports view to show how many reports each therapist still has in a given (typically \'unsubmitted\') state.
         * @summary Get count of doctor reports per assigned therapist for a given status
         * @param {string} status 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReportTherapistCounts(status: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DoctorReportTherapistCountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReportTherapistCounts(status, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReportsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReportsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves doctor reports in batches with pagination support to reduce loading time.
         * @summary Get doctor reports with pagination and filters (batch loading)
         * @param {number} limit Number of items per page (Max: 50)
         * @param {number} page Page number (Min: 1)
         * @param {GetClinicalDoctorReportsWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {string} [userId] Filter by user ID (therapist/doctor)
         * @param {string} [assignedToUserId] Filter by assigned user ID - only returns reports assigned to this user (same as userId)
         * @param {number} [patientId] Filter by patient ID
         * @param {string} [locationId] Filter by location ID (Rx.patient.location)
         * @param {GetClinicalDoctorReportsWithFiltersStatusEnum} [status] Filter by doctor report status
         * @param {string} [doctorBsnr] Filter by doctor BSNR (clinic identifier number)
         * @param {string} [accountId] Filter by account ID (Rx.account)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalDoctorReportsWithFilters(limit: number, page: number, sortOrder?: GetClinicalDoctorReportsWithFiltersSortOrderEnum, userId?: string, assignedToUserId?: string, patientId?: number, locationId?: string, status?: GetClinicalDoctorReportsWithFiltersStatusEnum, doctorBsnr?: string, accountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClinicalDoctorReportsWithFilters200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalDoctorReportsWithFilters(limit, page, sortOrder, userId, assignedToUserId, patientId, locationId, status, doctorBsnr, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalFirstAndLastTimeSlot(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportTimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalFirstAndLastTimeSlot(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalInitialEvaluation(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetInitialEvaluationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalInitialEvaluation(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns one bucket per requested patientId, newest-first, capped at 20 evaluations per patient. Used by the therapist app to warm the offline cache without per-patient fan-out.
         * @summary Get initial evaluations for many patients in a single request
         * @param {BulkPatientIdsDto} bulkPatientIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalInitialEvaluationsBulk(bulkPatientIdsDto: BulkPatientIdsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InitialEvaluationsByPatientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalInitialEvaluationsBulk(bulkPatientIdsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalTreatmentNotes(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeSlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalTreatmentNotes(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk-fetch the first page of treatment notes for multiple patients
         * @param {BulkPatientIdsDto} bulkPatientIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalTreatmentNotesBulk(bulkPatientIdsDto: BulkPatientIdsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TreatmentNotesByPatientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalTreatmentNotesBulk(bulkPatientIdsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalTreatmentNotesByTreatmentId(treatmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TreatmentNoteDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalTreatmentNotesByTreatmentId(treatmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {number} limit Number of items per page (Max: 10)
         * @param {number} page Page number (Min: 1)
         * @param {GetClinicalTreatmentNotesWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {string} [appointmentId] appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicalTreatmentNotesWithFilters(patientId: number, limit: number, page: number, sortOrder?: GetClinicalTreatmentNotesWithFiltersSortOrderEnum, appointmentId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeSlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalTreatmentNotesWithFilters(patientId, limit, page, sortOrder, appointmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Per-therapist documentation completeness over a trailing window
         * @param {string} [locationId] Filter therapists by location ID
         * @param {GetDocumentationStatsWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentationStats(locationId?: string, window?: GetDocumentationStatsWindowEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistryDocumentationStatsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentationStats(locationId, window, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cross-patient, paginated treatment-notes listing (registry view)
         * @param {number} limit Number of items per page (Max: 100)
         * @param {number} page Page number (Min: 1)
         * @param {GetRegistryTreatmentNotesSortOrderEnum} [sortOrder] Sort by the treatment-note date (timeslot.start)
         * @param {string} [locationId] Filter by location ID
         * @param {string} [therapistId] Filter by therapist (treatment note author) user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistryTreatmentNotes(limit: number, page: number, sortOrder?: GetRegistryTreatmentNotesSortOrderEnum, locationId?: string, therapistId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistryTreatmentNoteRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistryTreatmentNotes(limit, page, sortOrder, locationId, therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Attended treatments without notes for a therapist + window
         * @param {string} userId Therapist user id
         * @param {GetUndocumentedTreatmentsWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUndocumentedTreatments(userId: string, window?: GetUndocumentedTreatmentsWindowEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UndocumentedTreatmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUndocumentedTreatments(userId, window, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateDoctorReportDto} createDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClinicalDoctorReport(createDoctorReportDto: CreateDoctorReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClinicalDoctorReport(createDoctorReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {DoctorReportDto} doctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putClinicalDoctorReport(doctorReportDto: DoctorReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putClinicalDoctorReport(doctorReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Takes the current (unsaved) free-text fields of a Therapiebericht and returns refined versions: thorough German grammar/spelling correction plus optional rephrasing per the therapist\'s instruction. All text is anonymized before it reaches the LLM. Nothing is persisted.
         * @summary Refine the free-text fields of a doctor report using the LLM
         * @param {string} rxId 
         * @param {RefineDoctorReportRequestDto} refineDoctorReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refineClinicalDoctorReport(rxId: string, refineDoctorReportRequestDto: RefineDoctorReportRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDoctorReportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refineClinicalDoctorReport(rxId, refineDoctorReportRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Corrects spelling, grammar and dictation errors in the given note text while preserving shorthand and length. The text is anonymized server-side before it is sent to the LLM. Nothing is persisted.
         * @summary Refine a treatment-note text (grammar/spelling/dictation fixes)
         * @param {RefineTreatmentNoteRequestDto} refineTreatmentNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refineClinicalTreatmentNote(refineTreatmentNoteRequestDto: RefineTreatmentNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefineTreatmentNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refineClinicalTreatmentNote(refineTreatmentNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendClinicalDoctorReportByEmail(reportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendClinicalDoctorReportByEmail(reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {CreateDoctorReportDto} createDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClinicalDoctorReport(id: string, createDoctorReportDto: CreateDoctorReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClinicalDoctorReport(id, createDoctorReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {DoctorReportStatusDto} doctorReportStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClinicalDoctorReportStatus(id: string, doctorReportStatusDto: DoctorReportStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoctorReportStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClinicalDoctorReportStatus(id, doctorReportStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClinicalInitialEvaluation(id: number, createInitialEvaluationDto: CreateInitialEvaluationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInitialEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClinicalInitialEvaluation(id, createInitialEvaluationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClinicalTreatmentNote(id: number, createTreatmentNoteDto: CreateTreatmentNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TreatmentNoteDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClinicalTreatmentNote(id, createTreatmentNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClinicalDocumentationApi - factory interface
 * @export
 */
export const ClinicalDocumentationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicalDocumentationApiFp(configuration)
    return {
        /**
         * Allows reassigning a doctor report to a different therapist.
         * @summary Assign or reassign a doctor report to a different therapist
         * @param {string} id 
         * @param {AssignDoctorReportDto} assignDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignClinicalDoctorReport(id: string, assignDoctorReportDto: AssignDoctorReportDto, options?: any): AxiosPromise<DoctorReportDto> {
            return localVarFp.assignClinicalDoctorReport(id, assignDoctorReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinicalInitialEvaluation(createInitialEvaluationDto: CreateInitialEvaluationDto, options?: any): AxiosPromise<GetInitialEvaluationDto> {
            return localVarFp.createClinicalInitialEvaluation(createInitialEvaluationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinicalTreatmentNote(createTreatmentNoteDto: CreateTreatmentNoteDto, options?: any): AxiosPromise<TreatmentNoteDTO> {
            return localVarFp.createClinicalTreatmentNote(createTreatmentNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Drafts the free-text fields of a Therapiebericht from the Rx\'s treatment notes and (optionally) the patient\'s initial evaluation. All source text is anonymized before it reaches the LLM. Nothing is persisted — the returned fields are a draft the therapist reviews and edits.
         * @summary Generate a doctor report draft from documentation using the LLM
         * @param {string} rxId 
         * @param {GenerateDoctorReportRequestDto} generateDoctorReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClinicalDoctorReport(rxId: string, generateDoctorReportRequestDto: GenerateDoctorReportRequestDto, options?: any): AxiosPromise<GenerateDoctorReportResponseDto> {
            return localVarFp.generateClinicalDoctorReport(rxId, generateDoctorReportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClinicalDoctorReportPdf(reportId: string, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.generateClinicalDoctorReportPdf(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReport(id: string, options?: any): AxiosPromise<DoctorReportDto> {
            return localVarFp.getClinicalDoctorReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportByRxId(rxId: string, options?: any): AxiosPromise<DoctorReportDto> {
            return localVarFp.getClinicalDoctorReportByRxId(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportStatus(rxId: string, options?: any): AxiosPromise<DoctorReportStatusDto> {
            return localVarFp.getClinicalDoctorReportStatus(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns one entry per requested Rx. Used by the therapist app to warm the offline cache without firing one HTTP request per Rx.
         * @summary Get doctor report status for many Rx IDs in a single request
         * @param {BulkRxIdsDto} bulkRxIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportStatusBulk(bulkRxIdsDto: BulkRxIdsDto, options?: any): AxiosPromise<Array<DoctorReportStatusByRxDto>> {
            return localVarFp.getClinicalDoctorReportStatusBulk(bulkRxIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the Registry / DoctorReports view to show how many reports each therapist still has in a given (typically \'unsubmitted\') state.
         * @summary Get count of doctor reports per assigned therapist for a given status
         * @param {string} status 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportTherapistCounts(status: string, locationId: string, options?: any): AxiosPromise<Array<DoctorReportTherapistCountDto>> {
            return localVarFp.getClinicalDoctorReportTherapistCounts(status, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportsForPatient(patientId: number, options?: any): AxiosPromise<void> {
            return localVarFp.getClinicalDoctorReportsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves doctor reports in batches with pagination support to reduce loading time.
         * @summary Get doctor reports with pagination and filters (batch loading)
         * @param {number} limit Number of items per page (Max: 50)
         * @param {number} page Page number (Min: 1)
         * @param {GetClinicalDoctorReportsWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {string} [userId] Filter by user ID (therapist/doctor)
         * @param {string} [assignedToUserId] Filter by assigned user ID - only returns reports assigned to this user (same as userId)
         * @param {number} [patientId] Filter by patient ID
         * @param {string} [locationId] Filter by location ID (Rx.patient.location)
         * @param {GetClinicalDoctorReportsWithFiltersStatusEnum} [status] Filter by doctor report status
         * @param {string} [doctorBsnr] Filter by doctor BSNR (clinic identifier number)
         * @param {string} [accountId] Filter by account ID (Rx.account)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalDoctorReportsWithFilters(limit: number, page: number, sortOrder?: GetClinicalDoctorReportsWithFiltersSortOrderEnum, userId?: string, assignedToUserId?: string, patientId?: number, locationId?: string, status?: GetClinicalDoctorReportsWithFiltersStatusEnum, doctorBsnr?: string, accountId?: string, options?: any): AxiosPromise<GetClinicalDoctorReportsWithFilters200Response> {
            return localVarFp.getClinicalDoctorReportsWithFilters(limit, page, sortOrder, userId, assignedToUserId, patientId, locationId, status, doctorBsnr, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalFirstAndLastTimeSlot(rxId: string, options?: any): AxiosPromise<DoctorReportTimeSlotDto> {
            return localVarFp.getClinicalFirstAndLastTimeSlot(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalInitialEvaluation(patientId: number, options?: any): AxiosPromise<Array<GetInitialEvaluationDto>> {
            return localVarFp.getClinicalInitialEvaluation(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns one bucket per requested patientId, newest-first, capped at 20 evaluations per patient. Used by the therapist app to warm the offline cache without per-patient fan-out.
         * @summary Get initial evaluations for many patients in a single request
         * @param {BulkPatientIdsDto} bulkPatientIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalInitialEvaluationsBulk(bulkPatientIdsDto: BulkPatientIdsDto, options?: any): AxiosPromise<Array<InitialEvaluationsByPatientDto>> {
            return localVarFp.getClinicalInitialEvaluationsBulk(bulkPatientIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotes(patientId: number, options?: any): AxiosPromise<Array<TimeSlotDto>> {
            return localVarFp.getClinicalTreatmentNotes(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk-fetch the first page of treatment notes for multiple patients
         * @param {BulkPatientIdsDto} bulkPatientIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotesBulk(bulkPatientIdsDto: BulkPatientIdsDto, options?: any): AxiosPromise<Array<TreatmentNotesByPatientDto>> {
            return localVarFp.getClinicalTreatmentNotesBulk(bulkPatientIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotesByTreatmentId(treatmentId: string, options?: any): AxiosPromise<Array<TreatmentNoteDTO>> {
            return localVarFp.getClinicalTreatmentNotesByTreatmentId(treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {number} limit Number of items per page (Max: 10)
         * @param {number} page Page number (Min: 1)
         * @param {GetClinicalTreatmentNotesWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {string} [appointmentId] appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTreatmentNotesWithFilters(patientId: number, limit: number, page: number, sortOrder?: GetClinicalTreatmentNotesWithFiltersSortOrderEnum, appointmentId?: string, options?: any): AxiosPromise<Array<TimeSlotDto>> {
            return localVarFp.getClinicalTreatmentNotesWithFilters(patientId, limit, page, sortOrder, appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Per-therapist documentation completeness over a trailing window
         * @param {string} [locationId] Filter therapists by location ID
         * @param {GetDocumentationStatsWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentationStats(locationId?: string, window?: GetDocumentationStatsWindowEnum, options?: any): AxiosPromise<Array<RegistryDocumentationStatsDto>> {
            return localVarFp.getDocumentationStats(locationId, window, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cross-patient, paginated treatment-notes listing (registry view)
         * @param {number} limit Number of items per page (Max: 100)
         * @param {number} page Page number (Min: 1)
         * @param {GetRegistryTreatmentNotesSortOrderEnum} [sortOrder] Sort by the treatment-note date (timeslot.start)
         * @param {string} [locationId] Filter by location ID
         * @param {string} [therapistId] Filter by therapist (treatment note author) user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistryTreatmentNotes(limit: number, page: number, sortOrder?: GetRegistryTreatmentNotesSortOrderEnum, locationId?: string, therapistId?: string, options?: any): AxiosPromise<Array<RegistryTreatmentNoteRowDto>> {
            return localVarFp.getRegistryTreatmentNotes(limit, page, sortOrder, locationId, therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attended treatments without notes for a therapist + window
         * @param {string} userId Therapist user id
         * @param {GetUndocumentedTreatmentsWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUndocumentedTreatments(userId: string, window?: GetUndocumentedTreatmentsWindowEnum, options?: any): AxiosPromise<Array<UndocumentedTreatmentDto>> {
            return localVarFp.getUndocumentedTreatments(userId, window, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateDoctorReportDto} createDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClinicalDoctorReport(createDoctorReportDto: CreateDoctorReportDto, options?: any): AxiosPromise<object> {
            return localVarFp.postClinicalDoctorReport(createDoctorReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {DoctorReportDto} doctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putClinicalDoctorReport(doctorReportDto: DoctorReportDto, options?: any): AxiosPromise<void> {
            return localVarFp.putClinicalDoctorReport(doctorReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes the current (unsaved) free-text fields of a Therapiebericht and returns refined versions: thorough German grammar/spelling correction plus optional rephrasing per the therapist\'s instruction. All text is anonymized before it reaches the LLM. Nothing is persisted.
         * @summary Refine the free-text fields of a doctor report using the LLM
         * @param {string} rxId 
         * @param {RefineDoctorReportRequestDto} refineDoctorReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refineClinicalDoctorReport(rxId: string, refineDoctorReportRequestDto: RefineDoctorReportRequestDto, options?: any): AxiosPromise<GenerateDoctorReportResponseDto> {
            return localVarFp.refineClinicalDoctorReport(rxId, refineDoctorReportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Corrects spelling, grammar and dictation errors in the given note text while preserving shorthand and length. The text is anonymized server-side before it is sent to the LLM. Nothing is persisted.
         * @summary Refine a treatment-note text (grammar/spelling/dictation fixes)
         * @param {RefineTreatmentNoteRequestDto} refineTreatmentNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refineClinicalTreatmentNote(refineTreatmentNoteRequestDto: RefineTreatmentNoteRequestDto, options?: any): AxiosPromise<RefineTreatmentNoteResponseDto> {
            return localVarFp.refineClinicalTreatmentNote(refineTreatmentNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendClinicalDoctorReportByEmail(reportId: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendClinicalDoctorReportByEmail(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {CreateDoctorReportDto} createDoctorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalDoctorReport(id: string, createDoctorReportDto: CreateDoctorReportDto, options?: any): AxiosPromise<DoctorReportDto> {
            return localVarFp.updateClinicalDoctorReport(id, createDoctorReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {DoctorReportStatusDto} doctorReportStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalDoctorReportStatus(id: string, doctorReportStatusDto: DoctorReportStatusDto, options?: any): AxiosPromise<DoctorReportStatusDto> {
            return localVarFp.updateClinicalDoctorReportStatus(id, doctorReportStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalInitialEvaluation(id: number, createInitialEvaluationDto: CreateInitialEvaluationDto, options?: any): AxiosPromise<GetInitialEvaluationDto> {
            return localVarFp.updateClinicalInitialEvaluation(id, createInitialEvaluationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalTreatmentNote(id: number, createTreatmentNoteDto: CreateTreatmentNoteDto, options?: any): AxiosPromise<TreatmentNoteDTO> {
            return localVarFp.updateClinicalTreatmentNote(id, createTreatmentNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClinicalDocumentationApi - object-oriented interface
 * @export
 * @class ClinicalDocumentationApi
 * @extends {BaseAPI}
 */
export class ClinicalDocumentationApi extends BaseAPI {
    /**
     * Allows reassigning a doctor report to a different therapist.
     * @summary Assign or reassign a doctor report to a different therapist
     * @param {string} id 
     * @param {AssignDoctorReportDto} assignDoctorReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public assignClinicalDoctorReport(id: string, assignDoctorReportDto: AssignDoctorReportDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).assignClinicalDoctorReport(id, assignDoctorReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public createClinicalInitialEvaluation(createInitialEvaluationDto: CreateInitialEvaluationDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).createClinicalInitialEvaluation(createInitialEvaluationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public createClinicalTreatmentNote(createTreatmentNoteDto: CreateTreatmentNoteDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).createClinicalTreatmentNote(createTreatmentNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Drafts the free-text fields of a Therapiebericht from the Rx\'s treatment notes and (optionally) the patient\'s initial evaluation. All source text is anonymized before it reaches the LLM. Nothing is persisted — the returned fields are a draft the therapist reviews and edits.
     * @summary Generate a doctor report draft from documentation using the LLM
     * @param {string} rxId 
     * @param {GenerateDoctorReportRequestDto} generateDoctorReportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public generateClinicalDoctorReport(rxId: string, generateDoctorReportRequestDto: GenerateDoctorReportRequestDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).generateClinicalDoctorReport(rxId, generateDoctorReportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public generateClinicalDoctorReportPdf(reportId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).generateClinicalDoctorReportPdf(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReport(id: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReport(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReportByRxId(rxId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReportByRxId(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReportStatus(rxId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReportStatus(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns one entry per requested Rx. Used by the therapist app to warm the offline cache without firing one HTTP request per Rx.
     * @summary Get doctor report status for many Rx IDs in a single request
     * @param {BulkRxIdsDto} bulkRxIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReportStatusBulk(bulkRxIdsDto: BulkRxIdsDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReportStatusBulk(bulkRxIdsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by the Registry / DoctorReports view to show how many reports each therapist still has in a given (typically \'unsubmitted\') state.
     * @summary Get count of doctor reports per assigned therapist for a given status
     * @param {string} status 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReportTherapistCounts(status: string, locationId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReportTherapistCounts(status, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReportsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReportsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves doctor reports in batches with pagination support to reduce loading time.
     * @summary Get doctor reports with pagination and filters (batch loading)
     * @param {number} limit Number of items per page (Max: 50)
     * @param {number} page Page number (Min: 1)
     * @param {GetClinicalDoctorReportsWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
     * @param {string} [userId] Filter by user ID (therapist/doctor)
     * @param {string} [assignedToUserId] Filter by assigned user ID - only returns reports assigned to this user (same as userId)
     * @param {number} [patientId] Filter by patient ID
     * @param {string} [locationId] Filter by location ID (Rx.patient.location)
     * @param {GetClinicalDoctorReportsWithFiltersStatusEnum} [status] Filter by doctor report status
     * @param {string} [doctorBsnr] Filter by doctor BSNR (clinic identifier number)
     * @param {string} [accountId] Filter by account ID (Rx.account)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalDoctorReportsWithFilters(limit: number, page: number, sortOrder?: GetClinicalDoctorReportsWithFiltersSortOrderEnum, userId?: string, assignedToUserId?: string, patientId?: number, locationId?: string, status?: GetClinicalDoctorReportsWithFiltersStatusEnum, doctorBsnr?: string, accountId?: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalDoctorReportsWithFilters(limit, page, sortOrder, userId, assignedToUserId, patientId, locationId, status, doctorBsnr, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalFirstAndLastTimeSlot(rxId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalFirstAndLastTimeSlot(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalInitialEvaluation(patientId: number, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalInitialEvaluation(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns one bucket per requested patientId, newest-first, capped at 20 evaluations per patient. Used by the therapist app to warm the offline cache without per-patient fan-out.
     * @summary Get initial evaluations for many patients in a single request
     * @param {BulkPatientIdsDto} bulkPatientIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalInitialEvaluationsBulk(bulkPatientIdsDto: BulkPatientIdsDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalInitialEvaluationsBulk(bulkPatientIdsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalTreatmentNotes(patientId: number, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalTreatmentNotes(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk-fetch the first page of treatment notes for multiple patients
     * @param {BulkPatientIdsDto} bulkPatientIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalTreatmentNotesBulk(bulkPatientIdsDto: BulkPatientIdsDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalTreatmentNotesBulk(bulkPatientIdsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} treatmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalTreatmentNotesByTreatmentId(treatmentId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalTreatmentNotesByTreatmentId(treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {number} limit Number of items per page (Max: 10)
     * @param {number} page Page number (Min: 1)
     * @param {GetClinicalTreatmentNotesWithFiltersSortOrderEnum} [sortOrder] Sorting order: asc or desc
     * @param {string} [appointmentId] appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getClinicalTreatmentNotesWithFilters(patientId: number, limit: number, page: number, sortOrder?: GetClinicalTreatmentNotesWithFiltersSortOrderEnum, appointmentId?: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getClinicalTreatmentNotesWithFilters(patientId, limit, page, sortOrder, appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Per-therapist documentation completeness over a trailing window
     * @param {string} [locationId] Filter therapists by location ID
     * @param {GetDocumentationStatsWindowEnum} [window] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getDocumentationStats(locationId?: string, window?: GetDocumentationStatsWindowEnum, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getDocumentationStats(locationId, window, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cross-patient, paginated treatment-notes listing (registry view)
     * @param {number} limit Number of items per page (Max: 100)
     * @param {number} page Page number (Min: 1)
     * @param {GetRegistryTreatmentNotesSortOrderEnum} [sortOrder] Sort by the treatment-note date (timeslot.start)
     * @param {string} [locationId] Filter by location ID
     * @param {string} [therapistId] Filter by therapist (treatment note author) user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getRegistryTreatmentNotes(limit: number, page: number, sortOrder?: GetRegistryTreatmentNotesSortOrderEnum, locationId?: string, therapistId?: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getRegistryTreatmentNotes(limit, page, sortOrder, locationId, therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attended treatments without notes for a therapist + window
     * @param {string} userId Therapist user id
     * @param {GetUndocumentedTreatmentsWindowEnum} [window] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public getUndocumentedTreatments(userId: string, window?: GetUndocumentedTreatmentsWindowEnum, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).getUndocumentedTreatments(userId, window, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateDoctorReportDto} createDoctorReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public postClinicalDoctorReport(createDoctorReportDto: CreateDoctorReportDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).postClinicalDoctorReport(createDoctorReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {DoctorReportDto} doctorReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public putClinicalDoctorReport(doctorReportDto: DoctorReportDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).putClinicalDoctorReport(doctorReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes the current (unsaved) free-text fields of a Therapiebericht and returns refined versions: thorough German grammar/spelling correction plus optional rephrasing per the therapist\'s instruction. All text is anonymized before it reaches the LLM. Nothing is persisted.
     * @summary Refine the free-text fields of a doctor report using the LLM
     * @param {string} rxId 
     * @param {RefineDoctorReportRequestDto} refineDoctorReportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public refineClinicalDoctorReport(rxId: string, refineDoctorReportRequestDto: RefineDoctorReportRequestDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).refineClinicalDoctorReport(rxId, refineDoctorReportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Corrects spelling, grammar and dictation errors in the given note text while preserving shorthand and length. The text is anonymized server-side before it is sent to the LLM. Nothing is persisted.
     * @summary Refine a treatment-note text (grammar/spelling/dictation fixes)
     * @param {RefineTreatmentNoteRequestDto} refineTreatmentNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public refineClinicalTreatmentNote(refineTreatmentNoteRequestDto: RefineTreatmentNoteRequestDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).refineClinicalTreatmentNote(refineTreatmentNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public sendClinicalDoctorReportByEmail(reportId: string, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).sendClinicalDoctorReportByEmail(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {CreateDoctorReportDto} createDoctorReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public updateClinicalDoctorReport(id: string, createDoctorReportDto: CreateDoctorReportDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).updateClinicalDoctorReport(id, createDoctorReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {DoctorReportStatusDto} doctorReportStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public updateClinicalDoctorReportStatus(id: string, doctorReportStatusDto: DoctorReportStatusDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).updateClinicalDoctorReportStatus(id, doctorReportStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {CreateInitialEvaluationDto} createInitialEvaluationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public updateClinicalInitialEvaluation(id: number, createInitialEvaluationDto: CreateInitialEvaluationDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).updateClinicalInitialEvaluation(id, createInitialEvaluationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {CreateTreatmentNoteDto} createTreatmentNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalDocumentationApi
     */
    public updateClinicalTreatmentNote(id: number, createTreatmentNoteDto: CreateTreatmentNoteDto, options?: AxiosRequestConfig) {
        return ClinicalDocumentationApiFp(this.configuration).updateClinicalTreatmentNote(id, createTreatmentNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetClinicalDoctorReportsWithFiltersSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetClinicalDoctorReportsWithFiltersSortOrderEnum = typeof GetClinicalDoctorReportsWithFiltersSortOrderEnum[keyof typeof GetClinicalDoctorReportsWithFiltersSortOrderEnum];
/**
 * @export
 */
export const GetClinicalDoctorReportsWithFiltersStatusEnum = {
    Entwurf: 'Entwurf',
    Abgegeben: 'Abgegeben',
    Versendet: 'Versendet'
} as const;
export type GetClinicalDoctorReportsWithFiltersStatusEnum = typeof GetClinicalDoctorReportsWithFiltersStatusEnum[keyof typeof GetClinicalDoctorReportsWithFiltersStatusEnum];
/**
 * @export
 */
export const GetClinicalTreatmentNotesWithFiltersSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetClinicalTreatmentNotesWithFiltersSortOrderEnum = typeof GetClinicalTreatmentNotesWithFiltersSortOrderEnum[keyof typeof GetClinicalTreatmentNotesWithFiltersSortOrderEnum];
/**
 * @export
 */
export const GetDocumentationStatsWindowEnum = {
    Last3Months: 'last3Months',
    LastYear: 'lastYear'
} as const;
export type GetDocumentationStatsWindowEnum = typeof GetDocumentationStatsWindowEnum[keyof typeof GetDocumentationStatsWindowEnum];
/**
 * @export
 */
export const GetRegistryTreatmentNotesSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetRegistryTreatmentNotesSortOrderEnum = typeof GetRegistryTreatmentNotesSortOrderEnum[keyof typeof GetRegistryTreatmentNotesSortOrderEnum];
/**
 * @export
 */
export const GetUndocumentedTreatmentsWindowEnum = {
    Last3Months: 'last3Months',
    LastYear: 'lastYear'
} as const;
export type GetUndocumentedTreatmentsWindowEnum = typeof GetUndocumentedTreatmentsWindowEnum[keyof typeof GetUndocumentedTreatmentsWindowEnum];


/**
 * DoctorApi - axios parameter creator
 * @export
 */
export const DoctorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {CreateDoctorDto} createDoctorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUpdateDoctor: async (createDoctorDto: CreateDoctorDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDoctorDto' is not null or undefined
            assertParamExists('addUpdateDoctor', 'createDoctorDto', createDoctorDto)
            const localVarPath = `/doctor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDoctorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the number of Rx rows currently linked to this clinic. Used as a preflight check before BSNR change.
         * @summary Count Rxs that would be affected by a clinic BSNR change
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCountAffectedRxsForClinic: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerCountAffectedRxsForClinic', 'id', id)
            const localVarPath = `/doctor/clinic/{id}/affected-rxs/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the number of Rx rows currently linked to this doctor. Used as a preflight check before LANR change.
         * @summary Count Rxs that would be affected by a doctor LANR change
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCountAffectedRxsForDoctor: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerCountAffectedRxsForDoctor', 'id', id)
            const localVarPath = `/doctor/{id}/affected-rxs/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new clinic
         * @param {CreateClinicDto} createClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCreateClinic: async (createClinicDto: CreateClinicDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClinicDto' is not null or undefined
            assertParamExists('doctorControllerCreateClinic', 'createClinicDto', createClinicDto)
            const localVarPath = `/doctor/clinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClinicDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation creates a new doctor and associates them with an existing clinic or creates a new clinic if the clinic does not exist.
         * @summary Create a doctor and associate it with a clinic
         * @param {CreateDoctorClinicDto} createDoctorClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCreateDoctorWithClinic: async (createDoctorClinicDto: CreateDoctorClinicDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDoctorClinicDto' is not null or undefined
            assertParamExists('doctorControllerCreateDoctorWithClinic', 'createDoctorClinicDto', createDoctorClinicDto)
            const localVarPath = `/doctor/create-with-clinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDoctorClinicDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all clinics with pagination
         * @param {string} page 
         * @param {string} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerFindAllClinics: async (page: string, limit: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('doctorControllerFindAllClinics', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('doctorControllerFindAllClinics', 'limit', limit)
            const localVarPath = `/doctor/clinic/findAllClinics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clinic by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerGetClinicById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerGetClinicById', 'id', id)
            const localVarPath = `/doctor/clinic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get doctor by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerGetDoctorById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerGetDoctorById', 'id', id)
            const localVarPath = `/doctor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provide either one parameter or none. If no parameters are provided, all doctors are returned
         * @summary fetch Doctors using various alternative methods
         * @param {string} [id] 
         * @param {string} [doctorNumber] 
         * @param {string} [clinicNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerGetDoctors: async (id?: string, doctorNumber?: string, clinicNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/doctor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (doctorNumber !== undefined) {
                localVarQueryParameter['doctorNumber'] = doctorNumber;
            }

            if (clinicNumber !== undefined) {
                localVarQueryParameter['clinicNumber'] = clinicNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a clinic by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerRemoveClinic: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerRemoveClinic', 'id', id)
            const localVarPath = `/doctor/clinic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation is not yet implemented.
         * @summary delete by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerRemoveDoctor: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerRemoveDoctor', 'id', id)
            const localVarPath = `/doctor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation removes a doctor from a clinic without deleting the doctor record from the doctor table.
         * @summary Remove a doctor from a clinic
         * @param {string} doctorId 
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerRemoveDoctorFromClinic: async (doctorId: string, clinicId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorId' is not null or undefined
            assertParamExists('doctorControllerRemoveDoctorFromClinic', 'doctorId', doctorId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('doctorControllerRemoveDoctorFromClinic', 'clinicId', clinicId)
            const localVarPath = `/doctor/{doctorId}/clinic/{clinicId}`
                .replace(`{${"doctorId"}}`, encodeURIComponent(String(doctorId)))
                .replace(`{${"clinicId"}}`, encodeURIComponent(String(clinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search clinics by query parameters
         * @param {string} [id] 
         * @param {string} [businessName] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerSearchClinics: async (id?: string, businessName?: string, city?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/doctor/clinic/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle active status of a doctor-clinic assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerToggleAssignmentActive: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerToggleAssignmentActive', 'id', id)
            const localVarPath = `/doctor/assignment/{id}/active`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing clinic
         * @param {string} id 
         * @param {UpdateClinicDto} updateClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateClinic: async (id: string, updateClinicDto: UpdateClinicDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerUpdateClinic', 'id', id)
            // verify required parameter 'updateClinicDto' is not null or undefined
            assertParamExists('doctorControllerUpdateClinic', 'updateClinicDto', updateClinicDto)
            const localVarPath = `/doctor/clinic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClinicDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or updates the BSNR for a clinic and cascades to all linked Rx rows.
         * @summary Update a clinic\'s BSNR
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateClinicBSNR: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerUpdateClinicBSNR', 'id', id)
            const localVarPath = `/doctor/clinic/{id}/bsnr`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation updates specific fields of a doctor\'s contact info.
         * @summary Update a doctor\'s information
         * @param {string} id 
         * @param {UpdateDoctorDto} updateDoctorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateDoctor: async (id: string, updateDoctorDto: UpdateDoctorDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerUpdateDoctor', 'id', id)
            // verify required parameter 'updateDoctorDto' is not null or undefined
            assertParamExists('doctorControllerUpdateDoctor', 'updateDoctorDto', updateDoctorDto)
            const localVarPath = `/doctor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDoctorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or updates the LANR for a doctor and cascades to all linked Rx rows.
         * @summary Update a doctor\'s LANR
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateDoctorLANR: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doctorControllerUpdateDoctorLANR', 'id', id)
            const localVarPath = `/doctor/{id}/lanr`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDOctorList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/doctor/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch doctors along with their clinic data with pagination
         * @summary Get doctors with their clinic data
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDOctorsWithClinicsList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/doctor/with-clinic-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retains the target clinic (optionally updated), deletes the source clinic, and moves all Rxs, tickets and doctor assignments from the source to the target.
         * @summary Merge two duplicate clinics
         * @param {MergeClinicsDto} mergeClinicsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeClinics: async (mergeClinicsDto: MergeClinicsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mergeClinicsDto' is not null or undefined
            assertParamExists('mergeClinics', 'mergeClinicsDto', mergeClinicsDto)
            const localVarPath = `/doctor/clinic/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeClinicsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retains the target doctor (optionally updated), deletes the source doctor, and moves all Rxs, tickets and clinic assignments from the source to the target.
         * @summary Merge two duplicate doctors
         * @param {MergeDoctorsDto} mergeDoctorsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeDoctors: async (mergeDoctorsDto: MergeDoctorsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mergeDoctorsDto' is not null or undefined
            assertParamExists('mergeDoctors', 'mergeDoctorsDto', mergeDoctorsDto)
            const localVarPath = `/doctor/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeDoctorsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SearchDoctorDto} searchDoctorDto 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchClinic: async (searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchDoctorDto' is not null or undefined
            assertParamExists('searchClinic', 'searchDoctorDto', searchDoctorDto)
            const localVarPath = `/doctor/clinic/searchClinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDoctorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SearchDoctorDto} searchDoctorDto 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDoctor: async (searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchDoctorDto' is not null or undefined
            assertParamExists('searchDoctor', 'searchDoctorDto', searchDoctorDto)
            const localVarPath = `/doctor/searchDoctor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDoctorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoctorApi - functional programming interface
 * @export
 */
export const DoctorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoctorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateDoctorDto} createDoctorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUpdateDoctor(createDoctorDto: CreateDoctorDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUpdateDoctor(createDoctorDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the number of Rx rows currently linked to this clinic. Used as a preflight check before BSNR change.
         * @summary Count Rxs that would be affected by a clinic BSNR change
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerCountAffectedRxsForClinic(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerCountAffectedRxsForClinic(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the number of Rx rows currently linked to this doctor. Used as a preflight check before LANR change.
         * @summary Count Rxs that would be affected by a doctor LANR change
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerCountAffectedRxsForDoctor(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerCountAffectedRxsForDoctor(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new clinic
         * @param {CreateClinicDto} createClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerCreateClinic(createClinicDto: CreateClinicDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerCreateClinic(createClinicDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation creates a new doctor and associates them with an existing clinic or creates a new clinic if the clinic does not exist.
         * @summary Create a doctor and associate it with a clinic
         * @param {CreateDoctorClinicDto} createDoctorClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerCreateDoctorWithClinic(createDoctorClinicDto: CreateDoctorClinicDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerCreateDoctorWithClinic(createDoctorClinicDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all clinics with pagination
         * @param {string} page 
         * @param {string} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerFindAllClinics(page: string, limit: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerFindAllClinics(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get clinic by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerGetClinicById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateClinicDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerGetClinicById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get doctor by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerGetDoctorById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDoctorClinicDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerGetDoctorById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provide either one parameter or none. If no parameters are provided, all doctors are returned
         * @summary fetch Doctors using various alternative methods
         * @param {string} [id] 
         * @param {string} [doctorNumber] 
         * @param {string} [clinicNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerGetDoctors(id?: string, doctorNumber?: string, clinicNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerGetDoctors(id, doctorNumber, clinicNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a clinic by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerRemoveClinic(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerRemoveClinic(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation is not yet implemented.
         * @summary delete by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerRemoveDoctor(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerRemoveDoctor(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation removes a doctor from a clinic without deleting the doctor record from the doctor table.
         * @summary Remove a doctor from a clinic
         * @param {string} doctorId 
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerRemoveDoctorFromClinic(doctorId: string, clinicId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerRemoveDoctorFromClinic(doctorId, clinicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search clinics by query parameters
         * @param {string} [id] 
         * @param {string} [businessName] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerSearchClinics(id?: string, businessName?: string, city?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateClinicDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerSearchClinics(id, businessName, city, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Toggle active status of a doctor-clinic assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerToggleAssignmentActive(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerToggleAssignmentActive(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an existing clinic
         * @param {string} id 
         * @param {UpdateClinicDto} updateClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerUpdateClinic(id: string, updateClinicDto: UpdateClinicDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerUpdateClinic(id, updateClinicDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets or updates the BSNR for a clinic and cascades to all linked Rx rows.
         * @summary Update a clinic\'s BSNR
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerUpdateClinicBSNR(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerUpdateClinicBSNR(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation updates specific fields of a doctor\'s contact info.
         * @summary Update a doctor\'s information
         * @param {string} id 
         * @param {UpdateDoctorDto} updateDoctorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerUpdateDoctor(id: string, updateDoctorDto: UpdateDoctorDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerUpdateDoctor(id, updateDoctorDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets or updates the LANR for a doctor and cascades to all linked Rx rows.
         * @summary Update a doctor\'s LANR
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doctorControllerUpdateDoctorLANR(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doctorControllerUpdateDoctorLANR(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDOctorList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDOctorList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch doctors along with their clinic data with pagination
         * @summary Get doctors with their clinic data
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDOctorsWithClinicsList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDOctorsWithClinicsList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retains the target clinic (optionally updated), deletes the source clinic, and moves all Rxs, tickets and doctor assignments from the source to the target.
         * @summary Merge two duplicate clinics
         * @param {MergeClinicsDto} mergeClinicsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeClinics(mergeClinicsDto: MergeClinicsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeClinics(mergeClinicsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retains the target doctor (optionally updated), deletes the source doctor, and moves all Rxs, tickets and clinic assignments from the source to the target.
         * @summary Merge two duplicate doctors
         * @param {MergeDoctorsDto} mergeDoctorsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeDoctors(mergeDoctorsDto: MergeDoctorsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeDoctors(mergeDoctorsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SearchDoctorDto} searchDoctorDto 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchClinic(searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchClinic(searchDoctorDto, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SearchDoctorDto} searchDoctorDto 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDoctor(searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDoctor(searchDoctorDto, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DoctorApi - factory interface
 * @export
 */
export const DoctorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoctorApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateDoctorDto} createDoctorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUpdateDoctor(createDoctorDto: CreateDoctorDto, options?: any): AxiosPromise<void> {
            return localVarFp.addUpdateDoctor(createDoctorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the number of Rx rows currently linked to this clinic. Used as a preflight check before BSNR change.
         * @summary Count Rxs that would be affected by a clinic BSNR change
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCountAffectedRxsForClinic(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerCountAffectedRxsForClinic(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the number of Rx rows currently linked to this doctor. Used as a preflight check before LANR change.
         * @summary Count Rxs that would be affected by a doctor LANR change
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCountAffectedRxsForDoctor(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerCountAffectedRxsForDoctor(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new clinic
         * @param {CreateClinicDto} createClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCreateClinic(createClinicDto: CreateClinicDto, options?: any): AxiosPromise<object> {
            return localVarFp.doctorControllerCreateClinic(createClinicDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation creates a new doctor and associates them with an existing clinic or creates a new clinic if the clinic does not exist.
         * @summary Create a doctor and associate it with a clinic
         * @param {CreateDoctorClinicDto} createDoctorClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerCreateDoctorWithClinic(createDoctorClinicDto: CreateDoctorClinicDto, options?: any): AxiosPromise<object> {
            return localVarFp.doctorControllerCreateDoctorWithClinic(createDoctorClinicDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all clinics with pagination
         * @param {string} page 
         * @param {string} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerFindAllClinics(page: string, limit: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerFindAllClinics(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clinic by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerGetClinicById(id: string, options?: any): AxiosPromise<CreateClinicDto> {
            return localVarFp.doctorControllerGetClinicById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get doctor by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerGetDoctorById(id: string, options?: any): AxiosPromise<CreateDoctorClinicDto> {
            return localVarFp.doctorControllerGetDoctorById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Provide either one parameter or none. If no parameters are provided, all doctors are returned
         * @summary fetch Doctors using various alternative methods
         * @param {string} [id] 
         * @param {string} [doctorNumber] 
         * @param {string} [clinicNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerGetDoctors(id?: string, doctorNumber?: string, clinicNumber?: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerGetDoctors(id, doctorNumber, clinicNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a clinic by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerRemoveClinic(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerRemoveClinic(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation is not yet implemented.
         * @summary delete by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerRemoveDoctor(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerRemoveDoctor(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation removes a doctor from a clinic without deleting the doctor record from the doctor table.
         * @summary Remove a doctor from a clinic
         * @param {string} doctorId 
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerRemoveDoctorFromClinic(doctorId: string, clinicId: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerRemoveDoctorFromClinic(doctorId, clinicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search clinics by query parameters
         * @param {string} [id] 
         * @param {string} [businessName] 
         * @param {string} [city] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerSearchClinics(id?: string, businessName?: string, city?: string, options?: any): AxiosPromise<Array<CreateClinicDto>> {
            return localVarFp.doctorControllerSearchClinics(id, businessName, city, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle active status of a doctor-clinic assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerToggleAssignmentActive(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerToggleAssignmentActive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing clinic
         * @param {string} id 
         * @param {UpdateClinicDto} updateClinicDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateClinic(id: string, updateClinicDto: UpdateClinicDto, options?: any): AxiosPromise<object> {
            return localVarFp.doctorControllerUpdateClinic(id, updateClinicDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or updates the BSNR for a clinic and cascades to all linked Rx rows.
         * @summary Update a clinic\'s BSNR
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateClinicBSNR(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerUpdateClinicBSNR(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation updates specific fields of a doctor\'s contact info.
         * @summary Update a doctor\'s information
         * @param {string} id 
         * @param {UpdateDoctorDto} updateDoctorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateDoctor(id: string, updateDoctorDto: UpdateDoctorDto, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerUpdateDoctor(id, updateDoctorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or updates the LANR for a doctor and cascades to all linked Rx rows.
         * @summary Update a doctor\'s LANR
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doctorControllerUpdateDoctorLANR(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.doctorControllerUpdateDoctorLANR(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDOctorList(page?: number, limit?: number, options?: any): AxiosPromise<void> {
            return localVarFp.getAllDOctorList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch doctors along with their clinic data with pagination
         * @summary Get doctors with their clinic data
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDOctorsWithClinicsList(page?: number, limit?: number, options?: any): AxiosPromise<void> {
            return localVarFp.getDOctorsWithClinicsList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retains the target clinic (optionally updated), deletes the source clinic, and moves all Rxs, tickets and doctor assignments from the source to the target.
         * @summary Merge two duplicate clinics
         * @param {MergeClinicsDto} mergeClinicsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeClinics(mergeClinicsDto: MergeClinicsDto, options?: any): AxiosPromise<void> {
            return localVarFp.mergeClinics(mergeClinicsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retains the target doctor (optionally updated), deletes the source doctor, and moves all Rxs, tickets and clinic assignments from the source to the target.
         * @summary Merge two duplicate doctors
         * @param {MergeDoctorsDto} mergeDoctorsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeDoctors(mergeDoctorsDto: MergeDoctorsDto, options?: any): AxiosPromise<void> {
            return localVarFp.mergeDoctors(mergeDoctorsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SearchDoctorDto} searchDoctorDto 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchClinic(searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options?: any): AxiosPromise<void> {
            return localVarFp.searchClinic(searchDoctorDto, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SearchDoctorDto} searchDoctorDto 
         * @param {number} [page] Page number
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDoctor(searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options?: any): AxiosPromise<void> {
            return localVarFp.searchDoctor(searchDoctorDto, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoctorApi - object-oriented interface
 * @export
 * @class DoctorApi
 * @extends {BaseAPI}
 */
export class DoctorApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {CreateDoctorDto} createDoctorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public addUpdateDoctor(createDoctorDto: CreateDoctorDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).addUpdateDoctor(createDoctorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the number of Rx rows currently linked to this clinic. Used as a preflight check before BSNR change.
     * @summary Count Rxs that would be affected by a clinic BSNR change
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerCountAffectedRxsForClinic(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerCountAffectedRxsForClinic(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the number of Rx rows currently linked to this doctor. Used as a preflight check before LANR change.
     * @summary Count Rxs that would be affected by a doctor LANR change
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerCountAffectedRxsForDoctor(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerCountAffectedRxsForDoctor(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new clinic
     * @param {CreateClinicDto} createClinicDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerCreateClinic(createClinicDto: CreateClinicDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerCreateClinic(createClinicDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation creates a new doctor and associates them with an existing clinic or creates a new clinic if the clinic does not exist.
     * @summary Create a doctor and associate it with a clinic
     * @param {CreateDoctorClinicDto} createDoctorClinicDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerCreateDoctorWithClinic(createDoctorClinicDto: CreateDoctorClinicDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerCreateDoctorWithClinic(createDoctorClinicDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all clinics with pagination
     * @param {string} page 
     * @param {string} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerFindAllClinics(page: string, limit: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerFindAllClinics(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clinic by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerGetClinicById(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerGetClinicById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get doctor by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerGetDoctorById(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerGetDoctorById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provide either one parameter or none. If no parameters are provided, all doctors are returned
     * @summary fetch Doctors using various alternative methods
     * @param {string} [id] 
     * @param {string} [doctorNumber] 
     * @param {string} [clinicNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerGetDoctors(id?: string, doctorNumber?: string, clinicNumber?: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerGetDoctors(id, doctorNumber, clinicNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a clinic by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerRemoveClinic(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerRemoveClinic(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation is not yet implemented.
     * @summary delete by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerRemoveDoctor(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerRemoveDoctor(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation removes a doctor from a clinic without deleting the doctor record from the doctor table.
     * @summary Remove a doctor from a clinic
     * @param {string} doctorId 
     * @param {string} clinicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerRemoveDoctorFromClinic(doctorId: string, clinicId: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerRemoveDoctorFromClinic(doctorId, clinicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search clinics by query parameters
     * @param {string} [id] 
     * @param {string} [businessName] 
     * @param {string} [city] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerSearchClinics(id?: string, businessName?: string, city?: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerSearchClinics(id, businessName, city, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle active status of a doctor-clinic assignment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerToggleAssignmentActive(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerToggleAssignmentActive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing clinic
     * @param {string} id 
     * @param {UpdateClinicDto} updateClinicDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerUpdateClinic(id: string, updateClinicDto: UpdateClinicDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerUpdateClinic(id, updateClinicDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or updates the BSNR for a clinic and cascades to all linked Rx rows.
     * @summary Update a clinic\'s BSNR
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerUpdateClinicBSNR(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerUpdateClinicBSNR(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation updates specific fields of a doctor\'s contact info.
     * @summary Update a doctor\'s information
     * @param {string} id 
     * @param {UpdateDoctorDto} updateDoctorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerUpdateDoctor(id: string, updateDoctorDto: UpdateDoctorDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerUpdateDoctor(id, updateDoctorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or updates the LANR for a doctor and cascades to all linked Rx rows.
     * @summary Update a doctor\'s LANR
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public doctorControllerUpdateDoctorLANR(id: string, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).doctorControllerUpdateDoctorLANR(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public getAllDOctorList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).getAllDOctorList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch doctors along with their clinic data with pagination
     * @summary Get doctors with their clinic data
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public getDOctorsWithClinicsList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).getDOctorsWithClinicsList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retains the target clinic (optionally updated), deletes the source clinic, and moves all Rxs, tickets and doctor assignments from the source to the target.
     * @summary Merge two duplicate clinics
     * @param {MergeClinicsDto} mergeClinicsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public mergeClinics(mergeClinicsDto: MergeClinicsDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).mergeClinics(mergeClinicsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retains the target doctor (optionally updated), deletes the source doctor, and moves all Rxs, tickets and clinic assignments from the source to the target.
     * @summary Merge two duplicate doctors
     * @param {MergeDoctorsDto} mergeDoctorsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public mergeDoctors(mergeDoctorsDto: MergeDoctorsDto, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).mergeDoctors(mergeDoctorsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SearchDoctorDto} searchDoctorDto 
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public searchClinic(searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).searchClinic(searchDoctorDto, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SearchDoctorDto} searchDoctorDto 
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoctorApi
     */
    public searchDoctor(searchDoctorDto: SearchDoctorDto, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return DoctorApiFp(this.configuration).searchDoctor(searchDoctorDto, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign an inbox document to a patient
         * @param {string} documentId 
         * @param {AssignPatientDto} assignPatientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDocumentToPatient: async (documentId: string, assignPatientDto: AssignPatientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('assignDocumentToPatient', 'documentId', documentId)
            // verify required parameter 'assignPatientDto' is not null or undefined
            assertParamExists('assignDocumentToPatient', 'assignPatientDto', assignPatientDto)
            const localVarPath = `/documents/{documentId}/assign-patient`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignPatientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocument', 'id', id)
            const localVarPath = `/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractDocumentOcr: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('extractDocumentOcr', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}/ocr/extract`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move document out of inbox after Rx is saved
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeInboxDocument: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('finalizeInboxDocument', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}/finalize-inbox`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentOcr: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentOcr', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}/ocr`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentRxExtraction: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentRxExtraction', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}/ocr/rx-extraction`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getDocuments', 'patientId', patientId)
            const localVarPath = `/documents/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unassigned inbox documents for a location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInboxDocuments: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getInboxDocuments', 'locationId', locationId)
            const localVarPath = `/documents/inbox/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the mapping between RxExtractionDto fields and OCR analyzer field names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcrFieldMapping: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/documents/ocr/field-mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccessForDocument: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('requestAccessForDocument', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}/access`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {boolean} [mobileRendition] Re-render oversized scan PDFs to a mobile-safe resolution. Set by iOS clients — mobile WebKit cannot decode very high-resolution scans (OOM). Off by default: without the flag the original bytes are always served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestViewAccessForDocument: async (documentId: string, mobileRendition?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('requestViewAccessForDocument', 'documentId', documentId)
            const localVarPath = `/documents/{documentId}/view`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mobileRendition !== undefined) {
                localVarQueryParameter['mobileRendition'] = mobileRendition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save curated OCR extraction data as an Rx (create or update)
         * @param {string} documentId 
         * @param {SaveRxFromExtractionDto} saveRxFromExtractionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRxFromExtraction: async (documentId: string, saveRxFromExtractionDto: SaveRxFromExtractionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('saveRxFromExtraction', 'documentId', documentId)
            // verify required parameter 'saveRxFromExtractionDto' is not null or undefined
            assertParamExists('saveRxFromExtraction', 'saveRxFromExtractionDto', saveRxFromExtractionDto)
            const localVarPath = `/documents/{documentId}/ocr/save-rx`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveRxFromExtractionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDocumentDto} updateDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: async (id: string, updateDocumentDto: UpdateDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDocument', 'id', id)
            // verify required parameter 'updateDocumentDto' is not null or undefined
            assertParamExists('updateDocument', 'updateDocumentDto', updateDocumentDto)
            const localVarPath = `/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign an inbox document to a patient
         * @param {string} documentId 
         * @param {AssignPatientDto} assignPatientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDocumentToPatient(documentId: string, assignPatientDto: AssignPatientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDocumentToPatient(documentId, assignPatientDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractDocumentOcr(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractDocumentOcr(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move document out of inbox after Rx is saved
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeInboxDocument(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeInboxDocument(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentOcr(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentOcr(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentRxExtraction(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxExtractionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentRxExtraction(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get unassigned inbox documents for a location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInboxDocuments(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInboxDocuments(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the mapping between RxExtractionDto fields and OCR analyzer field names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcrFieldMapping(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcrFieldMapping(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccessForDocument(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccessForDocument(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {boolean} [mobileRendition] Re-render oversized scan PDFs to a mobile-safe resolution. Set by iOS clients — mobile WebKit cannot decode very high-resolution scans (OOM). Off by default: without the flag the original bytes are always served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestViewAccessForDocument(documentId: string, mobileRendition?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestViewAccessForDocument(documentId, mobileRendition, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save curated OCR extraction data as an Rx (create or update)
         * @param {string} documentId 
         * @param {SaveRxFromExtractionDto} saveRxFromExtractionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRxFromExtraction(documentId: string, saveRxFromExtractionDto: SaveRxFromExtractionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaveRxResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRxFromExtraction(documentId, saveRxFromExtractionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDocumentDto} updateDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocument(id: string, updateDocumentDto: UpdateDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocument(id, updateDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign an inbox document to a patient
         * @param {string} documentId 
         * @param {AssignPatientDto} assignPatientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDocumentToPatient(documentId: string, assignPatientDto: AssignPatientDto, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.assignDocumentToPatient(documentId, assignPatientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(id: string, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.deleteDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractDocumentOcr(documentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.extractDocumentOcr(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move document out of inbox after Rx is saved
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeInboxDocument(documentId: string, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.finalizeInboxDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentOcr(documentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDocumentOcr(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentRxExtraction(documentId: string, options?: any): AxiosPromise<RxExtractionDto> {
            return localVarFp.getDocumentRxExtraction(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(patientId: number, options?: any): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.getDocuments(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unassigned inbox documents for a location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInboxDocuments(locationId: string, options?: any): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.getInboxDocuments(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the mapping between RxExtractionDto fields and OCR analyzer field names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcrFieldMapping(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getOcrFieldMapping(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccessForDocument(documentId: string, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.requestAccessForDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} documentId 
         * @param {boolean} [mobileRendition] Re-render oversized scan PDFs to a mobile-safe resolution. Set by iOS clients — mobile WebKit cannot decode very high-resolution scans (OOM). Off by default: without the flag the original bytes are always served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestViewAccessForDocument(documentId: string, mobileRendition?: boolean, options?: any): AxiosPromise<any> {
            return localVarFp.requestViewAccessForDocument(documentId, mobileRendition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save curated OCR extraction data as an Rx (create or update)
         * @param {string} documentId 
         * @param {SaveRxFromExtractionDto} saveRxFromExtractionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRxFromExtraction(documentId: string, saveRxFromExtractionDto: SaveRxFromExtractionDto, options?: any): AxiosPromise<Array<SaveRxResponse>> {
            return localVarFp.saveRxFromExtraction(documentId, saveRxFromExtractionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDocumentDto} updateDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(id: string, updateDocumentDto: UpdateDocumentDto, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.updateDocument(id, updateDocumentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @summary Assign an inbox document to a patient
     * @param {string} documentId 
     * @param {AssignPatientDto} assignPatientDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public assignDocumentToPatient(documentId: string, assignPatientDto: AssignPatientDto, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).assignDocumentToPatient(documentId, assignPatientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public deleteDocument(id: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).deleteDocument(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public extractDocumentOcr(documentId: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).extractDocumentOcr(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move document out of inbox after Rx is saved
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public finalizeInboxDocument(documentId: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).finalizeInboxDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentOcr(documentId: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentOcr(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentRxExtraction(documentId: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentRxExtraction(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocuments(patientId: number, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocuments(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unassigned inbox documents for a location
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getInboxDocuments(locationId: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getInboxDocuments(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the mapping between RxExtractionDto fields and OCR analyzer field names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getOcrFieldMapping(options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getOcrFieldMapping(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public requestAccessForDocument(documentId: string, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).requestAccessForDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} documentId 
     * @param {boolean} [mobileRendition] Re-render oversized scan PDFs to a mobile-safe resolution. Set by iOS clients — mobile WebKit cannot decode very high-resolution scans (OOM). Off by default: without the flag the original bytes are always served.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public requestViewAccessForDocument(documentId: string, mobileRendition?: boolean, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).requestViewAccessForDocument(documentId, mobileRendition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save curated OCR extraction data as an Rx (create or update)
     * @param {string} documentId 
     * @param {SaveRxFromExtractionDto} saveRxFromExtractionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public saveRxFromExtraction(documentId: string, saveRxFromExtractionDto: SaveRxFromExtractionDto, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).saveRxFromExtraction(documentId, saveRxFromExtractionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateDocumentDto} updateDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public updateDocument(id: string, updateDocumentDto: UpdateDocumentDto, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).updateDocument(id, updateDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HistoryApi - axios parameter creator
 * @export
 */
export const HistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {HistoryType} [type] 
         * @param {string | null} [action] 
         * @param {string | null} [searchKey] 
         * @param {string | null} [fromDate] 
         * @param {string | null} [toDate] 
         * @param {number} [patientId] 
         * @param {string} [rxId] 
         * @param {string} [appointmentId] 
         * @param {number} [initialEvaluationId] 
         * @param {number} [treatmentNoteId] 
         * @param {string} [addressId] 
         * @param {string} [therapyRxId] 
         * @param {string} [affectedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHistory: async (limit?: number, page?: number, type?: HistoryType, action?: string | null, searchKey?: string | null, fromDate?: string | null, toDate?: string | null, patientId?: number, rxId?: string, appointmentId?: string, initialEvaluationId?: number, treatmentNoteId?: number, addressId?: string, therapyRxId?: string, affectedUserId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (searchKey !== undefined) {
                localVarQueryParameter['searchKey'] = searchKey;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (rxId !== undefined) {
                localVarQueryParameter['rxId'] = rxId;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (initialEvaluationId !== undefined) {
                localVarQueryParameter['initialEvaluationId'] = initialEvaluationId;
            }

            if (treatmentNoteId !== undefined) {
                localVarQueryParameter['treatmentNoteId'] = treatmentNoteId;
            }

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }

            if (therapyRxId !== undefined) {
                localVarQueryParameter['therapyRxId'] = therapyRxId;
            }

            if (affectedUserId !== undefined) {
                localVarQueryParameter['affectedUserId'] = affectedUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryFilters: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoryApi - functional programming interface
 * @export
 */
export const HistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {HistoryType} [type] 
         * @param {string | null} [action] 
         * @param {string | null} [searchKey] 
         * @param {string | null} [fromDate] 
         * @param {string | null} [toDate] 
         * @param {number} [patientId] 
         * @param {string} [rxId] 
         * @param {string} [appointmentId] 
         * @param {number} [initialEvaluationId] 
         * @param {number} [treatmentNoteId] 
         * @param {string} [addressId] 
         * @param {string} [therapyRxId] 
         * @param {string} [affectedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHistory(limit?: number, page?: number, type?: HistoryType, action?: string | null, searchKey?: string | null, fromDate?: string | null, toDate?: string | null, patientId?: number, rxId?: string, appointmentId?: string, initialEvaluationId?: number, treatmentNoteId?: number, addressId?: string, therapyRxId?: string, affectedUserId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHistory(limit, page, type, action, searchKey, fromDate, toDate, patientId, rxId, appointmentId, initialEvaluationId, treatmentNoteId, addressId, therapyRxId, affectedUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryFilters(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryFiltersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryFilters(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HistoryApi - factory interface
 * @export
 */
export const HistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {HistoryType} [type] 
         * @param {string | null} [action] 
         * @param {string | null} [searchKey] 
         * @param {string | null} [fromDate] 
         * @param {string | null} [toDate] 
         * @param {number} [patientId] 
         * @param {string} [rxId] 
         * @param {string} [appointmentId] 
         * @param {number} [initialEvaluationId] 
         * @param {number} [treatmentNoteId] 
         * @param {string} [addressId] 
         * @param {string} [therapyRxId] 
         * @param {string} [affectedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHistory(limit?: number, page?: number, type?: HistoryType, action?: string | null, searchKey?: string | null, fromDate?: string | null, toDate?: string | null, patientId?: number, rxId?: string, appointmentId?: string, initialEvaluationId?: number, treatmentNoteId?: number, addressId?: string, therapyRxId?: string, affectedUserId?: string, options?: any): AxiosPromise<Array<GetHistoryDto>> {
            return localVarFp.getAllHistory(limit, page, type, action, searchKey, fromDate, toDate, patientId, rxId, appointmentId, initialEvaluationId, treatmentNoteId, addressId, therapyRxId, affectedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryFilters(options?: any): AxiosPromise<HistoryFiltersDto> {
            return localVarFp.getHistoryFilters(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoryApi - object-oriented interface
 * @export
 * @class HistoryApi
 * @extends {BaseAPI}
 */
export class HistoryApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {HistoryType} [type] 
     * @param {string | null} [action] 
     * @param {string | null} [searchKey] 
     * @param {string | null} [fromDate] 
     * @param {string | null} [toDate] 
     * @param {number} [patientId] 
     * @param {string} [rxId] 
     * @param {string} [appointmentId] 
     * @param {number} [initialEvaluationId] 
     * @param {number} [treatmentNoteId] 
     * @param {string} [addressId] 
     * @param {string} [therapyRxId] 
     * @param {string} [affectedUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getAllHistory(limit?: number, page?: number, type?: HistoryType, action?: string | null, searchKey?: string | null, fromDate?: string | null, toDate?: string | null, patientId?: number, rxId?: string, appointmentId?: string, initialEvaluationId?: number, treatmentNoteId?: number, addressId?: string, therapyRxId?: string, affectedUserId?: string, options?: AxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getAllHistory(limit, page, type, action, searchKey, fromDate, toDate, patientId, rxId, appointmentId, initialEvaluationId, treatmentNoteId, addressId, therapyRxId, affectedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getHistoryFilters(options?: AxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getHistoryFilters(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} workflowId 
         * @param {string} jobId 
         * @param {WorkflowEventResultSchemaMap} workflowEventResultSchemaMap 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWorkflowEvents: async (workflowId: string, jobId: string, workflowEventResultSchemaMap: WorkflowEventResultSchemaMap, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowId' is not null or undefined
            assertParamExists('handleWorkflowEvents', 'workflowId', workflowId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('handleWorkflowEvents', 'jobId', jobId)
            // verify required parameter 'workflowEventResultSchemaMap' is not null or undefined
            assertParamExists('handleWorkflowEvents', 'workflowEventResultSchemaMap', workflowEventResultSchemaMap)
            const localVarPath = `/workflows/{workflowId}/{jobId}/events`
                .replace(`{${"workflowId"}}`, encodeURIComponent(String(workflowId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowEventResultSchemaMap, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} workflowId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWorkflowTokens: async (workflowId: string, jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowId' is not null or undefined
            assertParamExists('refreshWorkflowTokens', 'workflowId', workflowId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('refreshWorkflowTokens', 'jobId', jobId)
            const localVarPath = `/workflows/{workflowId}/jobs/{jobId}/refresh-tokens`
                .replace(`{${"workflowId"}}`, encodeURIComponent(String(workflowId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} workflowId 
         * @param {string} jobId 
         * @param {WorkflowEventResultSchemaMap} workflowEventResultSchemaMap 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWorkflowEvents(workflowId: string, jobId: string, workflowEventResultSchemaMap: WorkflowEventResultSchemaMap, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWorkflowEvents(workflowId, jobId, workflowEventResultSchemaMap, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} workflowId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshWorkflowTokens(workflowId: string, jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshWorkflowTokens(workflowId, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} workflowId 
         * @param {string} jobId 
         * @param {WorkflowEventResultSchemaMap} workflowEventResultSchemaMap 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWorkflowEvents(workflowId: string, jobId: string, workflowEventResultSchemaMap: WorkflowEventResultSchemaMap, options?: any): AxiosPromise<void> {
            return localVarFp.handleWorkflowEvents(workflowId, jobId, workflowEventResultSchemaMap, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} workflowId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWorkflowTokens(workflowId: string, jobId: string, options?: any): AxiosPromise<void> {
            return localVarFp.refreshWorkflowTokens(workflowId, jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} workflowId 
     * @param {string} jobId 
     * @param {WorkflowEventResultSchemaMap} workflowEventResultSchemaMap 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public handleWorkflowEvents(workflowId: string, jobId: string, workflowEventResultSchemaMap: WorkflowEventResultSchemaMap, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).handleWorkflowEvents(workflowId, jobId, workflowEventResultSchemaMap, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} workflowId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public refreshWorkflowTokens(workflowId: string, jobId: string, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).refreshWorkflowTokens(workflowId, jobId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KostentraegerApi - axios parameter creator
 * @export
 */
export const KostentraegerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {CreateKostentraegerDto} createKostentraegerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKostentraeger: async (createKostentraegerDto: CreateKostentraegerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createKostentraegerDto' is not null or undefined
            assertParamExists('createKostentraeger', 'createKostentraegerDto', createKostentraegerDto)
            const localVarPath = `/kostentraeger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKostentraegerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKostentraegerUploads: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/kostentraeger/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadKostentraeger: async (files?: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/kostentraeger/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KostentraegerApi - functional programming interface
 * @export
 */
export const KostentraegerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KostentraegerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateKostentraegerDto} createKostentraegerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKostentraeger(createKostentraegerDto: CreateKostentraegerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KostentraegerCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKostentraeger(createKostentraegerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKostentraegerUploads(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KostentraegerUploadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKostentraegerUploads(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadKostentraeger(files?: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KostentraegerImportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadKostentraeger(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KostentraegerApi - factory interface
 * @export
 */
export const KostentraegerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KostentraegerApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateKostentraegerDto} createKostentraegerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKostentraeger(createKostentraegerDto: CreateKostentraegerDto, options?: any): AxiosPromise<KostentraegerCreatedDto> {
            return localVarFp.createKostentraeger(createKostentraegerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKostentraegerUploads(options?: any): AxiosPromise<Array<KostentraegerUploadDto>> {
            return localVarFp.getKostentraegerUploads(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadKostentraeger(files?: Array<File>, options?: any): AxiosPromise<KostentraegerImportResultDto> {
            return localVarFp.uploadKostentraeger(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KostentraegerApi - object-oriented interface
 * @export
 * @class KostentraegerApi
 * @extends {BaseAPI}
 */
export class KostentraegerApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {CreateKostentraegerDto} createKostentraegerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KostentraegerApi
     */
    public createKostentraeger(createKostentraegerDto: CreateKostentraegerDto, options?: AxiosRequestConfig) {
        return KostentraegerApiFp(this.configuration).createKostentraeger(createKostentraegerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KostentraegerApi
     */
    public getKostentraegerUploads(options?: AxiosRequestConfig) {
        return KostentraegerApiFp(this.configuration).getKostentraegerUploads(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KostentraegerApi
     */
    public uploadKostentraeger(files?: Array<File>, options?: AxiosRequestConfig) {
        return KostentraegerApiFp(this.configuration).uploadKostentraeger(files, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoadTestApi - axios parameter creator
 * @export
 */
export const LoadTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clear completed and failed jobs from the PDF queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearJobs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/load-test/clear-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get PDF queue statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/load-test/queue-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger PDF generation job(s) for load testing
         * @param {number} [count] Number of jobs (1-100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerPdfJob: async (count?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/load-test/pdf-job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoadTestApi - functional programming interface
 * @export
 */
export const LoadTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoadTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clear completed and failed jobs from the PDF queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearJobs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearJobs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get PDF queue statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueueStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueueStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Trigger PDF generation job(s) for load testing
         * @param {number} [count] Number of jobs (1-100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerPdfJob(count?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerPdfJob(count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoadTestApi - factory interface
 * @export
 */
export const LoadTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoadTestApiFp(configuration)
    return {
        /**
         * 
         * @summary Clear completed and failed jobs from the PDF queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearJobs(options?: any): AxiosPromise<void> {
            return localVarFp.clearJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get PDF queue statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueStats(options?: any): AxiosPromise<void> {
            return localVarFp.getQueueStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger PDF generation job(s) for load testing
         * @param {number} [count] Number of jobs (1-100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerPdfJob(count?: number, options?: any): AxiosPromise<void> {
            return localVarFp.triggerPdfJob(count, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoadTestApi - object-oriented interface
 * @export
 * @class LoadTestApi
 * @extends {BaseAPI}
 */
export class LoadTestApi extends BaseAPI {
    /**
     * 
     * @summary Clear completed and failed jobs from the PDF queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTestApi
     */
    public clearJobs(options?: AxiosRequestConfig) {
        return LoadTestApiFp(this.configuration).clearJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get PDF queue statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTestApi
     */
    public getQueueStats(options?: AxiosRequestConfig) {
        return LoadTestApiFp(this.configuration).getQueueStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger PDF generation job(s) for load testing
     * @param {number} [count] Number of jobs (1-100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTestApi
     */
    public triggerPdfJob(count?: number, options?: AxiosRequestConfig) {
        return LoadTestApiFp(this.configuration).triggerPdfJob(count, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MasterlistsApi - axios parameter creator
 * @export
 */
export const MasterlistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {BulkSaveRequestDto} bulkSaveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveChanges: async (bulkSaveRequestDto: BulkSaveRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSaveRequestDto' is not null or undefined
            assertParamExists('bulkSaveChanges', 'bulkSaveRequestDto', bulkSaveRequestDto)
            const localVarPath = `/masterlists/bulk-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSaveRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogMethod: async (upsertTherapyMethodDto: UpsertTherapyMethodDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertTherapyMethodDto' is not null or undefined
            assertParamExists('createCatalogMethod', 'upsertTherapyMethodDto', upsertTherapyMethodDto)
            const localVarPath = `/masterlists/catalog/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertTherapyMethodDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogTerm: async (upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertPrescribedTherapyDto' is not null or undefined
            assertParamExists('createCatalogTerm', 'upsertPrescribedTherapyDto', upsertPrescribedTherapyDto)
            const localVarPath = `/masterlists/catalog/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertPrescribedTherapyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateDiagnosisGroupDto} createDiagnosisGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiagnosisGroup: async (createDiagnosisGroupDto: CreateDiagnosisGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDiagnosisGroupDto' is not null or undefined
            assertParamExists('createDiagnosisGroup', 'createDiagnosisGroupDto', createDiagnosisGroupDto)
            const localVarPath = `/masterlists/diagnosisGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDiagnosisGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreatePriceDateRangeDto} createPriceDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrice: async (createPriceDateRangeDto: CreatePriceDateRangeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPriceDateRangeDto' is not null or undefined
            assertParamExists('createPrice', 'createPriceDateRangeDto', createPriceDateRangeDto)
            const localVarPath = `/masterlists/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPriceDateRangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateTherapyDto} createTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTherapy: async (createTherapyDto: CreateTherapyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTherapyDto' is not null or undefined
            assertParamExists('createTherapy', 'createTherapyDto', createTherapyDto)
            const localVarPath = `/masterlists/therapies/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTherapyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogMethod: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCatalogMethod', 'id', id)
            const localVarPath = `/masterlists/catalog/methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogTerm: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCatalogTerm', 'id', id)
            const localVarPath = `/masterlists/catalog/terms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refused while any prescription still names the group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiagnosisGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDiagnosisGroup', 'id', id)
            const localVarPath = `/masterlists/diagnosisGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refused while any slot inside the range was treated at this price
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrice: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePrice', 'id', id)
            const localVarPath = `/masterlists/prices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refused while any slot, Dauertermin, cancellation or qualification references it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTherapy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTherapy', 'id', id)
            const localVarPath = `/masterlists/therapies/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMasterTables: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinesses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/businesses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The whole resolution chain: term -> method -> billable line item per tarif group, including which terms resolve to nothing for which payer
         * @param {GetCatalogGraphTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGraph: async (therapyType?: GetCatalogGraphTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/catalog/graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What references this method — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogMethodUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCatalogMethodUsage', 'id', id)
            const localVarPath = `/masterlists/catalog/methods/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tarif-agnostic therapy methods, with the line items and terms attached to each
         * @param {GetCatalogMethodsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogMethods: async (therapyType?: GetCatalogMethodsTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/catalog/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What references this term — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogTermUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCatalogTermUsage', 'id', id)
            const localVarPath = `/masterlists/catalog/terms/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prescribed terms with their aliases, prioritised resolutions and usage counts
         * @param {GetCatalogTermsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogTerms: async (therapyType?: GetCatalogTermsTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/catalog/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiagnosisGroupById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDiagnosisGroupById', 'id', id)
            const localVarPath = `/masterlists/diagnosisGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What references this diagnosis group — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiagnosisGroupUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDiagnosisGroupUsage', 'id', id)
            const localVarPath = `/masterlists/diagnosisGroups/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetDiagnosisGroupsAdminTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiagnosisGroupsAdmin: async (therapyType?: GetDiagnosisGroupsAdminTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/diagnosisGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} [text] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getICDCCode: async (text?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/icdCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForBusiness: async (businessId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getLocationsForBusiness', 'businessId', businessId)
            const localVarPath = `/masterlists/locationsForBusiness/{businessId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prescribed terms as Rx-entry options: id, shortLabel, label and all aliases. Payer-independent by design — the billable line item is chosen at scheduling.
         * @param {GetPrescribedTherapyOptionsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescribedTherapyOptions: async (therapyType?: GetPrescribedTherapyOptionsTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/catalog/termOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What this price range still has to be able to price — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPriceUsage', 'id', id)
            const localVarPath = `/masterlists/prices/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} therapyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricesForTherapy: async (therapyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapyId' is not null or undefined
            assertParamExists('getPricesForTherapy', 'therapyId', therapyId)
            const localVarPath = `/masterlists/prices/therapy/{therapyId}`
                .replace(`{${"therapyId"}}`, encodeURIComponent(String(therapyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/rxTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTarifGroups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/tarifGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetTherapiesTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapies: async (therapyType?: GetTherapiesTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/therapies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetTherapiesAdminTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapiesAdmin: async (therapyType?: GetTherapiesAdminTherapyTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/therapies/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (therapyType !== undefined) {
                localVarQueryParameter['therapyType'] = therapyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTherapyById', 'id', id)
            const localVarPath = `/masterlists/therapies/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyCertifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/therapyCertifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyColors: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterlists/therapyColors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What references this Heilmittel — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTherapyUsage', 'id', id)
            const localVarPath = `/masterlists/therapies/admin/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {AiPriceProcessingRequestDto} aiPriceProcessingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAiPriceText: async (aiPriceProcessingRequestDto: AiPriceProcessingRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiPriceProcessingRequestDto' is not null or undefined
            assertParamExists('processAiPriceText', 'aiPriceProcessingRequestDto', aiPriceProcessingRequestDto)
            const localVarPath = `/masterlists/prices/ai-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiPriceProcessingRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogMethod: async (id: string, upsertTherapyMethodDto: UpsertTherapyMethodDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCatalogMethod', 'id', id)
            // verify required parameter 'upsertTherapyMethodDto' is not null or undefined
            assertParamExists('updateCatalogMethod', 'upsertTherapyMethodDto', upsertTherapyMethodDto)
            const localVarPath = `/masterlists/catalog/methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertTherapyMethodDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a term; `aliases` and `resolutions` replace the stored lists wholesale
         * @param {string} id 
         * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogTerm: async (id: string, upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCatalogTerm', 'id', id)
            // verify required parameter 'upsertPrescribedTherapyDto' is not null or undefined
            assertParamExists('updateCatalogTerm', 'upsertPrescribedTherapyDto', upsertPrescribedTherapyDto)
            const localVarPath = `/masterlists/catalog/terms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertPrescribedTherapyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDiagnosisGroupDto} updateDiagnosisGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiagnosisGroup: async (id: string, updateDiagnosisGroupDto: UpdateDiagnosisGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDiagnosisGroup', 'id', id)
            // verify required parameter 'updateDiagnosisGroupDto' is not null or undefined
            assertParamExists('updateDiagnosisGroup', 'updateDiagnosisGroupDto', updateDiagnosisGroupDto)
            const localVarPath = `/masterlists/diagnosisGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDiagnosisGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdatePriceDateRangeDto} updatePriceDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrice: async (id: string, updatePriceDateRangeDto: UpdatePriceDateRangeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePrice', 'id', id)
            // verify required parameter 'updatePriceDateRangeDto' is not null or undefined
            assertParamExists('updatePrice', 'updatePriceDateRangeDto', updatePriceDateRangeDto)
            const localVarPath = `/masterlists/prices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePriceDateRangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateTherapyDto} updateTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTherapy: async (id: string, updateTherapyDto: UpdateTherapyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTherapy', 'id', id)
            // verify required parameter 'updateTherapyDto' is not null or undefined
            assertParamExists('updateTherapy', 'updateTherapyDto', updateTherapyDto)
            const localVarPath = `/masterlists/therapies/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTherapyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterlistsApi - functional programming interface
 * @export
 */
export const MasterlistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterlistsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {BulkSaveRequestDto} bulkSaveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSaveChanges(bulkSaveRequestDto: BulkSaveRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSaveResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSaveChanges(bulkSaveRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCatalogMethod(upsertTherapyMethodDto: UpsertTherapyMethodDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCatalogMethod(upsertTherapyMethodDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCatalogTerm(upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrescribedTherapyAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCatalogTerm(upsertPrescribedTherapyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateDiagnosisGroupDto} createDiagnosisGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiagnosisGroup(createDiagnosisGroupDto: CreateDiagnosisGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosisGroupAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiagnosisGroup(createDiagnosisGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreatePriceDateRangeDto} createPriceDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrice(createPriceDateRangeDto: CreatePriceDateRangeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceDateRangeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrice(createPriceDateRangeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateTherapyDto} createTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTherapy(createTherapyDto: CreateTherapyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTherapy(createTherapyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCatalogMethod(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCatalogMethod(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCatalogTerm(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCatalogTerm(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Refused while any prescription still names the group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDiagnosisGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDiagnosisGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Refused while any slot inside the range was treated at this price
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrice(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Refused while any slot, Dauertermin, cancellation or qualification references it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTherapy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTherapy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMasterTables(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMasterTables(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPrices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriceDateRangeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPrices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinesses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinesses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The whole resolution chain: term -> method -> billable line item per tarif group, including which terms resolve to nothing for which payer
         * @param {GetCatalogGraphTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogGraph(therapyType?: GetCatalogGraphTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogGraphDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogGraph(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary What references this method — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogMethodUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogUsageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogMethodUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Tarif-agnostic therapy methods, with the line items and terms attached to each
         * @param {GetCatalogMethodsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogMethods(therapyType?: GetCatalogMethodsTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyMethodAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogMethods(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary What references this term — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogTermUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogUsageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogTermUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Prescribed terms with their aliases, prioritised resolutions and usage counts
         * @param {GetCatalogTermsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogTerms(therapyType?: GetCatalogTermsTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrescribedTherapyAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogTerms(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiagnosisGroupById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosisGroupAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiagnosisGroupById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary What references this diagnosis group — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiagnosisGroupUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogUsageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiagnosisGroupUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {GetDiagnosisGroupsAdminTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiagnosisGroupsAdmin(therapyType?: GetDiagnosisGroupsAdminTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiagnosisGroupAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiagnosisGroupsAdmin(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} [text] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getICDCCode(text?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getICDCCode(text, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsForBusiness(businessId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsForBusiness(businessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Prescribed terms as Rx-entry options: id, shortLabel, label and all aliases. Payer-independent by design — the billable line item is chosen at scheduling.
         * @param {GetPrescribedTherapyOptionsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescribedTherapyOptions(therapyType?: GetPrescribedTherapyOptionsTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrescribedTherapyOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescribedTherapyOptions(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary What this price range still has to be able to price — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogUsageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} therapyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricesForTherapy(therapyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriceDateRangeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricesForTherapy(therapyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTarifGroups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTarifGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {GetTherapiesTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapies(therapyType?: GetTherapiesTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapies(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {GetTherapiesAdminTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapiesAdmin(therapyType?: GetTherapiesAdminTherapyTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapiesAdmin(therapyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyCertifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyCertifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyColors(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyColors(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary What references this Heilmittel — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogUsageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {AiPriceProcessingRequestDto} aiPriceProcessingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processAiPriceText(aiPriceProcessingRequestDto: AiPriceProcessingRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiPriceProcessingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processAiPriceText(aiPriceProcessingRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCatalogMethod(id: string, upsertTherapyMethodDto: UpsertTherapyMethodDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCatalogMethod(id, upsertTherapyMethodDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a term; `aliases` and `resolutions` replace the stored lists wholesale
         * @param {string} id 
         * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCatalogTerm(id: string, upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrescribedTherapyAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCatalogTerm(id, upsertPrescribedTherapyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDiagnosisGroupDto} updateDiagnosisGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiagnosisGroup(id: string, updateDiagnosisGroupDto: UpdateDiagnosisGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosisGroupAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiagnosisGroup(id, updateDiagnosisGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdatePriceDateRangeDto} updatePriceDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrice(id: string, updatePriceDateRangeDto: UpdatePriceDateRangeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceDateRangeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrice(id, updatePriceDateRangeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateTherapyDto} updateTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTherapy(id: string, updateTherapyDto: UpdateTherapyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTherapy(id, updateTherapyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterlistsApi - factory interface
 * @export
 */
export const MasterlistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterlistsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {BulkSaveRequestDto} bulkSaveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveChanges(bulkSaveRequestDto: BulkSaveRequestDto, options?: any): AxiosPromise<BulkSaveResponseDto> {
            return localVarFp.bulkSaveChanges(bulkSaveRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogMethod(upsertTherapyMethodDto: UpsertTherapyMethodDto, options?: any): AxiosPromise<void> {
            return localVarFp.createCatalogMethod(upsertTherapyMethodDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogTerm(upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options?: any): AxiosPromise<PrescribedTherapyAdminDto> {
            return localVarFp.createCatalogTerm(upsertPrescribedTherapyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateDiagnosisGroupDto} createDiagnosisGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiagnosisGroup(createDiagnosisGroupDto: CreateDiagnosisGroupDto, options?: any): AxiosPromise<DiagnosisGroupAdminDto> {
            return localVarFp.createDiagnosisGroup(createDiagnosisGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreatePriceDateRangeDto} createPriceDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrice(createPriceDateRangeDto: CreatePriceDateRangeDto, options?: any): AxiosPromise<PriceDateRangeDto> {
            return localVarFp.createPrice(createPriceDateRangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateTherapyDto} createTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTherapy(createTherapyDto: CreateTherapyDto, options?: any): AxiosPromise<TherapyAdminDto> {
            return localVarFp.createTherapy(createTherapyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogMethod(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCatalogMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogTerm(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCatalogTerm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refused while any prescription still names the group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiagnosisGroup(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDiagnosisGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refused while any slot inside the range was treated at this price
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrice(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePrice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refused while any slot, Dauertermin, cancellation or qualification references it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTherapy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTherapy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMasterTables(options?: any): AxiosPromise<void> {
            return localVarFp.getAllMasterTables(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrices(options?: any): AxiosPromise<Array<PriceDateRangeDto>> {
            return localVarFp.getAllPrices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinesses(options?: any): AxiosPromise<Array<BusinessDto>> {
            return localVarFp.getBusinesses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The whole resolution chain: term -> method -> billable line item per tarif group, including which terms resolve to nothing for which payer
         * @param {GetCatalogGraphTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGraph(therapyType?: GetCatalogGraphTherapyTypeEnum, options?: any): AxiosPromise<CatalogGraphDto> {
            return localVarFp.getCatalogGraph(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What references this method — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogMethodUsage(id: string, options?: any): AxiosPromise<CatalogUsageDto> {
            return localVarFp.getCatalogMethodUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tarif-agnostic therapy methods, with the line items and terms attached to each
         * @param {GetCatalogMethodsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogMethods(therapyType?: GetCatalogMethodsTherapyTypeEnum, options?: any): AxiosPromise<Array<TherapyMethodAdminDto>> {
            return localVarFp.getCatalogMethods(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What references this term — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogTermUsage(id: string, options?: any): AxiosPromise<CatalogUsageDto> {
            return localVarFp.getCatalogTermUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prescribed terms with their aliases, prioritised resolutions and usage counts
         * @param {GetCatalogTermsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogTerms(therapyType?: GetCatalogTermsTherapyTypeEnum, options?: any): AxiosPromise<Array<PrescribedTherapyAdminDto>> {
            return localVarFp.getCatalogTerms(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiagnosisGroupById(id: string, options?: any): AxiosPromise<DiagnosisGroupAdminDto> {
            return localVarFp.getDiagnosisGroupById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What references this diagnosis group — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiagnosisGroupUsage(id: string, options?: any): AxiosPromise<CatalogUsageDto> {
            return localVarFp.getDiagnosisGroupUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {GetDiagnosisGroupsAdminTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiagnosisGroupsAdmin(therapyType?: GetDiagnosisGroupsAdminTherapyTypeEnum, options?: any): AxiosPromise<Array<DiagnosisGroupAdminDto>> {
            return localVarFp.getDiagnosisGroupsAdmin(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} [text] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getICDCCode(text?: string, options?: any): AxiosPromise<object> {
            return localVarFp.getICDCCode(text, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(options?: any): AxiosPromise<Array<LocationDto>> {
            return localVarFp.getLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForBusiness(businessId: string, options?: any): AxiosPromise<Array<LocationDto>> {
            return localVarFp.getLocationsForBusiness(businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prescribed terms as Rx-entry options: id, shortLabel, label and all aliases. Payer-independent by design — the billable line item is chosen at scheduling.
         * @param {GetPrescribedTherapyOptionsTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescribedTherapyOptions(therapyType?: GetPrescribedTherapyOptionsTherapyTypeEnum, options?: any): AxiosPromise<Array<PrescribedTherapyOptionDto>> {
            return localVarFp.getPrescribedTherapyOptions(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What this price range still has to be able to price — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceUsage(id: string, options?: any): AxiosPromise<CatalogUsageDto> {
            return localVarFp.getPriceUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} therapyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricesForTherapy(therapyId: string, options?: any): AxiosPromise<Array<PriceDateRangeDto>> {
            return localVarFp.getPricesForTherapy(therapyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxTypes(options?: any): AxiosPromise<void> {
            return localVarFp.getRxTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTarifGroups(options?: any): AxiosPromise<void> {
            return localVarFp.getTarifGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {GetTherapiesTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapies(therapyType?: GetTherapiesTherapyTypeEnum, options?: any): AxiosPromise<Array<TherapyDto>> {
            return localVarFp.getTherapies(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {GetTherapiesAdminTherapyTypeEnum} [therapyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapiesAdmin(therapyType?: GetTherapiesAdminTherapyTypeEnum, options?: any): AxiosPromise<Array<TherapyAdminDto>> {
            return localVarFp.getTherapiesAdmin(therapyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyById(id: string, options?: any): AxiosPromise<TherapyAdminDto> {
            return localVarFp.getTherapyById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyCertifications(options?: any): AxiosPromise<void> {
            return localVarFp.getTherapyCertifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyColors(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getTherapyColors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What references this Heilmittel — call before offering a delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyUsage(id: string, options?: any): AxiosPromise<CatalogUsageDto> {
            return localVarFp.getTherapyUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {AiPriceProcessingRequestDto} aiPriceProcessingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAiPriceText(aiPriceProcessingRequestDto: AiPriceProcessingRequestDto, options?: any): AxiosPromise<AiPriceProcessingResponseDto> {
            return localVarFp.processAiPriceText(aiPriceProcessingRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogMethod(id: string, upsertTherapyMethodDto: UpsertTherapyMethodDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateCatalogMethod(id, upsertTherapyMethodDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a term; `aliases` and `resolutions` replace the stored lists wholesale
         * @param {string} id 
         * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogTerm(id: string, upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options?: any): AxiosPromise<PrescribedTherapyAdminDto> {
            return localVarFp.updateCatalogTerm(id, upsertPrescribedTherapyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDiagnosisGroupDto} updateDiagnosisGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiagnosisGroup(id: string, updateDiagnosisGroupDto: UpdateDiagnosisGroupDto, options?: any): AxiosPromise<DiagnosisGroupAdminDto> {
            return localVarFp.updateDiagnosisGroup(id, updateDiagnosisGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdatePriceDateRangeDto} updatePriceDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrice(id: string, updatePriceDateRangeDto: UpdatePriceDateRangeDto, options?: any): AxiosPromise<PriceDateRangeDto> {
            return localVarFp.updatePrice(id, updatePriceDateRangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateTherapyDto} updateTherapyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTherapy(id: string, updateTherapyDto: UpdateTherapyDto, options?: any): AxiosPromise<TherapyAdminDto> {
            return localVarFp.updateTherapy(id, updateTherapyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterlistsApi - object-oriented interface
 * @export
 * @class MasterlistsApi
 * @extends {BaseAPI}
 */
export class MasterlistsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {BulkSaveRequestDto} bulkSaveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public bulkSaveChanges(bulkSaveRequestDto: BulkSaveRequestDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).bulkSaveChanges(bulkSaveRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public createCatalogMethod(upsertTherapyMethodDto: UpsertTherapyMethodDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).createCatalogMethod(upsertTherapyMethodDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public createCatalogTerm(upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).createCatalogTerm(upsertPrescribedTherapyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateDiagnosisGroupDto} createDiagnosisGroupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public createDiagnosisGroup(createDiagnosisGroupDto: CreateDiagnosisGroupDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).createDiagnosisGroup(createDiagnosisGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreatePriceDateRangeDto} createPriceDateRangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public createPrice(createPriceDateRangeDto: CreatePriceDateRangeDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).createPrice(createPriceDateRangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateTherapyDto} createTherapyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public createTherapy(createTherapyDto: CreateTherapyDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).createTherapy(createTherapyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public deleteCatalogMethod(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).deleteCatalogMethod(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public deleteCatalogTerm(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).deleteCatalogTerm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refused while any prescription still names the group
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public deleteDiagnosisGroup(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).deleteDiagnosisGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refused while any slot inside the range was treated at this price
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public deletePrice(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).deletePrice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refused while any slot, Dauertermin, cancellation or qualification references it
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public deleteTherapy(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).deleteTherapy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getAllMasterTables(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getAllMasterTables(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getAllPrices(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getAllPrices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getBusinesses(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getBusinesses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The whole resolution chain: term -> method -> billable line item per tarif group, including which terms resolve to nothing for which payer
     * @param {GetCatalogGraphTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getCatalogGraph(therapyType?: GetCatalogGraphTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getCatalogGraph(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What references this method — call before offering a delete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getCatalogMethodUsage(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getCatalogMethodUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tarif-agnostic therapy methods, with the line items and terms attached to each
     * @param {GetCatalogMethodsTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getCatalogMethods(therapyType?: GetCatalogMethodsTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getCatalogMethods(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What references this term — call before offering a delete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getCatalogTermUsage(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getCatalogTermUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prescribed terms with their aliases, prioritised resolutions and usage counts
     * @param {GetCatalogTermsTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getCatalogTerms(therapyType?: GetCatalogTermsTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getCatalogTerms(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getDiagnosisGroupById(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getDiagnosisGroupById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What references this diagnosis group — call before offering a delete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getDiagnosisGroupUsage(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getDiagnosisGroupUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {GetDiagnosisGroupsAdminTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getDiagnosisGroupsAdmin(therapyType?: GetDiagnosisGroupsAdminTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getDiagnosisGroupsAdmin(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} [text] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getICDCCode(text?: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getICDCCode(text, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getLocations(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} businessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getLocationsForBusiness(businessId: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getLocationsForBusiness(businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prescribed terms as Rx-entry options: id, shortLabel, label and all aliases. Payer-independent by design — the billable line item is chosen at scheduling.
     * @param {GetPrescribedTherapyOptionsTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getPrescribedTherapyOptions(therapyType?: GetPrescribedTherapyOptionsTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getPrescribedTherapyOptions(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What this price range still has to be able to price — call before offering a delete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getPriceUsage(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getPriceUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} therapyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getPricesForTherapy(therapyId: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getPricesForTherapy(therapyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getRxTypes(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getRxTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTarifGroups(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTarifGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {GetTherapiesTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTherapies(therapyType?: GetTherapiesTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTherapies(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {GetTherapiesAdminTherapyTypeEnum} [therapyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTherapiesAdmin(therapyType?: GetTherapiesAdminTherapyTypeEnum, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTherapiesAdmin(therapyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTherapyById(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTherapyById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTherapyCertifications(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTherapyCertifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTherapyColors(options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTherapyColors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What references this Heilmittel — call before offering a delete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public getTherapyUsage(id: string, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).getTherapyUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {AiPriceProcessingRequestDto} aiPriceProcessingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public processAiPriceText(aiPriceProcessingRequestDto: AiPriceProcessingRequestDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).processAiPriceText(aiPriceProcessingRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpsertTherapyMethodDto} upsertTherapyMethodDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public updateCatalogMethod(id: string, upsertTherapyMethodDto: UpsertTherapyMethodDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).updateCatalogMethod(id, upsertTherapyMethodDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a term; `aliases` and `resolutions` replace the stored lists wholesale
     * @param {string} id 
     * @param {UpsertPrescribedTherapyDto} upsertPrescribedTherapyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public updateCatalogTerm(id: string, upsertPrescribedTherapyDto: UpsertPrescribedTherapyDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).updateCatalogTerm(id, upsertPrescribedTherapyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateDiagnosisGroupDto} updateDiagnosisGroupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public updateDiagnosisGroup(id: string, updateDiagnosisGroupDto: UpdateDiagnosisGroupDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).updateDiagnosisGroup(id, updateDiagnosisGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdatePriceDateRangeDto} updatePriceDateRangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public updatePrice(id: string, updatePriceDateRangeDto: UpdatePriceDateRangeDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).updatePrice(id, updatePriceDateRangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateTherapyDto} updateTherapyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterlistsApi
     */
    public updateTherapy(id: string, updateTherapyDto: UpdateTherapyDto, options?: AxiosRequestConfig) {
        return MasterlistsApiFp(this.configuration).updateTherapy(id, updateTherapyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCatalogGraphTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetCatalogGraphTherapyTypeEnum = typeof GetCatalogGraphTherapyTypeEnum[keyof typeof GetCatalogGraphTherapyTypeEnum];
/**
 * @export
 */
export const GetCatalogMethodsTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetCatalogMethodsTherapyTypeEnum = typeof GetCatalogMethodsTherapyTypeEnum[keyof typeof GetCatalogMethodsTherapyTypeEnum];
/**
 * @export
 */
export const GetCatalogTermsTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetCatalogTermsTherapyTypeEnum = typeof GetCatalogTermsTherapyTypeEnum[keyof typeof GetCatalogTermsTherapyTypeEnum];
/**
 * @export
 */
export const GetDiagnosisGroupsAdminTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetDiagnosisGroupsAdminTherapyTypeEnum = typeof GetDiagnosisGroupsAdminTherapyTypeEnum[keyof typeof GetDiagnosisGroupsAdminTherapyTypeEnum];
/**
 * @export
 */
export const GetPrescribedTherapyOptionsTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetPrescribedTherapyOptionsTherapyTypeEnum = typeof GetPrescribedTherapyOptionsTherapyTypeEnum[keyof typeof GetPrescribedTherapyOptionsTherapyTypeEnum];
/**
 * @export
 */
export const GetTherapiesTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetTherapiesTherapyTypeEnum = typeof GetTherapiesTherapyTypeEnum[keyof typeof GetTherapiesTherapyTypeEnum];
/**
 * @export
 */
export const GetTherapiesAdminTherapyTypeEnum = {
    Physiotherapie: 'Physiotherapie',
    Ergotherapie: 'Ergotherapie'
} as const;
export type GetTherapiesAdminTherapyTypeEnum = typeof GetTherapiesAdminTherapyTypeEnum[keyof typeof GetTherapiesAdminTherapyTypeEnum];


/**
 * NoteApi - axios parameter creator
 * @export
 */
export const NoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllAppointmentNotes: async (appointmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('deleteAllAppointmentNotes', 'appointmentId', appointmentId)
            const localVarPath = `/note/deleteAll/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllPatientNotes: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deleteAllPatientNotes', 'patientId', patientId)
            const localVarPath = `/note/deleteAll/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllRxNotes: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('deleteAllRxNotes', 'rxId', rxId)
            const localVarPath = `/note/deleteAll/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNote', 'id', id)
            const localVarPath = `/note/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentNotes: async (appointmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentNotes', 'appointmentId', appointmentId)
            const localVarPath = `/note/getAppointmentNotes/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNote', 'id', id)
            const localVarPath = `/note/getNote/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesForAppointments: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getNotesForAppointments', 'requestBody', requestBody)
            const localVarPath = `/note/getNotesForAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notes for many patient IDs in a single request
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesForPatients: async (requestBody: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getNotesForPatients', 'requestBody', requestBody)
            const localVarPath = `/note/getNotesForPatients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notes for many Rx IDs in a single request
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesForRxs: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getNotesForRxs', 'requestBody', requestBody)
            const localVarPath = `/note/getNotesForRxs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientNotes: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientNotes', 'patientId', patientId)
            const localVarPath = `/note/getPatientNotes/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxNotes: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getRxNotes', 'rxId', rxId)
            const localVarPath = `/note/getRxNotes/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote: async (userId: string, createNoteDto: CreateNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postNote', 'userId', userId)
            // verify required parameter 'createNoteDto' is not null or undefined
            assertParamExists('postNote', 'createNoteDto', createNoteDto)
            const localVarPath = `/note/postNote/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNote: async (userId: string, createNoteDto: CreateNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('putNote', 'userId', userId)
            // verify required parameter 'createNoteDto' is not null or undefined
            assertParamExists('putNote', 'createNoteDto', createNoteDto)
            const localVarPath = `/note/updateNote/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string} userId 
         * @param {UpdateNoteDto} updateNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNote: async (id: string, userId: string, updateNoteDto: UpdateNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNote', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateNote', 'userId', userId)
            // verify required parameter 'updateNoteDto' is not null or undefined
            assertParamExists('updateNote', 'updateNoteDto', updateNoteDto)
            const localVarPath = `/note/updateNote/{id}/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NoteApi - functional programming interface
 * @export
 */
export const NoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllAppointmentNotes(appointmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllAppointmentNotes(appointmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllPatientNotes(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllPatientNotes(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllRxNotes(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllRxNotes(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNote(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNote(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentNotes(appointmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentNotes(appointmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNote(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNote(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotesForAppointments(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotesForAppointments(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get notes for many patient IDs in a single request
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotesForPatients(requestBody: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotesForPatients(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get notes for many Rx IDs in a single request
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotesForRxs(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotesForRxs(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientNotes(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientNotes(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxNotes(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxNotes(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNote(userId: string, createNoteDto: CreateNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNote(userId, createNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putNote(userId: string, createNoteDto: CreateNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putNote(userId, createNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string} userId 
         * @param {UpdateNoteDto} updateNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNote(id: string, userId: string, updateNoteDto: UpdateNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNote(id, userId, updateNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NoteApi - factory interface
 * @export
 */
export const NoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NoteApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllAppointmentNotes(appointmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAllAppointmentNotes(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllPatientNotes(patientId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAllPatientNotes(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllRxNotes(rxId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAllRxNotes(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteNote(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentNotes(appointmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getAppointmentNotes(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getNote(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesForAppointments(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getNotesForAppointments(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get notes for many patient IDs in a single request
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesForPatients(requestBody: Array<number>, options?: any): AxiosPromise<Array<NoteDto>> {
            return localVarFp.getNotesForPatients(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get notes for many Rx IDs in a single request
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesForRxs(requestBody: Array<string>, options?: any): AxiosPromise<Array<NoteDto>> {
            return localVarFp.getNotesForRxs(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientNotes(patientId: string, options?: any): AxiosPromise<Array<NoteDto>> {
            return localVarFp.getPatientNotes(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxNotes(rxId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getRxNotes(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(userId: string, createNoteDto: CreateNoteDto, options?: any): AxiosPromise<object> {
            return localVarFp.postNote(userId, createNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNote(userId: string, createNoteDto: CreateNoteDto, options?: any): AxiosPromise<void> {
            return localVarFp.putNote(userId, createNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string} userId 
         * @param {UpdateNoteDto} updateNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNote(id: string, userId: string, updateNoteDto: UpdateNoteDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateNote(id, userId, updateNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NoteApi - object-oriented interface
 * @export
 * @class NoteApi
 * @extends {BaseAPI}
 */
export class NoteApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public deleteAllAppointmentNotes(appointmentId: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).deleteAllAppointmentNotes(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public deleteAllPatientNotes(patientId: number, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).deleteAllPatientNotes(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public deleteAllRxNotes(rxId: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).deleteAllRxNotes(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public deleteNote(id: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).deleteNote(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getAppointmentNotes(appointmentId: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getAppointmentNotes(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getNote(id: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getNote(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getNotesForAppointments(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getNotesForAppointments(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get notes for many patient IDs in a single request
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getNotesForPatients(requestBody: Array<number>, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getNotesForPatients(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get notes for many Rx IDs in a single request
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getNotesForRxs(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getNotesForRxs(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getPatientNotes(patientId: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getPatientNotes(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public getRxNotes(rxId: string, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).getRxNotes(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {CreateNoteDto} createNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public postNote(userId: string, createNoteDto: CreateNoteDto, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).postNote(userId, createNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {CreateNoteDto} createNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public putNote(userId: string, createNoteDto: CreateNoteDto, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).putNote(userId, createNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {string} userId 
     * @param {UpdateNoteDto} updateNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public updateNote(id: string, userId: string, updateNoteDto: UpdateNoteDto, options?: AxiosRequestConfig) {
        return NoteApiFp(this.configuration).updateNote(id, userId, updateNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NoticeDefinitionApi - axios parameter creator
 * @export
 */
export const NoticeDefinitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForNewNoticeData: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('checkForNewNoticeData', 'patientId', patientId)
            const localVarPath = `/noticeDefinition/checkForNewNoticeData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateNoticeDefinitionDto} createNoticeDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoticeDefinition: async (createNoticeDefinitionDto: CreateNoticeDefinitionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNoticeDefinitionDto' is not null or undefined
            assertParamExists('createNoticeDefinition', 'createNoticeDefinitionDto', createNoticeDefinitionDto)
            const localVarPath = `/noticeDefinition/createNoticeDefinition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoticeDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateBaseNoticeDefinitionDataDto} createBaseNoticeDefinitionDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrivatePatientPriceNoticeTemplateData: async (createBaseNoticeDefinitionDataDto: CreateBaseNoticeDefinitionDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBaseNoticeDefinitionDataDto' is not null or undefined
            assertParamExists('createPrivatePatientPriceNoticeTemplateData', 'createBaseNoticeDefinitionDataDto', createBaseNoticeDefinitionDataDto)
            const localVarPath = `/noticeDefinition/createPrivatePatientPriceNoticeTemplateData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBaseNoticeDefinitionDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {RenderPatientNoticeTemplateDto} renderPatientNoticeTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderPatientNoticeTemplate: async (renderPatientNoticeTemplateDto: RenderPatientNoticeTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'renderPatientNoticeTemplateDto' is not null or undefined
            assertParamExists('renderPatientNoticeTemplate', 'renderPatientNoticeTemplateDto', renderPatientNoticeTemplateDto)
            const localVarPath = `/noticeDefinition/renderPatientNoticeTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renderPatientNoticeTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {ToggleNoticeDefinitionDataActiveStatusDto} toggleNoticeDefinitionDataActiveStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleNoticeDefinitionDataActiveStatus: async (toggleNoticeDefinitionDataActiveStatusDto: ToggleNoticeDefinitionDataActiveStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleNoticeDefinitionDataActiveStatusDto' is not null or undefined
            assertParamExists('toggleNoticeDefinitionDataActiveStatus', 'toggleNoticeDefinitionDataActiveStatusDto', toggleNoticeDefinitionDataActiveStatusDto)
            const localVarPath = `/noticeDefinition/toggleNoticeDefinitionDataActiveStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleNoticeDefinitionDataActiveStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NoticeDefinitionApi - functional programming interface
 * @export
 */
export const NoticeDefinitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NoticeDefinitionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkForNewNoticeData(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNoticeDefinitionDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkForNewNoticeData(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateNoticeDefinitionDto} createNoticeDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNoticeDefinition(createNoticeDefinitionDto: CreateNoticeDefinitionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotificationDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNoticeDefinition(createNoticeDefinitionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateBaseNoticeDefinitionDataDto} createBaseNoticeDefinitionDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrivatePatientPriceNoticeTemplateData(createBaseNoticeDefinitionDataDto: CreateBaseNoticeDefinitionDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNoticeDefinitionDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrivatePatientPriceNoticeTemplateData(createBaseNoticeDefinitionDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {RenderPatientNoticeTemplateDto} renderPatientNoticeTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renderPatientNoticeTemplate(renderPatientNoticeTemplateDto: RenderPatientNoticeTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renderPatientNoticeTemplate(renderPatientNoticeTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {ToggleNoticeDefinitionDataActiveStatusDto} toggleNoticeDefinitionDataActiveStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleNoticeDefinitionDataActiveStatus(toggleNoticeDefinitionDataActiveStatusDto: ToggleNoticeDefinitionDataActiveStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleNoticeDefinitionDataActiveStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleNoticeDefinitionDataActiveStatus(toggleNoticeDefinitionDataActiveStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NoticeDefinitionApi - factory interface
 * @export
 */
export const NoticeDefinitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NoticeDefinitionApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForNewNoticeData(patientId: number, options?: any): AxiosPromise<Array<GetNoticeDefinitionDataDto>> {
            return localVarFp.checkForNewNoticeData(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateNoticeDefinitionDto} createNoticeDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoticeDefinition(createNoticeDefinitionDto: CreateNoticeDefinitionDto, options?: any): AxiosPromise<GetNotificationDefinitionDto> {
            return localVarFp.createNoticeDefinition(createNoticeDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateBaseNoticeDefinitionDataDto} createBaseNoticeDefinitionDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrivatePatientPriceNoticeTemplateData(createBaseNoticeDefinitionDataDto: CreateBaseNoticeDefinitionDataDto, options?: any): AxiosPromise<GetNoticeDefinitionDataDto> {
            return localVarFp.createPrivatePatientPriceNoticeTemplateData(createBaseNoticeDefinitionDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {RenderPatientNoticeTemplateDto} renderPatientNoticeTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderPatientNoticeTemplate(renderPatientNoticeTemplateDto: RenderPatientNoticeTemplateDto, options?: any): AxiosPromise<File> {
            return localVarFp.renderPatientNoticeTemplate(renderPatientNoticeTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {ToggleNoticeDefinitionDataActiveStatusDto} toggleNoticeDefinitionDataActiveStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleNoticeDefinitionDataActiveStatus(toggleNoticeDefinitionDataActiveStatusDto: ToggleNoticeDefinitionDataActiveStatusDto, options?: any): AxiosPromise<ToggleNoticeDefinitionDataActiveStatusDto> {
            return localVarFp.toggleNoticeDefinitionDataActiveStatus(toggleNoticeDefinitionDataActiveStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NoticeDefinitionApi - object-oriented interface
 * @export
 * @class NoticeDefinitionApi
 * @extends {BaseAPI}
 */
export class NoticeDefinitionApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeDefinitionApi
     */
    public checkForNewNoticeData(patientId: number, options?: AxiosRequestConfig) {
        return NoticeDefinitionApiFp(this.configuration).checkForNewNoticeData(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateNoticeDefinitionDto} createNoticeDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeDefinitionApi
     */
    public createNoticeDefinition(createNoticeDefinitionDto: CreateNoticeDefinitionDto, options?: AxiosRequestConfig) {
        return NoticeDefinitionApiFp(this.configuration).createNoticeDefinition(createNoticeDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateBaseNoticeDefinitionDataDto} createBaseNoticeDefinitionDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeDefinitionApi
     */
    public createPrivatePatientPriceNoticeTemplateData(createBaseNoticeDefinitionDataDto: CreateBaseNoticeDefinitionDataDto, options?: AxiosRequestConfig) {
        return NoticeDefinitionApiFp(this.configuration).createPrivatePatientPriceNoticeTemplateData(createBaseNoticeDefinitionDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {RenderPatientNoticeTemplateDto} renderPatientNoticeTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeDefinitionApi
     */
    public renderPatientNoticeTemplate(renderPatientNoticeTemplateDto: RenderPatientNoticeTemplateDto, options?: AxiosRequestConfig) {
        return NoticeDefinitionApiFp(this.configuration).renderPatientNoticeTemplate(renderPatientNoticeTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {ToggleNoticeDefinitionDataActiveStatusDto} toggleNoticeDefinitionDataActiveStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeDefinitionApi
     */
    public toggleNoticeDefinitionDataActiveStatus(toggleNoticeDefinitionDataActiveStatusDto: ToggleNoticeDefinitionDataActiveStatusDto, options?: AxiosRequestConfig) {
        return NoticeDefinitionApiFp(this.configuration).toggleNoticeDefinitionDataActiveStatus(toggleNoticeDefinitionDataActiveStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientsApi - axios parameter creator
 * @export
 */
export const PatientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add/Remove patient to waitlist
         * @param {number} id 
         * @param {AddOrRemoveToWaitlistActionEnum} action Whether to add or remove the waitlist entry
         * @param {Array<WaitListEntryDto>} waitListEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveToWaitlist: async (id: number, action: AddOrRemoveToWaitlistActionEnum, waitListEntryDto: Array<WaitListEntryDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addOrRemoveToWaitlist', 'id', id)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('addOrRemoveToWaitlist', 'action', action)
            // verify required parameter 'waitListEntryDto' is not null or undefined
            assertParamExists('addOrRemoveToWaitlist', 'waitListEntryDto', waitListEntryDto)
            const localVarPath = `/patient/addOrRemoveToWaitlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waitListEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint removes a address of a patient from the database.
         * @summary Remove a address
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAddress', 'id', id)
            const localVarPath = `/patient/deleteAddress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatients: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/getAllPatients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedPatients: async (page: number, limit: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getArchivedPatients', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getArchivedPatients', 'limit', limit)
            const localVarPath = `/patient/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PatientTableFilters} patientTableFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAllPatients: async (patientTableFilters: PatientTableFilters, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientTableFilters' is not null or undefined
            assertParamExists('getFilteredAllPatients', 'patientTableFilters', patientTableFilters)
            const localVarPath = `/patient/getFilteredAllPatients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientTableFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {RxWriteDto} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveValidation: async (rxWriteDto: RxWriteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxWriteDto' is not null or undefined
            assertParamExists('getLiveValidation', 'rxWriteDto', rxWriteDto)
            const localVarPath = `/patient/getLiveValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxWriteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: async (id: number, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPatient', 'id', id)
            const localVarPath = `/patient/getPatient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientByRxId: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getPatientByRxId', 'rxId', rxId)
            const localVarPath = `/patient/getPatientByRxId/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRxSeriesData: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientRxSeriesData', 'patientId', patientId)
            const localVarPath = `/patient/patientRxSeriesData/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientWaitlistStats: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientWaitlistStats', 'patientId', patientId)
            const localVarPath = `/patient/patientWaitlistStats/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch full PatientDto records (addresses, payer, notes, tarifGroup, etc.) for multiple patient IDs in a single request. Max 100 IDs per request.
         * @summary Get multiple patients (full detail) by IDs
         * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsFullByIds: async (getPatientsByIdsDto: GetPatientsByIdsDto, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPatientsByIdsDto' is not null or undefined
            assertParamExists('getPatientsFullByIds', 'getPatientsByIdsDto', getPatientsByIdsDto)
            const localVarPath = `/patient/full-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPatientsByIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch minimal patient information (id, firstName, lastName, dob) for multiple patient IDs in a single request. Missing or invalid IDs are silently skipped. Max 100 IDs per request.
         * @summary Get multiple patients by IDs
         * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsMinimalByIds: async (getPatientsByIdsDto: GetPatientsByIdsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPatientsByIdsDto' is not null or undefined
            assertParamExists('getPatientsMinimalByIds', 'getPatientsByIdsDto', getPatientsByIdsDto)
            const localVarPath = `/patient/minimal-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPatientsByIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/rxStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {HardDeletePatientRequest} hardDeletePatientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeletePatient: async (id: number, hardDeletePatientRequest: HardDeletePatientRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hardDeletePatient', 'id', id)
            // verify required parameter 'hardDeletePatientRequest' is not null or undefined
            assertParamExists('hardDeletePatient', 'hardDeletePatientRequest', hardDeletePatientRequest)
            const localVarPath = `/patient/hardDelete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hardDeletePatientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PatientDto} patientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPatients: async (patientDto: PatientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDto' is not null or undefined
            assertParamExists('patchPatients', 'patientDto', patientDto)
            const localVarPath = `/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreatePatientDto} createPatientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPatients: async (createPatientDto: CreatePatientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPatientDto' is not null or undefined
            assertParamExists('postPatients', 'createPatientDto', createPatientDto)
            const localVarPath = `/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPatientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePatient: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restorePatient', 'id', id)
            const localVarPath = `/patient/restore/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search by patient name, patient ID, or prescription ID. Results prioritize the current location when provided.
         * @summary Unified search for patients and prescriptions
         * @param {string} [q] Free text. Supports patient name, patient ID, or prescription ID.
         * @param {string} [locationId] Current UI location identifier to prioritize results.
         * @param {string} [insuranceNo] Exact insurance number (Versichertennummer) to match.
         * @param {string} [dob] Date of birth (YYYY-MM-DD) to find patients born on this date.
         * @param {number} [limit] Max results to return (combined). Default 12.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q?: string, locationId?: string, insuranceNo?: string, dob?: string, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (insuranceNo !== undefined) {
                localVarQueryParameter['insuranceNo'] = insuranceNo;
            }

            if (dob !== undefined) {
                localVarQueryParameter['dob'] = dob;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeletePatient: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('softDeletePatient', 'id', id)
            const localVarPath = `/patient/softDelete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientsApi - functional programming interface
 * @export
 */
export const PatientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add/Remove patient to waitlist
         * @param {number} id 
         * @param {AddOrRemoveToWaitlistActionEnum} action Whether to add or remove the waitlist entry
         * @param {Array<WaitListEntryDto>} waitListEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrRemoveToWaitlist(id: number, action: AddOrRemoveToWaitlistActionEnum, waitListEntryDto: Array<WaitListEntryDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaitListEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrRemoveToWaitlist(id, action, waitListEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint removes a address of a patient from the database.
         * @summary Remove a address
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatients(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatients(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchivedPatients(page: number, limit: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchivedPatients(page, limit, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PatientTableFilters} patientTableFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredAllPatients(patientTableFilters: PatientTableFilters, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientTableDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredAllPatients(patientTableFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {RxWriteDto} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiveValidation(rxWriteDto: RxWriteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiveValidation(rxWriteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatient(id: number, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatient(id, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientByRxId(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientByRxId(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientRxSeriesData(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientRxSeriesData(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientWaitlistStats(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitListEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientWaitlistStats(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch full PatientDto records (addresses, payer, notes, tarifGroup, etc.) for multiple patient IDs in a single request. Max 100 IDs per request.
         * @summary Get multiple patients (full detail) by IDs
         * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientsFullByIds(getPatientsByIdsDto: GetPatientsByIdsDto, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientsFullByIds(getPatientsByIdsDto, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch minimal patient information (id, firstName, lastName, dob) for multiple patient IDs in a single request. Missing or invalid IDs are silently skipped. Max 100 IDs per request.
         * @summary Get multiple patients by IDs
         * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientsMinimalByIds(getPatientsByIdsDto: GetPatientsByIdsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientsMinimalByIds(getPatientsByIdsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {HardDeletePatientRequest} hardDeletePatientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDeletePatient(id: number, hardDeletePatientRequest: HardDeletePatientRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDeletePatient(id, hardDeletePatientRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PatientDto} patientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPatients(patientDto: PatientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPatientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPatients(patientDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreatePatientDto} createPatientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPatients(createPatientDto: CreatePatientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPatientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPatients(createPatientDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restorePatient(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restorePatient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search by patient name, patient ID, or prescription ID. Results prioritize the current location when provided.
         * @summary Unified search for patients and prescriptions
         * @param {string} [q] Free text. Supports patient name, patient ID, or prescription ID.
         * @param {string} [locationId] Current UI location identifier to prioritize results.
         * @param {string} [insuranceNo] Exact insurance number (Versichertennummer) to match.
         * @param {string} [dob] Date of birth (YYYY-MM-DD) to find patients born on this date.
         * @param {number} [limit] Max results to return (combined). Default 12.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q?: string, locationId?: string, insuranceNo?: string, dob?: string, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, locationId, insuranceNo, dob, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeletePatient(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeletePatient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PatientsApi - factory interface
 * @export
 */
export const PatientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add/Remove patient to waitlist
         * @param {number} id 
         * @param {AddOrRemoveToWaitlistActionEnum} action Whether to add or remove the waitlist entry
         * @param {Array<WaitListEntryDto>} waitListEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveToWaitlist(id: number, action: AddOrRemoveToWaitlistActionEnum, waitListEntryDto: Array<WaitListEntryDto>, options?: any): AxiosPromise<Array<WaitListEntryDto>> {
            return localVarFp.addOrRemoveToWaitlist(id, action, waitListEntryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint removes a address of a patient from the database.
         * @summary Remove a address
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(id: string, options?: any): AxiosPromise<AddressDto> {
            return localVarFp.deleteAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatients(options?: any): AxiosPromise<Array<PatientMinimalDto>> {
            return localVarFp.getAllPatients(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedPatients(page: number, limit: number, search?: string, options?: any): AxiosPromise<Array<PatientDto>> {
            return localVarFp.getArchivedPatients(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PatientTableFilters} patientTableFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAllPatients(patientTableFilters: PatientTableFilters, options?: any): AxiosPromise<Array<PatientTableDto>> {
            return localVarFp.getFilteredAllPatients(patientTableFilters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {RxWriteDto} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveValidation(rxWriteDto: RxWriteDto, options?: any): AxiosPromise<object> {
            return localVarFp.getLiveValidation(rxWriteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient(id: number, locationId?: string, options?: any): AxiosPromise<PatientDto> {
            return localVarFp.getPatient(id, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientByRxId(rxId: string, options?: any): AxiosPromise<PatientDto> {
            return localVarFp.getPatientByRxId(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRxSeriesData(patientId: number, options?: any): AxiosPromise<object> {
            return localVarFp.getPatientRxSeriesData(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientWaitlistStats(patientId: number, options?: any): AxiosPromise<WaitListEntryDto> {
            return localVarFp.getPatientWaitlistStats(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch full PatientDto records (addresses, payer, notes, tarifGroup, etc.) for multiple patient IDs in a single request. Max 100 IDs per request.
         * @summary Get multiple patients (full detail) by IDs
         * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsFullByIds(getPatientsByIdsDto: GetPatientsByIdsDto, locationId?: string, options?: any): AxiosPromise<Array<PatientDto>> {
            return localVarFp.getPatientsFullByIds(getPatientsByIdsDto, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch minimal patient information (id, firstName, lastName, dob) for multiple patient IDs in a single request. Missing or invalid IDs are silently skipped. Max 100 IDs per request.
         * @summary Get multiple patients by IDs
         * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsMinimalByIds(getPatientsByIdsDto: GetPatientsByIdsDto, options?: any): AxiosPromise<Array<PatientMinimalDto>> {
            return localVarFp.getPatientsMinimalByIds(getPatientsByIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxStats(options?: any): AxiosPromise<object> {
            return localVarFp.getRxStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(options?: any): AxiosPromise<object> {
            return localVarFp.getStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {HardDeletePatientRequest} hardDeletePatientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeletePatient(id: number, hardDeletePatientRequest: HardDeletePatientRequest, options?: any): AxiosPromise<object> {
            return localVarFp.hardDeletePatient(id, hardDeletePatientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PatientDto} patientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPatients(patientDto: PatientDto, options?: any): AxiosPromise<PostPatientResponse> {
            return localVarFp.patchPatients(patientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreatePatientDto} createPatientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPatients(createPatientDto: CreatePatientDto, options?: any): AxiosPromise<PostPatientResponse> {
            return localVarFp.postPatients(createPatientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePatient(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.restorePatient(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search by patient name, patient ID, or prescription ID. Results prioritize the current location when provided.
         * @summary Unified search for patients and prescriptions
         * @param {string} [q] Free text. Supports patient name, patient ID, or prescription ID.
         * @param {string} [locationId] Current UI location identifier to prioritize results.
         * @param {string} [insuranceNo] Exact insurance number (Versichertennummer) to match.
         * @param {string} [dob] Date of birth (YYYY-MM-DD) to find patients born on this date.
         * @param {number} [limit] Max results to return (combined). Default 12.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q?: string, locationId?: string, insuranceNo?: string, dob?: string, limit?: number, options?: any): AxiosPromise<SearchResponseDto> {
            return localVarFp.search(q, locationId, insuranceNo, dob, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeletePatient(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.softDeletePatient(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientsApi - object-oriented interface
 * @export
 * @class PatientsApi
 * @extends {BaseAPI}
 */
export class PatientsApi extends BaseAPI {
    /**
     * 
     * @summary Add/Remove patient to waitlist
     * @param {number} id 
     * @param {AddOrRemoveToWaitlistActionEnum} action Whether to add or remove the waitlist entry
     * @param {Array<WaitListEntryDto>} waitListEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public addOrRemoveToWaitlist(id: number, action: AddOrRemoveToWaitlistActionEnum, waitListEntryDto: Array<WaitListEntryDto>, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).addOrRemoveToWaitlist(id, action, waitListEntryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint removes a address of a patient from the database.
     * @summary Remove a address
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public deleteAddress(id: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deleteAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getAllPatients(options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getAllPatients(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} page 
     * @param {number} limit 
     * @param {string} [search] Search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getArchivedPatients(page: number, limit: number, search?: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getArchivedPatients(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PatientTableFilters} patientTableFilters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getFilteredAllPatients(patientTableFilters: PatientTableFilters, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getFilteredAllPatients(patientTableFilters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {RxWriteDto} rxWriteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getLiveValidation(rxWriteDto: RxWriteDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getLiveValidation(rxWriteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {string} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getPatient(id: number, locationId?: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatient(id, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getPatientByRxId(rxId: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientByRxId(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getPatientRxSeriesData(patientId: number, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientRxSeriesData(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getPatientWaitlistStats(patientId: number, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientWaitlistStats(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch full PatientDto records (addresses, payer, notes, tarifGroup, etc.) for multiple patient IDs in a single request. Max 100 IDs per request.
     * @summary Get multiple patients (full detail) by IDs
     * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
     * @param {string} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getPatientsFullByIds(getPatientsByIdsDto: GetPatientsByIdsDto, locationId?: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientsFullByIds(getPatientsByIdsDto, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch minimal patient information (id, firstName, lastName, dob) for multiple patient IDs in a single request. Missing or invalid IDs are silently skipped. Max 100 IDs per request.
     * @summary Get multiple patients by IDs
     * @param {GetPatientsByIdsDto} getPatientsByIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getPatientsMinimalByIds(getPatientsByIdsDto: GetPatientsByIdsDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientsMinimalByIds(getPatientsByIdsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getRxStats(options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getRxStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public getStats(options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {HardDeletePatientRequest} hardDeletePatientRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public hardDeletePatient(id: number, hardDeletePatientRequest: HardDeletePatientRequest, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).hardDeletePatient(id, hardDeletePatientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PatientDto} patientDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patchPatients(patientDto: PatientDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patchPatients(patientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreatePatientDto} createPatientDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public postPatients(createPatientDto: CreatePatientDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).postPatients(createPatientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public restorePatient(id: number, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).restorePatient(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search by patient name, patient ID, or prescription ID. Results prioritize the current location when provided.
     * @summary Unified search for patients and prescriptions
     * @param {string} [q] Free text. Supports patient name, patient ID, or prescription ID.
     * @param {string} [locationId] Current UI location identifier to prioritize results.
     * @param {string} [insuranceNo] Exact insurance number (Versichertennummer) to match.
     * @param {string} [dob] Date of birth (YYYY-MM-DD) to find patients born on this date.
     * @param {number} [limit] Max results to return (combined). Default 12.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public search(q?: string, locationId?: string, insuranceNo?: string, dob?: string, limit?: number, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).search(q, locationId, insuranceNo, dob, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public softDeletePatient(id: number, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).softDeletePatient(id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AddOrRemoveToWaitlistActionEnum = {
    Add: 'add',
    Remove: 'remove'
} as const;
export type AddOrRemoveToWaitlistActionEnum = typeof AddOrRemoveToWaitlistActionEnum[keyof typeof AddOrRemoveToWaitlistActionEnum];


/**
 * PublicHolidayApi - axios parameter creator
 * @export
 */
export const PublicHolidayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {CreatePublicHolidayDto} createPublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublicHoliday: async (createPublicHolidayDto: CreatePublicHolidayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPublicHolidayDto' is not null or undefined
            assertParamExists('createPublicHoliday', 'createPublicHolidayDto', createPublicHolidayDto)
            const localVarPath = `/public-holiday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPublicHolidayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<CreatePublicHolidayDto>} createPublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublicHolidaysBulk: async (createPublicHolidayDto: Array<CreatePublicHolidayDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPublicHolidayDto' is not null or undefined
            assertParamExists('createPublicHolidaysBulk', 'createPublicHolidayDto', createPublicHolidayDto)
            const localVarPath = `/public-holiday/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPublicHolidayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublicHoliday: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePublicHoliday', 'id', id)
            const localVarPath = `/public-holiday/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} year 
         * @param {string} [bundesland] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublicHolidaysByYear: async (year: number, bundesland?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('deletePublicHolidaysByYear', 'year', year)
            const localVarPath = `/public-holiday/year/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bundesland !== undefined) {
                localVarQueryParameter['bundesland'] = bundesland;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicHoliday: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPublicHoliday', 'id', id)
            const localVarPath = `/public-holiday/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} [year] 
         * @param {string} [bundesland] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicHolidays: async (year?: number, bundesland?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public-holiday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (bundesland !== undefined) {
                localVarQueryParameter['bundesland'] = bundesland;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {UpdatePublicHolidayDto} updatePublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicHoliday: async (id: number, updatePublicHolidayDto: UpdatePublicHolidayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePublicHoliday', 'id', id)
            // verify required parameter 'updatePublicHolidayDto' is not null or undefined
            assertParamExists('updatePublicHoliday', 'updatePublicHolidayDto', updatePublicHolidayDto)
            const localVarPath = `/public-holiday/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePublicHolidayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicHolidayApi - functional programming interface
 * @export
 */
export const PublicHolidayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicHolidayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreatePublicHolidayDto} createPublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPublicHoliday(createPublicHolidayDto: CreatePublicHolidayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPublicHoliday(createPublicHolidayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<CreatePublicHolidayDto>} createPublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPublicHolidaysBulk(createPublicHolidayDto: Array<CreatePublicHolidayDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPublicHolidaysBulk(createPublicHolidayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePublicHoliday(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePublicHoliday(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} year 
         * @param {string} [bundesland] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePublicHolidaysByYear(year: number, bundesland?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePublicHolidaysByYear(year, bundesland, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicHoliday(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicHoliday(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} [year] 
         * @param {string} [bundesland] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicHolidays(year?: number, bundesland?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicHolidays(year, bundesland, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {UpdatePublicHolidayDto} updatePublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePublicHoliday(id: number, updatePublicHolidayDto: UpdatePublicHolidayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePublicHoliday(id, updatePublicHolidayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicHolidayApi - factory interface
 * @export
 */
export const PublicHolidayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicHolidayApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreatePublicHolidayDto} createPublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublicHoliday(createPublicHolidayDto: CreatePublicHolidayDto, options?: any): AxiosPromise<Array<PublicHolidayDto>> {
            return localVarFp.createPublicHoliday(createPublicHolidayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<CreatePublicHolidayDto>} createPublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublicHolidaysBulk(createPublicHolidayDto: Array<CreatePublicHolidayDto>, options?: any): AxiosPromise<Array<PublicHolidayDto>> {
            return localVarFp.createPublicHolidaysBulk(createPublicHolidayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublicHoliday(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePublicHoliday(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} year 
         * @param {string} [bundesland] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublicHolidaysByYear(year: number, bundesland?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePublicHolidaysByYear(year, bundesland, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicHoliday(id: number, options?: any): AxiosPromise<PublicHolidayDto> {
            return localVarFp.getPublicHoliday(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} [year] 
         * @param {string} [bundesland] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicHolidays(year?: number, bundesland?: string, options?: any): AxiosPromise<Array<PublicHolidayDto>> {
            return localVarFp.getPublicHolidays(year, bundesland, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {UpdatePublicHolidayDto} updatePublicHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicHoliday(id: number, updatePublicHolidayDto: UpdatePublicHolidayDto, options?: any): AxiosPromise<PublicHolidayDto> {
            return localVarFp.updatePublicHoliday(id, updatePublicHolidayDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicHolidayApi - object-oriented interface
 * @export
 * @class PublicHolidayApi
 * @extends {BaseAPI}
 */
export class PublicHolidayApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {CreatePublicHolidayDto} createPublicHolidayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public createPublicHoliday(createPublicHolidayDto: CreatePublicHolidayDto, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).createPublicHoliday(createPublicHolidayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<CreatePublicHolidayDto>} createPublicHolidayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public createPublicHolidaysBulk(createPublicHolidayDto: Array<CreatePublicHolidayDto>, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).createPublicHolidaysBulk(createPublicHolidayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public deletePublicHoliday(id: number, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).deletePublicHoliday(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} year 
     * @param {string} [bundesland] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public deletePublicHolidaysByYear(year: number, bundesland?: string, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).deletePublicHolidaysByYear(year, bundesland, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public getPublicHoliday(id: number, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).getPublicHoliday(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} [year] 
     * @param {string} [bundesland] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public getPublicHolidays(year?: number, bundesland?: string, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).getPublicHolidays(year, bundesland, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {UpdatePublicHolidayDto} updatePublicHolidayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidayApi
     */
    public updatePublicHoliday(id: number, updatePublicHolidayDto: UpdatePublicHolidayDto, options?: AxiosRequestConfig) {
        return PublicHolidayApiFp(this.configuration).updatePublicHoliday(id, updatePublicHolidayDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RxApi - axios parameter creator
 * @export
 */
export const RxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {RxSeriesDto} rxSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewSeriesToPatient: async (patientId: number, rxSeriesDto: RxSeriesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('addNewSeriesToPatient', 'patientId', patientId)
            // verify required parameter 'rxSeriesDto' is not null or undefined
            assertParamExists('addNewSeriesToPatient', 'rxSeriesDto', rxSeriesDto)
            const localVarPath = `/rx/addSeriesForPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pre-flight check: whether an Rx may be (soft-)deleted
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRxDeletable: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('checkRxDeletable', 'rxId', rxId)
            const localVarPath = `/rx/checkDeletable/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyToContinuous: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('copyToContinuous', 'rxId', rxId)
            const localVarPath = `/rx/copyToContinuous/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete an Rx
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('deleteRx', 'rxId', rxId)
            const localVarPath = `/rx/deleteRx/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeries: async (seriesId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('deleteSeries', 'seriesId', seriesId)
            const localVarPath = `/rx/deleteSeries/{seriesId}`
                .replace(`{${"seriesId"}}`, encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated: Use GetRxsForPatient instead
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllRx: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAllRx', 'patientId', patientId)
            const localVarPath = `/rx/getAll/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Rx IDs (optionally only active) for a patient
         * @param {number} patientId 
         * @param {boolean} activeOnly If true, return only active prescriptions (exclude \&#39;abgeschlossen\&#39; &amp; \&#39;abgebrochen\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRxIds: async (patientId: number, activeOnly: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAllRxIds', 'patientId', patientId)
            // verify required parameter 'activeOnly' is not null or undefined
            assertParamExists('getAllRxIds', 'activeOnly', activeOnly)
            const localVarPath = `/rx/getAllIds/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} requestBody Array of Rx IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStats: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getAppStats', 'requestBody', requestBody)
            const localVarPath = `/rx/appstats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {RxTableFilters} rxTableFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAllRxs: async (rxTableFilters: RxTableFilters, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxTableFilters' is not null or undefined
            assertParamExists('getFilteredAllRxs', 'rxTableFilters', rxTableFilters)
            const localVarPath = `/rx/getFilteredAllRxs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxTableFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRx: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRx', 'id', id)
            const localVarPath = `/rx/getRx/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxByNumber: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRxByNumber', 'id', id)
            const localVarPath = `/rx/getRxByNumber/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxDebitById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRxDebitById', 'id', id)
            const localVarPath = `/rx/getRxDebit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxLackingAppointments: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getRxLackingAppointments', 'patientId', patientId)
            const localVarPath = `/rx/lackingAppointments/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxLight: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRxLight', 'id', id)
            const localVarPath = `/rx/getRxLight/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxPriceById: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getRxPriceById', 'rxId', rxId)
            const localVarPath = `/rx/getRxPrice/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query builder: find Rxs by multiple criteria
         * @param {RxSelectionFiltersDto} rxSelectionFiltersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxSelection: async (rxSelectionFiltersDto: RxSelectionFiltersDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxSelectionFiltersDto' is not null or undefined
            assertParamExists('getRxSelection', 'rxSelectionFiltersDto', rxSelectionFiltersDto)
            const localVarPath = `/rx/selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxSelectionFiltersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxSeriesForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getRxSeriesForPatient', 'patientId', patientId)
            const localVarPath = `/rx/series/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxSeriesForSeriesId: async (seriesId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('getRxSeriesForSeriesId', 'seriesId', seriesId)
            const localVarPath = `/rx/individualSeries/{seriesId}`
                .replace(`{${"seriesId"}}`, encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxWithValidations: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRxWithValidations', 'id', id)
            const localVarPath = `/rx/getRxWithValidations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch full RxDto records for multiple Rx IDs in a single request. Max 200 IDs per request.
         * @summary Get multiple Rxs (full detail) by IDs
         * @param {GetRxsByIdsDto} getRxsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxsByIds: async (getRxsByIdsDto: GetRxsByIdsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getRxsByIdsDto' is not null or undefined
            assertParamExists('getRxsByIds', 'getRxsByIdsDto', getRxsByIdsDto)
            const localVarPath = `/rx/getRxsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getRxsByIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Rxs for a patient as light dtos
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getRxsForPatient', 'patientId', patientId)
            const localVarPath = `/rx/forPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generic data feed for the dynamic template widget (selectable Rxs + default selection)
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateWidgetData: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getTemplateWidgetData', 'patientId', patientId)
            const localVarPath = `/rx/templateWidgetData/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyRxsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getTherapyRxsForPatient', 'patientId', patientId)
            const localVarPath = `/rx/therapyRxs/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyRxsSeriesForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getTherapyRxsSeriesForPatient', 'patientId', patientId)
            const localVarPath = `/rx/therapyRxsSeries/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<RxWriteDto>} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSaveRxs: async (patientId: number, rxWriteDto: Array<RxWriteDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('patientSaveRxs', 'patientId', patientId)
            // verify required parameter 'rxWriteDto' is not null or undefined
            assertParamExists('patientSaveRxs', 'rxWriteDto', rxWriteDto)
            const localVarPath = `/rx/patientSaveRxs/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxWriteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start an on-demand bulk Rx validation (Rezeptprüfung) run. Streams invalid Rxs via the workflow websocket.
         * @param {RunRxValidationBulkDto} runRxValidationBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runRxValidationBulk: async (runRxValidationBulkDto: RunRxValidationBulkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runRxValidationBulkDto' is not null or undefined
            assertParamExists('runRxValidationBulk', 'runRxValidationBulkDto', runRxValidationBulkDto)
            const localVarPath = `/rx/rxValidationBulk/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runRxValidationBulkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all therapy certifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rxControllerGetAllTherapyCertifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rx/therapy-certifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {RxWriteDto} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRx: async (rxWriteDto: RxWriteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxWriteDto' is not null or undefined
            assertParamExists('saveRx', 'rxWriteDto', rxWriteDto)
            const localVarPath = `/rx/saveRx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxWriteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIsTaxieren: async (id: string, status: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIsTaxieren', 'id', id)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateIsTaxieren', 'status', status)
            const localVarPath = `/rx/taxieren/{id}/{status}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {string} processingStatus 
         * @param {Array<string>} requestBody Array of appointment IDs to update (optional)
         * @param {boolean} [removeUnscheduled] If true, removes unscheduled appointments before setting FINISHED status (used after swap)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessingStatus: async (rxId: string, processingStatus: string, requestBody: Array<string>, removeUnscheduled?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('updateProcessingStatus', 'rxId', rxId)
            // verify required parameter 'processingStatus' is not null or undefined
            assertParamExists('updateProcessingStatus', 'processingStatus', processingStatus)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateProcessingStatus', 'requestBody', requestBody)
            const localVarPath = `/rx/updateProcessingStatus/{rxId}/{processingStatus}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)))
                .replace(`{${"processingStatus"}}`, encodeURIComponent(String(processingStatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (removeUnscheduled !== undefined) {
                localVarQueryParameter['removeUnscheduled'] = removeUnscheduled;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {number} patientId 
         * @param {RxSeriesDto} rxSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeries: async (seriesId: string, patientId: number, rxSeriesDto: RxSeriesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('updateSeries', 'seriesId', seriesId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updateSeries', 'patientId', patientId)
            // verify required parameter 'rxSeriesDto' is not null or undefined
            assertParamExists('updateSeries', 'rxSeriesDto', rxSeriesDto)
            const localVarPath = `/rx/updateSeries/forPatient/{patientId}/{seriesId}`
                .replace(`{${"seriesId"}}`, encodeURIComponent(String(seriesId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rxSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {string} newSeriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesForTherapyRx: async (therapyRxId: string, newSeriesId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapyRxId' is not null or undefined
            assertParamExists('updateSeriesForTherapyRx', 'therapyRxId', therapyRxId)
            // verify required parameter 'newSeriesId' is not null or undefined
            assertParamExists('updateSeriesForTherapyRx', 'newSeriesId', newSeriesId)
            const localVarPath = `/rx/updateSeriesId/forTherapyRx/{therapyRxId}/{newSeriesId}`
                .replace(`{${"therapyRxId"}}`, encodeURIComponent(String(therapyRxId)))
                .replace(`{${"newSeriesId"}}`, encodeURIComponent(String(newSeriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RxApi - functional programming interface
 * @export
 */
export const RxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RxApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {RxSeriesDto} rxSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewSeriesToPatient(patientId: number, rxSeriesDto: RxSeriesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewSeriesToPatient(patientId, rxSeriesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Pre-flight check: whether an Rx may be (soft-)deleted
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRxDeletable(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxDeletionCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRxDeletable(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyToContinuous(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyToContinuous(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete an Rx
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxDeletionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSeries(seriesId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSeries(seriesId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deprecated: Use GetRxsForPatient instead
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAllRx(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRx(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Rx IDs (optionally only active) for a patient
         * @param {number} patientId 
         * @param {boolean} activeOnly If true, return only active prescriptions (exclude \&#39;abgeschlossen\&#39; &amp; \&#39;abgebrochen\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRxIds(patientId: number, activeOnly: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxIdDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRxIds(patientId, activeOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} requestBody Array of Rx IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppStats(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppStatsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppStats(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {RxTableFilters} rxTableFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredAllRxs(rxTableFilters: RxTableFilters, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxTableDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredAllRxs(rxTableFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRx(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRx(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxByNumber(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxByNumber(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxDebitById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxDebitById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxLackingAppointments(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxLackingAppointments(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxLight(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxLightDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxLight(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxPriceById(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateRxDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxPriceById(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query builder: find Rxs by multiple criteria
         * @param {RxSelectionFiltersDto} rxSelectionFiltersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxSelection(rxSelectionFiltersDto: RxSelectionFiltersDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxSelectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxSelection(rxSelectionFiltersDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxSeriesForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxSeriesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxSeriesForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxSeriesForSeriesId(seriesId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxSeriesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxSeriesForSeriesId(seriesId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxWithValidations(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxWithValidations(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch full RxDto records for multiple Rx IDs in a single request. Max 200 IDs per request.
         * @summary Get multiple Rxs (full detail) by IDs
         * @param {GetRxsByIdsDto} getRxsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxsByIds(getRxsByIdsDto: GetRxsByIdsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxsByIds(getRxsByIdsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Rxs for a patient as light dtos
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxLightDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generic data feed for the dynamic template widget (selectable Rxs + default selection)
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateWidgetData(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateWidgetDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateWidgetData(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyRxsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyRxsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapyRxsSeriesForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapyRxsSeriesForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<RxWriteDto>} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientSaveRxs(patientId: number, rxWriteDto: Array<RxWriteDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaveRxResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientSaveRxs(patientId, rxWriteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start an on-demand bulk Rx validation (Rezeptprüfung) run. Streams invalid Rxs via the workflow websocket.
         * @param {RunRxValidationBulkDto} runRxValidationBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runRxValidationBulk(runRxValidationBulkDto: RunRxValidationBulkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedWorkflowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runRxValidationBulk(runRxValidationBulkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all therapy certifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rxControllerGetAllTherapyCertifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rxControllerGetAllTherapyCertifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {RxWriteDto} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRx(rxWriteDto: RxWriteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRx(rxWriteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIsTaxieren(id: string, status: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIsTaxieren(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {string} processingStatus 
         * @param {Array<string>} requestBody Array of appointment IDs to update (optional)
         * @param {boolean} [removeUnscheduled] If true, removes unscheduled appointments before setting FINISHED status (used after swap)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessingStatus(rxId: string, processingStatus: string, requestBody: Array<string>, removeUnscheduled?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProcessingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessingStatus(rxId, processingStatus, requestBody, removeUnscheduled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {number} patientId 
         * @param {RxSeriesDto} rxSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeries(seriesId: string, patientId: number, rxSeriesDto: RxSeriesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSeries(seriesId, patientId, rxSeriesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {string} newSeriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeriesForTherapyRx(therapyRxId: string, newSeriesId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSeriesForTherapyRx(therapyRxId, newSeriesId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RxApi - factory interface
 * @export
 */
export const RxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RxApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {RxSeriesDto} rxSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewSeriesToPatient(patientId: number, rxSeriesDto: RxSeriesDto, options?: any): AxiosPromise<void> {
            return localVarFp.addNewSeriesToPatient(patientId, rxSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pre-flight check: whether an Rx may be (soft-)deleted
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRxDeletable(rxId: string, options?: any): AxiosPromise<RxDeletionCheckDto> {
            return localVarFp.checkRxDeletable(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyToContinuous(rxId: string, options?: any): AxiosPromise<void> {
            return localVarFp.copyToContinuous(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete an Rx
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRx(rxId: string, options?: any): AxiosPromise<RxDeletionResultDto> {
            return localVarFp.deleteRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeries(seriesId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSeries(seriesId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated: Use GetRxsForPatient instead
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllRx(patientId: number, options?: any): AxiosPromise<Array<RxDto>> {
            return localVarFp.getAllRx(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Rx IDs (optionally only active) for a patient
         * @param {number} patientId 
         * @param {boolean} activeOnly If true, return only active prescriptions (exclude \&#39;abgeschlossen\&#39; &amp; \&#39;abgebrochen\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRxIds(patientId: number, activeOnly: boolean, options?: any): AxiosPromise<Array<RxIdDto>> {
            return localVarFp.getAllRxIds(patientId, activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} requestBody Array of Rx IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStats(requestBody: Array<string>, options?: any): AxiosPromise<Array<AppStatsDto>> {
            return localVarFp.getAppStats(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {RxTableFilters} rxTableFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAllRxs(rxTableFilters: RxTableFilters, options?: any): AxiosPromise<Array<RxTableDto>> {
            return localVarFp.getFilteredAllRxs(rxTableFilters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRx(id: string, options?: any): AxiosPromise<RxDto> {
            return localVarFp.getRx(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxByNumber(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.getRxByNumber(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxDebitById(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.getRxDebitById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxLackingAppointments(patientId: number, options?: any): AxiosPromise<Array<RxDto>> {
            return localVarFp.getRxLackingAppointments(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxLight(id: string, options?: any): AxiosPromise<RxLightDto> {
            return localVarFp.getRxLight(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxPriceById(rxId: string, options?: any): AxiosPromise<CalculateRxDTO> {
            return localVarFp.getRxPriceById(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query builder: find Rxs by multiple criteria
         * @param {RxSelectionFiltersDto} rxSelectionFiltersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxSelection(rxSelectionFiltersDto: RxSelectionFiltersDto, options?: any): AxiosPromise<RxSelectionResponseDto> {
            return localVarFp.getRxSelection(rxSelectionFiltersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxSeriesForPatient(patientId: number, options?: any): AxiosPromise<Array<RxSeriesDto>> {
            return localVarFp.getRxSeriesForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxSeriesForSeriesId(seriesId: string, options?: any): AxiosPromise<RxSeriesDto> {
            return localVarFp.getRxSeriesForSeriesId(seriesId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxWithValidations(id: string, options?: any): AxiosPromise<RxDto> {
            return localVarFp.getRxWithValidations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch full RxDto records for multiple Rx IDs in a single request. Max 200 IDs per request.
         * @summary Get multiple Rxs (full detail) by IDs
         * @param {GetRxsByIdsDto} getRxsByIdsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxsByIds(getRxsByIdsDto: GetRxsByIdsDto, options?: any): AxiosPromise<Array<RxDto>> {
            return localVarFp.getRxsByIds(getRxsByIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Rxs for a patient as light dtos
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxsForPatient(patientId: number, options?: any): AxiosPromise<Array<RxLightDto>> {
            return localVarFp.getRxsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generic data feed for the dynamic template widget (selectable Rxs + default selection)
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateWidgetData(patientId: number, options?: any): AxiosPromise<TemplateWidgetDataDto> {
            return localVarFp.getTemplateWidgetData(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyRxsForPatient(patientId: number, options?: any): AxiosPromise<void> {
            return localVarFp.getTherapyRxsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapyRxsSeriesForPatient(patientId: number, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getTherapyRxsSeriesForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {Array<RxWriteDto>} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSaveRxs(patientId: number, rxWriteDto: Array<RxWriteDto>, options?: any): AxiosPromise<Array<SaveRxResponse>> {
            return localVarFp.patientSaveRxs(patientId, rxWriteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start an on-demand bulk Rx validation (Rezeptprüfung) run. Streams invalid Rxs via the workflow websocket.
         * @param {RunRxValidationBulkDto} runRxValidationBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runRxValidationBulk(runRxValidationBulkDto: RunRxValidationBulkDto, options?: any): AxiosPromise<GeneratedWorkflowDto> {
            return localVarFp.runRxValidationBulk(runRxValidationBulkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all therapy certifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rxControllerGetAllTherapyCertifications(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.rxControllerGetAllTherapyCertifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {RxWriteDto} rxWriteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRx(rxWriteDto: RxWriteDto, options?: any): AxiosPromise<void> {
            return localVarFp.saveRx(rxWriteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIsTaxieren(id: string, status: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateIsTaxieren(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId 
         * @param {string} processingStatus 
         * @param {Array<string>} requestBody Array of appointment IDs to update (optional)
         * @param {boolean} [removeUnscheduled] If true, removes unscheduled appointments before setting FINISHED status (used after swap)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessingStatus(rxId: string, processingStatus: string, requestBody: Array<string>, removeUnscheduled?: boolean, options?: any): AxiosPromise<UpdateProcessingStatusResponse> {
            return localVarFp.updateProcessingStatus(rxId, processingStatus, requestBody, removeUnscheduled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} seriesId 
         * @param {number} patientId 
         * @param {RxSeriesDto} rxSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeries(seriesId: string, patientId: number, rxSeriesDto: RxSeriesDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateSeries(seriesId, patientId, rxSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} therapyRxId 
         * @param {string} newSeriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesForTherapyRx(therapyRxId: string, newSeriesId: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateSeriesForTherapyRx(therapyRxId, newSeriesId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RxApi - object-oriented interface
 * @export
 * @class RxApi
 * @extends {BaseAPI}
 */
export class RxApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {RxSeriesDto} rxSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public addNewSeriesToPatient(patientId: number, rxSeriesDto: RxSeriesDto, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).addNewSeriesToPatient(patientId, rxSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pre-flight check: whether an Rx may be (soft-)deleted
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public checkRxDeletable(rxId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).checkRxDeletable(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public copyToContinuous(rxId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).copyToContinuous(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete an Rx
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public deleteRx(rxId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).deleteRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} seriesId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public deleteSeries(seriesId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).deleteSeries(seriesId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated: Use GetRxsForPatient instead
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getAllRx(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getAllRx(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Rx IDs (optionally only active) for a patient
     * @param {number} patientId 
     * @param {boolean} activeOnly If true, return only active prescriptions (exclude \&#39;abgeschlossen\&#39; &amp; \&#39;abgebrochen\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getAllRxIds(patientId: number, activeOnly: boolean, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getAllRxIds(patientId, activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<string>} requestBody Array of Rx IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getAppStats(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getAppStats(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {RxTableFilters} rxTableFilters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getFilteredAllRxs(rxTableFilters: RxTableFilters, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getFilteredAllRxs(rxTableFilters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRx(id: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRx(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxByNumber(id: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxByNumber(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxDebitById(id: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxDebitById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxLackingAppointments(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxLackingAppointments(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxLight(id: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxLight(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxPriceById(rxId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxPriceById(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query builder: find Rxs by multiple criteria
     * @param {RxSelectionFiltersDto} rxSelectionFiltersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxSelection(rxSelectionFiltersDto: RxSelectionFiltersDto, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxSelection(rxSelectionFiltersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxSeriesForPatient(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxSeriesForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} seriesId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxSeriesForSeriesId(seriesId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxSeriesForSeriesId(seriesId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxWithValidations(id: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxWithValidations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch full RxDto records for multiple Rx IDs in a single request. Max 200 IDs per request.
     * @summary Get multiple Rxs (full detail) by IDs
     * @param {GetRxsByIdsDto} getRxsByIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxsByIds(getRxsByIdsDto: GetRxsByIdsDto, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxsByIds(getRxsByIdsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Rxs for a patient as light dtos
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getRxsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getRxsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generic data feed for the dynamic template widget (selectable Rxs + default selection)
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getTemplateWidgetData(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getTemplateWidgetData(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getTherapyRxsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getTherapyRxsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public getTherapyRxsSeriesForPatient(patientId: number, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).getTherapyRxsSeriesForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {Array<RxWriteDto>} rxWriteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public patientSaveRxs(patientId: number, rxWriteDto: Array<RxWriteDto>, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).patientSaveRxs(patientId, rxWriteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start an on-demand bulk Rx validation (Rezeptprüfung) run. Streams invalid Rxs via the workflow websocket.
     * @param {RunRxValidationBulkDto} runRxValidationBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public runRxValidationBulk(runRxValidationBulkDto: RunRxValidationBulkDto, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).runRxValidationBulk(runRxValidationBulkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all therapy certifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public rxControllerGetAllTherapyCertifications(options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).rxControllerGetAllTherapyCertifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {RxWriteDto} rxWriteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public saveRx(rxWriteDto: RxWriteDto, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).saveRx(rxWriteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {string} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public updateIsTaxieren(id: string, status: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).updateIsTaxieren(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId 
     * @param {string} processingStatus 
     * @param {Array<string>} requestBody Array of appointment IDs to update (optional)
     * @param {boolean} [removeUnscheduled] If true, removes unscheduled appointments before setting FINISHED status (used after swap)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public updateProcessingStatus(rxId: string, processingStatus: string, requestBody: Array<string>, removeUnscheduled?: boolean, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).updateProcessingStatus(rxId, processingStatus, requestBody, removeUnscheduled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} seriesId 
     * @param {number} patientId 
     * @param {RxSeriesDto} rxSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public updateSeries(seriesId: string, patientId: number, rxSeriesDto: RxSeriesDto, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).updateSeries(seriesId, patientId, rxSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} therapyRxId 
     * @param {string} newSeriesId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RxApi
     */
    public updateSeriesForTherapyRx(therapyRxId: string, newSeriesId: string, options?: AxiosRequestConfig) {
        return RxApiFp(this.configuration).updateSeriesForTherapyRx(therapyRxId, newSeriesId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesApi - axios parameter creator
 * @export
 */
export const SalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {GiftCertificateDto} giftCertificateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCertificate: async (giftCertificateDto: GiftCertificateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'giftCertificateDto' is not null or undefined
            assertParamExists('createGiftCertificate', 'giftCertificateDto', giftCertificateDto)
            const localVarPath = `/sales/createGiftCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(giftCertificateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an unpaid gift certificate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGiftCertificate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGiftCertificate', 'id', id)
            const localVarPath = `/sales/giftCertificate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Gift Certificate By Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCertificateById: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getGiftCertificateById', 'code', code)
            const localVarPath = `/sales/giftCertificate/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Gift Certificates For Patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCertificatesByPatientId: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getGiftCertificatesByPatientId', 'patientId', patientId)
            const localVarPath = `/sales/giftCertificates/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleServices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales/getSaleServices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get services for a specific Patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesByPatient: async (pid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('getServicesByPatient', 'pid', pid)
            const localVarPath = `/sales/patient/services/{pid}`
                .replace(`{${"pid"}}`, encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Unpaid Gift Certificates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnpaidGiftCertificates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales/unpaidGiftCertificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} giftCardNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCard: async (patientId: number, giftCardNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updateGiftCard', 'patientId', patientId)
            // verify required parameter 'giftCardNumber' is not null or undefined
            assertParamExists('updateGiftCard', 'giftCardNumber', giftCardNumber)
            const localVarPath = `/sales/updateGiftCard/{patientId}/{giftCardNumber}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"giftCardNumber"}}`, encodeURIComponent(String(giftCardNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesApi - functional programming interface
 * @export
 */
export const SalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {GiftCertificateDto} giftCertificateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGiftCertificate(giftCertificateDto: GiftCertificateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGiftCertificate(giftCertificateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an unpaid gift certificate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGiftCertificate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGiftCertificate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Gift Certificate By Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCertificateById(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCertificateById(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Gift Certificates For Patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCertificatesByPatientId(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GiftCertificateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCertificatesByPatientId(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleServices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleServices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get services for a specific Patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicesByPatient(pid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesTimeSlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicesByPatient(pid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Unpaid Gift Certificates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnpaidGiftCertificates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnpaidGiftCertificates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} giftCardNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGiftCard(patientId: number, giftCardNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGiftCard(patientId, giftCardNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesApi - factory interface
 * @export
 */
export const SalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {GiftCertificateDto} giftCertificateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCertificate(giftCertificateDto: GiftCertificateDto, options?: any): AxiosPromise<object> {
            return localVarFp.createGiftCertificate(giftCertificateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an unpaid gift certificate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGiftCertificate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGiftCertificate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Gift Certificate By Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCertificateById(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.getGiftCertificateById(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Gift Certificates For Patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCertificatesByPatientId(patientId: number, options?: any): AxiosPromise<Array<GiftCertificateDto>> {
            return localVarFp.getGiftCertificatesByPatientId(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleServices(options?: any): AxiosPromise<Array<TherapyDetailsDto>> {
            return localVarFp.getSaleServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get services for a specific Patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesByPatient(pid: number, options?: any): AxiosPromise<SalesTimeSlotDto> {
            return localVarFp.getServicesByPatient(pid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Unpaid Gift Certificates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnpaidGiftCertificates(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getUnpaidGiftCertificates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {string} giftCardNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCard(patientId: number, giftCardNumber: string, options?: any): AxiosPromise<object> {
            return localVarFp.updateGiftCard(patientId, giftCardNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesApi - object-oriented interface
 * @export
 * @class SalesApi
 * @extends {BaseAPI}
 */
export class SalesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {GiftCertificateDto} giftCertificateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public createGiftCertificate(giftCertificateDto: GiftCertificateDto, options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).createGiftCertificate(giftCertificateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an unpaid gift certificate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public deleteGiftCertificate(id: string, options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).deleteGiftCertificate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Gift Certificate By Code
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getGiftCertificateById(code: string, options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).getGiftCertificateById(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Gift Certificates For Patient
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getGiftCertificatesByPatientId(patientId: number, options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).getGiftCertificatesByPatientId(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSaleServices(options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSaleServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get services for a specific Patient
     * @param {number} pid Please provide a valid patient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getServicesByPatient(pid: number, options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).getServicesByPatient(pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Unpaid Gift Certificates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getUnpaidGiftCertificates(options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).getUnpaidGiftCertificates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {string} giftCardNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public updateGiftCard(patientId: number, giftCardNumber: string, options?: AxiosRequestConfig) {
        return SalesApiFp(this.configuration).updateGiftCard(patientId, giftCardNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScheduleApi - axios parameter creator
 * @export
 */
export const ScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Aggregated offline-prefetch payload for one therapist + day (replaces the 9 separate bulk calls)
         * @param {string} userId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleBootstrap: async (userId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getScheduleBootstrap', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getScheduleBootstrap', 'date', date)
            const localVarPath = `/schedule/bootstrap/{userId}/{date}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduleApi - functional programming interface
 * @export
 */
export const ScheduleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Aggregated offline-prefetch payload for one therapist + day (replaces the 9 separate bulk calls)
         * @param {string} userId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleBootstrap(userId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleBootstrapDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleBootstrap(userId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScheduleApi - factory interface
 * @export
 */
export const ScheduleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduleApiFp(configuration)
    return {
        /**
         * 
         * @summary Aggregated offline-prefetch payload for one therapist + day (replaces the 9 separate bulk calls)
         * @param {string} userId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleBootstrap(userId: string, date: string, options?: any): AxiosPromise<ScheduleBootstrapDto> {
            return localVarFp.getScheduleBootstrap(userId, date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScheduleApi - object-oriented interface
 * @export
 * @class ScheduleApi
 * @extends {BaseAPI}
 */
export class ScheduleApi extends BaseAPI {
    /**
     * 
     * @summary Aggregated offline-prefetch payload for one therapist + day (replaces the 9 separate bulk calls)
     * @param {string} userId 
     * @param {string} date Day in YYYY-MM-DD format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    public getScheduleBootstrap(userId: string, date: string, options?: AxiosRequestConfig) {
        return ScheduleApiFp(this.configuration).getScheduleBootstrap(userId, date, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerBatchCancelAndDeleteAppointments: async (batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchCancelDeleteAppointmentDto' is not null or undefined
            assertParamExists('schedulerBatchCancelAndDeleteAppointments', 'batchCancelDeleteAppointmentDto', batchCancelDeleteAppointmentDto)
            const localVarPath = `/scheduler/batchCancelAndDeleteAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCancelDeleteAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerBatchCancelAndDeleteTimeSlots: async (batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchCancelDeleteAppointmentDto' is not null or undefined
            assertParamExists('schedulerBatchCancelAndDeleteTimeSlots', 'batchCancelDeleteAppointmentDto', batchCancelDeleteAppointmentDto)
            const localVarPath = `/scheduler/batchCancelAndDeleteTimeSlots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCancelDeleteAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel an appointment (unschedule + CancelledAppointment + group reconcile)
         * @param {string} apptId Appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerCancelAppointment: async (apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apptId' is not null or undefined
            assertParamExists('schedulerCancelAppointment', 'apptId', apptId)
            // verify required parameter 'byTherapist' is not null or undefined
            assertParamExists('schedulerCancelAppointment', 'byTherapist', byTherapist)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('schedulerCancelAppointment', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/scheduler/cancelAppointment/{apptId}`
                .replace(`{${"apptId"}}`, encodeURIComponent(String(apptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byTherapist !== undefined) {
                localVarQueryParameter['byTherapist'] = byTherapist;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel an entire group appointment (cancel each participant; anchor purged as side effect)
         * @param {string} anchorId Group anchor appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerCancelGroupAppointment: async (anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('schedulerCancelGroupAppointment', 'anchorId', anchorId)
            // verify required parameter 'byTherapist' is not null or undefined
            assertParamExists('schedulerCancelGroupAppointment', 'byTherapist', byTherapist)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('schedulerCancelGroupAppointment', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/scheduler/cancelGroupAppointment/{anchorId}`
                .replace(`{${"anchorId"}}`, encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byTherapist !== undefined) {
                localVarQueryParameter['byTherapist'] = byTherapist;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a single time slot (split off + cancellation + group reconcile)
         * @param {string} slotId TimeSlot ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerCancelTimeSlot: async (slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerCancelTimeSlot', 'slotId', slotId)
            // verify required parameter 'byTherapist' is not null or undefined
            assertParamExists('schedulerCancelTimeSlot', 'byTherapist', byTherapist)
            // verify required parameter 'updateCancelledAppointmentDto' is not null or undefined
            assertParamExists('schedulerCancelTimeSlot', 'updateCancelledAppointmentDto', updateCancelledAppointmentDto)
            const localVarPath = `/scheduler/cancelTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byTherapist !== undefined) {
                localVarQueryParameter['byTherapist'] = byTherapist;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCancelledAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an (unscheduled) appointment and its slots
         * @param {string} id Appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schedulerDeleteAppointment', 'id', id)
            const localVarPath = `/scheduler/deleteAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a continuous appointment and its slots
         * @param {string} id Continuous appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteContinuousAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schedulerDeleteContinuousAppointment', 'id', id)
            const localVarPath = `/scheduler/deleteContinuousAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the absence and puts back every appointment it cancelled that is still untouched (unresolved, never rescheduled, not finally cancelled, not cancelled for another reason) and whose original time is still free. Appointments that stay cancelled are returned in `skipped` with a user-facing message.
         * @summary Delete a leave of absence and restore the appointments it cancelled
         * @param {string} slotId LeaveOfAbsence TimeSlot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteLeaveOfAbsence: async (slotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerDeleteLeaveOfAbsence', 'slotId', slotId)
            const localVarPath = `/scheduler/deleteLeaveOfAbsence/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a time slot (deletes its parent appointment if it becomes empty)
         * @param {string} slotId TimeSlot ID
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteTimeSlot: async (slotId: string, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerDeleteTimeSlot', 'slotId', slotId)
            const localVarPath = `/scheduler/deleteTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete all unscheduled appointments for a patient
         * @param {number} patientId Patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteUnscheduledAppointments: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('schedulerDeleteUnscheduledAppointments', 'patientId', patientId)
            const localVarPath = `/scheduler/deleteUnscheduledAppointments/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Safety-net cleanup for an orphaned group anchor (zero participants). The data model should never produce one (the reconciler tears it down when the last participant leaves), but this provides a manual repair affordance. NOT the way to cancel a live group — use cancelGroupAppointment.
         * @summary Clean up an EMPTY group-therapist anchor (refuses if participants remain)
         * @param {string} timeSlotId GroupTimeSlotTherapist ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerPurgeEmptyGroupAnchor: async (timeSlotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('schedulerPurgeEmptyGroupAnchor', 'timeSlotId', timeSlotId)
            const localVarPath = `/scheduler/purgeEmptyGroupAnchor/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a new desired state (window, user, slots, address, visit fee) and runs all integrity maintenance in one transaction: slot upserts, MOB-956 cancellation resolution, group-participant assignment, therapist-anchor→participant sync, and same-day merge.
         * @summary Reschedule / update an appointment (the unified SCHEDULE/RESCHEDULE verb)
         * @param {string} id Appointment ID
         * @param {UpdateAppointmentDto} updateAppointmentDto 
         * @param {boolean} [updateMultiple] 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerReschedule: async (id: string, updateAppointmentDto: UpdateAppointmentDto, updateMultiple?: boolean, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schedulerReschedule', 'id', id)
            // verify required parameter 'updateAppointmentDto' is not null or undefined
            assertParamExists('schedulerReschedule', 'updateAppointmentDto', updateAppointmentDto)
            const localVarPath = `/scheduler/reschedule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateMultiple !== undefined) {
                localVarQueryParameter['updateMultiple'] = updateMultiple;
            }

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reschedule / update a continuous (template) appointment incl. back-plan
         * @param {string} id Continuous appointment ID
         * @param {ContinuousAppointmentDto} continuousAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleContinuous: async (id: string, continuousAppointmentDto: ContinuousAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schedulerRescheduleContinuous', 'id', id)
            // verify required parameter 'continuousAppointmentDto' is not null or undefined
            assertParamExists('schedulerRescheduleContinuous', 'continuousAppointmentDto', continuousAppointmentDto)
            const localVarPath = `/scheduler/rescheduleContinuous/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continuousAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Continuous variant of rescheduleTimeSlot. Templates carry no cancellations and never merge, so this isolates the slot (split if it shares its appointment), applies the new window/user, and reconciles any vacated continuous group anchor.
         * @summary Reschedule a single continuous (template) time slot (SPLIT + apply)
         * @param {string} slotId Continuous TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleContinuousTimeSlot: async (slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerRescheduleContinuousTimeSlot', 'slotId', slotId)
            // verify required parameter 'rescheduleTimeSlotDto' is not null or undefined
            assertParamExists('schedulerRescheduleContinuousTimeSlot', 'rescheduleTimeSlotDto', rescheduleTimeSlotDto)
            const localVarPath = `/scheduler/rescheduleContinuousTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleTimeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reschedule / update many appointments at once
         * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleMultiple: async (updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAppointmentDto' is not null or undefined
            assertParamExists('schedulerRescheduleMultiple', 'updateAppointmentDto', updateAppointmentDto)
            const localVarPath = `/scheduler/rescheduleMultiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Moves ONE time slot to a new window (and optionally a new therapist). Isolates the slot from any siblings (splitting it off into its own appointment so the others are untouched), detaches it from a group anchor if it was a participant, resolves any prior cancellation, reconciles the vacated anchor, and runs the same-day merge so the patient keeps a single appointment per day. Returns the canonical survivor appointment.
         * @summary Reschedule a single time slot (drag-move one slot: SPLIT + apply + MERGE)
         * @param {string} slotId TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleTimeSlot: async (slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerRescheduleTimeSlot', 'slotId', slotId)
            // verify required parameter 'rescheduleTimeSlotDto' is not null or undefined
            assertParamExists('schedulerRescheduleTimeSlot', 'rescheduleTimeSlotDto', rescheduleTimeSlotDto)
            const localVarPath = `/scheduler/rescheduleTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleTimeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedules a single previously-unscheduled time slot onto the calendar. If the slots left behind would all be supplementary they are deleted (no split); otherwise the slot is split into its own appointment and the rest stay unscheduled. ALWAYS resolves any cancellation on the source appointment, then runs the same-day merge. Returns the canonical survivor appointment.
         * @summary Schedule one UNSCHEDULED time slot from the shelf (split-or-supplement-cleanup + resolve cancellation + MERGE)
         * @param {string} slotId TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerScheduleUnscheduledTimeSlot: async (slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerScheduleUnscheduledTimeSlot', 'slotId', slotId)
            // verify required parameter 'rescheduleTimeSlotDto' is not null or undefined
            assertParamExists('schedulerScheduleUnscheduledTimeSlot', 'rescheduleTimeSlotDto', rescheduleTimeSlotDto)
            const localVarPath = `/scheduler/scheduleUnscheduledTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleTimeSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *        Swap / reorder the Rx assignment across appointment series.              **Preview mode (previewMode=true, default):** Returns preview with assignments, errors, and warnings. No changes are committed.       **Execute mode (previewMode=false):** Executes the swap. User can proceed even if there are errors.              Errors are returned, not thrown, so the UI can show them and let the user decide.     
         * @summary Simplified swap with preview and execute modes
         * @param {SimpleSwapRequestDto} simpleSwapRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerSimpleSwapAppointments: async (simpleSwapRequestDto: SimpleSwapRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simpleSwapRequestDto' is not null or undefined
            assertParamExists('schedulerSimpleSwapAppointments', 'simpleSwapRequestDto', simpleSwapRequestDto)
            const localVarPath = `/scheduler/simpleSwapAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simpleSwapRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Split a time slot off into its own appointment (raw primitive)
         * @param {string} timeSlotId TimeSlot ID
         * @param {string} [reason] 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerSplitTimeSlot: async (timeSlotId: string, reason?: string, isContinuous?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('schedulerSplitTimeSlot', 'timeSlotId', timeSlotId)
            const localVarPath = `/scheduler/splitTimeSlot/{timeSlotId}`
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (isContinuous !== undefined) {
                localVarQueryParameter['isContinuous'] = isContinuous;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unschedule an appointment (clear its window; keep the row; reconcile group)
         * @param {string} id Appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerUnscheduleAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schedulerUnscheduleAppointment', 'id', id)
            const localVarPath = `/scheduler/unscheduleAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unschedule a continuous appointment (no cancellation event for templates)
         * @param {string} id Continuous appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerUnscheduleContinuousAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schedulerUnscheduleContinuousAppointment', 'id', id)
            const localVarPath = `/scheduler/unscheduleContinuousAppointment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unschedule a single time slot (split off, clear window; reconcile group)
         * @param {string} slotId TimeSlot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerUnscheduleTimeSlot: async (slotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('schedulerUnscheduleTimeSlot', 'slotId', slotId)
            const localVarPath = `/scheduler/unscheduleTimeSlot/{slotId}`
                .replace(`{${"slotId"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Audit the scheduling graph for invariant violations (read-only). Disabled unless SCHEDULER_INTEGRITY_ENDPOINT_ENABLED=true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerVerifyIntegrity: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/scheduler/integrity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerBatchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerBatchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerBatchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCancelDeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerBatchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel an appointment (unschedule + CancelledAppointment + group reconcile)
         * @param {string} apptId Appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerCancelAppointment(apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerCancelAppointment(apptId, byTherapist, updateCancelledAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel an entire group appointment (cancel each participant; anchor purged as side effect)
         * @param {string} anchorId Group anchor appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerCancelGroupAppointment(anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerCancelGroupAppointment(anchorId, byTherapist, updateCancelledAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel a single time slot (split off + cancellation + group reconcile)
         * @param {string} slotId TimeSlot ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerCancelTimeSlot(slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerCancelTimeSlot(slotId, byTherapist, updateCancelledAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an (unscheduled) appointment and its slots
         * @param {string} id Appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerDeleteAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerDeleteAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a continuous appointment and its slots
         * @param {string} id Continuous appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerDeleteContinuousAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerDeleteContinuousAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Removes the absence and puts back every appointment it cancelled that is still untouched (unresolved, never rescheduled, not finally cancelled, not cancelled for another reason) and whose original time is still free. Appointments that stay cancelled are returned in `skipped` with a user-facing message.
         * @summary Delete a leave of absence and restore the appointments it cancelled
         * @param {string} slotId LeaveOfAbsence TimeSlot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerDeleteLeaveOfAbsence(slotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteLeaveOfAbsenceResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerDeleteLeaveOfAbsence(slotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a time slot (deletes its parent appointment if it becomes empty)
         * @param {string} slotId TimeSlot ID
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerDeleteTimeSlot(slotId: string, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerDeleteTimeSlot(slotId, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete all unscheduled appointments for a patient
         * @param {number} patientId Patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerDeleteUnscheduledAppointments(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerDeleteUnscheduledAppointments(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Safety-net cleanup for an orphaned group anchor (zero participants). The data model should never produce one (the reconciler tears it down when the last participant leaves), but this provides a manual repair affordance. NOT the way to cancel a live group — use cancelGroupAppointment.
         * @summary Clean up an EMPTY group-therapist anchor (refuses if participants remain)
         * @param {string} timeSlotId GroupTimeSlotTherapist ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerPurgeEmptyGroupAnchor(timeSlotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerPurgeEmptyGroupAnchor(timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Applies a new desired state (window, user, slots, address, visit fee) and runs all integrity maintenance in one transaction: slot upserts, MOB-956 cancellation resolution, group-participant assignment, therapist-anchor→participant sync, and same-day merge.
         * @summary Reschedule / update an appointment (the unified SCHEDULE/RESCHEDULE verb)
         * @param {string} id Appointment ID
         * @param {UpdateAppointmentDto} updateAppointmentDto 
         * @param {boolean} [updateMultiple] 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerReschedule(id: string, updateAppointmentDto: UpdateAppointmentDto, updateMultiple?: boolean, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerReschedule(id, updateAppointmentDto, updateMultiple, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reschedule / update a continuous (template) appointment incl. back-plan
         * @param {string} id Continuous appointment ID
         * @param {ContinuousAppointmentDto} continuousAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerRescheduleContinuous(id: string, continuousAppointmentDto: ContinuousAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerRescheduleContinuous(id, continuousAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Continuous variant of rescheduleTimeSlot. Templates carry no cancellations and never merge, so this isolates the slot (split if it shares its appointment), applies the new window/user, and reconciles any vacated continuous group anchor.
         * @summary Reschedule a single continuous (template) time slot (SPLIT + apply)
         * @param {string} slotId Continuous TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerRescheduleContinuousTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinuousAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerRescheduleContinuousTimeSlot(slotId, rescheduleTimeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reschedule / update many appointments at once
         * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerRescheduleMultiple(updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerRescheduleMultiple(updateAppointmentDto, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Moves ONE time slot to a new window (and optionally a new therapist). Isolates the slot from any siblings (splitting it off into its own appointment so the others are untouched), detaches it from a group anchor if it was a participant, resolves any prior cancellation, reconciles the vacated anchor, and runs the same-day merge so the patient keeps a single appointment per day. Returns the canonical survivor appointment.
         * @summary Reschedule a single time slot (drag-move one slot: SPLIT + apply + MERGE)
         * @param {string} slotId TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerRescheduleTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerRescheduleTimeSlot(slotId, rescheduleTimeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Schedules a single previously-unscheduled time slot onto the calendar. If the slots left behind would all be supplementary they are deleted (no split); otherwise the slot is split into its own appointment and the rest stay unscheduled. ALWAYS resolves any cancellation on the source appointment, then runs the same-day merge. Returns the canonical survivor appointment.
         * @summary Schedule one UNSCHEDULED time slot from the shelf (split-or-supplement-cleanup + resolve cancellation + MERGE)
         * @param {string} slotId TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerScheduleUnscheduledTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerScheduleUnscheduledTimeSlot(slotId, rescheduleTimeSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *        Swap / reorder the Rx assignment across appointment series.              **Preview mode (previewMode=true, default):** Returns preview with assignments, errors, and warnings. No changes are committed.       **Execute mode (previewMode=false):** Executes the swap. User can proceed even if there are errors.              Errors are returned, not thrown, so the UI can show them and let the user decide.     
         * @summary Simplified swap with preview and execute modes
         * @param {SimpleSwapRequestDto} simpleSwapRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerSimpleSwapAppointments(simpleSwapRequestDto: SimpleSwapRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleSwapResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerSimpleSwapAppointments(simpleSwapRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Split a time slot off into its own appointment (raw primitive)
         * @param {string} timeSlotId TimeSlot ID
         * @param {string} [reason] 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerSplitTimeSlot(timeSlotId: string, reason?: string, isContinuous?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerSplitTimeSlot(timeSlotId, reason, isContinuous, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unschedule an appointment (clear its window; keep the row; reconcile group)
         * @param {string} id Appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerUnscheduleAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerUnscheduleAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unschedule a continuous appointment (no cancellation event for templates)
         * @param {string} id Continuous appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerUnscheduleContinuousAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerUnscheduleContinuousAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unschedule a single time slot (split off, clear window; reconcile group)
         * @param {string} slotId TimeSlot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerUnscheduleTimeSlot(slotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerUnscheduleTimeSlot(slotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Audit the scheduling graph for invariant violations (read-only). Disabled unless SCHEDULER_INTEGRITY_ENDPOINT_ENABLED=true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerVerifyIntegrity(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerVerifyIntegrity(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerBatchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerBatchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerBatchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: any): AxiosPromise<BatchCancelDeleteResponseDto> {
            return localVarFp.schedulerBatchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel an appointment (unschedule + CancelledAppointment + group reconcile)
         * @param {string} apptId Appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerCancelAppointment(apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerCancelAppointment(apptId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel an entire group appointment (cancel each participant; anchor purged as side effect)
         * @param {string} anchorId Group anchor appointment ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerCancelGroupAppointment(anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerCancelGroupAppointment(anchorId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a single time slot (split off + cancellation + group reconcile)
         * @param {string} slotId TimeSlot ID
         * @param {boolean} byTherapist 
         * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerCancelTimeSlot(slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerCancelTimeSlot(slotId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an (unscheduled) appointment and its slots
         * @param {string} id Appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteAppointment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerDeleteAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a continuous appointment and its slots
         * @param {string} id Continuous appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteContinuousAppointment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerDeleteContinuousAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the absence and puts back every appointment it cancelled that is still untouched (unresolved, never rescheduled, not finally cancelled, not cancelled for another reason) and whose original time is still free. Appointments that stay cancelled are returned in `skipped` with a user-facing message.
         * @summary Delete a leave of absence and restore the appointments it cancelled
         * @param {string} slotId LeaveOfAbsence TimeSlot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteLeaveOfAbsence(slotId: string, options?: any): AxiosPromise<DeleteLeaveOfAbsenceResultDto> {
            return localVarFp.schedulerDeleteLeaveOfAbsence(slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a time slot (deletes its parent appointment if it becomes empty)
         * @param {string} slotId TimeSlot ID
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteTimeSlot(slotId: string, isContinuous?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerDeleteTimeSlot(slotId, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete all unscheduled appointments for a patient
         * @param {number} patientId Patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerDeleteUnscheduledAppointments(patientId: number, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerDeleteUnscheduledAppointments(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Safety-net cleanup for an orphaned group anchor (zero participants). The data model should never produce one (the reconciler tears it down when the last participant leaves), but this provides a manual repair affordance. NOT the way to cancel a live group — use cancelGroupAppointment.
         * @summary Clean up an EMPTY group-therapist anchor (refuses if participants remain)
         * @param {string} timeSlotId GroupTimeSlotTherapist ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerPurgeEmptyGroupAnchor(timeSlotId: string, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerPurgeEmptyGroupAnchor(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a new desired state (window, user, slots, address, visit fee) and runs all integrity maintenance in one transaction: slot upserts, MOB-956 cancellation resolution, group-participant assignment, therapist-anchor→participant sync, and same-day merge.
         * @summary Reschedule / update an appointment (the unified SCHEDULE/RESCHEDULE verb)
         * @param {string} id Appointment ID
         * @param {UpdateAppointmentDto} updateAppointmentDto 
         * @param {boolean} [updateMultiple] 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerReschedule(id: string, updateAppointmentDto: UpdateAppointmentDto, updateMultiple?: boolean, isContinuous?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.schedulerReschedule(id, updateAppointmentDto, updateMultiple, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reschedule / update a continuous (template) appointment incl. back-plan
         * @param {string} id Continuous appointment ID
         * @param {ContinuousAppointmentDto} continuousAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleContinuous(id: string, continuousAppointmentDto: ContinuousAppointmentDto, options?: any): AxiosPromise<CAResponse> {
            return localVarFp.schedulerRescheduleContinuous(id, continuousAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Continuous variant of rescheduleTimeSlot. Templates carry no cancellations and never merge, so this isolates the slot (split if it shares its appointment), applies the new window/user, and reconciles any vacated continuous group anchor.
         * @summary Reschedule a single continuous (template) time slot (SPLIT + apply)
         * @param {string} slotId Continuous TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleContinuousTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: any): AxiosPromise<ContinuousAppointmentDto> {
            return localVarFp.schedulerRescheduleContinuousTimeSlot(slotId, rescheduleTimeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reschedule / update many appointments at once
         * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleMultiple(updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.schedulerRescheduleMultiple(updateAppointmentDto, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * Moves ONE time slot to a new window (and optionally a new therapist). Isolates the slot from any siblings (splitting it off into its own appointment so the others are untouched), detaches it from a group anchor if it was a participant, resolves any prior cancellation, reconciles the vacated anchor, and runs the same-day merge so the patient keeps a single appointment per day. Returns the canonical survivor appointment.
         * @summary Reschedule a single time slot (drag-move one slot: SPLIT + apply + MERGE)
         * @param {string} slotId TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerRescheduleTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: any): AxiosPromise<object> {
            return localVarFp.schedulerRescheduleTimeSlot(slotId, rescheduleTimeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Schedules a single previously-unscheduled time slot onto the calendar. If the slots left behind would all be supplementary they are deleted (no split); otherwise the slot is split into its own appointment and the rest stay unscheduled. ALWAYS resolves any cancellation on the source appointment, then runs the same-day merge. Returns the canonical survivor appointment.
         * @summary Schedule one UNSCHEDULED time slot from the shelf (split-or-supplement-cleanup + resolve cancellation + MERGE)
         * @param {string} slotId TimeSlot ID
         * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerScheduleUnscheduledTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: any): AxiosPromise<object> {
            return localVarFp.schedulerScheduleUnscheduledTimeSlot(slotId, rescheduleTimeSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         *        Swap / reorder the Rx assignment across appointment series.              **Preview mode (previewMode=true, default):** Returns preview with assignments, errors, and warnings. No changes are committed.       **Execute mode (previewMode=false):** Executes the swap. User can proceed even if there are errors.              Errors are returned, not thrown, so the UI can show them and let the user decide.     
         * @summary Simplified swap with preview and execute modes
         * @param {SimpleSwapRequestDto} simpleSwapRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerSimpleSwapAppointments(simpleSwapRequestDto: SimpleSwapRequestDto, options?: any): AxiosPromise<SimpleSwapResponseDto> {
            return localVarFp.schedulerSimpleSwapAppointments(simpleSwapRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Split a time slot off into its own appointment (raw primitive)
         * @param {string} timeSlotId TimeSlot ID
         * @param {string} [reason] 
         * @param {boolean} [isContinuous] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerSplitTimeSlot(timeSlotId: string, reason?: string, isContinuous?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerSplitTimeSlot(timeSlotId, reason, isContinuous, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unschedule an appointment (clear its window; keep the row; reconcile group)
         * @param {string} id Appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerUnscheduleAppointment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerUnscheduleAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unschedule a continuous appointment (no cancellation event for templates)
         * @param {string} id Continuous appointment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerUnscheduleContinuousAppointment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerUnscheduleContinuousAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unschedule a single time slot (split off, clear window; reconcile group)
         * @param {string} slotId TimeSlot ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerUnscheduleTimeSlot(slotId: string, options?: any): AxiosPromise<void> {
            return localVarFp.schedulerUnscheduleTimeSlot(slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Audit the scheduling graph for invariant violations (read-only). Disabled unless SCHEDULER_INTEGRITY_ENDPOINT_ENABLED=true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerVerifyIntegrity(options?: any): AxiosPromise<object> {
            return localVarFp.schedulerVerifyIntegrity(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerBatchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerBatchCancelAndDeleteAppointments(batchCancelDeleteAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {BatchCancelDeleteAppointmentDto} batchCancelDeleteAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerBatchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto: BatchCancelDeleteAppointmentDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerBatchCancelAndDeleteTimeSlots(batchCancelDeleteAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel an appointment (unschedule + CancelledAppointment + group reconcile)
     * @param {string} apptId Appointment ID
     * @param {boolean} byTherapist 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerCancelAppointment(apptId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerCancelAppointment(apptId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel an entire group appointment (cancel each participant; anchor purged as side effect)
     * @param {string} anchorId Group anchor appointment ID
     * @param {boolean} byTherapist 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerCancelGroupAppointment(anchorId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerCancelGroupAppointment(anchorId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a single time slot (split off + cancellation + group reconcile)
     * @param {string} slotId TimeSlot ID
     * @param {boolean} byTherapist 
     * @param {UpdateCancelledAppointmentDto} updateCancelledAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerCancelTimeSlot(slotId: string, byTherapist: boolean, updateCancelledAppointmentDto: UpdateCancelledAppointmentDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerCancelTimeSlot(slotId, byTherapist, updateCancelledAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an (unscheduled) appointment and its slots
     * @param {string} id Appointment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerDeleteAppointment(id: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerDeleteAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a continuous appointment and its slots
     * @param {string} id Continuous appointment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerDeleteContinuousAppointment(id: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerDeleteContinuousAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the absence and puts back every appointment it cancelled that is still untouched (unresolved, never rescheduled, not finally cancelled, not cancelled for another reason) and whose original time is still free. Appointments that stay cancelled are returned in `skipped` with a user-facing message.
     * @summary Delete a leave of absence and restore the appointments it cancelled
     * @param {string} slotId LeaveOfAbsence TimeSlot ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerDeleteLeaveOfAbsence(slotId: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerDeleteLeaveOfAbsence(slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a time slot (deletes its parent appointment if it becomes empty)
     * @param {string} slotId TimeSlot ID
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerDeleteTimeSlot(slotId: string, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerDeleteTimeSlot(slotId, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete all unscheduled appointments for a patient
     * @param {number} patientId Patient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerDeleteUnscheduledAppointments(patientId: number, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerDeleteUnscheduledAppointments(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Safety-net cleanup for an orphaned group anchor (zero participants). The data model should never produce one (the reconciler tears it down when the last participant leaves), but this provides a manual repair affordance. NOT the way to cancel a live group — use cancelGroupAppointment.
     * @summary Clean up an EMPTY group-therapist anchor (refuses if participants remain)
     * @param {string} timeSlotId GroupTimeSlotTherapist ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerPurgeEmptyGroupAnchor(timeSlotId: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerPurgeEmptyGroupAnchor(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a new desired state (window, user, slots, address, visit fee) and runs all integrity maintenance in one transaction: slot upserts, MOB-956 cancellation resolution, group-participant assignment, therapist-anchor→participant sync, and same-day merge.
     * @summary Reschedule / update an appointment (the unified SCHEDULE/RESCHEDULE verb)
     * @param {string} id Appointment ID
     * @param {UpdateAppointmentDto} updateAppointmentDto 
     * @param {boolean} [updateMultiple] 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerReschedule(id: string, updateAppointmentDto: UpdateAppointmentDto, updateMultiple?: boolean, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerReschedule(id, updateAppointmentDto, updateMultiple, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reschedule / update a continuous (template) appointment incl. back-plan
     * @param {string} id Continuous appointment ID
     * @param {ContinuousAppointmentDto} continuousAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerRescheduleContinuous(id: string, continuousAppointmentDto: ContinuousAppointmentDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerRescheduleContinuous(id, continuousAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Continuous variant of rescheduleTimeSlot. Templates carry no cancellations and never merge, so this isolates the slot (split if it shares its appointment), applies the new window/user, and reconciles any vacated continuous group anchor.
     * @summary Reschedule a single continuous (template) time slot (SPLIT + apply)
     * @param {string} slotId Continuous TimeSlot ID
     * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerRescheduleContinuousTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerRescheduleContinuousTimeSlot(slotId, rescheduleTimeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reschedule / update many appointments at once
     * @param {Array<UpdateAppointmentDto>} updateAppointmentDto 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerRescheduleMultiple(updateAppointmentDto: Array<UpdateAppointmentDto>, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerRescheduleMultiple(updateAppointmentDto, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Moves ONE time slot to a new window (and optionally a new therapist). Isolates the slot from any siblings (splitting it off into its own appointment so the others are untouched), detaches it from a group anchor if it was a participant, resolves any prior cancellation, reconciles the vacated anchor, and runs the same-day merge so the patient keeps a single appointment per day. Returns the canonical survivor appointment.
     * @summary Reschedule a single time slot (drag-move one slot: SPLIT + apply + MERGE)
     * @param {string} slotId TimeSlot ID
     * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerRescheduleTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerRescheduleTimeSlot(slotId, rescheduleTimeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedules a single previously-unscheduled time slot onto the calendar. If the slots left behind would all be supplementary they are deleted (no split); otherwise the slot is split into its own appointment and the rest stay unscheduled. ALWAYS resolves any cancellation on the source appointment, then runs the same-day merge. Returns the canonical survivor appointment.
     * @summary Schedule one UNSCHEDULED time slot from the shelf (split-or-supplement-cleanup + resolve cancellation + MERGE)
     * @param {string} slotId TimeSlot ID
     * @param {RescheduleTimeSlotDto} rescheduleTimeSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerScheduleUnscheduledTimeSlot(slotId: string, rescheduleTimeSlotDto: RescheduleTimeSlotDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerScheduleUnscheduledTimeSlot(slotId, rescheduleTimeSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *        Swap / reorder the Rx assignment across appointment series.              **Preview mode (previewMode=true, default):** Returns preview with assignments, errors, and warnings. No changes are committed.       **Execute mode (previewMode=false):** Executes the swap. User can proceed even if there are errors.              Errors are returned, not thrown, so the UI can show them and let the user decide.     
     * @summary Simplified swap with preview and execute modes
     * @param {SimpleSwapRequestDto} simpleSwapRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerSimpleSwapAppointments(simpleSwapRequestDto: SimpleSwapRequestDto, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerSimpleSwapAppointments(simpleSwapRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Split a time slot off into its own appointment (raw primitive)
     * @param {string} timeSlotId TimeSlot ID
     * @param {string} [reason] 
     * @param {boolean} [isContinuous] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerSplitTimeSlot(timeSlotId: string, reason?: string, isContinuous?: boolean, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerSplitTimeSlot(timeSlotId, reason, isContinuous, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unschedule an appointment (clear its window; keep the row; reconcile group)
     * @param {string} id Appointment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerUnscheduleAppointment(id: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerUnscheduleAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unschedule a continuous appointment (no cancellation event for templates)
     * @param {string} id Continuous appointment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerUnscheduleContinuousAppointment(id: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerUnscheduleContinuousAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unschedule a single time slot (split off, clear window; reconcile group)
     * @param {string} slotId TimeSlot ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerUnscheduleTimeSlot(slotId: string, options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerUnscheduleTimeSlot(slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Audit the scheduling graph for invariant violations (read-only). Disabled unless SCHEDULER_INTEGRITY_ENDPOINT_ENABLED=true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerVerifyIntegrity(options?: AxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerVerifyIntegrity(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SepaApi - axios parameter creator
 * @export
 */
export const SepaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate a DRAFT mandate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSepaMandate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateSepaMandate', 'id', id)
            const localVarPath = `/sepa/mandates/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a still-pending SEPA transaction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSepaTransaction: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelSepaTransaction', 'id', id)
            const localVarPath = `/sepa/transactions/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register (or reuse) a patient\'s bank account
         * @param {CreateBankAccountDto} createBankAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaBankAccount: async (createBankAccountDto: CreateBankAccountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBankAccountDto' is not null or undefined
            assertParamExists('createSepaBankAccount', 'createBankAccountDto', createBankAccountDto)
            const localVarPath = `/sepa/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SEPA direct-debit transaction (collect from patient)
         * @param {CreateDirectDebitDto} createDirectDebitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaDirectDebit: async (createDirectDebitDto: CreateDirectDebitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDirectDebitDto' is not null or undefined
            assertParamExists('createSepaDirectDebit', 'createDirectDebitDto', createDirectDebitDto)
            const localVarPath = `/sepa/transactions/direct-debit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDirectDebitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export PENDING transactions for an account + direction into one SEPA file (atomic)
         * @param {CreateExportBatchDto} createExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaExportBatch: async (createExportBatchDto: CreateExportBatchDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createExportBatchDto' is not null or undefined
            assertParamExists('createSepaExportBatch', 'createExportBatchDto', createExportBatchDto)
            const localVarPath = `/sepa/export-batches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExportBatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SEPA direct-debit mandate
         * @param {CreateMandateDto} createMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaMandate: async (createMandateDto: CreateMandateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMandateDto' is not null or undefined
            assertParamExists('createSepaMandate', 'createMandateDto', createMandateDto)
            const localVarPath = `/sepa/mandates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMandateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SEPA refund transaction (pay back to patient)
         * @param {CreateSepaRefundDto} createSepaRefundDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaRefund: async (createSepaRefundDto: CreateSepaRefundDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSepaRefundDto' is not null or undefined
            assertParamExists('createSepaRefund', 'createSepaRefundDto', createSepaRefundDto)
            const localVarPath = `/sepa/transactions/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSepaRefundDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a patient\'s bank account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSepaBankAccount: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSepaBankAccount', 'id', id)
            const localVarPath = `/sepa/bank-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a mandate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSepaMandate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSepaMandate', 'id', id)
            const localVarPath = `/sepa/mandates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate/download the fillable SEPA mandate form (SEPAMandat) for signing
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSepaMandateFormPdf: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateSepaMandateFormPdf', 'id', id)
            const localVarPath = `/sepa/mandates/{id}/form-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a patient\'s bank accounts, each enriched with its mandate summaries
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaBankAccountsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getSepaBankAccountsForPatient', 'patientId', patientId)
            const localVarPath = `/sepa/bank-accounts/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single export batch with its transactions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaExportBatch: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSepaExportBatch', 'id', id)
            const localVarPath = `/sepa/export-batches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a patient\'s mandates
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaMandatesForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getSepaMandatesForPatient', 'patientId', patientId)
            const localVarPath = `/sepa/mandates/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single SEPA transaction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaTransaction: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSepaTransaction', 'id', id)
            const localVarPath = `/sepa/transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a transaction\'s lifecycle timeline (creation + every export attempt)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaTransactionTimeline: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSepaTransactionTimeline', 'id', id)
            const localVarPath = `/sepa/transactions/{id}/timeline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List export batches (keyset paginated) with optional filters
         * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
         * @param {number} [limit] Page size (1-100).
         * @param {string} [accountId] Filter by creditor account (Mandant) id.
         * @param {ListSepaExportBatchesDirectionEnum} [direction] Filter by direction.
         * @param {ListSepaExportBatchesStatusEnum} [status] Filter by batch status.
         * @param {string} [searchStr] Search export batches by batch number or the name of the user who created them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaExportBatches: async (cursor?: string, limit?: number, accountId?: string, direction?: ListSepaExportBatchesDirectionEnum, status?: ListSepaExportBatchesStatusEnum, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sepa/export-batches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List SEPA transactions (keyset paginated) with optional filters
         * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
         * @param {number} [limit] Page size (1-100).
         * @param {string} [accountId] Filter by creditor/paying account id.
         * @param {ListSepaTransactionsDirectionEnum} [direction] 
         * @param {ListSepaTransactionsStatusEnum} [status] 
         * @param {string} [searchStr] Global spotlight search across the account\&#39;s transactions (ignores direction/status). Matches transaction number, patient name, or prescription (Rx) number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaTransactions: async (cursor?: string, limit?: number, accountId?: string, direction?: ListSepaTransactionsDirectionEnum, status?: ListSepaTransactionsStatusEnum, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sepa/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record a bank acknowledgement; the export\'s transactions become SETTLED
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSepaExportAccepted: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markSepaExportAccepted', 'id', id)
            const localVarPath = `/sepa/export-batches/{id}/mark-accepted`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record a bank rejection; the export\'s transactions become RETURNED
         * @param {string} id 
         * @param {RejectExportBatchDto} rejectExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSepaExportRejected: async (id: string, rejectExportBatchDto: RejectExportBatchDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markSepaExportRejected', 'id', id)
            // verify required parameter 'rejectExportBatchDto' is not null or undefined
            assertParamExists('markSepaExportRejected', 'rejectExportBatchDto', rejectExportBatchDto)
            const localVarPath = `/sepa/export-batches/{id}/mark-rejected`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectExportBatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a generated export as submitted to the bank (locks it against rollback)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSepaExportSent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markSepaExportSent', 'id', id)
            const localVarPath = `/sepa/export-batches/{id}/mark-sent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reverse (storno) a SEPA transaction: keeps the original visible and books a reversing entry
         * @param {string} id 
         * @param {ReverseSepaTransactionDto} reverseSepaTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseSepaTransaction: async (id: string, reverseSepaTransactionDto: ReverseSepaTransactionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reverseSepaTransaction', 'id', id)
            // verify required parameter 'reverseSepaTransactionDto' is not null or undefined
            assertParamExists('reverseSepaTransaction', 'reverseSepaTransactionDto', reverseSepaTransactionDto)
            const localVarPath = `/sepa/transactions/{id}/reverse`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reverseSepaTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a mandate
         * @param {string} id 
         * @param {RevokeMandateDto} revokeMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSepaMandate: async (id: string, revokeMandateDto: RevokeMandateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeSepaMandate', 'id', id)
            // verify required parameter 'revokeMandateDto' is not null or undefined
            assertParamExists('revokeSepaMandate', 'revokeMandateDto', revokeMandateDto)
            const localVarPath = `/sepa/mandates/{id}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeMandateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Roll back a generated (not yet sent) export; its transactions return to PENDING
         * @param {string} id 
         * @param {UndoExportBatchDto} undoExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoSepaExportBatch: async (id: string, undoExportBatchDto: UndoExportBatchDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('undoSepaExportBatch', 'id', id)
            // verify required parameter 'undoExportBatchDto' is not null or undefined
            assertParamExists('undoSepaExportBatch', 'undoExportBatchDto', undoExportBatchDto)
            const localVarPath = `/sepa/export-batches/{id}/undo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoExportBatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Correct a DRAFT mandate\'s bank details / cap / validity (active mandates are locked)
         * @param {string} id 
         * @param {UpdateMandateDto} updateMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSepaMandate: async (id: string, updateMandateDto: UpdateMandateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSepaMandate', 'id', id)
            // verify required parameter 'updateMandateDto' is not null or undefined
            assertParamExists('updateSepaMandate', 'updateMandateDto', updateMandateDto)
            const localVarPath = `/sepa/mandates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMandateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach the signed mandate document and confirm it to activate the mandate
         * @param {string} id 
         * @param {UploadSepaMandateSignedDocumentDocuTypeEnum} docuType 
         * @param {UploadSepaMandateSignedDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {string} signatureDate Actual date the debtor signed.
         * @param {string} confirmed Explicit confirmation the document is readable, signed and matches the data.
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSepaMandateSignedDocument: async (id: string, docuType: UploadSepaMandateSignedDocumentDocuTypeEnum, ownerType: UploadSepaMandateSignedDocumentOwnerTypeEnum, ownerId: string, file: File, signatureDate: string, confirmed: string, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'id', id)
            // verify required parameter 'docuType' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'docuType', docuType)
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'ownerType', ownerType)
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'ownerId', ownerId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'file', file)
            // verify required parameter 'signatureDate' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'signatureDate', signatureDate)
            // verify required parameter 'confirmed' is not null or undefined
            assertParamExists('uploadSepaMandateSignedDocument', 'confirmed', confirmed)
            const localVarPath = `/sepa/mandates/{id}/signed-document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (docuType !== undefined) { 
                localVarFormParams.append('docuType', docuType as any);
            }
    
            if (ownerType !== undefined) { 
                localVarFormParams.append('ownerType', ownerType as any);
            }
    
            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
    
            if (makeAccessible !== undefined) { 
                localVarFormParams.append('makeAccessible', makeAccessible as any);
            }
    
            if (rxId !== undefined) { 
                localVarFormParams.append('rxId', rxId as any);
            }
    
            if (noticeDefinitionDataId !== undefined) { 
                localVarFormParams.append('noticeDefinitionDataId', noticeDefinitionDataId as any);
            }
    
            if (scanToSearchablePdf !== undefined) { 
                localVarFormParams.append('scanToSearchablePdf', scanToSearchablePdf as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (signatureDate !== undefined) { 
                localVarFormParams.append('signatureDate', signatureDate as any);
            }
    
            if (confirmed !== undefined) { 
                localVarFormParams.append('confirmed', confirmed as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SepaApi - functional programming interface
 * @export
 */
export const SepaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SepaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate a DRAFT mandate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateSepaMandate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateSepaMandate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel a still-pending SEPA transaction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSepaTransaction(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSepaTransaction(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register (or reuse) a patient\'s bank account
         * @param {CreateBankAccountDto} createBankAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSepaBankAccount(createBankAccountDto: CreateBankAccountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSepaBankAccount(createBankAccountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a SEPA direct-debit transaction (collect from patient)
         * @param {CreateDirectDebitDto} createDirectDebitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSepaDirectDebit(createDirectDebitDto: CreateDirectDebitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSepaDirectDebit(createDirectDebitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export PENDING transactions for an account + direction into one SEPA file (atomic)
         * @param {CreateExportBatchDto} createExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSepaExportBatch(createExportBatchDto: CreateExportBatchDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSepaExportBatch(createExportBatchDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a SEPA direct-debit mandate
         * @param {CreateMandateDto} createMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSepaMandate(createMandateDto: CreateMandateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSepaMandate(createMandateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a SEPA refund transaction (pay back to patient)
         * @param {CreateSepaRefundDto} createSepaRefundDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSepaRefund(createSepaRefundDto: CreateSepaRefundDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSepaRefund(createSepaRefundDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete a patient\'s bank account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSepaBankAccount(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSepaBankAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete a mandate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSepaMandate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSepaMandate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate/download the fillable SEPA mandate form (SEPAMandat) for signing
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSepaMandateFormPdf(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSepaMandateFormPdf(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List a patient\'s bank accounts, each enriched with its mandate summaries
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaBankAccountsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankAccountWithMandatesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaBankAccountsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single export batch with its transactions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaExportBatch(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaExportBatch(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List a patient\'s mandates
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaMandatesForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaMandatesForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single SEPA transaction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaTransaction(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaTransaction(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a transaction\'s lifecycle timeline (creation + every export attempt)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaTransactionTimeline(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionTimelineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaTransactionTimeline(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List export batches (keyset paginated) with optional filters
         * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
         * @param {number} [limit] Page size (1-100).
         * @param {string} [accountId] Filter by creditor account (Mandant) id.
         * @param {ListSepaExportBatchesDirectionEnum} [direction] Filter by direction.
         * @param {ListSepaExportBatchesStatusEnum} [status] Filter by batch status.
         * @param {string} [searchStr] Search export batches by batch number or the name of the user who created them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSepaExportBatches(cursor?: string, limit?: number, accountId?: string, direction?: ListSepaExportBatchesDirectionEnum, status?: ListSepaExportBatchesStatusEnum, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSepaExportBatches(cursor, limit, accountId, direction, status, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List SEPA transactions (keyset paginated) with optional filters
         * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
         * @param {number} [limit] Page size (1-100).
         * @param {string} [accountId] Filter by creditor/paying account id.
         * @param {ListSepaTransactionsDirectionEnum} [direction] 
         * @param {ListSepaTransactionsStatusEnum} [status] 
         * @param {string} [searchStr] Global spotlight search across the account\&#39;s transactions (ignores direction/status). Matches transaction number, patient name, or prescription (Rx) number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSepaTransactions(cursor?: string, limit?: number, accountId?: string, direction?: ListSepaTransactionsDirectionEnum, status?: ListSepaTransactionsStatusEnum, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSepaTransactions(cursor, limit, accountId, direction, status, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record a bank acknowledgement; the export\'s transactions become SETTLED
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSepaExportAccepted(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSepaExportAccepted(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record a bank rejection; the export\'s transactions become RETURNED
         * @param {string} id 
         * @param {RejectExportBatchDto} rejectExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSepaExportRejected(id: string, rejectExportBatchDto: RejectExportBatchDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSepaExportRejected(id, rejectExportBatchDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark a generated export as submitted to the bank (locks it against rollback)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSepaExportSent(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSepaExportSent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reverse (storno) a SEPA transaction: keeps the original visible and books a reversing entry
         * @param {string} id 
         * @param {ReverseSepaTransactionDto} reverseSepaTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reverseSepaTransaction(id: string, reverseSepaTransactionDto: ReverseSepaTransactionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaTransactionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reverseSepaTransaction(id, reverseSepaTransactionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke a mandate
         * @param {string} id 
         * @param {RevokeMandateDto} revokeMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSepaMandate(id: string, revokeMandateDto: RevokeMandateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSepaMandate(id, revokeMandateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Roll back a generated (not yet sent) export; its transactions return to PENDING
         * @param {string} id 
         * @param {UndoExportBatchDto} undoExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoSepaExportBatch(id: string, undoExportBatchDto: UndoExportBatchDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaExportBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoSepaExportBatch(id, undoExportBatchDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Correct a DRAFT mandate\'s bank details / cap / validity (active mandates are locked)
         * @param {string} id 
         * @param {UpdateMandateDto} updateMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSepaMandate(id: string, updateMandateDto: UpdateMandateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSepaMandate(id, updateMandateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Attach the signed mandate document and confirm it to activate the mandate
         * @param {string} id 
         * @param {UploadSepaMandateSignedDocumentDocuTypeEnum} docuType 
         * @param {UploadSepaMandateSignedDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {string} signatureDate Actual date the debtor signed.
         * @param {string} confirmed Explicit confirmation the document is readable, signed and matches the data.
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSepaMandateSignedDocument(id: string, docuType: UploadSepaMandateSignedDocumentDocuTypeEnum, ownerType: UploadSepaMandateSignedDocumentOwnerTypeEnum, ownerId: string, file: File, signatureDate: string, confirmed: string, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSepaMandateSignedDocument(id, docuType, ownerType, ownerId, file, signatureDate, confirmed, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SepaApi - factory interface
 * @export
 */
export const SepaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SepaApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate a DRAFT mandate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSepaMandate(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.activateSepaMandate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a still-pending SEPA transaction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSepaTransaction(id: string, options?: any): AxiosPromise<SepaTransactionResponseDto> {
            return localVarFp.cancelSepaTransaction(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register (or reuse) a patient\'s bank account
         * @param {CreateBankAccountDto} createBankAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaBankAccount(createBankAccountDto: CreateBankAccountDto, options?: any): AxiosPromise<object> {
            return localVarFp.createSepaBankAccount(createBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SEPA direct-debit transaction (collect from patient)
         * @param {CreateDirectDebitDto} createDirectDebitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaDirectDebit(createDirectDebitDto: CreateDirectDebitDto, options?: any): AxiosPromise<SepaTransactionResponseDto> {
            return localVarFp.createSepaDirectDebit(createDirectDebitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export PENDING transactions for an account + direction into one SEPA file (atomic)
         * @param {CreateExportBatchDto} createExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaExportBatch(createExportBatchDto: CreateExportBatchDto, options?: any): AxiosPromise<SepaExportBatchResponseDto> {
            return localVarFp.createSepaExportBatch(createExportBatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SEPA direct-debit mandate
         * @param {CreateMandateDto} createMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaMandate(createMandateDto: CreateMandateDto, options?: any): AxiosPromise<object> {
            return localVarFp.createSepaMandate(createMandateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SEPA refund transaction (pay back to patient)
         * @param {CreateSepaRefundDto} createSepaRefundDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSepaRefund(createSepaRefundDto: CreateSepaRefundDto, options?: any): AxiosPromise<SepaTransactionResponseDto> {
            return localVarFp.createSepaRefund(createSepaRefundDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a patient\'s bank account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSepaBankAccount(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSepaBankAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a mandate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSepaMandate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSepaMandate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate/download the fillable SEPA mandate form (SEPAMandat) for signing
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSepaMandateFormPdf(id: string, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.generateSepaMandateFormPdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a patient\'s bank accounts, each enriched with its mandate summaries
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaBankAccountsForPatient(patientId: number, options?: any): AxiosPromise<Array<BankAccountWithMandatesDto>> {
            return localVarFp.getSepaBankAccountsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single export batch with its transactions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaExportBatch(id: string, options?: any): AxiosPromise<SepaExportBatchResponseDto> {
            return localVarFp.getSepaExportBatch(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a patient\'s mandates
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaMandatesForPatient(patientId: number, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getSepaMandatesForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single SEPA transaction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaTransaction(id: string, options?: any): AxiosPromise<SepaTransactionResponseDto> {
            return localVarFp.getSepaTransaction(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a transaction\'s lifecycle timeline (creation + every export attempt)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaTransactionTimeline(id: string, options?: any): AxiosPromise<SepaTransactionTimelineDto> {
            return localVarFp.getSepaTransactionTimeline(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List export batches (keyset paginated) with optional filters
         * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
         * @param {number} [limit] Page size (1-100).
         * @param {string} [accountId] Filter by creditor account (Mandant) id.
         * @param {ListSepaExportBatchesDirectionEnum} [direction] Filter by direction.
         * @param {ListSepaExportBatchesStatusEnum} [status] Filter by batch status.
         * @param {string} [searchStr] Search export batches by batch number or the name of the user who created them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaExportBatches(cursor?: string, limit?: number, accountId?: string, direction?: ListSepaExportBatchesDirectionEnum, status?: ListSepaExportBatchesStatusEnum, searchStr?: string, options?: any): AxiosPromise<SepaExportBatchPageDto> {
            return localVarFp.listSepaExportBatches(cursor, limit, accountId, direction, status, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List SEPA transactions (keyset paginated) with optional filters
         * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
         * @param {number} [limit] Page size (1-100).
         * @param {string} [accountId] Filter by creditor/paying account id.
         * @param {ListSepaTransactionsDirectionEnum} [direction] 
         * @param {ListSepaTransactionsStatusEnum} [status] 
         * @param {string} [searchStr] Global spotlight search across the account\&#39;s transactions (ignores direction/status). Matches transaction number, patient name, or prescription (Rx) number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaTransactions(cursor?: string, limit?: number, accountId?: string, direction?: ListSepaTransactionsDirectionEnum, status?: ListSepaTransactionsStatusEnum, searchStr?: string, options?: any): AxiosPromise<SepaTransactionPageDto> {
            return localVarFp.listSepaTransactions(cursor, limit, accountId, direction, status, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record a bank acknowledgement; the export\'s transactions become SETTLED
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSepaExportAccepted(id: string, options?: any): AxiosPromise<SepaExportBatchResponseDto> {
            return localVarFp.markSepaExportAccepted(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record a bank rejection; the export\'s transactions become RETURNED
         * @param {string} id 
         * @param {RejectExportBatchDto} rejectExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSepaExportRejected(id: string, rejectExportBatchDto: RejectExportBatchDto, options?: any): AxiosPromise<SepaExportBatchResponseDto> {
            return localVarFp.markSepaExportRejected(id, rejectExportBatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a generated export as submitted to the bank (locks it against rollback)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSepaExportSent(id: string, options?: any): AxiosPromise<SepaExportBatchResponseDto> {
            return localVarFp.markSepaExportSent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reverse (storno) a SEPA transaction: keeps the original visible and books a reversing entry
         * @param {string} id 
         * @param {ReverseSepaTransactionDto} reverseSepaTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseSepaTransaction(id: string, reverseSepaTransactionDto: ReverseSepaTransactionDto, options?: any): AxiosPromise<SepaTransactionResponseDto> {
            return localVarFp.reverseSepaTransaction(id, reverseSepaTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a mandate
         * @param {string} id 
         * @param {RevokeMandateDto} revokeMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSepaMandate(id: string, revokeMandateDto: RevokeMandateDto, options?: any): AxiosPromise<object> {
            return localVarFp.revokeSepaMandate(id, revokeMandateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Roll back a generated (not yet sent) export; its transactions return to PENDING
         * @param {string} id 
         * @param {UndoExportBatchDto} undoExportBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoSepaExportBatch(id: string, undoExportBatchDto: UndoExportBatchDto, options?: any): AxiosPromise<SepaExportBatchResponseDto> {
            return localVarFp.undoSepaExportBatch(id, undoExportBatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Correct a DRAFT mandate\'s bank details / cap / validity (active mandates are locked)
         * @param {string} id 
         * @param {UpdateMandateDto} updateMandateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSepaMandate(id: string, updateMandateDto: UpdateMandateDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateSepaMandate(id, updateMandateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach the signed mandate document and confirm it to activate the mandate
         * @param {string} id 
         * @param {UploadSepaMandateSignedDocumentDocuTypeEnum} docuType 
         * @param {UploadSepaMandateSignedDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {string} signatureDate Actual date the debtor signed.
         * @param {string} confirmed Explicit confirmation the document is readable, signed and matches the data.
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSepaMandateSignedDocument(id: string, docuType: UploadSepaMandateSignedDocumentDocuTypeEnum, ownerType: UploadSepaMandateSignedDocumentOwnerTypeEnum, ownerId: string, file: File, signatureDate: string, confirmed: string, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.uploadSepaMandateSignedDocument(id, docuType, ownerType, ownerId, file, signatureDate, confirmed, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SepaApi - object-oriented interface
 * @export
 * @class SepaApi
 * @extends {BaseAPI}
 */
export class SepaApi extends BaseAPI {
    /**
     * 
     * @summary Activate a DRAFT mandate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public activateSepaMandate(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).activateSepaMandate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a still-pending SEPA transaction
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public cancelSepaTransaction(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).cancelSepaTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register (or reuse) a patient\'s bank account
     * @param {CreateBankAccountDto} createBankAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public createSepaBankAccount(createBankAccountDto: CreateBankAccountDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).createSepaBankAccount(createBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SEPA direct-debit transaction (collect from patient)
     * @param {CreateDirectDebitDto} createDirectDebitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public createSepaDirectDebit(createDirectDebitDto: CreateDirectDebitDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).createSepaDirectDebit(createDirectDebitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export PENDING transactions for an account + direction into one SEPA file (atomic)
     * @param {CreateExportBatchDto} createExportBatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public createSepaExportBatch(createExportBatchDto: CreateExportBatchDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).createSepaExportBatch(createExportBatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SEPA direct-debit mandate
     * @param {CreateMandateDto} createMandateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public createSepaMandate(createMandateDto: CreateMandateDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).createSepaMandate(createMandateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SEPA refund transaction (pay back to patient)
     * @param {CreateSepaRefundDto} createSepaRefundDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public createSepaRefund(createSepaRefundDto: CreateSepaRefundDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).createSepaRefund(createSepaRefundDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a patient\'s bank account
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public deleteSepaBankAccount(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).deleteSepaBankAccount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a mandate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public deleteSepaMandate(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).deleteSepaMandate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate/download the fillable SEPA mandate form (SEPAMandat) for signing
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public generateSepaMandateFormPdf(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).generateSepaMandateFormPdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a patient\'s bank accounts, each enriched with its mandate summaries
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public getSepaBankAccountsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).getSepaBankAccountsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single export batch with its transactions
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public getSepaExportBatch(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).getSepaExportBatch(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a patient\'s mandates
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public getSepaMandatesForPatient(patientId: number, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).getSepaMandatesForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single SEPA transaction
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public getSepaTransaction(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).getSepaTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a transaction\'s lifecycle timeline (creation + every export attempt)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public getSepaTransactionTimeline(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).getSepaTransactionTimeline(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List export batches (keyset paginated) with optional filters
     * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
     * @param {number} [limit] Page size (1-100).
     * @param {string} [accountId] Filter by creditor account (Mandant) id.
     * @param {ListSepaExportBatchesDirectionEnum} [direction] Filter by direction.
     * @param {ListSepaExportBatchesStatusEnum} [status] Filter by batch status.
     * @param {string} [searchStr] Search export batches by batch number or the name of the user who created them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public listSepaExportBatches(cursor?: string, limit?: number, accountId?: string, direction?: ListSepaExportBatchesDirectionEnum, status?: ListSepaExportBatchesStatusEnum, searchStr?: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).listSepaExportBatches(cursor, limit, accountId, direction, status, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List SEPA transactions (keyset paginated) with optional filters
     * @param {string} [cursor] Opaque cursor returned as &#x60;nextCursor&#x60; by the previous page. Omit for the first page.
     * @param {number} [limit] Page size (1-100).
     * @param {string} [accountId] Filter by creditor/paying account id.
     * @param {ListSepaTransactionsDirectionEnum} [direction] 
     * @param {ListSepaTransactionsStatusEnum} [status] 
     * @param {string} [searchStr] Global spotlight search across the account\&#39;s transactions (ignores direction/status). Matches transaction number, patient name, or prescription (Rx) number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public listSepaTransactions(cursor?: string, limit?: number, accountId?: string, direction?: ListSepaTransactionsDirectionEnum, status?: ListSepaTransactionsStatusEnum, searchStr?: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).listSepaTransactions(cursor, limit, accountId, direction, status, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record a bank acknowledgement; the export\'s transactions become SETTLED
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public markSepaExportAccepted(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).markSepaExportAccepted(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record a bank rejection; the export\'s transactions become RETURNED
     * @param {string} id 
     * @param {RejectExportBatchDto} rejectExportBatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public markSepaExportRejected(id: string, rejectExportBatchDto: RejectExportBatchDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).markSepaExportRejected(id, rejectExportBatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a generated export as submitted to the bank (locks it against rollback)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public markSepaExportSent(id: string, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).markSepaExportSent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reverse (storno) a SEPA transaction: keeps the original visible and books a reversing entry
     * @param {string} id 
     * @param {ReverseSepaTransactionDto} reverseSepaTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public reverseSepaTransaction(id: string, reverseSepaTransactionDto: ReverseSepaTransactionDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).reverseSepaTransaction(id, reverseSepaTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a mandate
     * @param {string} id 
     * @param {RevokeMandateDto} revokeMandateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public revokeSepaMandate(id: string, revokeMandateDto: RevokeMandateDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).revokeSepaMandate(id, revokeMandateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Roll back a generated (not yet sent) export; its transactions return to PENDING
     * @param {string} id 
     * @param {UndoExportBatchDto} undoExportBatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public undoSepaExportBatch(id: string, undoExportBatchDto: UndoExportBatchDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).undoSepaExportBatch(id, undoExportBatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Correct a DRAFT mandate\'s bank details / cap / validity (active mandates are locked)
     * @param {string} id 
     * @param {UpdateMandateDto} updateMandateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public updateSepaMandate(id: string, updateMandateDto: UpdateMandateDto, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).updateSepaMandate(id, updateMandateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach the signed mandate document and confirm it to activate the mandate
     * @param {string} id 
     * @param {UploadSepaMandateSignedDocumentDocuTypeEnum} docuType 
     * @param {UploadSepaMandateSignedDocumentOwnerTypeEnum} ownerType 
     * @param {string} ownerId 
     * @param {File} file 
     * @param {string} signatureDate Actual date the debtor signed.
     * @param {string} confirmed Explicit confirmation the document is readable, signed and matches the data.
     * @param {boolean} [makeAccessible] 
     * @param {string} [rxId] 
     * @param {string} [noticeDefinitionDataId] 
     * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaApi
     */
    public uploadSepaMandateSignedDocument(id: string, docuType: UploadSepaMandateSignedDocumentDocuTypeEnum, ownerType: UploadSepaMandateSignedDocumentOwnerTypeEnum, ownerId: string, file: File, signatureDate: string, confirmed: string, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig) {
        return SepaApiFp(this.configuration).uploadSepaMandateSignedDocument(id, docuType, ownerType, ownerId, file, signatureDate, confirmed, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListSepaExportBatchesDirectionEnum = {
    DirectDebit: 'DIRECT_DEBIT',
    CreditTransfer: 'CREDIT_TRANSFER'
} as const;
export type ListSepaExportBatchesDirectionEnum = typeof ListSepaExportBatchesDirectionEnum[keyof typeof ListSepaExportBatchesDirectionEnum];
/**
 * @export
 */
export const ListSepaExportBatchesStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    SentToBank: 'SENT_TO_BANK',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Undone: 'UNDONE',
    Reversed: 'REVERSED'
} as const;
export type ListSepaExportBatchesStatusEnum = typeof ListSepaExportBatchesStatusEnum[keyof typeof ListSepaExportBatchesStatusEnum];
/**
 * @export
 */
export const ListSepaTransactionsDirectionEnum = {
    DirectDebit: 'DIRECT_DEBIT',
    CreditTransfer: 'CREDIT_TRANSFER'
} as const;
export type ListSepaTransactionsDirectionEnum = typeof ListSepaTransactionsDirectionEnum[keyof typeof ListSepaTransactionsDirectionEnum];
/**
 * @export
 */
export const ListSepaTransactionsStatusEnum = {
    Pending: 'PENDING',
    Exported: 'EXPORTED',
    Settled: 'SETTLED',
    Returned: 'RETURNED',
    Cancelled: 'CANCELLED',
    Reversed: 'REVERSED'
} as const;
export type ListSepaTransactionsStatusEnum = typeof ListSepaTransactionsStatusEnum[keyof typeof ListSepaTransactionsStatusEnum];
/**
 * @export
 */
export const UploadSepaMandateSignedDocumentDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;
export type UploadSepaMandateSignedDocumentDocuTypeEnum = typeof UploadSepaMandateSignedDocumentDocuTypeEnum[keyof typeof UploadSepaMandateSignedDocumentDocuTypeEnum];
/**
 * @export
 */
export const UploadSepaMandateSignedDocumentOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;
export type UploadSepaMandateSignedDocumentOwnerTypeEnum = typeof UploadSepaMandateSignedDocumentOwnerTypeEnum[keyof typeof UploadSepaMandateSignedDocumentOwnerTypeEnum];


/**
 * StorageApi - axios parameter creator
 * @export
 */
export const StorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {UploadDocumentDto} uploadDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyAPI: async (uploadDocumentDto: UploadDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadDocumentDto' is not null or undefined
            assertParamExists('dummyAPI', 'uploadDocumentDto', uploadDocumentDto)
            const localVarPath = `/storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UploadDocumentDocuTypeEnum} docuType 
         * @param {UploadDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument: async (docuType: UploadDocumentDocuTypeEnum, ownerType: UploadDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'docuType' is not null or undefined
            assertParamExists('uploadDocument', 'docuType', docuType)
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('uploadDocument', 'ownerType', ownerType)
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('uploadDocument', 'ownerId', ownerId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDocument', 'file', file)
            const localVarPath = `/storage/uploadDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (docuType !== undefined) { 
                localVarFormParams.append('docuType', docuType as any);
            }
    
            if (ownerType !== undefined) { 
                localVarFormParams.append('ownerType', ownerType as any);
            }
    
            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
    
            if (makeAccessible !== undefined) { 
                localVarFormParams.append('makeAccessible', makeAccessible as any);
            }
    
            if (rxId !== undefined) { 
                localVarFormParams.append('rxId', rxId as any);
            }
    
            if (noticeDefinitionDataId !== undefined) { 
                localVarFormParams.append('noticeDefinitionDataId', noticeDefinitionDataId as any);
            }
    
            if (scanToSearchablePdf !== undefined) { 
                localVarFormParams.append('scanToSearchablePdf', scanToSearchablePdf as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageApi - functional programming interface
 * @export
 */
export const StorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {UploadDocumentDto} uploadDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dummyAPI(uploadDocumentDto: UploadDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dummyAPI(uploadDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UploadDocumentDocuTypeEnum} docuType 
         * @param {UploadDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocument(docuType: UploadDocumentDocuTypeEnum, ownerType: UploadDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument(docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StorageApi - factory interface
 * @export
 */
export const StorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {UploadDocumentDto} uploadDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyAPI(uploadDocumentDto: UploadDocumentDto, options?: any): AxiosPromise<void> {
            return localVarFp.dummyAPI(uploadDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UploadDocumentDocuTypeEnum} docuType 
         * @param {UploadDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument(docuType: UploadDocumentDocuTypeEnum, ownerType: UploadDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.uploadDocument(docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageApi - object-oriented interface
 * @export
 * @class StorageApi
 * @extends {BaseAPI}
 */
export class StorageApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {UploadDocumentDto} uploadDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageApi
     */
    public dummyAPI(uploadDocumentDto: UploadDocumentDto, options?: AxiosRequestConfig) {
        return StorageApiFp(this.configuration).dummyAPI(uploadDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UploadDocumentDocuTypeEnum} docuType 
     * @param {UploadDocumentOwnerTypeEnum} ownerType 
     * @param {string} ownerId 
     * @param {File} file 
     * @param {boolean} [makeAccessible] 
     * @param {string} [rxId] 
     * @param {string} [noticeDefinitionDataId] 
     * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageApi
     */
    public uploadDocument(docuType: UploadDocumentDocuTypeEnum, ownerType: UploadDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig) {
        return StorageApiFp(this.configuration).uploadDocument(docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UploadDocumentDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;
export type UploadDocumentDocuTypeEnum = typeof UploadDocumentDocuTypeEnum[keyof typeof UploadDocumentDocuTypeEnum];
/**
 * @export
 */
export const UploadDocumentOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;
export type UploadDocumentOwnerTypeEnum = typeof UploadDocumentOwnerTypeEnum[keyof typeof UploadDocumentOwnerTypeEnum];


/**
 * TaxationApi - axios parameter creator
 * @export
 */
export const TaxationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authentication for Admin
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateAdmin: async (tssId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('authenticateAdmin', 'tssId', tssId)
            const localVarPath = `/taxation/admin-auth/{tssId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {ChangeAdminPinDto} changeAdminPinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAdminPin: async (tssId: string, changeAdminPinDto: ChangeAdminPinDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('changeAdminPin', 'tssId', tssId)
            // verify required parameter 'changeAdminPinDto' is not null or undefined
            assertParamExists('changeAdminPin', 'changeAdminPinDto', changeAdminPinDto)
            const localVarPath = `/taxation/admin-pin/{tssId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAdminPinDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Client (auto-generated IDs)
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientTSS: async (tssId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('createClientTSS', 'tssId', tssId)
            const localVarPath = `/taxation/client/{tssId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create TSS (one-time)
         * @param {BusinessLocationTssDto} businessLocationTssDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTss: async (businessLocationTssDto: BusinessLocationTssDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessLocationTssDto' is not null or undefined
            assertParamExists('createTss', 'businessLocationTssDto', businessLocationTssDto)
            const localVarPath = `/taxation/tss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(businessLocationTssDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download export file for a TSS or Client
         * @param {string} tssId TSS ID
         * @param {string} exportId Export ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExport: async (tssId: string, exportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('downloadExport', 'tssId', tssId)
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('downloadExport', 'exportId', exportId)
            const localVarPath = `/taxation/export/{tssId}/{exportId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)))
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger export for a TSS or Client
         * @param {ExportQueryDto} exportQueryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTss: async (exportQueryDto: ExportQueryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportQueryDto' is not null or undefined
            assertParamExists('exportTss', 'exportQueryDto', exportQueryDto)
            const localVarPath = `/taxation/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all transactions for a specific client with pagination and filtering
         * @param {string} tssId TSS ID
         * @param {string} clientId Client ID
         * @param {number} [limit] Number of transactions per page (1-100, default: 50)
         * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClientTransactions: async (tssId: string, clientId: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('getAllClientTransactions', 'tssId', tssId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAllClientTransactions', 'clientId', clientId)
            const localVarPath = `/taxation/tss/{tssId}/clients/{clientId}/transactions`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Client records from Fiskaly with optional sorting
         * @param {GetAllClientsOrderByEnum} [orderBy] Order Client results by serial_number or time_creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClients: async (orderBy?: GetAllClientsOrderByEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/taxation/client/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all TSS records from Fiskaly with optional sorting
         * @param {GetAllTssOrderByEnum} [orderBy] Order TSS results by description, state, or time_creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTss: async (orderBy?: GetAllTssOrderByEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/taxation/tss/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all export records for a specific TSS
         * @param {string} tssId TSS ID
         * @param {number} [limit] Number of transactions per page (1-100, default: 10)
         * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTssExports: async (tssId: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('getAllTssExports', 'tssId', tssId)
            const localVarPath = `/taxation/export/tss/all/{tssId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comprehensive dashboard statistics for TSS, Clients, and Exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/taxation/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TSS details by TSS ID
         * @param {string} tssId TSS ID to retrieve details for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTssById: async (tssId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('getTssById', 'tssId', tssId)
            const localVarPath = `/taxation/tss/{tssId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout Admin from TSS
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOutAdmin: async (tssId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tssId' is not null or undefined
            assertParamExists('logOutAdmin', 'tssId', tssId)
            const localVarPath = `/taxation/admin-logout/{tssId}`
                .replace(`{${"tssId"}}`, encodeURIComponent(String(tssId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Client State
         * @param {string} clientId Existing Client ID
         * @param {UpdateClientStateRequest} updateClientStateRequest Client state update payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientState: async (clientId: string, updateClientStateRequest: UpdateClientStateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateClientState', 'clientId', clientId)
            // verify required parameter 'updateClientStateRequest' is not null or undefined
            assertParamExists('updateClientState', 'updateClientStateRequest', updateClientStateRequest)
            const localVarPath = `/taxation/client/update/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update TSS state → UNINITIALIZED / INITIALIZED
         * @param {UpdateTssDto} updateTssDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTss: async (updateTssDto: UpdateTssDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTssDto' is not null or undefined
            assertParamExists('updateTss', 'updateTssDto', updateTssDto)
            const localVarPath = `/taxation/tss/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTssDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxationApi - functional programming interface
 * @export
 */
export const TaxationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authentication for Admin
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateAdmin(tssId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateAdmin(tssId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {ChangeAdminPinDto} changeAdminPinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAdminPin(tssId: string, changeAdminPinDto: ChangeAdminPinDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAdminPin(tssId, changeAdminPinDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Client (auto-generated IDs)
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientTSS(tssId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClientTSS(tssId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create TSS (one-time)
         * @param {BusinessLocationTssDto} businessLocationTssDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTss(businessLocationTssDto: BusinessLocationTssDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TssInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTss(businessLocationTssDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download export file for a TSS or Client
         * @param {string} tssId TSS ID
         * @param {string} exportId Export ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadExport(tssId: string, exportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadExport(tssId, exportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Trigger export for a TSS or Client
         * @param {ExportQueryDto} exportQueryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTss(exportQueryDto: ExportQueryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTss(exportQueryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all transactions for a specific client with pagination and filtering
         * @param {string} tssId TSS ID
         * @param {string} clientId Client ID
         * @param {number} [limit] Number of transactions per page (1-100, default: 50)
         * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClientTransactions(tssId: string, clientId: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClientTransactions(tssId, clientId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Client records from Fiskaly with optional sorting
         * @param {GetAllClientsOrderByEnum} [orderBy] Order Client results by serial_number or time_creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClients(orderBy?: GetAllClientsOrderByEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FiskalyClientResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClients(orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all TSS records from Fiskaly with optional sorting
         * @param {GetAllTssOrderByEnum} [orderBy] Order TSS results by description, state, or time_creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTss(orderBy?: GetAllTssOrderByEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FiskalyTssResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTss(orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all export records for a specific TSS
         * @param {string} tssId TSS ID
         * @param {number} [limit] Number of transactions per page (1-100, default: 10)
         * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTssExports(tssId: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportTransactionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTssExports(tssId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comprehensive dashboard statistics for TSS, Clients, and Exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get TSS details by TSS ID
         * @param {string} tssId TSS ID to retrieve details for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTssById(tssId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiskalyTssResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTssById(tssId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout Admin from TSS
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logOutAdmin(tssId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logOutAdmin(tssId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Client State
         * @param {string} clientId Existing Client ID
         * @param {UpdateClientStateRequest} updateClientStateRequest Client state update payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientState(clientId: string, updateClientStateRequest: UpdateClientStateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientState(clientId, updateClientStateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update TSS state → UNINITIALIZED / INITIALIZED
         * @param {UpdateTssDto} updateTssDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTss(updateTssDto: UpdateTssDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TssInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTss(updateTssDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaxationApi - factory interface
 * @export
 */
export const TaxationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxationApiFp(configuration)
    return {
        /**
         * 
         * @summary Authentication for Admin
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateAdmin(tssId: string, options?: any): AxiosPromise<void> {
            return localVarFp.authenticateAdmin(tssId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {ChangeAdminPinDto} changeAdminPinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAdminPin(tssId: string, changeAdminPinDto: ChangeAdminPinDto, options?: any): AxiosPromise<void> {
            return localVarFp.changeAdminPin(tssId, changeAdminPinDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Client (auto-generated IDs)
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientTSS(tssId: string, options?: any): AxiosPromise<ClientInfoDto> {
            return localVarFp.createClientTSS(tssId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create TSS (one-time)
         * @param {BusinessLocationTssDto} businessLocationTssDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTss(businessLocationTssDto: BusinessLocationTssDto, options?: any): AxiosPromise<TssInfoDto> {
            return localVarFp.createTss(businessLocationTssDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download export file for a TSS or Client
         * @param {string} tssId TSS ID
         * @param {string} exportId Export ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExport(tssId: string, exportId: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadExport(tssId, exportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger export for a TSS or Client
         * @param {ExportQueryDto} exportQueryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTss(exportQueryDto: ExportQueryDto, options?: any): AxiosPromise<void> {
            return localVarFp.exportTss(exportQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all transactions for a specific client with pagination and filtering
         * @param {string} tssId TSS ID
         * @param {string} clientId Client ID
         * @param {number} [limit] Number of transactions per page (1-100, default: 50)
         * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClientTransactions(tssId: string, clientId: string, limit?: number, offset?: number, options?: any): AxiosPromise<TransactionsResponseDto> {
            return localVarFp.getAllClientTransactions(tssId, clientId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Client records from Fiskaly with optional sorting
         * @param {GetAllClientsOrderByEnum} [orderBy] Order Client results by serial_number or time_creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClients(orderBy?: GetAllClientsOrderByEnum, options?: any): AxiosPromise<Array<FiskalyClientResponseDto>> {
            return localVarFp.getAllClients(orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all TSS records from Fiskaly with optional sorting
         * @param {GetAllTssOrderByEnum} [orderBy] Order TSS results by description, state, or time_creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTss(orderBy?: GetAllTssOrderByEnum, options?: any): AxiosPromise<Array<FiskalyTssResponseDto>> {
            return localVarFp.getAllTss(orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all export records for a specific TSS
         * @param {string} tssId TSS ID
         * @param {number} [limit] Number of transactions per page (1-100, default: 10)
         * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTssExports(tssId: string, limit?: number, offset?: number, options?: any): AxiosPromise<ExportTransactionsResponseDto> {
            return localVarFp.getAllTssExports(tssId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comprehensive dashboard statistics for TSS, Clients, and Exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardStats(options?: any): AxiosPromise<GetDashboardStats200Response> {
            return localVarFp.getDashboardStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TSS details by TSS ID
         * @param {string} tssId TSS ID to retrieve details for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTssById(tssId: string, options?: any): AxiosPromise<FiskalyTssResponseDto> {
            return localVarFp.getTssById(tssId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout Admin from TSS
         * @param {string} tssId Existing INITIALIZED TSS ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOutAdmin(tssId: string, options?: any): AxiosPromise<void> {
            return localVarFp.logOutAdmin(tssId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Client State
         * @param {string} clientId Existing Client ID
         * @param {UpdateClientStateRequest} updateClientStateRequest Client state update payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientState(clientId: string, updateClientStateRequest: UpdateClientStateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateClientState(clientId, updateClientStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update TSS state → UNINITIALIZED / INITIALIZED
         * @param {UpdateTssDto} updateTssDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTss(updateTssDto: UpdateTssDto, options?: any): AxiosPromise<TssInfoDto> {
            return localVarFp.updateTss(updateTssDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxationApi - object-oriented interface
 * @export
 * @class TaxationApi
 * @extends {BaseAPI}
 */
export class TaxationApi extends BaseAPI {
    /**
     * 
     * @summary Authentication for Admin
     * @param {string} tssId Existing INITIALIZED TSS ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public authenticateAdmin(tssId: string, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).authenticateAdmin(tssId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} tssId Existing INITIALIZED TSS ID
     * @param {ChangeAdminPinDto} changeAdminPinDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public changeAdminPin(tssId: string, changeAdminPinDto: ChangeAdminPinDto, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).changeAdminPin(tssId, changeAdminPinDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Client (auto-generated IDs)
     * @param {string} tssId Existing INITIALIZED TSS ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public createClientTSS(tssId: string, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).createClientTSS(tssId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create TSS (one-time)
     * @param {BusinessLocationTssDto} businessLocationTssDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public createTss(businessLocationTssDto: BusinessLocationTssDto, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).createTss(businessLocationTssDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download export file for a TSS or Client
     * @param {string} tssId TSS ID
     * @param {string} exportId Export ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public downloadExport(tssId: string, exportId: string, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).downloadExport(tssId, exportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger export for a TSS or Client
     * @param {ExportQueryDto} exportQueryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public exportTss(exportQueryDto: ExportQueryDto, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).exportTss(exportQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all transactions for a specific client with pagination and filtering
     * @param {string} tssId TSS ID
     * @param {string} clientId Client ID
     * @param {number} [limit] Number of transactions per page (1-100, default: 50)
     * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public getAllClientTransactions(tssId: string, clientId: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).getAllClientTransactions(tssId, clientId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Client records from Fiskaly with optional sorting
     * @param {GetAllClientsOrderByEnum} [orderBy] Order Client results by serial_number or time_creation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public getAllClients(orderBy?: GetAllClientsOrderByEnum, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).getAllClients(orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all TSS records from Fiskaly with optional sorting
     * @param {GetAllTssOrderByEnum} [orderBy] Order TSS results by description, state, or time_creation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public getAllTss(orderBy?: GetAllTssOrderByEnum, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).getAllTss(orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all export records for a specific TSS
     * @param {string} tssId TSS ID
     * @param {number} [limit] Number of transactions per page (1-100, default: 10)
     * @param {number} [offset] Offset for pagination (number of transactions to skip, default: 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public getAllTssExports(tssId: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).getAllTssExports(tssId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comprehensive dashboard statistics for TSS, Clients, and Exports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public getDashboardStats(options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).getDashboardStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TSS details by TSS ID
     * @param {string} tssId TSS ID to retrieve details for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public getTssById(tssId: string, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).getTssById(tssId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout Admin from TSS
     * @param {string} tssId Existing INITIALIZED TSS ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public logOutAdmin(tssId: string, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).logOutAdmin(tssId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Client State
     * @param {string} clientId Existing Client ID
     * @param {UpdateClientStateRequest} updateClientStateRequest Client state update payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public updateClientState(clientId: string, updateClientStateRequest: UpdateClientStateRequest, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).updateClientState(clientId, updateClientStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update TSS state → UNINITIALIZED / INITIALIZED
     * @param {UpdateTssDto} updateTssDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxationApi
     */
    public updateTss(updateTssDto: UpdateTssDto, options?: AxiosRequestConfig) {
        return TaxationApiFp(this.configuration).updateTss(updateTssDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllClientsOrderByEnum = {
    SerialNumber: 'serial_number',
    TimeCreation: 'time_creation'
} as const;
export type GetAllClientsOrderByEnum = typeof GetAllClientsOrderByEnum[keyof typeof GetAllClientsOrderByEnum];
/**
 * @export
 */
export const GetAllTssOrderByEnum = {
    Description: 'description',
    State: 'state',
    TimeCreation: 'time_creation'
} as const;
export type GetAllTssOrderByEnum = typeof GetAllTssOrderByEnum[keyof typeof GetAllTssOrderByEnum];


/**
 * TemplateApi - axios parameter creator
 * @export
 */
export const TemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a template
         * @param {string} title Title of the template
         * @param {string} type Tyoe of the template
         * @param {CreateHtmlHandlerBarTemplateTemplateFormatEnum} templateFormat Template format type (e.g., HTML, DOCX)
         * @param {Array<string>} templateVariableKeys The template variables used from variable registry
         * @param {string} [description] Description of the template
         * @param {string} [template] Raw content of the template (e.g., Handlebars HTML)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHtmlHandlerBarTemplate: async (title: string, type: string, templateFormat: CreateHtmlHandlerBarTemplateTemplateFormatEnum, templateVariableKeys: Array<string>, description?: string, template?: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('createHtmlHandlerBarTemplate', 'title', title)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('createHtmlHandlerBarTemplate', 'type', type)
            // verify required parameter 'templateFormat' is not null or undefined
            assertParamExists('createHtmlHandlerBarTemplate', 'templateFormat', templateFormat)
            // verify required parameter 'templateVariableKeys' is not null or undefined
            assertParamExists('createHtmlHandlerBarTemplate', 'templateVariableKeys', templateVariableKeys)
            const localVarPath = `/template/createHtmlHandlerBarTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (templateFormat !== undefined) { 
                localVarFormParams.append('templateFormat', templateFormat as any);
            }
    
            if (template !== undefined) { 
                localVarFormParams.append('template', template as any);
            }
                if (templateVariableKeys) {
                localVarFormParams.append('templateVariableKeys', templateVariableKeys.join(COLLECTION_FORMATS.csv));
            }

    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateApi - functional programming interface
 * @export
 */
export const TemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a template
         * @param {string} title Title of the template
         * @param {string} type Tyoe of the template
         * @param {CreateHtmlHandlerBarTemplateTemplateFormatEnum} templateFormat Template format type (e.g., HTML, DOCX)
         * @param {Array<string>} templateVariableKeys The template variables used from variable registry
         * @param {string} [description] Description of the template
         * @param {string} [template] Raw content of the template (e.g., Handlebars HTML)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHtmlHandlerBarTemplate(title: string, type: string, templateFormat: CreateHtmlHandlerBarTemplateTemplateFormatEnum, templateVariableKeys: Array<string>, description?: string, template?: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHtmlHandlerBarTemplate(title, type, templateFormat, templateVariableKeys, description, template, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateApi - factory interface
 * @export
 */
export const TemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a template
         * @param {string} title Title of the template
         * @param {string} type Tyoe of the template
         * @param {CreateHtmlHandlerBarTemplateTemplateFormatEnum} templateFormat Template format type (e.g., HTML, DOCX)
         * @param {Array<string>} templateVariableKeys The template variables used from variable registry
         * @param {string} [description] Description of the template
         * @param {string} [template] Raw content of the template (e.g., Handlebars HTML)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHtmlHandlerBarTemplate(title: string, type: string, templateFormat: CreateHtmlHandlerBarTemplateTemplateFormatEnum, templateVariableKeys: Array<string>, description?: string, template?: string, file?: File, options?: any): AxiosPromise<object> {
            return localVarFp.createHtmlHandlerBarTemplate(title, type, templateFormat, templateVariableKeys, description, template, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
export class TemplateApi extends BaseAPI {
    /**
     * 
     * @summary Create a template
     * @param {string} title Title of the template
     * @param {string} type Tyoe of the template
     * @param {CreateHtmlHandlerBarTemplateTemplateFormatEnum} templateFormat Template format type (e.g., HTML, DOCX)
     * @param {Array<string>} templateVariableKeys The template variables used from variable registry
     * @param {string} [description] Description of the template
     * @param {string} [template] Raw content of the template (e.g., Handlebars HTML)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public createHtmlHandlerBarTemplate(title: string, type: string, templateFormat: CreateHtmlHandlerBarTemplateTemplateFormatEnum, templateVariableKeys: Array<string>, description?: string, template?: string, file?: File, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).createHtmlHandlerBarTemplate(title, type, templateFormat, templateVariableKeys, description, template, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CreateHtmlHandlerBarTemplateTemplateFormatEnum = {
    HtmlHandlebar: 'HTML_HANDLEBAR'
} as const;
export type CreateHtmlHandlerBarTemplateTemplateFormatEnum = typeof CreateHtmlHandlerBarTemplateTemplateFormatEnum[keyof typeof CreateHtmlHandlerBarTemplateTemplateFormatEnum];


/**
 * TestApi - axios parameter creator
 * @export
 */
export const TestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Debug SEPA data in detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugSepaData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/debug-sepa-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attempt to fix SEPA data issues by creating test data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixSepaData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/fix-sepa-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Simple test endpoint without auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testBackend: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/test-backend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test SEPA database connection without auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSepaData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/test-sepa-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApi - functional programming interface
 * @export
 */
export const TestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Debug SEPA data in detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugSepaData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debugSepaData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Attempt to fix SEPA data issues by creating test data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixSepaData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixSepaData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Simple test endpoint without auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testBackend(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testBackend(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Test SEPA database connection without auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSepaData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSepaData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestApi - factory interface
 * @export
 */
export const TestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiFp(configuration)
    return {
        /**
         * 
         * @summary Debug SEPA data in detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugSepaData(options?: any): AxiosPromise<void> {
            return localVarFp.debugSepaData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attempt to fix SEPA data issues by creating test data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixSepaData(options?: any): AxiosPromise<void> {
            return localVarFp.fixSepaData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Simple test endpoint without auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testBackend(options?: any): AxiosPromise<void> {
            return localVarFp.testBackend(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test SEPA database connection without auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSepaData(options?: any): AxiosPromise<void> {
            return localVarFp.testSepaData(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestApi - object-oriented interface
 * @export
 * @class TestApi
 * @extends {BaseAPI}
 */
export class TestApi extends BaseAPI {
    /**
     * 
     * @summary Debug SEPA data in detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public debugSepaData(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).debugSepaData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attempt to fix SEPA data issues by creating test data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public fixSepaData(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).fixSepaData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Simple test endpoint without auth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public testBackend(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).testBackend(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test SEPA database connection without auth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public testSepaData(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).testSepaData(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketsApi - axios parameter creator
 * @export
 */
export const TicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new comment if activityId is not provided, updates existing comment if activityId is provided
         * @summary Create new comment or update existing comment
         * @param {number} id 
         * @param {CommentRequestDto} commentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateComment: async (id: number, commentRequestDto: CommentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createOrUpdateComment', 'id', id)
            // verify required parameter 'commentRequestDto' is not null or undefined
            assertParamExists('createOrUpdateComment', 'commentRequestDto', commentRequestDto)
            const localVarPath = `/tickets/createOrUpdateComment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new reminder for an existing ticket
         * @summary Create a new reminder
         * @param {number} ticketId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReminder: async (ticketId: number, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('createReminder', 'ticketId', ticketId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createReminder', 'body', body)
            const localVarPath = `/tickets/{ticketId}/reminders`
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {TicketDto} ticketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket: async (ticketDto: TicketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketDto' is not null or undefined
            assertParamExists('createTicket', 'ticketDto', ticketDto)
            const localVarPath = `/tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteComment', 'id', id)
            const localVarPath = `/tickets/deleteComment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a reminder by its ID
         * @summary Delete a reminder
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReminder: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReminder', 'id', id)
            const localVarPath = `/tickets/reminder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a reminder\'s status, date, and alternative message
         * @summary Edit a reminder
         * @param {number} id 
         * @param {ReminderDto} reminderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReminder: async (id: number, reminderDto: ReminderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editReminder', 'id', id)
            // verify required parameter 'reminderDto' is not null or undefined
            assertParamExists('editReminder', 'reminderDto', reminderDto)
            const localVarPath = `/tickets/reminder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all activities with filters
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {GetAllTicketActivitiesSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {Array<GetAllTicketActivitiesTypeEnum>} [type] 
         * @param {number} [ticketId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTicketActivities: async (limit?: number, page?: number, sortOrder?: GetAllTicketActivitiesSortOrderEnum, type?: Array<GetAllTicketActivitiesTypeEnum>, ticketId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tickets/getAllTicketActivities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {FindAllTicketsQueryFilters} findAllTicketsQueryFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTickets: async (findAllTicketsQueryFilters: FindAllTicketsQueryFilters, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findAllTicketsQueryFilters' is not null or undefined
            assertParamExists('getAllTickets', 'findAllTicketsQueryFilters', findAllTicketsQueryFilters)
            const localVarPath = `/tickets/getAllTickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findAllTicketsQueryFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentTickets: async (appointmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentTickets', 'appointmentId', appointmentId)
            const localVarPath = `/tickets/getAppointmentTickets/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} entities 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTicketTypes: async (entities: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entities' is not null or undefined
            assertParamExists('getEntityTicketTypes', 'entities', entities)
            const localVarPath = `/tickets/entityTicketTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entities) {
                localVarQueryParameter['entities'] = entities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId Location ID to filter tickets
         * @param {GetExpiredTicketsDigestTypeEnum} [digestType] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiredTickets: async (locationId: string, digestType?: GetExpiredTicketsDigestTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getExpiredTickets', 'locationId', locationId)
            const localVarPath = `/tickets/getExpiredTickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (digestType !== undefined) {
                localVarQueryParameter['digestType'] = digestType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientTickets: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientTickets', 'patientId', patientId)
            const localVarPath = `/tickets/getPatienttickets/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTicketById', 'id', id)
            const localVarPath = `/tickets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketFilters: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tickets/ticketFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketFlatFilters: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tickets/ticketFlatFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} date Target date in YYYY-MM-DD format
         * @param {string} locationId Location ID to filter tickets
         * @param {GetTicketsByDateDigestTypeEnum} [digestType] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsByDate: async (date: string, locationId: string, digestType?: GetTicketsByDateDigestTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getTicketsByDate', 'date', date)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getTicketsByDate', 'locationId', locationId)
            const localVarPath = `/tickets/getTicketsByDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (digestType !== undefined) {
                localVarQueryParameter['digestType'] = digestType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {ActivityDto} activityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postorUpateComment: async (id: number, activityDto: ActivityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postorUpateComment', 'id', id)
            // verify required parameter 'activityDto' is not null or undefined
            assertParamExists('postorUpateComment', 'activityDto', activityDto)
            const localVarPath = `/tickets/postorUpateComment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {TicketDto} ticketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTickets: async (id: number, ticketDto: TicketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTickets', 'id', id)
            // verify required parameter 'ticketDto' is not null or undefined
            assertParamExists('updateTickets', 'ticketDto', ticketDto)
            const localVarPath = `/tickets/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketsApi - functional programming interface
 * @export
 */
export const TicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new comment if activityId is not provided, updates existing comment if activityId is provided
         * @summary Create new comment or update existing comment
         * @param {number} id 
         * @param {CommentRequestDto} commentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateComment(id: number, commentRequestDto: CommentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateComment(id, commentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new reminder for an existing ticket
         * @summary Create a new reminder
         * @param {number} ticketId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReminder(ticketId: number, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReminder(ticketId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {TicketDto} ticketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicket(ticketDto: TicketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicket(ticketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a reminder by its ID
         * @summary Delete a reminder
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReminder(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReminder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates a reminder\'s status, date, and alternative message
         * @summary Edit a reminder
         * @param {number} id 
         * @param {ReminderDto} reminderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editReminder(id: number, reminderDto: ReminderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editReminder(id, reminderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all activities with filters
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {GetAllTicketActivitiesSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {Array<GetAllTicketActivitiesTypeEnum>} [type] 
         * @param {number} [ticketId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTicketActivities(limit?: number, page?: number, sortOrder?: GetAllTicketActivitiesSortOrderEnum, type?: Array<GetAllTicketActivitiesTypeEnum>, ticketId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTicketActivities(limit, page, sortOrder, type, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {FindAllTicketsQueryFilters} findAllTicketsQueryFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTickets(findAllTicketsQueryFilters: FindAllTicketsQueryFilters, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTickets(findAllTicketsQueryFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentTickets(appointmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentTickets(appointmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} entities 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTicketTypes(entities: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityTicketTypesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTicketTypes(entities, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId Location ID to filter tickets
         * @param {GetExpiredTicketsDigestTypeEnum} [digestType] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpiredTickets(locationId: string, digestType?: GetExpiredTicketsDigestTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExpiredTicketDigestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpiredTickets(locationId, digestType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientTickets(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientTickets(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketFilters(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketFilterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketFilters(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketFlatFilters(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketFlatFilterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketFlatFilters(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} date Target date in YYYY-MM-DD format
         * @param {string} locationId Location ID to filter tickets
         * @param {GetTicketsByDateDigestTypeEnum} [digestType] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketsByDate(date: string, locationId: string, digestType?: GetTicketsByDateDigestTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketsByDateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketsByDate(date, locationId, digestType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {ActivityDto} activityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postorUpateComment(id: number, activityDto: ActivityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postorUpateComment(id, activityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {TicketDto} ticketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTickets(id: number, ticketDto: TicketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTickets(id, ticketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TicketsApi - factory interface
 * @export
 */
export const TicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketsApiFp(configuration)
    return {
        /**
         * Creates a new comment if activityId is not provided, updates existing comment if activityId is provided
         * @summary Create new comment or update existing comment
         * @param {number} id 
         * @param {CommentRequestDto} commentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateComment(id: number, commentRequestDto: CommentRequestDto, options?: any): AxiosPromise<ActivityDto> {
            return localVarFp.createOrUpdateComment(id, commentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new reminder for an existing ticket
         * @summary Create a new reminder
         * @param {number} ticketId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReminder(ticketId: number, body: object, options?: any): AxiosPromise<ReminderDto> {
            return localVarFp.createReminder(ticketId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {TicketDto} ticketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket(ticketDto: TicketDto, options?: any): AxiosPromise<TicketDto> {
            return localVarFp.createTicket(ticketDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteComment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a reminder by its ID
         * @summary Delete a reminder
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReminder(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteReminder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a reminder\'s status, date, and alternative message
         * @summary Edit a reminder
         * @param {number} id 
         * @param {ReminderDto} reminderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReminder(id: number, reminderDto: ReminderDto, options?: any): AxiosPromise<void> {
            return localVarFp.editReminder(id, reminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all activities with filters
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {GetAllTicketActivitiesSortOrderEnum} [sortOrder] Sorting order: asc or desc
         * @param {Array<GetAllTicketActivitiesTypeEnum>} [type] 
         * @param {number} [ticketId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTicketActivities(limit?: number, page?: number, sortOrder?: GetAllTicketActivitiesSortOrderEnum, type?: Array<GetAllTicketActivitiesTypeEnum>, ticketId?: number, options?: any): AxiosPromise<Array<ActivityDto>> {
            return localVarFp.getAllTicketActivities(limit, page, sortOrder, type, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {FindAllTicketsQueryFilters} findAllTicketsQueryFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTickets(findAllTicketsQueryFilters: FindAllTicketsQueryFilters, options?: any): AxiosPromise<Array<TicketDto>> {
            return localVarFp.getAllTickets(findAllTicketsQueryFilters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentTickets(appointmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getAppointmentTickets(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<string>} entities 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTicketTypes(entities: Array<string>, options?: any): AxiosPromise<Array<EntityTicketTypesDto>> {
            return localVarFp.getEntityTicketTypes(entities, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId Location ID to filter tickets
         * @param {GetExpiredTicketsDigestTypeEnum} [digestType] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiredTickets(locationId: string, digestType?: GetExpiredTicketsDigestTypeEnum, userId?: string, options?: any): AxiosPromise<Array<ExpiredTicketDigestDto>> {
            return localVarFp.getExpiredTickets(locationId, digestType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientTickets(patientId: number, options?: any): AxiosPromise<void> {
            return localVarFp.getPatientTickets(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketById(id: number, options?: any): AxiosPromise<TicketDto> {
            return localVarFp.getTicketById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketFilters(options?: any): AxiosPromise<Array<TicketFilterDto>> {
            return localVarFp.getTicketFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketFlatFilters(options?: any): AxiosPromise<TicketFlatFilterDto> {
            return localVarFp.getTicketFlatFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} date Target date in YYYY-MM-DD format
         * @param {string} locationId Location ID to filter tickets
         * @param {GetTicketsByDateDigestTypeEnum} [digestType] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsByDate(date: string, locationId: string, digestType?: GetTicketsByDateDigestTypeEnum, userId?: string, options?: any): AxiosPromise<Array<TicketsByDateDto>> {
            return localVarFp.getTicketsByDate(date, locationId, digestType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {ActivityDto} activityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postorUpateComment(id: number, activityDto: ActivityDto, options?: any): AxiosPromise<void> {
            return localVarFp.postorUpateComment(id, activityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {TicketDto} ticketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTickets(id: number, ticketDto: TicketDto, options?: any): AxiosPromise<TicketDto> {
            return localVarFp.updateTickets(id, ticketDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketsApi - object-oriented interface
 * @export
 * @class TicketsApi
 * @extends {BaseAPI}
 */
export class TicketsApi extends BaseAPI {
    /**
     * Creates a new comment if activityId is not provided, updates existing comment if activityId is provided
     * @summary Create new comment or update existing comment
     * @param {number} id 
     * @param {CommentRequestDto} commentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createOrUpdateComment(id: number, commentRequestDto: CommentRequestDto, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createOrUpdateComment(id, commentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new reminder for an existing ticket
     * @summary Create a new reminder
     * @param {number} ticketId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createReminder(ticketId: number, body: object, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createReminder(ticketId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {TicketDto} ticketDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicket(ticketDto: TicketDto, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicket(ticketDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deleteComment(id: string, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deleteComment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a reminder by its ID
     * @summary Delete a reminder
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deleteReminder(id: number, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deleteReminder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a reminder\'s status, date, and alternative message
     * @summary Edit a reminder
     * @param {number} id 
     * @param {ReminderDto} reminderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public editReminder(id: number, reminderDto: ReminderDto, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).editReminder(id, reminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all activities with filters
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {GetAllTicketActivitiesSortOrderEnum} [sortOrder] Sorting order: asc or desc
     * @param {Array<GetAllTicketActivitiesTypeEnum>} [type] 
     * @param {number} [ticketId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getAllTicketActivities(limit?: number, page?: number, sortOrder?: GetAllTicketActivitiesSortOrderEnum, type?: Array<GetAllTicketActivitiesTypeEnum>, ticketId?: number, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getAllTicketActivities(limit, page, sortOrder, type, ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {FindAllTicketsQueryFilters} findAllTicketsQueryFilters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getAllTickets(findAllTicketsQueryFilters: FindAllTicketsQueryFilters, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getAllTickets(findAllTicketsQueryFilters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getAppointmentTickets(appointmentId: string, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getAppointmentTickets(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<string>} entities 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getEntityTicketTypes(entities: Array<string>, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getEntityTicketTypes(entities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId Location ID to filter tickets
     * @param {GetExpiredTicketsDigestTypeEnum} [digestType] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getExpiredTickets(locationId: string, digestType?: GetExpiredTicketsDigestTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getExpiredTickets(locationId, digestType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getPatientTickets(patientId: number, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getPatientTickets(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketById(id: number, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketFilters(options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketFlatFilters(options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketFlatFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} date Target date in YYYY-MM-DD format
     * @param {string} locationId Location ID to filter tickets
     * @param {GetTicketsByDateDigestTypeEnum} [digestType] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketsByDate(date: string, locationId: string, digestType?: GetTicketsByDateDigestTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketsByDate(date, locationId, digestType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {ActivityDto} activityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public postorUpateComment(id: number, activityDto: ActivityDto, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).postorUpateComment(id, activityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {TicketDto} ticketDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTickets(id: number, ticketDto: TicketDto, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTickets(id, ticketDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllTicketActivitiesSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetAllTicketActivitiesSortOrderEnum = typeof GetAllTicketActivitiesSortOrderEnum[keyof typeof GetAllTicketActivitiesSortOrderEnum];
/**
 * @export
 */
export const GetAllTicketActivitiesTypeEnum = {
    Comments: 'COMMENTS',
    History: 'HISTORY'
} as const;
export type GetAllTicketActivitiesTypeEnum = typeof GetAllTicketActivitiesTypeEnum[keyof typeof GetAllTicketActivitiesTypeEnum];
/**
 * @export
 */
export const GetExpiredTicketsDigestTypeEnum = {
    Team: 'team',
    Personal: 'personal',
    Rx: 'rx'
} as const;
export type GetExpiredTicketsDigestTypeEnum = typeof GetExpiredTicketsDigestTypeEnum[keyof typeof GetExpiredTicketsDigestTypeEnum];
/**
 * @export
 */
export const GetTicketsByDateDigestTypeEnum = {
    Team: 'team',
    Personal: 'personal',
    Rx: 'rx'
} as const;
export type GetTicketsByDateDigestTypeEnum = typeof GetTicketsByDateDigestTypeEnum[keyof typeof GetTicketsByDateDigestTypeEnum];


/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all tickets associated with an insurance transaction
         * @param {string} transactionId Please provide a valid transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTicketsByTransactionId: async (transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('allTicketsByTransactionId', 'transactionId', transactionId)
            const localVarPath = `/transactions/insurance/tickets/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns detailed unpaid bills information for a specific patient. (excluding BG, perpetual, without dates Rxs along with Rx with rechnung)
         * @summary Get a warning badge for unpaid bills
         * @param {number} pid Numeric patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgesForUnpaidBills: async (pid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('badgesForUnpaidBills', 'pid', pid)
            const localVarPath = `/transactions/patient/bill/unpaid/badge/{pid}`
                .replace(`{${"pid"}}`, encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk soft delete multiple LastSchrift transactions and optionally their associated Rechnungen
         * @param {BulkSoftDeleteLastSchriftsRequest} bulkSoftDeleteLastSchriftsRequest LastSchrift IDs and options for bulk deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSoftDeleteLastSchrifts: async (bulkSoftDeleteLastSchriftsRequest: BulkSoftDeleteLastSchriftsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSoftDeleteLastSchriftsRequest' is not null or undefined
            assertParamExists('bulkSoftDeleteLastSchrifts', 'bulkSoftDeleteLastSchriftsRequest', bulkSoftDeleteLastSchriftsRequest)
            const localVarPath = `/transactions/lastschrift/delete/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSoftDeleteLastSchriftsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original Bank Transfer transaction to cancel
         * @param {object} body Reason for cancelling the Bank Transfer transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBankTransfer: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelBankTransfer', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('cancelBankTransfer', 'body', body)
            const localVarPath = `/transactions/bank-transfer/cancel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original cash transaction to cancel
         * @param {object} body Reason for cancelling the cash transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCashTransaction: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelCashTransaction', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('cancelCashTransaction', 'body', body)
            const localVarPath = `/transactions/cash-transaction/cancel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original EC transaction to cancel
         * @param {object} body Reason for cancelling the EC transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelECTransaction: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelECTransaction', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('cancelECTransaction', 'body', body)
            const localVarPath = `/transactions/ec-transaction/cancel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateBankTransferDto} createBankTransferDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransferForRechnung: async (createBankTransferDto: CreateBankTransferDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBankTransferDto' is not null or undefined
            assertParamExists('createBankTransferForRechnung', 'createBankTransferDto', createBankTransferDto)
            const localVarPath = `/transactions/rechnung/banktransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBankTransferDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillReminderForRechnung: async (rId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rId' is not null or undefined
            assertParamExists('createBillReminderForRechnung', 'rId', rId)
            const localVarPath = `/transactions/reminder/create/{rId}`
                .replace(`{${"rId"}}`, encodeURIComponent(String(rId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint creates or updates credit permissions for SEPA credit transfer (refund) transactions. For direct debits, use the /debitPermission endpoint instead.
         * @summary Create or update a credit permission (bank account for refunds)
         * @param {DebitPermissionDto} debitPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateCreditPermission: async (debitPermissionDto: DebitPermissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'debitPermissionDto' is not null or undefined
            assertParamExists('createOrUpdateCreditPermission', 'debitPermissionDto', debitPermissionDto)
            const localVarPath = `/transactions/creditPermission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(debitPermissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint creates or updates debit permissions for SEPA direct debit transactions. For refunds, use the /creditPermission endpoint instead.
         * @summary Create or update a debit permission (bank account for direct debits)
         * @param {number} patientId 
         * @param {DebitPermissionDto} debitPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateDebitPermission: async (patientId: number, debitPermissionDto: DebitPermissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createOrUpdateDebitPermission', 'patientId', patientId)
            // verify required parameter 'debitPermissionDto' is not null or undefined
            assertParamExists('createOrUpdateDebitPermission', 'debitPermissionDto', debitPermissionDto)
            const localVarPath = `/transactions/debitPermission/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(debitPermissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateRechnungDto} createRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRechnung: async (createRechnungDto: CreateRechnungDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRechnungDto' is not null or undefined
            assertParamExists('createRechnung', 'createRechnungDto', createRechnungDto)
            const localVarPath = `/transactions/rechnung`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRechnungDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a refund (LastSchrift with type=REFUND) using a patient\'s credit permission. Amount is stored as negative in database for accounting purposes (money leaving practice), but will be converted to positive when exporting to SEPA XML.
         * @summary Create a refund transaction using credit permission
         * @param {CreateRefundDto} createRefundDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund: async (createRefundDto: CreateRefundDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRefundDto' is not null or undefined
            assertParamExists('createRefund', 'createRefundDto', createRefundDto)
            const localVarPath = `/transactions/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRefundDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateServiceRechnungDto} createServiceRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceRechnung: async (createServiceRechnungDto: CreateServiceRechnungDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createServiceRechnungDto' is not null or undefined
            assertParamExists('createServiceRechnung', 'createServiceRechnungDto', createServiceRechnungDto)
            const localVarPath = `/transactions/serviceRechnung`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createServiceRechnungDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary A generic transaction creation endpoint for services
         * @param {CreateServicesTransactionDto} createServicesTransactionDto 
         * @param {boolean} [isGiftCertificate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServicesTransaction: async (createServicesTransactionDto: CreateServicesTransactionDto, isGiftCertificate?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createServicesTransactionDto' is not null or undefined
            assertParamExists('createServicesTransaction', 'createServicesTransactionDto', createServicesTransactionDto)
            const localVarPath = `/transactions/createServicesTransaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isGiftCertificate !== undefined) {
                localVarQueryParameter['isGiftCertificate'] = isGiftCertificate;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createServicesTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary A generic transaction creation endpoint for both patient and insurance
         * @param {CreateTransactionRequest} createTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction: async (createTransactionRequest: CreateTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTransactionRequest' is not null or undefined
            assertParamExists('createTransaction', 'createTransactionRequest', createTransactionRequest)
            const localVarPath = `/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDirectBillingDocument: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadDirectBillingDocument', 'id', id)
            const localVarPath = `/transactions/insurance/bill/direct/download/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates SEPA Credit Transfer XML file for outgoing payments (Überweisungen)
         * @summary Export Credit Transfer transactions to SEPA pain.001.001.03 format
         * @param {ExportCreditTransferToSEPARequest} exportCreditTransferToSEPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCreditTransferToSEPA: async (exportCreditTransferToSEPARequest: ExportCreditTransferToSEPARequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportCreditTransferToSEPARequest' is not null or undefined
            assertParamExists('exportCreditTransferToSEPA', 'exportCreditTransferToSEPARequest', exportCreditTransferToSEPARequest)
            const localVarPath = `/transactions/credit-transfer/sepa-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportCreditTransferToSEPARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export credit transfer (refund) transactions to SEPA pain.001.001.03 format and mark as exported
         * @param {ExportCreditTransfersBatchRequest} exportCreditTransfersBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCreditTransfersBatch: async (exportCreditTransfersBatchRequest: ExportCreditTransfersBatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportCreditTransfersBatchRequest' is not null or undefined
            assertParamExists('exportCreditTransfersBatch', 'exportCreditTransfersBatchRequest', exportCreditTransfersBatchRequest)
            const localVarPath = `/transactions/credit-transfer/sepa-export-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportCreditTransfersBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export GKV bills — encrypt EDIFACT and send to data center
         * @param {GkvBillExportRequestDto} gkvBillExportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportGkvBills: async (gkvBillExportRequestDto: GkvBillExportRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gkvBillExportRequestDto' is not null or undefined
            assertParamExists('exportGkvBills', 'gkvBillExportRequestDto', gkvBillExportRequestDto)
            const localVarPath = `/transactions/insurance/gkv/bill/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gkvBillExportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export/Convert insurance bills to a relevant file type format
         * @param {ExportBillingRequestDto} exportBillingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInsuranceBills: async (exportBillingRequestDto: ExportBillingRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportBillingRequestDto' is not null or undefined
            assertParamExists('exportInsuranceBills', 'exportBillingRequestDto', exportBillingRequestDto)
            const localVarPath = `/transactions/insurance/bill/direct/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportBillingRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export all unexported LastSchrift transactions for an account to SEPA format
         * @param {ExportLastSchriftsByAccountRequest} exportLastSchriftsByAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLastSchriftsByAccount: async (exportLastSchriftsByAccountRequest: ExportLastSchriftsByAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportLastSchriftsByAccountRequest' is not null or undefined
            assertParamExists('exportLastSchriftsByAccount', 'exportLastSchriftsByAccountRequest', exportLastSchriftsByAccountRequest)
            const localVarPath = `/transactions/lastschrift/sepa-export-by-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLastSchriftsByAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export LastSchrift transactions to SEPA pain.008.001.02 format
         * @param {ExportLastSchriftsToSEPARequest} exportLastSchriftsToSEPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLastSchriftsToSEPA: async (exportLastSchriftsToSEPARequest: ExportLastSchriftsToSEPARequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportLastSchriftsToSEPARequest' is not null or undefined
            assertParamExists('exportLastSchriftsToSEPA', 'exportLastSchriftsToSEPARequest', exportLastSchriftsToSEPARequest)
            const localVarPath = `/transactions/lastschrift/sepa-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLastSchriftsToSEPARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Details regarding the export of an insurance bill to the insurance company.
         * @param {string} transactionId Please provide a valid insurance transaction ID(UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportedInsuranceDetails: async (transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('exportedInsuranceDetails', 'transactionId', transactionId)
            const localVarPath = `/transactions/insurance/direct/export/details/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDebitPermissionPdf: async (debitPermissionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'debitPermissionId' is not null or undefined
            assertParamExists('generateDebitPermissionPdf', 'debitPermissionId', debitPermissionId)
            const localVarPath = `/transactions/generateDebitPermissionPdf/{debitPermissionId}`
                .replace(`{${"debitPermissionId"}}`, encodeURIComponent(String(debitPermissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all bank transfers to show in Kasse (BANK TRANSFERS)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBankTransfers: async (accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAllBankTransfers', 'accountId', accountId)
            const localVarPath = `/transactions/rechnung/banktransfers/all/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all copayment type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCopaymentInsuranceTransactions: async (billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billStatus' is not null or undefined
            assertParamExists('getAllCopaymentInsuranceTransactions', 'billStatus', billStatus)
            const localVarPath = `/transactions/insurance/bill/copayment/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCorrectionInsuranceTransactions: async (billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billStatus' is not null or undefined
            assertParamExists('getAllCorrectionInsuranceTransactions', 'billStatus', billStatus)
            const localVarPath = `/transactions/insurance/bill/correction/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInsuranceTransactions: async (billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billStatus' is not null or undefined
            assertParamExists('getAllInsuranceTransactions', 'billStatus', billStatus)
            const localVarPath = `/transactions/insurance/bill/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all line item correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLineItemCorrectionInsuranceTransactions: async (billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billStatus' is not null or undefined
            assertParamExists('getAllLineItemCorrectionInsuranceTransactions', 'billStatus', billStatus)
            const localVarPath = `/transactions/insurance/bill/line-item-correction/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Paper type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaperInsuranceTransactions: async (billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billStatus' is not null or undefined
            assertParamExists('getAllPaperInsuranceTransactions', 'billStatus', billStatus)
            const localVarPath = `/transactions/insurance/bill/paper/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all unpaid Rechnungen eligible for a Mahnung (bill reminder)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRechnungWithBillReminders: async (accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAllRechnungWithBillReminders', 'accountId', accountId)
            const localVarPath = `/transactions/rechnung/bill/reminder/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all transactions but we will not use Bank Transfer for this
         * @param {string} accountId Please provide a valid account ID
         * @param {string} transactionType 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTransactions: async (accountId: string, transactionType: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAllTransactions', 'accountId', accountId)
            // verify required parameter 'transactionType' is not null or undefined
            assertParamExists('getAllTransactions', 'transactionType', transactionType)
            const localVarPath = `/transactions/all/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch all types of Transaction that have already been created for a specific Patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTxsForPatient: async (pid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('getAllTxsForPatient', 'pid', pid)
            const localVarPath = `/transactions/patient/{pid}`
                .replace(`{${"pid"}}`, encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Lastschrift transactions that have not been exported to SEPA yet
         * @summary Fetch all unexported Lastschrift transactions for an account
         * @param {string} accountId Account ID to filter transactions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnexportedLastschriftTransactions: async (accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAllUnexportedLastschriftTransactions', 'accountId', accountId)
            const localVarPath = `/transactions/lastschrift/unexported/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payers and relative billing centers for a specific insurance
         * @param {string} payerIk 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingCentersFromPayer: async (payerIk: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerIk' is not null or undefined
            assertParamExists('getBillingCentersFromPayer', 'payerIk', payerIk)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getBillingCentersFromPayer', 'accountId', accountId)
            const localVarPath = `/transactions/insurance/bill/indirect/billingCenter/{payerIk}`
                .replace(`{${"payerIk"}}`, encodeURIComponent(String(payerIk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get billing data for editing
         * @param {Array<string>} billId 
         * @param {string} billingType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingDataForEditing: async (billId: Array<string>, billingType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getBillingDataForEditing', 'billId', billId)
            // verify required parameter 'billingType' is not null or undefined
            assertParamExists('getBillingDataForEditing', 'billingType', billingType)
            const localVarPath = `/transactions/insurance/bill/direct/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (billId) {
                localVarQueryParameter['billId'] = billId;
            }

            if (billingType !== undefined) {
                localVarQueryParameter['billingType'] = billingType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId The ID of the patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditPermissionsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getCreditPermissionsForPatient', 'patientId', patientId)
            const localVarPath = `/transactions/creditPermission/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all relevant data from GKV rxs for billing including payer
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPacketForCopaymentBilling: async (accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getDataPacketForCopaymentBilling', 'accountId', accountId)
            const localVarPath = `/transactions/insurance/bill/copayment/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the data packets(rxs details) for sepcific care provider
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPacketForDirectBilling: async (accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getDataPacketForDirectBilling', 'accountId', accountId)
            const localVarPath = `/transactions/inusrance/bill/direct/rxs/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all relevant data for paper billing including payer
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPacketForPaperBilling: async (accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getDataPacketForPaperBilling', 'accountId', accountId)
            const localVarPath = `/transactions/inusrance/bill/paper/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitPermissionsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getDebitPermissionsForPatient', 'patientId', patientId)
            const localVarPath = `/transactions/debitPermission/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get due amount for a specific rx number
         * @param {string} rxId Please provide a valid rxId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuePaymentByRxId: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getDuePaymentByRxId', 'rxId', rxId)
            const localVarPath = `/transactions/patient/bill/due/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get EDIFACT payload for a specific insurance export
         * @param {string} exportId The ID of the insurance export record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEdifactPayload: async (exportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('getEdifactPayload', 'exportId', exportId)
            const localVarPath = `/transactions/insurance/bill/direct/export/edifact/{exportId}`
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve optimized analytics data for executive dashboards with key metrics, top performers, trend data, and forecasting insights.
         * @summary Get executive dashboard data
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetExecutiveDashboardBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetExecutiveDashboardBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutiveDashboard: async (startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetExecutiveDashboardBillStatusEnum, billType?: GetExecutiveDashboardBillTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/analytics/executive-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }

            if (billType !== undefined) {
                localVarQueryParameter['billType'] = billType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve key performance indicators including billing volume, revenue metrics, workflow status, and period-over-period growth percentages.
         * @summary Get KPI analytics with period comparison
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetKpiAnalyticsBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetKpiAnalyticsBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpiAnalytics: async (startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetKpiAnalyticsBillStatusEnum, billType?: GetKpiAnalyticsBillTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/analytics/kpi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }

            if (billType !== undefined) {
                localVarQueryParameter['billType'] = billType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all possible line items for an Rx (for line item correction selection)
         * @param {string} rxId The Rx ID to fetch line items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItemsForRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getLineItemsForRx', 'rxId', rxId)
            const localVarPath = `/transactions/insurance/bill/line-item-correction/line-items/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all paid Rechnungen for Kasse (BEZAHLT)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaidRechnung: async (accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getPaidRechnung', 'accountId', accountId)
            const localVarPath = `/transactions/rechnung/paid/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get price data for a specific Rx (line items and copayment info)
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceDataForRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getPriceDataForRx', 'rxId', rxId)
            const localVarPath = `/transactions/price/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all transactions and Rechnungen (with Mahnungen) for a specific Rx, sorted chronologically. Includes soft-deleted records and cancellations for full audit trail.
         * @summary Get billing timeline for a specific Rx
         * @param {string} rxId The Rx ID to fetch the billing timeline for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBillingTimeline: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getRxBillingTimeline', 'rxId', rxId)
            const localVarPath = `/transactions/patient/bill/timeline/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the waivable fees of an Rx and whether each is waived
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxFeeWaivers: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('getRxFeeWaivers', 'rxId', rxId)
            const localVarPath = `/transactions/patient/bill/fee-waivers/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Rx previews for a specific transaction/bill for correction
         * @param {string} transactionId Transaction ID obtained from resolveCorrectionBillNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxPreviewsForCorrectionBill: async (transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getRxPreviewsForCorrectionBill', 'transactionId', transactionId)
            const localVarPath = `/transactions/insurance/bill/correction/rx-previews/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve distribution of prescriptions by type (Heilmittel, Services, etc.) with revenue and volume metrics.
         * @summary Get prescription type distribution
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetRxTypeDistributionBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetRxTypeDistributionBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxTypeDistribution: async (startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetRxTypeDistributionBillStatusEnum, billType?: GetRxTypeDistributionBillTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/analytics/rx-distribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }

            if (billType !== undefined) {
                localVarQueryParameter['billType'] = billType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a single Rx to add to an indirect bill
         * @param {string} rxNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleRxForIndirectBillsForInsurance: async (rxNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxNumber' is not null or undefined
            assertParamExists('getSingleRxForIndirectBillsForInsurance', 'rxNumber', rxNumber)
            const localVarPath = `/transactions/insurance/bill/indirect/singlerx/{rxNumber}`
                .replace(`{${"rxNumber"}}`, encodeURIComponent(String(rxNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the highest revenue-generating insurance payers with bill counts and revenue percentages.
         * @summary Get top performing payers by amount
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetTopPayersByAmountBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetTopPayersByAmountBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {number} [limit] Maximum number of top payers to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopPayersByAmount: async (startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTopPayersByAmountBillStatusEnum, billType?: GetTopPayersByAmountBillTypeEnum, userId?: string, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/analytics/top-payers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }

            if (billType !== undefined) {
                localVarQueryParameter['billType'] = billType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve time-series trend data including monthly and weekly transaction trends, and prescription volume trends for charts and forecasting.
         * @summary Get comprehensive trend analytics
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetTrendAnalyticsBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetTrendAnalyticsBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendAnalytics: async (startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTrendAnalyticsBillStatusEnum, billType?: GetTrendAnalyticsBillTypeEnum, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/analytics/trends`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }

            if (billType !== undefined) {
                localVarQueryParameter['billType'] = billType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all credit transfer (refund) transactions that haven\'t been exported yet with account SEPA data
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnexportedCreditTransfers: async (accountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/credit-transfer/unexported`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all LastSchrift transactions that haven\'t been exported yet with account SEPA data
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnexportedLastSchrifts: async (accountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/lastschrift/unexported`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unique firstName, lastName, and iban pairs for a patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniquePairsForPatient: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getUniquePairsForPatient', 'patientId', patientId)
            const localVarPath = `/transactions/unique-pairs/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all unpaid Rechnungen (OFFENE POSTEN)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnpaidRechnung: async (accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getUnpaidRechnung', 'accountId', accountId)
            const localVarPath = `/transactions/rechnung/unpaid/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Optimized loading GKV billing - grouped by payer with total prices
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGkvBills: async (accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('loadGkvBills', 'accountId', accountId)
            const localVarPath = `/transactions/insurance/gkv/load/all/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load GKV bills for editing — optimized batch endpoint
         * @param {Array<string>} billIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGkvBillsForEdit: async (billIds: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billIds' is not null or undefined
            assertParamExists('loadGkvBillsForEdit', 'billIds', billIds)
            const localVarPath = `/transactions/insurance/gkv/bill/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (billIds) {
                localVarQueryParameter['billIds'] = billIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load a single Rx for GKV direct billing with price, billing centers and validation
         * @param {string} rxId The Rx ID to load
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSingleGkvBillRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('loadSingleGkvBillRx', 'rxId', rxId)
            const localVarPath = `/transactions/insurance/gkv/load/single/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {MergeDocumentsRequestDto} mergeDocumentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeDirectBillingDocuments: async (mergeDocumentsRequestDto: MergeDocumentsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mergeDocumentsRequestDto' is not null or undefined
            assertParamExists('mergeDirectBillingDocuments', 'mergeDocumentsRequestDto', mergeDocumentsRequestDto)
            const localVarPath = `/transactions/insurance/bill/direct/merge-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeDocumentsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get minimal insurance transaction details by transaction ID (for internal use)
         * @param {string} id Please provide a valid transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        minimalInsuranceTransactionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('minimalInsuranceTransactionById', 'id', id)
            const localVarPath = `/transactions/insurance/minimal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {CreateRechnungDto} createRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noShowInvoiceTransaction: async (appointmentId: string, createRechnungDto: CreateRechnungDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('noShowInvoiceTransaction', 'appointmentId', appointmentId)
            // verify required parameter 'createRechnungDto' is not null or undefined
            assertParamExists('noShowInvoiceTransaction', 'createRechnungDto', createRechnungDto)
            const localVarPath = `/transactions/noShowInvoiceTransaction/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRechnungDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bills Information (Paid, Due and others) for a specific patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientBillInfo: async (pid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('patientBillInfo', 'pid', pid)
            const localVarPath = `/transactions/patient/bill/info/{pid}`
                .replace(`{${"pid"}}`, encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all the rechnungs associated with the patient
         * @param {number} pId Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientRechnungInfo: async (pId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pId' is not null or undefined
            assertParamExists('patientRechnungInfo', 'pId', pId)
            const localVarPath = `/transactions/rechnung/{pId}`
                .replace(`{${"pId"}}`, encodeURIComponent(String(pId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create correction bills from selected Rxs
         * @param {PrepareCorrectionBillsFromRxsRequest} prepareCorrectionBillsFromRxsRequest Account ID and selected Rx IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareCorrectionBillsFromRxs: async (prepareCorrectionBillsFromRxsRequest: PrepareCorrectionBillsFromRxsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prepareCorrectionBillsFromRxsRequest' is not null or undefined
            assertParamExists('prepareCorrectionBillsFromRxs', 'prepareCorrectionBillsFromRxsRequest', prepareCorrectionBillsFromRxsRequest)
            const localVarPath = `/transactions/insurance/bill/correction/prepare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prepareCorrectionBillsFromRxsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {PrintDirectBillingDocumentTestTypeEnum} [testType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printDirectBillingDocument: async (id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, testType?: PrintDirectBillingDocumentTestTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printDirectBillingDocument', 'id', id)
            // verify required parameter 'updateInsuranceTransactionDto' is not null or undefined
            assertParamExists('printDirectBillingDocument', 'updateInsuranceTransactionDto', updateInsuranceTransactionDto)
            const localVarPath = `/transactions/insurance/bill/direct/print/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (testType !== undefined) {
                localVarQueryParameter['testType'] = testType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInsuranceTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Print GKV bill — generates PDFs and returns document references
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printGkvBill: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printGkvBill', 'id', id)
            const localVarPath = `/transactions/insurance/gkv/bill/print/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printInsuranceCopaymentDocuments: async (id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printInsuranceCopaymentDocuments', 'id', id)
            // verify required parameter 'updateInsuranceTransactionDto' is not null or undefined
            assertParamExists('printInsuranceCopaymentDocuments', 'updateInsuranceTransactionDto', updateInsuranceTransactionDto)
            const localVarPath = `/transactions/insurance/bill/copayment/print/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInsuranceTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPaperBillingDocument: async (id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('printPaperBillingDocument', 'id', id)
            // verify required parameter 'updateInsuranceTransactionDto' is not null or undefined
            assertParamExists('printPaperBillingDocument', 'updateInsuranceTransactionDto', updateInsuranceTransactionDto)
            const localVarPath = `/transactions/insurance/bill/paper/print/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInsuranceTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rxId Please provide a valid rx ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechnungsForRx: async (rxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('rechnungsForRx', 'rxId', rxId)
            const localVarPath = `/transactions/rechnung/rx/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAmount: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshAmount', 'id', id)
            const localVarPath = `/transactions/insurance/bill/direct/edit/amount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} billId 
         * @param {string} pdfDate Optional date to be included in the regenerated PDF documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateInsuranceTransactionPdfs: async (billId: string, pdfDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('regenerateInsuranceTransactionPdfs', 'billId', billId)
            // verify required parameter 'pdfDate' is not null or undefined
            assertParamExists('regenerateInsuranceTransactionPdfs', 'pdfDate', pdfDate)
            const localVarPath = `/transactions/insurance/bill/regenerate/print/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pdfDate !== undefined) {
                localVarQueryParameter['pdfDate'] = pdfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Rx from insurance transaction
         * @param {string} id Transaction ID
         * @param {string} rxId Rx ID to remove
         * @param {any} locationId Location ID of the user
         * @param {RemoveRxFromExportedTransactionDto} removeRxFromExportedTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRxFromTransaction: async (id: string, rxId: string, locationId: any, removeRxFromExportedTransactionDto: RemoveRxFromExportedTransactionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeRxFromTransaction', 'id', id)
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('removeRxFromTransaction', 'rxId', rxId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('removeRxFromTransaction', 'locationId', locationId)
            // verify required parameter 'removeRxFromExportedTransactionDto' is not null or undefined
            assertParamExists('removeRxFromTransaction', 'removeRxFromExportedTransactionDto', removeRxFromExportedTransactionDto)
            const localVarPath = `/transactions/insurance/bill/direct/export/{id}/rxs/{rxId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeRxFromExportedTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a bill number to get transaction ID for correction
         * @param {string} accountId 
         * @param {string} billNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCorrectionBillNumber: async (accountId: string, billNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('resolveCorrectionBillNumber', 'accountId', accountId)
            // verify required parameter 'billNumber' is not null or undefined
            assertParamExists('resolveCorrectionBillNumber', 'billNumber', billNumber)
            const localVarPath = `/transactions/insurance/bill/correction/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (billNumber !== undefined) {
                localVarQueryParameter['billNumber'] = billNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve rxId and accountId by rxNumber
         * @param {string} rxNumber The rxNumber to resolve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveRx: async (rxNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxNumber' is not null or undefined
            assertParamExists('resolveRx', 'rxNumber', rxNumber)
            const localVarPath = `/transactions/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (rxNumber !== undefined) {
                localVarQueryParameter['rxNumber'] = rxNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search prescriptions (Rx) by patient name for potential addition to insurance bill
         * @param {string} searchTerm Search term for patient name (first and/or last) to find relevant prescriptions (Rx) for insurance bill addition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRxToAddInsuranceBill: async (searchTerm: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchTerm' is not null or undefined
            assertParamExists('searchRxToAddInsuranceBill', 'searchTerm', searchTerm)
            const localVarPath = `/transactions/insurance/search/rx/{searchTerm}`
                .replace(`{${"searchTerm"}}`, encodeURIComponent(String(searchTerm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Email a patient\'s billing documents (Rechnung and/or Mahnungen) as PDF attachments
         * @param {string} rechnungId The UUID of the Rechnung whose documents should be emailed
         * @param {SendBillEmailDto} sendBillEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBillEmail: async (rechnungId: string, sendBillEmailDto: SendBillEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rechnungId' is not null or undefined
            assertParamExists('sendBillEmail', 'rechnungId', rechnungId)
            // verify required parameter 'sendBillEmailDto' is not null or undefined
            assertParamExists('sendBillEmail', 'sendBillEmailDto', sendBillEmailDto)
            const localVarPath = `/transactions/patient/bill/rechnung/{rechnungId}/send-email`
                .replace(`{${"rechnungId"}}`, encodeURIComponent(String(rechnungId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendBillEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set which fees of an Rx are waived
         * @param {string} rxId 
         * @param {SetRxFeeWaiversDto} setRxFeeWaiversDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRxFeeWaivers: async (rxId: string, setRxFeeWaiversDto: SetRxFeeWaiversDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('setRxFeeWaivers', 'rxId', rxId)
            // verify required parameter 'setRxFeeWaiversDto' is not null or undefined
            assertParamExists('setRxFeeWaivers', 'setRxFeeWaiversDto', setRxFeeWaiversDto)
            const localVarPath = `/transactions/patient/bill/fee-waivers/{rxId}`
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setRxFeeWaiversDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id Please provide a valid bill ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatusOpenToFinished: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setStatusOpenToFinished', 'id', id)
            const localVarPath = `/transactions/insurance/bill/direct/export/finished/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteDebitPermission: async (debitPermissionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'debitPermissionId' is not null or undefined
            assertParamExists('softDeleteDebitPermission', 'debitPermissionId', debitPermissionId)
            const localVarPath = `/transactions/debitPermission/delete/{debitPermissionId}`
                .replace(`{${"debitPermissionId"}}`, encodeURIComponent(String(debitPermissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteInsuranceTransaction: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('softDeleteInsuranceTransaction', 'id', id)
            const localVarPath = `/transactions/insurance/bill/direct/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft delete a LastSchrift transaction and optionally its associated Rechnung
         * @param {string} lastSchriftId ID of the LastSchrift transaction to delete
         * @param {boolean} [deleteRechnung] Whether to also delete the associated Rechnung (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteLastSchrift: async (lastSchriftId: string, deleteRechnung?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lastSchriftId' is not null or undefined
            assertParamExists('softDeleteLastSchrift', 'lastSchriftId', lastSchriftId)
            const localVarPath = `/transactions/lastschrift/delete/{lastSchriftId}`
                .replace(`{${"lastSchriftId"}}`, encodeURIComponent(String(lastSchriftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleteRechnung !== undefined) {
                localVarQueryParameter['deleteRechnung'] = deleteRechnung;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} rechnungId ID of the Rechnung to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteRechnung: async (rechnungId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rechnungId' is not null or undefined
            assertParamExists('softDeleteRechnung', 'rechnungId', rechnungId)
            const localVarPath = `/transactions/rechnung/delete/{rechnungId}`
                .replace(`{${"rechnungId"}}`, encodeURIComponent(String(rechnungId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a workflow to generate PDFs for multiple bills in parallel. Returns a workflowId for progress tracking via WebSocket.
         * @summary Start batch PDF generation for multiple bills
         * @param {StartBillPdfBatchRequestDto} startBillPdfBatchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startBillPdfBatch: async (startBillPdfBatchRequestDto: StartBillPdfBatchRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startBillPdfBatchRequestDto' is not null or undefined
            assertParamExists('startBillPdfBatch', 'startBillPdfBatchRequestDto', startBillPdfBatchRequestDto)
            const localVarPath = `/transactions/insurance/bill/batch-print`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startBillPdfBatchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test route to verify routing works after SEPA exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAfterSepa: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/test-after-sepa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test route to verify routing works
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testBeforeSepa: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions/test-before-sepa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets wasExported flag and clears export metadata for specified credit transfers
         * @summary Undo SEPA export status for credit transfers
         * @param {UndoCreditTransferExportRequest} undoCreditTransferExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCreditTransferExport: async (undoCreditTransferExportRequest: UndoCreditTransferExportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'undoCreditTransferExportRequest' is not null or undefined
            assertParamExists('undoCreditTransferExport', 'undoCreditTransferExportRequest', undoCreditTransferExportRequest)
            const localVarPath = `/transactions/credit-transfer/undo-sepa-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoCreditTransferExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets wasExported flag for all credit transfers linked to a specific SEPA document
         * @summary Undo SEPA credit transfer export by document ID
         * @param {UndoCreditTransferExportByDocumentRequest} undoCreditTransferExportByDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCreditTransferExportByDocument: async (undoCreditTransferExportByDocumentRequest: UndoCreditTransferExportByDocumentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'undoCreditTransferExportByDocumentRequest' is not null or undefined
            assertParamExists('undoCreditTransferExportByDocument', 'undoCreditTransferExportByDocumentRequest', undoCreditTransferExportByDocumentRequest)
            const localVarPath = `/transactions/credit-transfer/undo-sepa-export-by-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoCreditTransferExportByDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets the export status of all LastSchrift transactions that were part of a specific SEPA export document
         * @summary Undo SEPA export for all LastSchrift transactions associated with a SEPA document
         * @param {UndoSEPAExportByDocumentRequest} undoSEPAExportByDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoSEPAExportByDocument: async (undoSEPAExportByDocumentRequest: UndoSEPAExportByDocumentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'undoSEPAExportByDocumentRequest' is not null or undefined
            assertParamExists('undoSEPAExportByDocument', 'undoSEPAExportByDocumentRequest', undoSEPAExportByDocumentRequest)
            const localVarPath = `/transactions/lastschrift/undo-sepa-export-by-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoSEPAExportByDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets the export status of specified LastSchrift transactions, allowing them to be exported again
         * @summary Undo SEPA export for specific LastSchrift transactions
         * @param {UndoSEPAExportForLastSchriftsRequest} undoSEPAExportForLastSchriftsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoSEPAExportForLastSchrifts: async (undoSEPAExportForLastSchriftsRequest: UndoSEPAExportForLastSchriftsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'undoSEPAExportForLastSchriftsRequest' is not null or undefined
            assertParamExists('undoSEPAExportForLastSchrifts', 'undoSEPAExportForLastSchriftsRequest', undoSEPAExportForLastSchriftsRequest)
            const localVarPath = `/transactions/lastschrift/undo-sepa-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoSEPAExportForLastSchriftsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDelayStatusDto} updateDelayStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelayStatus: async (id: string, updateDelayStatusDto: UpdateDelayStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDelayStatus', 'id', id)
            // verify required parameter 'updateDelayStatusDto' is not null or undefined
            assertParamExists('updateDelayStatus', 'updateDelayStatusDto', updateDelayStatusDto)
            const localVarPath = `/transactions/insurance/bill/delay-status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDelayStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateExportStatusDto} updateExportStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportAndBillingStatus: async (id: string, updateExportStatusDto: UpdateExportStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateExportAndBillingStatus', 'id', id)
            // verify required parameter 'updateExportStatusDto' is not null or undefined
            assertParamExists('updateExportAndBillingStatus', 'updateExportStatusDto', updateExportStatusDto)
            const localVarPath = `/transactions/inusrance/bill/direct/export/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExportStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateExportStatusDto} updateExportStatusDto 
         * @param {Array<string>} [rxIds] Array of Rx IDs (can contain a single element or multiple)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportBillingStatusAndRxStatus: async (id: string, updateExportStatusDto: UpdateExportStatusDto, rxIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateExportBillingStatusAndRxStatus', 'id', id)
            // verify required parameter 'updateExportStatusDto' is not null or undefined
            assertParamExists('updateExportBillingStatusAndRxStatus', 'updateExportStatusDto', updateExportStatusDto)
            const localVarPath = `/transactions/inusrance/bill/bg/export/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (rxIds) {
                localVarQueryParameter['rxIds'] = rxIds;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExportStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update GKV bill — optimized lean endpoint
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGkvBill: async (id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGkvBill', 'id', id)
            // verify required parameter 'updateInsuranceTransactionDto' is not null or undefined
            assertParamExists('updateGkvBill', 'updateInsuranceTransactionDto', updateInsuranceTransactionDto)
            const localVarPath = `/transactions/insurance/gkv/bill/edit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInsuranceTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsuranceTransaction: async (id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInsuranceTransaction', 'id', id)
            // verify required parameter 'updateInsuranceTransactionDto' is not null or undefined
            assertParamExists('updateInsuranceTransaction', 'updateInsuranceTransactionDto', updateInsuranceTransactionDto)
            const localVarPath = `/transactions/insurance/bill/direct/edit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInsuranceTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing Rechnung.
         * @param {string} rechnungId The UUID of the existing Rechnung
         * @param {UpdateRechnungDto} updateRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRechnungById: async (rechnungId: string, updateRechnungDto: UpdateRechnungDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rechnungId' is not null or undefined
            assertParamExists('updateRechnungById', 'rechnungId', rechnungId)
            // verify required parameter 'updateRechnungDto' is not null or undefined
            assertParamExists('updateRechnungById', 'updateRechnungDto', updateRechnungDto)
            const localVarPath = `/transactions/rechnung/{rechnungId}`
                .replace(`{${"rechnungId"}}`, encodeURIComponent(String(rechnungId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRechnungDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the selected line items for an Rx within a LINE_ITEM_CORRECTION transaction
         * @param {string} transactionId 
         * @param {string} rxId 
         * @param {UpdateSelectedLineItemsRequest} updateSelectedLineItemsRequest Selected line items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectedLineItems: async (transactionId: string, rxId: string, updateSelectedLineItemsRequest: UpdateSelectedLineItemsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('updateSelectedLineItems', 'transactionId', transactionId)
            // verify required parameter 'rxId' is not null or undefined
            assertParamExists('updateSelectedLineItems', 'rxId', rxId)
            // verify required parameter 'updateSelectedLineItemsRequest' is not null or undefined
            assertParamExists('updateSelectedLineItems', 'updateSelectedLineItemsRequest', updateSelectedLineItemsRequest)
            const localVarPath = `/transactions/insurance/bill/line-item-correction/{transactionId}/rx/{rxId}/line-items`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)))
                .replace(`{${"rxId"}}`, encodeURIComponent(String(rxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSelectedLineItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an Rx scan document to an existing insurance bill
         * @param {string} transactionId ID of the insurance transaction
         * @param {UploadRxScanToExistingBillDocuTypeEnum} docuType 
         * @param {UploadRxScanToExistingBillOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRxScanToExistingBill: async (transactionId: string, docuType: UploadRxScanToExistingBillDocuTypeEnum, ownerType: UploadRxScanToExistingBillOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('uploadRxScanToExistingBill', 'transactionId', transactionId)
            // verify required parameter 'docuType' is not null or undefined
            assertParamExists('uploadRxScanToExistingBill', 'docuType', docuType)
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('uploadRxScanToExistingBill', 'ownerType', ownerType)
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('uploadRxScanToExistingBill', 'ownerId', ownerId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadRxScanToExistingBill', 'file', file)
            const localVarPath = `/transactions/upload-rx-scan/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (docuType !== undefined) { 
                localVarFormParams.append('docuType', docuType as any);
            }
    
            if (ownerType !== undefined) { 
                localVarFormParams.append('ownerType', ownerType as any);
            }
    
            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
    
            if (makeAccessible !== undefined) { 
                localVarFormParams.append('makeAccessible', makeAccessible as any);
            }
    
            if (rxId !== undefined) { 
                localVarFormParams.append('rxId', rxId as any);
            }
    
            if (noticeDefinitionDataId !== undefined) { 
                localVarFormParams.append('noticeDefinitionDataId', noticeDefinitionDataId as any);
            }
    
            if (scanToSearchablePdf !== undefined) { 
                localVarFormParams.append('scanToSearchablePdf', scanToSearchablePdf as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {UploadSignedDocumentDocuTypeEnum} docuType 
         * @param {UploadSignedDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSignedDocument: async (debitPermissionId: string, docuType: UploadSignedDocumentDocuTypeEnum, ownerType: UploadSignedDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'debitPermissionId' is not null or undefined
            assertParamExists('uploadSignedDocument', 'debitPermissionId', debitPermissionId)
            // verify required parameter 'docuType' is not null or undefined
            assertParamExists('uploadSignedDocument', 'docuType', docuType)
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('uploadSignedDocument', 'ownerType', ownerType)
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('uploadSignedDocument', 'ownerId', ownerId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSignedDocument', 'file', file)
            const localVarPath = `/transactions/upload-signed-document/{debitPermissionId}`
                .replace(`{${"debitPermissionId"}}`, encodeURIComponent(String(debitPermissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (docuType !== undefined) { 
                localVarFormParams.append('docuType', docuType as any);
            }
    
            if (ownerType !== undefined) { 
                localVarFormParams.append('ownerType', ownerType as any);
            }
    
            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
    
            if (makeAccessible !== undefined) { 
                localVarFormParams.append('makeAccessible', makeAccessible as any);
            }
    
            if (rxId !== undefined) { 
                localVarFormParams.append('rxId', rxId as any);
            }
    
            if (noticeDefinitionDataId !== undefined) { 
                localVarFormParams.append('noticeDefinitionDataId', noticeDefinitionDataId as any);
            }
    
            if (scanToSearchablePdf !== undefined) { 
                localVarFormParams.append('scanToSearchablePdf', scanToSearchablePdf as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch validate Rxs for GKV direct billing
         * @param {ValidateGkvBillRxsRequest} validateGkvBillRxsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateGkvBillRxs: async (validateGkvBillRxsRequest: ValidateGkvBillRxsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateGkvBillRxsRequest' is not null or undefined
            assertParamExists('validateGkvBillRxs', 'validateGkvBillRxsRequest', validateGkvBillRxsRequest)
            const localVarPath = `/transactions/insurance/gkv/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateGkvBillRxsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all tickets associated with an insurance transaction
         * @param {string} transactionId Please provide a valid transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allTicketsByTransactionId(transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allTicketsByTransactionId(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns detailed unpaid bills information for a specific patient. (excluding BG, perpetual, without dates Rxs along with Rx with rechnung)
         * @summary Get a warning badge for unpaid bills
         * @param {number} pid Numeric patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgesForUnpaidBills(pid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnpaidBillsBadgeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgesForUnpaidBills(pid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk soft delete multiple LastSchrift transactions and optionally their associated Rechnungen
         * @param {BulkSoftDeleteLastSchriftsRequest} bulkSoftDeleteLastSchriftsRequest LastSchrift IDs and options for bulk deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSoftDeleteLastSchrifts(bulkSoftDeleteLastSchriftsRequest: BulkSoftDeleteLastSchriftsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSoftDeleteLastSchrifts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSoftDeleteLastSchrifts(bulkSoftDeleteLastSchriftsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original Bank Transfer transaction to cancel
         * @param {object} body Reason for cancelling the Bank Transfer transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBankTransfer(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBankTransfer(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original cash transaction to cancel
         * @param {object} body Reason for cancelling the cash transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCashTransaction(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseTransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCashTransaction(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original EC transaction to cancel
         * @param {object} body Reason for cancelling the EC transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelECTransaction(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseTransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelECTransaction(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateBankTransferDto} createBankTransferDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankTransferForRechnung(createBankTransferDto: CreateBankTransferDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankTransferForRechnung(createBankTransferDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillReminderForRechnung(rId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRechnungDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillReminderForRechnung(rId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint creates or updates credit permissions for SEPA credit transfer (refund) transactions. For direct debits, use the /debitPermission endpoint instead.
         * @summary Create or update a credit permission (bank account for refunds)
         * @param {DebitPermissionDto} debitPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateCreditPermission(debitPermissionDto: DebitPermissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateCreditPermission(debitPermissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint creates or updates debit permissions for SEPA direct debit transactions. For refunds, use the /creditPermission endpoint instead.
         * @summary Create or update a debit permission (bank account for direct debits)
         * @param {number} patientId 
         * @param {DebitPermissionDto} debitPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateDebitPermission(patientId: number, debitPermissionDto: DebitPermissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateDebitPermission(patientId, debitPermissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateRechnungDto} createRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRechnung(createRechnungDto: CreateRechnungDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRechnungDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRechnung(createRechnungDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a refund (LastSchrift with type=REFUND) using a patient\'s credit permission. Amount is stored as negative in database for accounting purposes (money leaving practice), but will be converted to positive when exporting to SEPA XML.
         * @summary Create a refund transaction using credit permission
         * @param {CreateRefundDto} createRefundDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefund(createRefundDto: CreateRefundDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefund(createRefundDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateServiceRechnungDto} createServiceRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServiceRechnung(createServiceRechnungDto: CreateServiceRechnungDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRechnungDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServiceRechnung(createServiceRechnungDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary A generic transaction creation endpoint for services
         * @param {CreateServicesTransactionDto} createServicesTransactionDto 
         * @param {boolean} [isGiftCertificate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServicesTransaction(createServicesTransactionDto: CreateServicesTransactionDto, isGiftCertificate?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseTransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServicesTransaction(createServicesTransactionDto, isGiftCertificate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary A generic transaction creation endpoint for both patient and insurance
         * @param {CreateTransactionRequest} createTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransaction(createTransactionRequest: CreateTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseTransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransaction(createTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDirectBillingDocument(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDirectBillingDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates SEPA Credit Transfer XML file for outgoing payments (Überweisungen)
         * @summary Export Credit Transfer transactions to SEPA pain.001.001.03 format
         * @param {ExportCreditTransferToSEPARequest} exportCreditTransferToSEPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCreditTransferToSEPA(exportCreditTransferToSEPARequest: ExportCreditTransferToSEPARequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportCreditTransferToSEPA200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCreditTransferToSEPA(exportCreditTransferToSEPARequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export credit transfer (refund) transactions to SEPA pain.001.001.03 format and mark as exported
         * @param {ExportCreditTransfersBatchRequest} exportCreditTransfersBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCreditTransfersBatch(exportCreditTransfersBatchRequest: ExportCreditTransfersBatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SEPAExportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCreditTransfersBatch(exportCreditTransfersBatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export GKV bills — encrypt EDIFACT and send to data center
         * @param {GkvBillExportRequestDto} gkvBillExportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportGkvBills(gkvBillExportRequestDto: GkvBillExportRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GkvBillExportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportGkvBills(gkvBillExportRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export/Convert insurance bills to a relevant file type format
         * @param {ExportBillingRequestDto} exportBillingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportInsuranceBills(exportBillingRequestDto: ExportBillingRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportInsuranceBills(exportBillingRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export all unexported LastSchrift transactions for an account to SEPA format
         * @param {ExportLastSchriftsByAccountRequest} exportLastSchriftsByAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLastSchriftsByAccount(exportLastSchriftsByAccountRequest: ExportLastSchriftsByAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SEPAExportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLastSchriftsByAccount(exportLastSchriftsByAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export LastSchrift transactions to SEPA pain.008.001.02 format
         * @param {ExportLastSchriftsToSEPARequest} exportLastSchriftsToSEPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLastSchriftsToSEPA(exportLastSchriftsToSEPARequest: ExportLastSchriftsToSEPARequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SEPAExportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLastSchriftsToSEPA(exportLastSchriftsToSEPARequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Details regarding the export of an insurance bill to the insurance company.
         * @param {string} transactionId Please provide a valid insurance transaction ID(UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportedInsuranceDetails(transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseExportInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportedInsuranceDetails(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDebitPermissionPdf(debitPermissionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebitPermissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDebitPermissionPdf(debitPermissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all bank transfers to show in Kasse (BANK TRANSFERS)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBankTransfers(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetBankTransferDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBankTransfers(accountId, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all copayment type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCopaymentInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCopaymentInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCorrectionInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCorrectionInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all line item correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLineItemCorrectionInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLineItemCorrectionInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Paper type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPaperInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPaperInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all unpaid Rechnungen eligible for a Mahnung (bill reminder)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRechnungWithBillReminders(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetRechnungDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRechnungWithBillReminders(accountId, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all transactions but we will not use Bank Transfer for this
         * @param {string} accountId Please provide a valid account ID
         * @param {string} transactionType 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTransactions(accountId: string, transactionType: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBaseTransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTransactions(accountId, transactionType, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch all types of Transaction that have already been created for a specific Patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTxsForPatient(pid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseTransactionDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTxsForPatient(pid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all Lastschrift transactions that have not been exported to SEPA yet
         * @summary Fetch all unexported Lastschrift transactions for an account
         * @param {string} accountId Account ID to filter transactions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUnexportedLastschriftTransactions(accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseTransactionDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUnexportedLastschriftTransactions(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payers and relative billing centers for a specific insurance
         * @param {string} payerIk 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingCentersFromPayer(payerIk: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingCentersFromPayer(payerIk, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get billing data for editing
         * @param {Array<string>} billId 
         * @param {string} billingType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingDataForEditing(billId: Array<string>, billingType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportBillingData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingDataForEditing(billId, billingType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId The ID of the patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreditPermissionsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DebitPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreditPermissionsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all relevant data from GKV rxs for billing including payer
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPacketForCopaymentBilling(accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessedCopaymentBillingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPacketForCopaymentBilling(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all the data packets(rxs details) for sepcific care provider
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPacketForDirectBilling(accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupedDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPacketForDirectBilling(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all relevant data for paper billing including payer
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPacketForPaperBilling(accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessedPaperBillingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPacketForPaperBilling(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDebitPermissionsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DebitPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDebitPermissionsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get due amount for a specific rx number
         * @param {string} rxId Please provide a valid rxId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDuePaymentByRxId(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuePaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDuePaymentByRxId(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get EDIFACT payload for a specific insurance export
         * @param {string} exportId The ID of the insurance export record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEdifactPayload(exportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEdifactPayload(exportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve optimized analytics data for executive dashboards with key metrics, top performers, trend data, and forecasting insights.
         * @summary Get executive dashboard data
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetExecutiveDashboardBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetExecutiveDashboardBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutiveDashboard(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetExecutiveDashboardBillStatusEnum, billType?: GetExecutiveDashboardBillTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutiveDashboardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutiveDashboard(startDate, endDate, accountId, payerId, billStatus, billType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve key performance indicators including billing volume, revenue metrics, workflow status, and period-over-period growth percentages.
         * @summary Get KPI analytics with period comparison
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetKpiAnalyticsBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetKpiAnalyticsBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKpiAnalytics(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetKpiAnalyticsBillStatusEnum, billType?: GetKpiAnalyticsBillTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KpiAnalyticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKpiAnalytics(startDate, endDate, accountId, payerId, billStatus, billType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all possible line items for an Rx (for line item correction selection)
         * @param {string} rxId The Rx ID to fetch line items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLineItemsForRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineItemsForRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all paid Rechnungen for Kasse (BEZAHLT)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaidRechnung(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetRechnungDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaidRechnung(accountId, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get price data for a specific Rx (line items and copayment info)
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceDataForRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxPriceDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceDataForRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all transactions and Rechnungen (with Mahnungen) for a specific Rx, sorted chronologically. Includes soft-deleted records and cancellations for full audit trail.
         * @summary Get billing timeline for a specific Rx
         * @param {string} rxId The Rx ID to fetch the billing timeline for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxBillingTimeline(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxBillingTimelineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxBillingTimeline(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the waivable fees of an Rx and whether each is waived
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxFeeWaivers(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxFeeWaiversDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxFeeWaivers(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Rx previews for a specific transaction/bill for correction
         * @param {string} transactionId Transaction ID obtained from resolveCorrectionBillNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxPreviewsForCorrectionBill(transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxPreviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxPreviewsForCorrectionBill(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve distribution of prescriptions by type (Heilmittel, Services, etc.) with revenue and volume metrics.
         * @summary Get prescription type distribution
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetRxTypeDistributionBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetRxTypeDistributionBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRxTypeDistribution(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetRxTypeDistributionBillStatusEnum, billType?: GetRxTypeDistributionBillTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RxTypeDistributionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRxTypeDistribution(startDate, endDate, accountId, payerId, billStatus, billType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a single Rx to add to an indirect bill
         * @param {string} rxNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleRxForIndirectBillsForInsurance(rxNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleRxForIndirectBillsForInsurance(rxNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the highest revenue-generating insurance payers with bill counts and revenue percentages.
         * @summary Get top performing payers by amount
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetTopPayersByAmountBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetTopPayersByAmountBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {number} [limit] Maximum number of top payers to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopPayersByAmount(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTopPayersByAmountBillStatusEnum, billType?: GetTopPayersByAmountBillTypeEnum, userId?: string, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayerPerformanceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopPayersByAmount(startDate, endDate, accountId, payerId, billStatus, billType, userId, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve time-series trend data including monthly and weekly transaction trends, and prescription volume trends for charts and forecasting.
         * @summary Get comprehensive trend analytics
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetTrendAnalyticsBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetTrendAnalyticsBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrendAnalytics(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTrendAnalyticsBillStatusEnum, billType?: GetTrendAnalyticsBillTypeEnum, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendAnalyticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrendAnalytics(startDate, endDate, accountId, payerId, billStatus, billType, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all credit transfer (refund) transactions that haven\'t been exported yet with account SEPA data
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnexportedCreditTransfers(accountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnexportedLastSchriftsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnexportedCreditTransfers(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all LastSchrift transactions that haven\'t been exported yet with account SEPA data
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnexportedLastSchrifts(accountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnexportedLastSchriftsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnexportedLastSchrifts(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get unique firstName, lastName, and iban pairs for a patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUniquePairsForPatient(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DebitPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUniquePairsForPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all unpaid Rechnungen (OFFENE POSTEN)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnpaidRechnung(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetRechnungDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnpaidRechnung(accountId, limit, page, startDate, endDate, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Optimized loading GKV billing - grouped by payer with total prices
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadGkvBills(accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DirectBillingPayerGroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadGkvBills(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Load GKV bills for editing — optimized batch endpoint
         * @param {Array<string>} billIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadGkvBillsForEdit(billIds: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GkvBillEditDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadGkvBillsForEdit(billIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Load a single Rx for GKV direct billing with price, billing centers and validation
         * @param {string} rxId The Rx ID to load
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadSingleGkvBillRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectBillingSingleRxResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadSingleGkvBillRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {MergeDocumentsRequestDto} mergeDocumentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeDirectBillingDocuments(mergeDocumentsRequestDto: MergeDocumentsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergeDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeDirectBillingDocuments(mergeDocumentsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get minimal insurance transaction details by transaction ID (for internal use)
         * @param {string} id Please provide a valid transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async minimalInsuranceTransactionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.minimalInsuranceTransactionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {CreateRechnungDto} createRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async noShowInvoiceTransaction(appointmentId: string, createRechnungDto: CreateRechnungDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRechnungDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.noShowInvoiceTransaction(appointmentId, createRechnungDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Bills Information (Paid, Due and others) for a specific patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientBillInfo(pid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientBillInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientBillInfo(pid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves all the rechnungs associated with the patient
         * @param {number} pId Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientRechnungInfo(pId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRechnungDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientRechnungInfo(pId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create correction bills from selected Rxs
         * @param {PrepareCorrectionBillsFromRxsRequest} prepareCorrectionBillsFromRxsRequest Account ID and selected Rx IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareCorrectionBillsFromRxs(prepareCorrectionBillsFromRxsRequest: PrepareCorrectionBillsFromRxsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessedCorrectionBillingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareCorrectionBillsFromRxs(prepareCorrectionBillsFromRxsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {PrintDirectBillingDocumentTestTypeEnum} [testType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printDirectBillingDocument(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, testType?: PrintDirectBillingDocumentTestTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printDirectBillingDocument(id, updateInsuranceTransactionDto, testType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Print GKV bill — generates PDFs and returns document references
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printGkvBill(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GkvBillPrintResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printGkvBill(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printInsuranceCopaymentDocuments(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printInsuranceCopaymentDocuments(id, updateInsuranceTransactionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printPaperBillingDocument(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printPaperBillingDocument(id, updateInsuranceTransactionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rxId Please provide a valid rx ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechnungsForRx(rxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRechnungDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechnungsForRx(rxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshAmount(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshAmount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} billId 
         * @param {string} pdfDate Optional date to be included in the regenerated PDF documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateInsuranceTransactionPdfs(billId: string, pdfDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateInsuranceTransactionPdfs(billId, pdfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove Rx from insurance transaction
         * @param {string} id Transaction ID
         * @param {string} rxId Rx ID to remove
         * @param {any} locationId Location ID of the user
         * @param {RemoveRxFromExportedTransactionDto} removeRxFromExportedTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRxFromTransaction(id: string, rxId: string, locationId: any, removeRxFromExportedTransactionDto: RemoveRxFromExportedTransactionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseExportInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRxFromTransaction(id, rxId, locationId, removeRxFromExportedTransactionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolve a bill number to get transaction ID for correction
         * @param {string} accountId 
         * @param {string} billNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveCorrectionBillNumber(accountId: string, billNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolveCorrectionBillNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveCorrectionBillNumber(accountId, billNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolve rxId and accountId by rxNumber
         * @param {string} rxNumber The rxNumber to resolve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveRx(rxNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveRx(rxNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search prescriptions (Rx) by patient name for potential addition to insurance bill
         * @param {string} searchTerm Search term for patient name (first and/or last) to find relevant prescriptions (Rx) for insurance bill addition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRxToAddInsuranceBill(searchTerm: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRxToAddInsuranceBill(searchTerm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Email a patient\'s billing documents (Rechnung and/or Mahnungen) as PDF attachments
         * @param {string} rechnungId The UUID of the Rechnung whose documents should be emailed
         * @param {SendBillEmailDto} sendBillEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBillEmail(rechnungId: string, sendBillEmailDto: SendBillEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRechnungDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBillEmail(rechnungId, sendBillEmailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set which fees of an Rx are waived
         * @param {string} rxId 
         * @param {SetRxFeeWaiversDto} setRxFeeWaiversDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setRxFeeWaivers(rxId: string, setRxFeeWaiversDto: SetRxFeeWaiversDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RxFeeWaiversDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setRxFeeWaivers(rxId, setRxFeeWaiversDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id Please provide a valid bill ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStatusOpenToFinished(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStatusOpenToFinished(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteDebitPermission(debitPermissionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteDebitPermission(debitPermissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteInsuranceTransaction(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteInsuranceTransaction(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft delete a LastSchrift transaction and optionally its associated Rechnung
         * @param {string} lastSchriftId ID of the LastSchrift transaction to delete
         * @param {boolean} [deleteRechnung] Whether to also delete the associated Rechnung (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteLastSchrift(lastSchriftId: string, deleteRechnung?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoftDeleteLastSchrift200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteLastSchrift(lastSchriftId, deleteRechnung, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} rechnungId ID of the Rechnung to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteRechnung(rechnungId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteRechnung(rechnungId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a workflow to generate PDFs for multiple bills in parallel. Returns a workflowId for progress tracking via WebSocket.
         * @summary Start batch PDF generation for multiple bills
         * @param {StartBillPdfBatchRequestDto} startBillPdfBatchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startBillPdfBatch(startBillPdfBatchRequestDto: StartBillPdfBatchRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartBillPdfBatchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startBillPdfBatch(startBillPdfBatchRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Test route to verify routing works after SEPA exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testAfterSepa(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testAfterSepa(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Test route to verify routing works
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testBeforeSepa(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testBeforeSepa(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resets wasExported flag and clears export metadata for specified credit transfers
         * @summary Undo SEPA export status for credit transfers
         * @param {UndoCreditTransferExportRequest} undoCreditTransferExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoCreditTransferExport(undoCreditTransferExportRequest: UndoCreditTransferExportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndoCreditTransferExport200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoCreditTransferExport(undoCreditTransferExportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resets wasExported flag for all credit transfers linked to a specific SEPA document
         * @summary Undo SEPA credit transfer export by document ID
         * @param {UndoCreditTransferExportByDocumentRequest} undoCreditTransferExportByDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoCreditTransferExportByDocument(undoCreditTransferExportByDocumentRequest: UndoCreditTransferExportByDocumentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndoCreditTransferExport200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoCreditTransferExportByDocument(undoCreditTransferExportByDocumentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resets the export status of all LastSchrift transactions that were part of a specific SEPA export document
         * @summary Undo SEPA export for all LastSchrift transactions associated with a SEPA document
         * @param {UndoSEPAExportByDocumentRequest} undoSEPAExportByDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoSEPAExportByDocument(undoSEPAExportByDocumentRequest: UndoSEPAExportByDocumentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoSEPAExportByDocument(undoSEPAExportByDocumentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resets the export status of specified LastSchrift transactions, allowing them to be exported again
         * @summary Undo SEPA export for specific LastSchrift transactions
         * @param {UndoSEPAExportForLastSchriftsRequest} undoSEPAExportForLastSchriftsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoSEPAExportForLastSchrifts(undoSEPAExportForLastSchriftsRequest: UndoSEPAExportForLastSchriftsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndoSEPAExportForLastSchrifts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoSEPAExportForLastSchrifts(undoSEPAExportForLastSchriftsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDelayStatusDto} updateDelayStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDelayStatus(id: string, updateDelayStatusDto: UpdateDelayStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDelayStatus(id, updateDelayStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateExportStatusDto} updateExportStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExportAndBillingStatus(id: string, updateExportStatusDto: UpdateExportStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateExportStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExportAndBillingStatus(id, updateExportStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateExportStatusDto} updateExportStatusDto 
         * @param {Array<string>} [rxIds] Array of Rx IDs (can contain a single element or multiple)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExportBillingStatusAndRxStatus(id: string, updateExportStatusDto: UpdateExportStatusDto, rxIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateExportStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExportBillingStatusAndRxStatus(id, updateExportStatusDto, rxIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update GKV bill — optimized lean endpoint
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGkvBill(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GkvBillUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGkvBill(id, updateInsuranceTransactionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInsuranceTransaction(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateInsuranceTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInsuranceTransaction(id, updateInsuranceTransactionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an existing Rechnung.
         * @param {string} rechnungId The UUID of the existing Rechnung
         * @param {UpdateRechnungDto} updateRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRechnungById(rechnungId: string, updateRechnungDto: UpdateRechnungDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRechnungDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRechnungById(rechnungId, updateRechnungDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the selected line items for an Rx within a LINE_ITEM_CORRECTION transaction
         * @param {string} transactionId 
         * @param {string} rxId 
         * @param {UpdateSelectedLineItemsRequest} updateSelectedLineItemsRequest Selected line items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSelectedLineItems(transactionId: string, rxId: string, updateSelectedLineItemsRequest: UpdateSelectedLineItemsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSelectedLineItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSelectedLineItems(transactionId, rxId, updateSelectedLineItemsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload an Rx scan document to an existing insurance bill
         * @param {string} transactionId ID of the insurance transaction
         * @param {UploadRxScanToExistingBillDocuTypeEnum} docuType 
         * @param {UploadRxScanToExistingBillOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadRxScanToExistingBill(transactionId: string, docuType: UploadRxScanToExistingBillDocuTypeEnum, ownerType: UploadRxScanToExistingBillOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadRxScanToExistingBill(transactionId, docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {UploadSignedDocumentDocuTypeEnum} docuType 
         * @param {UploadSignedDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSignedDocument(debitPermissionId: string, docuType: UploadSignedDocumentDocuTypeEnum, ownerType: UploadSignedDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSignedDocument(debitPermissionId, docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Batch validate Rxs for GKV direct billing
         * @param {ValidateGkvBillRxsRequest} validateGkvBillRxsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateGkvBillRxs(validateGkvBillRxsRequest: ValidateGkvBillRxsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateGkvBillRxs(validateGkvBillRxsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all tickets associated with an insurance transaction
         * @param {string} transactionId Please provide a valid transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTicketsByTransactionId(transactionId: string, options?: any): AxiosPromise<Array<TicketDto>> {
            return localVarFp.allTicketsByTransactionId(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns detailed unpaid bills information for a specific patient. (excluding BG, perpetual, without dates Rxs along with Rx with rechnung)
         * @summary Get a warning badge for unpaid bills
         * @param {number} pid Numeric patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgesForUnpaidBills(pid: number, options?: any): AxiosPromise<UnpaidBillsBadgeDto> {
            return localVarFp.badgesForUnpaidBills(pid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk soft delete multiple LastSchrift transactions and optionally their associated Rechnungen
         * @param {BulkSoftDeleteLastSchriftsRequest} bulkSoftDeleteLastSchriftsRequest LastSchrift IDs and options for bulk deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSoftDeleteLastSchrifts(bulkSoftDeleteLastSchriftsRequest: BulkSoftDeleteLastSchriftsRequest, options?: any): AxiosPromise<BulkSoftDeleteLastSchrifts200Response> {
            return localVarFp.bulkSoftDeleteLastSchrifts(bulkSoftDeleteLastSchriftsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original Bank Transfer transaction to cancel
         * @param {object} body Reason for cancelling the Bank Transfer transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBankTransfer(id: string, body: object, options?: any): AxiosPromise<string> {
            return localVarFp.cancelBankTransfer(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original cash transaction to cancel
         * @param {object} body Reason for cancelling the cash transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCashTransaction(id: string, body: object, options?: any): AxiosPromise<BaseTransactionDetailsDto> {
            return localVarFp.cancelCashTransaction(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id ID of the original EC transaction to cancel
         * @param {object} body Reason for cancelling the EC transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelECTransaction(id: string, body: object, options?: any): AxiosPromise<BaseTransactionDetailsDto> {
            return localVarFp.cancelECTransaction(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateBankTransferDto} createBankTransferDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransferForRechnung(createBankTransferDto: CreateBankTransferDto, options?: any): AxiosPromise<void> {
            return localVarFp.createBankTransferForRechnung(createBankTransferDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillReminderForRechnung(rId: string, options?: any): AxiosPromise<GetRechnungDetailsDto> {
            return localVarFp.createBillReminderForRechnung(rId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint creates or updates credit permissions for SEPA credit transfer (refund) transactions. For direct debits, use the /debitPermission endpoint instead.
         * @summary Create or update a credit permission (bank account for refunds)
         * @param {DebitPermissionDto} debitPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateCreditPermission(debitPermissionDto: DebitPermissionDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOrUpdateCreditPermission(debitPermissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint creates or updates debit permissions for SEPA direct debit transactions. For refunds, use the /creditPermission endpoint instead.
         * @summary Create or update a debit permission (bank account for direct debits)
         * @param {number} patientId 
         * @param {DebitPermissionDto} debitPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateDebitPermission(patientId: number, debitPermissionDto: DebitPermissionDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOrUpdateDebitPermission(patientId, debitPermissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateRechnungDto} createRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRechnung(createRechnungDto: CreateRechnungDto, options?: any): AxiosPromise<GetRechnungDetailsDto> {
            return localVarFp.createRechnung(createRechnungDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a refund (LastSchrift with type=REFUND) using a patient\'s credit permission. Amount is stored as negative in database for accounting purposes (money leaving practice), but will be converted to positive when exporting to SEPA XML.
         * @summary Create a refund transaction using credit permission
         * @param {CreateRefundDto} createRefundDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund(createRefundDto: CreateRefundDto, options?: any): AxiosPromise<RefundDetailsDto> {
            return localVarFp.createRefund(createRefundDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateServiceRechnungDto} createServiceRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceRechnung(createServiceRechnungDto: CreateServiceRechnungDto, options?: any): AxiosPromise<GetRechnungDetailsDto> {
            return localVarFp.createServiceRechnung(createServiceRechnungDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary A generic transaction creation endpoint for services
         * @param {CreateServicesTransactionDto} createServicesTransactionDto 
         * @param {boolean} [isGiftCertificate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServicesTransaction(createServicesTransactionDto: CreateServicesTransactionDto, isGiftCertificate?: boolean, options?: any): AxiosPromise<BaseTransactionDetailsDto> {
            return localVarFp.createServicesTransaction(createServicesTransactionDto, isGiftCertificate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary A generic transaction creation endpoint for both patient and insurance
         * @param {CreateTransactionRequest} createTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction(createTransactionRequest: CreateTransactionRequest, options?: any): AxiosPromise<BaseTransactionDetailsDto> {
            return localVarFp.createTransaction(createTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDirectBillingDocument(id: string, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.downloadDirectBillingDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates SEPA Credit Transfer XML file for outgoing payments (Überweisungen)
         * @summary Export Credit Transfer transactions to SEPA pain.001.001.03 format
         * @param {ExportCreditTransferToSEPARequest} exportCreditTransferToSEPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCreditTransferToSEPA(exportCreditTransferToSEPARequest: ExportCreditTransferToSEPARequest, options?: any): AxiosPromise<ExportCreditTransferToSEPA200Response> {
            return localVarFp.exportCreditTransferToSEPA(exportCreditTransferToSEPARequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export credit transfer (refund) transactions to SEPA pain.001.001.03 format and mark as exported
         * @param {ExportCreditTransfersBatchRequest} exportCreditTransfersBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCreditTransfersBatch(exportCreditTransfersBatchRequest: ExportCreditTransfersBatchRequest, options?: any): AxiosPromise<SEPAExportResultDto> {
            return localVarFp.exportCreditTransfersBatch(exportCreditTransfersBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export GKV bills — encrypt EDIFACT and send to data center
         * @param {GkvBillExportRequestDto} gkvBillExportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportGkvBills(gkvBillExportRequestDto: GkvBillExportRequestDto, options?: any): AxiosPromise<GkvBillExportResponseDto> {
            return localVarFp.exportGkvBills(gkvBillExportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export/Convert insurance bills to a relevant file type format
         * @param {ExportBillingRequestDto} exportBillingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInsuranceBills(exportBillingRequestDto: ExportBillingRequestDto, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.exportInsuranceBills(exportBillingRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export all unexported LastSchrift transactions for an account to SEPA format
         * @param {ExportLastSchriftsByAccountRequest} exportLastSchriftsByAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLastSchriftsByAccount(exportLastSchriftsByAccountRequest: ExportLastSchriftsByAccountRequest, options?: any): AxiosPromise<SEPAExportResultDto> {
            return localVarFp.exportLastSchriftsByAccount(exportLastSchriftsByAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export LastSchrift transactions to SEPA pain.008.001.02 format
         * @param {ExportLastSchriftsToSEPARequest} exportLastSchriftsToSEPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLastSchriftsToSEPA(exportLastSchriftsToSEPARequest: ExportLastSchriftsToSEPARequest, options?: any): AxiosPromise<SEPAExportResultDto> {
            return localVarFp.exportLastSchriftsToSEPA(exportLastSchriftsToSEPARequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Details regarding the export of an insurance bill to the insurance company.
         * @param {string} transactionId Please provide a valid insurance transaction ID(UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportedInsuranceDetails(transactionId: string, options?: any): AxiosPromise<ResponseExportInfoDto> {
            return localVarFp.exportedInsuranceDetails(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDebitPermissionPdf(debitPermissionId: string, options?: any): AxiosPromise<DebitPermissionDto> {
            return localVarFp.generateDebitPermissionPdf(debitPermissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all bank transfers to show in Kasse (BANK TRANSFERS)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBankTransfers(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetBankTransferDto> {
            return localVarFp.getAllBankTransfers(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all copayment type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCopaymentInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetInsuranceTransactionDto> {
            return localVarFp.getAllCopaymentInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCorrectionInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetInsuranceTransactionDto> {
            return localVarFp.getAllCorrectionInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetInsuranceTransactionDto> {
            return localVarFp.getAllInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all line item correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLineItemCorrectionInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetInsuranceTransactionDto> {
            return localVarFp.getAllLineItemCorrectionInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Paper type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
         * @param {string} billStatus 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaperInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetInsuranceTransactionDto> {
            return localVarFp.getAllPaperInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all unpaid Rechnungen eligible for a Mahnung (bill reminder)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRechnungWithBillReminders(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetRechnungDto> {
            return localVarFp.getAllRechnungWithBillReminders(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all transactions but we will not use Bank Transfer for this
         * @param {string} accountId Please provide a valid account ID
         * @param {string} transactionType 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTransactions(accountId: string, transactionType: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedBaseTransactionDetailsDto> {
            return localVarFp.getAllTransactions(accountId, transactionType, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch all types of Transaction that have already been created for a specific Patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTxsForPatient(pid: number, options?: any): AxiosPromise<Array<BaseTransactionDetailsDto>> {
            return localVarFp.getAllTxsForPatient(pid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Lastschrift transactions that have not been exported to SEPA yet
         * @summary Fetch all unexported Lastschrift transactions for an account
         * @param {string} accountId Account ID to filter transactions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnexportedLastschriftTransactions(accountId: string, options?: any): AxiosPromise<Array<BaseTransactionDetailsDto>> {
            return localVarFp.getAllUnexportedLastschriftTransactions(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payers and relative billing centers for a specific insurance
         * @param {string} payerIk 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingCentersFromPayer(payerIk: string, accountId: string, options?: any): AxiosPromise<PayerDto> {
            return localVarFp.getBillingCentersFromPayer(payerIk, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get billing data for editing
         * @param {Array<string>} billId 
         * @param {string} billingType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingDataForEditing(billId: Array<string>, billingType: string, options?: any): AxiosPromise<ExportBillingData> {
            return localVarFp.getBillingDataForEditing(billId, billingType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId The ID of the patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditPermissionsForPatient(patientId: number, options?: any): AxiosPromise<Array<DebitPermissionDto>> {
            return localVarFp.getCreditPermissionsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all relevant data from GKV rxs for billing including payer
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPacketForCopaymentBilling(accountId: string, options?: any): AxiosPromise<ProcessedCopaymentBillingDto> {
            return localVarFp.getDataPacketForCopaymentBilling(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the data packets(rxs details) for sepcific care provider
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPacketForDirectBilling(accountId: string, options?: any): AxiosPromise<Array<GroupedDataDto>> {
            return localVarFp.getDataPacketForDirectBilling(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all relevant data for paper billing including payer
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPacketForPaperBilling(accountId: string, options?: any): AxiosPromise<ProcessedPaperBillingDto> {
            return localVarFp.getDataPacketForPaperBilling(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitPermissionsForPatient(patientId: number, options?: any): AxiosPromise<Array<DebitPermissionDto>> {
            return localVarFp.getDebitPermissionsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get due amount for a specific rx number
         * @param {string} rxId Please provide a valid rxId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuePaymentByRxId(rxId: string, options?: any): AxiosPromise<DuePaymentDto> {
            return localVarFp.getDuePaymentByRxId(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get EDIFACT payload for a specific insurance export
         * @param {string} exportId The ID of the insurance export record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEdifactPayload(exportId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getEdifactPayload(exportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve optimized analytics data for executive dashboards with key metrics, top performers, trend data, and forecasting insights.
         * @summary Get executive dashboard data
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetExecutiveDashboardBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetExecutiveDashboardBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutiveDashboard(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetExecutiveDashboardBillStatusEnum, billType?: GetExecutiveDashboardBillTypeEnum, userId?: string, options?: any): AxiosPromise<ExecutiveDashboardDto> {
            return localVarFp.getExecutiveDashboard(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve key performance indicators including billing volume, revenue metrics, workflow status, and period-over-period growth percentages.
         * @summary Get KPI analytics with period comparison
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetKpiAnalyticsBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetKpiAnalyticsBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpiAnalytics(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetKpiAnalyticsBillStatusEnum, billType?: GetKpiAnalyticsBillTypeEnum, userId?: string, options?: any): AxiosPromise<KpiAnalyticsDto> {
            return localVarFp.getKpiAnalytics(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all possible line items for an Rx (for line item correction selection)
         * @param {string} rxId The Rx ID to fetch line items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItemsForRx(rxId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getLineItemsForRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all paid Rechnungen for Kasse (BEZAHLT)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaidRechnung(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetRechnungDto> {
            return localVarFp.getPaidRechnung(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get price data for a specific Rx (line items and copayment info)
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceDataForRx(rxId: string, options?: any): AxiosPromise<RxPriceDataDto> {
            return localVarFp.getPriceDataForRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all transactions and Rechnungen (with Mahnungen) for a specific Rx, sorted chronologically. Includes soft-deleted records and cancellations for full audit trail.
         * @summary Get billing timeline for a specific Rx
         * @param {string} rxId The Rx ID to fetch the billing timeline for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxBillingTimeline(rxId: string, options?: any): AxiosPromise<RxBillingTimelineDto> {
            return localVarFp.getRxBillingTimeline(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the waivable fees of an Rx and whether each is waived
         * @param {string} rxId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxFeeWaivers(rxId: string, options?: any): AxiosPromise<RxFeeWaiversDto> {
            return localVarFp.getRxFeeWaivers(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Rx previews for a specific transaction/bill for correction
         * @param {string} transactionId Transaction ID obtained from resolveCorrectionBillNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxPreviewsForCorrectionBill(transactionId: string, options?: any): AxiosPromise<Array<RxPreviewDto>> {
            return localVarFp.getRxPreviewsForCorrectionBill(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve distribution of prescriptions by type (Heilmittel, Services, etc.) with revenue and volume metrics.
         * @summary Get prescription type distribution
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetRxTypeDistributionBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetRxTypeDistributionBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRxTypeDistribution(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetRxTypeDistributionBillStatusEnum, billType?: GetRxTypeDistributionBillTypeEnum, userId?: string, options?: any): AxiosPromise<Array<RxTypeDistributionDto>> {
            return localVarFp.getRxTypeDistribution(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a single Rx to add to an indirect bill
         * @param {string} rxNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleRxForIndirectBillsForInsurance(rxNumber: string, options?: any): AxiosPromise<RxDto> {
            return localVarFp.getSingleRxForIndirectBillsForInsurance(rxNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the highest revenue-generating insurance payers with bill counts and revenue percentages.
         * @summary Get top performing payers by amount
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetTopPayersByAmountBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetTopPayersByAmountBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {number} [limit] Maximum number of top payers to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopPayersByAmount(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTopPayersByAmountBillStatusEnum, billType?: GetTopPayersByAmountBillTypeEnum, userId?: string, limit?: number, options?: any): AxiosPromise<Array<PayerPerformanceDto>> {
            return localVarFp.getTopPayersByAmount(startDate, endDate, accountId, payerId, billStatus, billType, userId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve time-series trend data including monthly and weekly transaction trends, and prescription volume trends for charts and forecasting.
         * @summary Get comprehensive trend analytics
         * @param {string} [startDate] Start date for the analytics period
         * @param {string} [endDate] End date for the analytics period
         * @param {string} [accountId] Filter by specific account ID
         * @param {string} [payerId] Filter by specific payer ID
         * @param {GetTrendAnalyticsBillStatusEnum} [billStatus] Filter by bill status
         * @param {GetTrendAnalyticsBillTypeEnum} [billType] Filter by bill type
         * @param {string} [userId] Filter by user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendAnalytics(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTrendAnalyticsBillStatusEnum, billType?: GetTrendAnalyticsBillTypeEnum, userId?: string, options?: any): AxiosPromise<TrendAnalyticsResponseDto> {
            return localVarFp.getTrendAnalytics(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all credit transfer (refund) transactions that haven\'t been exported yet with account SEPA data
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnexportedCreditTransfers(accountId?: string, options?: any): AxiosPromise<UnexportedLastSchriftsResponseDto> {
            return localVarFp.getUnexportedCreditTransfers(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all LastSchrift transactions that haven\'t been exported yet with account SEPA data
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnexportedLastSchrifts(accountId?: string, options?: any): AxiosPromise<UnexportedLastSchriftsResponseDto> {
            return localVarFp.getUnexportedLastSchrifts(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unique firstName, lastName, and iban pairs for a patient
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniquePairsForPatient(patientId: number, options?: any): AxiosPromise<Array<DebitPermissionDto>> {
            return localVarFp.getUniquePairsForPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all unpaid Rechnungen (OFFENE POSTEN)
         * @param {string} accountId Please provide a valid account ID
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnpaidRechnung(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: any): AxiosPromise<PaginatedGetRechnungDto> {
            return localVarFp.getUnpaidRechnung(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Optimized loading GKV billing - grouped by payer with total prices
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGkvBills(accountId: string, options?: any): AxiosPromise<Array<DirectBillingPayerGroupDto>> {
            return localVarFp.loadGkvBills(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load GKV bills for editing — optimized batch endpoint
         * @param {Array<string>} billIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGkvBillsForEdit(billIds: Array<string>, options?: any): AxiosPromise<Array<GkvBillEditDto>> {
            return localVarFp.loadGkvBillsForEdit(billIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load a single Rx for GKV direct billing with price, billing centers and validation
         * @param {string} rxId The Rx ID to load
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSingleGkvBillRx(rxId: string, options?: any): AxiosPromise<DirectBillingSingleRxResponseDto> {
            return localVarFp.loadSingleGkvBillRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {MergeDocumentsRequestDto} mergeDocumentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeDirectBillingDocuments(mergeDocumentsRequestDto: MergeDocumentsRequestDto, options?: any): AxiosPromise<MergeDocumentsResponseDto> {
            return localVarFp.mergeDirectBillingDocuments(mergeDocumentsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get minimal insurance transaction details by transaction ID (for internal use)
         * @param {string} id Please provide a valid transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        minimalInsuranceTransactionById(id: string, options?: any): AxiosPromise<GetInsuranceTransactionDto> {
            return localVarFp.minimalInsuranceTransactionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} appointmentId 
         * @param {CreateRechnungDto} createRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        noShowInvoiceTransaction(appointmentId: string, createRechnungDto: CreateRechnungDto, options?: any): AxiosPromise<GetRechnungDetailsDto> {
            return localVarFp.noShowInvoiceTransaction(appointmentId, createRechnungDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bills Information (Paid, Due and others) for a specific patient
         * @param {number} pid Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientBillInfo(pid: number, options?: any): AxiosPromise<Array<PatientBillInfoDto>> {
            return localVarFp.patientBillInfo(pid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all the rechnungs associated with the patient
         * @param {number} pId Please provide a valid patient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientRechnungInfo(pId: number, options?: any): AxiosPromise<Array<GetRechnungDetailsDto>> {
            return localVarFp.patientRechnungInfo(pId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create correction bills from selected Rxs
         * @param {PrepareCorrectionBillsFromRxsRequest} prepareCorrectionBillsFromRxsRequest Account ID and selected Rx IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareCorrectionBillsFromRxs(prepareCorrectionBillsFromRxsRequest: PrepareCorrectionBillsFromRxsRequest, options?: any): AxiosPromise<Array<ProcessedCorrectionBillingDto>> {
            return localVarFp.prepareCorrectionBillsFromRxs(prepareCorrectionBillsFromRxsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {PrintDirectBillingDocumentTestTypeEnum} [testType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printDirectBillingDocument(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, testType?: PrintDirectBillingDocumentTestTypeEnum, options?: any): AxiosPromise<GetInsuranceTransactionDto> {
            return localVarFp.printDirectBillingDocument(id, updateInsuranceTransactionDto, testType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Print GKV bill — generates PDFs and returns document references
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printGkvBill(id: string, options?: any): AxiosPromise<GkvBillPrintResponseDto> {
            return localVarFp.printGkvBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printInsuranceCopaymentDocuments(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: any): AxiosPromise<GetInsuranceTransactionDto> {
            return localVarFp.printInsuranceCopaymentDocuments(id, updateInsuranceTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printPaperBillingDocument(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: any): AxiosPromise<GetInsuranceTransactionDto> {
            return localVarFp.printPaperBillingDocument(id, updateInsuranceTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rxId Please provide a valid rx ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechnungsForRx(rxId: string, options?: any): AxiosPromise<Array<GetRechnungDetailsDto>> {
            return localVarFp.rechnungsForRx(rxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAmount(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.refreshAmount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} billId 
         * @param {string} pdfDate Optional date to be included in the regenerated PDF documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateInsuranceTransactionPdfs(billId: string, pdfDate: string, options?: any): AxiosPromise<GetInsuranceTransactionDto> {
            return localVarFp.regenerateInsuranceTransactionPdfs(billId, pdfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Rx from insurance transaction
         * @param {string} id Transaction ID
         * @param {string} rxId Rx ID to remove
         * @param {any} locationId Location ID of the user
         * @param {RemoveRxFromExportedTransactionDto} removeRxFromExportedTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRxFromTransaction(id: string, rxId: string, locationId: any, removeRxFromExportedTransactionDto: RemoveRxFromExportedTransactionDto, options?: any): AxiosPromise<ResponseExportInfoDto> {
            return localVarFp.removeRxFromTransaction(id, rxId, locationId, removeRxFromExportedTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a bill number to get transaction ID for correction
         * @param {string} accountId 
         * @param {string} billNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCorrectionBillNumber(accountId: string, billNumber: string, options?: any): AxiosPromise<ResolveCorrectionBillNumber200Response> {
            return localVarFp.resolveCorrectionBillNumber(accountId, billNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve rxId and accountId by rxNumber
         * @param {string} rxNumber The rxNumber to resolve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveRx(rxNumber: string, options?: any): AxiosPromise<void> {
            return localVarFp.resolveRx(rxNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search prescriptions (Rx) by patient name for potential addition to insurance bill
         * @param {string} searchTerm Search term for patient name (first and/or last) to find relevant prescriptions (Rx) for insurance bill addition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRxToAddInsuranceBill(searchTerm: string, options?: any): AxiosPromise<void> {
            return localVarFp.searchRxToAddInsuranceBill(searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Email a patient\'s billing documents (Rechnung and/or Mahnungen) as PDF attachments
         * @param {string} rechnungId The UUID of the Rechnung whose documents should be emailed
         * @param {SendBillEmailDto} sendBillEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBillEmail(rechnungId: string, sendBillEmailDto: SendBillEmailDto, options?: any): AxiosPromise<GetRechnungDetailsDto> {
            return localVarFp.sendBillEmail(rechnungId, sendBillEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set which fees of an Rx are waived
         * @param {string} rxId 
         * @param {SetRxFeeWaiversDto} setRxFeeWaiversDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRxFeeWaivers(rxId: string, setRxFeeWaiversDto: SetRxFeeWaiversDto, options?: any): AxiosPromise<RxFeeWaiversDto> {
            return localVarFp.setRxFeeWaivers(rxId, setRxFeeWaiversDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id Please provide a valid bill ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatusOpenToFinished(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.setStatusOpenToFinished(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteDebitPermission(debitPermissionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.softDeleteDebitPermission(debitPermissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteInsuranceTransaction(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.softDeleteInsuranceTransaction(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft delete a LastSchrift transaction and optionally its associated Rechnung
         * @param {string} lastSchriftId ID of the LastSchrift transaction to delete
         * @param {boolean} [deleteRechnung] Whether to also delete the associated Rechnung (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteLastSchrift(lastSchriftId: string, deleteRechnung?: boolean, options?: any): AxiosPromise<SoftDeleteLastSchrift200Response> {
            return localVarFp.softDeleteLastSchrift(lastSchriftId, deleteRechnung, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} rechnungId ID of the Rechnung to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteRechnung(rechnungId: string, options?: any): AxiosPromise<string> {
            return localVarFp.softDeleteRechnung(rechnungId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a workflow to generate PDFs for multiple bills in parallel. Returns a workflowId for progress tracking via WebSocket.
         * @summary Start batch PDF generation for multiple bills
         * @param {StartBillPdfBatchRequestDto} startBillPdfBatchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startBillPdfBatch(startBillPdfBatchRequestDto: StartBillPdfBatchRequestDto, options?: any): AxiosPromise<StartBillPdfBatchResponseDto> {
            return localVarFp.startBillPdfBatch(startBillPdfBatchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test route to verify routing works after SEPA exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAfterSepa(options?: any): AxiosPromise<void> {
            return localVarFp.testAfterSepa(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test route to verify routing works
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testBeforeSepa(options?: any): AxiosPromise<void> {
            return localVarFp.testBeforeSepa(options).then((request) => request(axios, basePath));
        },
        /**
         * Resets wasExported flag and clears export metadata for specified credit transfers
         * @summary Undo SEPA export status for credit transfers
         * @param {UndoCreditTransferExportRequest} undoCreditTransferExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCreditTransferExport(undoCreditTransferExportRequest: UndoCreditTransferExportRequest, options?: any): AxiosPromise<UndoCreditTransferExport200Response> {
            return localVarFp.undoCreditTransferExport(undoCreditTransferExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets wasExported flag for all credit transfers linked to a specific SEPA document
         * @summary Undo SEPA credit transfer export by document ID
         * @param {UndoCreditTransferExportByDocumentRequest} undoCreditTransferExportByDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCreditTransferExportByDocument(undoCreditTransferExportByDocumentRequest: UndoCreditTransferExportByDocumentRequest, options?: any): AxiosPromise<UndoCreditTransferExport200Response> {
            return localVarFp.undoCreditTransferExportByDocument(undoCreditTransferExportByDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets the export status of all LastSchrift transactions that were part of a specific SEPA export document
         * @summary Undo SEPA export for all LastSchrift transactions associated with a SEPA document
         * @param {UndoSEPAExportByDocumentRequest} undoSEPAExportByDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoSEPAExportByDocument(undoSEPAExportByDocumentRequest: UndoSEPAExportByDocumentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.undoSEPAExportByDocument(undoSEPAExportByDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets the export status of specified LastSchrift transactions, allowing them to be exported again
         * @summary Undo SEPA export for specific LastSchrift transactions
         * @param {UndoSEPAExportForLastSchriftsRequest} undoSEPAExportForLastSchriftsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoSEPAExportForLastSchrifts(undoSEPAExportForLastSchriftsRequest: UndoSEPAExportForLastSchriftsRequest, options?: any): AxiosPromise<UndoSEPAExportForLastSchrifts200Response> {
            return localVarFp.undoSEPAExportForLastSchrifts(undoSEPAExportForLastSchriftsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateDelayStatusDto} updateDelayStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelayStatus(id: string, updateDelayStatusDto: UpdateDelayStatusDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateDelayStatus(id, updateDelayStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateExportStatusDto} updateExportStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportAndBillingStatus(id: string, updateExportStatusDto: UpdateExportStatusDto, options?: any): AxiosPromise<UpdateExportStatusDto> {
            return localVarFp.updateExportAndBillingStatus(id, updateExportStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateExportStatusDto} updateExportStatusDto 
         * @param {Array<string>} [rxIds] Array of Rx IDs (can contain a single element or multiple)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportBillingStatusAndRxStatus(id: string, updateExportStatusDto: UpdateExportStatusDto, rxIds?: Array<string>, options?: any): AxiosPromise<UpdateExportStatusDto> {
            return localVarFp.updateExportBillingStatusAndRxStatus(id, updateExportStatusDto, rxIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update GKV bill — optimized lean endpoint
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGkvBill(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: any): AxiosPromise<GkvBillUpdateResponseDto> {
            return localVarFp.updateGkvBill(id, updateInsuranceTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsuranceTransaction(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: any): AxiosPromise<UpdateInsuranceTransactionDto> {
            return localVarFp.updateInsuranceTransaction(id, updateInsuranceTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing Rechnung.
         * @param {string} rechnungId The UUID of the existing Rechnung
         * @param {UpdateRechnungDto} updateRechnungDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRechnungById(rechnungId: string, updateRechnungDto: UpdateRechnungDto, options?: any): AxiosPromise<GetRechnungDetailsDto> {
            return localVarFp.updateRechnungById(rechnungId, updateRechnungDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the selected line items for an Rx within a LINE_ITEM_CORRECTION transaction
         * @param {string} transactionId 
         * @param {string} rxId 
         * @param {UpdateSelectedLineItemsRequest} updateSelectedLineItemsRequest Selected line items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectedLineItems(transactionId: string, rxId: string, updateSelectedLineItemsRequest: UpdateSelectedLineItemsRequest, options?: any): AxiosPromise<UpdateSelectedLineItems200Response> {
            return localVarFp.updateSelectedLineItems(transactionId, rxId, updateSelectedLineItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an Rx scan document to an existing insurance bill
         * @param {string} transactionId ID of the insurance transaction
         * @param {UploadRxScanToExistingBillDocuTypeEnum} docuType 
         * @param {UploadRxScanToExistingBillOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRxScanToExistingBill(transactionId: string, docuType: UploadRxScanToExistingBillDocuTypeEnum, ownerType: UploadRxScanToExistingBillOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.uploadRxScanToExistingBill(transactionId, docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} debitPermissionId 
         * @param {UploadSignedDocumentDocuTypeEnum} docuType 
         * @param {UploadSignedDocumentOwnerTypeEnum} ownerType 
         * @param {string} ownerId 
         * @param {File} file 
         * @param {boolean} [makeAccessible] 
         * @param {string} [rxId] 
         * @param {string} [noticeDefinitionDataId] 
         * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSignedDocument(debitPermissionId: string, docuType: UploadSignedDocumentDocuTypeEnum, ownerType: UploadSignedDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.uploadSignedDocument(debitPermissionId, docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Batch validate Rxs for GKV direct billing
         * @param {ValidateGkvBillRxsRequest} validateGkvBillRxsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateGkvBillRxs(validateGkvBillRxsRequest: ValidateGkvBillRxsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.validateGkvBillRxs(validateGkvBillRxsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @summary Get all tickets associated with an insurance transaction
     * @param {string} transactionId Please provide a valid transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public allTicketsByTransactionId(transactionId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).allTicketsByTransactionId(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns detailed unpaid bills information for a specific patient. (excluding BG, perpetual, without dates Rxs along with Rx with rechnung)
     * @summary Get a warning badge for unpaid bills
     * @param {number} pid Numeric patient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public badgesForUnpaidBills(pid: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).badgesForUnpaidBills(pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk soft delete multiple LastSchrift transactions and optionally their associated Rechnungen
     * @param {BulkSoftDeleteLastSchriftsRequest} bulkSoftDeleteLastSchriftsRequest LastSchrift IDs and options for bulk deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public bulkSoftDeleteLastSchrifts(bulkSoftDeleteLastSchriftsRequest: BulkSoftDeleteLastSchriftsRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).bulkSoftDeleteLastSchrifts(bulkSoftDeleteLastSchriftsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id ID of the original Bank Transfer transaction to cancel
     * @param {object} body Reason for cancelling the Bank Transfer transaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public cancelBankTransfer(id: string, body: object, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).cancelBankTransfer(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id ID of the original cash transaction to cancel
     * @param {object} body Reason for cancelling the cash transaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public cancelCashTransaction(id: string, body: object, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).cancelCashTransaction(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id ID of the original EC transaction to cancel
     * @param {object} body Reason for cancelling the EC transaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public cancelECTransaction(id: string, body: object, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).cancelECTransaction(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateBankTransferDto} createBankTransferDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createBankTransferForRechnung(createBankTransferDto: CreateBankTransferDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createBankTransferForRechnung(createBankTransferDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createBillReminderForRechnung(rId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createBillReminderForRechnung(rId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint creates or updates credit permissions for SEPA credit transfer (refund) transactions. For direct debits, use the /debitPermission endpoint instead.
     * @summary Create or update a credit permission (bank account for refunds)
     * @param {DebitPermissionDto} debitPermissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createOrUpdateCreditPermission(debitPermissionDto: DebitPermissionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createOrUpdateCreditPermission(debitPermissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint creates or updates debit permissions for SEPA direct debit transactions. For refunds, use the /creditPermission endpoint instead.
     * @summary Create or update a debit permission (bank account for direct debits)
     * @param {number} patientId 
     * @param {DebitPermissionDto} debitPermissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createOrUpdateDebitPermission(patientId: number, debitPermissionDto: DebitPermissionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createOrUpdateDebitPermission(patientId, debitPermissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateRechnungDto} createRechnungDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createRechnung(createRechnungDto: CreateRechnungDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createRechnung(createRechnungDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a refund (LastSchrift with type=REFUND) using a patient\'s credit permission. Amount is stored as negative in database for accounting purposes (money leaving practice), but will be converted to positive when exporting to SEPA XML.
     * @summary Create a refund transaction using credit permission
     * @param {CreateRefundDto} createRefundDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createRefund(createRefundDto: CreateRefundDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createRefund(createRefundDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateServiceRechnungDto} createServiceRechnungDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createServiceRechnung(createServiceRechnungDto: CreateServiceRechnungDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createServiceRechnung(createServiceRechnungDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary A generic transaction creation endpoint for services
     * @param {CreateServicesTransactionDto} createServicesTransactionDto 
     * @param {boolean} [isGiftCertificate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createServicesTransaction(createServicesTransactionDto: CreateServicesTransactionDto, isGiftCertificate?: boolean, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createServicesTransaction(createServicesTransactionDto, isGiftCertificate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary A generic transaction creation endpoint for both patient and insurance
     * @param {CreateTransactionRequest} createTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public createTransaction(createTransactionRequest: CreateTransactionRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).createTransaction(createTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public downloadDirectBillingDocument(id: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).downloadDirectBillingDocument(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates SEPA Credit Transfer XML file for outgoing payments (Überweisungen)
     * @summary Export Credit Transfer transactions to SEPA pain.001.001.03 format
     * @param {ExportCreditTransferToSEPARequest} exportCreditTransferToSEPARequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportCreditTransferToSEPA(exportCreditTransferToSEPARequest: ExportCreditTransferToSEPARequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportCreditTransferToSEPA(exportCreditTransferToSEPARequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export credit transfer (refund) transactions to SEPA pain.001.001.03 format and mark as exported
     * @param {ExportCreditTransfersBatchRequest} exportCreditTransfersBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportCreditTransfersBatch(exportCreditTransfersBatchRequest: ExportCreditTransfersBatchRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportCreditTransfersBatch(exportCreditTransfersBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export GKV bills — encrypt EDIFACT and send to data center
     * @param {GkvBillExportRequestDto} gkvBillExportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportGkvBills(gkvBillExportRequestDto: GkvBillExportRequestDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportGkvBills(gkvBillExportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export/Convert insurance bills to a relevant file type format
     * @param {ExportBillingRequestDto} exportBillingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportInsuranceBills(exportBillingRequestDto: ExportBillingRequestDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportInsuranceBills(exportBillingRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export all unexported LastSchrift transactions for an account to SEPA format
     * @param {ExportLastSchriftsByAccountRequest} exportLastSchriftsByAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportLastSchriftsByAccount(exportLastSchriftsByAccountRequest: ExportLastSchriftsByAccountRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportLastSchriftsByAccount(exportLastSchriftsByAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export LastSchrift transactions to SEPA pain.008.001.02 format
     * @param {ExportLastSchriftsToSEPARequest} exportLastSchriftsToSEPARequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportLastSchriftsToSEPA(exportLastSchriftsToSEPARequest: ExportLastSchriftsToSEPARequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportLastSchriftsToSEPA(exportLastSchriftsToSEPARequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Details regarding the export of an insurance bill to the insurance company.
     * @param {string} transactionId Please provide a valid insurance transaction ID(UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public exportedInsuranceDetails(transactionId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).exportedInsuranceDetails(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} debitPermissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public generateDebitPermissionPdf(debitPermissionId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).generateDebitPermissionPdf(debitPermissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all bank transfers to show in Kasse (BANK TRANSFERS)
     * @param {string} accountId Please provide a valid account ID
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllBankTransfers(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllBankTransfers(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all copayment type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
     * @param {string} billStatus 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllCopaymentInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllCopaymentInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
     * @param {string} billStatus 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllCorrectionInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllCorrectionInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
     * @param {string} billStatus 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all line item correction type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
     * @param {string} billStatus 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllLineItemCorrectionInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllLineItemCorrectionInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Paper type insurance bills according to billing status (Status: OPEN, PREVIOUS, START)
     * @param {string} billStatus 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllPaperInsuranceTransactions(billStatus: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllPaperInsuranceTransactions(billStatus, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all unpaid Rechnungen eligible for a Mahnung (bill reminder)
     * @param {string} accountId Please provide a valid account ID
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllRechnungWithBillReminders(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllRechnungWithBillReminders(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all transactions but we will not use Bank Transfer for this
     * @param {string} accountId Please provide a valid account ID
     * @param {string} transactionType 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllTransactions(accountId: string, transactionType: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllTransactions(accountId, transactionType, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch all types of Transaction that have already been created for a specific Patient
     * @param {number} pid Please provide a valid patient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllTxsForPatient(pid: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllTxsForPatient(pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Lastschrift transactions that have not been exported to SEPA yet
     * @summary Fetch all unexported Lastschrift transactions for an account
     * @param {string} accountId Account ID to filter transactions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getAllUnexportedLastschriftTransactions(accountId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getAllUnexportedLastschriftTransactions(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payers and relative billing centers for a specific insurance
     * @param {string} payerIk 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getBillingCentersFromPayer(payerIk: string, accountId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getBillingCentersFromPayer(payerIk, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get billing data for editing
     * @param {Array<string>} billId 
     * @param {string} billingType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getBillingDataForEditing(billId: Array<string>, billingType: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getBillingDataForEditing(billId, billingType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId The ID of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getCreditPermissionsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getCreditPermissionsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all relevant data from GKV rxs for billing including payer
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getDataPacketForCopaymentBilling(accountId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getDataPacketForCopaymentBilling(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the data packets(rxs details) for sepcific care provider
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getDataPacketForDirectBilling(accountId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getDataPacketForDirectBilling(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all relevant data for paper billing including payer
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getDataPacketForPaperBilling(accountId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getDataPacketForPaperBilling(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getDebitPermissionsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getDebitPermissionsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get due amount for a specific rx number
     * @param {string} rxId Please provide a valid rxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getDuePaymentByRxId(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getDuePaymentByRxId(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get EDIFACT payload for a specific insurance export
     * @param {string} exportId The ID of the insurance export record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getEdifactPayload(exportId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getEdifactPayload(exportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve optimized analytics data for executive dashboards with key metrics, top performers, trend data, and forecasting insights.
     * @summary Get executive dashboard data
     * @param {string} [startDate] Start date for the analytics period
     * @param {string} [endDate] End date for the analytics period
     * @param {string} [accountId] Filter by specific account ID
     * @param {string} [payerId] Filter by specific payer ID
     * @param {GetExecutiveDashboardBillStatusEnum} [billStatus] Filter by bill status
     * @param {GetExecutiveDashboardBillTypeEnum} [billType] Filter by bill type
     * @param {string} [userId] Filter by user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getExecutiveDashboard(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetExecutiveDashboardBillStatusEnum, billType?: GetExecutiveDashboardBillTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getExecutiveDashboard(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve key performance indicators including billing volume, revenue metrics, workflow status, and period-over-period growth percentages.
     * @summary Get KPI analytics with period comparison
     * @param {string} [startDate] Start date for the analytics period
     * @param {string} [endDate] End date for the analytics period
     * @param {string} [accountId] Filter by specific account ID
     * @param {string} [payerId] Filter by specific payer ID
     * @param {GetKpiAnalyticsBillStatusEnum} [billStatus] Filter by bill status
     * @param {GetKpiAnalyticsBillTypeEnum} [billType] Filter by bill type
     * @param {string} [userId] Filter by user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getKpiAnalytics(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetKpiAnalyticsBillStatusEnum, billType?: GetKpiAnalyticsBillTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getKpiAnalytics(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all possible line items for an Rx (for line item correction selection)
     * @param {string} rxId The Rx ID to fetch line items for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getLineItemsForRx(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getLineItemsForRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all paid Rechnungen for Kasse (BEZAHLT)
     * @param {string} accountId Please provide a valid account ID
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getPaidRechnung(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getPaidRechnung(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get price data for a specific Rx (line items and copayment info)
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getPriceDataForRx(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getPriceDataForRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all transactions and Rechnungen (with Mahnungen) for a specific Rx, sorted chronologically. Includes soft-deleted records and cancellations for full audit trail.
     * @summary Get billing timeline for a specific Rx
     * @param {string} rxId The Rx ID to fetch the billing timeline for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getRxBillingTimeline(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getRxBillingTimeline(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the waivable fees of an Rx and whether each is waived
     * @param {string} rxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getRxFeeWaivers(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getRxFeeWaivers(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Rx previews for a specific transaction/bill for correction
     * @param {string} transactionId Transaction ID obtained from resolveCorrectionBillNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getRxPreviewsForCorrectionBill(transactionId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getRxPreviewsForCorrectionBill(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve distribution of prescriptions by type (Heilmittel, Services, etc.) with revenue and volume metrics.
     * @summary Get prescription type distribution
     * @param {string} [startDate] Start date for the analytics period
     * @param {string} [endDate] End date for the analytics period
     * @param {string} [accountId] Filter by specific account ID
     * @param {string} [payerId] Filter by specific payer ID
     * @param {GetRxTypeDistributionBillStatusEnum} [billStatus] Filter by bill status
     * @param {GetRxTypeDistributionBillTypeEnum} [billType] Filter by bill type
     * @param {string} [userId] Filter by user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getRxTypeDistribution(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetRxTypeDistributionBillStatusEnum, billType?: GetRxTypeDistributionBillTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getRxTypeDistribution(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a single Rx to add to an indirect bill
     * @param {string} rxNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getSingleRxForIndirectBillsForInsurance(rxNumber: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getSingleRxForIndirectBillsForInsurance(rxNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the highest revenue-generating insurance payers with bill counts and revenue percentages.
     * @summary Get top performing payers by amount
     * @param {string} [startDate] Start date for the analytics period
     * @param {string} [endDate] End date for the analytics period
     * @param {string} [accountId] Filter by specific account ID
     * @param {string} [payerId] Filter by specific payer ID
     * @param {GetTopPayersByAmountBillStatusEnum} [billStatus] Filter by bill status
     * @param {GetTopPayersByAmountBillTypeEnum} [billType] Filter by bill type
     * @param {string} [userId] Filter by user ID
     * @param {number} [limit] Maximum number of top payers to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getTopPayersByAmount(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTopPayersByAmountBillStatusEnum, billType?: GetTopPayersByAmountBillTypeEnum, userId?: string, limit?: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTopPayersByAmount(startDate, endDate, accountId, payerId, billStatus, billType, userId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve time-series trend data including monthly and weekly transaction trends, and prescription volume trends for charts and forecasting.
     * @summary Get comprehensive trend analytics
     * @param {string} [startDate] Start date for the analytics period
     * @param {string} [endDate] End date for the analytics period
     * @param {string} [accountId] Filter by specific account ID
     * @param {string} [payerId] Filter by specific payer ID
     * @param {GetTrendAnalyticsBillStatusEnum} [billStatus] Filter by bill status
     * @param {GetTrendAnalyticsBillTypeEnum} [billType] Filter by bill type
     * @param {string} [userId] Filter by user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getTrendAnalytics(startDate?: string, endDate?: string, accountId?: string, payerId?: string, billStatus?: GetTrendAnalyticsBillStatusEnum, billType?: GetTrendAnalyticsBillTypeEnum, userId?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTrendAnalytics(startDate, endDate, accountId, payerId, billStatus, billType, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all credit transfer (refund) transactions that haven\'t been exported yet with account SEPA data
     * @param {string} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getUnexportedCreditTransfers(accountId?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getUnexportedCreditTransfers(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all LastSchrift transactions that haven\'t been exported yet with account SEPA data
     * @param {string} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getUnexportedLastSchrifts(accountId?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getUnexportedLastSchrifts(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unique firstName, lastName, and iban pairs for a patient
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getUniquePairsForPatient(patientId: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getUniquePairsForPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all unpaid Rechnungen (OFFENE POSTEN)
     * @param {string} accountId Please provide a valid account ID
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getUnpaidRechnung(accountId: string, limit?: number, page?: number, startDate?: string, endDate?: string, searchStr?: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getUnpaidRechnung(accountId, limit, page, startDate, endDate, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Optimized loading GKV billing - grouped by payer with total prices
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public loadGkvBills(accountId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).loadGkvBills(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load GKV bills for editing — optimized batch endpoint
     * @param {Array<string>} billIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public loadGkvBillsForEdit(billIds: Array<string>, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).loadGkvBillsForEdit(billIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load a single Rx for GKV direct billing with price, billing centers and validation
     * @param {string} rxId The Rx ID to load
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public loadSingleGkvBillRx(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).loadSingleGkvBillRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {MergeDocumentsRequestDto} mergeDocumentsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public mergeDirectBillingDocuments(mergeDocumentsRequestDto: MergeDocumentsRequestDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).mergeDirectBillingDocuments(mergeDocumentsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get minimal insurance transaction details by transaction ID (for internal use)
     * @param {string} id Please provide a valid transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public minimalInsuranceTransactionById(id: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).minimalInsuranceTransactionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} appointmentId 
     * @param {CreateRechnungDto} createRechnungDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public noShowInvoiceTransaction(appointmentId: string, createRechnungDto: CreateRechnungDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).noShowInvoiceTransaction(appointmentId, createRechnungDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bills Information (Paid, Due and others) for a specific patient
     * @param {number} pid Please provide a valid patient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public patientBillInfo(pid: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).patientBillInfo(pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all the rechnungs associated with the patient
     * @param {number} pId Please provide a valid patient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public patientRechnungInfo(pId: number, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).patientRechnungInfo(pId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create correction bills from selected Rxs
     * @param {PrepareCorrectionBillsFromRxsRequest} prepareCorrectionBillsFromRxsRequest Account ID and selected Rx IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public prepareCorrectionBillsFromRxs(prepareCorrectionBillsFromRxsRequest: PrepareCorrectionBillsFromRxsRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).prepareCorrectionBillsFromRxs(prepareCorrectionBillsFromRxsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
     * @param {PrintDirectBillingDocumentTestTypeEnum} [testType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public printDirectBillingDocument(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, testType?: PrintDirectBillingDocumentTestTypeEnum, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).printDirectBillingDocument(id, updateInsuranceTransactionDto, testType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Print GKV bill — generates PDFs and returns document references
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public printGkvBill(id: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).printGkvBill(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public printInsuranceCopaymentDocuments(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).printInsuranceCopaymentDocuments(id, updateInsuranceTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public printPaperBillingDocument(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).printPaperBillingDocument(id, updateInsuranceTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rxId Please provide a valid rx ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public rechnungsForRx(rxId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).rechnungsForRx(rxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public refreshAmount(id: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).refreshAmount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} billId 
     * @param {string} pdfDate Optional date to be included in the regenerated PDF documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public regenerateInsuranceTransactionPdfs(billId: string, pdfDate: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).regenerateInsuranceTransactionPdfs(billId, pdfDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Rx from insurance transaction
     * @param {string} id Transaction ID
     * @param {string} rxId Rx ID to remove
     * @param {any} locationId Location ID of the user
     * @param {RemoveRxFromExportedTransactionDto} removeRxFromExportedTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public removeRxFromTransaction(id: string, rxId: string, locationId: any, removeRxFromExportedTransactionDto: RemoveRxFromExportedTransactionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).removeRxFromTransaction(id, rxId, locationId, removeRxFromExportedTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a bill number to get transaction ID for correction
     * @param {string} accountId 
     * @param {string} billNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public resolveCorrectionBillNumber(accountId: string, billNumber: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).resolveCorrectionBillNumber(accountId, billNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve rxId and accountId by rxNumber
     * @param {string} rxNumber The rxNumber to resolve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public resolveRx(rxNumber: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).resolveRx(rxNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search prescriptions (Rx) by patient name for potential addition to insurance bill
     * @param {string} searchTerm Search term for patient name (first and/or last) to find relevant prescriptions (Rx) for insurance bill addition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public searchRxToAddInsuranceBill(searchTerm: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).searchRxToAddInsuranceBill(searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Email a patient\'s billing documents (Rechnung and/or Mahnungen) as PDF attachments
     * @param {string} rechnungId The UUID of the Rechnung whose documents should be emailed
     * @param {SendBillEmailDto} sendBillEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public sendBillEmail(rechnungId: string, sendBillEmailDto: SendBillEmailDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).sendBillEmail(rechnungId, sendBillEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set which fees of an Rx are waived
     * @param {string} rxId 
     * @param {SetRxFeeWaiversDto} setRxFeeWaiversDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public setRxFeeWaivers(rxId: string, setRxFeeWaiversDto: SetRxFeeWaiversDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).setRxFeeWaivers(rxId, setRxFeeWaiversDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id Please provide a valid bill ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public setStatusOpenToFinished(id: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).setStatusOpenToFinished(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} debitPermissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public softDeleteDebitPermission(debitPermissionId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).softDeleteDebitPermission(debitPermissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public softDeleteInsuranceTransaction(id: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).softDeleteInsuranceTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft delete a LastSchrift transaction and optionally its associated Rechnung
     * @param {string} lastSchriftId ID of the LastSchrift transaction to delete
     * @param {boolean} [deleteRechnung] Whether to also delete the associated Rechnung (default: true)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public softDeleteLastSchrift(lastSchriftId: string, deleteRechnung?: boolean, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).softDeleteLastSchrift(lastSchriftId, deleteRechnung, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} rechnungId ID of the Rechnung to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public softDeleteRechnung(rechnungId: string, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).softDeleteRechnung(rechnungId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a workflow to generate PDFs for multiple bills in parallel. Returns a workflowId for progress tracking via WebSocket.
     * @summary Start batch PDF generation for multiple bills
     * @param {StartBillPdfBatchRequestDto} startBillPdfBatchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public startBillPdfBatch(startBillPdfBatchRequestDto: StartBillPdfBatchRequestDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).startBillPdfBatch(startBillPdfBatchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test route to verify routing works after SEPA exports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public testAfterSepa(options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).testAfterSepa(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test route to verify routing works
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public testBeforeSepa(options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).testBeforeSepa(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets wasExported flag and clears export metadata for specified credit transfers
     * @summary Undo SEPA export status for credit transfers
     * @param {UndoCreditTransferExportRequest} undoCreditTransferExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public undoCreditTransferExport(undoCreditTransferExportRequest: UndoCreditTransferExportRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).undoCreditTransferExport(undoCreditTransferExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets wasExported flag for all credit transfers linked to a specific SEPA document
     * @summary Undo SEPA credit transfer export by document ID
     * @param {UndoCreditTransferExportByDocumentRequest} undoCreditTransferExportByDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public undoCreditTransferExportByDocument(undoCreditTransferExportByDocumentRequest: UndoCreditTransferExportByDocumentRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).undoCreditTransferExportByDocument(undoCreditTransferExportByDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets the export status of all LastSchrift transactions that were part of a specific SEPA export document
     * @summary Undo SEPA export for all LastSchrift transactions associated with a SEPA document
     * @param {UndoSEPAExportByDocumentRequest} undoSEPAExportByDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public undoSEPAExportByDocument(undoSEPAExportByDocumentRequest: UndoSEPAExportByDocumentRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).undoSEPAExportByDocument(undoSEPAExportByDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets the export status of specified LastSchrift transactions, allowing them to be exported again
     * @summary Undo SEPA export for specific LastSchrift transactions
     * @param {UndoSEPAExportForLastSchriftsRequest} undoSEPAExportForLastSchriftsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public undoSEPAExportForLastSchrifts(undoSEPAExportForLastSchriftsRequest: UndoSEPAExportForLastSchriftsRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).undoSEPAExportForLastSchrifts(undoSEPAExportForLastSchriftsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateDelayStatusDto} updateDelayStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateDelayStatus(id: string, updateDelayStatusDto: UpdateDelayStatusDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateDelayStatus(id, updateDelayStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateExportStatusDto} updateExportStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateExportAndBillingStatus(id: string, updateExportStatusDto: UpdateExportStatusDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateExportAndBillingStatus(id, updateExportStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateExportStatusDto} updateExportStatusDto 
     * @param {Array<string>} [rxIds] Array of Rx IDs (can contain a single element or multiple)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateExportBillingStatusAndRxStatus(id: string, updateExportStatusDto: UpdateExportStatusDto, rxIds?: Array<string>, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateExportBillingStatusAndRxStatus(id, updateExportStatusDto, rxIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update GKV bill — optimized lean endpoint
     * @param {string} id 
     * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateGkvBill(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateGkvBill(id, updateInsuranceTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateInsuranceTransactionDto} updateInsuranceTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateInsuranceTransaction(id: string, updateInsuranceTransactionDto: UpdateInsuranceTransactionDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateInsuranceTransaction(id, updateInsuranceTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing Rechnung.
     * @param {string} rechnungId The UUID of the existing Rechnung
     * @param {UpdateRechnungDto} updateRechnungDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateRechnungById(rechnungId: string, updateRechnungDto: UpdateRechnungDto, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateRechnungById(rechnungId, updateRechnungDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the selected line items for an Rx within a LINE_ITEM_CORRECTION transaction
     * @param {string} transactionId 
     * @param {string} rxId 
     * @param {UpdateSelectedLineItemsRequest} updateSelectedLineItemsRequest Selected line items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateSelectedLineItems(transactionId: string, rxId: string, updateSelectedLineItemsRequest: UpdateSelectedLineItemsRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateSelectedLineItems(transactionId, rxId, updateSelectedLineItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an Rx scan document to an existing insurance bill
     * @param {string} transactionId ID of the insurance transaction
     * @param {UploadRxScanToExistingBillDocuTypeEnum} docuType 
     * @param {UploadRxScanToExistingBillOwnerTypeEnum} ownerType 
     * @param {string} ownerId 
     * @param {File} file 
     * @param {boolean} [makeAccessible] 
     * @param {string} [rxId] 
     * @param {string} [noticeDefinitionDataId] 
     * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public uploadRxScanToExistingBill(transactionId: string, docuType: UploadRxScanToExistingBillDocuTypeEnum, ownerType: UploadRxScanToExistingBillOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).uploadRxScanToExistingBill(transactionId, docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} debitPermissionId 
     * @param {UploadSignedDocumentDocuTypeEnum} docuType 
     * @param {UploadSignedDocumentOwnerTypeEnum} ownerType 
     * @param {string} ownerId 
     * @param {File} file 
     * @param {boolean} [makeAccessible] 
     * @param {string} [rxId] 
     * @param {string} [noticeDefinitionDataId] 
     * @param {boolean} [scanToSearchablePdf] Image uploads are cropped/deskewed and converted to a cleaned, searchable PDF by default. Set to false to store the original image as-is. Non-image uploads are unaffected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public uploadSignedDocument(debitPermissionId: string, docuType: UploadSignedDocumentDocuTypeEnum, ownerType: UploadSignedDocumentOwnerTypeEnum, ownerId: string, file: File, makeAccessible?: boolean, rxId?: string, noticeDefinitionDataId?: string, scanToSearchablePdf?: boolean, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).uploadSignedDocument(debitPermissionId, docuType, ownerType, ownerId, file, makeAccessible, rxId, noticeDefinitionDataId, scanToSearchablePdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Batch validate Rxs for GKV direct billing
     * @param {ValidateGkvBillRxsRequest} validateGkvBillRxsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public validateGkvBillRxs(validateGkvBillRxsRequest: ValidateGkvBillRxsRequest, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).validateGkvBillRxs(validateGkvBillRxsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetExecutiveDashboardBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;
export type GetExecutiveDashboardBillStatusEnum = typeof GetExecutiveDashboardBillStatusEnum[keyof typeof GetExecutiveDashboardBillStatusEnum];
/**
 * @export
 */
export const GetExecutiveDashboardBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;
export type GetExecutiveDashboardBillTypeEnum = typeof GetExecutiveDashboardBillTypeEnum[keyof typeof GetExecutiveDashboardBillTypeEnum];
/**
 * @export
 */
export const GetKpiAnalyticsBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;
export type GetKpiAnalyticsBillStatusEnum = typeof GetKpiAnalyticsBillStatusEnum[keyof typeof GetKpiAnalyticsBillStatusEnum];
/**
 * @export
 */
export const GetKpiAnalyticsBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;
export type GetKpiAnalyticsBillTypeEnum = typeof GetKpiAnalyticsBillTypeEnum[keyof typeof GetKpiAnalyticsBillTypeEnum];
/**
 * @export
 */
export const GetRxTypeDistributionBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;
export type GetRxTypeDistributionBillStatusEnum = typeof GetRxTypeDistributionBillStatusEnum[keyof typeof GetRxTypeDistributionBillStatusEnum];
/**
 * @export
 */
export const GetRxTypeDistributionBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;
export type GetRxTypeDistributionBillTypeEnum = typeof GetRxTypeDistributionBillTypeEnum[keyof typeof GetRxTypeDistributionBillTypeEnum];
/**
 * @export
 */
export const GetTopPayersByAmountBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;
export type GetTopPayersByAmountBillStatusEnum = typeof GetTopPayersByAmountBillStatusEnum[keyof typeof GetTopPayersByAmountBillStatusEnum];
/**
 * @export
 */
export const GetTopPayersByAmountBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;
export type GetTopPayersByAmountBillTypeEnum = typeof GetTopPayersByAmountBillTypeEnum[keyof typeof GetTopPayersByAmountBillTypeEnum];
/**
 * @export
 */
export const GetTrendAnalyticsBillStatusEnum = {
    Start: 'START',
    Open: 'OPEN',
    Previous: 'PREVIOUS'
} as const;
export type GetTrendAnalyticsBillStatusEnum = typeof GetTrendAnalyticsBillStatusEnum[keyof typeof GetTrendAnalyticsBillStatusEnum];
/**
 * @export
 */
export const GetTrendAnalyticsBillTypeEnum = {
    Paper: 'PAPER',
    Gkv: 'GKV',
    Zuzahlung: 'ZUZAHLUNG',
    Bg: 'BG',
    Correction: 'CORRECTION',
    LineItemCorrection: 'LINE_ITEM_CORRECTION'
} as const;
export type GetTrendAnalyticsBillTypeEnum = typeof GetTrendAnalyticsBillTypeEnum[keyof typeof GetTrendAnalyticsBillTypeEnum];
/**
 * @export
 */
export const PrintDirectBillingDocumentTestTypeEnum = {
    Global: 'Global',
    Internal: 'Internal',
    External: 'External'
} as const;
export type PrintDirectBillingDocumentTestTypeEnum = typeof PrintDirectBillingDocumentTestTypeEnum[keyof typeof PrintDirectBillingDocumentTestTypeEnum];
/**
 * @export
 */
export const UploadRxScanToExistingBillDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;
export type UploadRxScanToExistingBillDocuTypeEnum = typeof UploadRxScanToExistingBillDocuTypeEnum[keyof typeof UploadRxScanToExistingBillDocuTypeEnum];
/**
 * @export
 */
export const UploadRxScanToExistingBillOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;
export type UploadRxScanToExistingBillOwnerTypeEnum = typeof UploadRxScanToExistingBillOwnerTypeEnum[keyof typeof UploadRxScanToExistingBillOwnerTypeEnum];
/**
 * @export
 */
export const UploadSignedDocumentDocuTypeEnum = {
    Rezept: 'Rezept',
    Medizinisch: 'Medizinisch',
    Rechnung: 'Rechnung',
    Quittung: 'Quittung',
    Termine: 'Termine',
    Sonstiges: 'Sonstiges',
    Mandat: 'Mandat',
    Mitteilung: 'Mitteilung',
    Therapiebericht: 'Therapiebericht',
    Zuzahlungsbefreiung: 'Zuzahlungsbefreiung',
    Logo: 'Logo'
} as const;
export type UploadSignedDocumentDocuTypeEnum = typeof UploadSignedDocumentDocuTypeEnum[keyof typeof UploadSignedDocumentDocuTypeEnum];
/**
 * @export
 */
export const UploadSignedDocumentOwnerTypeEnum = {
    User: 'User',
    Patient: 'Patient',
    Payer: 'Payer',
    Account: 'Account',
    Inbox: 'Inbox'
} as const;
export type UploadSignedDocumentOwnerTypeEnum = typeof UploadSignedDocumentOwnerTypeEnum[keyof typeof UploadSignedDocumentOwnerTypeEnum];


/**
 * UserProfileApi - axios parameter creator
 * @export
 */
export const UserProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {boolean} softDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrDeactivateUser: async (userId: string, softDelete: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('activateOrDeactivateUser', 'userId', userId)
            // verify required parameter 'softDelete' is not null or undefined
            assertParamExists('activateOrDeactivateUser', 'softDelete', softDelete)
            const localVarPath = `/user-profile/activateOrDeactivateUser/{userId}/{softDelete}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"softDelete"}}`, encodeURIComponent(String(softDelete)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} newLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserLocation: async (userId: string, newLocationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('changeUserLocation', 'userId', userId)
            // verify required parameter 'newLocationId' is not null or undefined
            assertParamExists('changeUserLocation', 'newLocationId', newLocationId)
            const localVarPath = `/user-profile/changeUserLocation/{userId}/{newLocationId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"newLocationId"}}`, encodeURIComponent(String(newLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserLoginDetails: async (userRegisterDto: UserRegisterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterDto' is not null or undefined
            assertParamExists('changeUserLoginDetails', 'userRegisterDto', userRegisterDto)
            const localVarPath = `/user-profile/changeUserLoginDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeeklyWorkDay: async (weeklyWorkDayDto: WeeklyWorkDayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyWorkDayDto' is not null or undefined
            assertParamExists('createWeeklyWorkDay', 'weeklyWorkDayDto', weeklyWorkDayDto)
            const localVarPath = `/user-profile/createWeeklyWorkDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyWorkDayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {WorkPlanDto} workPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkPlan: async (workPlanDto: WorkPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workPlanDto' is not null or undefined
            assertParamExists('createWorkPlan', 'workPlanDto', workPlanDto)
            const localVarPath = `/user-profile/workPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deletUser', 'userId', userId)
            const localVarPath = `/user-profile/delete/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWeeklyWorkDay: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWeeklyWorkDay', 'id', id)
            const localVarPath = `/user-profile/deleteWeeklyWorkDay/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkPlan: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWorkPlan', 'id', id)
            const localVarPath = `/user-profile/deleteWorkPlan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByLocationId: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAccountsByLocationId', 'locationId', locationId)
            const localVarPath = `/user-profile/accounts/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersBasic: async (limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/getAllUsersBasic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (relations) {
                localVarQueryParameter['relations'] = relations;
            }

            if (withDeleted !== undefined) {
                localVarQueryParameter['withDeleted'] = withDeleted;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticatedUser: async (relations?: Array<UserRelationsEnum>, withDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/getAuthUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (relations) {
                localVarQueryParameter['relations'] = relations;
            }

            if (withDeleted !== undefined) {
                localVarQueryParameter['withDeleted'] = withDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarColumnOrder: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCalendarColumnOrder', 'locationId', locationId)
            const localVarPath = `/user-profile/calendarColumnOrder/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistCredentials: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getTherapistCredentials', 'locationId', locationId)
            const localVarPath = `/user-profile/therapistCredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/user-profile/getUser/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByIdWithTherapies: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserByIdWithTherapies', 'userId', userId)
            const localVarPath = `/user-profile/getUserWithTherapies/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (relations) {
                localVarQueryParameter['relations'] = relations;
            }

            if (withDeleted !== undefined) {
                localVarQueryParameter['withDeleted'] = withDeleted;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersBy: async (locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/getUsersBy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyWorkDays: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWeeklyWorkDays', 'userId', userId)
            const localVarPath = `/user-profile/weeklyWorkDays/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {number} workPlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyWorkDaysByWorkPlan: async (userId: string, workPlanId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWeeklyWorkDaysByWorkPlan', 'userId', userId)
            // verify required parameter 'workPlanId' is not null or undefined
            assertParamExists('getWeeklyWorkDaysByWorkPlan', 'workPlanId', workPlanId)
            const localVarPath = `/user-profile/weeklyWorkDays/{userId}/{workPlanId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"workPlanId"}}`, encodeURIComponent(String(workPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkPlans: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkPlans', 'userId', userId)
            const localVarPath = `/user-profile/workPlans/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Preflight check: Verifies whether a user can be permanently deleted and provides reasons if not.
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeletePreflight: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('hardDeletePreflight', 'userId', userId)
            const localVarPath = `/user-profile/hardDelete/preflight/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hard delete a user only if they have no future appointments and no appointments in the last 10 years
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('hardDeleteUser', 'userId', userId)
            const localVarPath = `/user-profile/hardDelete/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWeeklyWorkDay: async (weeklyWorkDayDto: WeeklyWorkDayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyWorkDayDto' is not null or undefined
            assertParamExists('putWeeklyWorkDay', 'weeklyWorkDayDto', weeklyWorkDayDto)
            const localVarPath = `/user-profile/putWeeklyWorkDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyWorkDayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SaveCalendarColumnOrderDto} saveCalendarColumnOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCalendarColumnOrder: async (saveCalendarColumnOrderDto: SaveCalendarColumnOrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveCalendarColumnOrderDto' is not null or undefined
            assertParamExists('saveCalendarColumnOrder', 'saveCalendarColumnOrderDto', saveCalendarColumnOrderDto)
            const localVarPath = `/user-profile/calendarColumnOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCalendarColumnOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserInfo: async (userDto: UserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('saveUserInfo', 'userDto', userDto)
            const localVarPath = `/user-profile/saveUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendOtp', 'userId', userId)
            const localVarPath = `/user-profile/sendOtp/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserActivationEmail: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendUserActivationEmail', 'userId', userId)
            const localVarPath = `/user-profile/send-activation-email/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerGenerateActivationLink: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/generateActivationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkPlanDto} workPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerPutWorkPlan: async (workPlanDto: WorkPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workPlanDto' is not null or undefined
            assertParamExists('userProfileControllerPutWorkPlan', 'workPlanDto', workPlanDto)
            const localVarPath = `/user-profile/putWorkPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerVerifyShortToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-profile/verify-short-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegister: async (userRegisterDto: UserRegisterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterDto' is not null or undefined
            assertParamExists('userRegister', 'userRegisterDto', userRegisterDto)
            const localVarPath = `/user-profile/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new work plan version starting from the effective date, closing the original plan on that date. Use this when editing a plan that has validityStart in the past to preserve historical schedules.
         * @summary Create a new work plan version when editing historical data
         * @param {VersionWorkPlanDto} versionWorkPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionWorkPlan: async (versionWorkPlanDto: VersionWorkPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionWorkPlanDto' is not null or undefined
            assertParamExists('versionWorkPlan', 'versionWorkPlanDto', versionWorkPlanDto)
            const localVarPath = `/user-profile/workPlan/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(versionWorkPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileApi - functional programming interface
 * @export
 */
export const UserProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {boolean} softDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateOrDeactivateUser(userId: string, softDelete: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateOrDeactivateUser(userId, softDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} newLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserLocation(userId: string, newLocationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserLocation(userId, newLocationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserLoginDetails(userRegisterDto: UserRegisterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserLoginDetails(userRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWeeklyWorkDay(weeklyWorkDayDto: WeeklyWorkDayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWeeklyWorkDay(weeklyWorkDayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {WorkPlanDto} workPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkPlan(workPlanDto: WorkPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkPlan(workPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWeeklyWorkDay(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWeeklyWorkDay(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkPlan(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkPlan(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountsByLocationId(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountsByLocationId(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLocations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersBasic(limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersBasic(limit, page, relations, withDeleted, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthenticatedUser(relations?: Array<UserRelationsEnum>, withDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthenticatedUser(relations, withDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarColumnOrder(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarColumnOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarColumnOrder(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTherapistCredentials(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTherapistCredentials(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByIdWithTherapies(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByIdWithTherapies(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(limit, page, relations, withDeleted, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersBy(locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersBy(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyWorkDays(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeeklyWorkDayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyWorkDays(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {number} workPlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyWorkDaysByWorkPlan(userId: string, workPlanId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeeklyWorkDayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyWorkDaysByWorkPlan(userId, workPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkPlans(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkPlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkPlans(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Preflight check: Verifies whether a user can be permanently deleted and provides reasons if not.
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDeletePreflight(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDeletePreflight(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Hard delete a user only if they have no future appointments and no appointments in the last 10 years
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDeleteUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDeleteUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putWeeklyWorkDay(weeklyWorkDayDto: WeeklyWorkDayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putWeeklyWorkDay(weeklyWorkDayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SaveCalendarColumnOrderDto} saveCalendarColumnOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCalendarColumnOrder(saveCalendarColumnOrderDto: SaveCalendarColumnOrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarColumnOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCalendarColumnOrder(saveCalendarColumnOrderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserInfo(userDto: UserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserInfo(userDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOtp(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtp(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserActivationEmail(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserActivationEmail(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfileControllerGenerateActivationLink(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfileControllerGenerateActivationLink(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WorkPlanDto} workPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfileControllerPutWorkPlan(workPlanDto: WorkPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfileControllerPutWorkPlan(workPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfileControllerVerifyShortToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfileControllerVerifyShortToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegister(userRegisterDto: UserRegisterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegister(userRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new work plan version starting from the effective date, closing the original plan on that date. Use this when editing a plan that has validityStart in the past to preserve historical schedules.
         * @summary Create a new work plan version when editing historical data
         * @param {VersionWorkPlanDto} versionWorkPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async versionWorkPlan(versionWorkPlanDto: VersionWorkPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.versionWorkPlan(versionWorkPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserProfileApi - factory interface
 * @export
 */
export const UserProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {boolean} softDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrDeactivateUser(userId: string, softDelete: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.activateOrDeactivateUser(userId, softDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInfo(options?: any): AxiosPromise<object> {
            return localVarFp.apiInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} newLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserLocation(userId: string, newLocationId: string, options?: any): AxiosPromise<object> {
            return localVarFp.changeUserLocation(userId, newLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserLoginDetails(userRegisterDto: UserRegisterDto, options?: any): AxiosPromise<object> {
            return localVarFp.changeUserLoginDetails(userRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeeklyWorkDay(weeklyWorkDayDto: WeeklyWorkDayDto, options?: any): AxiosPromise<object> {
            return localVarFp.createWeeklyWorkDay(weeklyWorkDayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {WorkPlanDto} workPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkPlan(workPlanDto: WorkPlanDto, options?: any): AxiosPromise<object> {
            return localVarFp.createWorkPlan(workPlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWeeklyWorkDay(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWeeklyWorkDay(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkPlan(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkPlan(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByLocationId(locationId: string, options?: any): AxiosPromise<Array<AccountDto>> {
            return localVarFp.getAccountsByLocationId(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocations(options?: any): AxiosPromise<Array<LocationDto>> {
            return localVarFp.getAllLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersBasic(limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getAllUsersBasic(limit, page, relations, withDeleted, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticatedUser(relations?: Array<UserRelationsEnum>, withDeleted?: boolean, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getAuthenticatedUser(relations, withDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarColumnOrder(locationId: string, options?: any): AxiosPromise<Array<CalendarColumnOrderDto>> {
            return localVarFp.getCalendarColumnOrder(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTherapistCredentials(locationId: string, options?: any): AxiosPromise<object> {
            return localVarFp.getTherapistCredentials(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByIdWithTherapies(userId: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getUserByIdWithTherapies(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} [limit] Number of items per page (Max &#x3D; 50)
         * @param {number} [page] Page number (Min &#x3D; 1)
         * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
         * @param {boolean} [withDeleted] You need soft deleted users
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getUsers(limit, page, relations, withDeleted, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersBy(locationId?: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getUsersBy(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyWorkDays(userId: string, options?: any): AxiosPromise<Array<WeeklyWorkDayDto>> {
            return localVarFp.getWeeklyWorkDays(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {number} workPlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyWorkDaysByWorkPlan(userId: string, workPlanId: number, options?: any): AxiosPromise<Array<WeeklyWorkDayDto>> {
            return localVarFp.getWeeklyWorkDaysByWorkPlan(userId, workPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkPlans(userId: string, options?: any): AxiosPromise<Array<WorkPlanDto>> {
            return localVarFp.getWorkPlans(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Preflight check: Verifies whether a user can be permanently deleted and provides reasons if not.
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeletePreflight(userId: string, options?: any): AxiosPromise<object> {
            return localVarFp.hardDeletePreflight(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Hard delete a user only if they have no future appointments and no appointments in the last 10 years
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.hardDeleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWeeklyWorkDay(weeklyWorkDayDto: WeeklyWorkDayDto, options?: any): AxiosPromise<object> {
            return localVarFp.putWeeklyWorkDay(weeklyWorkDayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SaveCalendarColumnOrderDto} saveCalendarColumnOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCalendarColumnOrder(saveCalendarColumnOrderDto: SaveCalendarColumnOrderDto, options?: any): AxiosPromise<Array<CalendarColumnOrderDto>> {
            return localVarFp.saveCalendarColumnOrder(saveCalendarColumnOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserInfo(userDto: UserDto, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.saveUserInfo(userDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp(userId: string, options?: any): AxiosPromise<object> {
            return localVarFp.sendOtp(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserActivationEmail(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendUserActivationEmail(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerGenerateActivationLink(options?: any): AxiosPromise<object> {
            return localVarFp.userProfileControllerGenerateActivationLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkPlanDto} workPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerPutWorkPlan(workPlanDto: WorkPlanDto, options?: any): AxiosPromise<object> {
            return localVarFp.userProfileControllerPutWorkPlan(workPlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerVerifyShortToken(options?: any): AxiosPromise<object> {
            return localVarFp.userProfileControllerVerifyShortToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegister(userRegisterDto: UserRegisterDto, options?: any): AxiosPromise<object> {
            return localVarFp.userRegister(userRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new work plan version starting from the effective date, closing the original plan on that date. Use this when editing a plan that has validityStart in the past to preserve historical schedules.
         * @summary Create a new work plan version when editing historical data
         * @param {VersionWorkPlanDto} versionWorkPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionWorkPlan(versionWorkPlanDto: VersionWorkPlanDto, options?: any): AxiosPromise<object> {
            return localVarFp.versionWorkPlan(versionWorkPlanDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */
export class UserProfileApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {boolean} softDelete 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public activateOrDeactivateUser(userId: string, softDelete: boolean, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).activateOrDeactivateUser(userId, softDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public apiInfo(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).apiInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {string} newLocationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public changeUserLocation(userId: string, newLocationId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).changeUserLocation(userId, newLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UserRegisterDto} userRegisterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public changeUserLoginDetails(userRegisterDto: UserRegisterDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).changeUserLoginDetails(userRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public createWeeklyWorkDay(weeklyWorkDayDto: WeeklyWorkDayDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).createWeeklyWorkDay(weeklyWorkDayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {WorkPlanDto} workPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public createWorkPlan(workPlanDto: WorkPlanDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).createWorkPlan(workPlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public deletUser(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).deletUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public deleteWeeklyWorkDay(id: number, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).deleteWeeklyWorkDay(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public deleteWorkPlan(id: number, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).deleteWorkPlan(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getAccountsByLocationId(locationId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getAccountsByLocationId(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getAllLocations(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getAllLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
     * @param {boolean} [withDeleted] You need soft deleted users
     * @param {string} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getAllUsersBasic(limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getAllUsersBasic(limit, page, relations, withDeleted, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
     * @param {boolean} [withDeleted] You need soft deleted users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getAuthenticatedUser(relations?: Array<UserRelationsEnum>, withDeleted?: boolean, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getAuthenticatedUser(relations, withDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getCalendarColumnOrder(locationId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getCalendarColumnOrder(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getTherapistCredentials(locationId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getTherapistCredentials(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getUserById(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getUserByIdWithTherapies(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getUserByIdWithTherapies(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} [limit] Number of items per page (Max &#x3D; 50)
     * @param {number} [page] Page number (Min &#x3D; 1)
     * @param {Array<UserRelationsEnum>} [relations] Array of relations to fetch
     * @param {boolean} [withDeleted] You need soft deleted users
     * @param {string} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getUsers(limit?: number, page?: number, relations?: Array<UserRelationsEnum>, withDeleted?: boolean, locationId?: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getUsers(limit, page, relations, withDeleted, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getUsersBy(locationId?: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getUsersBy(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getWeeklyWorkDays(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getWeeklyWorkDays(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {number} workPlanId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getWeeklyWorkDaysByWorkPlan(userId: string, workPlanId: number, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getWeeklyWorkDaysByWorkPlan(userId, workPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getWorkPlans(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getWorkPlans(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Preflight check: Verifies whether a user can be permanently deleted and provides reasons if not.
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public hardDeletePreflight(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).hardDeletePreflight(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hard delete a user only if they have no future appointments and no appointments in the last 10 years
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public hardDeleteUser(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).hardDeleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {WeeklyWorkDayDto} weeklyWorkDayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public putWeeklyWorkDay(weeklyWorkDayDto: WeeklyWorkDayDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).putWeeklyWorkDay(weeklyWorkDayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SaveCalendarColumnOrderDto} saveCalendarColumnOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public saveCalendarColumnOrder(saveCalendarColumnOrderDto: SaveCalendarColumnOrderDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).saveCalendarColumnOrder(saveCalendarColumnOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public saveUserInfo(userDto: UserDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).saveUserInfo(userDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public sendOtp(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).sendOtp(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public sendUserActivationEmail(userId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).sendUserActivationEmail(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public userProfileControllerGenerateActivationLink(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).userProfileControllerGenerateActivationLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkPlanDto} workPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public userProfileControllerPutWorkPlan(workPlanDto: WorkPlanDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).userProfileControllerPutWorkPlan(workPlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public userProfileControllerVerifyShortToken(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).userProfileControllerVerifyShortToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UserRegisterDto} userRegisterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public userRegister(userRegisterDto: UserRegisterDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).userRegister(userRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new work plan version starting from the effective date, closing the original plan on that date. Use this when editing a plan that has validityStart in the past to preserve historical schedules.
     * @summary Create a new work plan version when editing historical data
     * @param {VersionWorkPlanDto} versionWorkPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public versionWorkPlan(versionWorkPlanDto: VersionWorkPlanDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).versionWorkPlan(versionWorkPlanDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkingHoursApi - axios parameter creator
 * @export
 */
export const WorkingHoursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes existing exceptions for the day, then creates a cancel exception. Appointments remain in the system.
         * @summary Cancel entire day for a user
         * @param {CancelDayRequest} cancelDayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDay: async (cancelDayRequest: CancelDayRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelDayRequest' is not null or undefined
            assertParamExists('cancelDay', 'cancelDayRequest', cancelDayRequest)
            const localVarPath = `/working-hours/cancelDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelDayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch weekly workdays for multiple users based on horizon date
         * @param {Array<string>} userIds 
         * @param {number} [dayOfWeek] 0 (Sunday) to 6 (Saturday)
         * @param {string} [locationId] Only return plans at this location; omit for the merged cross-location view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continuousWorkPlansForUsers: async (userIds: Array<string>, dayOfWeek?: number, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIds' is not null or undefined
            assertParamExists('continuousWorkPlansForUsers', 'userIds', userIds)
            const localVarPath = `/working-hours/continuousWorkPlansForUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dayOfWeek !== undefined) {
                localVarQueryParameter['dayOfWeek'] = dayOfWeek;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {WorkHourExceptionDto} workHourExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkHourException: async (workHourExceptionDto: WorkHourExceptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workHourExceptionDto' is not null or undefined
            assertParamExists('createWorkHourException', 'workHourExceptionDto', workHourExceptionDto)
            const localVarPath = `/working-hours/createWorkHourException`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workHourExceptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a working hour exception for a specific date with automatic lunch break generation based on duration rules
         * @summary Create working hours for a specific day
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format (YYYY-MM-DD)
         * @param {CreateWorkingHoursForDayDto} createWorkingHoursForDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHoursForDay: async (userId: string, date: string, createWorkingHoursForDayDto: CreateWorkingHoursForDayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createWorkingHoursForDay', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('createWorkingHoursForDay', 'date', date)
            // verify required parameter 'createWorkingHoursForDayDto' is not null or undefined
            assertParamExists('createWorkingHoursForDay', 'createWorkingHoursForDayDto', createWorkingHoursForDayDto)
            const localVarPath = `/working-hours/createWorkingHoursForDay/{userId}/{date}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkingHoursForDayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id Exception ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteException: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteException', 'id', id)
            const localVarPath = `/working-hours/deleteException/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an exception that preserves working hours but removes the lunch break for that day only. With the optional slotId query param, only that specific break is removed (other breaks keep their identity). Blocked with a 400 when the resulting day would violate § 4 ArbZG.
         * @summary Delete lunch break for a specific day
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} [slotId] Slot ID of the specific break to delete; omit to delete all breaks of the day
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLunchBreakForDay: async (userId: string, date: string, slotId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteLunchBreakForDay', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('deleteLunchBreakForDay', 'date', date)
            const localVarPath = `/working-hours/deleteLunchBreakForDay/{userId}/{date}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deriveWorkingHoursForUserForDateRange: async (userId: string, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deriveWorkingHoursForUserForDateRange', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('deriveWorkingHoursForUserForDateRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('deriveWorkingHoursForUserForDateRange', 'endDate', endDate)
            const localVarPath = `/working-hours/deriveWorkingHoursForUserForDateRange/{userId}/{startDate}/{endDate}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [userIds] 
         * @param {string} [locationId] 
         * @param {boolean} [onlyIncludeTherapists] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deriveWorkingHoursForUsers: async (startDate?: string, endDate?: string, userIds?: Array<string>, locationId?: string, onlyIncludeTherapists?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/working-hours/deriveWorkingHoursForUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (onlyIncludeTherapists !== undefined) {
                localVarQueryParameter['onlyIncludeTherapists'] = onlyIncludeTherapists;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {ExtendWorkingHoursForAppointmentDto} extendWorkingHoursForAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendWorkingHoursForAppointment: async (extendWorkingHoursForAppointmentDto: ExtendWorkingHoursForAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extendWorkingHoursForAppointmentDto' is not null or undefined
            assertParamExists('extendWorkingHoursForAppointment', 'extendWorkingHoursForAppointmentDto', extendWorkingHoursForAppointmentDto)
            const localVarPath = `/working-hours/extendForAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendWorkingHoursForAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregated delta minutes (over/under planned hours) for each user
         * @summary Get over/under hours summary for users in date range
         * @param {string} startDate Start date (YYYY-MM-DD)
         * @param {string} endDate End date (YYYY-MM-DD)
         * @param {Array<string>} userIds Array of user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeltaSummary: async (startDate: string, endDate: string, userIds: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDeltaSummary', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDeltaSummary', 'endDate', endDate)
            // verify required parameter 'userIds' is not null or undefined
            assertParamExists('getDeltaSummary', 'userIds', userIds)
            const localVarPath = `/working-hours/delta-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionsByUsersAndDates: async (userId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getExceptionsByUsersAndDates', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getExceptionsByUsersAndDates', 'date', date)
            const localVarPath = `/working-hours/getExceptionsByUsersAndDates/{userId}/{date}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires the punchIn permission. Punch-in shifts today\'s working hours to start at `at` (same length; breaks stay); punch-out ends them at `at`. `dryRun` returns the resulting day without saving.
         * @summary Punch the calling user in or out
         * @param {PunchRequestDto} punchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        punch: async (punchRequestDto: PunchRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'punchRequestDto' is not null or undefined
            assertParamExists('punch', 'punchRequestDto', punchRequestDto)
            const localVarPath = `/working-hours/punch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEndpoint: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/working-hours/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {WorkHourExceptionDto} workHourExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkHourException: async (id: string, workHourExceptionDto: WorkHourExceptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWorkHourException', 'id', id)
            // verify required parameter 'workHourExceptionDto' is not null or undefined
            assertParamExists('updateWorkHourException', 'workHourExceptionDto', workHourExceptionDto)
            const localVarPath = `/working-hours/updateWorkHourException/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workHourExceptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {boolean} includeLunchBreaks 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerGetTherapistAvailability: async (userId: string, startDate: string, endDate: string, includeLunchBreaks: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('workingHoursControllerGetTherapistAvailability', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('workingHoursControllerGetTherapistAvailability', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('workingHoursControllerGetTherapistAvailability', 'endDate', endDate)
            // verify required parameter 'includeLunchBreaks' is not null or undefined
            assertParamExists('workingHoursControllerGetTherapistAvailability', 'includeLunchBreaks', includeLunchBreaks)
            const localVarPath = `/working-hours/availability/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (includeLunchBreaks !== undefined) {
                localVarQueryParameter['includeLunchBreaks'] = includeLunchBreaks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkingHoursApi - functional programming interface
 * @export
 */
export const WorkingHoursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkingHoursApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes existing exceptions for the day, then creates a cancel exception. Appointments remain in the system.
         * @summary Cancel entire day for a user
         * @param {CancelDayRequest} cancelDayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDay(cancelDayRequest: CancelDayRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDay(cancelDayRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch weekly workdays for multiple users based on horizon date
         * @param {Array<string>} userIds 
         * @param {number} [dayOfWeek] 0 (Sunday) to 6 (Saturday)
         * @param {string} [locationId] Only return plans at this location; omit for the merged cross-location view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continuousWorkPlansForUsers(userIds: Array<string>, dayOfWeek?: number, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continuousWorkPlansForUsers(userIds, dayOfWeek, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {WorkHourExceptionDto} workHourExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkHourException(workHourExceptionDto: WorkHourExceptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkHourException(workHourExceptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a working hour exception for a specific date with automatic lunch break generation based on duration rules
         * @summary Create working hours for a specific day
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format (YYYY-MM-DD)
         * @param {CreateWorkingHoursForDayDto} createWorkingHoursForDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkingHoursForDay(userId: string, date: string, createWorkingHoursForDayDto: CreateWorkingHoursForDayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkingHoursForDay(userId, date, createWorkingHoursForDayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id Exception ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteException(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteExceptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteException(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates an exception that preserves working hours but removes the lunch break for that day only. With the optional slotId query param, only that specific break is removed (other breaks keep their identity). Blocked with a 400 when the resulting day would violate § 4 ArbZG.
         * @summary Delete lunch break for a specific day
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} [slotId] Slot ID of the specific break to delete; omit to delete all breaks of the day
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLunchBreakForDay(userId: string, date: string, slotId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLunchBreakForDay(userId, date, slotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deriveWorkingHoursForUserForDateRange(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deriveWorkingHoursForUserForDateRange(userId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [userIds] 
         * @param {string} [locationId] 
         * @param {boolean} [onlyIncludeTherapists] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deriveWorkingHoursForUsers(startDate?: string, endDate?: string, userIds?: Array<string>, locationId?: string, onlyIncludeTherapists?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deriveWorkingHoursForUsers(startDate, endDate, userIds, locationId, onlyIncludeTherapists, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {ExtendWorkingHoursForAppointmentDto} extendWorkingHoursForAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendWorkingHoursForAppointment(extendWorkingHoursForAppointmentDto: ExtendWorkingHoursForAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendWorkingHoursForAppointment(extendWorkingHoursForAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns aggregated delta minutes (over/under planned hours) for each user
         * @summary Get over/under hours summary for users in date range
         * @param {string} startDate Start date (YYYY-MM-DD)
         * @param {string} endDate End date (YYYY-MM-DD)
         * @param {Array<string>} userIds Array of user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeltaSummary(startDate: string, endDate: string, userIds: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeltaSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeltaSummary(startDate, endDate, userIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExceptionsByUsersAndDates(userId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExceptionsByUsersAndDates(userId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Requires the punchIn permission. Punch-in shifts today\'s working hours to start at `at` (same length; breaks stay); punch-out ends them at `at`. `dryRun` returns the resulting day without saving.
         * @summary Punch the calling user in or out
         * @param {PunchRequestDto} punchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async punch(punchRequestDto: PunchRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.punch(punchRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testEndpoint(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testEndpoint(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {WorkHourExceptionDto} workHourExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkHourException(id: string, workHourExceptionDto: WorkHourExceptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkHourException(id, workHourExceptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {boolean} includeLunchBreaks 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingHoursControllerGetTherapistAvailability(userId: string, startDate: string, endDate: string, includeLunchBreaks: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingHoursControllerGetTherapistAvailability(userId, startDate, endDate, includeLunchBreaks, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkingHoursApi - factory interface
 * @export
 */
export const WorkingHoursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkingHoursApiFp(configuration)
    return {
        /**
         * Deletes existing exceptions for the day, then creates a cancel exception. Appointments remain in the system.
         * @summary Cancel entire day for a user
         * @param {CancelDayRequest} cancelDayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDay(cancelDayRequest: CancelDayRequest, options?: any): AxiosPromise<void> {
            return localVarFp.cancelDay(cancelDayRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch weekly workdays for multiple users based on horizon date
         * @param {Array<string>} userIds 
         * @param {number} [dayOfWeek] 0 (Sunday) to 6 (Saturday)
         * @param {string} [locationId] Only return plans at this location; omit for the merged cross-location view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continuousWorkPlansForUsers(userIds: Array<string>, dayOfWeek?: number, locationId?: string, options?: any): AxiosPromise<Array<WorkingHoursDto>> {
            return localVarFp.continuousWorkPlansForUsers(userIds, dayOfWeek, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {WorkHourExceptionDto} workHourExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkHourException(workHourExceptionDto: WorkHourExceptionDto, options?: any): AxiosPromise<void> {
            return localVarFp.createWorkHourException(workHourExceptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a working hour exception for a specific date with automatic lunch break generation based on duration rules
         * @summary Create working hours for a specific day
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format (YYYY-MM-DD)
         * @param {CreateWorkingHoursForDayDto} createWorkingHoursForDayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHoursForDay(userId: string, date: string, createWorkingHoursForDayDto: CreateWorkingHoursForDayDto, options?: any): AxiosPromise<void> {
            return localVarFp.createWorkingHoursForDay(userId, date, createWorkingHoursForDayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id Exception ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteException(id: string, options?: any): AxiosPromise<DeleteExceptionResponseDto> {
            return localVarFp.deleteException(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an exception that preserves working hours but removes the lunch break for that day only. With the optional slotId query param, only that specific break is removed (other breaks keep their identity). Blocked with a 400 when the resulting day would violate § 4 ArbZG.
         * @summary Delete lunch break for a specific day
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} [slotId] Slot ID of the specific break to delete; omit to delete all breaks of the day
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLunchBreakForDay(userId: string, date: string, slotId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLunchBreakForDay(userId, date, slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deriveWorkingHoursForUserForDateRange(userId: string, startDate: string, endDate: string, options?: any): AxiosPromise<Array<WorkingHoursDto>> {
            return localVarFp.deriveWorkingHoursForUserForDateRange(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [userIds] 
         * @param {string} [locationId] 
         * @param {boolean} [onlyIncludeTherapists] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deriveWorkingHoursForUsers(startDate?: string, endDate?: string, userIds?: Array<string>, locationId?: string, onlyIncludeTherapists?: boolean, options?: any): AxiosPromise<Array<WorkingHoursDto>> {
            return localVarFp.deriveWorkingHoursForUsers(startDate, endDate, userIds, locationId, onlyIncludeTherapists, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {ExtendWorkingHoursForAppointmentDto} extendWorkingHoursForAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendWorkingHoursForAppointment(extendWorkingHoursForAppointmentDto: ExtendWorkingHoursForAppointmentDto, options?: any): AxiosPromise<object> {
            return localVarFp.extendWorkingHoursForAppointment(extendWorkingHoursForAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregated delta minutes (over/under planned hours) for each user
         * @summary Get over/under hours summary for users in date range
         * @param {string} startDate Start date (YYYY-MM-DD)
         * @param {string} endDate End date (YYYY-MM-DD)
         * @param {Array<string>} userIds Array of user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeltaSummary(startDate: string, endDate: string, userIds: Array<string>, options?: any): AxiosPromise<Array<DeltaSummaryDto>> {
            return localVarFp.getDeltaSummary(startDate, endDate, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionsByUsersAndDates(userId: string, date: string, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getExceptionsByUsersAndDates(userId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires the punchIn permission. Punch-in shifts today\'s working hours to start at `at` (same length; breaks stay); punch-out ends them at `at`. `dryRun` returns the resulting day without saving.
         * @summary Punch the calling user in or out
         * @param {PunchRequestDto} punchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        punch(punchRequestDto: PunchRequestDto, options?: any): AxiosPromise<PunchResultDto> {
            return localVarFp.punch(punchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEndpoint(options?: any): AxiosPromise<void> {
            return localVarFp.testEndpoint(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {WorkHourExceptionDto} workHourExceptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkHourException(id: string, workHourExceptionDto: WorkHourExceptionDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateWorkHourException(id, workHourExceptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {boolean} includeLunchBreaks 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerGetTherapistAvailability(userId: string, startDate: string, endDate: string, includeLunchBreaks: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.workingHoursControllerGetTherapistAvailability(userId, startDate, endDate, includeLunchBreaks, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkingHoursApi - object-oriented interface
 * @export
 * @class WorkingHoursApi
 * @extends {BaseAPI}
 */
export class WorkingHoursApi extends BaseAPI {
    /**
     * Deletes existing exceptions for the day, then creates a cancel exception. Appointments remain in the system.
     * @summary Cancel entire day for a user
     * @param {CancelDayRequest} cancelDayRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public cancelDay(cancelDayRequest: CancelDayRequest, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).cancelDay(cancelDayRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch weekly workdays for multiple users based on horizon date
     * @param {Array<string>} userIds 
     * @param {number} [dayOfWeek] 0 (Sunday) to 6 (Saturday)
     * @param {string} [locationId] Only return plans at this location; omit for the merged cross-location view
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public continuousWorkPlansForUsers(userIds: Array<string>, dayOfWeek?: number, locationId?: string, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).continuousWorkPlansForUsers(userIds, dayOfWeek, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {WorkHourExceptionDto} workHourExceptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public createWorkHourException(workHourExceptionDto: WorkHourExceptionDto, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).createWorkHourException(workHourExceptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a working hour exception for a specific date with automatic lunch break generation based on duration rules
     * @summary Create working hours for a specific day
     * @param {string} userId User ID
     * @param {string} date Date in YYYY-MM-DD format (YYYY-MM-DD)
     * @param {CreateWorkingHoursForDayDto} createWorkingHoursForDayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public createWorkingHoursForDay(userId: string, date: string, createWorkingHoursForDayDto: CreateWorkingHoursForDayDto, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).createWorkingHoursForDay(userId, date, createWorkingHoursForDayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id Exception ID to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public deleteException(id: string, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).deleteException(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an exception that preserves working hours but removes the lunch break for that day only. With the optional slotId query param, only that specific break is removed (other breaks keep their identity). Blocked with a 400 when the resulting day would violate § 4 ArbZG.
     * @summary Delete lunch break for a specific day
     * @param {string} userId User ID
     * @param {string} date Date in YYYY-MM-DD format
     * @param {string} [slotId] Slot ID of the specific break to delete; omit to delete all breaks of the day
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public deleteLunchBreakForDay(userId: string, date: string, slotId?: string, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).deleteLunchBreakForDay(userId, date, slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public deriveWorkingHoursForUserForDateRange(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).deriveWorkingHoursForUserForDateRange(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [userIds] 
     * @param {string} [locationId] 
     * @param {boolean} [onlyIncludeTherapists] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public deriveWorkingHoursForUsers(startDate?: string, endDate?: string, userIds?: Array<string>, locationId?: string, onlyIncludeTherapists?: boolean, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).deriveWorkingHoursForUsers(startDate, endDate, userIds, locationId, onlyIncludeTherapists, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {ExtendWorkingHoursForAppointmentDto} extendWorkingHoursForAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public extendWorkingHoursForAppointment(extendWorkingHoursForAppointmentDto: ExtendWorkingHoursForAppointmentDto, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).extendWorkingHoursForAppointment(extendWorkingHoursForAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregated delta minutes (over/under planned hours) for each user
     * @summary Get over/under hours summary for users in date range
     * @param {string} startDate Start date (YYYY-MM-DD)
     * @param {string} endDate End date (YYYY-MM-DD)
     * @param {Array<string>} userIds Array of user IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getDeltaSummary(startDate: string, endDate: string, userIds: Array<string>, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getDeltaSummary(startDate, endDate, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} userId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getExceptionsByUsersAndDates(userId: string, date: string, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getExceptionsByUsersAndDates(userId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires the punchIn permission. Punch-in shifts today\'s working hours to start at `at` (same length; breaks stay); punch-out ends them at `at`. `dryRun` returns the resulting day without saving.
     * @summary Punch the calling user in or out
     * @param {PunchRequestDto} punchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public punch(punchRequestDto: PunchRequestDto, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).punch(punchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public testEndpoint(options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).testEndpoint(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {WorkHourExceptionDto} workHourExceptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public updateWorkHourException(id: string, workHourExceptionDto: WorkHourExceptionDto, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).updateWorkHourException(id, workHourExceptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {boolean} includeLunchBreaks 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public workingHoursControllerGetTherapistAvailability(userId: string, startDate: string, endDate: string, includeLunchBreaks: boolean, options?: AxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).workingHoursControllerGetTherapistAvailability(userId, startDate, endDate, includeLunchBreaks, options).then((request) => request(this.axios, this.basePath));
    }
}



